import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  date: { input: string; output: string; }
  float8: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: number; output: number; }
  path: { input: string; output: string; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "additional_column_configs" */
export type Additional_Column_Configs = {
  __typename?: 'additional_column_configs';
  anchor_to_column?: Maybe<Scalars['String']['output']>;
  anchoring?: Maybe<Scalars['String']['output']>;
  cluster_id: Scalars['uuid']['output'];
  column_key: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  formatter: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  in_queue_cluster: In_Queue_Clusters;
  scenario_stage: Scalars['String']['output'];
  target_table: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "additional_column_configs" */
export type Additional_Column_Configs_Aggregate = {
  __typename?: 'additional_column_configs_aggregate';
  aggregate?: Maybe<Additional_Column_Configs_Aggregate_Fields>;
  nodes: Array<Additional_Column_Configs>;
};

/** aggregate fields of "additional_column_configs" */
export type Additional_Column_Configs_Aggregate_Fields = {
  __typename?: 'additional_column_configs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Additional_Column_Configs_Max_Fields>;
  min?: Maybe<Additional_Column_Configs_Min_Fields>;
};


/** aggregate fields of "additional_column_configs" */
export type Additional_Column_Configs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Additional_Column_Configs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "additional_column_configs". All fields are combined with a logical 'AND'. */
export type Additional_Column_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Additional_Column_Configs_Bool_Exp>>;
  _not?: InputMaybe<Additional_Column_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Additional_Column_Configs_Bool_Exp>>;
  anchor_to_column?: InputMaybe<String_Comparison_Exp>;
  anchoring?: InputMaybe<String_Comparison_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  column_key?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  formatter?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  scenario_stage?: InputMaybe<String_Comparison_Exp>;
  target_table?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "additional_column_configs" */
export enum Additional_Column_Configs_Constraint {
  /** unique or primary key constraint on columns "cluster_id", "target_table", "column_key", "scenario_stage" */
  AdditionalColumnConfigsClusterStageTargetKeyUnique = 'additional_column_configs_cluster_stage_target_key_unique',
  /** unique or primary key constraint on columns "id" */
  AdditionalColumnConfigsPkey = 'additional_column_configs_pkey'
}

/** input type for inserting data into table "additional_column_configs" */
export type Additional_Column_Configs_Insert_Input = {
  anchor_to_column?: InputMaybe<Scalars['String']['input']>;
  anchoring?: InputMaybe<Scalars['String']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  column_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  formatter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  target_table?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Additional_Column_Configs_Max_Fields = {
  __typename?: 'additional_column_configs_max_fields';
  anchor_to_column?: Maybe<Scalars['String']['output']>;
  anchoring?: Maybe<Scalars['String']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  column_key?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  formatter?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  scenario_stage?: Maybe<Scalars['String']['output']>;
  target_table?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Additional_Column_Configs_Min_Fields = {
  __typename?: 'additional_column_configs_min_fields';
  anchor_to_column?: Maybe<Scalars['String']['output']>;
  anchoring?: Maybe<Scalars['String']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  column_key?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  formatter?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  scenario_stage?: Maybe<Scalars['String']['output']>;
  target_table?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "additional_column_configs" */
export type Additional_Column_Configs_Mutation_Response = {
  __typename?: 'additional_column_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Additional_Column_Configs>;
};

/** on_conflict condition type for table "additional_column_configs" */
export type Additional_Column_Configs_On_Conflict = {
  constraint: Additional_Column_Configs_Constraint;
  update_columns?: Array<Additional_Column_Configs_Update_Column>;
  where?: InputMaybe<Additional_Column_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "additional_column_configs". */
export type Additional_Column_Configs_Order_By = {
  anchor_to_column?: InputMaybe<Order_By>;
  anchoring?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  column_key?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  formatter?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  scenario_stage?: InputMaybe<Order_By>;
  target_table?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: additional_column_configs */
export type Additional_Column_Configs_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "additional_column_configs" */
export enum Additional_Column_Configs_Select_Column {
  /** column name */
  AnchorToColumn = 'anchor_to_column',
  /** column name */
  Anchoring = 'anchoring',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  ColumnKey = 'column_key',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Formatter = 'formatter',
  /** column name */
  Id = 'id',
  /** column name */
  ScenarioStage = 'scenario_stage',
  /** column name */
  TargetTable = 'target_table',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "additional_column_configs" */
export type Additional_Column_Configs_Set_Input = {
  anchor_to_column?: InputMaybe<Scalars['String']['input']>;
  anchoring?: InputMaybe<Scalars['String']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  column_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  formatter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  target_table?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "additional_column_configs" */
export type Additional_Column_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Additional_Column_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Additional_Column_Configs_Stream_Cursor_Value_Input = {
  anchor_to_column?: InputMaybe<Scalars['String']['input']>;
  anchoring?: InputMaybe<Scalars['String']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  column_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  formatter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  target_table?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "additional_column_configs" */
export enum Additional_Column_Configs_Update_Column {
  /** column name */
  AnchorToColumn = 'anchor_to_column',
  /** column name */
  Anchoring = 'anchoring',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  ColumnKey = 'column_key',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Formatter = 'formatter',
  /** column name */
  Id = 'id',
  /** column name */
  ScenarioStage = 'scenario_stage',
  /** column name */
  TargetTable = 'target_table',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Additional_Column_Configs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Additional_Column_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Additional_Column_Configs_Bool_Exp;
};

/** columns and relationships of "admin_app.audit_log" */
export type Admin_App_Audit_Log = {
  __typename?: 'admin_app_audit_log';
  action: Scalars['String']['output'];
  actor_email: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  targets: Array<Admin_App_Audit_Log_Targets>;
  /** An aggregate relationship */
  targets_aggregate: Admin_App_Audit_Log_Targets_Aggregate;
};


/** columns and relationships of "admin_app.audit_log" */
export type Admin_App_Audit_LogTargetsArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
};


/** columns and relationships of "admin_app.audit_log" */
export type Admin_App_Audit_LogTargets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
};

/** aggregated selection of "admin_app.audit_log" */
export type Admin_App_Audit_Log_Aggregate = {
  __typename?: 'admin_app_audit_log_aggregate';
  aggregate?: Maybe<Admin_App_Audit_Log_Aggregate_Fields>;
  nodes: Array<Admin_App_Audit_Log>;
};

/** aggregate fields of "admin_app.audit_log" */
export type Admin_App_Audit_Log_Aggregate_Fields = {
  __typename?: 'admin_app_audit_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_App_Audit_Log_Max_Fields>;
  min?: Maybe<Admin_App_Audit_Log_Min_Fields>;
};


/** aggregate fields of "admin_app.audit_log" */
export type Admin_App_Audit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_App_Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "admin_app.audit_log". All fields are combined with a logical 'AND'. */
export type Admin_App_Audit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_App_Audit_Log_Bool_Exp>>;
  _not?: InputMaybe<Admin_App_Audit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_App_Audit_Log_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  actor_email?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  targets?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
  targets_aggregate?: InputMaybe<Admin_App_Audit_Log_Targets_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "admin_app.audit_log" */
export enum Admin_App_Audit_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  AuditLogPkey = 'audit_log_pkey'
}

/** input type for inserting data into table "admin_app.audit_log" */
export type Admin_App_Audit_Log_Insert_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  actor_email?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  targets?: InputMaybe<Admin_App_Audit_Log_Targets_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Admin_App_Audit_Log_Max_Fields = {
  __typename?: 'admin_app_audit_log_max_fields';
  action?: Maybe<Scalars['String']['output']>;
  actor_email?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Admin_App_Audit_Log_Min_Fields = {
  __typename?: 'admin_app_audit_log_min_fields';
  action?: Maybe<Scalars['String']['output']>;
  actor_email?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "admin_app.audit_log" */
export type Admin_App_Audit_Log_Mutation_Response = {
  __typename?: 'admin_app_audit_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_App_Audit_Log>;
};

/** input type for inserting object relation for remote table "admin_app.audit_log" */
export type Admin_App_Audit_Log_Obj_Rel_Insert_Input = {
  data: Admin_App_Audit_Log_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_App_Audit_Log_On_Conflict>;
};

/** on_conflict condition type for table "admin_app.audit_log" */
export type Admin_App_Audit_Log_On_Conflict = {
  constraint: Admin_App_Audit_Log_Constraint;
  update_columns?: Array<Admin_App_Audit_Log_Update_Column>;
  where?: InputMaybe<Admin_App_Audit_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "admin_app.audit_log". */
export type Admin_App_Audit_Log_Order_By = {
  action?: InputMaybe<Order_By>;
  actor_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  targets_aggregate?: InputMaybe<Admin_App_Audit_Log_Targets_Aggregate_Order_By>;
};

/** primary key columns input for table: admin_app.audit_log */
export type Admin_App_Audit_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "admin_app.audit_log" */
export enum Admin_App_Audit_Log_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActorEmail = 'actor_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "admin_app.audit_log" */
export type Admin_App_Audit_Log_Set_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  actor_email?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "admin_app_audit_log" */
export type Admin_App_Audit_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_App_Audit_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_App_Audit_Log_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']['input']>;
  actor_email?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets = {
  __typename?: 'admin_app_audit_log_targets';
  /** An object relationship */
  audit_log: Admin_App_Audit_Log;
  audit_log_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  record_id: Scalars['String']['output'];
  table_name: Scalars['String']['output'];
};

/** aggregated selection of "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Aggregate = {
  __typename?: 'admin_app_audit_log_targets_aggregate';
  aggregate?: Maybe<Admin_App_Audit_Log_Targets_Aggregate_Fields>;
  nodes: Array<Admin_App_Audit_Log_Targets>;
};

export type Admin_App_Audit_Log_Targets_Aggregate_Bool_Exp = {
  count?: InputMaybe<Admin_App_Audit_Log_Targets_Aggregate_Bool_Exp_Count>;
};

export type Admin_App_Audit_Log_Targets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Aggregate_Fields = {
  __typename?: 'admin_app_audit_log_targets_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Admin_App_Audit_Log_Targets_Max_Fields>;
  min?: Maybe<Admin_App_Audit_Log_Targets_Min_Fields>;
};


/** aggregate fields of "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Admin_App_Audit_Log_Targets_Max_Order_By>;
  min?: InputMaybe<Admin_App_Audit_Log_Targets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Arr_Rel_Insert_Input = {
  data: Array<Admin_App_Audit_Log_Targets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Admin_App_Audit_Log_Targets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "admin_app.audit_log_targets". All fields are combined with a logical 'AND'. */
export type Admin_App_Audit_Log_Targets_Bool_Exp = {
  _and?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Bool_Exp>>;
  _not?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
  _or?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Bool_Exp>>;
  audit_log?: InputMaybe<Admin_App_Audit_Log_Bool_Exp>;
  audit_log_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  record_id?: InputMaybe<String_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "admin_app.audit_log_targets" */
export enum Admin_App_Audit_Log_Targets_Constraint {
  /** unique or primary key constraint on columns "id" */
  AuditLogTargetsPkey = 'audit_log_targets_pkey'
}

/** input type for inserting data into table "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Insert_Input = {
  audit_log?: InputMaybe<Admin_App_Audit_Log_Obj_Rel_Insert_Input>;
  audit_log_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  record_id?: InputMaybe<Scalars['String']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Admin_App_Audit_Log_Targets_Max_Fields = {
  __typename?: 'admin_app_audit_log_targets_max_fields';
  audit_log_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  record_id?: Maybe<Scalars['String']['output']>;
  table_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Max_Order_By = {
  audit_log_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  record_id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Admin_App_Audit_Log_Targets_Min_Fields = {
  __typename?: 'admin_app_audit_log_targets_min_fields';
  audit_log_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  record_id?: Maybe<Scalars['String']['output']>;
  table_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Min_Order_By = {
  audit_log_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  record_id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Mutation_Response = {
  __typename?: 'admin_app_audit_log_targets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Admin_App_Audit_Log_Targets>;
};

/** on_conflict condition type for table "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_On_Conflict = {
  constraint: Admin_App_Audit_Log_Targets_Constraint;
  update_columns?: Array<Admin_App_Audit_Log_Targets_Update_Column>;
  where?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
};

/** Ordering options when selecting data from "admin_app.audit_log_targets". */
export type Admin_App_Audit_Log_Targets_Order_By = {
  audit_log?: InputMaybe<Admin_App_Audit_Log_Order_By>;
  audit_log_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  record_id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: admin_app.audit_log_targets */
export type Admin_App_Audit_Log_Targets_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "admin_app.audit_log_targets" */
export enum Admin_App_Audit_Log_Targets_Select_Column {
  /** column name */
  AuditLogId = 'audit_log_id',
  /** column name */
  Id = 'id',
  /** column name */
  RecordId = 'record_id',
  /** column name */
  TableName = 'table_name'
}

/** input type for updating data in table "admin_app.audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Set_Input = {
  audit_log_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  record_id?: InputMaybe<Scalars['String']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "admin_app_audit_log_targets" */
export type Admin_App_Audit_Log_Targets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Admin_App_Audit_Log_Targets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Admin_App_Audit_Log_Targets_Stream_Cursor_Value_Input = {
  audit_log_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  record_id?: InputMaybe<Scalars['String']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "admin_app.audit_log_targets" */
export enum Admin_App_Audit_Log_Targets_Update_Column {
  /** column name */
  AuditLogId = 'audit_log_id',
  /** column name */
  Id = 'id',
  /** column name */
  RecordId = 'record_id',
  /** column name */
  TableName = 'table_name'
}

export type Admin_App_Audit_Log_Targets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_App_Audit_Log_Targets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_App_Audit_Log_Targets_Bool_Exp;
};

/** update columns of table "admin_app.audit_log" */
export enum Admin_App_Audit_Log_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActorEmail = 'actor_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

export type Admin_App_Audit_Log_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Admin_App_Audit_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Admin_App_Audit_Log_Bool_Exp;
};

/** columns and relationships of "advanced_studies" */
export type Advanced_Studies = {
  __typename?: 'advanced_studies';
  /** An array relationship */
  advanced_study_constraint_stacks: Array<Advanced_Study_Constraint_Stacks>;
  /** An aggregate relationship */
  advanced_study_constraint_stacks_aggregate: Advanced_Study_Constraint_Stacks_Aggregate;
  advanced_study_id: Scalars['uuid']['output'];
  /** An array relationship */
  advanced_study_loads: Array<Advanced_Study_Loads>;
  /** An aggregate relationship */
  advanced_study_loads_aggregate: Advanced_Study_Loads_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  dagster_run_id?: Maybe<Scalars['String']['output']>;
  model_vintage?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "advanced_studies" */
export type Advanced_StudiesAdvanced_Study_Constraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
};


/** columns and relationships of "advanced_studies" */
export type Advanced_StudiesAdvanced_Study_Constraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
};


/** columns and relationships of "advanced_studies" */
export type Advanced_StudiesAdvanced_Study_LoadsArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Loads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Loads_Order_By>>;
  where?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
};


/** columns and relationships of "advanced_studies" */
export type Advanced_StudiesAdvanced_Study_Loads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Loads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Loads_Order_By>>;
  where?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
};

/** aggregated selection of "advanced_studies" */
export type Advanced_Studies_Aggregate = {
  __typename?: 'advanced_studies_aggregate';
  aggregate?: Maybe<Advanced_Studies_Aggregate_Fields>;
  nodes: Array<Advanced_Studies>;
};

/** aggregate fields of "advanced_studies" */
export type Advanced_Studies_Aggregate_Fields = {
  __typename?: 'advanced_studies_aggregate_fields';
  avg?: Maybe<Advanced_Studies_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Advanced_Studies_Max_Fields>;
  min?: Maybe<Advanced_Studies_Min_Fields>;
  stddev?: Maybe<Advanced_Studies_Stddev_Fields>;
  stddev_pop?: Maybe<Advanced_Studies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Advanced_Studies_Stddev_Samp_Fields>;
  sum?: Maybe<Advanced_Studies_Sum_Fields>;
  var_pop?: Maybe<Advanced_Studies_Var_Pop_Fields>;
  var_samp?: Maybe<Advanced_Studies_Var_Samp_Fields>;
  variance?: Maybe<Advanced_Studies_Variance_Fields>;
};


/** aggregate fields of "advanced_studies" */
export type Advanced_Studies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advanced_Studies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Advanced_Studies_Avg_Fields = {
  __typename?: 'advanced_studies_avg_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "advanced_studies". All fields are combined with a logical 'AND'. */
export type Advanced_Studies_Bool_Exp = {
  _and?: InputMaybe<Array<Advanced_Studies_Bool_Exp>>;
  _not?: InputMaybe<Advanced_Studies_Bool_Exp>;
  _or?: InputMaybe<Array<Advanced_Studies_Bool_Exp>>;
  advanced_study_constraint_stacks?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
  advanced_study_constraint_stacks_aggregate?: InputMaybe<Advanced_Study_Constraint_Stacks_Aggregate_Bool_Exp>;
  advanced_study_id?: InputMaybe<Uuid_Comparison_Exp>;
  advanced_study_loads?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
  advanced_study_loads_aggregate?: InputMaybe<Advanced_Study_Loads_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dagster_run_id?: InputMaybe<String_Comparison_Exp>;
  model_vintage?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "advanced_studies" */
export enum Advanced_Studies_Constraint {
  /** unique or primary key constraint on columns "advanced_study_id" */
  AdvancedStudiesPkey = 'advanced_studies_pkey'
}

/** input type for incrementing numeric columns in table "advanced_studies" */
export type Advanced_Studies_Inc_Input = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "advanced_studies" */
export type Advanced_Studies_Insert_Input = {
  advanced_study_constraint_stacks?: InputMaybe<Advanced_Study_Constraint_Stacks_Arr_Rel_Insert_Input>;
  advanced_study_id?: InputMaybe<Scalars['uuid']['input']>;
  advanced_study_loads?: InputMaybe<Advanced_Study_Loads_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dagster_run_id?: InputMaybe<Scalars['String']['input']>;
  model_vintage?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Advanced_Studies_Max_Fields = {
  __typename?: 'advanced_studies_max_fields';
  advanced_study_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dagster_run_id?: Maybe<Scalars['String']['output']>;
  model_vintage?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Advanced_Studies_Min_Fields = {
  __typename?: 'advanced_studies_min_fields';
  advanced_study_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dagster_run_id?: Maybe<Scalars['String']['output']>;
  model_vintage?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "advanced_studies" */
export type Advanced_Studies_Mutation_Response = {
  __typename?: 'advanced_studies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Advanced_Studies>;
};

/** input type for inserting object relation for remote table "advanced_studies" */
export type Advanced_Studies_Obj_Rel_Insert_Input = {
  data: Advanced_Studies_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Advanced_Studies_On_Conflict>;
};

/** on_conflict condition type for table "advanced_studies" */
export type Advanced_Studies_On_Conflict = {
  constraint: Advanced_Studies_Constraint;
  update_columns?: Array<Advanced_Studies_Update_Column>;
  where?: InputMaybe<Advanced_Studies_Bool_Exp>;
};

/** Ordering options when selecting data from "advanced_studies". */
export type Advanced_Studies_Order_By = {
  advanced_study_constraint_stacks_aggregate?: InputMaybe<Advanced_Study_Constraint_Stacks_Aggregate_Order_By>;
  advanced_study_id?: InputMaybe<Order_By>;
  advanced_study_loads_aggregate?: InputMaybe<Advanced_Study_Loads_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  dagster_run_id?: InputMaybe<Order_By>;
  model_vintage?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advanced_studies */
export type Advanced_Studies_Pk_Columns_Input = {
  advanced_study_id: Scalars['uuid']['input'];
};

/** select columns of table "advanced_studies" */
export enum Advanced_Studies_Select_Column {
  /** column name */
  AdvancedStudyId = 'advanced_study_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DagsterRunId = 'dagster_run_id',
  /** column name */
  ModelVintage = 'model_vintage',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "advanced_studies" */
export type Advanced_Studies_Set_Input = {
  advanced_study_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dagster_run_id?: InputMaybe<Scalars['String']['input']>;
  model_vintage?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Advanced_Studies_Stddev_Fields = {
  __typename?: 'advanced_studies_stddev_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Advanced_Studies_Stddev_Pop_Fields = {
  __typename?: 'advanced_studies_stddev_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Advanced_Studies_Stddev_Samp_Fields = {
  __typename?: 'advanced_studies_stddev_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "advanced_studies" */
export type Advanced_Studies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advanced_Studies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advanced_Studies_Stream_Cursor_Value_Input = {
  advanced_study_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dagster_run_id?: InputMaybe<Scalars['String']['input']>;
  model_vintage?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Advanced_Studies_Sum_Fields = {
  __typename?: 'advanced_studies_sum_fields';
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "advanced_studies" */
export enum Advanced_Studies_Update_Column {
  /** column name */
  AdvancedStudyId = 'advanced_study_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DagsterRunId = 'dagster_run_id',
  /** column name */
  ModelVintage = 'model_vintage',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Advanced_Studies_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Advanced_Studies_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advanced_Studies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Advanced_Studies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Advanced_Studies_Var_Pop_Fields = {
  __typename?: 'advanced_studies_var_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Advanced_Studies_Var_Samp_Fields = {
  __typename?: 'advanced_studies_var_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Advanced_Studies_Variance_Fields = {
  __typename?: 'advanced_studies_variance_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks = {
  __typename?: 'advanced_study_constraint_stacks';
  /** An object relationship */
  advanced_study: Advanced_Studies;
  advanced_study_id: Scalars['uuid']['output'];
  bench_percent_loading: Scalars['numeric']['output'];
  contingency: Scalars['String']['output'];
  cost: Scalars['numeric']['output'];
  dfax: Scalars['numeric']['output'];
  monitored_facility_id: Scalars['String']['output'];
  monitored_facility_name: Scalars['String']['output'];
  nira_bus_id: Scalars['String']['output'];
  rating: Scalars['numeric']['output'];
  study_percent_loading: Scalars['numeric']['output'];
};

/** aggregated selection of "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Aggregate = {
  __typename?: 'advanced_study_constraint_stacks_aggregate';
  aggregate?: Maybe<Advanced_Study_Constraint_Stacks_Aggregate_Fields>;
  nodes: Array<Advanced_Study_Constraint_Stacks>;
};

export type Advanced_Study_Constraint_Stacks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Advanced_Study_Constraint_Stacks_Aggregate_Bool_Exp_Count>;
};

export type Advanced_Study_Constraint_Stacks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Aggregate_Fields = {
  __typename?: 'advanced_study_constraint_stacks_aggregate_fields';
  avg?: Maybe<Advanced_Study_Constraint_Stacks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Advanced_Study_Constraint_Stacks_Max_Fields>;
  min?: Maybe<Advanced_Study_Constraint_Stacks_Min_Fields>;
  stddev?: Maybe<Advanced_Study_Constraint_Stacks_Stddev_Fields>;
  stddev_pop?: Maybe<Advanced_Study_Constraint_Stacks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Advanced_Study_Constraint_Stacks_Stddev_Samp_Fields>;
  sum?: Maybe<Advanced_Study_Constraint_Stacks_Sum_Fields>;
  var_pop?: Maybe<Advanced_Study_Constraint_Stacks_Var_Pop_Fields>;
  var_samp?: Maybe<Advanced_Study_Constraint_Stacks_Var_Samp_Fields>;
  variance?: Maybe<Advanced_Study_Constraint_Stacks_Variance_Fields>;
};


/** aggregate fields of "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Aggregate_Order_By = {
  avg?: InputMaybe<Advanced_Study_Constraint_Stacks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Advanced_Study_Constraint_Stacks_Max_Order_By>;
  min?: InputMaybe<Advanced_Study_Constraint_Stacks_Min_Order_By>;
  stddev?: InputMaybe<Advanced_Study_Constraint_Stacks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Advanced_Study_Constraint_Stacks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Advanced_Study_Constraint_Stacks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Advanced_Study_Constraint_Stacks_Sum_Order_By>;
  var_pop?: InputMaybe<Advanced_Study_Constraint_Stacks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Advanced_Study_Constraint_Stacks_Var_Samp_Order_By>;
  variance?: InputMaybe<Advanced_Study_Constraint_Stacks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Arr_Rel_Insert_Input = {
  data: Array<Advanced_Study_Constraint_Stacks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Advanced_Study_Constraint_Stacks_On_Conflict>;
};

/** aggregate avg on columns */
export type Advanced_Study_Constraint_Stacks_Avg_Fields = {
  __typename?: 'advanced_study_constraint_stacks_avg_fields';
  bench_percent_loading?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  dfax?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  study_percent_loading?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Avg_Order_By = {
  bench_percent_loading?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "advanced_study_constraint_stacks". All fields are combined with a logical 'AND'. */
export type Advanced_Study_Constraint_Stacks_Bool_Exp = {
  _and?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Bool_Exp>>;
  _not?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
  _or?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Bool_Exp>>;
  advanced_study?: InputMaybe<Advanced_Studies_Bool_Exp>;
  advanced_study_id?: InputMaybe<Uuid_Comparison_Exp>;
  bench_percent_loading?: InputMaybe<Numeric_Comparison_Exp>;
  contingency?: InputMaybe<String_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  dfax?: InputMaybe<Numeric_Comparison_Exp>;
  monitored_facility_id?: InputMaybe<String_Comparison_Exp>;
  monitored_facility_name?: InputMaybe<String_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  rating?: InputMaybe<Numeric_Comparison_Exp>;
  study_percent_loading?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "advanced_study_constraint_stacks" */
export enum Advanced_Study_Constraint_Stacks_Constraint {
  /** unique or primary key constraint on columns "nira_bus_id", "advanced_study_id", "monitored_facility_id" */
  AdvancedStudyConstraintStacksPkey = 'advanced_study_constraint_stacks_pkey'
}

/** input type for incrementing numeric columns in table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Inc_Input = {
  bench_percent_loading?: InputMaybe<Scalars['numeric']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  study_percent_loading?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Insert_Input = {
  advanced_study?: InputMaybe<Advanced_Studies_Obj_Rel_Insert_Input>;
  advanced_study_id?: InputMaybe<Scalars['uuid']['input']>;
  bench_percent_loading?: InputMaybe<Scalars['numeric']['input']>;
  contingency?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  study_percent_loading?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Advanced_Study_Constraint_Stacks_Max_Fields = {
  __typename?: 'advanced_study_constraint_stacks_max_fields';
  advanced_study_id?: Maybe<Scalars['uuid']['output']>;
  bench_percent_loading?: Maybe<Scalars['numeric']['output']>;
  contingency?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  study_percent_loading?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Max_Order_By = {
  advanced_study_id?: InputMaybe<Order_By>;
  bench_percent_loading?: InputMaybe<Order_By>;
  contingency?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Advanced_Study_Constraint_Stacks_Min_Fields = {
  __typename?: 'advanced_study_constraint_stacks_min_fields';
  advanced_study_id?: Maybe<Scalars['uuid']['output']>;
  bench_percent_loading?: Maybe<Scalars['numeric']['output']>;
  contingency?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  study_percent_loading?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Min_Order_By = {
  advanced_study_id?: InputMaybe<Order_By>;
  bench_percent_loading?: InputMaybe<Order_By>;
  contingency?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Mutation_Response = {
  __typename?: 'advanced_study_constraint_stacks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Advanced_Study_Constraint_Stacks>;
};

/** on_conflict condition type for table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_On_Conflict = {
  constraint: Advanced_Study_Constraint_Stacks_Constraint;
  update_columns?: Array<Advanced_Study_Constraint_Stacks_Update_Column>;
  where?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
};

/** Ordering options when selecting data from "advanced_study_constraint_stacks". */
export type Advanced_Study_Constraint_Stacks_Order_By = {
  advanced_study?: InputMaybe<Advanced_Studies_Order_By>;
  advanced_study_id?: InputMaybe<Order_By>;
  bench_percent_loading?: InputMaybe<Order_By>;
  contingency?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advanced_study_constraint_stacks */
export type Advanced_Study_Constraint_Stacks_Pk_Columns_Input = {
  advanced_study_id: Scalars['uuid']['input'];
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
};

/** select columns of table "advanced_study_constraint_stacks" */
export enum Advanced_Study_Constraint_Stacks_Select_Column {
  /** column name */
  AdvancedStudyId = 'advanced_study_id',
  /** column name */
  BenchPercentLoading = 'bench_percent_loading',
  /** column name */
  Contingency = 'contingency',
  /** column name */
  Cost = 'cost',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Rating = 'rating',
  /** column name */
  StudyPercentLoading = 'study_percent_loading'
}

/** input type for updating data in table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Set_Input = {
  advanced_study_id?: InputMaybe<Scalars['uuid']['input']>;
  bench_percent_loading?: InputMaybe<Scalars['numeric']['input']>;
  contingency?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  study_percent_loading?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Advanced_Study_Constraint_Stacks_Stddev_Fields = {
  __typename?: 'advanced_study_constraint_stacks_stddev_fields';
  bench_percent_loading?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  dfax?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  study_percent_loading?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Stddev_Order_By = {
  bench_percent_loading?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Advanced_Study_Constraint_Stacks_Stddev_Pop_Fields = {
  __typename?: 'advanced_study_constraint_stacks_stddev_pop_fields';
  bench_percent_loading?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  dfax?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  study_percent_loading?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Stddev_Pop_Order_By = {
  bench_percent_loading?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Advanced_Study_Constraint_Stacks_Stddev_Samp_Fields = {
  __typename?: 'advanced_study_constraint_stacks_stddev_samp_fields';
  bench_percent_loading?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  dfax?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  study_percent_loading?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Stddev_Samp_Order_By = {
  bench_percent_loading?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advanced_Study_Constraint_Stacks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advanced_Study_Constraint_Stacks_Stream_Cursor_Value_Input = {
  advanced_study_id?: InputMaybe<Scalars['uuid']['input']>;
  bench_percent_loading?: InputMaybe<Scalars['numeric']['input']>;
  contingency?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['numeric']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  study_percent_loading?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Advanced_Study_Constraint_Stacks_Sum_Fields = {
  __typename?: 'advanced_study_constraint_stacks_sum_fields';
  bench_percent_loading?: Maybe<Scalars['numeric']['output']>;
  cost?: Maybe<Scalars['numeric']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  study_percent_loading?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Sum_Order_By = {
  bench_percent_loading?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** update columns of table "advanced_study_constraint_stacks" */
export enum Advanced_Study_Constraint_Stacks_Update_Column {
  /** column name */
  AdvancedStudyId = 'advanced_study_id',
  /** column name */
  BenchPercentLoading = 'bench_percent_loading',
  /** column name */
  Contingency = 'contingency',
  /** column name */
  Cost = 'cost',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Rating = 'rating',
  /** column name */
  StudyPercentLoading = 'study_percent_loading'
}

export type Advanced_Study_Constraint_Stacks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Advanced_Study_Constraint_Stacks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advanced_Study_Constraint_Stacks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Advanced_Study_Constraint_Stacks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Advanced_Study_Constraint_Stacks_Var_Pop_Fields = {
  __typename?: 'advanced_study_constraint_stacks_var_pop_fields';
  bench_percent_loading?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  dfax?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  study_percent_loading?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Var_Pop_Order_By = {
  bench_percent_loading?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Advanced_Study_Constraint_Stacks_Var_Samp_Fields = {
  __typename?: 'advanced_study_constraint_stacks_var_samp_fields';
  bench_percent_loading?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  dfax?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  study_percent_loading?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Var_Samp_Order_By = {
  bench_percent_loading?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Advanced_Study_Constraint_Stacks_Variance_Fields = {
  __typename?: 'advanced_study_constraint_stacks_variance_fields';
  bench_percent_loading?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  dfax?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  study_percent_loading?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "advanced_study_constraint_stacks" */
export type Advanced_Study_Constraint_Stacks_Variance_Order_By = {
  bench_percent_loading?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  study_percent_loading?: InputMaybe<Order_By>;
};

/** columns and relationships of "advanced_study_loads" */
export type Advanced_Study_Loads = {
  __typename?: 'advanced_study_loads';
  /** An object relationship */
  advanced_study: Advanced_Studies;
  advanced_study_id: Scalars['uuid']['output'];
  /** An object relationship */
  bus?: Maybe<Buses>;
  facility_type: Scalars['String']['output'];
  mw_size: Scalars['numeric']['output'];
  nira_bus_id: Scalars['String']['output'];
};

/** aggregated selection of "advanced_study_loads" */
export type Advanced_Study_Loads_Aggregate = {
  __typename?: 'advanced_study_loads_aggregate';
  aggregate?: Maybe<Advanced_Study_Loads_Aggregate_Fields>;
  nodes: Array<Advanced_Study_Loads>;
};

export type Advanced_Study_Loads_Aggregate_Bool_Exp = {
  count?: InputMaybe<Advanced_Study_Loads_Aggregate_Bool_Exp_Count>;
};

export type Advanced_Study_Loads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Advanced_Study_Loads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "advanced_study_loads" */
export type Advanced_Study_Loads_Aggregate_Fields = {
  __typename?: 'advanced_study_loads_aggregate_fields';
  avg?: Maybe<Advanced_Study_Loads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Advanced_Study_Loads_Max_Fields>;
  min?: Maybe<Advanced_Study_Loads_Min_Fields>;
  stddev?: Maybe<Advanced_Study_Loads_Stddev_Fields>;
  stddev_pop?: Maybe<Advanced_Study_Loads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Advanced_Study_Loads_Stddev_Samp_Fields>;
  sum?: Maybe<Advanced_Study_Loads_Sum_Fields>;
  var_pop?: Maybe<Advanced_Study_Loads_Var_Pop_Fields>;
  var_samp?: Maybe<Advanced_Study_Loads_Var_Samp_Fields>;
  variance?: Maybe<Advanced_Study_Loads_Variance_Fields>;
};


/** aggregate fields of "advanced_study_loads" */
export type Advanced_Study_Loads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advanced_Study_Loads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "advanced_study_loads" */
export type Advanced_Study_Loads_Aggregate_Order_By = {
  avg?: InputMaybe<Advanced_Study_Loads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Advanced_Study_Loads_Max_Order_By>;
  min?: InputMaybe<Advanced_Study_Loads_Min_Order_By>;
  stddev?: InputMaybe<Advanced_Study_Loads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Advanced_Study_Loads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Advanced_Study_Loads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Advanced_Study_Loads_Sum_Order_By>;
  var_pop?: InputMaybe<Advanced_Study_Loads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Advanced_Study_Loads_Var_Samp_Order_By>;
  variance?: InputMaybe<Advanced_Study_Loads_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "advanced_study_loads" */
export type Advanced_Study_Loads_Arr_Rel_Insert_Input = {
  data: Array<Advanced_Study_Loads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Advanced_Study_Loads_On_Conflict>;
};

/** aggregate avg on columns */
export type Advanced_Study_Loads_Avg_Fields = {
  __typename?: 'advanced_study_loads_avg_fields';
  mw_size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Avg_Order_By = {
  mw_size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "advanced_study_loads". All fields are combined with a logical 'AND'. */
export type Advanced_Study_Loads_Bool_Exp = {
  _and?: InputMaybe<Array<Advanced_Study_Loads_Bool_Exp>>;
  _not?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
  _or?: InputMaybe<Array<Advanced_Study_Loads_Bool_Exp>>;
  advanced_study?: InputMaybe<Advanced_Studies_Bool_Exp>;
  advanced_study_id?: InputMaybe<Uuid_Comparison_Exp>;
  bus?: InputMaybe<Buses_Bool_Exp>;
  facility_type?: InputMaybe<String_Comparison_Exp>;
  mw_size?: InputMaybe<Numeric_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "advanced_study_loads" */
export enum Advanced_Study_Loads_Constraint {
  /** unique or primary key constraint on columns "nira_bus_id", "facility_type", "advanced_study_id" */
  AdvancedStudyLoadsPkey = 'advanced_study_loads_pkey'
}

/** input type for incrementing numeric columns in table "advanced_study_loads" */
export type Advanced_Study_Loads_Inc_Input = {
  mw_size?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "advanced_study_loads" */
export type Advanced_Study_Loads_Insert_Input = {
  advanced_study?: InputMaybe<Advanced_Studies_Obj_Rel_Insert_Input>;
  advanced_study_id?: InputMaybe<Scalars['uuid']['input']>;
  bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  facility_type?: InputMaybe<Scalars['String']['input']>;
  mw_size?: InputMaybe<Scalars['numeric']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Advanced_Study_Loads_Max_Fields = {
  __typename?: 'advanced_study_loads_max_fields';
  advanced_study_id?: Maybe<Scalars['uuid']['output']>;
  facility_type?: Maybe<Scalars['String']['output']>;
  mw_size?: Maybe<Scalars['numeric']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Max_Order_By = {
  advanced_study_id?: InputMaybe<Order_By>;
  facility_type?: InputMaybe<Order_By>;
  mw_size?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Advanced_Study_Loads_Min_Fields = {
  __typename?: 'advanced_study_loads_min_fields';
  advanced_study_id?: Maybe<Scalars['uuid']['output']>;
  facility_type?: Maybe<Scalars['String']['output']>;
  mw_size?: Maybe<Scalars['numeric']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Min_Order_By = {
  advanced_study_id?: InputMaybe<Order_By>;
  facility_type?: InputMaybe<Order_By>;
  mw_size?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "advanced_study_loads" */
export type Advanced_Study_Loads_Mutation_Response = {
  __typename?: 'advanced_study_loads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Advanced_Study_Loads>;
};

/** on_conflict condition type for table "advanced_study_loads" */
export type Advanced_Study_Loads_On_Conflict = {
  constraint: Advanced_Study_Loads_Constraint;
  update_columns?: Array<Advanced_Study_Loads_Update_Column>;
  where?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
};

/** Ordering options when selecting data from "advanced_study_loads". */
export type Advanced_Study_Loads_Order_By = {
  advanced_study?: InputMaybe<Advanced_Studies_Order_By>;
  advanced_study_id?: InputMaybe<Order_By>;
  bus?: InputMaybe<Buses_Order_By>;
  facility_type?: InputMaybe<Order_By>;
  mw_size?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advanced_study_loads */
export type Advanced_Study_Loads_Pk_Columns_Input = {
  advanced_study_id: Scalars['uuid']['input'];
  facility_type: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
};

/** select columns of table "advanced_study_loads" */
export enum Advanced_Study_Loads_Select_Column {
  /** column name */
  AdvancedStudyId = 'advanced_study_id',
  /** column name */
  FacilityType = 'facility_type',
  /** column name */
  MwSize = 'mw_size',
  /** column name */
  NiraBusId = 'nira_bus_id'
}

/** input type for updating data in table "advanced_study_loads" */
export type Advanced_Study_Loads_Set_Input = {
  advanced_study_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_type?: InputMaybe<Scalars['String']['input']>;
  mw_size?: InputMaybe<Scalars['numeric']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Advanced_Study_Loads_Stddev_Fields = {
  __typename?: 'advanced_study_loads_stddev_fields';
  mw_size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Stddev_Order_By = {
  mw_size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Advanced_Study_Loads_Stddev_Pop_Fields = {
  __typename?: 'advanced_study_loads_stddev_pop_fields';
  mw_size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Stddev_Pop_Order_By = {
  mw_size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Advanced_Study_Loads_Stddev_Samp_Fields = {
  __typename?: 'advanced_study_loads_stddev_samp_fields';
  mw_size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Stddev_Samp_Order_By = {
  mw_size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "advanced_study_loads" */
export type Advanced_Study_Loads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advanced_Study_Loads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advanced_Study_Loads_Stream_Cursor_Value_Input = {
  advanced_study_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_type?: InputMaybe<Scalars['String']['input']>;
  mw_size?: InputMaybe<Scalars['numeric']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Advanced_Study_Loads_Sum_Fields = {
  __typename?: 'advanced_study_loads_sum_fields';
  mw_size?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Sum_Order_By = {
  mw_size?: InputMaybe<Order_By>;
};

/** update columns of table "advanced_study_loads" */
export enum Advanced_Study_Loads_Update_Column {
  /** column name */
  AdvancedStudyId = 'advanced_study_id',
  /** column name */
  FacilityType = 'facility_type',
  /** column name */
  MwSize = 'mw_size',
  /** column name */
  NiraBusId = 'nira_bus_id'
}

export type Advanced_Study_Loads_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Advanced_Study_Loads_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advanced_Study_Loads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Advanced_Study_Loads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Advanced_Study_Loads_Var_Pop_Fields = {
  __typename?: 'advanced_study_loads_var_pop_fields';
  mw_size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Var_Pop_Order_By = {
  mw_size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Advanced_Study_Loads_Var_Samp_Fields = {
  __typename?: 'advanced_study_loads_var_samp_fields';
  mw_size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Var_Samp_Order_By = {
  mw_size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Advanced_Study_Loads_Variance_Fields = {
  __typename?: 'advanced_study_loads_variance_fields';
  mw_size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "advanced_study_loads" */
export type Advanced_Study_Loads_Variance_Order_By = {
  mw_size?: InputMaybe<Order_By>;
};

/** columns and relationships of "all_projects" */
export type All_Projects = {
  __typename?: 'all_projects';
  bus_number?: Maybe<Scalars['String']['output']>;
  cluster_id: Scalars['uuid']['output'];
  developer_name?: Maybe<Scalars['String']['output']>;
  eris_capacity_mw: Scalars['numeric']['output'];
  facility_id?: Maybe<Scalars['String']['output']>;
  fuel_type: Scalars['String']['output'];
  /** An object relationship */
  in_queue_cluster: In_Queue_Clusters;
  is_editable: Scalars['Boolean']['output'];
  is_withdrawn: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  nris_capacity_mw: Scalars['numeric']['output'];
  project_id: Scalars['String']['output'];
  region: Scalars['String']['output'];
  stage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  study_cycle: Scalars['String']['output'];
  study_group: Scalars['String']['output'];
  study_phase: Scalars['String']['output'];
};


/** columns and relationships of "all_projects" */
export type All_ProjectsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "all_projects" */
export type All_Projects_Aggregate = {
  __typename?: 'all_projects_aggregate';
  aggregate?: Maybe<All_Projects_Aggregate_Fields>;
  nodes: Array<All_Projects>;
};

/** aggregate fields of "all_projects" */
export type All_Projects_Aggregate_Fields = {
  __typename?: 'all_projects_aggregate_fields';
  avg?: Maybe<All_Projects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<All_Projects_Max_Fields>;
  min?: Maybe<All_Projects_Min_Fields>;
  stddev?: Maybe<All_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<All_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<All_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<All_Projects_Sum_Fields>;
  var_pop?: Maybe<All_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<All_Projects_Var_Samp_Fields>;
  variance?: Maybe<All_Projects_Variance_Fields>;
};


/** aggregate fields of "all_projects" */
export type All_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<All_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type All_Projects_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type All_Projects_Avg_Fields = {
  __typename?: 'all_projects_avg_fields';
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "all_projects". All fields are combined with a logical 'AND'. */
export type All_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<All_Projects_Bool_Exp>>;
  _not?: InputMaybe<All_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<All_Projects_Bool_Exp>>;
  bus_number?: InputMaybe<String_Comparison_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  developer_name?: InputMaybe<String_Comparison_Exp>;
  eris_capacity_mw?: InputMaybe<Numeric_Comparison_Exp>;
  facility_id?: InputMaybe<String_Comparison_Exp>;
  fuel_type?: InputMaybe<String_Comparison_Exp>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  is_editable?: InputMaybe<Boolean_Comparison_Exp>;
  is_withdrawn?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  nris_capacity_mw?: InputMaybe<Numeric_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  study_cycle?: InputMaybe<String_Comparison_Exp>;
  study_group?: InputMaybe<String_Comparison_Exp>;
  study_phase?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "all_projects" */
export enum All_Projects_Constraint {
  /** unique or primary key constraint on columns "cluster_id", "project_id" */
  AllProjectsPkey = 'all_projects_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type All_Projects_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type All_Projects_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type All_Projects_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "all_projects" */
export type All_Projects_Inc_Input = {
  eris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  nris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "all_projects" */
export type All_Projects_Insert_Input = {
  bus_number?: InputMaybe<Scalars['String']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  developer_name?: InputMaybe<Scalars['String']['input']>;
  eris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  is_editable?: InputMaybe<Scalars['Boolean']['input']>;
  is_withdrawn?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  nris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type All_Projects_Max_Fields = {
  __typename?: 'all_projects_max_fields';
  bus_number?: Maybe<Scalars['String']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  developer_name?: Maybe<Scalars['String']['output']>;
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  study_phase?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type All_Projects_Min_Fields = {
  __typename?: 'all_projects_min_fields';
  bus_number?: Maybe<Scalars['String']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  developer_name?: Maybe<Scalars['String']['output']>;
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  study_phase?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "all_projects" */
export type All_Projects_Mutation_Response = {
  __typename?: 'all_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<All_Projects>;
};

/** on_conflict condition type for table "all_projects" */
export type All_Projects_On_Conflict = {
  constraint: All_Projects_Constraint;
  update_columns?: Array<All_Projects_Update_Column>;
  where?: InputMaybe<All_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "all_projects". */
export type All_Projects_Order_By = {
  bus_number?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  developer_name?: InputMaybe<Order_By>;
  eris_capacity_mw?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  fuel_type?: InputMaybe<Order_By>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  is_editable?: InputMaybe<Order_By>;
  is_withdrawn?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  nris_capacity_mw?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  study_cycle?: InputMaybe<Order_By>;
  study_group?: InputMaybe<Order_By>;
  study_phase?: InputMaybe<Order_By>;
};

/** primary key columns input for table: all_projects */
export type All_Projects_Pk_Columns_Input = {
  cluster_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type All_Projects_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "all_projects" */
export enum All_Projects_Select_Column {
  /** column name */
  BusNumber = 'bus_number',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  DeveloperName = 'developer_name',
  /** column name */
  ErisCapacityMw = 'eris_capacity_mw',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FuelType = 'fuel_type',
  /** column name */
  IsEditable = 'is_editable',
  /** column name */
  IsWithdrawn = 'is_withdrawn',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Notes = 'notes',
  /** column name */
  NrisCapacityMw = 'nris_capacity_mw',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Region = 'region',
  /** column name */
  Stage = 'stage',
  /** column name */
  Status = 'status',
  /** column name */
  StudyCycle = 'study_cycle',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  StudyPhase = 'study_phase'
}

/** input type for updating data in table "all_projects" */
export type All_Projects_Set_Input = {
  bus_number?: InputMaybe<Scalars['String']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  developer_name?: InputMaybe<Scalars['String']['input']>;
  eris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  is_editable?: InputMaybe<Scalars['Boolean']['input']>;
  is_withdrawn?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  nris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type All_Projects_Stddev_Fields = {
  __typename?: 'all_projects_stddev_fields';
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type All_Projects_Stddev_Pop_Fields = {
  __typename?: 'all_projects_stddev_pop_fields';
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type All_Projects_Stddev_Samp_Fields = {
  __typename?: 'all_projects_stddev_samp_fields';
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "all_projects" */
export type All_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: All_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type All_Projects_Stream_Cursor_Value_Input = {
  bus_number?: InputMaybe<Scalars['String']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  developer_name?: InputMaybe<Scalars['String']['input']>;
  eris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  is_editable?: InputMaybe<Scalars['Boolean']['input']>;
  is_withdrawn?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  nris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type All_Projects_Sum_Fields = {
  __typename?: 'all_projects_sum_fields';
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "all_projects" */
export enum All_Projects_Update_Column {
  /** column name */
  BusNumber = 'bus_number',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  DeveloperName = 'developer_name',
  /** column name */
  ErisCapacityMw = 'eris_capacity_mw',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FuelType = 'fuel_type',
  /** column name */
  IsEditable = 'is_editable',
  /** column name */
  IsWithdrawn = 'is_withdrawn',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Notes = 'notes',
  /** column name */
  NrisCapacityMw = 'nris_capacity_mw',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Region = 'region',
  /** column name */
  Stage = 'stage',
  /** column name */
  Status = 'status',
  /** column name */
  StudyCycle = 'study_cycle',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  StudyPhase = 'study_phase'
}

export type All_Projects_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<All_Projects_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<All_Projects_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<All_Projects_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<All_Projects_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<All_Projects_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<All_Projects_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<All_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: All_Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type All_Projects_Var_Pop_Fields = {
  __typename?: 'all_projects_var_pop_fields';
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type All_Projects_Var_Samp_Fields = {
  __typename?: 'all_projects_var_samp_fields';
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type All_Projects_Variance_Fields = {
  __typename?: 'all_projects_variance_fields';
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "branches" */
export type Branches = {
  __typename?: 'branches';
  branch_path: Scalars['path']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['String']['output'];
  latitude_substation_one: Scalars['numeric']['output'];
  latitude_substation_two: Scalars['numeric']['output'];
  longitude_substation_one: Scalars['numeric']['output'];
  longitude_substation_two: Scalars['numeric']['output'];
  /** An array relationship */
  model_lines_to_branches: Array<Model_Lines_To_Branches>;
  /** An aggregate relationship */
  model_lines_to_branches_aggregate: Model_Lines_To_Branches_Aggregate;
  regions: Scalars['jsonb']['output'];
  states: Scalars['jsonb']['output'];
  voltage: Scalars['numeric']['output'];
};


/** columns and relationships of "branches" */
export type BranchesModel_Lines_To_BranchesArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Branches_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
};


/** columns and relationships of "branches" */
export type BranchesModel_Lines_To_Branches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Branches_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
};


/** columns and relationships of "branches" */
export type BranchesRegionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "branches" */
export type BranchesStatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "branches" */
export type Branches_Aggregate = {
  __typename?: 'branches_aggregate';
  aggregate?: Maybe<Branches_Aggregate_Fields>;
  nodes: Array<Branches>;
};

/** aggregate fields of "branches" */
export type Branches_Aggregate_Fields = {
  __typename?: 'branches_aggregate_fields';
  avg?: Maybe<Branches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Branches_Max_Fields>;
  min?: Maybe<Branches_Min_Fields>;
  stddev?: Maybe<Branches_Stddev_Fields>;
  stddev_pop?: Maybe<Branches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Branches_Stddev_Samp_Fields>;
  sum?: Maybe<Branches_Sum_Fields>;
  var_pop?: Maybe<Branches_Var_Pop_Fields>;
  var_samp?: Maybe<Branches_Var_Samp_Fields>;
  variance?: Maybe<Branches_Variance_Fields>;
};


/** aggregate fields of "branches" */
export type Branches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Branches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Branches_Append_Input = {
  regions?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Branches_Avg_Fields = {
  __typename?: 'branches_avg_fields';
  latitude_substation_one?: Maybe<Scalars['Float']['output']>;
  latitude_substation_two?: Maybe<Scalars['Float']['output']>;
  longitude_substation_one?: Maybe<Scalars['Float']['output']>;
  longitude_substation_two?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "branches". All fields are combined with a logical 'AND'. */
export type Branches_Bool_Exp = {
  _and?: InputMaybe<Array<Branches_Bool_Exp>>;
  _not?: InputMaybe<Branches_Bool_Exp>;
  _or?: InputMaybe<Array<Branches_Bool_Exp>>;
  branch_path?: InputMaybe<Path_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  latitude_substation_one?: InputMaybe<Numeric_Comparison_Exp>;
  latitude_substation_two?: InputMaybe<Numeric_Comparison_Exp>;
  longitude_substation_one?: InputMaybe<Numeric_Comparison_Exp>;
  longitude_substation_two?: InputMaybe<Numeric_Comparison_Exp>;
  model_lines_to_branches?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
  model_lines_to_branches_aggregate?: InputMaybe<Model_Lines_To_Branches_Aggregate_Bool_Exp>;
  regions?: InputMaybe<Jsonb_Comparison_Exp>;
  states?: InputMaybe<Jsonb_Comparison_Exp>;
  voltage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "branches" */
export enum Branches_Constraint {
  /** unique or primary key constraint on columns "id" */
  BranchesPkey = 'branches_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Branches_Delete_At_Path_Input = {
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Branches_Delete_Elem_Input = {
  regions?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Branches_Delete_Key_Input = {
  regions?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "branches" */
export type Branches_Inc_Input = {
  latitude_substation_one?: InputMaybe<Scalars['numeric']['input']>;
  latitude_substation_two?: InputMaybe<Scalars['numeric']['input']>;
  longitude_substation_one?: InputMaybe<Scalars['numeric']['input']>;
  longitude_substation_two?: InputMaybe<Scalars['numeric']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "branches" */
export type Branches_Insert_Input = {
  branch_path?: InputMaybe<Scalars['path']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude_substation_one?: InputMaybe<Scalars['numeric']['input']>;
  latitude_substation_two?: InputMaybe<Scalars['numeric']['input']>;
  longitude_substation_one?: InputMaybe<Scalars['numeric']['input']>;
  longitude_substation_two?: InputMaybe<Scalars['numeric']['input']>;
  model_lines_to_branches?: InputMaybe<Model_Lines_To_Branches_Arr_Rel_Insert_Input>;
  regions?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Branches_Max_Fields = {
  __typename?: 'branches_max_fields';
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude_substation_one?: Maybe<Scalars['numeric']['output']>;
  latitude_substation_two?: Maybe<Scalars['numeric']['output']>;
  longitude_substation_one?: Maybe<Scalars['numeric']['output']>;
  longitude_substation_two?: Maybe<Scalars['numeric']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Branches_Min_Fields = {
  __typename?: 'branches_min_fields';
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude_substation_one?: Maybe<Scalars['numeric']['output']>;
  latitude_substation_two?: Maybe<Scalars['numeric']['output']>;
  longitude_substation_one?: Maybe<Scalars['numeric']['output']>;
  longitude_substation_two?: Maybe<Scalars['numeric']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "branches" */
export type Branches_Mutation_Response = {
  __typename?: 'branches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Branches>;
};

/** input type for inserting object relation for remote table "branches" */
export type Branches_Obj_Rel_Insert_Input = {
  data: Branches_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Branches_On_Conflict>;
};

/** on_conflict condition type for table "branches" */
export type Branches_On_Conflict = {
  constraint: Branches_Constraint;
  update_columns?: Array<Branches_Update_Column>;
  where?: InputMaybe<Branches_Bool_Exp>;
};

/** Ordering options when selecting data from "branches". */
export type Branches_Order_By = {
  branch_path?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude_substation_one?: InputMaybe<Order_By>;
  latitude_substation_two?: InputMaybe<Order_By>;
  longitude_substation_one?: InputMaybe<Order_By>;
  longitude_substation_two?: InputMaybe<Order_By>;
  model_lines_to_branches_aggregate?: InputMaybe<Model_Lines_To_Branches_Aggregate_Order_By>;
  regions?: InputMaybe<Order_By>;
  states?: InputMaybe<Order_By>;
  voltage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: branches */
export type Branches_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Branches_Prepend_Input = {
  regions?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "branches" */
export enum Branches_Select_Column {
  /** column name */
  BranchPath = 'branch_path',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  LatitudeSubstationOne = 'latitude_substation_one',
  /** column name */
  LatitudeSubstationTwo = 'latitude_substation_two',
  /** column name */
  LongitudeSubstationOne = 'longitude_substation_one',
  /** column name */
  LongitudeSubstationTwo = 'longitude_substation_two',
  /** column name */
  Regions = 'regions',
  /** column name */
  States = 'states',
  /** column name */
  Voltage = 'voltage'
}

/** input type for updating data in table "branches" */
export type Branches_Set_Input = {
  branch_path?: InputMaybe<Scalars['path']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude_substation_one?: InputMaybe<Scalars['numeric']['input']>;
  latitude_substation_two?: InputMaybe<Scalars['numeric']['input']>;
  longitude_substation_one?: InputMaybe<Scalars['numeric']['input']>;
  longitude_substation_two?: InputMaybe<Scalars['numeric']['input']>;
  regions?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Branches_Stddev_Fields = {
  __typename?: 'branches_stddev_fields';
  latitude_substation_one?: Maybe<Scalars['Float']['output']>;
  latitude_substation_two?: Maybe<Scalars['Float']['output']>;
  longitude_substation_one?: Maybe<Scalars['Float']['output']>;
  longitude_substation_two?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Branches_Stddev_Pop_Fields = {
  __typename?: 'branches_stddev_pop_fields';
  latitude_substation_one?: Maybe<Scalars['Float']['output']>;
  latitude_substation_two?: Maybe<Scalars['Float']['output']>;
  longitude_substation_one?: Maybe<Scalars['Float']['output']>;
  longitude_substation_two?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Branches_Stddev_Samp_Fields = {
  __typename?: 'branches_stddev_samp_fields';
  latitude_substation_one?: Maybe<Scalars['Float']['output']>;
  latitude_substation_two?: Maybe<Scalars['Float']['output']>;
  longitude_substation_one?: Maybe<Scalars['Float']['output']>;
  longitude_substation_two?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "branches" */
export type Branches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Branches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Branches_Stream_Cursor_Value_Input = {
  branch_path?: InputMaybe<Scalars['path']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude_substation_one?: InputMaybe<Scalars['numeric']['input']>;
  latitude_substation_two?: InputMaybe<Scalars['numeric']['input']>;
  longitude_substation_one?: InputMaybe<Scalars['numeric']['input']>;
  longitude_substation_two?: InputMaybe<Scalars['numeric']['input']>;
  regions?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Branches_Sum_Fields = {
  __typename?: 'branches_sum_fields';
  latitude_substation_one?: Maybe<Scalars['numeric']['output']>;
  latitude_substation_two?: Maybe<Scalars['numeric']['output']>;
  longitude_substation_one?: Maybe<Scalars['numeric']['output']>;
  longitude_substation_two?: Maybe<Scalars['numeric']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "branches" */
export enum Branches_Update_Column {
  /** column name */
  BranchPath = 'branch_path',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  LatitudeSubstationOne = 'latitude_substation_one',
  /** column name */
  LatitudeSubstationTwo = 'latitude_substation_two',
  /** column name */
  LongitudeSubstationOne = 'longitude_substation_one',
  /** column name */
  LongitudeSubstationTwo = 'longitude_substation_two',
  /** column name */
  Regions = 'regions',
  /** column name */
  States = 'states',
  /** column name */
  Voltage = 'voltage'
}

export type Branches_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Branches_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Branches_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Branches_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Branches_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Branches_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Branches_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Branches_Set_Input>;
  /** filter the rows which have to be updated */
  where: Branches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Branches_Var_Pop_Fields = {
  __typename?: 'branches_var_pop_fields';
  latitude_substation_one?: Maybe<Scalars['Float']['output']>;
  latitude_substation_two?: Maybe<Scalars['Float']['output']>;
  longitude_substation_one?: Maybe<Scalars['Float']['output']>;
  longitude_substation_two?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Branches_Var_Samp_Fields = {
  __typename?: 'branches_var_samp_fields';
  latitude_substation_one?: Maybe<Scalars['Float']['output']>;
  latitude_substation_two?: Maybe<Scalars['Float']['output']>;
  longitude_substation_one?: Maybe<Scalars['Float']['output']>;
  longitude_substation_two?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Branches_Variance_Fields = {
  __typename?: 'branches_variance_fields';
  latitude_substation_one?: Maybe<Scalars['Float']['output']>;
  latitude_substation_two?: Maybe<Scalars['Float']['output']>;
  longitude_substation_one?: Maybe<Scalars['Float']['output']>;
  longitude_substation_two?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "brand_colors" */
export type Brand_Colors = {
  __typename?: 'brand_colors';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "brand_colors" */
export type Brand_Colors_Aggregate = {
  __typename?: 'brand_colors_aggregate';
  aggregate?: Maybe<Brand_Colors_Aggregate_Fields>;
  nodes: Array<Brand_Colors>;
};

/** aggregate fields of "brand_colors" */
export type Brand_Colors_Aggregate_Fields = {
  __typename?: 'brand_colors_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Colors_Max_Fields>;
  min?: Maybe<Brand_Colors_Min_Fields>;
};


/** aggregate fields of "brand_colors" */
export type Brand_Colors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Colors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "brand_colors". All fields are combined with a logical 'AND'. */
export type Brand_Colors_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Colors_Bool_Exp>>;
  _not?: InputMaybe<Brand_Colors_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Colors_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_colors" */
export enum Brand_Colors_Constraint {
  /** unique or primary key constraint on columns "name" */
  BrandColorsPkey = 'brand_colors_pkey'
}

export enum Brand_Colors_Enum {
  /** Cerulean: used for accents and bolded titles. */
  Cerulean = 'CERULEAN',
  /** Charcoal: used for body text. */
  Charcoal = 'CHARCOAL',
  /** Green: core two-tone button color used for new tools. */
  Green = 'GREEN',
  /** Nira Off-White: used for backgrounds. */
  NiraOffWhite = 'NIRA_OFF_WHITE',
  /** Orange Peel: used for accents and graphics. */
  OrangePeel = 'ORANGE_PEEL',
  /** Picton Blue: used for accents and graphics. */
  PictonBlue = 'PICTON_BLUE',
  /** Red: core two-tone button color used for developer challenges. */
  Red = 'RED'
}

/** Boolean expression to compare columns of type "brand_colors_enum". All fields are combined with logical 'AND'. */
export type Brand_Colors_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Brand_Colors_Enum>;
  _in?: InputMaybe<Array<Brand_Colors_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Brand_Colors_Enum>;
  _nin?: InputMaybe<Array<Brand_Colors_Enum>>;
};

/** input type for inserting data into table "brand_colors" */
export type Brand_Colors_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Brand_Colors_Max_Fields = {
  __typename?: 'brand_colors_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Brand_Colors_Min_Fields = {
  __typename?: 'brand_colors_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "brand_colors" */
export type Brand_Colors_Mutation_Response = {
  __typename?: 'brand_colors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Colors>;
};

/** on_conflict condition type for table "brand_colors" */
export type Brand_Colors_On_Conflict = {
  constraint: Brand_Colors_Constraint;
  update_columns?: Array<Brand_Colors_Update_Column>;
  where?: InputMaybe<Brand_Colors_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_colors". */
export type Brand_Colors_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_colors */
export type Brand_Colors_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "brand_colors" */
export enum Brand_Colors_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "brand_colors" */
export type Brand_Colors_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "brand_colors" */
export type Brand_Colors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Colors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Colors_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "brand_colors" */
export enum Brand_Colors_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

export type Brand_Colors_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Colors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Colors_Bool_Exp;
};

/** columns and relationships of "bus_overrides" */
export type Bus_Overrides = {
  __typename?: 'bus_overrides';
  bus_display_name?: Maybe<Scalars['String']['output']>;
  bus_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  removed_at?: Maybe<Scalars['timestamptz']['output']>;
  removed_by?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "bus_overrides" */
export type Bus_Overrides_Aggregate = {
  __typename?: 'bus_overrides_aggregate';
  aggregate?: Maybe<Bus_Overrides_Aggregate_Fields>;
  nodes: Array<Bus_Overrides>;
};

/** aggregate fields of "bus_overrides" */
export type Bus_Overrides_Aggregate_Fields = {
  __typename?: 'bus_overrides_aggregate_fields';
  avg?: Maybe<Bus_Overrides_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Bus_Overrides_Max_Fields>;
  min?: Maybe<Bus_Overrides_Min_Fields>;
  stddev?: Maybe<Bus_Overrides_Stddev_Fields>;
  stddev_pop?: Maybe<Bus_Overrides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bus_Overrides_Stddev_Samp_Fields>;
  sum?: Maybe<Bus_Overrides_Sum_Fields>;
  var_pop?: Maybe<Bus_Overrides_Var_Pop_Fields>;
  var_samp?: Maybe<Bus_Overrides_Var_Samp_Fields>;
  variance?: Maybe<Bus_Overrides_Variance_Fields>;
};


/** aggregate fields of "bus_overrides" */
export type Bus_Overrides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bus_Overrides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Bus_Overrides_Avg_Fields = {
  __typename?: 'bus_overrides_avg_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "bus_overrides". All fields are combined with a logical 'AND'. */
export type Bus_Overrides_Bool_Exp = {
  _and?: InputMaybe<Array<Bus_Overrides_Bool_Exp>>;
  _not?: InputMaybe<Bus_Overrides_Bool_Exp>;
  _or?: InputMaybe<Array<Bus_Overrides_Bool_Exp>>;
  bus_display_name?: InputMaybe<String_Comparison_Exp>;
  bus_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  location_code?: InputMaybe<Int_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  owner_name?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  removed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  removed_by?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  voltage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "bus_overrides" */
export enum Bus_Overrides_Constraint {
  /** unique or primary key constraint on columns "id" */
  BusOverridesPkey = 'bus_overrides_pkey',
  /** unique or primary key constraint on columns "region", "bus_id" */
  BusOverridesRegionalUniqueness = 'bus_overrides_regional_uniqueness',
  /** unique or primary key constraint on columns "scope", "region", "bus_id" */
  BusOverridesScopedUniqueness = 'bus_overrides_scoped_uniqueness'
}

/** input type for incrementing numeric columns in table "bus_overrides" */
export type Bus_Overrides_Inc_Input = {
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "bus_overrides" */
export type Bus_Overrides_Insert_Input = {
  bus_display_name?: InputMaybe<Scalars['String']['input']>;
  bus_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  removed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  removed_by?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Bus_Overrides_Max_Fields = {
  __typename?: 'bus_overrides_max_fields';
  bus_display_name?: Maybe<Scalars['String']['output']>;
  bus_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  removed_at?: Maybe<Scalars['timestamptz']['output']>;
  removed_by?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Bus_Overrides_Min_Fields = {
  __typename?: 'bus_overrides_min_fields';
  bus_display_name?: Maybe<Scalars['String']['output']>;
  bus_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  removed_at?: Maybe<Scalars['timestamptz']['output']>;
  removed_by?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "bus_overrides" */
export type Bus_Overrides_Mutation_Response = {
  __typename?: 'bus_overrides_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Bus_Overrides>;
};

/** on_conflict condition type for table "bus_overrides" */
export type Bus_Overrides_On_Conflict = {
  constraint: Bus_Overrides_Constraint;
  update_columns?: Array<Bus_Overrides_Update_Column>;
  where?: InputMaybe<Bus_Overrides_Bool_Exp>;
};

/** Ordering options when selecting data from "bus_overrides". */
export type Bus_Overrides_Order_By = {
  bus_display_name?: InputMaybe<Order_By>;
  bus_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location_code?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  owner_name?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  removed_at?: InputMaybe<Order_By>;
  removed_by?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  voltage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bus_overrides */
export type Bus_Overrides_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "bus_overrides" */
export enum Bus_Overrides_Select_Column {
  /** column name */
  BusDisplayName = 'bus_display_name',
  /** column name */
  BusId = 'bus_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LocationCode = 'location_code',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  OwnerName = 'owner_name',
  /** column name */
  Region = 'region',
  /** column name */
  RemovedAt = 'removed_at',
  /** column name */
  RemovedBy = 'removed_by',
  /** column name */
  Scope = 'scope',
  /** column name */
  State = 'state',
  /** column name */
  Voltage = 'voltage'
}

/** input type for updating data in table "bus_overrides" */
export type Bus_Overrides_Set_Input = {
  bus_display_name?: InputMaybe<Scalars['String']['input']>;
  bus_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  removed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  removed_by?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Bus_Overrides_Stddev_Fields = {
  __typename?: 'bus_overrides_stddev_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Bus_Overrides_Stddev_Pop_Fields = {
  __typename?: 'bus_overrides_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Bus_Overrides_Stddev_Samp_Fields = {
  __typename?: 'bus_overrides_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "bus_overrides" */
export type Bus_Overrides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bus_Overrides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bus_Overrides_Stream_Cursor_Value_Input = {
  bus_display_name?: InputMaybe<Scalars['String']['input']>;
  bus_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  removed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  removed_by?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Bus_Overrides_Sum_Fields = {
  __typename?: 'bus_overrides_sum_fields';
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "bus_overrides" */
export enum Bus_Overrides_Update_Column {
  /** column name */
  BusDisplayName = 'bus_display_name',
  /** column name */
  BusId = 'bus_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LocationCode = 'location_code',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  OwnerName = 'owner_name',
  /** column name */
  Region = 'region',
  /** column name */
  RemovedAt = 'removed_at',
  /** column name */
  RemovedBy = 'removed_by',
  /** column name */
  Scope = 'scope',
  /** column name */
  State = 'state',
  /** column name */
  Voltage = 'voltage'
}

export type Bus_Overrides_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bus_Overrides_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bus_Overrides_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bus_Overrides_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bus_Overrides_Var_Pop_Fields = {
  __typename?: 'bus_overrides_var_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Bus_Overrides_Var_Samp_Fields = {
  __typename?: 'bus_overrides_var_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Bus_Overrides_Variance_Fields = {
  __typename?: 'bus_overrides_variance_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "buses" */
export type Buses = {
  __typename?: 'buses';
  bus_display_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  bus_to_scopes: Array<Buses_To_Scopes>;
  /** An aggregate relationship */
  bus_to_scopes_aggregate: Buses_To_Scopes_Aggregate;
  /** An array relationship */
  capacity_costs: Array<Capacity_Costs>;
  /** An aggregate relationship */
  capacity_costs_aggregate: Capacity_Costs_Aggregate;
  /** An array relationship */
  constraint_stacks: Array<Constraint_Stacks>;
  /** An aggregate relationship */
  constraint_stacks_aggregate: Constraint_Stacks_Aggregate;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  out_of_region?: Maybe<Scalars['Boolean']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  queue_project_hops: Array<Queue_Project_Hops>;
  /** An aggregate relationship */
  queue_project_hops_aggregate: Queue_Project_Hops_Aggregate;
  region?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  region_subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  region_subscriptions_aggregate: Subscriptions_Aggregate;
  scopes?: Maybe<Scalars['jsonb']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  substation_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  unlocked: Array<Unlocked_Buses>;
  /** An aggregate relationship */
  unlocked_aggregate: Unlocked_Buses_Aggregate;
  utility_discharging?: Maybe<Scalars['String']['output']>;
  utility_storage?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "buses" */
export type BusesBus_To_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesBus_To_Scopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesCapacity_CostsArgs = {
  distinct_on?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capacity_Costs_Order_By>>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesCapacity_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capacity_Costs_Order_By>>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesConstraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesConstraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesQueue_Project_HopsArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Hops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Hops_Order_By>>;
  where?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesQueue_Project_Hops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Hops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Hops_Order_By>>;
  where?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesRegion_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesRegion_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesScopesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "buses" */
export type BusesUnlockedArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};


/** columns and relationships of "buses" */
export type BusesUnlocked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};

/** aggregated selection of "buses" */
export type Buses_Aggregate = {
  __typename?: 'buses_aggregate';
  aggregate?: Maybe<Buses_Aggregate_Fields>;
  nodes: Array<Buses>;
};

/** aggregate fields of "buses" */
export type Buses_Aggregate_Fields = {
  __typename?: 'buses_aggregate_fields';
  avg?: Maybe<Buses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buses_Max_Fields>;
  min?: Maybe<Buses_Min_Fields>;
  stddev?: Maybe<Buses_Stddev_Fields>;
  stddev_pop?: Maybe<Buses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buses_Stddev_Samp_Fields>;
  sum?: Maybe<Buses_Sum_Fields>;
  var_pop?: Maybe<Buses_Var_Pop_Fields>;
  var_samp?: Maybe<Buses_Var_Samp_Fields>;
  variance?: Maybe<Buses_Variance_Fields>;
};


/** aggregate fields of "buses" */
export type Buses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Buses_Avg_Fields = {
  __typename?: 'buses_avg_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "buses". All fields are combined with a logical 'AND'. */
export type Buses_Bool_Exp = {
  _and?: InputMaybe<Array<Buses_Bool_Exp>>;
  _not?: InputMaybe<Buses_Bool_Exp>;
  _or?: InputMaybe<Array<Buses_Bool_Exp>>;
  bus_display_name?: InputMaybe<String_Comparison_Exp>;
  bus_to_scopes?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
  bus_to_scopes_aggregate?: InputMaybe<Buses_To_Scopes_Aggregate_Bool_Exp>;
  capacity_costs?: InputMaybe<Capacity_Costs_Bool_Exp>;
  capacity_costs_aggregate?: InputMaybe<Capacity_Costs_Aggregate_Bool_Exp>;
  constraint_stacks?: InputMaybe<Constraint_Stacks_Bool_Exp>;
  constraint_stacks_aggregate?: InputMaybe<Constraint_Stacks_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  location_code?: InputMaybe<Int_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  out_of_region?: InputMaybe<Boolean_Comparison_Exp>;
  owner_name?: InputMaybe<String_Comparison_Exp>;
  queue_project_hops?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
  queue_project_hops_aggregate?: InputMaybe<Queue_Project_Hops_Aggregate_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  region_subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  region_subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  scopes?: InputMaybe<Jsonb_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  substation_id?: InputMaybe<String_Comparison_Exp>;
  unlocked?: InputMaybe<Unlocked_Buses_Bool_Exp>;
  unlocked_aggregate?: InputMaybe<Unlocked_Buses_Aggregate_Bool_Exp>;
  utility_discharging?: InputMaybe<String_Comparison_Exp>;
  utility_storage?: InputMaybe<String_Comparison_Exp>;
  voltage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "buses" */
export enum Buses_Constraint {
  /** unique or primary key constraint on columns "nira_bus_id" */
  BusesUnique = 'buses_unique'
}

/** input type for inserting data into table "buses" */
export type Buses_Insert_Input = {
  bus_display_name?: InputMaybe<Scalars['String']['input']>;
  bus_to_scopes?: InputMaybe<Buses_To_Scopes_Arr_Rel_Insert_Input>;
  capacity_costs?: InputMaybe<Capacity_Costs_Arr_Rel_Insert_Input>;
  constraint_stacks?: InputMaybe<Constraint_Stacks_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  out_of_region?: InputMaybe<Scalars['Boolean']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  queue_project_hops?: InputMaybe<Queue_Project_Hops_Arr_Rel_Insert_Input>;
  region?: InputMaybe<Scalars['String']['input']>;
  region_subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  substation_id?: InputMaybe<Scalars['String']['input']>;
  unlocked?: InputMaybe<Unlocked_Buses_Arr_Rel_Insert_Input>;
  utility_discharging?: InputMaybe<Scalars['String']['input']>;
  utility_storage?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Buses_Max_Fields = {
  __typename?: 'buses_max_fields';
  bus_display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  substation_id?: Maybe<Scalars['String']['output']>;
  utility_discharging?: Maybe<Scalars['String']['output']>;
  utility_storage?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Buses_Min_Fields = {
  __typename?: 'buses_min_fields';
  bus_display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  substation_id?: Maybe<Scalars['String']['output']>;
  utility_discharging?: Maybe<Scalars['String']['output']>;
  utility_storage?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** input type for inserting object relation for remote table "buses" */
export type Buses_Obj_Rel_Insert_Input = {
  data: Buses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buses_On_Conflict>;
};

/** on_conflict condition type for table "buses" */
export type Buses_On_Conflict = {
  constraint: Buses_Constraint;
  update_columns?: Array<Buses_Update_Column>;
  where?: InputMaybe<Buses_Bool_Exp>;
};

/** Ordering options when selecting data from "buses". */
export type Buses_Order_By = {
  bus_display_name?: InputMaybe<Order_By>;
  bus_to_scopes_aggregate?: InputMaybe<Buses_To_Scopes_Aggregate_Order_By>;
  capacity_costs_aggregate?: InputMaybe<Capacity_Costs_Aggregate_Order_By>;
  constraint_stacks_aggregate?: InputMaybe<Constraint_Stacks_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location_code?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  out_of_region?: InputMaybe<Order_By>;
  owner_name?: InputMaybe<Order_By>;
  queue_project_hops_aggregate?: InputMaybe<Queue_Project_Hops_Aggregate_Order_By>;
  region?: InputMaybe<Order_By>;
  region_subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  scopes?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  substation_id?: InputMaybe<Order_By>;
  unlocked_aggregate?: InputMaybe<Unlocked_Buses_Aggregate_Order_By>;
  utility_discharging?: InputMaybe<Order_By>;
  utility_storage?: InputMaybe<Order_By>;
  voltage?: InputMaybe<Order_By>;
};

/** select columns of table "buses" */
export enum Buses_Select_Column {
  /** column name */
  BusDisplayName = 'bus_display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LocationCode = 'location_code',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  OutOfRegion = 'out_of_region',
  /** column name */
  OwnerName = 'owner_name',
  /** column name */
  Region = 'region',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  State = 'state',
  /** column name */
  SubstationId = 'substation_id',
  /** column name */
  UtilityDischarging = 'utility_discharging',
  /** column name */
  UtilityStorage = 'utility_storage',
  /** column name */
  Voltage = 'voltage'
}

/** aggregate stddev on columns */
export type Buses_Stddev_Fields = {
  __typename?: 'buses_stddev_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Buses_Stddev_Pop_Fields = {
  __typename?: 'buses_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Buses_Stddev_Samp_Fields = {
  __typename?: 'buses_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buses" */
export type Buses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buses_Stream_Cursor_Value_Input = {
  bus_display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  out_of_region?: InputMaybe<Scalars['Boolean']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  substation_id?: InputMaybe<Scalars['String']['input']>;
  utility_discharging?: InputMaybe<Scalars['String']['input']>;
  utility_storage?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Buses_Sum_Fields = {
  __typename?: 'buses_sum_fields';
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** columns and relationships of "buses_to_scopes" */
export type Buses_To_Scopes = {
  __typename?: 'buses_to_scopes';
  /** An object relationship */
  bus?: Maybe<Buses>;
  bus_id: Scalars['String']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  /** An object relationship */
  scope_info?: Maybe<Scopes>;
  scope_view: Scalars['String']['output'];
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
};


/** columns and relationships of "buses_to_scopes" */
export type Buses_To_ScopesUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "buses_to_scopes" */
export type Buses_To_ScopesUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "buses_to_scopes" */
export type Buses_To_Scopes_Aggregate = {
  __typename?: 'buses_to_scopes_aggregate';
  aggregate?: Maybe<Buses_To_Scopes_Aggregate_Fields>;
  nodes: Array<Buses_To_Scopes>;
};

export type Buses_To_Scopes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Buses_To_Scopes_Aggregate_Bool_Exp_Count>;
};

export type Buses_To_Scopes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "buses_to_scopes" */
export type Buses_To_Scopes_Aggregate_Fields = {
  __typename?: 'buses_to_scopes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Buses_To_Scopes_Max_Fields>;
  min?: Maybe<Buses_To_Scopes_Min_Fields>;
};


/** aggregate fields of "buses_to_scopes" */
export type Buses_To_Scopes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "buses_to_scopes" */
export type Buses_To_Scopes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Buses_To_Scopes_Max_Order_By>;
  min?: InputMaybe<Buses_To_Scopes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "buses_to_scopes" */
export type Buses_To_Scopes_Arr_Rel_Insert_Input = {
  data: Array<Buses_To_Scopes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Buses_To_Scopes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "buses_to_scopes". All fields are combined with a logical 'AND'. */
export type Buses_To_Scopes_Bool_Exp = {
  _and?: InputMaybe<Array<Buses_To_Scopes_Bool_Exp>>;
  _not?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
  _or?: InputMaybe<Array<Buses_To_Scopes_Bool_Exp>>;
  bus?: InputMaybe<Buses_Bool_Exp>;
  bus_id?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_info?: InputMaybe<Scopes_Bool_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "buses_to_scopes" */
export enum Buses_To_Scopes_Constraint {
  /** unique or primary key constraint on columns "scope", "nira_bus_id", "scope_view" */
  BusesToScopesPkey = 'buses_to_scopes_pkey'
}

/** input type for inserting data into table "buses_to_scopes" */
export type Buses_To_Scopes_Insert_Input = {
  bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  bus_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_info?: InputMaybe<Scopes_Obj_Rel_Insert_Input>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Buses_To_Scopes_Max_Fields = {
  __typename?: 'buses_to_scopes_max_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "buses_to_scopes" */
export type Buses_To_Scopes_Max_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Buses_To_Scopes_Min_Fields = {
  __typename?: 'buses_to_scopes_min_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "buses_to_scopes" */
export type Buses_To_Scopes_Min_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "buses_to_scopes" */
export type Buses_To_Scopes_Mutation_Response = {
  __typename?: 'buses_to_scopes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buses_To_Scopes>;
};

/** on_conflict condition type for table "buses_to_scopes" */
export type Buses_To_Scopes_On_Conflict = {
  constraint: Buses_To_Scopes_Constraint;
  update_columns?: Array<Buses_To_Scopes_Update_Column>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};

/** Ordering options when selecting data from "buses_to_scopes". */
export type Buses_To_Scopes_Order_By = {
  bus?: InputMaybe<Buses_Order_By>;
  bus_id?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_info?: InputMaybe<Scopes_Order_By>;
  scope_view?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: buses_to_scopes */
export type Buses_To_Scopes_Pk_Columns_Input = {
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};

/** select columns of table "buses_to_scopes" */
export enum Buses_To_Scopes_Select_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view'
}

/** input type for updating data in table "buses_to_scopes" */
export type Buses_To_Scopes_Set_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "buses_to_scopes" */
export type Buses_To_Scopes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buses_To_Scopes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buses_To_Scopes_Stream_Cursor_Value_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "buses_to_scopes" */
export enum Buses_To_Scopes_Update_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view'
}

export type Buses_To_Scopes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buses_To_Scopes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buses_To_Scopes_Bool_Exp;
};

/** update columns of table "buses" */
export enum Buses_Update_Column {
  /** column name */
  BusDisplayName = 'bus_display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LocationCode = 'location_code',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  OutOfRegion = 'out_of_region',
  /** column name */
  OwnerName = 'owner_name',
  /** column name */
  Region = 'region',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  State = 'state',
  /** column name */
  SubstationId = 'substation_id',
  /** column name */
  UtilityDischarging = 'utility_discharging',
  /** column name */
  UtilityStorage = 'utility_storage',
  /** column name */
  Voltage = 'voltage'
}

/** aggregate var_pop on columns */
export type Buses_Var_Pop_Fields = {
  __typename?: 'buses_var_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Buses_Var_Samp_Fields = {
  __typename?: 'buses_var_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Buses_Variance_Fields = {
  __typename?: 'buses_variance_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_Overrides = {
  __typename?: 'buses_without_overrides';
  /** An object relationship */
  bus?: Maybe<Buses>;
  bus_display_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  buses_to_scopes: Array<Buses_To_Scopes>;
  /** An aggregate relationship */
  buses_to_scopes_aggregate: Buses_To_Scopes_Aggregate;
  /** An array relationship */
  capacity_costs: Array<Capacity_Costs>;
  /** An aggregate relationship */
  capacity_costs_aggregate: Capacity_Costs_Aggregate;
  /** An array relationship */
  constraint_stacks: Array<Constraint_Stacks>;
  /** An aggregate relationship */
  constraint_stacks_aggregate: Constraint_Stacks_Aggregate;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  nira_bus_id: Scalars['String']['output'];
  out_of_region: Scalars['Boolean']['output'];
  owner_name?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  /** An array relationship */
  region_subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  region_subscriptions_aggregate: Subscriptions_Aggregate;
  scopes: Scalars['jsonb']['output'];
  state?: Maybe<Scalars['String']['output']>;
  substation_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  unlocked: Array<Unlocked_Buses>;
  /** An aggregate relationship */
  unlocked_aggregate: Unlocked_Buses_Aggregate;
  utility_discharging?: Maybe<Scalars['String']['output']>;
  utility_storage?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesBuses_To_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesBuses_To_Scopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesCapacity_CostsArgs = {
  distinct_on?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capacity_Costs_Order_By>>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesCapacity_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capacity_Costs_Order_By>>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesConstraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesConstraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesRegion_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesRegion_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesScopesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesUnlockedArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};


/** columns and relationships of "buses_without_overrides" */
export type Buses_Without_OverridesUnlocked_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};

/** aggregated selection of "buses_without_overrides" */
export type Buses_Without_Overrides_Aggregate = {
  __typename?: 'buses_without_overrides_aggregate';
  aggregate?: Maybe<Buses_Without_Overrides_Aggregate_Fields>;
  nodes: Array<Buses_Without_Overrides>;
};

/** aggregate fields of "buses_without_overrides" */
export type Buses_Without_Overrides_Aggregate_Fields = {
  __typename?: 'buses_without_overrides_aggregate_fields';
  avg?: Maybe<Buses_Without_Overrides_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buses_Without_Overrides_Max_Fields>;
  min?: Maybe<Buses_Without_Overrides_Min_Fields>;
  stddev?: Maybe<Buses_Without_Overrides_Stddev_Fields>;
  stddev_pop?: Maybe<Buses_Without_Overrides_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buses_Without_Overrides_Stddev_Samp_Fields>;
  sum?: Maybe<Buses_Without_Overrides_Sum_Fields>;
  var_pop?: Maybe<Buses_Without_Overrides_Var_Pop_Fields>;
  var_samp?: Maybe<Buses_Without_Overrides_Var_Samp_Fields>;
  variance?: Maybe<Buses_Without_Overrides_Variance_Fields>;
};


/** aggregate fields of "buses_without_overrides" */
export type Buses_Without_Overrides_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buses_Without_Overrides_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Buses_Without_Overrides_Append_Input = {
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Buses_Without_Overrides_Avg_Fields = {
  __typename?: 'buses_without_overrides_avg_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "buses_without_overrides". All fields are combined with a logical 'AND'. */
export type Buses_Without_Overrides_Bool_Exp = {
  _and?: InputMaybe<Array<Buses_Without_Overrides_Bool_Exp>>;
  _not?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
  _or?: InputMaybe<Array<Buses_Without_Overrides_Bool_Exp>>;
  bus?: InputMaybe<Buses_Bool_Exp>;
  bus_display_name?: InputMaybe<String_Comparison_Exp>;
  buses_to_scopes?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
  buses_to_scopes_aggregate?: InputMaybe<Buses_To_Scopes_Aggregate_Bool_Exp>;
  capacity_costs?: InputMaybe<Capacity_Costs_Bool_Exp>;
  capacity_costs_aggregate?: InputMaybe<Capacity_Costs_Aggregate_Bool_Exp>;
  constraint_stacks?: InputMaybe<Constraint_Stacks_Bool_Exp>;
  constraint_stacks_aggregate?: InputMaybe<Constraint_Stacks_Aggregate_Bool_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  location_code?: InputMaybe<Int_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  out_of_region?: InputMaybe<Boolean_Comparison_Exp>;
  owner_name?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  region_subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  region_subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  scopes?: InputMaybe<Jsonb_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  substation_id?: InputMaybe<String_Comparison_Exp>;
  unlocked?: InputMaybe<Unlocked_Buses_Bool_Exp>;
  unlocked_aggregate?: InputMaybe<Unlocked_Buses_Aggregate_Bool_Exp>;
  utility_discharging?: InputMaybe<String_Comparison_Exp>;
  utility_storage?: InputMaybe<String_Comparison_Exp>;
  voltage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "buses_without_overrides" */
export enum Buses_Without_Overrides_Constraint {
  /** unique or primary key constraint on columns "nira_bus_id" */
  BusesWithoutOverridesPkey = 'buses_without_overrides_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Buses_Without_Overrides_Delete_At_Path_Input = {
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Buses_Without_Overrides_Delete_Elem_Input = {
  scopes?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Buses_Without_Overrides_Delete_Key_Input = {
  scopes?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "buses_without_overrides" */
export type Buses_Without_Overrides_Inc_Input = {
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "buses_without_overrides" */
export type Buses_Without_Overrides_Insert_Input = {
  bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  bus_display_name?: InputMaybe<Scalars['String']['input']>;
  buses_to_scopes?: InputMaybe<Buses_To_Scopes_Arr_Rel_Insert_Input>;
  capacity_costs?: InputMaybe<Capacity_Costs_Arr_Rel_Insert_Input>;
  constraint_stacks?: InputMaybe<Constraint_Stacks_Arr_Rel_Insert_Input>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  out_of_region?: InputMaybe<Scalars['Boolean']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  region_subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  substation_id?: InputMaybe<Scalars['String']['input']>;
  unlocked?: InputMaybe<Unlocked_Buses_Arr_Rel_Insert_Input>;
  utility_discharging?: InputMaybe<Scalars['String']['input']>;
  utility_storage?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Buses_Without_Overrides_Max_Fields = {
  __typename?: 'buses_without_overrides_max_fields';
  bus_display_name?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  substation_id?: Maybe<Scalars['String']['output']>;
  utility_discharging?: Maybe<Scalars['String']['output']>;
  utility_storage?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Buses_Without_Overrides_Min_Fields = {
  __typename?: 'buses_without_overrides_min_fields';
  bus_display_name?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  owner_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  substation_id?: Maybe<Scalars['String']['output']>;
  utility_discharging?: Maybe<Scalars['String']['output']>;
  utility_storage?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "buses_without_overrides" */
export type Buses_Without_Overrides_Mutation_Response = {
  __typename?: 'buses_without_overrides_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buses_Without_Overrides>;
};

/** input type for inserting object relation for remote table "buses_without_overrides" */
export type Buses_Without_Overrides_Obj_Rel_Insert_Input = {
  data: Buses_Without_Overrides_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buses_Without_Overrides_On_Conflict>;
};

/** on_conflict condition type for table "buses_without_overrides" */
export type Buses_Without_Overrides_On_Conflict = {
  constraint: Buses_Without_Overrides_Constraint;
  update_columns?: Array<Buses_Without_Overrides_Update_Column>;
  where?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
};

/** Ordering options when selecting data from "buses_without_overrides". */
export type Buses_Without_Overrides_Order_By = {
  bus?: InputMaybe<Buses_Order_By>;
  bus_display_name?: InputMaybe<Order_By>;
  buses_to_scopes_aggregate?: InputMaybe<Buses_To_Scopes_Aggregate_Order_By>;
  capacity_costs_aggregate?: InputMaybe<Capacity_Costs_Aggregate_Order_By>;
  constraint_stacks_aggregate?: InputMaybe<Constraint_Stacks_Aggregate_Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location_code?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  out_of_region?: InputMaybe<Order_By>;
  owner_name?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  region_subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  scopes?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  substation_id?: InputMaybe<Order_By>;
  unlocked_aggregate?: InputMaybe<Unlocked_Buses_Aggregate_Order_By>;
  utility_discharging?: InputMaybe<Order_By>;
  utility_storage?: InputMaybe<Order_By>;
  voltage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: buses_without_overrides */
export type Buses_Without_Overrides_Pk_Columns_Input = {
  nira_bus_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Buses_Without_Overrides_Prepend_Input = {
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "buses_without_overrides" */
export enum Buses_Without_Overrides_Select_Column {
  /** column name */
  BusDisplayName = 'bus_display_name',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LocationCode = 'location_code',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  OutOfRegion = 'out_of_region',
  /** column name */
  OwnerName = 'owner_name',
  /** column name */
  Region = 'region',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  State = 'state',
  /** column name */
  SubstationId = 'substation_id',
  /** column name */
  UtilityDischarging = 'utility_discharging',
  /** column name */
  UtilityStorage = 'utility_storage',
  /** column name */
  Voltage = 'voltage'
}

/** input type for updating data in table "buses_without_overrides" */
export type Buses_Without_Overrides_Set_Input = {
  bus_display_name?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  out_of_region?: InputMaybe<Scalars['Boolean']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  substation_id?: InputMaybe<Scalars['String']['input']>;
  utility_discharging?: InputMaybe<Scalars['String']['input']>;
  utility_storage?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Buses_Without_Overrides_Stddev_Fields = {
  __typename?: 'buses_without_overrides_stddev_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Buses_Without_Overrides_Stddev_Pop_Fields = {
  __typename?: 'buses_without_overrides_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Buses_Without_Overrides_Stddev_Samp_Fields = {
  __typename?: 'buses_without_overrides_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buses_without_overrides" */
export type Buses_Without_Overrides_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buses_Without_Overrides_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buses_Without_Overrides_Stream_Cursor_Value_Input = {
  bus_display_name?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_code?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  out_of_region?: InputMaybe<Scalars['Boolean']['input']>;
  owner_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  substation_id?: InputMaybe<Scalars['String']['input']>;
  utility_discharging?: InputMaybe<Scalars['String']['input']>;
  utility_storage?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Buses_Without_Overrides_Sum_Fields = {
  __typename?: 'buses_without_overrides_sum_fields';
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_code?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "buses_without_overrides" */
export enum Buses_Without_Overrides_Update_Column {
  /** column name */
  BusDisplayName = 'bus_display_name',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LocationCode = 'location_code',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  OutOfRegion = 'out_of_region',
  /** column name */
  OwnerName = 'owner_name',
  /** column name */
  Region = 'region',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  State = 'state',
  /** column name */
  SubstationId = 'substation_id',
  /** column name */
  UtilityDischarging = 'utility_discharging',
  /** column name */
  UtilityStorage = 'utility_storage',
  /** column name */
  Voltage = 'voltage'
}

export type Buses_Without_Overrides_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Buses_Without_Overrides_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Buses_Without_Overrides_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Buses_Without_Overrides_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Buses_Without_Overrides_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buses_Without_Overrides_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Buses_Without_Overrides_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buses_Without_Overrides_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buses_Without_Overrides_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buses_Without_Overrides_Var_Pop_Fields = {
  __typename?: 'buses_without_overrides_var_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Buses_Without_Overrides_Var_Samp_Fields = {
  __typename?: 'buses_without_overrides_var_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Buses_Without_Overrides_Variance_Fields = {
  __typename?: 'buses_without_overrides_variance_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  location_code?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "capacity_costs" */
export type Capacity_Costs = {
  __typename?: 'capacity_costs';
  /** An object relationship */
  bus?: Maybe<Buses>;
  bus_id: Scalars['String']['output'];
  /** An object relationship */
  bus_without_override: Buses_Without_Overrides;
  capacity_size: Scalars['numeric']['output'];
  charging_size: Scalars['numeric']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  energy_size: Scalars['numeric']['output'];
  /** A computed field, executes function "capacity_costs_id" */
  id?: Maybe<Scalars['uuid']['output']>;
  includes_pre_existing: Scalars['Boolean']['output'];
  nira_bus_id: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  scope_view: Scalars['String']['output'];
  total_upgrade_costs: Scalars['numeric']['output'];
  upgrade_costs: Scalars['numeric']['output'];
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
};


/** columns and relationships of "capacity_costs" */
export type Capacity_CostsUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "capacity_costs" */
export type Capacity_CostsUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "capacity_costs" */
export type Capacity_Costs_Aggregate = {
  __typename?: 'capacity_costs_aggregate';
  aggregate?: Maybe<Capacity_Costs_Aggregate_Fields>;
  nodes: Array<Capacity_Costs>;
};

export type Capacity_Costs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Capacity_Costs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Capacity_Costs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Capacity_Costs_Aggregate_Bool_Exp_Count>;
};

export type Capacity_Costs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Capacity_Costs_Select_Column_Capacity_Costs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Capacity_Costs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Capacity_Costs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Capacity_Costs_Select_Column_Capacity_Costs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Capacity_Costs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Capacity_Costs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Capacity_Costs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "capacity_costs" */
export type Capacity_Costs_Aggregate_Fields = {
  __typename?: 'capacity_costs_aggregate_fields';
  avg?: Maybe<Capacity_Costs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Capacity_Costs_Max_Fields>;
  min?: Maybe<Capacity_Costs_Min_Fields>;
  stddev?: Maybe<Capacity_Costs_Stddev_Fields>;
  stddev_pop?: Maybe<Capacity_Costs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Capacity_Costs_Stddev_Samp_Fields>;
  sum?: Maybe<Capacity_Costs_Sum_Fields>;
  var_pop?: Maybe<Capacity_Costs_Var_Pop_Fields>;
  var_samp?: Maybe<Capacity_Costs_Var_Samp_Fields>;
  variance?: Maybe<Capacity_Costs_Variance_Fields>;
};


/** aggregate fields of "capacity_costs" */
export type Capacity_Costs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "capacity_costs" */
export type Capacity_Costs_Aggregate_Order_By = {
  avg?: InputMaybe<Capacity_Costs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Capacity_Costs_Max_Order_By>;
  min?: InputMaybe<Capacity_Costs_Min_Order_By>;
  stddev?: InputMaybe<Capacity_Costs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Capacity_Costs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Capacity_Costs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Capacity_Costs_Sum_Order_By>;
  var_pop?: InputMaybe<Capacity_Costs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Capacity_Costs_Var_Samp_Order_By>;
  variance?: InputMaybe<Capacity_Costs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "capacity_costs" */
export type Capacity_Costs_Arr_Rel_Insert_Input = {
  data: Array<Capacity_Costs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Capacity_Costs_On_Conflict>;
};

/** aggregate avg on columns */
export type Capacity_Costs_Avg_Fields = {
  __typename?: 'capacity_costs_avg_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "capacity_costs" */
export type Capacity_Costs_Avg_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "capacity_costs". All fields are combined with a logical 'AND'. */
export type Capacity_Costs_Bool_Exp = {
  _and?: InputMaybe<Array<Capacity_Costs_Bool_Exp>>;
  _not?: InputMaybe<Capacity_Costs_Bool_Exp>;
  _or?: InputMaybe<Array<Capacity_Costs_Bool_Exp>>;
  bus?: InputMaybe<Buses_Bool_Exp>;
  bus_id?: InputMaybe<String_Comparison_Exp>;
  bus_without_override?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
  capacity_size?: InputMaybe<Numeric_Comparison_Exp>;
  charging_size?: InputMaybe<Numeric_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  energy_size?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  includes_pre_existing?: InputMaybe<Boolean_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  total_upgrade_costs?: InputMaybe<Numeric_Comparison_Exp>;
  upgrade_costs?: InputMaybe<Numeric_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "capacity_costs" */
export enum Capacity_Costs_Constraint {
  /** unique or primary key constraint on columns "scope", "nira_bus_id", "energy_size", "includes_pre_existing", "scope_view" */
  CapacityCostsPkey = 'capacity_costs_pkey'
}

/** input type for incrementing numeric columns in table "capacity_costs" */
export type Capacity_Costs_Inc_Input = {
  capacity_size?: InputMaybe<Scalars['numeric']['input']>;
  charging_size?: InputMaybe<Scalars['numeric']['input']>;
  energy_size?: InputMaybe<Scalars['numeric']['input']>;
  total_upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "capacity_costs" */
export type Capacity_Costs_Insert_Input = {
  bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  bus_id?: InputMaybe<Scalars['String']['input']>;
  bus_without_override?: InputMaybe<Buses_Without_Overrides_Obj_Rel_Insert_Input>;
  capacity_size?: InputMaybe<Scalars['numeric']['input']>;
  charging_size?: InputMaybe<Scalars['numeric']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  energy_size?: InputMaybe<Scalars['numeric']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  total_upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Capacity_Costs_Max_Fields = {
  __typename?: 'capacity_costs_max_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  capacity_size?: Maybe<Scalars['numeric']['output']>;
  charging_size?: Maybe<Scalars['numeric']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  energy_size?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "capacity_costs_id" */
  id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  total_upgrade_costs?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "capacity_costs" */
export type Capacity_Costs_Max_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Capacity_Costs_Min_Fields = {
  __typename?: 'capacity_costs_min_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  capacity_size?: Maybe<Scalars['numeric']['output']>;
  charging_size?: Maybe<Scalars['numeric']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  energy_size?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "capacity_costs_id" */
  id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  total_upgrade_costs?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "capacity_costs" */
export type Capacity_Costs_Min_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "capacity_costs" */
export type Capacity_Costs_Mutation_Response = {
  __typename?: 'capacity_costs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Capacity_Costs>;
};

/** on_conflict condition type for table "capacity_costs" */
export type Capacity_Costs_On_Conflict = {
  constraint: Capacity_Costs_Constraint;
  update_columns?: Array<Capacity_Costs_Update_Column>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};

/** Ordering options when selecting data from "capacity_costs". */
export type Capacity_Costs_Order_By = {
  bus?: InputMaybe<Buses_Order_By>;
  bus_id?: InputMaybe<Order_By>;
  bus_without_override?: InputMaybe<Buses_Without_Overrides_Order_By>;
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  includes_pre_existing?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: capacity_costs */
export type Capacity_Costs_Pk_Columns_Input = {
  energy_size: Scalars['numeric']['input'];
  includes_pre_existing: Scalars['Boolean']['input'];
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};

/** select columns of table "capacity_costs" */
export enum Capacity_Costs_Select_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  CapacitySize = 'capacity_size',
  /** column name */
  ChargingSize = 'charging_size',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  EnergySize = 'energy_size',
  /** column name */
  IncludesPreExisting = 'includes_pre_existing',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  TotalUpgradeCosts = 'total_upgrade_costs',
  /** column name */
  UpgradeCosts = 'upgrade_costs'
}

/** select "capacity_costs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "capacity_costs" */
export enum Capacity_Costs_Select_Column_Capacity_Costs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IncludesPreExisting = 'includes_pre_existing'
}

/** select "capacity_costs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "capacity_costs" */
export enum Capacity_Costs_Select_Column_Capacity_Costs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IncludesPreExisting = 'includes_pre_existing'
}

/** input type for updating data in table "capacity_costs" */
export type Capacity_Costs_Set_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  capacity_size?: InputMaybe<Scalars['numeric']['input']>;
  charging_size?: InputMaybe<Scalars['numeric']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  energy_size?: InputMaybe<Scalars['numeric']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  total_upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Capacity_Costs_Stddev_Fields = {
  __typename?: 'capacity_costs_stddev_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "capacity_costs" */
export type Capacity_Costs_Stddev_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Capacity_Costs_Stddev_Pop_Fields = {
  __typename?: 'capacity_costs_stddev_pop_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "capacity_costs" */
export type Capacity_Costs_Stddev_Pop_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Capacity_Costs_Stddev_Samp_Fields = {
  __typename?: 'capacity_costs_stddev_samp_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "capacity_costs" */
export type Capacity_Costs_Stddev_Samp_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "capacity_costs" */
export type Capacity_Costs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Capacity_Costs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Capacity_Costs_Stream_Cursor_Value_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  capacity_size?: InputMaybe<Scalars['numeric']['input']>;
  charging_size?: InputMaybe<Scalars['numeric']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  energy_size?: InputMaybe<Scalars['numeric']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  total_upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Capacity_Costs_Sum_Fields = {
  __typename?: 'capacity_costs_sum_fields';
  capacity_size?: Maybe<Scalars['numeric']['output']>;
  charging_size?: Maybe<Scalars['numeric']['output']>;
  energy_size?: Maybe<Scalars['numeric']['output']>;
  total_upgrade_costs?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "capacity_costs" */
export type Capacity_Costs_Sum_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** update columns of table "capacity_costs" */
export enum Capacity_Costs_Update_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  CapacitySize = 'capacity_size',
  /** column name */
  ChargingSize = 'charging_size',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  EnergySize = 'energy_size',
  /** column name */
  IncludesPreExisting = 'includes_pre_existing',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  TotalUpgradeCosts = 'total_upgrade_costs',
  /** column name */
  UpgradeCosts = 'upgrade_costs'
}

export type Capacity_Costs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Capacity_Costs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Capacity_Costs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Capacity_Costs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Capacity_Costs_Var_Pop_Fields = {
  __typename?: 'capacity_costs_var_pop_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "capacity_costs" */
export type Capacity_Costs_Var_Pop_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Capacity_Costs_Var_Samp_Fields = {
  __typename?: 'capacity_costs_var_samp_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "capacity_costs" */
export type Capacity_Costs_Var_Samp_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Capacity_Costs_Variance_Fields = {
  __typename?: 'capacity_costs_variance_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "capacity_costs" */
export type Capacity_Costs_Variance_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** columns and relationships of "ceii_access" */
export type Ceii_Access = {
  __typename?: 'ceii_access';
  access_end: Scalars['timestamptz']['output'];
  access_start: Scalars['timestamptz']['output'];
  auth0_id?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  document_link: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** aggregated selection of "ceii_access" */
export type Ceii_Access_Aggregate = {
  __typename?: 'ceii_access_aggregate';
  aggregate?: Maybe<Ceii_Access_Aggregate_Fields>;
  nodes: Array<Ceii_Access>;
};

/** aggregate fields of "ceii_access" */
export type Ceii_Access_Aggregate_Fields = {
  __typename?: 'ceii_access_aggregate_fields';
  avg?: Maybe<Ceii_Access_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ceii_Access_Max_Fields>;
  min?: Maybe<Ceii_Access_Min_Fields>;
  stddev?: Maybe<Ceii_Access_Stddev_Fields>;
  stddev_pop?: Maybe<Ceii_Access_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ceii_Access_Stddev_Samp_Fields>;
  sum?: Maybe<Ceii_Access_Sum_Fields>;
  var_pop?: Maybe<Ceii_Access_Var_Pop_Fields>;
  var_samp?: Maybe<Ceii_Access_Var_Samp_Fields>;
  variance?: Maybe<Ceii_Access_Variance_Fields>;
};


/** aggregate fields of "ceii_access" */
export type Ceii_Access_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ceii_Access_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ceii_Access_Avg_Fields = {
  __typename?: 'ceii_access_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "ceii_access". All fields are combined with a logical 'AND'. */
export type Ceii_Access_Bool_Exp = {
  _and?: InputMaybe<Array<Ceii_Access_Bool_Exp>>;
  _not?: InputMaybe<Ceii_Access_Bool_Exp>;
  _or?: InputMaybe<Array<Ceii_Access_Bool_Exp>>;
  access_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  access_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  auth0_id?: InputMaybe<String_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_link?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "ceii_access" */
export enum Ceii_Access_Constraint {
  /** unique or primary key constraint on columns "id" */
  CeiiAccessPkey = 'ceii_access_pkey'
}

/** input type for incrementing numeric columns in table "ceii_access" */
export type Ceii_Access_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "ceii_access" */
export type Ceii_Access_Insert_Input = {
  access_end?: InputMaybe<Scalars['timestamptz']['input']>;
  access_start?: InputMaybe<Scalars['timestamptz']['input']>;
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ceii_Access_Max_Fields = {
  __typename?: 'ceii_access_max_fields';
  access_end?: Maybe<Scalars['timestamptz']['output']>;
  access_start?: Maybe<Scalars['timestamptz']['output']>;
  auth0_id?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  document_link?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ceii_Access_Min_Fields = {
  __typename?: 'ceii_access_min_fields';
  access_end?: Maybe<Scalars['timestamptz']['output']>;
  access_start?: Maybe<Scalars['timestamptz']['output']>;
  auth0_id?: Maybe<Scalars['String']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  document_link?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "ceii_access" */
export type Ceii_Access_Mutation_Response = {
  __typename?: 'ceii_access_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ceii_Access>;
};

/** on_conflict condition type for table "ceii_access" */
export type Ceii_Access_On_Conflict = {
  constraint: Ceii_Access_Constraint;
  update_columns?: Array<Ceii_Access_Update_Column>;
  where?: InputMaybe<Ceii_Access_Bool_Exp>;
};

/** Ordering options when selecting data from "ceii_access". */
export type Ceii_Access_Order_By = {
  access_end?: InputMaybe<Order_By>;
  access_start?: InputMaybe<Order_By>;
  auth0_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  document_link?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: ceii_access */
export type Ceii_Access_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "ceii_access" */
export enum Ceii_Access_Select_Column {
  /** column name */
  AccessEnd = 'access_end',
  /** column name */
  AccessStart = 'access_start',
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DocumentLink = 'document_link',
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region'
}

/** input type for updating data in table "ceii_access" */
export type Ceii_Access_Set_Input = {
  access_end?: InputMaybe<Scalars['timestamptz']['input']>;
  access_start?: InputMaybe<Scalars['timestamptz']['input']>;
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Ceii_Access_Stddev_Fields = {
  __typename?: 'ceii_access_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ceii_Access_Stddev_Pop_Fields = {
  __typename?: 'ceii_access_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ceii_Access_Stddev_Samp_Fields = {
  __typename?: 'ceii_access_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "ceii_access" */
export type Ceii_Access_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ceii_Access_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ceii_Access_Stream_Cursor_Value_Input = {
  access_end?: InputMaybe<Scalars['timestamptz']['input']>;
  access_start?: InputMaybe<Scalars['timestamptz']['input']>;
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_link?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Ceii_Access_Sum_Fields = {
  __typename?: 'ceii_access_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "ceii_access" */
export enum Ceii_Access_Update_Column {
  /** column name */
  AccessEnd = 'access_end',
  /** column name */
  AccessStart = 'access_start',
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DocumentLink = 'document_link',
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region'
}

export type Ceii_Access_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ceii_Access_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ceii_Access_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ceii_Access_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ceii_Access_Var_Pop_Fields = {
  __typename?: 'ceii_access_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ceii_Access_Var_Samp_Fields = {
  __typename?: 'ceii_access_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ceii_Access_Variance_Fields = {
  __typename?: 'ceii_access_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "cluster_current_sis_report_posting" */
export type Cluster_Current_Sis_Report_Posting = {
  __typename?: 'cluster_current_sis_report_posting';
  /** An object relationship */
  cluster?: Maybe<In_Queue_Clusters>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  posting?: Maybe<Sis_Report_Postings>;
  posting_id?: Maybe<Scalars['uuid']['output']>;
  report_link?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "cluster_current_sis_report_posting" */
export type Cluster_Current_Sis_Report_Posting_Aggregate = {
  __typename?: 'cluster_current_sis_report_posting_aggregate';
  aggregate?: Maybe<Cluster_Current_Sis_Report_Posting_Aggregate_Fields>;
  nodes: Array<Cluster_Current_Sis_Report_Posting>;
};

/** aggregate fields of "cluster_current_sis_report_posting" */
export type Cluster_Current_Sis_Report_Posting_Aggregate_Fields = {
  __typename?: 'cluster_current_sis_report_posting_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Cluster_Current_Sis_Report_Posting_Max_Fields>;
  min?: Maybe<Cluster_Current_Sis_Report_Posting_Min_Fields>;
};


/** aggregate fields of "cluster_current_sis_report_posting" */
export type Cluster_Current_Sis_Report_Posting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "cluster_current_sis_report_posting". All fields are combined with a logical 'AND'. */
export type Cluster_Current_Sis_Report_Posting_Bool_Exp = {
  _and?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Bool_Exp>>;
  _not?: InputMaybe<Cluster_Current_Sis_Report_Posting_Bool_Exp>;
  _or?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Bool_Exp>>;
  cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  posted_at?: InputMaybe<Date_Comparison_Exp>;
  posting?: InputMaybe<Sis_Report_Postings_Bool_Exp>;
  posting_id?: InputMaybe<Uuid_Comparison_Exp>;
  report_link?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "cluster_current_sis_report_posting" */
export type Cluster_Current_Sis_Report_Posting_Insert_Input = {
  cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  posted_at?: InputMaybe<Scalars['date']['input']>;
  posting?: InputMaybe<Sis_Report_Postings_Obj_Rel_Insert_Input>;
  posting_id?: InputMaybe<Scalars['uuid']['input']>;
  report_link?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Cluster_Current_Sis_Report_Posting_Max_Fields = {
  __typename?: 'cluster_current_sis_report_posting_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  posting_id?: Maybe<Scalars['uuid']['output']>;
  report_link?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Cluster_Current_Sis_Report_Posting_Min_Fields = {
  __typename?: 'cluster_current_sis_report_posting_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  posting_id?: Maybe<Scalars['uuid']['output']>;
  report_link?: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "cluster_current_sis_report_posting" */
export type Cluster_Current_Sis_Report_Posting_Obj_Rel_Insert_Input = {
  data: Cluster_Current_Sis_Report_Posting_Insert_Input;
};

/** Ordering options when selecting data from "cluster_current_sis_report_posting". */
export type Cluster_Current_Sis_Report_Posting_Order_By = {
  cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  posting?: InputMaybe<Sis_Report_Postings_Order_By>;
  posting_id?: InputMaybe<Order_By>;
  report_link?: InputMaybe<Order_By>;
};

/** select columns of table "cluster_current_sis_report_posting" */
export enum Cluster_Current_Sis_Report_Posting_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  Name = 'name',
  /** column name */
  PostedAt = 'posted_at',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  ReportLink = 'report_link'
}

/** Streaming cursor of the table "cluster_current_sis_report_posting" */
export type Cluster_Current_Sis_Report_Posting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cluster_Current_Sis_Report_Posting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cluster_Current_Sis_Report_Posting_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  posted_at?: InputMaybe<Scalars['date']['input']>;
  posting_id?: InputMaybe<Scalars['uuid']['input']>;
  report_link?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "cluster_projects" */
export type Cluster_Projects = {
  __typename?: 'cluster_projects';
  /** An object relationship */
  base_scenario?: Maybe<Current_Base_Scenarios>;
  /** An object relationship */
  cluster?: Maybe<In_Queue_Clusters>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  cost_per_mw?: Maybe<Scalars['numeric']['output']>;
  developer_name?: Maybe<Scalars['String']['output']>;
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  eris_mw?: Maybe<Scalars['numeric']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  hybrid_limit?: Maybe<Scalars['numeric']['output']>;
  is_editable?: Maybe<Scalars['Boolean']['output']>;
  is_withdrawn?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  nris_mw?: Maybe<Scalars['numeric']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['Int']['output']>;
  /** fetch data from the table: "project_configurations" */
  project_configurations: Array<Project_Configurations>;
  /** fetch aggregated fields from the table: "project_configurations" */
  project_configurations_aggregate: Project_Configurations_Aggregate;
  project_id?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sis_reported_values: Array<Current_Project_Sis_Reported_Values>;
  /** An aggregate relationship */
  sis_reported_values_aggregate: Current_Project_Sis_Reported_Values_Aggregate;
  status?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  study_phase?: Maybe<Scalars['String']['output']>;
  sum_allocated_cost?: Maybe<Scalars['numeric']['output']>;
  total_ranked?: Maybe<Scalars['Int']['output']>;
  total_reported_cost?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  tracked_projects: Array<Tracked_Projects>;
  /** An aggregate relationship */
  tracked_projects_aggregate: Tracked_Projects_Aggregate;
};


/** columns and relationships of "cluster_projects" */
export type Cluster_ProjectsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "cluster_projects" */
export type Cluster_ProjectsProject_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Configurations_Order_By>>;
  where?: InputMaybe<Project_Configurations_Bool_Exp>;
};


/** columns and relationships of "cluster_projects" */
export type Cluster_ProjectsProject_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Configurations_Order_By>>;
  where?: InputMaybe<Project_Configurations_Bool_Exp>;
};


/** columns and relationships of "cluster_projects" */
export type Cluster_ProjectsSis_Reported_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Order_By>>;
  where?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
};


/** columns and relationships of "cluster_projects" */
export type Cluster_ProjectsSis_Reported_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Order_By>>;
  where?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
};


/** columns and relationships of "cluster_projects" */
export type Cluster_ProjectsTracked_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tracked_Projects_Order_By>>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};


/** columns and relationships of "cluster_projects" */
export type Cluster_ProjectsTracked_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tracked_Projects_Order_By>>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};

/** aggregated selection of "cluster_projects" */
export type Cluster_Projects_Aggregate = {
  __typename?: 'cluster_projects_aggregate';
  aggregate?: Maybe<Cluster_Projects_Aggregate_Fields>;
  nodes: Array<Cluster_Projects>;
};

/** aggregate fields of "cluster_projects" */
export type Cluster_Projects_Aggregate_Fields = {
  __typename?: 'cluster_projects_aggregate_fields';
  avg?: Maybe<Cluster_Projects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cluster_Projects_Max_Fields>;
  min?: Maybe<Cluster_Projects_Min_Fields>;
  stddev?: Maybe<Cluster_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Cluster_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cluster_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Cluster_Projects_Sum_Fields>;
  var_pop?: Maybe<Cluster_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Cluster_Projects_Var_Samp_Fields>;
  variance?: Maybe<Cluster_Projects_Variance_Fields>;
};


/** aggregate fields of "cluster_projects" */
export type Cluster_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cluster_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Cluster_Projects_Avg_Fields = {
  __typename?: 'cluster_projects_avg_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_mw?: Maybe<Scalars['Float']['output']>;
  hybrid_limit?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_mw?: Maybe<Scalars['Float']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_reported_cost?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cluster_projects". All fields are combined with a logical 'AND'. */
export type Cluster_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Cluster_Projects_Bool_Exp>>;
  _not?: InputMaybe<Cluster_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Cluster_Projects_Bool_Exp>>;
  base_scenario?: InputMaybe<Current_Base_Scenarios_Bool_Exp>;
  cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  cost_per_mw?: InputMaybe<Numeric_Comparison_Exp>;
  developer_name?: InputMaybe<String_Comparison_Exp>;
  eris_capacity_mw?: InputMaybe<Numeric_Comparison_Exp>;
  eris_mw?: InputMaybe<Numeric_Comparison_Exp>;
  fuel_type?: InputMaybe<String_Comparison_Exp>;
  hybrid_limit?: InputMaybe<Numeric_Comparison_Exp>;
  is_editable?: InputMaybe<Boolean_Comparison_Exp>;
  is_withdrawn?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  nris_capacity_mw?: InputMaybe<Numeric_Comparison_Exp>;
  nris_mw?: InputMaybe<Numeric_Comparison_Exp>;
  num_assigned_upgrades?: InputMaybe<Int_Comparison_Exp>;
  percentile?: InputMaybe<Int_Comparison_Exp>;
  project_configurations?: InputMaybe<Project_Configurations_Bool_Exp>;
  project_configurations_aggregate?: InputMaybe<Project_Configurations_Aggregate_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  sis_reported_values?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
  sis_reported_values_aggregate?: InputMaybe<Current_Project_Sis_Reported_Values_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  study_cycle?: InputMaybe<String_Comparison_Exp>;
  study_group?: InputMaybe<String_Comparison_Exp>;
  study_phase?: InputMaybe<String_Comparison_Exp>;
  sum_allocated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  total_ranked?: InputMaybe<Int_Comparison_Exp>;
  total_reported_cost?: InputMaybe<Numeric_Comparison_Exp>;
  tracked_projects?: InputMaybe<Tracked_Projects_Bool_Exp>;
  tracked_projects_aggregate?: InputMaybe<Tracked_Projects_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Cluster_Projects_Max_Fields = {
  __typename?: 'cluster_projects_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  cost_per_mw?: Maybe<Scalars['numeric']['output']>;
  developer_name?: Maybe<Scalars['String']['output']>;
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  eris_mw?: Maybe<Scalars['numeric']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  hybrid_limit?: Maybe<Scalars['numeric']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  nris_mw?: Maybe<Scalars['numeric']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  study_phase?: Maybe<Scalars['String']['output']>;
  sum_allocated_cost?: Maybe<Scalars['numeric']['output']>;
  total_ranked?: Maybe<Scalars['Int']['output']>;
  total_reported_cost?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Cluster_Projects_Min_Fields = {
  __typename?: 'cluster_projects_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  cost_per_mw?: Maybe<Scalars['numeric']['output']>;
  developer_name?: Maybe<Scalars['String']['output']>;
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  eris_mw?: Maybe<Scalars['numeric']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  hybrid_limit?: Maybe<Scalars['numeric']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  nris_mw?: Maybe<Scalars['numeric']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  study_phase?: Maybe<Scalars['String']['output']>;
  sum_allocated_cost?: Maybe<Scalars['numeric']['output']>;
  total_ranked?: Maybe<Scalars['Int']['output']>;
  total_reported_cost?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "cluster_projects". */
export type Cluster_Projects_Order_By = {
  base_scenario?: InputMaybe<Current_Base_Scenarios_Order_By>;
  cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  cost_per_mw?: InputMaybe<Order_By>;
  developer_name?: InputMaybe<Order_By>;
  eris_capacity_mw?: InputMaybe<Order_By>;
  eris_mw?: InputMaybe<Order_By>;
  fuel_type?: InputMaybe<Order_By>;
  hybrid_limit?: InputMaybe<Order_By>;
  is_editable?: InputMaybe<Order_By>;
  is_withdrawn?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  nris_capacity_mw?: InputMaybe<Order_By>;
  nris_mw?: InputMaybe<Order_By>;
  num_assigned_upgrades?: InputMaybe<Order_By>;
  percentile?: InputMaybe<Order_By>;
  project_configurations_aggregate?: InputMaybe<Project_Configurations_Aggregate_Order_By>;
  project_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  sis_reported_values_aggregate?: InputMaybe<Current_Project_Sis_Reported_Values_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  study_cycle?: InputMaybe<Order_By>;
  study_group?: InputMaybe<Order_By>;
  study_phase?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
  total_ranked?: InputMaybe<Order_By>;
  total_reported_cost?: InputMaybe<Order_By>;
  tracked_projects_aggregate?: InputMaybe<Tracked_Projects_Aggregate_Order_By>;
};

/** select columns of table "cluster_projects" */
export enum Cluster_Projects_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CostPerMw = 'cost_per_mw',
  /** column name */
  DeveloperName = 'developer_name',
  /** column name */
  ErisCapacityMw = 'eris_capacity_mw',
  /** column name */
  ErisMw = 'eris_mw',
  /** column name */
  FuelType = 'fuel_type',
  /** column name */
  HybridLimit = 'hybrid_limit',
  /** column name */
  IsEditable = 'is_editable',
  /** column name */
  IsWithdrawn = 'is_withdrawn',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NrisCapacityMw = 'nris_capacity_mw',
  /** column name */
  NrisMw = 'nris_mw',
  /** column name */
  NumAssignedUpgrades = 'num_assigned_upgrades',
  /** column name */
  Percentile = 'percentile',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  Region = 'region',
  /** column name */
  Status = 'status',
  /** column name */
  StudyCycle = 'study_cycle',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  StudyPhase = 'study_phase',
  /** column name */
  SumAllocatedCost = 'sum_allocated_cost',
  /** column name */
  TotalRanked = 'total_ranked',
  /** column name */
  TotalReportedCost = 'total_reported_cost'
}

/** aggregate stddev on columns */
export type Cluster_Projects_Stddev_Fields = {
  __typename?: 'cluster_projects_stddev_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_mw?: Maybe<Scalars['Float']['output']>;
  hybrid_limit?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_mw?: Maybe<Scalars['Float']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_reported_cost?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Cluster_Projects_Stddev_Pop_Fields = {
  __typename?: 'cluster_projects_stddev_pop_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_mw?: Maybe<Scalars['Float']['output']>;
  hybrid_limit?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_mw?: Maybe<Scalars['Float']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_reported_cost?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Cluster_Projects_Stddev_Samp_Fields = {
  __typename?: 'cluster_projects_stddev_samp_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_mw?: Maybe<Scalars['Float']['output']>;
  hybrid_limit?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_mw?: Maybe<Scalars['Float']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_reported_cost?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "cluster_projects" */
export type Cluster_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cluster_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cluster_Projects_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  cost_per_mw?: InputMaybe<Scalars['numeric']['input']>;
  developer_name?: InputMaybe<Scalars['String']['input']>;
  eris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  eris_mw?: InputMaybe<Scalars['numeric']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  hybrid_limit?: InputMaybe<Scalars['numeric']['input']>;
  is_editable?: InputMaybe<Scalars['Boolean']['input']>;
  is_withdrawn?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  nris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  nris_mw?: InputMaybe<Scalars['numeric']['input']>;
  num_assigned_upgrades?: InputMaybe<Scalars['Int']['input']>;
  percentile?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
  sum_allocated_cost?: InputMaybe<Scalars['numeric']['input']>;
  total_ranked?: InputMaybe<Scalars['Int']['input']>;
  total_reported_cost?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Cluster_Projects_Sum_Fields = {
  __typename?: 'cluster_projects_sum_fields';
  cost_per_mw?: Maybe<Scalars['numeric']['output']>;
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  eris_mw?: Maybe<Scalars['numeric']['output']>;
  hybrid_limit?: Maybe<Scalars['numeric']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  nris_mw?: Maybe<Scalars['numeric']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Int']['output']>;
  percentile?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  sum_allocated_cost?: Maybe<Scalars['numeric']['output']>;
  total_ranked?: Maybe<Scalars['Int']['output']>;
  total_reported_cost?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Cluster_Projects_Var_Pop_Fields = {
  __typename?: 'cluster_projects_var_pop_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_mw?: Maybe<Scalars['Float']['output']>;
  hybrid_limit?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_mw?: Maybe<Scalars['Float']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_reported_cost?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Cluster_Projects_Var_Samp_Fields = {
  __typename?: 'cluster_projects_var_samp_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_mw?: Maybe<Scalars['Float']['output']>;
  hybrid_limit?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_mw?: Maybe<Scalars['Float']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_reported_cost?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Cluster_Projects_Variance_Fields = {
  __typename?: 'cluster_projects_variance_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_mw?: Maybe<Scalars['Float']['output']>;
  hybrid_limit?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_mw?: Maybe<Scalars['Float']['output']>;
  num_assigned_upgrades?: Maybe<Scalars['Float']['output']>;
  percentile?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_reported_cost?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "constraint_stacks" */
export type Constraint_Stacks = {
  __typename?: 'constraint_stacks';
  /** An object relationship */
  bus?: Maybe<Buses>;
  bus_id: Scalars['String']['output'];
  /** An object relationship */
  bus_without_override: Buses_Without_Overrides;
  contingency: Scalars['String']['output'];
  contingency_buses?: Maybe<Scalars['String']['output']>;
  contingency_type?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax: Scalars['numeric']['output'];
  element_type: Scalars['String']['output'];
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "constraint_stacks_id" */
  id?: Maybe<Scalars['uuid']['output']>;
  injection_threshold: Scalars['numeric']['output'];
  is_pre_existing: Scalars['Boolean']['output'];
  line_length?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  model_generator_facility_dfaxes: Array<Model_Generator_Facility_Dfax>;
  /** An aggregate relationship */
  model_generator_facility_dfaxes_aggregate: Model_Generator_Facility_Dfax_Aggregate;
  monitored_facility_id: Scalars['String']['output'];
  monitored_facility_name: Scalars['String']['output'];
  nira_bus_id: Scalars['String']['output'];
  pre_study_load: Scalars['numeric']['output'];
  /** An array relationship */
  queue_project_facility_dfaxes: Array<Queue_Project_Facility_Dfax>;
  /** An aggregate relationship */
  queue_project_facility_dfaxes_aggregate: Queue_Project_Facility_Dfax_Aggregate;
  rating: Scalars['numeric']['output'];
  resource_type: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  scope_view: Scalars['String']['output'];
  source_case?: Maybe<Scalars['String']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
};


/** columns and relationships of "constraint_stacks" */
export type Constraint_StacksModel_Generator_Facility_DfaxesArgs = {
  distinct_on?: InputMaybe<Array<Model_Generator_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generator_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
};


/** columns and relationships of "constraint_stacks" */
export type Constraint_StacksModel_Generator_Facility_Dfaxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Generator_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generator_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
};


/** columns and relationships of "constraint_stacks" */
export type Constraint_StacksQueue_Project_Facility_DfaxesArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
};


/** columns and relationships of "constraint_stacks" */
export type Constraint_StacksQueue_Project_Facility_Dfaxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
};


/** columns and relationships of "constraint_stacks" */
export type Constraint_StacksUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "constraint_stacks" */
export type Constraint_StacksUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "constraint_stacks" */
export type Constraint_Stacks_Aggregate = {
  __typename?: 'constraint_stacks_aggregate';
  aggregate?: Maybe<Constraint_Stacks_Aggregate_Fields>;
  nodes: Array<Constraint_Stacks>;
};

export type Constraint_Stacks_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Constraint_Stacks_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Constraint_Stacks_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Constraint_Stacks_Aggregate_Bool_Exp_Count>;
};

export type Constraint_Stacks_Aggregate_Bool_Exp_Bool_And = {
  arguments: Constraint_Stacks_Select_Column_Constraint_Stacks_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Constraint_Stacks_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Constraint_Stacks_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Constraint_Stacks_Select_Column_Constraint_Stacks_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Constraint_Stacks_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Constraint_Stacks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Constraint_Stacks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "constraint_stacks" */
export type Constraint_Stacks_Aggregate_Fields = {
  __typename?: 'constraint_stacks_aggregate_fields';
  avg?: Maybe<Constraint_Stacks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Constraint_Stacks_Max_Fields>;
  min?: Maybe<Constraint_Stacks_Min_Fields>;
  stddev?: Maybe<Constraint_Stacks_Stddev_Fields>;
  stddev_pop?: Maybe<Constraint_Stacks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Constraint_Stacks_Stddev_Samp_Fields>;
  sum?: Maybe<Constraint_Stacks_Sum_Fields>;
  var_pop?: Maybe<Constraint_Stacks_Var_Pop_Fields>;
  var_samp?: Maybe<Constraint_Stacks_Var_Samp_Fields>;
  variance?: Maybe<Constraint_Stacks_Variance_Fields>;
};


/** aggregate fields of "constraint_stacks" */
export type Constraint_Stacks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "constraint_stacks" */
export type Constraint_Stacks_Aggregate_Order_By = {
  avg?: InputMaybe<Constraint_Stacks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Constraint_Stacks_Max_Order_By>;
  min?: InputMaybe<Constraint_Stacks_Min_Order_By>;
  stddev?: InputMaybe<Constraint_Stacks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Constraint_Stacks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Constraint_Stacks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Constraint_Stacks_Sum_Order_By>;
  var_pop?: InputMaybe<Constraint_Stacks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Constraint_Stacks_Var_Samp_Order_By>;
  variance?: InputMaybe<Constraint_Stacks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "constraint_stacks" */
export type Constraint_Stacks_Arr_Rel_Insert_Input = {
  data: Array<Constraint_Stacks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Constraint_Stacks_On_Conflict>;
};

/** aggregate avg on columns */
export type Constraint_Stacks_Avg_Fields = {
  __typename?: 'constraint_stacks_avg_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Avg_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "constraint_stacks". All fields are combined with a logical 'AND'. */
export type Constraint_Stacks_Bool_Exp = {
  _and?: InputMaybe<Array<Constraint_Stacks_Bool_Exp>>;
  _not?: InputMaybe<Constraint_Stacks_Bool_Exp>;
  _or?: InputMaybe<Array<Constraint_Stacks_Bool_Exp>>;
  bus?: InputMaybe<Buses_Bool_Exp>;
  bus_id?: InputMaybe<String_Comparison_Exp>;
  bus_without_override?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
  contingency?: InputMaybe<String_Comparison_Exp>;
  contingency_buses?: InputMaybe<String_Comparison_Exp>;
  contingency_type?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  dfax?: InputMaybe<Numeric_Comparison_Exp>;
  element_type?: InputMaybe<String_Comparison_Exp>;
  estimated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  from_bus_kv_nominal?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  injection_threshold?: InputMaybe<Numeric_Comparison_Exp>;
  is_pre_existing?: InputMaybe<Boolean_Comparison_Exp>;
  line_length?: InputMaybe<Numeric_Comparison_Exp>;
  model_generator_facility_dfaxes?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
  model_generator_facility_dfaxes_aggregate?: InputMaybe<Model_Generator_Facility_Dfax_Aggregate_Bool_Exp>;
  monitored_facility_id?: InputMaybe<String_Comparison_Exp>;
  monitored_facility_name?: InputMaybe<String_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  pre_study_load?: InputMaybe<Numeric_Comparison_Exp>;
  queue_project_facility_dfaxes?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
  queue_project_facility_dfaxes_aggregate?: InputMaybe<Queue_Project_Facility_Dfax_Aggregate_Bool_Exp>;
  rating?: InputMaybe<Numeric_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  source_case?: InputMaybe<String_Comparison_Exp>;
  to_bus_kv_nominal?: InputMaybe<Numeric_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "constraint_stacks" */
export enum Constraint_Stacks_Constraint {
  /** unique or primary key constraint on columns "scope", "nira_bus_id", "scope_view", "resource_type", "monitored_facility_id" */
  ConstraintStacksPkey = 'constraint_stacks_pkey'
}

/** input type for incrementing numeric columns in table "constraint_stacks" */
export type Constraint_Stacks_Inc_Input = {
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  from_bus_kv_nominal?: InputMaybe<Scalars['numeric']['input']>;
  injection_threshold?: InputMaybe<Scalars['numeric']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  to_bus_kv_nominal?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "constraint_stacks" */
export type Constraint_Stacks_Insert_Input = {
  bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  bus_id?: InputMaybe<Scalars['String']['input']>;
  bus_without_override?: InputMaybe<Buses_Without_Overrides_Obj_Rel_Insert_Input>;
  contingency?: InputMaybe<Scalars['String']['input']>;
  contingency_buses?: InputMaybe<Scalars['String']['input']>;
  contingency_type?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  from_bus_kv_nominal?: InputMaybe<Scalars['numeric']['input']>;
  injection_threshold?: InputMaybe<Scalars['numeric']['input']>;
  is_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  model_generator_facility_dfaxes?: InputMaybe<Model_Generator_Facility_Dfax_Arr_Rel_Insert_Input>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  queue_project_facility_dfaxes?: InputMaybe<Queue_Project_Facility_Dfax_Arr_Rel_Insert_Input>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  source_case?: InputMaybe<Scalars['String']['input']>;
  to_bus_kv_nominal?: InputMaybe<Scalars['numeric']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Constraint_Stacks_Max_Fields = {
  __typename?: 'constraint_stacks_max_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  contingency?: Maybe<Scalars['String']['output']>;
  contingency_buses?: Maybe<Scalars['String']['output']>;
  contingency_type?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "constraint_stacks_id" */
  id?: Maybe<Scalars['uuid']['output']>;
  injection_threshold?: Maybe<Scalars['numeric']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  source_case?: Maybe<Scalars['String']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Max_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  contingency?: InputMaybe<Order_By>;
  contingency_buses?: InputMaybe<Order_By>;
  contingency_type?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  source_case?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Constraint_Stacks_Min_Fields = {
  __typename?: 'constraint_stacks_min_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  contingency?: Maybe<Scalars['String']['output']>;
  contingency_buses?: Maybe<Scalars['String']['output']>;
  contingency_type?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['numeric']['output']>;
  /** A computed field, executes function "constraint_stacks_id" */
  id?: Maybe<Scalars['uuid']['output']>;
  injection_threshold?: Maybe<Scalars['numeric']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  source_case?: Maybe<Scalars['String']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Min_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  contingency?: InputMaybe<Order_By>;
  contingency_buses?: InputMaybe<Order_By>;
  contingency_type?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  source_case?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "constraint_stacks" */
export type Constraint_Stacks_Mutation_Response = {
  __typename?: 'constraint_stacks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Constraint_Stacks>;
};

/** on_conflict condition type for table "constraint_stacks" */
export type Constraint_Stacks_On_Conflict = {
  constraint: Constraint_Stacks_Constraint;
  update_columns?: Array<Constraint_Stacks_Update_Column>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};

/** Ordering options when selecting data from "constraint_stacks". */
export type Constraint_Stacks_Order_By = {
  bus?: InputMaybe<Buses_Order_By>;
  bus_id?: InputMaybe<Order_By>;
  bus_without_override?: InputMaybe<Buses_Without_Overrides_Order_By>;
  contingency?: InputMaybe<Order_By>;
  contingency_buses?: InputMaybe<Order_By>;
  contingency_type?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  is_pre_existing?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  model_generator_facility_dfaxes_aggregate?: InputMaybe<Model_Generator_Facility_Dfax_Aggregate_Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  queue_project_facility_dfaxes_aggregate?: InputMaybe<Queue_Project_Facility_Dfax_Aggregate_Order_By>;
  rating?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  source_case?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: constraint_stacks */
export type Constraint_Stacks_Pk_Columns_Input = {
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  resource_type: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};

/** select columns of table "constraint_stacks" */
export enum Constraint_Stacks_Select_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  Contingency = 'contingency',
  /** column name */
  ContingencyBuses = 'contingency_buses',
  /** column name */
  ContingencyType = 'contingency_type',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  ElementType = 'element_type',
  /** column name */
  EstimatedCost = 'estimated_cost',
  /** column name */
  FromBusKvNominal = 'from_bus_kv_nominal',
  /** column name */
  InjectionThreshold = 'injection_threshold',
  /** column name */
  IsPreExisting = 'is_pre_existing',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  PreStudyLoad = 'pre_study_load',
  /** column name */
  Rating = 'rating',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  SourceCase = 'source_case',
  /** column name */
  ToBusKvNominal = 'to_bus_kv_nominal'
}

/** select "constraint_stacks_aggregate_bool_exp_bool_and_arguments_columns" columns of table "constraint_stacks" */
export enum Constraint_Stacks_Select_Column_Constraint_Stacks_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPreExisting = 'is_pre_existing'
}

/** select "constraint_stacks_aggregate_bool_exp_bool_or_arguments_columns" columns of table "constraint_stacks" */
export enum Constraint_Stacks_Select_Column_Constraint_Stacks_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPreExisting = 'is_pre_existing'
}

/** input type for updating data in table "constraint_stacks" */
export type Constraint_Stacks_Set_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  contingency?: InputMaybe<Scalars['String']['input']>;
  contingency_buses?: InputMaybe<Scalars['String']['input']>;
  contingency_type?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  from_bus_kv_nominal?: InputMaybe<Scalars['numeric']['input']>;
  injection_threshold?: InputMaybe<Scalars['numeric']['input']>;
  is_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  source_case?: InputMaybe<Scalars['String']['input']>;
  to_bus_kv_nominal?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Constraint_Stacks_Stddev_Fields = {
  __typename?: 'constraint_stacks_stddev_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Stddev_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Constraint_Stacks_Stddev_Pop_Fields = {
  __typename?: 'constraint_stacks_stddev_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Stddev_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Constraint_Stacks_Stddev_Samp_Fields = {
  __typename?: 'constraint_stacks_stddev_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Stddev_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "constraint_stacks" */
export type Constraint_Stacks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Constraint_Stacks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Constraint_Stacks_Stream_Cursor_Value_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  contingency?: InputMaybe<Scalars['String']['input']>;
  contingency_buses?: InputMaybe<Scalars['String']['input']>;
  contingency_type?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  from_bus_kv_nominal?: InputMaybe<Scalars['numeric']['input']>;
  injection_threshold?: InputMaybe<Scalars['numeric']['input']>;
  is_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  source_case?: InputMaybe<Scalars['String']['input']>;
  to_bus_kv_nominal?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Constraint_Stacks_Sum_Fields = {
  __typename?: 'constraint_stacks_sum_fields';
  dfax?: Maybe<Scalars['numeric']['output']>;
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['numeric']['output']>;
  injection_threshold?: Maybe<Scalars['numeric']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Sum_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** update columns of table "constraint_stacks" */
export enum Constraint_Stacks_Update_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  Contingency = 'contingency',
  /** column name */
  ContingencyBuses = 'contingency_buses',
  /** column name */
  ContingencyType = 'contingency_type',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  ElementType = 'element_type',
  /** column name */
  EstimatedCost = 'estimated_cost',
  /** column name */
  FromBusKvNominal = 'from_bus_kv_nominal',
  /** column name */
  InjectionThreshold = 'injection_threshold',
  /** column name */
  IsPreExisting = 'is_pre_existing',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  PreStudyLoad = 'pre_study_load',
  /** column name */
  Rating = 'rating',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  SourceCase = 'source_case',
  /** column name */
  ToBusKvNominal = 'to_bus_kv_nominal'
}

export type Constraint_Stacks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Constraint_Stacks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Constraint_Stacks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Constraint_Stacks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Constraint_Stacks_Var_Pop_Fields = {
  __typename?: 'constraint_stacks_var_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Var_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Constraint_Stacks_Var_Samp_Fields = {
  __typename?: 'constraint_stacks_var_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Var_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Constraint_Stacks_Variance_Fields = {
  __typename?: 'constraint_stacks_variance_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  from_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  to_bus_kv_nominal?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "constraint_stacks" */
export type Constraint_Stacks_Variance_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  from_bus_kv_nominal?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  to_bus_kv_nominal?: InputMaybe<Order_By>;
};

/** columns and relationships of "constraint_types" */
export type Constraint_Types = {
  __typename?: 'constraint_types';
  constraint_type: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

/** aggregated selection of "constraint_types" */
export type Constraint_Types_Aggregate = {
  __typename?: 'constraint_types_aggregate';
  aggregate?: Maybe<Constraint_Types_Aggregate_Fields>;
  nodes: Array<Constraint_Types>;
};

/** aggregate fields of "constraint_types" */
export type Constraint_Types_Aggregate_Fields = {
  __typename?: 'constraint_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Constraint_Types_Max_Fields>;
  min?: Maybe<Constraint_Types_Min_Fields>;
};


/** aggregate fields of "constraint_types" */
export type Constraint_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Constraint_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "constraint_types". All fields are combined with a logical 'AND'. */
export type Constraint_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Constraint_Types_Bool_Exp>>;
  _not?: InputMaybe<Constraint_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Constraint_Types_Bool_Exp>>;
  constraint_type?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "constraint_types" */
export enum Constraint_Types_Constraint {
  /** unique or primary key constraint on columns "constraint_type" */
  ConstraintTypesPkey = 'constraint_types_pkey'
}

export enum Constraint_Types_Enum {
  /** A constraint type for IQ NYISO */
  Cris = 'CRIS',
  /** An ERIS thermal constraint */
  Eris = 'ERIS',
  /** An ERIS charging constraint, used in MISO */
  ErisCharging = 'ERIS_CHARGING',
  /** A complex cost allocation for an ERIS constraint, used in MISO */
  ErisComplex = 'ERIS_COMPLEX',
  /** An ERIS Local Planning Criteria constraint in MISO */
  ErisLpc = 'ERIS_LPC',
  /** An ERIS TO constraint, used in MISO DPP-2022-Cycle */
  ErisTo = 'ERIS_TO',
  /** A Gen Deliv analysis constraint for PJM */
  GenDeliv = 'GEN_DELIV',
  /** An IPD analysis constraint for PJM */
  Ipd = 'IPD',
  /** Light load contingency type for PJM */
  LightLoad = 'LIGHT_LOAD',
  /** An NRIS thermal constraint */
  Nris = 'NRIS',
  /** A complex cost allocation for an NRIS constraint, used in MISO */
  NrisComplex = 'NRIS_COMPLEX',
  /** A network upgrade shared with a prior DPP cycle, used in MISO */
  SharedNetworkUpgrade = 'SHARED_NETWORK_UPGRADE',
  /** A non-convergence constraint type for SPP */
  SppNonConvergence = 'SPP_NON_CONVERGENCE',
  /** A thermal constraint type for SPP */
  SppThermal = 'SPP_THERMAL',
  /** Summer peak contingency type for PJM */
  SummerPeak = 'SUMMER_PEAK',
  /** Winter peak contingency type for PJM */
  WinterPeak = 'WINTER_PEAK'
}

/** Boolean expression to compare columns of type "constraint_types_enum". All fields are combined with logical 'AND'. */
export type Constraint_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Constraint_Types_Enum>;
  _in?: InputMaybe<Array<Constraint_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Constraint_Types_Enum>;
  _nin?: InputMaybe<Array<Constraint_Types_Enum>>;
};

/** input type for inserting data into table "constraint_types" */
export type Constraint_Types_Insert_Input = {
  constraint_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Constraint_Types_Max_Fields = {
  __typename?: 'constraint_types_max_fields';
  constraint_type?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Constraint_Types_Min_Fields = {
  __typename?: 'constraint_types_min_fields';
  constraint_type?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "constraint_types" */
export type Constraint_Types_Mutation_Response = {
  __typename?: 'constraint_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Constraint_Types>;
};

/** on_conflict condition type for table "constraint_types" */
export type Constraint_Types_On_Conflict = {
  constraint: Constraint_Types_Constraint;
  update_columns?: Array<Constraint_Types_Update_Column>;
  where?: InputMaybe<Constraint_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "constraint_types". */
export type Constraint_Types_Order_By = {
  constraint_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
};

/** primary key columns input for table: constraint_types */
export type Constraint_Types_Pk_Columns_Input = {
  constraint_type: Scalars['String']['input'];
};

/** select columns of table "constraint_types" */
export enum Constraint_Types_Select_Column {
  /** column name */
  ConstraintType = 'constraint_type',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "constraint_types" */
export type Constraint_Types_Set_Input = {
  constraint_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "constraint_types" */
export type Constraint_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Constraint_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Constraint_Types_Stream_Cursor_Value_Input = {
  constraint_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "constraint_types" */
export enum Constraint_Types_Update_Column {
  /** column name */
  ConstraintType = 'constraint_type',
  /** column name */
  Description = 'description'
}

export type Constraint_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Constraint_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Constraint_Types_Bool_Exp;
};

/** columns and relationships of "current_base_scenarios" */
export type Current_Base_Scenarios = {
  __typename?: 'current_base_scenarios';
  /** An object relationship */
  cluster?: Maybe<In_Queue_Clusters>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  project_size_assumptions?: Maybe<Scalars['jsonb']['output']>;
  run_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  scenario?: Maybe<Scenarios>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  scenario_stage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "current_base_scenarios" */
export type Current_Base_ScenariosProject_Size_AssumptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "current_base_scenarios" */
export type Current_Base_Scenarios_Aggregate = {
  __typename?: 'current_base_scenarios_aggregate';
  aggregate?: Maybe<Current_Base_Scenarios_Aggregate_Fields>;
  nodes: Array<Current_Base_Scenarios>;
};

/** aggregate fields of "current_base_scenarios" */
export type Current_Base_Scenarios_Aggregate_Fields = {
  __typename?: 'current_base_scenarios_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Current_Base_Scenarios_Max_Fields>;
  min?: Maybe<Current_Base_Scenarios_Min_Fields>;
};


/** aggregate fields of "current_base_scenarios" */
export type Current_Base_Scenarios_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Current_Base_Scenarios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "current_base_scenarios". All fields are combined with a logical 'AND'. */
export type Current_Base_Scenarios_Bool_Exp = {
  _and?: InputMaybe<Array<Current_Base_Scenarios_Bool_Exp>>;
  _not?: InputMaybe<Current_Base_Scenarios_Bool_Exp>;
  _or?: InputMaybe<Array<Current_Base_Scenarios_Bool_Exp>>;
  cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  project_size_assumptions?: InputMaybe<Jsonb_Comparison_Exp>;
  run_completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  scenario?: InputMaybe<Scenarios_Bool_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_stage?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Current_Base_Scenarios_Max_Fields = {
  __typename?: 'current_base_scenarios_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  run_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  scenario_stage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Current_Base_Scenarios_Min_Fields = {
  __typename?: 'current_base_scenarios_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  run_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  scenario_stage?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "current_base_scenarios". */
export type Current_Base_Scenarios_Order_By = {
  cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  project_size_assumptions?: InputMaybe<Order_By>;
  run_completed_at?: InputMaybe<Order_By>;
  scenario?: InputMaybe<Scenarios_Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  scenario_stage?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** select columns of table "current_base_scenarios" */
export enum Current_Base_Scenarios_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectSizeAssumptions = 'project_size_assumptions',
  /** column name */
  RunCompletedAt = 'run_completed_at',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  ScenarioStage = 'scenario_stage',
  /** column name */
  Title = 'title'
}

/** Streaming cursor of the table "current_base_scenarios" */
export type Current_Base_Scenarios_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Current_Base_Scenarios_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Current_Base_Scenarios_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  project_size_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
  run_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values = {
  __typename?: 'current_project_sis_reported_values';
  amount?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  cluster?: Maybe<In_Queue_Clusters>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  cost_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  cost_type_metadata?: Maybe<Sis_Project_Cost_Type_Metadata>;
  project_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Aggregate = {
  __typename?: 'current_project_sis_reported_values_aggregate';
  aggregate?: Maybe<Current_Project_Sis_Reported_Values_Aggregate_Fields>;
  nodes: Array<Current_Project_Sis_Reported_Values>;
};

export type Current_Project_Sis_Reported_Values_Aggregate_Bool_Exp = {
  count?: InputMaybe<Current_Project_Sis_Reported_Values_Aggregate_Bool_Exp_Count>;
};

export type Current_Project_Sis_Reported_Values_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Aggregate_Fields = {
  __typename?: 'current_project_sis_reported_values_aggregate_fields';
  avg?: Maybe<Current_Project_Sis_Reported_Values_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Current_Project_Sis_Reported_Values_Max_Fields>;
  min?: Maybe<Current_Project_Sis_Reported_Values_Min_Fields>;
  stddev?: Maybe<Current_Project_Sis_Reported_Values_Stddev_Fields>;
  stddev_pop?: Maybe<Current_Project_Sis_Reported_Values_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Current_Project_Sis_Reported_Values_Stddev_Samp_Fields>;
  sum?: Maybe<Current_Project_Sis_Reported_Values_Sum_Fields>;
  var_pop?: Maybe<Current_Project_Sis_Reported_Values_Var_Pop_Fields>;
  var_samp?: Maybe<Current_Project_Sis_Reported_Values_Var_Samp_Fields>;
  variance?: Maybe<Current_Project_Sis_Reported_Values_Variance_Fields>;
};


/** aggregate fields of "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Aggregate_Order_By = {
  avg?: InputMaybe<Current_Project_Sis_Reported_Values_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Current_Project_Sis_Reported_Values_Max_Order_By>;
  min?: InputMaybe<Current_Project_Sis_Reported_Values_Min_Order_By>;
  stddev?: InputMaybe<Current_Project_Sis_Reported_Values_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Current_Project_Sis_Reported_Values_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Current_Project_Sis_Reported_Values_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Current_Project_Sis_Reported_Values_Sum_Order_By>;
  var_pop?: InputMaybe<Current_Project_Sis_Reported_Values_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Current_Project_Sis_Reported_Values_Var_Samp_Order_By>;
  variance?: InputMaybe<Current_Project_Sis_Reported_Values_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Current_Project_Sis_Reported_Values_Avg_Fields = {
  __typename?: 'current_project_sis_reported_values_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "current_project_sis_reported_values". All fields are combined with a logical 'AND'. */
export type Current_Project_Sis_Reported_Values_Bool_Exp = {
  _and?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Bool_Exp>>;
  _not?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
  _or?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  cost_type?: InputMaybe<String_Comparison_Exp>;
  cost_type_metadata?: InputMaybe<Sis_Project_Cost_Type_Metadata_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Current_Project_Sis_Reported_Values_Max_Fields = {
  __typename?: 'current_project_sis_reported_values_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  cost_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  cost_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Current_Project_Sis_Reported_Values_Min_Fields = {
  __typename?: 'current_project_sis_reported_values_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  cost_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  cost_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "current_project_sis_reported_values". */
export type Current_Project_Sis_Reported_Values_Order_By = {
  amount?: InputMaybe<Order_By>;
  cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  cost_type?: InputMaybe<Order_By>;
  cost_type_metadata?: InputMaybe<Sis_Project_Cost_Type_Metadata_Order_By>;
  project_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** select columns of table "current_project_sis_reported_values" */
export enum Current_Project_Sis_Reported_Values_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CostType = 'cost_type',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Source = 'source'
}

/** aggregate stddev on columns */
export type Current_Project_Sis_Reported_Values_Stddev_Fields = {
  __typename?: 'current_project_sis_reported_values_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Current_Project_Sis_Reported_Values_Stddev_Pop_Fields = {
  __typename?: 'current_project_sis_reported_values_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Current_Project_Sis_Reported_Values_Stddev_Samp_Fields = {
  __typename?: 'current_project_sis_reported_values_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Current_Project_Sis_Reported_Values_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Current_Project_Sis_Reported_Values_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  cost_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Current_Project_Sis_Reported_Values_Sum_Fields = {
  __typename?: 'current_project_sis_reported_values_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Current_Project_Sis_Reported_Values_Var_Pop_Fields = {
  __typename?: 'current_project_sis_reported_values_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Current_Project_Sis_Reported_Values_Var_Samp_Fields = {
  __typename?: 'current_project_sis_reported_values_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Current_Project_Sis_Reported_Values_Variance_Fields = {
  __typename?: 'current_project_sis_reported_values_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "current_project_sis_reported_values" */
export type Current_Project_Sis_Reported_Values_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

export type Current_Validation_Custom_Upgrades_Args = {
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "custom_upgrade_files" */
export type Custom_Upgrade_Files = {
  __typename?: 'custom_upgrade_files';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  custom_upgrade: Custom_Upgrades;
  custom_upgrade_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  model_variant?: Maybe<In_Queue_Model_Variants>;
  source_file_contents: Scalars['String']['output'];
  source_file_format: Scalars['String']['output'];
  source_file_name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  variant?: Maybe<In_Queue_Model_Variants_Enum>;
};

/** aggregated selection of "custom_upgrade_files" */
export type Custom_Upgrade_Files_Aggregate = {
  __typename?: 'custom_upgrade_files_aggregate';
  aggregate?: Maybe<Custom_Upgrade_Files_Aggregate_Fields>;
  nodes: Array<Custom_Upgrade_Files>;
};

export type Custom_Upgrade_Files_Aggregate_Bool_Exp = {
  count?: InputMaybe<Custom_Upgrade_Files_Aggregate_Bool_Exp_Count>;
};

export type Custom_Upgrade_Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Custom_Upgrade_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "custom_upgrade_files" */
export type Custom_Upgrade_Files_Aggregate_Fields = {
  __typename?: 'custom_upgrade_files_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Upgrade_Files_Max_Fields>;
  min?: Maybe<Custom_Upgrade_Files_Min_Fields>;
};


/** aggregate fields of "custom_upgrade_files" */
export type Custom_Upgrade_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Upgrade_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "custom_upgrade_files" */
export type Custom_Upgrade_Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Custom_Upgrade_Files_Max_Order_By>;
  min?: InputMaybe<Custom_Upgrade_Files_Min_Order_By>;
};

/** input type for inserting array relation for remote table "custom_upgrade_files" */
export type Custom_Upgrade_Files_Arr_Rel_Insert_Input = {
  data: Array<Custom_Upgrade_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Custom_Upgrade_Files_On_Conflict>;
};

/** Boolean expression to filter rows from the table "custom_upgrade_files". All fields are combined with a logical 'AND'. */
export type Custom_Upgrade_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Custom_Upgrade_Files_Bool_Exp>>;
  _not?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Upgrade_Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_upgrade?: InputMaybe<Custom_Upgrades_Bool_Exp>;
  custom_upgrade_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  model_variant?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
  source_file_contents?: InputMaybe<String_Comparison_Exp>;
  source_file_format?: InputMaybe<String_Comparison_Exp>;
  source_file_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_upgrade_files" */
export enum Custom_Upgrade_Files_Constraint {
  /** unique or primary key constraint on columns "custom_upgrade_id", "variant" */
  CustomUpgradeFilesModelSpecificUnique = 'custom_upgrade_files_model_specific_unique',
  /** unique or primary key constraint on columns "custom_upgrade_id" */
  CustomUpgradeFilesNonModelSpecificUnique = 'custom_upgrade_files_non_model_specific_unique',
  /** unique or primary key constraint on columns "id" */
  CustomUpgradeFilesPkey = 'custom_upgrade_files_pkey'
}

/** input type for inserting data into table "custom_upgrade_files" */
export type Custom_Upgrade_Files_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_upgrade?: InputMaybe<Custom_Upgrades_Obj_Rel_Insert_Input>;
  custom_upgrade_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model_variant?: InputMaybe<In_Queue_Model_Variants_Obj_Rel_Insert_Input>;
  source_file_contents?: InputMaybe<Scalars['String']['input']>;
  source_file_format?: InputMaybe<Scalars['String']['input']>;
  source_file_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum>;
};

/** aggregate max on columns */
export type Custom_Upgrade_Files_Max_Fields = {
  __typename?: 'custom_upgrade_files_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  custom_upgrade_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source_file_contents?: Maybe<Scalars['String']['output']>;
  source_file_format?: Maybe<Scalars['String']['output']>;
  source_file_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "custom_upgrade_files" */
export type Custom_Upgrade_Files_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  custom_upgrade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source_file_contents?: InputMaybe<Order_By>;
  source_file_format?: InputMaybe<Order_By>;
  source_file_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Custom_Upgrade_Files_Min_Fields = {
  __typename?: 'custom_upgrade_files_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  custom_upgrade_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  source_file_contents?: Maybe<Scalars['String']['output']>;
  source_file_format?: Maybe<Scalars['String']['output']>;
  source_file_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "custom_upgrade_files" */
export type Custom_Upgrade_Files_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  custom_upgrade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  source_file_contents?: InputMaybe<Order_By>;
  source_file_format?: InputMaybe<Order_By>;
  source_file_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "custom_upgrade_files" */
export type Custom_Upgrade_Files_Mutation_Response = {
  __typename?: 'custom_upgrade_files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Upgrade_Files>;
};

/** on_conflict condition type for table "custom_upgrade_files" */
export type Custom_Upgrade_Files_On_Conflict = {
  constraint: Custom_Upgrade_Files_Constraint;
  update_columns?: Array<Custom_Upgrade_Files_Update_Column>;
  where?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_upgrade_files". */
export type Custom_Upgrade_Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  custom_upgrade?: InputMaybe<Custom_Upgrades_Order_By>;
  custom_upgrade_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_variant?: InputMaybe<In_Queue_Model_Variants_Order_By>;
  source_file_contents?: InputMaybe<Order_By>;
  source_file_format?: InputMaybe<Order_By>;
  source_file_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  variant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_upgrade_files */
export type Custom_Upgrade_Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_upgrade_files" */
export enum Custom_Upgrade_Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomUpgradeId = 'custom_upgrade_id',
  /** column name */
  Id = 'id',
  /** column name */
  SourceFileContents = 'source_file_contents',
  /** column name */
  SourceFileFormat = 'source_file_format',
  /** column name */
  SourceFileName = 'source_file_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Variant = 'variant'
}

/** input type for updating data in table "custom_upgrade_files" */
export type Custom_Upgrade_Files_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_upgrade_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source_file_contents?: InputMaybe<Scalars['String']['input']>;
  source_file_format?: InputMaybe<Scalars['String']['input']>;
  source_file_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum>;
};

/** Streaming cursor of the table "custom_upgrade_files" */
export type Custom_Upgrade_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Upgrade_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Upgrade_Files_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_upgrade_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  source_file_contents?: InputMaybe<Scalars['String']['input']>;
  source_file_format?: InputMaybe<Scalars['String']['input']>;
  source_file_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum>;
};

/** update columns of table "custom_upgrade_files" */
export enum Custom_Upgrade_Files_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomUpgradeId = 'custom_upgrade_id',
  /** column name */
  Id = 'id',
  /** column name */
  SourceFileContents = 'source_file_contents',
  /** column name */
  SourceFileFormat = 'source_file_format',
  /** column name */
  SourceFileName = 'source_file_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Variant = 'variant'
}

export type Custom_Upgrade_Files_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Upgrade_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Upgrade_Files_Bool_Exp;
};

/** columns and relationships of "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures = {
  __typename?: 'custom_upgrade_model_set_validation_failures';
  code: Custom_Upgrade_Validation_Failure_Codes_Enum;
  created_at: Scalars['timestamptz']['output'];
  custom_upgrade_model_set_validation_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  line_number?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  /** An object relationship */
  model_variant: In_Queue_Model_Variants;
  offending_text?: Maybe<Scalars['String']['output']>;
  severity: Custom_Upgrade_Validation_Failure_Severities_Enum;
  suggested_fix?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  validation: Custom_Upgrade_Model_Set_Validations;
  variant: In_Queue_Model_Variants_Enum;
  warn_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Aggregate = {
  __typename?: 'custom_upgrade_model_set_validation_failures_aggregate';
  aggregate?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Aggregate_Fields>;
  nodes: Array<Custom_Upgrade_Model_Set_Validation_Failures>;
};

export type Custom_Upgrade_Model_Set_Validation_Failures_Aggregate_Bool_Exp = {
  count?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Aggregate_Bool_Exp_Count>;
};

export type Custom_Upgrade_Model_Set_Validation_Failures_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Aggregate_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_aggregate_fields';
  avg?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Max_Fields>;
  min?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Min_Fields>;
  stddev?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Fields>;
  stddev_pop?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Samp_Fields>;
  sum?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Sum_Fields>;
  var_pop?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Var_Pop_Fields>;
  var_samp?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Var_Samp_Fields>;
  variance?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Variance_Fields>;
};


/** aggregate fields of "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Aggregate_Order_By = {
  avg?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Max_Order_By>;
  min?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Min_Order_By>;
  stddev?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Sum_Order_By>;
  var_pop?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Var_Samp_Order_By>;
  variance?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Arr_Rel_Insert_Input = {
  data: Array<Custom_Upgrade_Model_Set_Validation_Failures_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_On_Conflict>;
};

/** aggregate avg on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Avg_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_avg_fields';
  line_number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Avg_Order_By = {
  line_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "custom_upgrade_model_set_validation_failures". All fields are combined with a logical 'AND'. */
export type Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp = {
  _and?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>>;
  _not?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>>;
  code?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_upgrade_model_set_validation_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  line_number?: InputMaybe<Int_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  model_variant?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
  offending_text?: InputMaybe<String_Comparison_Exp>;
  severity?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Enum_Comparison_Exp>;
  suggested_fix?: InputMaybe<String_Comparison_Exp>;
  validation?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum_Comparison_Exp>;
  warn_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_upgrade_model_set_validation_failures" */
export enum Custom_Upgrade_Model_Set_Validation_Failures_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomUpgradeModelSetValidationFailuresPkey = 'custom_upgrade_model_set_validation_failures_pkey'
}

/** input type for incrementing numeric columns in table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Inc_Input = {
  line_number?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Insert_Input = {
  code?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_upgrade_model_set_validation_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  line_number?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  model_variant?: InputMaybe<In_Queue_Model_Variants_Obj_Rel_Insert_Input>;
  offending_text?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Enum>;
  suggested_fix?: InputMaybe<Scalars['String']['input']>;
  validation?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Obj_Rel_Insert_Input>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum>;
  warn_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Max_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  custom_upgrade_model_set_validation_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  line_number?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  offending_text?: Maybe<Scalars['String']['output']>;
  suggested_fix?: Maybe<Scalars['String']['output']>;
  warn_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  custom_upgrade_model_set_validation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_number?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  offending_text?: InputMaybe<Order_By>;
  suggested_fix?: InputMaybe<Order_By>;
  warn_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Min_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  custom_upgrade_model_set_validation_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  line_number?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  offending_text?: Maybe<Scalars['String']['output']>;
  suggested_fix?: Maybe<Scalars['String']['output']>;
  warn_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  custom_upgrade_model_set_validation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_number?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  offending_text?: InputMaybe<Order_By>;
  suggested_fix?: InputMaybe<Order_By>;
  warn_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Mutation_Response = {
  __typename?: 'custom_upgrade_model_set_validation_failures_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Upgrade_Model_Set_Validation_Failures>;
};

/** on_conflict condition type for table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_On_Conflict = {
  constraint: Custom_Upgrade_Model_Set_Validation_Failures_Constraint;
  update_columns?: Array<Custom_Upgrade_Model_Set_Validation_Failures_Update_Column>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_upgrade_model_set_validation_failures". */
export type Custom_Upgrade_Model_Set_Validation_Failures_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_upgrade_model_set_validation_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  line_number?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  model_variant?: InputMaybe<In_Queue_Model_Variants_Order_By>;
  offending_text?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  suggested_fix?: InputMaybe<Order_By>;
  validation?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Order_By>;
  variant?: InputMaybe<Order_By>;
  warn_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_upgrade_model_set_validation_failures */
export type Custom_Upgrade_Model_Set_Validation_Failures_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_upgrade_model_set_validation_failures" */
export enum Custom_Upgrade_Model_Set_Validation_Failures_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomUpgradeModelSetValidationId = 'custom_upgrade_model_set_validation_id',
  /** column name */
  Id = 'id',
  /** column name */
  LineNumber = 'line_number',
  /** column name */
  Message = 'message',
  /** column name */
  OffendingText = 'offending_text',
  /** column name */
  Severity = 'severity',
  /** column name */
  SuggestedFix = 'suggested_fix',
  /** column name */
  Variant = 'variant',
  /** column name */
  WarnId = 'warn_id'
}

/** input type for updating data in table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Set_Input = {
  code?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_upgrade_model_set_validation_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  line_number?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  offending_text?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Enum>;
  suggested_fix?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum>;
  warn_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_stddev_fields';
  line_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Order_By = {
  line_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Pop_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_stddev_pop_fields';
  line_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Pop_Order_By = {
  line_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Samp_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_stddev_samp_fields';
  line_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Stddev_Samp_Order_By = {
  line_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Upgrade_Model_Set_Validation_Failures_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Upgrade_Model_Set_Validation_Failures_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_upgrade_model_set_validation_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  line_number?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  offending_text?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Enum>;
  suggested_fix?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum>;
  warn_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Sum_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_sum_fields';
  line_number?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Sum_Order_By = {
  line_number?: InputMaybe<Order_By>;
};

/** update columns of table "custom_upgrade_model_set_validation_failures" */
export enum Custom_Upgrade_Model_Set_Validation_Failures_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomUpgradeModelSetValidationId = 'custom_upgrade_model_set_validation_id',
  /** column name */
  Id = 'id',
  /** column name */
  LineNumber = 'line_number',
  /** column name */
  Message = 'message',
  /** column name */
  OffendingText = 'offending_text',
  /** column name */
  Severity = 'severity',
  /** column name */
  SuggestedFix = 'suggested_fix',
  /** column name */
  Variant = 'variant',
  /** column name */
  WarnId = 'warn_id'
}

export type Custom_Upgrade_Model_Set_Validation_Failures_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Var_Pop_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_var_pop_fields';
  line_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Var_Pop_Order_By = {
  line_number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Var_Samp_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_var_samp_fields';
  line_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Var_Samp_Order_By = {
  line_number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Custom_Upgrade_Model_Set_Validation_Failures_Variance_Fields = {
  __typename?: 'custom_upgrade_model_set_validation_failures_variance_fields';
  line_number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "custom_upgrade_model_set_validation_failures" */
export type Custom_Upgrade_Model_Set_Validation_Failures_Variance_Order_By = {
  line_number?: InputMaybe<Order_By>;
};

/** columns and relationships of "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations = {
  __typename?: 'custom_upgrade_model_set_validations';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  custom_upgrade: Custom_Upgrades;
  custom_upgrade_id: Scalars['uuid']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  failures: Array<Custom_Upgrade_Model_Set_Validation_Failures>;
  /** An aggregate relationship */
  failures_aggregate: Custom_Upgrade_Model_Set_Validation_Failures_Aggregate;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  in_queue_cluster_model_set: In_Queue_Cluster_Model_Sets;
  in_queue_cluster_model_set_id: Scalars['uuid']['output'];
  model_set_id: Scalars['uuid']['output'];
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  validation_status: Custom_Upgrade_Validation_Statuses_Enum;
};


/** columns and relationships of "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_ValidationsFailuresArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
};


/** columns and relationships of "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_ValidationsFailures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
};

/** aggregated selection of "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Aggregate = {
  __typename?: 'custom_upgrade_model_set_validations_aggregate';
  aggregate?: Maybe<Custom_Upgrade_Model_Set_Validations_Aggregate_Fields>;
  nodes: Array<Custom_Upgrade_Model_Set_Validations>;
};

export type Custom_Upgrade_Model_Set_Validations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Aggregate_Bool_Exp_Count>;
};

export type Custom_Upgrade_Model_Set_Validations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Aggregate_Fields = {
  __typename?: 'custom_upgrade_model_set_validations_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Upgrade_Model_Set_Validations_Max_Fields>;
  min?: Maybe<Custom_Upgrade_Model_Set_Validations_Min_Fields>;
};


/** aggregate fields of "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Max_Order_By>;
  min?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Arr_Rel_Insert_Input = {
  data: Array<Custom_Upgrade_Model_Set_Validations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Custom_Upgrade_Model_Set_Validations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "custom_upgrade_model_set_validations". All fields are combined with a logical 'AND'. */
export type Custom_Upgrade_Model_Set_Validations_Bool_Exp = {
  _and?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Bool_Exp>>;
  _not?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_upgrade?: InputMaybe<Custom_Upgrades_Bool_Exp>;
  custom_upgrade_id?: InputMaybe<Uuid_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  failures?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
  failures_aggregate?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_queue_cluster_model_set?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
  in_queue_cluster_model_set_id?: InputMaybe<Uuid_Comparison_Exp>;
  model_set_id?: InputMaybe<Uuid_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  validation_status?: InputMaybe<Custom_Upgrade_Validation_Statuses_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_upgrade_model_set_validations" */
export enum Custom_Upgrade_Model_Set_Validations_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomUpgradeModelSetValidationsPkey = 'custom_upgrade_model_set_validations_pkey',
  /** unique or primary key constraint on columns "custom_upgrade_id", "model_set_id" */
  CustomUpgradeModelSetValidationsUpgradeModelSetUnique = 'custom_upgrade_model_set_validations_upgrade_model_set_unique'
}

/** input type for inserting data into table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Insert_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_upgrade?: InputMaybe<Custom_Upgrades_Obj_Rel_Insert_Input>;
  custom_upgrade_id?: InputMaybe<Scalars['uuid']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  failures?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster_model_set?: InputMaybe<In_Queue_Cluster_Model_Sets_Obj_Rel_Insert_Input>;
  in_queue_cluster_model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  validation_status?: InputMaybe<Custom_Upgrade_Validation_Statuses_Enum>;
};

/** aggregate max on columns */
export type Custom_Upgrade_Model_Set_Validations_Max_Fields = {
  __typename?: 'custom_upgrade_model_set_validations_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  custom_upgrade_id?: Maybe<Scalars['uuid']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  in_queue_cluster_model_set_id?: Maybe<Scalars['uuid']['output']>;
  model_set_id?: Maybe<Scalars['uuid']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_upgrade_id?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster_model_set_id?: InputMaybe<Order_By>;
  model_set_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Custom_Upgrade_Model_Set_Validations_Min_Fields = {
  __typename?: 'custom_upgrade_model_set_validations_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  custom_upgrade_id?: Maybe<Scalars['uuid']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  in_queue_cluster_model_set_id?: Maybe<Scalars['uuid']['output']>;
  model_set_id?: Maybe<Scalars['uuid']['output']>;
  submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_upgrade_id?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster_model_set_id?: InputMaybe<Order_By>;
  model_set_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Mutation_Response = {
  __typename?: 'custom_upgrade_model_set_validations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Upgrade_Model_Set_Validations>;
};

/** input type for inserting object relation for remote table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Obj_Rel_Insert_Input = {
  data: Custom_Upgrade_Model_Set_Validations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Custom_Upgrade_Model_Set_Validations_On_Conflict>;
};

/** on_conflict condition type for table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_On_Conflict = {
  constraint: Custom_Upgrade_Model_Set_Validations_Constraint;
  update_columns?: Array<Custom_Upgrade_Model_Set_Validations_Update_Column>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_upgrade_model_set_validations". */
export type Custom_Upgrade_Model_Set_Validations_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_upgrade?: InputMaybe<Custom_Upgrades_Order_By>;
  custom_upgrade_id?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  failures_aggregate?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster_model_set?: InputMaybe<In_Queue_Cluster_Model_Sets_Order_By>;
  in_queue_cluster_model_set_id?: InputMaybe<Order_By>;
  model_set_id?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  validation_status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_upgrade_model_set_validations */
export type Custom_Upgrade_Model_Set_Validations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_upgrade_model_set_validations" */
export enum Custom_Upgrade_Model_Set_Validations_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomUpgradeId = 'custom_upgrade_id',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  InQueueClusterModelSetId = 'in_queue_cluster_model_set_id',
  /** column name */
  ModelSetId = 'model_set_id',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidationStatus = 'validation_status'
}

/** input type for updating data in table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Set_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_upgrade_id?: InputMaybe<Scalars['uuid']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster_model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  validation_status?: InputMaybe<Custom_Upgrade_Validation_Statuses_Enum>;
};

/** Streaming cursor of the table "custom_upgrade_model_set_validations" */
export type Custom_Upgrade_Model_Set_Validations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Upgrade_Model_Set_Validations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Upgrade_Model_Set_Validations_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_upgrade_id?: InputMaybe<Scalars['uuid']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster_model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  validation_status?: InputMaybe<Custom_Upgrade_Validation_Statuses_Enum>;
};

/** update columns of table "custom_upgrade_model_set_validations" */
export enum Custom_Upgrade_Model_Set_Validations_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomUpgradeId = 'custom_upgrade_id',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  InQueueClusterModelSetId = 'in_queue_cluster_model_set_id',
  /** column name */
  ModelSetId = 'model_set_id',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidationStatus = 'validation_status'
}

export type Custom_Upgrade_Model_Set_Validations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Upgrade_Model_Set_Validations_Bool_Exp;
};

/** columns and relationships of "custom_upgrade_validation_failure_codes" */
export type Custom_Upgrade_Validation_Failure_Codes = {
  __typename?: 'custom_upgrade_validation_failure_codes';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

/** aggregated selection of "custom_upgrade_validation_failure_codes" */
export type Custom_Upgrade_Validation_Failure_Codes_Aggregate = {
  __typename?: 'custom_upgrade_validation_failure_codes_aggregate';
  aggregate?: Maybe<Custom_Upgrade_Validation_Failure_Codes_Aggregate_Fields>;
  nodes: Array<Custom_Upgrade_Validation_Failure_Codes>;
};

/** aggregate fields of "custom_upgrade_validation_failure_codes" */
export type Custom_Upgrade_Validation_Failure_Codes_Aggregate_Fields = {
  __typename?: 'custom_upgrade_validation_failure_codes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Upgrade_Validation_Failure_Codes_Max_Fields>;
  min?: Maybe<Custom_Upgrade_Validation_Failure_Codes_Min_Fields>;
};


/** aggregate fields of "custom_upgrade_validation_failure_codes" */
export type Custom_Upgrade_Validation_Failure_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "custom_upgrade_validation_failure_codes". All fields are combined with a logical 'AND'. */
export type Custom_Upgrade_Validation_Failure_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Bool_Exp>>;
  _not?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_upgrade_validation_failure_codes" */
export enum Custom_Upgrade_Validation_Failure_Codes_Constraint {
  /** unique or primary key constraint on columns "code" */
  CustomUpgradeValidationFailureCodesPkey = 'custom_upgrade_validation_failure_codes_pkey'
}

export enum Custom_Upgrade_Validation_Failure_Codes_Enum {
  /** Validating this model/upgrade pair failed with an unexpected error */
  InternalError = 'internal_error',
  /** An added bus has no connectivity path to any existing model bus, so no voltage/angle seed could be derived */
  IsolatedNewBus = 'isolated_new_bus',
  /** The model did not converge after applying the change file */
  NonConvergence = 'non_convergence',
  /** A Python-style psspy.* IDEV line was found; TARA never supports these */
  PsspyPythonLine = 'psspy_python_line',
  /** TARA emitted a WarnID while applying the change file */
  TaraApplyWarning = 'tara_apply_warning',
  /** TARA reported a critical error while applying the change file */
  TaraCritical = 'tara_critical',
  /** A BAT_* or psspy.* command in an #IDEV block is not supported by this TARA build */
  UnsupportedCommand = 'unsupported_command'
}

/** Boolean expression to compare columns of type "custom_upgrade_validation_failure_codes_enum". All fields are combined with logical 'AND'. */
export type Custom_Upgrade_Validation_Failure_Codes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Enum>;
  _in?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Enum>;
  _nin?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Enum>>;
};

/** input type for inserting data into table "custom_upgrade_validation_failure_codes" */
export type Custom_Upgrade_Validation_Failure_Codes_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Custom_Upgrade_Validation_Failure_Codes_Max_Fields = {
  __typename?: 'custom_upgrade_validation_failure_codes_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Custom_Upgrade_Validation_Failure_Codes_Min_Fields = {
  __typename?: 'custom_upgrade_validation_failure_codes_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "custom_upgrade_validation_failure_codes" */
export type Custom_Upgrade_Validation_Failure_Codes_Mutation_Response = {
  __typename?: 'custom_upgrade_validation_failure_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Upgrade_Validation_Failure_Codes>;
};

/** on_conflict condition type for table "custom_upgrade_validation_failure_codes" */
export type Custom_Upgrade_Validation_Failure_Codes_On_Conflict = {
  constraint: Custom_Upgrade_Validation_Failure_Codes_Constraint;
  update_columns?: Array<Custom_Upgrade_Validation_Failure_Codes_Update_Column>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_upgrade_validation_failure_codes". */
export type Custom_Upgrade_Validation_Failure_Codes_Order_By = {
  code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_upgrade_validation_failure_codes */
export type Custom_Upgrade_Validation_Failure_Codes_Pk_Columns_Input = {
  code: Scalars['String']['input'];
};

/** select columns of table "custom_upgrade_validation_failure_codes" */
export enum Custom_Upgrade_Validation_Failure_Codes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "custom_upgrade_validation_failure_codes" */
export type Custom_Upgrade_Validation_Failure_Codes_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "custom_upgrade_validation_failure_codes" */
export type Custom_Upgrade_Validation_Failure_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Upgrade_Validation_Failure_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Upgrade_Validation_Failure_Codes_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "custom_upgrade_validation_failure_codes" */
export enum Custom_Upgrade_Validation_Failure_Codes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  Description = 'description'
}

export type Custom_Upgrade_Validation_Failure_Codes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Upgrade_Validation_Failure_Codes_Bool_Exp;
};

/** columns and relationships of "custom_upgrade_validation_failure_severities" */
export type Custom_Upgrade_Validation_Failure_Severities = {
  __typename?: 'custom_upgrade_validation_failure_severities';
  description: Scalars['String']['output'];
  severity: Scalars['String']['output'];
};

/** aggregated selection of "custom_upgrade_validation_failure_severities" */
export type Custom_Upgrade_Validation_Failure_Severities_Aggregate = {
  __typename?: 'custom_upgrade_validation_failure_severities_aggregate';
  aggregate?: Maybe<Custom_Upgrade_Validation_Failure_Severities_Aggregate_Fields>;
  nodes: Array<Custom_Upgrade_Validation_Failure_Severities>;
};

/** aggregate fields of "custom_upgrade_validation_failure_severities" */
export type Custom_Upgrade_Validation_Failure_Severities_Aggregate_Fields = {
  __typename?: 'custom_upgrade_validation_failure_severities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Upgrade_Validation_Failure_Severities_Max_Fields>;
  min?: Maybe<Custom_Upgrade_Validation_Failure_Severities_Min_Fields>;
};


/** aggregate fields of "custom_upgrade_validation_failure_severities" */
export type Custom_Upgrade_Validation_Failure_Severities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "custom_upgrade_validation_failure_severities". All fields are combined with a logical 'AND'. */
export type Custom_Upgrade_Validation_Failure_Severities_Bool_Exp = {
  _and?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Bool_Exp>>;
  _not?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_upgrade_validation_failure_severities" */
export enum Custom_Upgrade_Validation_Failure_Severities_Constraint {
  /** unique or primary key constraint on columns "severity" */
  CustomUpgradeValidationFailureSeveritiesPkey = 'custom_upgrade_validation_failure_severities_pkey'
}

export enum Custom_Upgrade_Validation_Failure_Severities_Enum {
  /** Blocking: the change did not produce a usable model */
  Failure = 'failure',
  /** Advisory: TARA accepted the change but flagged something to review */
  Warning = 'warning'
}

/** Boolean expression to compare columns of type "custom_upgrade_validation_failure_severities_enum". All fields are combined with logical 'AND'. */
export type Custom_Upgrade_Validation_Failure_Severities_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Enum>;
  _in?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Enum>;
  _nin?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Enum>>;
};

/** input type for inserting data into table "custom_upgrade_validation_failure_severities" */
export type Custom_Upgrade_Validation_Failure_Severities_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Custom_Upgrade_Validation_Failure_Severities_Max_Fields = {
  __typename?: 'custom_upgrade_validation_failure_severities_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Custom_Upgrade_Validation_Failure_Severities_Min_Fields = {
  __typename?: 'custom_upgrade_validation_failure_severities_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "custom_upgrade_validation_failure_severities" */
export type Custom_Upgrade_Validation_Failure_Severities_Mutation_Response = {
  __typename?: 'custom_upgrade_validation_failure_severities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Upgrade_Validation_Failure_Severities>;
};

/** on_conflict condition type for table "custom_upgrade_validation_failure_severities" */
export type Custom_Upgrade_Validation_Failure_Severities_On_Conflict = {
  constraint: Custom_Upgrade_Validation_Failure_Severities_Constraint;
  update_columns?: Array<Custom_Upgrade_Validation_Failure_Severities_Update_Column>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_upgrade_validation_failure_severities". */
export type Custom_Upgrade_Validation_Failure_Severities_Order_By = {
  description?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_upgrade_validation_failure_severities */
export type Custom_Upgrade_Validation_Failure_Severities_Pk_Columns_Input = {
  severity: Scalars['String']['input'];
};

/** select columns of table "custom_upgrade_validation_failure_severities" */
export enum Custom_Upgrade_Validation_Failure_Severities_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Severity = 'severity'
}

/** input type for updating data in table "custom_upgrade_validation_failure_severities" */
export type Custom_Upgrade_Validation_Failure_Severities_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "custom_upgrade_validation_failure_severities" */
export type Custom_Upgrade_Validation_Failure_Severities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Upgrade_Validation_Failure_Severities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Upgrade_Validation_Failure_Severities_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "custom_upgrade_validation_failure_severities" */
export enum Custom_Upgrade_Validation_Failure_Severities_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Severity = 'severity'
}

export type Custom_Upgrade_Validation_Failure_Severities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Upgrade_Validation_Failure_Severities_Bool_Exp;
};

/** columns and relationships of "custom_upgrade_validation_statuses" */
export type Custom_Upgrade_Validation_Statuses = {
  __typename?: 'custom_upgrade_validation_statuses';
  description: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** aggregated selection of "custom_upgrade_validation_statuses" */
export type Custom_Upgrade_Validation_Statuses_Aggregate = {
  __typename?: 'custom_upgrade_validation_statuses_aggregate';
  aggregate?: Maybe<Custom_Upgrade_Validation_Statuses_Aggregate_Fields>;
  nodes: Array<Custom_Upgrade_Validation_Statuses>;
};

/** aggregate fields of "custom_upgrade_validation_statuses" */
export type Custom_Upgrade_Validation_Statuses_Aggregate_Fields = {
  __typename?: 'custom_upgrade_validation_statuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Upgrade_Validation_Statuses_Max_Fields>;
  min?: Maybe<Custom_Upgrade_Validation_Statuses_Min_Fields>;
};


/** aggregate fields of "custom_upgrade_validation_statuses" */
export type Custom_Upgrade_Validation_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "custom_upgrade_validation_statuses". All fields are combined with a logical 'AND'. */
export type Custom_Upgrade_Validation_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Custom_Upgrade_Validation_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_upgrade_validation_statuses" */
export enum Custom_Upgrade_Validation_Statuses_Constraint {
  /** unique or primary key constraint on columns "status" */
  CustomUpgradeValidationStatusesPkey = 'custom_upgrade_validation_statuses_pkey'
}

export enum Custom_Upgrade_Validation_Statuses_Enum {
  /** Validation completed with a failure */
  Failed = 'FAILED',
  /** Validation has been requested but not yet started */
  Requested = 'REQUESTED',
  /** Validation is currently running */
  Running = 'RUNNING',
  /** Validation completed successfully */
  Succeeded = 'SUCCEEDED'
}

/** Boolean expression to compare columns of type "custom_upgrade_validation_statuses_enum". All fields are combined with logical 'AND'. */
export type Custom_Upgrade_Validation_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Custom_Upgrade_Validation_Statuses_Enum>;
  _in?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Custom_Upgrade_Validation_Statuses_Enum>;
  _nin?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Enum>>;
};

/** input type for inserting data into table "custom_upgrade_validation_statuses" */
export type Custom_Upgrade_Validation_Statuses_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Custom_Upgrade_Validation_Statuses_Max_Fields = {
  __typename?: 'custom_upgrade_validation_statuses_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Custom_Upgrade_Validation_Statuses_Min_Fields = {
  __typename?: 'custom_upgrade_validation_statuses_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "custom_upgrade_validation_statuses" */
export type Custom_Upgrade_Validation_Statuses_Mutation_Response = {
  __typename?: 'custom_upgrade_validation_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Upgrade_Validation_Statuses>;
};

/** on_conflict condition type for table "custom_upgrade_validation_statuses" */
export type Custom_Upgrade_Validation_Statuses_On_Conflict = {
  constraint: Custom_Upgrade_Validation_Statuses_Constraint;
  update_columns?: Array<Custom_Upgrade_Validation_Statuses_Update_Column>;
  where?: InputMaybe<Custom_Upgrade_Validation_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_upgrade_validation_statuses". */
export type Custom_Upgrade_Validation_Statuses_Order_By = {
  description?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_upgrade_validation_statuses */
export type Custom_Upgrade_Validation_Statuses_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "custom_upgrade_validation_statuses" */
export enum Custom_Upgrade_Validation_Statuses_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "custom_upgrade_validation_statuses" */
export type Custom_Upgrade_Validation_Statuses_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "custom_upgrade_validation_statuses" */
export type Custom_Upgrade_Validation_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Upgrade_Validation_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Upgrade_Validation_Statuses_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "custom_upgrade_validation_statuses" */
export enum Custom_Upgrade_Validation_Statuses_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type Custom_Upgrade_Validation_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Upgrade_Validation_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Upgrade_Validation_Statuses_Bool_Exp;
};

/** columns and relationships of "custom_upgrades" */
export type Custom_Upgrades = {
  __typename?: 'custom_upgrades';
  cluster_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "custom_upgrade_current_validation" */
  current_validation?: Maybe<Array<Custom_Upgrade_Model_Set_Validations>>;
  /** An array relationship */
  custom_upgrade_files: Array<Custom_Upgrade_Files>;
  /** An aggregate relationship */
  custom_upgrade_files_aggregate: Custom_Upgrade_Files_Aggregate;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  in_queue_cluster: In_Queue_Clusters;
  /** An array relationship */
  model_set_validations: Array<Custom_Upgrade_Model_Set_Validations>;
  /** An aggregate relationship */
  model_set_validations_aggregate: Custom_Upgrade_Model_Set_Validations_Aggregate;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  source_file_contents: Scalars['String']['output'];
  source_file_format: Scalars['String']['output'];
  source_file_name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "custom_upgrades" */
export type Custom_UpgradesCurrent_ValidationArgs = {
  args?: InputMaybe<Current_Validation_Custom_Upgrades_Args>;
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
};


/** columns and relationships of "custom_upgrades" */
export type Custom_UpgradesCustom_Upgrade_FilesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Files_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
};


/** columns and relationships of "custom_upgrades" */
export type Custom_UpgradesCustom_Upgrade_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Files_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
};


/** columns and relationships of "custom_upgrades" */
export type Custom_UpgradesModel_Set_ValidationsArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
};


/** columns and relationships of "custom_upgrades" */
export type Custom_UpgradesModel_Set_Validations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
};

/** aggregated selection of "custom_upgrades" */
export type Custom_Upgrades_Aggregate = {
  __typename?: 'custom_upgrades_aggregate';
  aggregate?: Maybe<Custom_Upgrades_Aggregate_Fields>;
  nodes: Array<Custom_Upgrades>;
};

/** aggregate fields of "custom_upgrades" */
export type Custom_Upgrades_Aggregate_Fields = {
  __typename?: 'custom_upgrades_aggregate_fields';
  avg?: Maybe<Custom_Upgrades_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Custom_Upgrades_Max_Fields>;
  min?: Maybe<Custom_Upgrades_Min_Fields>;
  stddev?: Maybe<Custom_Upgrades_Stddev_Fields>;
  stddev_pop?: Maybe<Custom_Upgrades_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Custom_Upgrades_Stddev_Samp_Fields>;
  sum?: Maybe<Custom_Upgrades_Sum_Fields>;
  var_pop?: Maybe<Custom_Upgrades_Var_Pop_Fields>;
  var_samp?: Maybe<Custom_Upgrades_Var_Samp_Fields>;
  variance?: Maybe<Custom_Upgrades_Variance_Fields>;
};


/** aggregate fields of "custom_upgrades" */
export type Custom_Upgrades_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Custom_Upgrades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Custom_Upgrades_Avg_Fields = {
  __typename?: 'custom_upgrades_avg_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "custom_upgrades". All fields are combined with a logical 'AND'. */
export type Custom_Upgrades_Bool_Exp = {
  _and?: InputMaybe<Array<Custom_Upgrades_Bool_Exp>>;
  _not?: InputMaybe<Custom_Upgrades_Bool_Exp>;
  _or?: InputMaybe<Array<Custom_Upgrades_Bool_Exp>>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  custom_upgrade_files?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
  custom_upgrade_files_aggregate?: InputMaybe<Custom_Upgrade_Files_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  model_set_validations?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
  model_set_validations_aggregate?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  source_file_contents?: InputMaybe<String_Comparison_Exp>;
  source_file_format?: InputMaybe<String_Comparison_Exp>;
  source_file_name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "custom_upgrades" */
export enum Custom_Upgrades_Constraint {
  /** unique or primary key constraint on columns "id" */
  CustomUpgradesPkey = 'custom_upgrades_pkey',
  /** unique or primary key constraint on columns "cluster_id", "name" */
  CustomUpgradesSharedClusterNameActiveUnique = 'custom_upgrades_shared_cluster_name_active_unique',
  /** unique or primary key constraint on columns "cluster_id", "name", "team_id" */
  CustomUpgradesTeamClusterNameActiveUnique = 'custom_upgrades_team_cluster_name_active_unique'
}

/** input type for incrementing numeric columns in table "custom_upgrades" */
export type Custom_Upgrades_Inc_Input = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "custom_upgrades" */
export type Custom_Upgrades_Insert_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  custom_upgrade_files?: InputMaybe<Custom_Upgrade_Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  model_set_validations?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  source_file_contents?: InputMaybe<Scalars['String']['input']>;
  source_file_format?: InputMaybe<Scalars['String']['input']>;
  source_file_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Custom_Upgrades_Max_Fields = {
  __typename?: 'custom_upgrades_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  source_file_contents?: Maybe<Scalars['String']['output']>;
  source_file_format?: Maybe<Scalars['String']['output']>;
  source_file_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Custom_Upgrades_Min_Fields = {
  __typename?: 'custom_upgrades_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  source_file_contents?: Maybe<Scalars['String']['output']>;
  source_file_format?: Maybe<Scalars['String']['output']>;
  source_file_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "custom_upgrades" */
export type Custom_Upgrades_Mutation_Response = {
  __typename?: 'custom_upgrades_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Custom_Upgrades>;
};

/** input type for inserting object relation for remote table "custom_upgrades" */
export type Custom_Upgrades_Obj_Rel_Insert_Input = {
  data: Custom_Upgrades_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Custom_Upgrades_On_Conflict>;
};

/** on_conflict condition type for table "custom_upgrades" */
export type Custom_Upgrades_On_Conflict = {
  constraint: Custom_Upgrades_Constraint;
  update_columns?: Array<Custom_Upgrades_Update_Column>;
  where?: InputMaybe<Custom_Upgrades_Bool_Exp>;
};

/** Ordering options when selecting data from "custom_upgrades". */
export type Custom_Upgrades_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  custom_upgrade_files_aggregate?: InputMaybe<Custom_Upgrade_Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  model_set_validations_aggregate?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  source_file_contents?: InputMaybe<Order_By>;
  source_file_format?: InputMaybe<Order_By>;
  source_file_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: custom_upgrades */
export type Custom_Upgrades_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_upgrades" */
export enum Custom_Upgrades_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  SourceFileContents = 'source_file_contents',
  /** column name */
  SourceFileFormat = 'source_file_format',
  /** column name */
  SourceFileName = 'source_file_name',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "custom_upgrades" */
export type Custom_Upgrades_Set_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  source_file_contents?: InputMaybe<Scalars['String']['input']>;
  source_file_format?: InputMaybe<Scalars['String']['input']>;
  source_file_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Custom_Upgrades_Stddev_Fields = {
  __typename?: 'custom_upgrades_stddev_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Custom_Upgrades_Stddev_Pop_Fields = {
  __typename?: 'custom_upgrades_stddev_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Custom_Upgrades_Stddev_Samp_Fields = {
  __typename?: 'custom_upgrades_stddev_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "custom_upgrades" */
export type Custom_Upgrades_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Custom_Upgrades_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Custom_Upgrades_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  source_file_contents?: InputMaybe<Scalars['String']['input']>;
  source_file_format?: InputMaybe<Scalars['String']['input']>;
  source_file_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Custom_Upgrades_Sum_Fields = {
  __typename?: 'custom_upgrades_sum_fields';
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "custom_upgrades" */
export enum Custom_Upgrades_Update_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  SourceFileContents = 'source_file_contents',
  /** column name */
  SourceFileFormat = 'source_file_format',
  /** column name */
  SourceFileName = 'source_file_name',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Custom_Upgrades_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Custom_Upgrades_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Custom_Upgrades_Set_Input>;
  /** filter the rows which have to be updated */
  where: Custom_Upgrades_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Custom_Upgrades_Var_Pop_Fields = {
  __typename?: 'custom_upgrades_var_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Custom_Upgrades_Var_Samp_Fields = {
  __typename?: 'custom_upgrades_var_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Custom_Upgrades_Variance_Fields = {
  __typename?: 'custom_upgrades_variance_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "data_versions" */
export type Data_Versions = {
  __typename?: 'data_versions';
  id: Scalars['uuid']['output'];
  region: Scalars['String']['output'];
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  version: Scalars['uuid']['output'];
};


/** columns and relationships of "data_versions" */
export type Data_VersionsSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "data_versions" */
export type Data_VersionsSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** aggregated selection of "data_versions" */
export type Data_Versions_Aggregate = {
  __typename?: 'data_versions_aggregate';
  aggregate?: Maybe<Data_Versions_Aggregate_Fields>;
  nodes: Array<Data_Versions>;
};

/** aggregate fields of "data_versions" */
export type Data_Versions_Aggregate_Fields = {
  __typename?: 'data_versions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Data_Versions_Max_Fields>;
  min?: Maybe<Data_Versions_Min_Fields>;
};


/** aggregate fields of "data_versions" */
export type Data_Versions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Data_Versions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "data_versions". All fields are combined with a logical 'AND'. */
export type Data_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Data_Versions_Bool_Exp>>;
  _not?: InputMaybe<Data_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Data_Versions_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  version?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "data_versions" */
export enum Data_Versions_Constraint {
  /** unique or primary key constraint on columns "id" */
  DataVersionsPkey = 'data_versions_pkey',
  /** unique or primary key constraint on columns "region" */
  DataVersionsRegionKey = 'data_versions_region_key'
}

/** input type for inserting data into table "data_versions" */
export type Data_Versions_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
  version?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Data_Versions_Max_Fields = {
  __typename?: 'data_versions_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Data_Versions_Min_Fields = {
  __typename?: 'data_versions_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "data_versions" */
export type Data_Versions_Mutation_Response = {
  __typename?: 'data_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Data_Versions>;
};

/** on_conflict condition type for table "data_versions" */
export type Data_Versions_On_Conflict = {
  constraint: Data_Versions_Constraint;
  update_columns?: Array<Data_Versions_Update_Column>;
  where?: InputMaybe<Data_Versions_Bool_Exp>;
};

/** Ordering options when selecting data from "data_versions". */
export type Data_Versions_Order_By = {
  id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: data_versions */
export type Data_Versions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "data_versions" */
export enum Data_Versions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "data_versions" */
export type Data_Versions_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "data_versions" */
export type Data_Versions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Data_Versions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Data_Versions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "data_versions" */
export enum Data_Versions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  Version = 'version'
}

export type Data_Versions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Data_Versions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Data_Versions_Bool_Exp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

export type External_Api_Bus_Args = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "external_api_buses" */
export type External_Api_Buses = {
  __typename?: 'external_api_buses';
  bus_name?: Maybe<Scalars['String']['output']>;
  bus_number?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_confidence?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  voltage_kv?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "external_api_buses" */
export type External_Api_BusesSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "external_api_buses" */
export type External_Api_BusesSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

export type External_Api_Buses_Aggregate = {
  __typename?: 'external_api_buses_aggregate';
  aggregate?: Maybe<External_Api_Buses_Aggregate_Fields>;
  nodes: Array<External_Api_Buses>;
};

/** aggregate fields of "external_api_buses" */
export type External_Api_Buses_Aggregate_Fields = {
  __typename?: 'external_api_buses_aggregate_fields';
  avg?: Maybe<External_Api_Buses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<External_Api_Buses_Max_Fields>;
  min?: Maybe<External_Api_Buses_Min_Fields>;
  stddev?: Maybe<External_Api_Buses_Stddev_Fields>;
  stddev_pop?: Maybe<External_Api_Buses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<External_Api_Buses_Stddev_Samp_Fields>;
  sum?: Maybe<External_Api_Buses_Sum_Fields>;
  var_pop?: Maybe<External_Api_Buses_Var_Pop_Fields>;
  var_samp?: Maybe<External_Api_Buses_Var_Samp_Fields>;
  variance?: Maybe<External_Api_Buses_Variance_Fields>;
};


/** aggregate fields of "external_api_buses" */
export type External_Api_Buses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type External_Api_Buses_Avg_Fields = {
  __typename?: 'external_api_buses_avg_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage_kv?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_api_buses". All fields are combined with a logical 'AND'. */
export type External_Api_Buses_Bool_Exp = {
  _and?: InputMaybe<Array<External_Api_Buses_Bool_Exp>>;
  _not?: InputMaybe<External_Api_Buses_Bool_Exp>;
  _or?: InputMaybe<Array<External_Api_Buses_Bool_Exp>>;
  bus_name?: InputMaybe<String_Comparison_Exp>;
  bus_number?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  location_confidence?: InputMaybe<String_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  voltage_kv?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type External_Api_Buses_Max_Fields = {
  __typename?: 'external_api_buses_max_fields';
  bus_name?: Maybe<Scalars['String']['output']>;
  bus_number?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_confidence?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  voltage_kv?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type External_Api_Buses_Min_Fields = {
  __typename?: 'external_api_buses_min_fields';
  bus_name?: Maybe<Scalars['String']['output']>;
  bus_number?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  location_confidence?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  voltage_kv?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "external_api_buses". */
export type External_Api_Buses_Order_By = {
  bus_name?: InputMaybe<Order_By>;
  bus_number?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  location_confidence?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  voltage_kv?: InputMaybe<Order_By>;
};

export type External_Api_Buses_Page_Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['uuid']['input']>;
};

/** select columns of table "external_api_buses" */
export enum External_Api_Buses_Select_Column {
  /** column name */
  BusName = 'bus_name',
  /** column name */
  BusNumber = 'bus_number',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LocationConfidence = 'location_confidence',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  Owner = 'owner',
  /** column name */
  Region = 'region',
  /** column name */
  State = 'state',
  /** column name */
  VoltageKv = 'voltage_kv'
}

/** aggregate stddev on columns */
export type External_Api_Buses_Stddev_Fields = {
  __typename?: 'external_api_buses_stddev_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage_kv?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type External_Api_Buses_Stddev_Pop_Fields = {
  __typename?: 'external_api_buses_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage_kv?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type External_Api_Buses_Stddev_Samp_Fields = {
  __typename?: 'external_api_buses_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage_kv?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "external_api_buses" */
export type External_Api_Buses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Api_Buses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Api_Buses_Stream_Cursor_Value_Input = {
  bus_name?: InputMaybe<Scalars['String']['input']>;
  bus_number?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  location_confidence?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  voltage_kv?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type External_Api_Buses_Sum_Fields = {
  __typename?: 'external_api_buses_sum_fields';
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  voltage_kv?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type External_Api_Buses_Var_Pop_Fields = {
  __typename?: 'external_api_buses_var_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage_kv?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type External_Api_Buses_Var_Samp_Fields = {
  __typename?: 'external_api_buses_var_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage_kv?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type External_Api_Buses_Variance_Fields = {
  __typename?: 'external_api_buses_variance_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  voltage_kv?: Maybe<Scalars['Float']['output']>;
};

export type External_Api_Capacity_Cost_Args = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "external_api_capacity_costs" */
export type External_Api_Capacity_Costs = {
  __typename?: 'external_api_capacity_costs';
  bus_id?: Maybe<Scalars['String']['output']>;
  capacity_size_mw?: Maybe<Scalars['numeric']['output']>;
  charging_size_mw?: Maybe<Scalars['numeric']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  energy_size_mw?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  includes_pre_existing?: Maybe<Scalars['Boolean']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  total_upgrade_costs_usd?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "external_api_capacity_costs" */
export type External_Api_Capacity_CostsSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "external_api_capacity_costs" */
export type External_Api_Capacity_CostsSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

export type External_Api_Capacity_Costs_Aggregate = {
  __typename?: 'external_api_capacity_costs_aggregate';
  aggregate?: Maybe<External_Api_Capacity_Costs_Aggregate_Fields>;
  nodes: Array<External_Api_Capacity_Costs>;
};

/** aggregate fields of "external_api_capacity_costs" */
export type External_Api_Capacity_Costs_Aggregate_Fields = {
  __typename?: 'external_api_capacity_costs_aggregate_fields';
  avg?: Maybe<External_Api_Capacity_Costs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<External_Api_Capacity_Costs_Max_Fields>;
  min?: Maybe<External_Api_Capacity_Costs_Min_Fields>;
  stddev?: Maybe<External_Api_Capacity_Costs_Stddev_Fields>;
  stddev_pop?: Maybe<External_Api_Capacity_Costs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<External_Api_Capacity_Costs_Stddev_Samp_Fields>;
  sum?: Maybe<External_Api_Capacity_Costs_Sum_Fields>;
  var_pop?: Maybe<External_Api_Capacity_Costs_Var_Pop_Fields>;
  var_samp?: Maybe<External_Api_Capacity_Costs_Var_Samp_Fields>;
  variance?: Maybe<External_Api_Capacity_Costs_Variance_Fields>;
};


/** aggregate fields of "external_api_capacity_costs" */
export type External_Api_Capacity_Costs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type External_Api_Capacity_Costs_Avg_Fields = {
  __typename?: 'external_api_capacity_costs_avg_fields';
  capacity_size_mw?: Maybe<Scalars['Float']['output']>;
  charging_size_mw?: Maybe<Scalars['Float']['output']>;
  energy_size_mw?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_api_capacity_costs". All fields are combined with a logical 'AND'. */
export type External_Api_Capacity_Costs_Bool_Exp = {
  _and?: InputMaybe<Array<External_Api_Capacity_Costs_Bool_Exp>>;
  _not?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
  _or?: InputMaybe<Array<External_Api_Capacity_Costs_Bool_Exp>>;
  bus_id?: InputMaybe<String_Comparison_Exp>;
  capacity_size_mw?: InputMaybe<Numeric_Comparison_Exp>;
  charging_size_mw?: InputMaybe<Numeric_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  energy_size_mw?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  includes_pre_existing?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  total_upgrade_costs_usd?: InputMaybe<Numeric_Comparison_Exp>;
  upgrade_costs_usd?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type External_Api_Capacity_Costs_Max_Fields = {
  __typename?: 'external_api_capacity_costs_max_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  capacity_size_mw?: Maybe<Scalars['numeric']['output']>;
  charging_size_mw?: Maybe<Scalars['numeric']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  energy_size_mw?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type External_Api_Capacity_Costs_Min_Fields = {
  __typename?: 'external_api_capacity_costs_min_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  capacity_size_mw?: Maybe<Scalars['numeric']['output']>;
  charging_size_mw?: Maybe<Scalars['numeric']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  energy_size_mw?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "external_api_capacity_costs". */
export type External_Api_Capacity_Costs_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  capacity_size_mw?: InputMaybe<Order_By>;
  charging_size_mw?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  energy_size_mw?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  includes_pre_existing?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  total_upgrade_costs_usd?: InputMaybe<Order_By>;
  upgrade_costs_usd?: InputMaybe<Order_By>;
};

export type External_Api_Capacity_Costs_Page_Args = {
  after?: InputMaybe<Scalars['uuid']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['uuid']['input']>;
};

/** select columns of table "external_api_capacity_costs" */
export enum External_Api_Capacity_Costs_Select_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  CapacitySizeMw = 'capacity_size_mw',
  /** column name */
  ChargingSizeMw = 'charging_size_mw',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  EnergySizeMw = 'energy_size_mw',
  /** column name */
  Id = 'id',
  /** column name */
  IncludesPreExisting = 'includes_pre_existing',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  TotalUpgradeCostsUsd = 'total_upgrade_costs_usd',
  /** column name */
  UpgradeCostsUsd = 'upgrade_costs_usd'
}

/** aggregate stddev on columns */
export type External_Api_Capacity_Costs_Stddev_Fields = {
  __typename?: 'external_api_capacity_costs_stddev_fields';
  capacity_size_mw?: Maybe<Scalars['Float']['output']>;
  charging_size_mw?: Maybe<Scalars['Float']['output']>;
  energy_size_mw?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type External_Api_Capacity_Costs_Stddev_Pop_Fields = {
  __typename?: 'external_api_capacity_costs_stddev_pop_fields';
  capacity_size_mw?: Maybe<Scalars['Float']['output']>;
  charging_size_mw?: Maybe<Scalars['Float']['output']>;
  energy_size_mw?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type External_Api_Capacity_Costs_Stddev_Samp_Fields = {
  __typename?: 'external_api_capacity_costs_stddev_samp_fields';
  capacity_size_mw?: Maybe<Scalars['Float']['output']>;
  charging_size_mw?: Maybe<Scalars['Float']['output']>;
  energy_size_mw?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "external_api_capacity_costs" */
export type External_Api_Capacity_Costs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Api_Capacity_Costs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Api_Capacity_Costs_Stream_Cursor_Value_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  capacity_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  charging_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  energy_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  total_upgrade_costs_usd?: InputMaybe<Scalars['numeric']['input']>;
  upgrade_costs_usd?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type External_Api_Capacity_Costs_Sum_Fields = {
  __typename?: 'external_api_capacity_costs_sum_fields';
  capacity_size_mw?: Maybe<Scalars['numeric']['output']>;
  charging_size_mw?: Maybe<Scalars['numeric']['output']>;
  energy_size_mw?: Maybe<Scalars['numeric']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type External_Api_Capacity_Costs_Var_Pop_Fields = {
  __typename?: 'external_api_capacity_costs_var_pop_fields';
  capacity_size_mw?: Maybe<Scalars['Float']['output']>;
  charging_size_mw?: Maybe<Scalars['Float']['output']>;
  energy_size_mw?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type External_Api_Capacity_Costs_Var_Samp_Fields = {
  __typename?: 'external_api_capacity_costs_var_samp_fields';
  capacity_size_mw?: Maybe<Scalars['Float']['output']>;
  charging_size_mw?: Maybe<Scalars['Float']['output']>;
  energy_size_mw?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type External_Api_Capacity_Costs_Variance_Fields = {
  __typename?: 'external_api_capacity_costs_variance_fields';
  capacity_size_mw?: Maybe<Scalars['Float']['output']>;
  charging_size_mw?: Maybe<Scalars['Float']['output']>;
  energy_size_mw?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
  upgrade_costs_usd?: Maybe<Scalars['Float']['output']>;
};

export type External_Api_Constraint_Args = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "external_api_constraints" */
export type External_Api_Constraints = {
  __typename?: 'external_api_constraints';
  bus_id?: Maybe<Scalars['String']['output']>;
  contingency?: Maybe<Scalars['String']['output']>;
  contingency_type?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  estimated_cost_usd?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  injection_threshold_mw?: Maybe<Scalars['numeric']['output']>;
  is_pre_existing?: Maybe<Scalars['Boolean']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  rating_mva?: Maybe<Scalars['numeric']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
};


/** columns and relationships of "external_api_constraints" */
export type External_Api_ConstraintsSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "external_api_constraints" */
export type External_Api_ConstraintsSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

export type External_Api_Constraints_Aggregate = {
  __typename?: 'external_api_constraints_aggregate';
  aggregate?: Maybe<External_Api_Constraints_Aggregate_Fields>;
  nodes: Array<External_Api_Constraints>;
};

/** aggregate fields of "external_api_constraints" */
export type External_Api_Constraints_Aggregate_Fields = {
  __typename?: 'external_api_constraints_aggregate_fields';
  avg?: Maybe<External_Api_Constraints_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<External_Api_Constraints_Max_Fields>;
  min?: Maybe<External_Api_Constraints_Min_Fields>;
  stddev?: Maybe<External_Api_Constraints_Stddev_Fields>;
  stddev_pop?: Maybe<External_Api_Constraints_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<External_Api_Constraints_Stddev_Samp_Fields>;
  sum?: Maybe<External_Api_Constraints_Sum_Fields>;
  var_pop?: Maybe<External_Api_Constraints_Var_Pop_Fields>;
  var_samp?: Maybe<External_Api_Constraints_Var_Samp_Fields>;
  variance?: Maybe<External_Api_Constraints_Variance_Fields>;
};


/** aggregate fields of "external_api_constraints" */
export type External_Api_Constraints_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type External_Api_Constraints_Avg_Fields = {
  __typename?: 'external_api_constraints_avg_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost_usd?: Maybe<Scalars['Float']['output']>;
  injection_threshold_mw?: Maybe<Scalars['Float']['output']>;
  rating_mva?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_api_constraints". All fields are combined with a logical 'AND'. */
export type External_Api_Constraints_Bool_Exp = {
  _and?: InputMaybe<Array<External_Api_Constraints_Bool_Exp>>;
  _not?: InputMaybe<External_Api_Constraints_Bool_Exp>;
  _or?: InputMaybe<Array<External_Api_Constraints_Bool_Exp>>;
  bus_id?: InputMaybe<String_Comparison_Exp>;
  contingency?: InputMaybe<String_Comparison_Exp>;
  contingency_type?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  dfax?: InputMaybe<Numeric_Comparison_Exp>;
  element_type?: InputMaybe<String_Comparison_Exp>;
  estimated_cost_usd?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  injection_threshold_mw?: InputMaybe<Numeric_Comparison_Exp>;
  is_pre_existing?: InputMaybe<Boolean_Comparison_Exp>;
  monitored_facility_id?: InputMaybe<String_Comparison_Exp>;
  monitored_facility_name?: InputMaybe<String_Comparison_Exp>;
  rating_mva?: InputMaybe<Numeric_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type External_Api_Constraints_Max_Fields = {
  __typename?: 'external_api_constraints_max_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  contingency?: Maybe<Scalars['String']['output']>;
  contingency_type?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  estimated_cost_usd?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  injection_threshold_mw?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  rating_mva?: Maybe<Scalars['numeric']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type External_Api_Constraints_Min_Fields = {
  __typename?: 'external_api_constraints_min_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  contingency?: Maybe<Scalars['String']['output']>;
  contingency_type?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  estimated_cost_usd?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  injection_threshold_mw?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  rating_mva?: Maybe<Scalars['numeric']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_api_constraints". */
export type External_Api_Constraints_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  contingency?: InputMaybe<Order_By>;
  contingency_type?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  estimated_cost_usd?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  injection_threshold_mw?: InputMaybe<Order_By>;
  is_pre_existing?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  rating_mva?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
};

export type External_Api_Constraints_Page_Args = {
  after?: InputMaybe<Scalars['uuid']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['uuid']['input']>;
};

/** select columns of table "external_api_constraints" */
export enum External_Api_Constraints_Select_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  Contingency = 'contingency',
  /** column name */
  ContingencyType = 'contingency_type',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  ElementType = 'element_type',
  /** column name */
  EstimatedCostUsd = 'estimated_cost_usd',
  /** column name */
  Id = 'id',
  /** column name */
  InjectionThresholdMw = 'injection_threshold_mw',
  /** column name */
  IsPreExisting = 'is_pre_existing',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  RatingMva = 'rating_mva',
  /** column name */
  Region = 'region',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view'
}

/** aggregate stddev on columns */
export type External_Api_Constraints_Stddev_Fields = {
  __typename?: 'external_api_constraints_stddev_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost_usd?: Maybe<Scalars['Float']['output']>;
  injection_threshold_mw?: Maybe<Scalars['Float']['output']>;
  rating_mva?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type External_Api_Constraints_Stddev_Pop_Fields = {
  __typename?: 'external_api_constraints_stddev_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost_usd?: Maybe<Scalars['Float']['output']>;
  injection_threshold_mw?: Maybe<Scalars['Float']['output']>;
  rating_mva?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type External_Api_Constraints_Stddev_Samp_Fields = {
  __typename?: 'external_api_constraints_stddev_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost_usd?: Maybe<Scalars['Float']['output']>;
  injection_threshold_mw?: Maybe<Scalars['Float']['output']>;
  rating_mva?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "external_api_constraints" */
export type External_Api_Constraints_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Api_Constraints_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Api_Constraints_Stream_Cursor_Value_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  contingency?: InputMaybe<Scalars['String']['input']>;
  contingency_type?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  estimated_cost_usd?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  injection_threshold_mw?: InputMaybe<Scalars['numeric']['input']>;
  is_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  rating_mva?: InputMaybe<Scalars['numeric']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type External_Api_Constraints_Sum_Fields = {
  __typename?: 'external_api_constraints_sum_fields';
  dfax?: Maybe<Scalars['numeric']['output']>;
  estimated_cost_usd?: Maybe<Scalars['numeric']['output']>;
  injection_threshold_mw?: Maybe<Scalars['numeric']['output']>;
  rating_mva?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type External_Api_Constraints_Var_Pop_Fields = {
  __typename?: 'external_api_constraints_var_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost_usd?: Maybe<Scalars['Float']['output']>;
  injection_threshold_mw?: Maybe<Scalars['Float']['output']>;
  rating_mva?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type External_Api_Constraints_Var_Samp_Fields = {
  __typename?: 'external_api_constraints_var_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost_usd?: Maybe<Scalars['Float']['output']>;
  injection_threshold_mw?: Maybe<Scalars['Float']['output']>;
  rating_mva?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type External_Api_Constraints_Variance_Fields = {
  __typename?: 'external_api_constraints_variance_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost_usd?: Maybe<Scalars['Float']['output']>;
  injection_threshold_mw?: Maybe<Scalars['Float']['output']>;
  rating_mva?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "external_api_scopes" */
export type External_Api_Scopes = {
  __typename?: 'external_api_scopes';
  data_freshness_date?: Maybe<Scalars['date']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_views?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
};


/** columns and relationships of "external_api_scopes" */
export type External_Api_ScopesScope_ViewsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "external_api_scopes" */
export type External_Api_ScopesSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "external_api_scopes" */
export type External_Api_ScopesSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** aggregated selection of "external_api_scopes" */
export type External_Api_Scopes_Aggregate = {
  __typename?: 'external_api_scopes_aggregate';
  aggregate?: Maybe<External_Api_Scopes_Aggregate_Fields>;
  nodes: Array<External_Api_Scopes>;
};

/** aggregate fields of "external_api_scopes" */
export type External_Api_Scopes_Aggregate_Fields = {
  __typename?: 'external_api_scopes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<External_Api_Scopes_Max_Fields>;
  min?: Maybe<External_Api_Scopes_Min_Fields>;
};


/** aggregate fields of "external_api_scopes" */
export type External_Api_Scopes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Api_Scopes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type External_Api_Scopes_Append_Input = {
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "external_api_scopes". All fields are combined with a logical 'AND'. */
export type External_Api_Scopes_Bool_Exp = {
  _and?: InputMaybe<Array<External_Api_Scopes_Bool_Exp>>;
  _not?: InputMaybe<External_Api_Scopes_Bool_Exp>;
  _or?: InputMaybe<Array<External_Api_Scopes_Bool_Exp>>;
  data_freshness_date?: InputMaybe<Date_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_views?: InputMaybe<Jsonb_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type External_Api_Scopes_Delete_At_Path_Input = {
  scope_views?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type External_Api_Scopes_Delete_Elem_Input = {
  scope_views?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type External_Api_Scopes_Delete_Key_Input = {
  scope_views?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "external_api_scopes" */
export type External_Api_Scopes_Insert_Input = {
  data_freshness_date?: InputMaybe<Scalars['date']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
  subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
};

export type External_Api_Scopes_List_Args = {
  region?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type External_Api_Scopes_Max_Fields = {
  __typename?: 'external_api_scopes_max_fields';
  data_freshness_date?: Maybe<Scalars['date']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type External_Api_Scopes_Min_Fields = {
  __typename?: 'external_api_scopes_min_fields';
  data_freshness_date?: Maybe<Scalars['date']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "external_api_scopes" */
export type External_Api_Scopes_Mutation_Response = {
  __typename?: 'external_api_scopes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<External_Api_Scopes>;
};

/** Ordering options when selecting data from "external_api_scopes". */
export type External_Api_Scopes_Order_By = {
  data_freshness_date?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_views?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type External_Api_Scopes_Prepend_Input = {
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "external_api_scopes" */
export enum External_Api_Scopes_Select_Column {
  /** column name */
  DataFreshnessDate = 'data_freshness_date',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeViews = 'scope_views'
}

/** input type for updating data in table "external_api_scopes" */
export type External_Api_Scopes_Set_Input = {
  data_freshness_date?: InputMaybe<Scalars['date']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "external_api_scopes" */
export type External_Api_Scopes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Api_Scopes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Api_Scopes_Stream_Cursor_Value_Input = {
  data_freshness_date?: InputMaybe<Scalars['date']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
};

export type External_Api_Scopes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<External_Api_Scopes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<External_Api_Scopes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<External_Api_Scopes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<External_Api_Scopes_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<External_Api_Scopes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<External_Api_Scopes_Set_Input>;
  /** filter the rows which have to be updated */
  where: External_Api_Scopes_Bool_Exp;
};

/** columns and relationships of "favorite_buses" */
export type Favorite_Buses = {
  __typename?: 'favorite_buses';
  auth0_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  nira_bus_id: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "favorite_buses" */
export type Favorite_Buses_Aggregate = {
  __typename?: 'favorite_buses_aggregate';
  aggregate?: Maybe<Favorite_Buses_Aggregate_Fields>;
  nodes: Array<Favorite_Buses>;
};

/** aggregate fields of "favorite_buses" */
export type Favorite_Buses_Aggregate_Fields = {
  __typename?: 'favorite_buses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Favorite_Buses_Max_Fields>;
  min?: Maybe<Favorite_Buses_Min_Fields>;
};


/** aggregate fields of "favorite_buses" */
export type Favorite_Buses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Favorite_Buses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "favorite_buses". All fields are combined with a logical 'AND'. */
export type Favorite_Buses_Bool_Exp = {
  _and?: InputMaybe<Array<Favorite_Buses_Bool_Exp>>;
  _not?: InputMaybe<Favorite_Buses_Bool_Exp>;
  _or?: InputMaybe<Array<Favorite_Buses_Bool_Exp>>;
  auth0_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "favorite_buses" */
export enum Favorite_Buses_Constraint {
  /** unique or primary key constraint on columns "nira_bus_id", "auth0_id" */
  FavoriteBusesAuth0IdNiraBusIdKey = 'favorite_buses_auth0_id_nira_bus_id_key',
  /** unique or primary key constraint on columns "id" */
  FavoriteBusesPkey = 'favorite_buses_pkey'
}

/** input type for inserting data into table "favorite_buses" */
export type Favorite_Buses_Insert_Input = {
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Favorite_Buses_Max_Fields = {
  __typename?: 'favorite_buses_max_fields';
  auth0_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Favorite_Buses_Min_Fields = {
  __typename?: 'favorite_buses_min_fields';
  auth0_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "favorite_buses" */
export type Favorite_Buses_Mutation_Response = {
  __typename?: 'favorite_buses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Favorite_Buses>;
};

/** on_conflict condition type for table "favorite_buses" */
export type Favorite_Buses_On_Conflict = {
  constraint: Favorite_Buses_Constraint;
  update_columns?: Array<Favorite_Buses_Update_Column>;
  where?: InputMaybe<Favorite_Buses_Bool_Exp>;
};

/** Ordering options when selecting data from "favorite_buses". */
export type Favorite_Buses_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: favorite_buses */
export type Favorite_Buses_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "favorite_buses" */
export enum Favorite_Buses_Select_Column {
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NiraBusId = 'nira_bus_id'
}

/** input type for updating data in table "favorite_buses" */
export type Favorite_Buses_Set_Input = {
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "favorite_buses" */
export type Favorite_Buses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Favorite_Buses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Favorite_Buses_Stream_Cursor_Value_Input = {
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "favorite_buses" */
export enum Favorite_Buses_Update_Column {
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NiraBusId = 'nira_bus_id'
}

export type Favorite_Buses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Favorite_Buses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Favorite_Buses_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "gtc_exposure" */
export type Gtc_Exposure = {
  __typename?: 'gtc_exposure';
  base_dfax?: Maybe<Scalars['float8']['output']>;
  base_net_dfax?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  bus?: Maybe<Buses>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  element_type: Scalars['String']['output'];
  /** Impact tier (low / medium / high / very_high) for this row, derived from the hidden base-case shift factor (pedestal-net for treated pocket GTCs, otherwise full). NULL below the serving floor. */
  impact_tier?: Maybe<Scalars['String']['output']>;
  interface_acronym: Scalars['String']['output'];
  monitored_facility_name: Scalars['String']['output'];
  n_contingencies: Scalars['Int']['output'];
  nira_bus_id: Scalars['String']['output'];
  region: Scalars['String']['output'];
  source_case: Scalars['String']['output'];
  worst_harm_contingency: Scalars['String']['output'];
  worst_harm_dfax: Scalars['float8']['output'];
  worst_harm_net_dfax?: Maybe<Scalars['float8']['output']>;
};

/** aggregated selection of "gtc_exposure" */
export type Gtc_Exposure_Aggregate = {
  __typename?: 'gtc_exposure_aggregate';
  aggregate?: Maybe<Gtc_Exposure_Aggregate_Fields>;
  nodes: Array<Gtc_Exposure>;
};

/** aggregate fields of "gtc_exposure" */
export type Gtc_Exposure_Aggregate_Fields = {
  __typename?: 'gtc_exposure_aggregate_fields';
  avg?: Maybe<Gtc_Exposure_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Gtc_Exposure_Max_Fields>;
  min?: Maybe<Gtc_Exposure_Min_Fields>;
  stddev?: Maybe<Gtc_Exposure_Stddev_Fields>;
  stddev_pop?: Maybe<Gtc_Exposure_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Gtc_Exposure_Stddev_Samp_Fields>;
  sum?: Maybe<Gtc_Exposure_Sum_Fields>;
  var_pop?: Maybe<Gtc_Exposure_Var_Pop_Fields>;
  var_samp?: Maybe<Gtc_Exposure_Var_Samp_Fields>;
  variance?: Maybe<Gtc_Exposure_Variance_Fields>;
};


/** aggregate fields of "gtc_exposure" */
export type Gtc_Exposure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gtc_Exposure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Gtc_Exposure_Avg_Fields = {
  __typename?: 'gtc_exposure_avg_fields';
  base_dfax?: Maybe<Scalars['Float']['output']>;
  base_net_dfax?: Maybe<Scalars['Float']['output']>;
  n_contingencies?: Maybe<Scalars['Float']['output']>;
  worst_harm_dfax?: Maybe<Scalars['Float']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "gtc_exposure". All fields are combined with a logical 'AND'. */
export type Gtc_Exposure_Bool_Exp = {
  _and?: InputMaybe<Array<Gtc_Exposure_Bool_Exp>>;
  _not?: InputMaybe<Gtc_Exposure_Bool_Exp>;
  _or?: InputMaybe<Array<Gtc_Exposure_Bool_Exp>>;
  base_dfax?: InputMaybe<Float8_Comparison_Exp>;
  base_net_dfax?: InputMaybe<Float8_Comparison_Exp>;
  bus?: InputMaybe<Buses_Bool_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  element_type?: InputMaybe<String_Comparison_Exp>;
  impact_tier?: InputMaybe<String_Comparison_Exp>;
  interface_acronym?: InputMaybe<String_Comparison_Exp>;
  monitored_facility_name?: InputMaybe<String_Comparison_Exp>;
  n_contingencies?: InputMaybe<Int_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  source_case?: InputMaybe<String_Comparison_Exp>;
  worst_harm_contingency?: InputMaybe<String_Comparison_Exp>;
  worst_harm_dfax?: InputMaybe<Float8_Comparison_Exp>;
  worst_harm_net_dfax?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "gtc_exposure" */
export enum Gtc_Exposure_Constraint {
  /** unique or primary key constraint on columns "nira_bus_id", "region", "interface_acronym", "source_case" */
  GtcExposurePkey = 'gtc_exposure_pkey'
}

/** input type for incrementing numeric columns in table "gtc_exposure" */
export type Gtc_Exposure_Inc_Input = {
  base_dfax?: InputMaybe<Scalars['float8']['input']>;
  base_net_dfax?: InputMaybe<Scalars['float8']['input']>;
  n_contingencies?: InputMaybe<Scalars['Int']['input']>;
  worst_harm_dfax?: InputMaybe<Scalars['float8']['input']>;
  worst_harm_net_dfax?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "gtc_exposure" */
export type Gtc_Exposure_Insert_Input = {
  base_dfax?: InputMaybe<Scalars['float8']['input']>;
  base_net_dfax?: InputMaybe<Scalars['float8']['input']>;
  bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  interface_acronym?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  n_contingencies?: InputMaybe<Scalars['Int']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  source_case?: InputMaybe<Scalars['String']['input']>;
  worst_harm_contingency?: InputMaybe<Scalars['String']['input']>;
  worst_harm_dfax?: InputMaybe<Scalars['float8']['input']>;
  worst_harm_net_dfax?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type Gtc_Exposure_Max_Fields = {
  __typename?: 'gtc_exposure_max_fields';
  base_dfax?: Maybe<Scalars['float8']['output']>;
  base_net_dfax?: Maybe<Scalars['float8']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  /** Impact tier (low / medium / high / very_high) for this row, derived from the hidden base-case shift factor (pedestal-net for treated pocket GTCs, otherwise full). NULL below the serving floor. */
  impact_tier?: Maybe<Scalars['String']['output']>;
  interface_acronym?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  n_contingencies?: Maybe<Scalars['Int']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  source_case?: Maybe<Scalars['String']['output']>;
  worst_harm_contingency?: Maybe<Scalars['String']['output']>;
  worst_harm_dfax?: Maybe<Scalars['float8']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Gtc_Exposure_Min_Fields = {
  __typename?: 'gtc_exposure_min_fields';
  base_dfax?: Maybe<Scalars['float8']['output']>;
  base_net_dfax?: Maybe<Scalars['float8']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  /** Impact tier (low / medium / high / very_high) for this row, derived from the hidden base-case shift factor (pedestal-net for treated pocket GTCs, otherwise full). NULL below the serving floor. */
  impact_tier?: Maybe<Scalars['String']['output']>;
  interface_acronym?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  n_contingencies?: Maybe<Scalars['Int']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  source_case?: Maybe<Scalars['String']['output']>;
  worst_harm_contingency?: Maybe<Scalars['String']['output']>;
  worst_harm_dfax?: Maybe<Scalars['float8']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['float8']['output']>;
};

/** response of any mutation on the table "gtc_exposure" */
export type Gtc_Exposure_Mutation_Response = {
  __typename?: 'gtc_exposure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Gtc_Exposure>;
};

/** on_conflict condition type for table "gtc_exposure" */
export type Gtc_Exposure_On_Conflict = {
  constraint: Gtc_Exposure_Constraint;
  update_columns?: Array<Gtc_Exposure_Update_Column>;
  where?: InputMaybe<Gtc_Exposure_Bool_Exp>;
};

/** Ordering options when selecting data from "gtc_exposure". */
export type Gtc_Exposure_Order_By = {
  base_dfax?: InputMaybe<Order_By>;
  base_net_dfax?: InputMaybe<Order_By>;
  bus?: InputMaybe<Buses_Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  impact_tier?: InputMaybe<Order_By>;
  interface_acronym?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  n_contingencies?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  source_case?: InputMaybe<Order_By>;
  worst_harm_contingency?: InputMaybe<Order_By>;
  worst_harm_dfax?: InputMaybe<Order_By>;
  worst_harm_net_dfax?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gtc_exposure */
export type Gtc_Exposure_Pk_Columns_Input = {
  interface_acronym: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  region: Scalars['String']['input'];
  source_case: Scalars['String']['input'];
};

/** select columns of table "gtc_exposure" */
export enum Gtc_Exposure_Select_Column {
  /** column name */
  BaseDfax = 'base_dfax',
  /** column name */
  BaseNetDfax = 'base_net_dfax',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  ElementType = 'element_type',
  /** column name */
  InterfaceAcronym = 'interface_acronym',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  NContingencies = 'n_contingencies',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Region = 'region',
  /** column name */
  SourceCase = 'source_case',
  /** column name */
  WorstHarmContingency = 'worst_harm_contingency',
  /** column name */
  WorstHarmDfax = 'worst_harm_dfax',
  /** column name */
  WorstHarmNetDfax = 'worst_harm_net_dfax'
}

/** input type for updating data in table "gtc_exposure" */
export type Gtc_Exposure_Set_Input = {
  base_dfax?: InputMaybe<Scalars['float8']['input']>;
  base_net_dfax?: InputMaybe<Scalars['float8']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  interface_acronym?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  n_contingencies?: InputMaybe<Scalars['Int']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  source_case?: InputMaybe<Scalars['String']['input']>;
  worst_harm_contingency?: InputMaybe<Scalars['String']['input']>;
  worst_harm_dfax?: InputMaybe<Scalars['float8']['input']>;
  worst_harm_net_dfax?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type Gtc_Exposure_Stddev_Fields = {
  __typename?: 'gtc_exposure_stddev_fields';
  base_dfax?: Maybe<Scalars['Float']['output']>;
  base_net_dfax?: Maybe<Scalars['Float']['output']>;
  n_contingencies?: Maybe<Scalars['Float']['output']>;
  worst_harm_dfax?: Maybe<Scalars['Float']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Gtc_Exposure_Stddev_Pop_Fields = {
  __typename?: 'gtc_exposure_stddev_pop_fields';
  base_dfax?: Maybe<Scalars['Float']['output']>;
  base_net_dfax?: Maybe<Scalars['Float']['output']>;
  n_contingencies?: Maybe<Scalars['Float']['output']>;
  worst_harm_dfax?: Maybe<Scalars['Float']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Gtc_Exposure_Stddev_Samp_Fields = {
  __typename?: 'gtc_exposure_stddev_samp_fields';
  base_dfax?: Maybe<Scalars['Float']['output']>;
  base_net_dfax?: Maybe<Scalars['Float']['output']>;
  n_contingencies?: Maybe<Scalars['Float']['output']>;
  worst_harm_dfax?: Maybe<Scalars['Float']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "gtc_exposure" */
export type Gtc_Exposure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gtc_Exposure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gtc_Exposure_Stream_Cursor_Value_Input = {
  base_dfax?: InputMaybe<Scalars['float8']['input']>;
  base_net_dfax?: InputMaybe<Scalars['float8']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  interface_acronym?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  n_contingencies?: InputMaybe<Scalars['Int']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  source_case?: InputMaybe<Scalars['String']['input']>;
  worst_harm_contingency?: InputMaybe<Scalars['String']['input']>;
  worst_harm_dfax?: InputMaybe<Scalars['float8']['input']>;
  worst_harm_net_dfax?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Gtc_Exposure_Sum_Fields = {
  __typename?: 'gtc_exposure_sum_fields';
  base_dfax?: Maybe<Scalars['float8']['output']>;
  base_net_dfax?: Maybe<Scalars['float8']['output']>;
  n_contingencies?: Maybe<Scalars['Int']['output']>;
  worst_harm_dfax?: Maybe<Scalars['float8']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "gtc_exposure" */
export enum Gtc_Exposure_Update_Column {
  /** column name */
  BaseDfax = 'base_dfax',
  /** column name */
  BaseNetDfax = 'base_net_dfax',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  ElementType = 'element_type',
  /** column name */
  InterfaceAcronym = 'interface_acronym',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  NContingencies = 'n_contingencies',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Region = 'region',
  /** column name */
  SourceCase = 'source_case',
  /** column name */
  WorstHarmContingency = 'worst_harm_contingency',
  /** column name */
  WorstHarmDfax = 'worst_harm_dfax',
  /** column name */
  WorstHarmNetDfax = 'worst_harm_net_dfax'
}

export type Gtc_Exposure_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Gtc_Exposure_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gtc_Exposure_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gtc_Exposure_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Gtc_Exposure_Var_Pop_Fields = {
  __typename?: 'gtc_exposure_var_pop_fields';
  base_dfax?: Maybe<Scalars['Float']['output']>;
  base_net_dfax?: Maybe<Scalars['Float']['output']>;
  n_contingencies?: Maybe<Scalars['Float']['output']>;
  worst_harm_dfax?: Maybe<Scalars['Float']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Gtc_Exposure_Var_Samp_Fields = {
  __typename?: 'gtc_exposure_var_samp_fields';
  base_dfax?: Maybe<Scalars['Float']['output']>;
  base_net_dfax?: Maybe<Scalars['Float']['output']>;
  n_contingencies?: Maybe<Scalars['Float']['output']>;
  worst_harm_dfax?: Maybe<Scalars['Float']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Gtc_Exposure_Variance_Fields = {
  __typename?: 'gtc_exposure_variance_fields';
  base_dfax?: Maybe<Scalars['Float']['output']>;
  base_net_dfax?: Maybe<Scalars['Float']['output']>;
  n_contingencies?: Maybe<Scalars['Float']['output']>;
  worst_harm_dfax?: Maybe<Scalars['Float']['output']>;
  worst_harm_net_dfax?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "in_queue_cluster_model_set_statuses" */
export type In_Queue_Cluster_Model_Set_Statuses = {
  __typename?: 'in_queue_cluster_model_set_statuses';
  description: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** aggregated selection of "in_queue_cluster_model_set_statuses" */
export type In_Queue_Cluster_Model_Set_Statuses_Aggregate = {
  __typename?: 'in_queue_cluster_model_set_statuses_aggregate';
  aggregate?: Maybe<In_Queue_Cluster_Model_Set_Statuses_Aggregate_Fields>;
  nodes: Array<In_Queue_Cluster_Model_Set_Statuses>;
};

/** aggregate fields of "in_queue_cluster_model_set_statuses" */
export type In_Queue_Cluster_Model_Set_Statuses_Aggregate_Fields = {
  __typename?: 'in_queue_cluster_model_set_statuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Cluster_Model_Set_Statuses_Max_Fields>;
  min?: Maybe<In_Queue_Cluster_Model_Set_Statuses_Min_Fields>;
};


/** aggregate fields of "in_queue_cluster_model_set_statuses" */
export type In_Queue_Cluster_Model_Set_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "in_queue_cluster_model_set_statuses". All fields are combined with a logical 'AND'. */
export type In_Queue_Cluster_Model_Set_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_queue_cluster_model_set_statuses" */
export enum In_Queue_Cluster_Model_Set_Statuses_Constraint {
  /** unique or primary key constraint on columns "status" */
  InQueueClusterModelSetStatusesPkey = 'in_queue_cluster_model_set_statuses_pkey'
}

export enum In_Queue_Cluster_Model_Set_Statuses_Enum {
  /** Model set is no longer in use */
  Archived = 'ARCHIVED',
  /** Model set is the current set used for the base scenario of the cluster (at most one per cluster) */
  Current = 'CURRENT',
  /** Model set is being prepared and is not yet available for use */
  Draft = 'DRAFT',
  /** Model set is available for use but is not the current model set for the cluster */
  Superseded = 'SUPERSEDED'
}

/** Boolean expression to compare columns of type "in_queue_cluster_model_set_statuses_enum". All fields are combined with logical 'AND'. */
export type In_Queue_Cluster_Model_Set_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Enum>;
  _in?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Enum>;
  _nin?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Enum>>;
};

/** input type for inserting data into table "in_queue_cluster_model_set_statuses" */
export type In_Queue_Cluster_Model_Set_Statuses_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type In_Queue_Cluster_Model_Set_Statuses_Max_Fields = {
  __typename?: 'in_queue_cluster_model_set_statuses_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type In_Queue_Cluster_Model_Set_Statuses_Min_Fields = {
  __typename?: 'in_queue_cluster_model_set_statuses_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "in_queue_cluster_model_set_statuses" */
export type In_Queue_Cluster_Model_Set_Statuses_Mutation_Response = {
  __typename?: 'in_queue_cluster_model_set_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Cluster_Model_Set_Statuses>;
};

/** on_conflict condition type for table "in_queue_cluster_model_set_statuses" */
export type In_Queue_Cluster_Model_Set_Statuses_On_Conflict = {
  constraint: In_Queue_Cluster_Model_Set_Statuses_Constraint;
  update_columns?: Array<In_Queue_Cluster_Model_Set_Statuses_Update_Column>;
  where?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_cluster_model_set_statuses". */
export type In_Queue_Cluster_Model_Set_Statuses_Order_By = {
  description?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_queue_cluster_model_set_statuses */
export type In_Queue_Cluster_Model_Set_Statuses_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "in_queue_cluster_model_set_statuses" */
export enum In_Queue_Cluster_Model_Set_Statuses_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "in_queue_cluster_model_set_statuses" */
export type In_Queue_Cluster_Model_Set_Statuses_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "in_queue_cluster_model_set_statuses" */
export type In_Queue_Cluster_Model_Set_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Cluster_Model_Set_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Cluster_Model_Set_Statuses_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "in_queue_cluster_model_set_statuses" */
export enum In_Queue_Cluster_Model_Set_Statuses_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type In_Queue_Cluster_Model_Set_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Cluster_Model_Set_Statuses_Bool_Exp;
};

/** columns and relationships of "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets = {
  __typename?: 'in_queue_cluster_model_sets';
  /** An object relationship */
  cluster: In_Queue_Clusters;
  cluster_id: Scalars['uuid']['output'];
  /** An array relationship */
  connection_points: Array<Queue_Project_Connection_Points>;
  /** An aggregate relationship */
  connection_points_aggregate: Queue_Project_Connection_Points_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  iq_model_set_id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  scenario_stage: Scalars['String']['output'];
  status: In_Queue_Cluster_Model_Set_Statuses_Enum;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_SetsConnection_PointsArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Points_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Points_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
};


/** columns and relationships of "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_SetsConnection_Points_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Points_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Points_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
};

/** aggregated selection of "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Aggregate = {
  __typename?: 'in_queue_cluster_model_sets_aggregate';
  aggregate?: Maybe<In_Queue_Cluster_Model_Sets_Aggregate_Fields>;
  nodes: Array<In_Queue_Cluster_Model_Sets>;
};

export type In_Queue_Cluster_Model_Sets_Aggregate_Bool_Exp = {
  count?: InputMaybe<In_Queue_Cluster_Model_Sets_Aggregate_Bool_Exp_Count>;
};

export type In_Queue_Cluster_Model_Sets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Aggregate_Fields = {
  __typename?: 'in_queue_cluster_model_sets_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Cluster_Model_Sets_Max_Fields>;
  min?: Maybe<In_Queue_Cluster_Model_Sets_Min_Fields>;
};


/** aggregate fields of "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<In_Queue_Cluster_Model_Sets_Max_Order_By>;
  min?: InputMaybe<In_Queue_Cluster_Model_Sets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Arr_Rel_Insert_Input = {
  data: Array<In_Queue_Cluster_Model_Sets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Cluster_Model_Sets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "in_queue_cluster_model_sets". All fields are combined with a logical 'AND'. */
export type In_Queue_Cluster_Model_Sets_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Bool_Exp>>;
  cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  connection_points?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
  connection_points_aggregate?: InputMaybe<Queue_Project_Connection_Points_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  iq_model_set_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  scenario_stage?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_queue_cluster_model_sets" */
export enum In_Queue_Cluster_Model_Sets_Constraint {
  /** unique or primary key constraint on columns "cluster_id", "scenario_stage" */
  InQueueClusterModelSetsClusterDefault = 'in_queue_cluster_model_sets_cluster_default',
  /** unique or primary key constraint on columns "cluster_id", "scenario_stage", "name" */
  InQueueClusterModelSetsClusterStageName = 'in_queue_cluster_model_sets_cluster_stage_name',
  /** unique or primary key constraint on columns "cluster_id", "iq_model_set_id", "scenario_stage" */
  InQueueClusterModelSetsCompositeIdx = 'in_queue_cluster_model_sets_composite_idx',
  /** unique or primary key constraint on columns "id" */
  InQueueClusterModelSetsPkey = 'in_queue_cluster_model_sets_pkey'
}

/** input type for inserting data into table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Insert_Input = {
  cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  connection_points?: InputMaybe<Queue_Project_Connection_Points_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  iq_model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type In_Queue_Cluster_Model_Sets_Max_Fields = {
  __typename?: 'in_queue_cluster_model_sets_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  iq_model_set_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scenario_stage?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Max_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  iq_model_set_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  scenario_stage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type In_Queue_Cluster_Model_Sets_Min_Fields = {
  __typename?: 'in_queue_cluster_model_sets_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  iq_model_set_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scenario_stage?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Min_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  iq_model_set_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  scenario_stage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Mutation_Response = {
  __typename?: 'in_queue_cluster_model_sets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Cluster_Model_Sets>;
};

/** input type for inserting object relation for remote table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Obj_Rel_Insert_Input = {
  data: In_Queue_Cluster_Model_Sets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Cluster_Model_Sets_On_Conflict>;
};

/** on_conflict condition type for table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_On_Conflict = {
  constraint: In_Queue_Cluster_Model_Sets_Constraint;
  update_columns?: Array<In_Queue_Cluster_Model_Sets_Update_Column>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_cluster_model_sets". */
export type In_Queue_Cluster_Model_Sets_Order_By = {
  cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  connection_points_aggregate?: InputMaybe<Queue_Project_Connection_Points_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  iq_model_set_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  scenario_stage?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_queue_cluster_model_sets */
export type In_Queue_Cluster_Model_Sets_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "in_queue_cluster_model_sets" */
export enum In_Queue_Cluster_Model_Sets_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IqModelSetId = 'iq_model_set_id',
  /** column name */
  Name = 'name',
  /** column name */
  ScenarioStage = 'scenario_stage',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Set_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  iq_model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "in_queue_cluster_model_sets" */
export type In_Queue_Cluster_Model_Sets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Cluster_Model_Sets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Cluster_Model_Sets_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  iq_model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "in_queue_cluster_model_sets" */
export enum In_Queue_Cluster_Model_Sets_Update_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IqModelSetId = 'iq_model_set_id',
  /** column name */
  Name = 'name',
  /** column name */
  ScenarioStage = 'scenario_stage',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type In_Queue_Cluster_Model_Sets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Cluster_Model_Sets_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Cluster_Model_Sets_Bool_Exp;
};

/** columns and relationships of "in_queue_cluster_statuses" */
export type In_Queue_Cluster_Statuses = {
  __typename?: 'in_queue_cluster_statuses';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** aggregated selection of "in_queue_cluster_statuses" */
export type In_Queue_Cluster_Statuses_Aggregate = {
  __typename?: 'in_queue_cluster_statuses_aggregate';
  aggregate?: Maybe<In_Queue_Cluster_Statuses_Aggregate_Fields>;
  nodes: Array<In_Queue_Cluster_Statuses>;
};

/** aggregate fields of "in_queue_cluster_statuses" */
export type In_Queue_Cluster_Statuses_Aggregate_Fields = {
  __typename?: 'in_queue_cluster_statuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Cluster_Statuses_Max_Fields>;
  min?: Maybe<In_Queue_Cluster_Statuses_Min_Fields>;
};


/** aggregate fields of "in_queue_cluster_statuses" */
export type In_Queue_Cluster_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Cluster_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "in_queue_cluster_statuses". All fields are combined with a logical 'AND'. */
export type In_Queue_Cluster_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Cluster_Statuses_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Cluster_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Cluster_Statuses_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_queue_cluster_statuses" */
export enum In_Queue_Cluster_Statuses_Constraint {
  /** unique or primary key constraint on columns "name" */
  InQueueClusterStatusesPkey = 'in_queue_cluster_statuses_pkey'
}

export enum In_Queue_Cluster_Statuses_Enum {
  /** Can view preview scenarios and DP scenarios but cannot run any scenarios */
  AfterDp = 'after_dp',
  /** The cluster is inactive */
  AllDisabled = 'all_disabled',
  /** Decision point. Can view preview scenarios but cannot run preview scenarios. Can view and run DP scenarios. */
  DpMode = 'dp_mode',
  /** The cluster is inactive and not viewable to customers */
  Hidden = 'hidden',
  /** Same as dp_mode but cannot view preview scenarios at all */
  OnlyDpMode = 'only_dp_mode',
  /** Can view preview scenarios but cannot run anything */
  PreviewButNoScenarios = 'preview_but_no_scenarios',
  /** Can view and run preview scenarios */
  PreviewMode = 'preview_mode'
}

/** Boolean expression to compare columns of type "in_queue_cluster_statuses_enum". All fields are combined with logical 'AND'. */
export type In_Queue_Cluster_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<In_Queue_Cluster_Statuses_Enum>;
  _in?: InputMaybe<Array<In_Queue_Cluster_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<In_Queue_Cluster_Statuses_Enum>;
  _nin?: InputMaybe<Array<In_Queue_Cluster_Statuses_Enum>>;
};

/** input type for inserting data into table "in_queue_cluster_statuses" */
export type In_Queue_Cluster_Statuses_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type In_Queue_Cluster_Statuses_Max_Fields = {
  __typename?: 'in_queue_cluster_statuses_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type In_Queue_Cluster_Statuses_Min_Fields = {
  __typename?: 'in_queue_cluster_statuses_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "in_queue_cluster_statuses" */
export type In_Queue_Cluster_Statuses_Mutation_Response = {
  __typename?: 'in_queue_cluster_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Cluster_Statuses>;
};

/** on_conflict condition type for table "in_queue_cluster_statuses" */
export type In_Queue_Cluster_Statuses_On_Conflict = {
  constraint: In_Queue_Cluster_Statuses_Constraint;
  update_columns?: Array<In_Queue_Cluster_Statuses_Update_Column>;
  where?: InputMaybe<In_Queue_Cluster_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_cluster_statuses". */
export type In_Queue_Cluster_Statuses_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_queue_cluster_statuses */
export type In_Queue_Cluster_Statuses_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "in_queue_cluster_statuses" */
export enum In_Queue_Cluster_Statuses_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "in_queue_cluster_statuses" */
export type In_Queue_Cluster_Statuses_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "in_queue_cluster_statuses" */
export type In_Queue_Cluster_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Cluster_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Cluster_Statuses_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "in_queue_cluster_statuses" */
export enum In_Queue_Cluster_Statuses_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

export type In_Queue_Cluster_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Cluster_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Cluster_Statuses_Bool_Exp;
};

/** columns and relationships of "in_queue_clusters" */
export type In_Queue_Clusters = {
  __typename?: 'in_queue_clusters';
  /** An object relationship */
  current_sis_report_posting?: Maybe<Cluster_Current_Sis_Report_Posting>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  in_queue_cluster_model_sets: Array<In_Queue_Cluster_Model_Sets>;
  /** An aggregate relationship */
  in_queue_cluster_model_sets_aggregate: In_Queue_Cluster_Model_Sets_Aggregate;
  /** An array relationship */
  in_queue_model_variants: Array<In_Queue_Region_Model_Variants>;
  /** An aggregate relationship */
  in_queue_model_variants_aggregate: In_Queue_Region_Model_Variants_Aggregate;
  region: Scalars['String']['output'];
  /** An array relationship */
  relevant_subscriptions: Array<In_Queue_Subscriptions>;
  /** An aggregate relationship */
  relevant_subscriptions_aggregate: In_Queue_Subscriptions_Aggregate;
  slug: Scalars['String']['output'];
  status: In_Queue_Cluster_Statuses_Enum;
  study_cycle: Scalars['String']['output'];
  study_group: Scalars['String']['output'];
  study_phase: Scalars['String']['output'];
};


/** columns and relationships of "in_queue_clusters" */
export type In_Queue_ClustersIn_Queue_Cluster_Model_SetsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};


/** columns and relationships of "in_queue_clusters" */
export type In_Queue_ClustersIn_Queue_Cluster_Model_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};


/** columns and relationships of "in_queue_clusters" */
export type In_Queue_ClustersIn_Queue_Model_VariantsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Region_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Region_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
};


/** columns and relationships of "in_queue_clusters" */
export type In_Queue_ClustersIn_Queue_Model_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Region_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Region_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
};


/** columns and relationships of "in_queue_clusters" */
export type In_Queue_ClustersRelevant_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscriptions_Order_By>>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "in_queue_clusters" */
export type In_Queue_ClustersRelevant_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscriptions_Order_By>>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};

/** aggregated selection of "in_queue_clusters" */
export type In_Queue_Clusters_Aggregate = {
  __typename?: 'in_queue_clusters_aggregate';
  aggregate?: Maybe<In_Queue_Clusters_Aggregate_Fields>;
  nodes: Array<In_Queue_Clusters>;
};

/** aggregate fields of "in_queue_clusters" */
export type In_Queue_Clusters_Aggregate_Fields = {
  __typename?: 'in_queue_clusters_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Clusters_Max_Fields>;
  min?: Maybe<In_Queue_Clusters_Min_Fields>;
};


/** aggregate fields of "in_queue_clusters" */
export type In_Queue_Clusters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Clusters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "in_queue_clusters". All fields are combined with a logical 'AND'. */
export type In_Queue_Clusters_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Clusters_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Clusters_Bool_Exp>>;
  current_sis_report_posting?: InputMaybe<Cluster_Current_Sis_Report_Posting_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_queue_cluster_model_sets?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
  in_queue_cluster_model_sets_aggregate?: InputMaybe<In_Queue_Cluster_Model_Sets_Aggregate_Bool_Exp>;
  in_queue_model_variants?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
  in_queue_model_variants_aggregate?: InputMaybe<In_Queue_Region_Model_Variants_Aggregate_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  relevant_subscriptions?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
  relevant_subscriptions_aggregate?: InputMaybe<In_Queue_Subscriptions_Aggregate_Bool_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<In_Queue_Cluster_Statuses_Enum_Comparison_Exp>;
  study_cycle?: InputMaybe<String_Comparison_Exp>;
  study_group?: InputMaybe<String_Comparison_Exp>;
  study_phase?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_queue_clusters" */
export enum In_Queue_Clusters_Constraint {
  /** unique or primary key constraint on columns "id" */
  InQueueClustersPkey = 'in_queue_clusters_pkey',
  /** unique or primary key constraint on columns "slug" */
  InQueueClustersSlugKey = 'in_queue_clusters_slug_key',
  /** unique or primary key constraint on columns "study_phase", "study_group", "study_cycle", "region" */
  InQueueClustersStudyCycleStudyGroupStudyPhaseRegioKey = 'in_queue_clusters_study_cycle_study_group_study_phase_regio_key'
}

/** input type for inserting data into table "in_queue_clusters" */
export type In_Queue_Clusters_Insert_Input = {
  current_sis_report_posting?: InputMaybe<Cluster_Current_Sis_Report_Posting_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster_model_sets?: InputMaybe<In_Queue_Cluster_Model_Sets_Arr_Rel_Insert_Input>;
  in_queue_model_variants?: InputMaybe<In_Queue_Region_Model_Variants_Arr_Rel_Insert_Input>;
  region?: InputMaybe<Scalars['String']['input']>;
  relevant_subscriptions?: InputMaybe<In_Queue_Subscriptions_Arr_Rel_Insert_Input>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<In_Queue_Cluster_Statuses_Enum>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type In_Queue_Clusters_Max_Fields = {
  __typename?: 'in_queue_clusters_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  study_phase?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type In_Queue_Clusters_Min_Fields = {
  __typename?: 'in_queue_clusters_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  study_phase?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "in_queue_clusters" */
export type In_Queue_Clusters_Mutation_Response = {
  __typename?: 'in_queue_clusters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Clusters>;
};

/** input type for inserting object relation for remote table "in_queue_clusters" */
export type In_Queue_Clusters_Obj_Rel_Insert_Input = {
  data: In_Queue_Clusters_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Clusters_On_Conflict>;
};

/** on_conflict condition type for table "in_queue_clusters" */
export type In_Queue_Clusters_On_Conflict = {
  constraint: In_Queue_Clusters_Constraint;
  update_columns?: Array<In_Queue_Clusters_Update_Column>;
  where?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_clusters". */
export type In_Queue_Clusters_Order_By = {
  current_sis_report_posting?: InputMaybe<Cluster_Current_Sis_Report_Posting_Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster_model_sets_aggregate?: InputMaybe<In_Queue_Cluster_Model_Sets_Aggregate_Order_By>;
  in_queue_model_variants_aggregate?: InputMaybe<In_Queue_Region_Model_Variants_Aggregate_Order_By>;
  region?: InputMaybe<Order_By>;
  relevant_subscriptions_aggregate?: InputMaybe<In_Queue_Subscriptions_Aggregate_Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  study_cycle?: InputMaybe<Order_By>;
  study_group?: InputMaybe<Order_By>;
  study_phase?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_queue_clusters */
export type In_Queue_Clusters_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "in_queue_clusters" */
export enum In_Queue_Clusters_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  StudyCycle = 'study_cycle',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  StudyPhase = 'study_phase'
}

/** input type for updating data in table "in_queue_clusters" */
export type In_Queue_Clusters_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<In_Queue_Cluster_Statuses_Enum>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "in_queue_clusters" */
export type In_Queue_Clusters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Clusters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Clusters_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<In_Queue_Cluster_Statuses_Enum>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "in_queue_clusters" */
export enum In_Queue_Clusters_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  StudyCycle = 'study_cycle',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  StudyPhase = 'study_phase'
}

export type In_Queue_Clusters_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Clusters_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Clusters_Bool_Exp;
};

/** columns and relationships of "in_queue_model_pois" */
export type In_Queue_Model_Pois = {
  __typename?: 'in_queue_model_pois';
  area: Scalars['String']['output'];
  cluster_id: Scalars['uuid']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  in_queue_cluster: In_Queue_Clusters;
  /** An array relationship */
  in_queue_speculative_projects: Array<In_Queue_Speculative_Projects>;
  /** An aggregate relationship */
  in_queue_speculative_projects_aggregate: In_Queue_Speculative_Projects_Aggregate;
  poi: Scalars['String']['output'];
  poi_name: Scalars['String']['output'];
  poi_type: Scalars['String']['output'];
  voltage: Scalars['String']['output'];
};


/** columns and relationships of "in_queue_model_pois" */
export type In_Queue_Model_PoisIn_Queue_Speculative_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};


/** columns and relationships of "in_queue_model_pois" */
export type In_Queue_Model_PoisIn_Queue_Speculative_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};

/** aggregated selection of "in_queue_model_pois" */
export type In_Queue_Model_Pois_Aggregate = {
  __typename?: 'in_queue_model_pois_aggregate';
  aggregate?: Maybe<In_Queue_Model_Pois_Aggregate_Fields>;
  nodes: Array<In_Queue_Model_Pois>;
};

/** aggregate fields of "in_queue_model_pois" */
export type In_Queue_Model_Pois_Aggregate_Fields = {
  __typename?: 'in_queue_model_pois_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Model_Pois_Max_Fields>;
  min?: Maybe<In_Queue_Model_Pois_Min_Fields>;
};


/** aggregate fields of "in_queue_model_pois" */
export type In_Queue_Model_Pois_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Model_Pois_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "in_queue_model_pois". All fields are combined with a logical 'AND'. */
export type In_Queue_Model_Pois_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Model_Pois_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Model_Pois_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Model_Pois_Bool_Exp>>;
  area?: InputMaybe<String_Comparison_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  in_queue_speculative_projects?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  in_queue_speculative_projects_aggregate?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp>;
  poi?: InputMaybe<String_Comparison_Exp>;
  poi_name?: InputMaybe<String_Comparison_Exp>;
  poi_type?: InputMaybe<String_Comparison_Exp>;
  voltage?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_queue_model_pois" */
export enum In_Queue_Model_Pois_Constraint {
  /** unique or primary key constraint on columns "cluster_id", "poi" */
  InQueueModelPoisClusterIdPoiKey = 'in_queue_model_pois_cluster_id_poi_key',
  /** unique or primary key constraint on columns "id" */
  InQueueModelPoisPkey = 'in_queue_model_pois_pkey'
}

/** input type for inserting data into table "in_queue_model_pois" */
export type In_Queue_Model_Pois_Insert_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  in_queue_speculative_projects?: InputMaybe<In_Queue_Speculative_Projects_Arr_Rel_Insert_Input>;
  poi?: InputMaybe<Scalars['String']['input']>;
  poi_name?: InputMaybe<Scalars['String']['input']>;
  poi_type?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type In_Queue_Model_Pois_Max_Fields = {
  __typename?: 'in_queue_model_pois_max_fields';
  area?: Maybe<Scalars['String']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  poi?: Maybe<Scalars['String']['output']>;
  poi_name?: Maybe<Scalars['String']['output']>;
  poi_type?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type In_Queue_Model_Pois_Min_Fields = {
  __typename?: 'in_queue_model_pois_min_fields';
  area?: Maybe<Scalars['String']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  poi?: Maybe<Scalars['String']['output']>;
  poi_name?: Maybe<Scalars['String']['output']>;
  poi_type?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "in_queue_model_pois" */
export type In_Queue_Model_Pois_Mutation_Response = {
  __typename?: 'in_queue_model_pois_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Model_Pois>;
};

/** input type for inserting object relation for remote table "in_queue_model_pois" */
export type In_Queue_Model_Pois_Obj_Rel_Insert_Input = {
  data: In_Queue_Model_Pois_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Model_Pois_On_Conflict>;
};

/** on_conflict condition type for table "in_queue_model_pois" */
export type In_Queue_Model_Pois_On_Conflict = {
  constraint: In_Queue_Model_Pois_Constraint;
  update_columns?: Array<In_Queue_Model_Pois_Update_Column>;
  where?: InputMaybe<In_Queue_Model_Pois_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_model_pois". */
export type In_Queue_Model_Pois_Order_By = {
  area?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  in_queue_speculative_projects_aggregate?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Order_By>;
  poi?: InputMaybe<Order_By>;
  poi_name?: InputMaybe<Order_By>;
  poi_type?: InputMaybe<Order_By>;
  voltage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_queue_model_pois */
export type In_Queue_Model_Pois_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "in_queue_model_pois" */
export enum In_Queue_Model_Pois_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Poi = 'poi',
  /** column name */
  PoiName = 'poi_name',
  /** column name */
  PoiType = 'poi_type',
  /** column name */
  Voltage = 'voltage'
}

/** input type for updating data in table "in_queue_model_pois" */
export type In_Queue_Model_Pois_Set_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  poi?: InputMaybe<Scalars['String']['input']>;
  poi_name?: InputMaybe<Scalars['String']['input']>;
  poi_type?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "in_queue_model_pois" */
export type In_Queue_Model_Pois_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Model_Pois_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Model_Pois_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  poi?: InputMaybe<Scalars['String']['input']>;
  poi_name?: InputMaybe<Scalars['String']['input']>;
  poi_type?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "in_queue_model_pois" */
export enum In_Queue_Model_Pois_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Poi = 'poi',
  /** column name */
  PoiName = 'poi_name',
  /** column name */
  PoiType = 'poi_type',
  /** column name */
  Voltage = 'voltage'
}

export type In_Queue_Model_Pois_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Model_Pois_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Model_Pois_Bool_Exp;
};

/** columns and relationships of "in_queue_model_variants" */
export type In_Queue_Model_Variants = {
  __typename?: 'in_queue_model_variants';
  description: Scalars['String']['output'];
  variant: Scalars['String']['output'];
};

/** aggregated selection of "in_queue_model_variants" */
export type In_Queue_Model_Variants_Aggregate = {
  __typename?: 'in_queue_model_variants_aggregate';
  aggregate?: Maybe<In_Queue_Model_Variants_Aggregate_Fields>;
  nodes: Array<In_Queue_Model_Variants>;
};

/** aggregate fields of "in_queue_model_variants" */
export type In_Queue_Model_Variants_Aggregate_Fields = {
  __typename?: 'in_queue_model_variants_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Model_Variants_Max_Fields>;
  min?: Maybe<In_Queue_Model_Variants_Min_Fields>;
};


/** aggregate fields of "in_queue_model_variants" */
export type In_Queue_Model_Variants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Model_Variants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "in_queue_model_variants". All fields are combined with a logical 'AND'. */
export type In_Queue_Model_Variants_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Model_Variants_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Model_Variants_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  variant?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_queue_model_variants" */
export enum In_Queue_Model_Variants_Constraint {
  /** unique or primary key constraint on columns "variant" */
  InQueueModelVariantsPkey = 'in_queue_model_variants_pkey'
}

export enum In_Queue_Model_Variants_Enum {
  /** NRIS (default) */
  MisoNrisDefault = 'miso_nris_default',
  /** Shoulder (charging) */
  MisoShoulderCharging = 'miso_shoulder_charging',
  /** Shoulder (discharging) */
  MisoShoulderDischarging = 'miso_shoulder_discharging',
  /** Summer */
  MisoSummerPeakDischarging = 'miso_summer_peak_discharging',
  /** Light Load */
  PjmLightLoad = 'pjm_light_load',
  /** Summer */
  PjmSummerPeak = 'pjm_summer_peak',
  /** Winter */
  PjmWinterPeak = 'pjm_winter_peak'
}

/** Boolean expression to compare columns of type "in_queue_model_variants_enum". All fields are combined with logical 'AND'. */
export type In_Queue_Model_Variants_Enum_Comparison_Exp = {
  _eq?: InputMaybe<In_Queue_Model_Variants_Enum>;
  _in?: InputMaybe<Array<In_Queue_Model_Variants_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<In_Queue_Model_Variants_Enum>;
  _nin?: InputMaybe<Array<In_Queue_Model_Variants_Enum>>;
};

/** input type for inserting data into table "in_queue_model_variants" */
export type In_Queue_Model_Variants_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type In_Queue_Model_Variants_Max_Fields = {
  __typename?: 'in_queue_model_variants_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type In_Queue_Model_Variants_Min_Fields = {
  __typename?: 'in_queue_model_variants_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "in_queue_model_variants" */
export type In_Queue_Model_Variants_Mutation_Response = {
  __typename?: 'in_queue_model_variants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Model_Variants>;
};

/** input type for inserting object relation for remote table "in_queue_model_variants" */
export type In_Queue_Model_Variants_Obj_Rel_Insert_Input = {
  data: In_Queue_Model_Variants_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Model_Variants_On_Conflict>;
};

/** on_conflict condition type for table "in_queue_model_variants" */
export type In_Queue_Model_Variants_On_Conflict = {
  constraint: In_Queue_Model_Variants_Constraint;
  update_columns?: Array<In_Queue_Model_Variants_Update_Column>;
  where?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_model_variants". */
export type In_Queue_Model_Variants_Order_By = {
  description?: InputMaybe<Order_By>;
  variant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_queue_model_variants */
export type In_Queue_Model_Variants_Pk_Columns_Input = {
  variant: Scalars['String']['input'];
};

/** select columns of table "in_queue_model_variants" */
export enum In_Queue_Model_Variants_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Variant = 'variant'
}

/** input type for updating data in table "in_queue_model_variants" */
export type In_Queue_Model_Variants_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "in_queue_model_variants" */
export type In_Queue_Model_Variants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Model_Variants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Model_Variants_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "in_queue_model_variants" */
export enum In_Queue_Model_Variants_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Variant = 'variant'
}

export type In_Queue_Model_Variants_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Model_Variants_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Model_Variants_Bool_Exp;
};

/** columns and relationships of "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants = {
  __typename?: 'in_queue_region_model_variants';
  /** An object relationship */
  model_variant: In_Queue_Model_Variants;
  region: Scalars['String']['output'];
  variant: In_Queue_Model_Variants_Enum;
};

/** aggregated selection of "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Aggregate = {
  __typename?: 'in_queue_region_model_variants_aggregate';
  aggregate?: Maybe<In_Queue_Region_Model_Variants_Aggregate_Fields>;
  nodes: Array<In_Queue_Region_Model_Variants>;
};

export type In_Queue_Region_Model_Variants_Aggregate_Bool_Exp = {
  count?: InputMaybe<In_Queue_Region_Model_Variants_Aggregate_Bool_Exp_Count>;
};

export type In_Queue_Region_Model_Variants_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<In_Queue_Region_Model_Variants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Aggregate_Fields = {
  __typename?: 'in_queue_region_model_variants_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Region_Model_Variants_Max_Fields>;
  min?: Maybe<In_Queue_Region_Model_Variants_Min_Fields>;
};


/** aggregate fields of "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Region_Model_Variants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<In_Queue_Region_Model_Variants_Max_Order_By>;
  min?: InputMaybe<In_Queue_Region_Model_Variants_Min_Order_By>;
};

/** input type for inserting array relation for remote table "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Arr_Rel_Insert_Input = {
  data: Array<In_Queue_Region_Model_Variants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Region_Model_Variants_On_Conflict>;
};

/** Boolean expression to filter rows from the table "in_queue_region_model_variants". All fields are combined with a logical 'AND'. */
export type In_Queue_Region_Model_Variants_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Region_Model_Variants_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Region_Model_Variants_Bool_Exp>>;
  model_variant?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_queue_region_model_variants" */
export enum In_Queue_Region_Model_Variants_Constraint {
  /** unique or primary key constraint on columns "variant", "region" */
  InQueueRegionModelVariantsPkey = 'in_queue_region_model_variants_pkey'
}

/** input type for inserting data into table "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Insert_Input = {
  model_variant?: InputMaybe<In_Queue_Model_Variants_Obj_Rel_Insert_Input>;
  region?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum>;
};

/** aggregate max on columns */
export type In_Queue_Region_Model_Variants_Max_Fields = {
  __typename?: 'in_queue_region_model_variants_max_fields';
  region?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Max_Order_By = {
  region?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type In_Queue_Region_Model_Variants_Min_Fields = {
  __typename?: 'in_queue_region_model_variants_min_fields';
  region?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Min_Order_By = {
  region?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Mutation_Response = {
  __typename?: 'in_queue_region_model_variants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Region_Model_Variants>;
};

/** on_conflict condition type for table "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_On_Conflict = {
  constraint: In_Queue_Region_Model_Variants_Constraint;
  update_columns?: Array<In_Queue_Region_Model_Variants_Update_Column>;
  where?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_region_model_variants". */
export type In_Queue_Region_Model_Variants_Order_By = {
  model_variant?: InputMaybe<In_Queue_Model_Variants_Order_By>;
  region?: InputMaybe<Order_By>;
  variant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_queue_region_model_variants */
export type In_Queue_Region_Model_Variants_Pk_Columns_Input = {
  region: Scalars['String']['input'];
  variant: In_Queue_Model_Variants_Enum;
};

/** select columns of table "in_queue_region_model_variants" */
export enum In_Queue_Region_Model_Variants_Select_Column {
  /** column name */
  Region = 'region',
  /** column name */
  Variant = 'variant'
}

/** input type for updating data in table "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Set_Input = {
  region?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum>;
};

/** Streaming cursor of the table "in_queue_region_model_variants" */
export type In_Queue_Region_Model_Variants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Region_Model_Variants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Region_Model_Variants_Stream_Cursor_Value_Input = {
  region?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<In_Queue_Model_Variants_Enum>;
};

/** update columns of table "in_queue_region_model_variants" */
export enum In_Queue_Region_Model_Variants_Update_Column {
  /** column name */
  Region = 'region',
  /** column name */
  Variant = 'variant'
}

export type In_Queue_Region_Model_Variants_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Region_Model_Variants_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Region_Model_Variants_Bool_Exp;
};

/** columns and relationships of "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects = {
  __typename?: 'in_queue_speculative_projects';
  cluster_id: Scalars['uuid']['output'];
  fuel_type: Scalars['String']['output'];
  hybrid_parent_project_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  in_queue_cluster: In_Queue_Clusters;
  /** An object relationship */
  in_queue_model_poi: In_Queue_Model_Pois;
  /** An object relationship */
  in_queue_speculative_project_hybrid_parent?: Maybe<In_Queue_Speculative_Projects>;
  /** An array relationship */
  in_queue_speculative_projects_children: Array<In_Queue_Speculative_Projects>;
  /** An aggregate relationship */
  in_queue_speculative_projects_children_aggregate: In_Queue_Speculative_Projects_Aggregate;
  /** An object relationship */
  in_queue_subscription: In_Queue_Subscriptions;
  mw_capacity: Scalars['float8']['output'];
  mw_energy: Scalars['float8']['output'];
  mw_mfo: Scalars['float8']['output'];
  poi_id: Scalars['uuid']['output'];
  project_id: Scalars['String']['output'];
  project_name: Scalars['String']['output'];
  subscription_id: Scalars['uuid']['output'];
  team_id?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "in_queue_speculative_projects" */
export type In_Queue_Speculative_ProjectsIn_Queue_Speculative_Projects_ChildrenArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};


/** columns and relationships of "in_queue_speculative_projects" */
export type In_Queue_Speculative_ProjectsIn_Queue_Speculative_Projects_Children_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};

/** aggregated selection of "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Aggregate = {
  __typename?: 'in_queue_speculative_projects_aggregate';
  aggregate?: Maybe<In_Queue_Speculative_Projects_Aggregate_Fields>;
  nodes: Array<In_Queue_Speculative_Projects>;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp = {
  avg?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Var_Samp>;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Avg = {
  arguments: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Corr = {
  arguments: In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Corr_Arguments = {
  X: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Max = {
  arguments: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Min = {
  arguments: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Sum = {
  arguments: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Var_Samp = {
  arguments: In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Aggregate_Fields = {
  __typename?: 'in_queue_speculative_projects_aggregate_fields';
  avg?: Maybe<In_Queue_Speculative_Projects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Speculative_Projects_Max_Fields>;
  min?: Maybe<In_Queue_Speculative_Projects_Min_Fields>;
  stddev?: Maybe<In_Queue_Speculative_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<In_Queue_Speculative_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<In_Queue_Speculative_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<In_Queue_Speculative_Projects_Sum_Fields>;
  var_pop?: Maybe<In_Queue_Speculative_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<In_Queue_Speculative_Projects_Var_Samp_Fields>;
  variance?: Maybe<In_Queue_Speculative_Projects_Variance_Fields>;
};


/** aggregate fields of "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Aggregate_Order_By = {
  avg?: InputMaybe<In_Queue_Speculative_Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<In_Queue_Speculative_Projects_Max_Order_By>;
  min?: InputMaybe<In_Queue_Speculative_Projects_Min_Order_By>;
  stddev?: InputMaybe<In_Queue_Speculative_Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<In_Queue_Speculative_Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<In_Queue_Speculative_Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<In_Queue_Speculative_Projects_Sum_Order_By>;
  var_pop?: InputMaybe<In_Queue_Speculative_Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<In_Queue_Speculative_Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<In_Queue_Speculative_Projects_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Arr_Rel_Insert_Input = {
  data: Array<In_Queue_Speculative_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Speculative_Projects_On_Conflict>;
};

/** aggregate avg on columns */
export type In_Queue_Speculative_Projects_Avg_Fields = {
  __typename?: 'in_queue_speculative_projects_avg_fields';
  mw_capacity?: Maybe<Scalars['Float']['output']>;
  mw_energy?: Maybe<Scalars['Float']['output']>;
  mw_mfo?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Avg_Order_By = {
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "in_queue_speculative_projects". All fields are combined with a logical 'AND'. */
export type In_Queue_Speculative_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Speculative_Projects_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Speculative_Projects_Bool_Exp>>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  fuel_type?: InputMaybe<String_Comparison_Exp>;
  hybrid_parent_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  in_queue_model_poi?: InputMaybe<In_Queue_Model_Pois_Bool_Exp>;
  in_queue_speculative_project_hybrid_parent?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  in_queue_speculative_projects_children?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  in_queue_speculative_projects_children_aggregate?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
  mw_capacity?: InputMaybe<Float8_Comparison_Exp>;
  mw_energy?: InputMaybe<Float8_Comparison_Exp>;
  mw_mfo?: InputMaybe<Float8_Comparison_Exp>;
  poi_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Constraint {
  /** unique or primary key constraint on columns "id" */
  InQueueSpeculativeProjectsPkey = 'in_queue_speculative_projects_pkey'
}

/** input type for incrementing numeric columns in table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Inc_Input = {
  mw_capacity?: InputMaybe<Scalars['float8']['input']>;
  mw_energy?: InputMaybe<Scalars['float8']['input']>;
  mw_mfo?: InputMaybe<Scalars['float8']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Insert_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  hybrid_parent_project_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  in_queue_model_poi?: InputMaybe<In_Queue_Model_Pois_Obj_Rel_Insert_Input>;
  in_queue_speculative_project_hybrid_parent?: InputMaybe<In_Queue_Speculative_Projects_Obj_Rel_Insert_Input>;
  in_queue_speculative_projects_children?: InputMaybe<In_Queue_Speculative_Projects_Arr_Rel_Insert_Input>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Obj_Rel_Insert_Input>;
  mw_capacity?: InputMaybe<Scalars['float8']['input']>;
  mw_energy?: InputMaybe<Scalars['float8']['input']>;
  mw_mfo?: InputMaybe<Scalars['float8']['input']>;
  poi_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type In_Queue_Speculative_Projects_Max_Fields = {
  __typename?: 'in_queue_speculative_projects_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  hybrid_parent_project_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mw_capacity?: Maybe<Scalars['float8']['output']>;
  mw_energy?: Maybe<Scalars['float8']['output']>;
  mw_mfo?: Maybe<Scalars['float8']['output']>;
  poi_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Max_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  fuel_type?: InputMaybe<Order_By>;
  hybrid_parent_project_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  poi_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type In_Queue_Speculative_Projects_Min_Fields = {
  __typename?: 'in_queue_speculative_projects_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  hybrid_parent_project_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mw_capacity?: Maybe<Scalars['float8']['output']>;
  mw_energy?: Maybe<Scalars['float8']['output']>;
  mw_mfo?: Maybe<Scalars['float8']['output']>;
  poi_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Min_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  fuel_type?: InputMaybe<Order_By>;
  hybrid_parent_project_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  poi_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Mutation_Response = {
  __typename?: 'in_queue_speculative_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Speculative_Projects>;
};

/** input type for inserting object relation for remote table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Obj_Rel_Insert_Input = {
  data: In_Queue_Speculative_Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Speculative_Projects_On_Conflict>;
};

/** on_conflict condition type for table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_On_Conflict = {
  constraint: In_Queue_Speculative_Projects_Constraint;
  update_columns?: Array<In_Queue_Speculative_Projects_Update_Column>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_speculative_projects". */
export type In_Queue_Speculative_Projects_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  fuel_type?: InputMaybe<Order_By>;
  hybrid_parent_project_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  in_queue_model_poi?: InputMaybe<In_Queue_Model_Pois_Order_By>;
  in_queue_speculative_project_hybrid_parent?: InputMaybe<In_Queue_Speculative_Projects_Order_By>;
  in_queue_speculative_projects_children_aggregate?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Order_By>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Order_By>;
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  poi_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_queue_speculative_projects */
export type In_Queue_Speculative_Projects_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  FuelType = 'fuel_type',
  /** column name */
  HybridParentProjectId = 'hybrid_parent_project_id',
  /** column name */
  Id = 'id',
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo',
  /** column name */
  PoiId = 'poi_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TeamId = 'team_id'
}

/** select "in_queue_speculative_projects_aggregate_bool_exp_avg_arguments_columns" columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo'
}

/** select "in_queue_speculative_projects_aggregate_bool_exp_corr_arguments_columns" columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo'
}

/** select "in_queue_speculative_projects_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo'
}

/** select "in_queue_speculative_projects_aggregate_bool_exp_max_arguments_columns" columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo'
}

/** select "in_queue_speculative_projects_aggregate_bool_exp_min_arguments_columns" columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo'
}

/** select "in_queue_speculative_projects_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo'
}

/** select "in_queue_speculative_projects_aggregate_bool_exp_sum_arguments_columns" columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo'
}

/** select "in_queue_speculative_projects_aggregate_bool_exp_var_samp_arguments_columns" columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Select_Column_In_Queue_Speculative_Projects_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo'
}

/** input type for updating data in table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Set_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  hybrid_parent_project_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mw_capacity?: InputMaybe<Scalars['float8']['input']>;
  mw_energy?: InputMaybe<Scalars['float8']['input']>;
  mw_mfo?: InputMaybe<Scalars['float8']['input']>;
  poi_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type In_Queue_Speculative_Projects_Stddev_Fields = {
  __typename?: 'in_queue_speculative_projects_stddev_fields';
  mw_capacity?: Maybe<Scalars['Float']['output']>;
  mw_energy?: Maybe<Scalars['Float']['output']>;
  mw_mfo?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Stddev_Order_By = {
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type In_Queue_Speculative_Projects_Stddev_Pop_Fields = {
  __typename?: 'in_queue_speculative_projects_stddev_pop_fields';
  mw_capacity?: Maybe<Scalars['Float']['output']>;
  mw_energy?: Maybe<Scalars['Float']['output']>;
  mw_mfo?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Stddev_Pop_Order_By = {
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type In_Queue_Speculative_Projects_Stddev_Samp_Fields = {
  __typename?: 'in_queue_speculative_projects_stddev_samp_fields';
  mw_capacity?: Maybe<Scalars['Float']['output']>;
  mw_energy?: Maybe<Scalars['Float']['output']>;
  mw_mfo?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Stddev_Samp_Order_By = {
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Speculative_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Speculative_Projects_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  hybrid_parent_project_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mw_capacity?: InputMaybe<Scalars['float8']['input']>;
  mw_energy?: InputMaybe<Scalars['float8']['input']>;
  mw_mfo?: InputMaybe<Scalars['float8']['input']>;
  poi_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type In_Queue_Speculative_Projects_Sum_Fields = {
  __typename?: 'in_queue_speculative_projects_sum_fields';
  mw_capacity?: Maybe<Scalars['float8']['output']>;
  mw_energy?: Maybe<Scalars['float8']['output']>;
  mw_mfo?: Maybe<Scalars['float8']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Sum_Order_By = {
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "in_queue_speculative_projects" */
export enum In_Queue_Speculative_Projects_Update_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  FuelType = 'fuel_type',
  /** column name */
  HybridParentProjectId = 'hybrid_parent_project_id',
  /** column name */
  Id = 'id',
  /** column name */
  MwCapacity = 'mw_capacity',
  /** column name */
  MwEnergy = 'mw_energy',
  /** column name */
  MwMfo = 'mw_mfo',
  /** column name */
  PoiId = 'poi_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TeamId = 'team_id'
}

export type In_Queue_Speculative_Projects_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<In_Queue_Speculative_Projects_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Speculative_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Speculative_Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type In_Queue_Speculative_Projects_Var_Pop_Fields = {
  __typename?: 'in_queue_speculative_projects_var_pop_fields';
  mw_capacity?: Maybe<Scalars['Float']['output']>;
  mw_energy?: Maybe<Scalars['Float']['output']>;
  mw_mfo?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Var_Pop_Order_By = {
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type In_Queue_Speculative_Projects_Var_Samp_Fields = {
  __typename?: 'in_queue_speculative_projects_var_samp_fields';
  mw_capacity?: Maybe<Scalars['Float']['output']>;
  mw_energy?: Maybe<Scalars['Float']['output']>;
  mw_mfo?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Var_Samp_Order_By = {
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type In_Queue_Speculative_Projects_Variance_Fields = {
  __typename?: 'in_queue_speculative_projects_variance_fields';
  mw_capacity?: Maybe<Scalars['Float']['output']>;
  mw_energy?: Maybe<Scalars['Float']['output']>;
  mw_mfo?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "in_queue_speculative_projects" */
export type In_Queue_Speculative_Projects_Variance_Order_By = {
  mw_capacity?: InputMaybe<Order_By>;
  mw_energy?: InputMaybe<Order_By>;
  mw_mfo?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons = {
  __typename?: 'in_queue_subscription_add_ons';
  add_on: Subscription_Add_Ons_Enum;
  /** An object relationship */
  in_queue_subscription: In_Queue_Subscriptions;
  subscription_id: Scalars['uuid']['output'];
};

/** aggregated selection of "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Aggregate = {
  __typename?: 'in_queue_subscription_add_ons_aggregate';
  aggregate?: Maybe<In_Queue_Subscription_Add_Ons_Aggregate_Fields>;
  nodes: Array<In_Queue_Subscription_Add_Ons>;
};

export type In_Queue_Subscription_Add_Ons_Aggregate_Bool_Exp = {
  count?: InputMaybe<In_Queue_Subscription_Add_Ons_Aggregate_Bool_Exp_Count>;
};

export type In_Queue_Subscription_Add_Ons_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Aggregate_Fields = {
  __typename?: 'in_queue_subscription_add_ons_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Subscription_Add_Ons_Max_Fields>;
  min?: Maybe<In_Queue_Subscription_Add_Ons_Min_Fields>;
};


/** aggregate fields of "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<In_Queue_Subscription_Add_Ons_Max_Order_By>;
  min?: InputMaybe<In_Queue_Subscription_Add_Ons_Min_Order_By>;
};

/** input type for inserting array relation for remote table "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Arr_Rel_Insert_Input = {
  data: Array<In_Queue_Subscription_Add_Ons_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Subscription_Add_Ons_On_Conflict>;
};

/** Boolean expression to filter rows from the table "in_queue_subscription_add_ons". All fields are combined with a logical 'AND'. */
export type In_Queue_Subscription_Add_Ons_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Bool_Exp>>;
  add_on?: InputMaybe<Subscription_Add_Ons_Enum_Comparison_Exp>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "in_queue_subscription_add_ons" */
export enum In_Queue_Subscription_Add_Ons_Constraint {
  /** unique or primary key constraint on columns "subscription_id", "add_on" */
  InQueueSubscriptionAddOnsPkey = 'in_queue_subscription_add_ons_pkey'
}

/** input type for inserting data into table "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Insert_Input = {
  add_on?: InputMaybe<Subscription_Add_Ons_Enum>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type In_Queue_Subscription_Add_Ons_Max_Fields = {
  __typename?: 'in_queue_subscription_add_ons_max_fields';
  subscription_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Max_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type In_Queue_Subscription_Add_Ons_Min_Fields = {
  __typename?: 'in_queue_subscription_add_ons_min_fields';
  subscription_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Min_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Mutation_Response = {
  __typename?: 'in_queue_subscription_add_ons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Subscription_Add_Ons>;
};

/** on_conflict condition type for table "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_On_Conflict = {
  constraint: In_Queue_Subscription_Add_Ons_Constraint;
  update_columns?: Array<In_Queue_Subscription_Add_Ons_Update_Column>;
  where?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_subscription_add_ons". */
export type In_Queue_Subscription_Add_Ons_Order_By = {
  add_on?: InputMaybe<Order_By>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: in_queue_subscription_add_ons */
export type In_Queue_Subscription_Add_Ons_Pk_Columns_Input = {
  add_on: Subscription_Add_Ons_Enum;
  subscription_id: Scalars['uuid']['input'];
};

/** select columns of table "in_queue_subscription_add_ons" */
export enum In_Queue_Subscription_Add_Ons_Select_Column {
  /** column name */
  AddOn = 'add_on',
  /** column name */
  SubscriptionId = 'subscription_id'
}

/** input type for updating data in table "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Set_Input = {
  add_on?: InputMaybe<Subscription_Add_Ons_Enum>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "in_queue_subscription_add_ons" */
export type In_Queue_Subscription_Add_Ons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Subscription_Add_Ons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Subscription_Add_Ons_Stream_Cursor_Value_Input = {
  add_on?: InputMaybe<Subscription_Add_Ons_Enum>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "in_queue_subscription_add_ons" */
export enum In_Queue_Subscription_Add_Ons_Update_Column {
  /** column name */
  AddOn = 'add_on',
  /** column name */
  SubscriptionId = 'subscription_id'
}

export type In_Queue_Subscription_Add_Ons_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Subscription_Add_Ons_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Subscription_Add_Ons_Bool_Exp;
};

/** columns and relationships of "in_queue_subscriptions" */
export type In_Queue_Subscriptions = {
  __typename?: 'in_queue_subscriptions';
  /** An object relationship */
  in_queue_cluster?: Maybe<In_Queue_Clusters>;
  /** An array relationship */
  in_queue_speculative_projects: Array<In_Queue_Speculative_Projects>;
  /** An aggregate relationship */
  in_queue_speculative_projects_aggregate: In_Queue_Speculative_Projects_Aggregate;
  /** An array relationship */
  in_queue_subscription_add_ons: Array<In_Queue_Subscription_Add_Ons>;
  /** An aggregate relationship */
  in_queue_subscription_add_ons_aggregate: In_Queue_Subscription_Add_Ons_Aggregate;
  phase: Scalars['String']['output'];
  project_limit?: Maybe<Scalars['Int']['output']>;
  region: Scalars['String']['output'];
  scenario_limit: Scalars['Int']['output'];
  /** An array relationship */
  scenarios: Array<Scenarios>;
  /** An aggregate relationship */
  scenarios_aggregate: Scenarios_Aggregate;
  status_override?: Maybe<In_Queue_Cluster_Statuses_Enum>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  study_cycle: Scalars['String']['output'];
  study_group: Scalars['String']['output'];
  subscription_id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int']['output'];
  /** An array relationship */
  tracked_projects: Array<Tracked_Projects>;
  /** An aggregate relationship */
  tracked_projects_aggregate: Tracked_Projects_Aggregate;
};


/** columns and relationships of "in_queue_subscriptions" */
export type In_Queue_SubscriptionsIn_Queue_Speculative_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};


/** columns and relationships of "in_queue_subscriptions" */
export type In_Queue_SubscriptionsIn_Queue_Speculative_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};


/** columns and relationships of "in_queue_subscriptions" */
export type In_Queue_SubscriptionsIn_Queue_Subscription_Add_OnsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
};


/** columns and relationships of "in_queue_subscriptions" */
export type In_Queue_SubscriptionsIn_Queue_Subscription_Add_Ons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
};


/** columns and relationships of "in_queue_subscriptions" */
export type In_Queue_SubscriptionsScenariosArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


/** columns and relationships of "in_queue_subscriptions" */
export type In_Queue_SubscriptionsScenarios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


/** columns and relationships of "in_queue_subscriptions" */
export type In_Queue_SubscriptionsTracked_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tracked_Projects_Order_By>>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};


/** columns and relationships of "in_queue_subscriptions" */
export type In_Queue_SubscriptionsTracked_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tracked_Projects_Order_By>>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};

/** aggregated selection of "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Aggregate = {
  __typename?: 'in_queue_subscriptions_aggregate';
  aggregate?: Maybe<In_Queue_Subscriptions_Aggregate_Fields>;
  nodes: Array<In_Queue_Subscriptions>;
};

export type In_Queue_Subscriptions_Aggregate_Bool_Exp = {
  count?: InputMaybe<In_Queue_Subscriptions_Aggregate_Bool_Exp_Count>;
};

export type In_Queue_Subscriptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Aggregate_Fields = {
  __typename?: 'in_queue_subscriptions_aggregate_fields';
  avg?: Maybe<In_Queue_Subscriptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<In_Queue_Subscriptions_Max_Fields>;
  min?: Maybe<In_Queue_Subscriptions_Min_Fields>;
  stddev?: Maybe<In_Queue_Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<In_Queue_Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<In_Queue_Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<In_Queue_Subscriptions_Sum_Fields>;
  var_pop?: Maybe<In_Queue_Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<In_Queue_Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<In_Queue_Subscriptions_Variance_Fields>;
};


/** aggregate fields of "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Aggregate_Order_By = {
  avg?: InputMaybe<In_Queue_Subscriptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<In_Queue_Subscriptions_Max_Order_By>;
  min?: InputMaybe<In_Queue_Subscriptions_Min_Order_By>;
  stddev?: InputMaybe<In_Queue_Subscriptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<In_Queue_Subscriptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<In_Queue_Subscriptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<In_Queue_Subscriptions_Sum_Order_By>;
  var_pop?: InputMaybe<In_Queue_Subscriptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<In_Queue_Subscriptions_Var_Samp_Order_By>;
  variance?: InputMaybe<In_Queue_Subscriptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Arr_Rel_Insert_Input = {
  data: Array<In_Queue_Subscriptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Subscriptions_On_Conflict>;
};

/** aggregate avg on columns */
export type In_Queue_Subscriptions_Avg_Fields = {
  __typename?: 'in_queue_subscriptions_avg_fields';
  project_limit?: Maybe<Scalars['Float']['output']>;
  scenario_limit?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Avg_Order_By = {
  project_limit?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "in_queue_subscriptions". All fields are combined with a logical 'AND'. */
export type In_Queue_Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<In_Queue_Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<In_Queue_Subscriptions_Bool_Exp>>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  in_queue_speculative_projects?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
  in_queue_speculative_projects_aggregate?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Bool_Exp>;
  in_queue_subscription_add_ons?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
  in_queue_subscription_add_ons_aggregate?: InputMaybe<In_Queue_Subscription_Add_Ons_Aggregate_Bool_Exp>;
  phase?: InputMaybe<String_Comparison_Exp>;
  project_limit?: InputMaybe<Int_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scenario_limit?: InputMaybe<Int_Comparison_Exp>;
  scenarios?: InputMaybe<Scenarios_Bool_Exp>;
  scenarios_aggregate?: InputMaybe<Scenarios_Aggregate_Bool_Exp>;
  status_override?: InputMaybe<In_Queue_Cluster_Statuses_Enum_Comparison_Exp>;
  stripe_id?: InputMaybe<String_Comparison_Exp>;
  study_cycle?: InputMaybe<String_Comparison_Exp>;
  study_group?: InputMaybe<String_Comparison_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  tracked_projects?: InputMaybe<Tracked_Projects_Bool_Exp>;
  tracked_projects_aggregate?: InputMaybe<Tracked_Projects_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "in_queue_subscriptions" */
export enum In_Queue_Subscriptions_Constraint {
  /** unique or primary key constraint on columns "subscription_id" */
  InQueueSubscriptionsPkey = 'in_queue_subscriptions_pkey'
}

/** input type for incrementing numeric columns in table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Inc_Input = {
  project_limit?: InputMaybe<Scalars['Int']['input']>;
  scenario_limit?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Insert_Input = {
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  in_queue_speculative_projects?: InputMaybe<In_Queue_Speculative_Projects_Arr_Rel_Insert_Input>;
  in_queue_subscription_add_ons?: InputMaybe<In_Queue_Subscription_Add_Ons_Arr_Rel_Insert_Input>;
  phase?: InputMaybe<Scalars['String']['input']>;
  project_limit?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scenario_limit?: InputMaybe<Scalars['Int']['input']>;
  scenarios?: InputMaybe<Scenarios_Arr_Rel_Insert_Input>;
  status_override?: InputMaybe<In_Queue_Cluster_Statuses_Enum>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  tracked_projects?: InputMaybe<Tracked_Projects_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type In_Queue_Subscriptions_Max_Fields = {
  __typename?: 'in_queue_subscriptions_max_fields';
  phase?: Maybe<Scalars['String']['output']>;
  project_limit?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scenario_limit?: Maybe<Scalars['Int']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Max_Order_By = {
  phase?: InputMaybe<Order_By>;
  project_limit?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  study_cycle?: InputMaybe<Order_By>;
  study_group?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type In_Queue_Subscriptions_Min_Fields = {
  __typename?: 'in_queue_subscriptions_min_fields';
  phase?: Maybe<Scalars['String']['output']>;
  project_limit?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scenario_limit?: Maybe<Scalars['Int']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Min_Order_By = {
  phase?: InputMaybe<Order_By>;
  project_limit?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  study_cycle?: InputMaybe<Order_By>;
  study_group?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Mutation_Response = {
  __typename?: 'in_queue_subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<In_Queue_Subscriptions>;
};

/** input type for inserting object relation for remote table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Obj_Rel_Insert_Input = {
  data: In_Queue_Subscriptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<In_Queue_Subscriptions_On_Conflict>;
};

/** on_conflict condition type for table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_On_Conflict = {
  constraint: In_Queue_Subscriptions_Constraint;
  update_columns?: Array<In_Queue_Subscriptions_Update_Column>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "in_queue_subscriptions". */
export type In_Queue_Subscriptions_Order_By = {
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  in_queue_speculative_projects_aggregate?: InputMaybe<In_Queue_Speculative_Projects_Aggregate_Order_By>;
  in_queue_subscription_add_ons_aggregate?: InputMaybe<In_Queue_Subscription_Add_Ons_Aggregate_Order_By>;
  phase?: InputMaybe<Order_By>;
  project_limit?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  scenarios_aggregate?: InputMaybe<Scenarios_Aggregate_Order_By>;
  status_override?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  study_cycle?: InputMaybe<Order_By>;
  study_group?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tracked_projects_aggregate?: InputMaybe<Tracked_Projects_Aggregate_Order_By>;
};

/** primary key columns input for table: in_queue_subscriptions */
export type In_Queue_Subscriptions_Pk_Columns_Input = {
  subscription_id: Scalars['uuid']['input'];
};

/** select columns of table "in_queue_subscriptions" */
export enum In_Queue_Subscriptions_Select_Column {
  /** column name */
  Phase = 'phase',
  /** column name */
  ProjectLimit = 'project_limit',
  /** column name */
  Region = 'region',
  /** column name */
  ScenarioLimit = 'scenario_limit',
  /** column name */
  StatusOverride = 'status_override',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  StudyCycle = 'study_cycle',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Set_Input = {
  phase?: InputMaybe<Scalars['String']['input']>;
  project_limit?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scenario_limit?: InputMaybe<Scalars['Int']['input']>;
  status_override?: InputMaybe<In_Queue_Cluster_Statuses_Enum>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type In_Queue_Subscriptions_Stddev_Fields = {
  __typename?: 'in_queue_subscriptions_stddev_fields';
  project_limit?: Maybe<Scalars['Float']['output']>;
  scenario_limit?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Stddev_Order_By = {
  project_limit?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type In_Queue_Subscriptions_Stddev_Pop_Fields = {
  __typename?: 'in_queue_subscriptions_stddev_pop_fields';
  project_limit?: Maybe<Scalars['Float']['output']>;
  scenario_limit?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Stddev_Pop_Order_By = {
  project_limit?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type In_Queue_Subscriptions_Stddev_Samp_Fields = {
  __typename?: 'in_queue_subscriptions_stddev_samp_fields';
  project_limit?: Maybe<Scalars['Float']['output']>;
  scenario_limit?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Stddev_Samp_Order_By = {
  project_limit?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: In_Queue_Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type In_Queue_Subscriptions_Stream_Cursor_Value_Input = {
  phase?: InputMaybe<Scalars['String']['input']>;
  project_limit?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scenario_limit?: InputMaybe<Scalars['Int']['input']>;
  status_override?: InputMaybe<In_Queue_Cluster_Statuses_Enum>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type In_Queue_Subscriptions_Sum_Fields = {
  __typename?: 'in_queue_subscriptions_sum_fields';
  project_limit?: Maybe<Scalars['Int']['output']>;
  scenario_limit?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Sum_Order_By = {
  project_limit?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "in_queue_subscriptions" */
export enum In_Queue_Subscriptions_Update_Column {
  /** column name */
  Phase = 'phase',
  /** column name */
  ProjectLimit = 'project_limit',
  /** column name */
  Region = 'region',
  /** column name */
  ScenarioLimit = 'scenario_limit',
  /** column name */
  StatusOverride = 'status_override',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  StudyCycle = 'study_cycle',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TeamId = 'team_id'
}

export type In_Queue_Subscriptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<In_Queue_Subscriptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<In_Queue_Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: In_Queue_Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type In_Queue_Subscriptions_Var_Pop_Fields = {
  __typename?: 'in_queue_subscriptions_var_pop_fields';
  project_limit?: Maybe<Scalars['Float']['output']>;
  scenario_limit?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Var_Pop_Order_By = {
  project_limit?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type In_Queue_Subscriptions_Var_Samp_Fields = {
  __typename?: 'in_queue_subscriptions_var_samp_fields';
  project_limit?: Maybe<Scalars['Float']['output']>;
  scenario_limit?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Var_Samp_Order_By = {
  project_limit?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type In_Queue_Subscriptions_Variance_Fields = {
  __typename?: 'in_queue_subscriptions_variance_fields';
  project_limit?: Maybe<Scalars['Float']['output']>;
  scenario_limit?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "in_queue_subscriptions" */
export type In_Queue_Subscriptions_Variance_Order_By = {
  project_limit?: InputMaybe<Order_By>;
  scenario_limit?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the jsonpath return any item for the specified JSON value */
  _jsonb_path_exists?: InputMaybe<Scalars['String']['input']>;
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonb_path_match?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "line_capacity_costs" */
export type Line_Capacity_Costs = {
  __typename?: 'line_capacity_costs';
  capacity_size: Scalars['numeric']['output'];
  charging_size: Scalars['numeric']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  energy_size: Scalars['numeric']['output'];
  includes_pre_existing: Scalars['Boolean']['output'];
  /** An object relationship */
  model_line?: Maybe<Model_Lines>;
  scope: Scalars['String']['output'];
  scope_view: Scalars['String']['output'];
  tap_facility_id: Scalars['String']['output'];
  total_upgrade_costs: Scalars['numeric']['output'];
  upgrade_costs: Scalars['numeric']['output'];
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
};


/** columns and relationships of "line_capacity_costs" */
export type Line_Capacity_CostsUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "line_capacity_costs" */
export type Line_Capacity_CostsUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "line_capacity_costs" */
export type Line_Capacity_Costs_Aggregate = {
  __typename?: 'line_capacity_costs_aggregate';
  aggregate?: Maybe<Line_Capacity_Costs_Aggregate_Fields>;
  nodes: Array<Line_Capacity_Costs>;
};

export type Line_Capacity_Costs_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Line_Capacity_Costs_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Line_Capacity_Costs_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Line_Capacity_Costs_Aggregate_Bool_Exp_Count>;
};

export type Line_Capacity_Costs_Aggregate_Bool_Exp_Bool_And = {
  arguments: Line_Capacity_Costs_Select_Column_Line_Capacity_Costs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Line_Capacity_Costs_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Line_Capacity_Costs_Select_Column_Line_Capacity_Costs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Line_Capacity_Costs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Line_Capacity_Costs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "line_capacity_costs" */
export type Line_Capacity_Costs_Aggregate_Fields = {
  __typename?: 'line_capacity_costs_aggregate_fields';
  avg?: Maybe<Line_Capacity_Costs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Line_Capacity_Costs_Max_Fields>;
  min?: Maybe<Line_Capacity_Costs_Min_Fields>;
  stddev?: Maybe<Line_Capacity_Costs_Stddev_Fields>;
  stddev_pop?: Maybe<Line_Capacity_Costs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Line_Capacity_Costs_Stddev_Samp_Fields>;
  sum?: Maybe<Line_Capacity_Costs_Sum_Fields>;
  var_pop?: Maybe<Line_Capacity_Costs_Var_Pop_Fields>;
  var_samp?: Maybe<Line_Capacity_Costs_Var_Samp_Fields>;
  variance?: Maybe<Line_Capacity_Costs_Variance_Fields>;
};


/** aggregate fields of "line_capacity_costs" */
export type Line_Capacity_Costs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Line_Capacity_Costs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "line_capacity_costs" */
export type Line_Capacity_Costs_Aggregate_Order_By = {
  avg?: InputMaybe<Line_Capacity_Costs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Line_Capacity_Costs_Max_Order_By>;
  min?: InputMaybe<Line_Capacity_Costs_Min_Order_By>;
  stddev?: InputMaybe<Line_Capacity_Costs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Line_Capacity_Costs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Line_Capacity_Costs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Line_Capacity_Costs_Sum_Order_By>;
  var_pop?: InputMaybe<Line_Capacity_Costs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Line_Capacity_Costs_Var_Samp_Order_By>;
  variance?: InputMaybe<Line_Capacity_Costs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "line_capacity_costs" */
export type Line_Capacity_Costs_Arr_Rel_Insert_Input = {
  data: Array<Line_Capacity_Costs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Line_Capacity_Costs_On_Conflict>;
};

/** aggregate avg on columns */
export type Line_Capacity_Costs_Avg_Fields = {
  __typename?: 'line_capacity_costs_avg_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Avg_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "line_capacity_costs". All fields are combined with a logical 'AND'. */
export type Line_Capacity_Costs_Bool_Exp = {
  _and?: InputMaybe<Array<Line_Capacity_Costs_Bool_Exp>>;
  _not?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
  _or?: InputMaybe<Array<Line_Capacity_Costs_Bool_Exp>>;
  capacity_size?: InputMaybe<Numeric_Comparison_Exp>;
  charging_size?: InputMaybe<Numeric_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  energy_size?: InputMaybe<Numeric_Comparison_Exp>;
  includes_pre_existing?: InputMaybe<Boolean_Comparison_Exp>;
  model_line?: InputMaybe<Model_Lines_Bool_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  tap_facility_id?: InputMaybe<String_Comparison_Exp>;
  total_upgrade_costs?: InputMaybe<Numeric_Comparison_Exp>;
  upgrade_costs?: InputMaybe<Numeric_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "line_capacity_costs" */
export enum Line_Capacity_Costs_Constraint {
  /** unique or primary key constraint on columns "scope", "energy_size", "includes_pre_existing", "tap_facility_id", "scope_view" */
  LineCapacityCostsPkey = 'line_capacity_costs_pkey'
}

/** input type for incrementing numeric columns in table "line_capacity_costs" */
export type Line_Capacity_Costs_Inc_Input = {
  capacity_size?: InputMaybe<Scalars['numeric']['input']>;
  charging_size?: InputMaybe<Scalars['numeric']['input']>;
  energy_size?: InputMaybe<Scalars['numeric']['input']>;
  total_upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "line_capacity_costs" */
export type Line_Capacity_Costs_Insert_Input = {
  capacity_size?: InputMaybe<Scalars['numeric']['input']>;
  charging_size?: InputMaybe<Scalars['numeric']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  energy_size?: InputMaybe<Scalars['numeric']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  model_line?: InputMaybe<Model_Lines_Obj_Rel_Insert_Input>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  tap_facility_id?: InputMaybe<Scalars['String']['input']>;
  total_upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Line_Capacity_Costs_Max_Fields = {
  __typename?: 'line_capacity_costs_max_fields';
  capacity_size?: Maybe<Scalars['numeric']['output']>;
  charging_size?: Maybe<Scalars['numeric']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  energy_size?: Maybe<Scalars['numeric']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  tap_facility_id?: Maybe<Scalars['String']['output']>;
  total_upgrade_costs?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Max_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  tap_facility_id?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Line_Capacity_Costs_Min_Fields = {
  __typename?: 'line_capacity_costs_min_fields';
  capacity_size?: Maybe<Scalars['numeric']['output']>;
  charging_size?: Maybe<Scalars['numeric']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  energy_size?: Maybe<Scalars['numeric']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  tap_facility_id?: Maybe<Scalars['String']['output']>;
  total_upgrade_costs?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Min_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  tap_facility_id?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "line_capacity_costs" */
export type Line_Capacity_Costs_Mutation_Response = {
  __typename?: 'line_capacity_costs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Line_Capacity_Costs>;
};

/** on_conflict condition type for table "line_capacity_costs" */
export type Line_Capacity_Costs_On_Conflict = {
  constraint: Line_Capacity_Costs_Constraint;
  update_columns?: Array<Line_Capacity_Costs_Update_Column>;
  where?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
};

/** Ordering options when selecting data from "line_capacity_costs". */
export type Line_Capacity_Costs_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  includes_pre_existing?: InputMaybe<Order_By>;
  model_line?: InputMaybe<Model_Lines_Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  tap_facility_id?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: line_capacity_costs */
export type Line_Capacity_Costs_Pk_Columns_Input = {
  energy_size: Scalars['numeric']['input'];
  includes_pre_existing: Scalars['Boolean']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  tap_facility_id: Scalars['String']['input'];
};

/** select columns of table "line_capacity_costs" */
export enum Line_Capacity_Costs_Select_Column {
  /** column name */
  CapacitySize = 'capacity_size',
  /** column name */
  ChargingSize = 'charging_size',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  EnergySize = 'energy_size',
  /** column name */
  IncludesPreExisting = 'includes_pre_existing',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  TapFacilityId = 'tap_facility_id',
  /** column name */
  TotalUpgradeCosts = 'total_upgrade_costs',
  /** column name */
  UpgradeCosts = 'upgrade_costs'
}

/** select "line_capacity_costs_aggregate_bool_exp_bool_and_arguments_columns" columns of table "line_capacity_costs" */
export enum Line_Capacity_Costs_Select_Column_Line_Capacity_Costs_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IncludesPreExisting = 'includes_pre_existing'
}

/** select "line_capacity_costs_aggregate_bool_exp_bool_or_arguments_columns" columns of table "line_capacity_costs" */
export enum Line_Capacity_Costs_Select_Column_Line_Capacity_Costs_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IncludesPreExisting = 'includes_pre_existing'
}

/** input type for updating data in table "line_capacity_costs" */
export type Line_Capacity_Costs_Set_Input = {
  capacity_size?: InputMaybe<Scalars['numeric']['input']>;
  charging_size?: InputMaybe<Scalars['numeric']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  energy_size?: InputMaybe<Scalars['numeric']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  tap_facility_id?: InputMaybe<Scalars['String']['input']>;
  total_upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Line_Capacity_Costs_Stddev_Fields = {
  __typename?: 'line_capacity_costs_stddev_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Stddev_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Line_Capacity_Costs_Stddev_Pop_Fields = {
  __typename?: 'line_capacity_costs_stddev_pop_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Stddev_Pop_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Line_Capacity_Costs_Stddev_Samp_Fields = {
  __typename?: 'line_capacity_costs_stddev_samp_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Stddev_Samp_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "line_capacity_costs" */
export type Line_Capacity_Costs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Line_Capacity_Costs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Line_Capacity_Costs_Stream_Cursor_Value_Input = {
  capacity_size?: InputMaybe<Scalars['numeric']['input']>;
  charging_size?: InputMaybe<Scalars['numeric']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  energy_size?: InputMaybe<Scalars['numeric']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  tap_facility_id?: InputMaybe<Scalars['String']['input']>;
  total_upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
  upgrade_costs?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Line_Capacity_Costs_Sum_Fields = {
  __typename?: 'line_capacity_costs_sum_fields';
  capacity_size?: Maybe<Scalars['numeric']['output']>;
  charging_size?: Maybe<Scalars['numeric']['output']>;
  energy_size?: Maybe<Scalars['numeric']['output']>;
  total_upgrade_costs?: Maybe<Scalars['numeric']['output']>;
  upgrade_costs?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Sum_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** update columns of table "line_capacity_costs" */
export enum Line_Capacity_Costs_Update_Column {
  /** column name */
  CapacitySize = 'capacity_size',
  /** column name */
  ChargingSize = 'charging_size',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  EnergySize = 'energy_size',
  /** column name */
  IncludesPreExisting = 'includes_pre_existing',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  TapFacilityId = 'tap_facility_id',
  /** column name */
  TotalUpgradeCosts = 'total_upgrade_costs',
  /** column name */
  UpgradeCosts = 'upgrade_costs'
}

export type Line_Capacity_Costs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Line_Capacity_Costs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Line_Capacity_Costs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Line_Capacity_Costs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Line_Capacity_Costs_Var_Pop_Fields = {
  __typename?: 'line_capacity_costs_var_pop_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Var_Pop_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Line_Capacity_Costs_Var_Samp_Fields = {
  __typename?: 'line_capacity_costs_var_samp_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Var_Samp_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Line_Capacity_Costs_Variance_Fields = {
  __typename?: 'line_capacity_costs_variance_fields';
  capacity_size?: Maybe<Scalars['Float']['output']>;
  charging_size?: Maybe<Scalars['Float']['output']>;
  energy_size?: Maybe<Scalars['Float']['output']>;
  total_upgrade_costs?: Maybe<Scalars['Float']['output']>;
  upgrade_costs?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "line_capacity_costs" */
export type Line_Capacity_Costs_Variance_Order_By = {
  capacity_size?: InputMaybe<Order_By>;
  charging_size?: InputMaybe<Order_By>;
  energy_size?: InputMaybe<Order_By>;
  total_upgrade_costs?: InputMaybe<Order_By>;
  upgrade_costs?: InputMaybe<Order_By>;
};

/** columns and relationships of "line_constraint_stacks" */
export type Line_Constraint_Stacks = {
  __typename?: 'line_constraint_stacks';
  contingency: Scalars['String']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax: Scalars['numeric']['output'];
  element_type: Scalars['String']['output'];
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  injection_threshold: Scalars['numeric']['output'];
  is_pre_existing: Scalars['Boolean']['output'];
  line_length?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  model_line?: Maybe<Model_Lines>;
  monitored_facility_id: Scalars['String']['output'];
  monitored_facility_name: Scalars['String']['output'];
  pre_study_load: Scalars['numeric']['output'];
  rating: Scalars['numeric']['output'];
  resource_type: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  scope_view: Scalars['String']['output'];
  tap_facility_id: Scalars['String']['output'];
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
};


/** columns and relationships of "line_constraint_stacks" */
export type Line_Constraint_StacksUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "line_constraint_stacks" */
export type Line_Constraint_StacksUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "line_constraint_stacks" */
export type Line_Constraint_Stacks_Aggregate = {
  __typename?: 'line_constraint_stacks_aggregate';
  aggregate?: Maybe<Line_Constraint_Stacks_Aggregate_Fields>;
  nodes: Array<Line_Constraint_Stacks>;
};

export type Line_Constraint_Stacks_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Line_Constraint_Stacks_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Line_Constraint_Stacks_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Line_Constraint_Stacks_Aggregate_Bool_Exp_Count>;
};

export type Line_Constraint_Stacks_Aggregate_Bool_Exp_Bool_And = {
  arguments: Line_Constraint_Stacks_Select_Column_Line_Constraint_Stacks_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Line_Constraint_Stacks_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Line_Constraint_Stacks_Select_Column_Line_Constraint_Stacks_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Line_Constraint_Stacks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Line_Constraint_Stacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "line_constraint_stacks" */
export type Line_Constraint_Stacks_Aggregate_Fields = {
  __typename?: 'line_constraint_stacks_aggregate_fields';
  avg?: Maybe<Line_Constraint_Stacks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Line_Constraint_Stacks_Max_Fields>;
  min?: Maybe<Line_Constraint_Stacks_Min_Fields>;
  stddev?: Maybe<Line_Constraint_Stacks_Stddev_Fields>;
  stddev_pop?: Maybe<Line_Constraint_Stacks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Line_Constraint_Stacks_Stddev_Samp_Fields>;
  sum?: Maybe<Line_Constraint_Stacks_Sum_Fields>;
  var_pop?: Maybe<Line_Constraint_Stacks_Var_Pop_Fields>;
  var_samp?: Maybe<Line_Constraint_Stacks_Var_Samp_Fields>;
  variance?: Maybe<Line_Constraint_Stacks_Variance_Fields>;
};


/** aggregate fields of "line_constraint_stacks" */
export type Line_Constraint_Stacks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Line_Constraint_Stacks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Aggregate_Order_By = {
  avg?: InputMaybe<Line_Constraint_Stacks_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Line_Constraint_Stacks_Max_Order_By>;
  min?: InputMaybe<Line_Constraint_Stacks_Min_Order_By>;
  stddev?: InputMaybe<Line_Constraint_Stacks_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Line_Constraint_Stacks_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Line_Constraint_Stacks_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Line_Constraint_Stacks_Sum_Order_By>;
  var_pop?: InputMaybe<Line_Constraint_Stacks_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Line_Constraint_Stacks_Var_Samp_Order_By>;
  variance?: InputMaybe<Line_Constraint_Stacks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Arr_Rel_Insert_Input = {
  data: Array<Line_Constraint_Stacks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Line_Constraint_Stacks_On_Conflict>;
};

/** aggregate avg on columns */
export type Line_Constraint_Stacks_Avg_Fields = {
  __typename?: 'line_constraint_stacks_avg_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Avg_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "line_constraint_stacks". All fields are combined with a logical 'AND'. */
export type Line_Constraint_Stacks_Bool_Exp = {
  _and?: InputMaybe<Array<Line_Constraint_Stacks_Bool_Exp>>;
  _not?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
  _or?: InputMaybe<Array<Line_Constraint_Stacks_Bool_Exp>>;
  contingency?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  dfax?: InputMaybe<Numeric_Comparison_Exp>;
  element_type?: InputMaybe<String_Comparison_Exp>;
  estimated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  injection_threshold?: InputMaybe<Numeric_Comparison_Exp>;
  is_pre_existing?: InputMaybe<Boolean_Comparison_Exp>;
  line_length?: InputMaybe<Numeric_Comparison_Exp>;
  model_line?: InputMaybe<Model_Lines_Bool_Exp>;
  monitored_facility_id?: InputMaybe<String_Comparison_Exp>;
  monitored_facility_name?: InputMaybe<String_Comparison_Exp>;
  pre_study_load?: InputMaybe<Numeric_Comparison_Exp>;
  rating?: InputMaybe<Numeric_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  tap_facility_id?: InputMaybe<String_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "line_constraint_stacks" */
export enum Line_Constraint_Stacks_Constraint {
  /** unique or primary key constraint on columns "scope", "tap_facility_id", "scope_view", "resource_type", "monitored_facility_id" */
  LineConstraintStacksPkey = 'line_constraint_stacks_pkey'
}

/** input type for incrementing numeric columns in table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Inc_Input = {
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  injection_threshold?: InputMaybe<Scalars['numeric']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Insert_Input = {
  contingency?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  injection_threshold?: InputMaybe<Scalars['numeric']['input']>;
  is_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  model_line?: InputMaybe<Model_Lines_Obj_Rel_Insert_Input>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  tap_facility_id?: InputMaybe<Scalars['String']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Line_Constraint_Stacks_Max_Fields = {
  __typename?: 'line_constraint_stacks_max_fields';
  contingency?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  injection_threshold?: Maybe<Scalars['numeric']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  tap_facility_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Max_Order_By = {
  contingency?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  tap_facility_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Line_Constraint_Stacks_Min_Fields = {
  __typename?: 'line_constraint_stacks_min_fields';
  contingency?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  injection_threshold?: Maybe<Scalars['numeric']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  tap_facility_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Min_Order_By = {
  contingency?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  tap_facility_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Mutation_Response = {
  __typename?: 'line_constraint_stacks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Line_Constraint_Stacks>;
};

/** on_conflict condition type for table "line_constraint_stacks" */
export type Line_Constraint_Stacks_On_Conflict = {
  constraint: Line_Constraint_Stacks_Constraint;
  update_columns?: Array<Line_Constraint_Stacks_Update_Column>;
  where?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
};

/** Ordering options when selecting data from "line_constraint_stacks". */
export type Line_Constraint_Stacks_Order_By = {
  contingency?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  is_pre_existing?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  model_line?: InputMaybe<Model_Lines_Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  tap_facility_id?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: line_constraint_stacks */
export type Line_Constraint_Stacks_Pk_Columns_Input = {
  monitored_facility_id: Scalars['String']['input'];
  resource_type: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  tap_facility_id: Scalars['String']['input'];
};

/** select columns of table "line_constraint_stacks" */
export enum Line_Constraint_Stacks_Select_Column {
  /** column name */
  Contingency = 'contingency',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  ElementType = 'element_type',
  /** column name */
  EstimatedCost = 'estimated_cost',
  /** column name */
  InjectionThreshold = 'injection_threshold',
  /** column name */
  IsPreExisting = 'is_pre_existing',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  PreStudyLoad = 'pre_study_load',
  /** column name */
  Rating = 'rating',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  TapFacilityId = 'tap_facility_id'
}

/** select "line_constraint_stacks_aggregate_bool_exp_bool_and_arguments_columns" columns of table "line_constraint_stacks" */
export enum Line_Constraint_Stacks_Select_Column_Line_Constraint_Stacks_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPreExisting = 'is_pre_existing'
}

/** select "line_constraint_stacks_aggregate_bool_exp_bool_or_arguments_columns" columns of table "line_constraint_stacks" */
export enum Line_Constraint_Stacks_Select_Column_Line_Constraint_Stacks_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPreExisting = 'is_pre_existing'
}

/** input type for updating data in table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Set_Input = {
  contingency?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  injection_threshold?: InputMaybe<Scalars['numeric']['input']>;
  is_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  tap_facility_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Line_Constraint_Stacks_Stddev_Fields = {
  __typename?: 'line_constraint_stacks_stddev_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Stddev_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Line_Constraint_Stacks_Stddev_Pop_Fields = {
  __typename?: 'line_constraint_stacks_stddev_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Stddev_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Line_Constraint_Stacks_Stddev_Samp_Fields = {
  __typename?: 'line_constraint_stacks_stddev_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Stddev_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Line_Constraint_Stacks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Line_Constraint_Stacks_Stream_Cursor_Value_Input = {
  contingency?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  estimated_cost?: InputMaybe<Scalars['numeric']['input']>;
  injection_threshold?: InputMaybe<Scalars['numeric']['input']>;
  is_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  tap_facility_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Line_Constraint_Stacks_Sum_Fields = {
  __typename?: 'line_constraint_stacks_sum_fields';
  dfax?: Maybe<Scalars['numeric']['output']>;
  estimated_cost?: Maybe<Scalars['numeric']['output']>;
  injection_threshold?: Maybe<Scalars['numeric']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Sum_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** update columns of table "line_constraint_stacks" */
export enum Line_Constraint_Stacks_Update_Column {
  /** column name */
  Contingency = 'contingency',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  ElementType = 'element_type',
  /** column name */
  EstimatedCost = 'estimated_cost',
  /** column name */
  InjectionThreshold = 'injection_threshold',
  /** column name */
  IsPreExisting = 'is_pre_existing',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  PreStudyLoad = 'pre_study_load',
  /** column name */
  Rating = 'rating',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  TapFacilityId = 'tap_facility_id'
}

export type Line_Constraint_Stacks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Line_Constraint_Stacks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Line_Constraint_Stacks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Line_Constraint_Stacks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Line_Constraint_Stacks_Var_Pop_Fields = {
  __typename?: 'line_constraint_stacks_var_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Var_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Line_Constraint_Stacks_Var_Samp_Fields = {
  __typename?: 'line_constraint_stacks_var_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Var_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Line_Constraint_Stacks_Variance_Fields = {
  __typename?: 'line_constraint_stacks_variance_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  estimated_cost?: Maybe<Scalars['Float']['output']>;
  injection_threshold?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "line_constraint_stacks" */
export type Line_Constraint_Stacks_Variance_Order_By = {
  dfax?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  injection_threshold?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax = {
  __typename?: 'model_generator_facility_dfax';
  contingency: Scalars['String']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax: Scalars['numeric']['output'];
  /** An object relationship */
  model_generator?: Maybe<Model_Generators>;
  monitored_facility_id: Scalars['String']['output'];
  nira_bus_id: Scalars['String']['output'];
  region: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
};


/** columns and relationships of "model_generator_facility_dfax" */
export type Model_Generator_Facility_DfaxUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "model_generator_facility_dfax" */
export type Model_Generator_Facility_DfaxUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Aggregate = {
  __typename?: 'model_generator_facility_dfax_aggregate';
  aggregate?: Maybe<Model_Generator_Facility_Dfax_Aggregate_Fields>;
  nodes: Array<Model_Generator_Facility_Dfax>;
};

export type Model_Generator_Facility_Dfax_Aggregate_Bool_Exp = {
  count?: InputMaybe<Model_Generator_Facility_Dfax_Aggregate_Bool_Exp_Count>;
};

export type Model_Generator_Facility_Dfax_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Model_Generator_Facility_Dfax_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Aggregate_Fields = {
  __typename?: 'model_generator_facility_dfax_aggregate_fields';
  avg?: Maybe<Model_Generator_Facility_Dfax_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Model_Generator_Facility_Dfax_Max_Fields>;
  min?: Maybe<Model_Generator_Facility_Dfax_Min_Fields>;
  stddev?: Maybe<Model_Generator_Facility_Dfax_Stddev_Fields>;
  stddev_pop?: Maybe<Model_Generator_Facility_Dfax_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Model_Generator_Facility_Dfax_Stddev_Samp_Fields>;
  sum?: Maybe<Model_Generator_Facility_Dfax_Sum_Fields>;
  var_pop?: Maybe<Model_Generator_Facility_Dfax_Var_Pop_Fields>;
  var_samp?: Maybe<Model_Generator_Facility_Dfax_Var_Samp_Fields>;
  variance?: Maybe<Model_Generator_Facility_Dfax_Variance_Fields>;
};


/** aggregate fields of "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Generator_Facility_Dfax_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Aggregate_Order_By = {
  avg?: InputMaybe<Model_Generator_Facility_Dfax_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Model_Generator_Facility_Dfax_Max_Order_By>;
  min?: InputMaybe<Model_Generator_Facility_Dfax_Min_Order_By>;
  stddev?: InputMaybe<Model_Generator_Facility_Dfax_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Model_Generator_Facility_Dfax_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Model_Generator_Facility_Dfax_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Model_Generator_Facility_Dfax_Sum_Order_By>;
  var_pop?: InputMaybe<Model_Generator_Facility_Dfax_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Model_Generator_Facility_Dfax_Var_Samp_Order_By>;
  variance?: InputMaybe<Model_Generator_Facility_Dfax_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Arr_Rel_Insert_Input = {
  data: Array<Model_Generator_Facility_Dfax_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_Generator_Facility_Dfax_On_Conflict>;
};

/** aggregate avg on columns */
export type Model_Generator_Facility_Dfax_Avg_Fields = {
  __typename?: 'model_generator_facility_dfax_avg_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Avg_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "model_generator_facility_dfax". All fields are combined with a logical 'AND'. */
export type Model_Generator_Facility_Dfax_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Generator_Facility_Dfax_Bool_Exp>>;
  _not?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Generator_Facility_Dfax_Bool_Exp>>;
  contingency?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  dfax?: InputMaybe<Numeric_Comparison_Exp>;
  model_generator?: InputMaybe<Model_Generators_Bool_Exp>;
  monitored_facility_id?: InputMaybe<String_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "model_generator_facility_dfax" */
export enum Model_Generator_Facility_Dfax_Constraint {
  /** unique or primary key constraint on columns "scope", "nira_bus_id", "contingency", "monitored_facility_id" */
  ModelGeneratorFacilityDfaxPkey = 'model_generator_facility_dfax_pkey'
}

/** input type for incrementing numeric columns in table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Inc_Input = {
  dfax?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Insert_Input = {
  contingency?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  model_generator?: InputMaybe<Model_Generators_Obj_Rel_Insert_Input>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Model_Generator_Facility_Dfax_Max_Fields = {
  __typename?: 'model_generator_facility_dfax_max_fields';
  contingency?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Max_Order_By = {
  contingency?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Model_Generator_Facility_Dfax_Min_Fields = {
  __typename?: 'model_generator_facility_dfax_min_fields';
  contingency?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Min_Order_By = {
  contingency?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Mutation_Response = {
  __typename?: 'model_generator_facility_dfax_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Generator_Facility_Dfax>;
};

/** on_conflict condition type for table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_On_Conflict = {
  constraint: Model_Generator_Facility_Dfax_Constraint;
  update_columns?: Array<Model_Generator_Facility_Dfax_Update_Column>;
  where?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
};

/** Ordering options when selecting data from "model_generator_facility_dfax". */
export type Model_Generator_Facility_Dfax_Order_By = {
  contingency?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  model_generator?: InputMaybe<Model_Generators_Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: model_generator_facility_dfax */
export type Model_Generator_Facility_Dfax_Pk_Columns_Input = {
  contingency: Scalars['String']['input'];
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};

/** select columns of table "model_generator_facility_dfax" */
export enum Model_Generator_Facility_Dfax_Select_Column {
  /** column name */
  Contingency = 'contingency',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope'
}

/** input type for updating data in table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Set_Input = {
  contingency?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Model_Generator_Facility_Dfax_Stddev_Fields = {
  __typename?: 'model_generator_facility_dfax_stddev_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Stddev_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Model_Generator_Facility_Dfax_Stddev_Pop_Fields = {
  __typename?: 'model_generator_facility_dfax_stddev_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Stddev_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Model_Generator_Facility_Dfax_Stddev_Samp_Fields = {
  __typename?: 'model_generator_facility_dfax_stddev_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Stddev_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Generator_Facility_Dfax_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Generator_Facility_Dfax_Stream_Cursor_Value_Input = {
  contingency?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Model_Generator_Facility_Dfax_Sum_Fields = {
  __typename?: 'model_generator_facility_dfax_sum_fields';
  dfax?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Sum_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** update columns of table "model_generator_facility_dfax" */
export enum Model_Generator_Facility_Dfax_Update_Column {
  /** column name */
  Contingency = 'contingency',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope'
}

export type Model_Generator_Facility_Dfax_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Generator_Facility_Dfax_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Generator_Facility_Dfax_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Generator_Facility_Dfax_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Model_Generator_Facility_Dfax_Var_Pop_Fields = {
  __typename?: 'model_generator_facility_dfax_var_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Var_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Model_Generator_Facility_Dfax_Var_Samp_Fields = {
  __typename?: 'model_generator_facility_dfax_var_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Var_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Model_Generator_Facility_Dfax_Variance_Fields = {
  __typename?: 'model_generator_facility_dfax_variance_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "model_generator_facility_dfax" */
export type Model_Generator_Facility_Dfax_Variance_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** columns and relationships of "model_generators" */
export type Model_Generators = {
  __typename?: 'model_generators';
  bus_number: Scalars['String']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  gen_id?: Maybe<Scalars['String']['output']>;
  generator_name?: Maybe<Scalars['String']['output']>;
  nira_bus_id: Scalars['String']['output'];
  pgen?: Maybe<Scalars['numeric']['output']>;
  pmax: Scalars['numeric']['output'];
  region: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
};


/** columns and relationships of "model_generators" */
export type Model_GeneratorsUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "model_generators" */
export type Model_GeneratorsUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "model_generators" */
export type Model_Generators_Aggregate = {
  __typename?: 'model_generators_aggregate';
  aggregate?: Maybe<Model_Generators_Aggregate_Fields>;
  nodes: Array<Model_Generators>;
};

/** aggregate fields of "model_generators" */
export type Model_Generators_Aggregate_Fields = {
  __typename?: 'model_generators_aggregate_fields';
  avg?: Maybe<Model_Generators_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Model_Generators_Max_Fields>;
  min?: Maybe<Model_Generators_Min_Fields>;
  stddev?: Maybe<Model_Generators_Stddev_Fields>;
  stddev_pop?: Maybe<Model_Generators_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Model_Generators_Stddev_Samp_Fields>;
  sum?: Maybe<Model_Generators_Sum_Fields>;
  var_pop?: Maybe<Model_Generators_Var_Pop_Fields>;
  var_samp?: Maybe<Model_Generators_Var_Samp_Fields>;
  variance?: Maybe<Model_Generators_Variance_Fields>;
};


/** aggregate fields of "model_generators" */
export type Model_Generators_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Generators_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Model_Generators_Avg_Fields = {
  __typename?: 'model_generators_avg_fields';
  pgen?: Maybe<Scalars['Float']['output']>;
  pmax?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "model_generators". All fields are combined with a logical 'AND'. */
export type Model_Generators_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Generators_Bool_Exp>>;
  _not?: InputMaybe<Model_Generators_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Generators_Bool_Exp>>;
  bus_number?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  fuel_type?: InputMaybe<String_Comparison_Exp>;
  gen_id?: InputMaybe<String_Comparison_Exp>;
  generator_name?: InputMaybe<String_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  pgen?: InputMaybe<Numeric_Comparison_Exp>;
  pmax?: InputMaybe<Numeric_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "model_generators" */
export enum Model_Generators_Constraint {
  /** unique or primary key constraint on columns "scope", "nira_bus_id" */
  ModelGeneratorsPkey = 'model_generators_pkey'
}

/** input type for incrementing numeric columns in table "model_generators" */
export type Model_Generators_Inc_Input = {
  pgen?: InputMaybe<Scalars['numeric']['input']>;
  pmax?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "model_generators" */
export type Model_Generators_Insert_Input = {
  bus_number?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  gen_id?: InputMaybe<Scalars['String']['input']>;
  generator_name?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  pgen?: InputMaybe<Scalars['numeric']['input']>;
  pmax?: InputMaybe<Scalars['numeric']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Model_Generators_Max_Fields = {
  __typename?: 'model_generators_max_fields';
  bus_number?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  gen_id?: Maybe<Scalars['String']['output']>;
  generator_name?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  pgen?: Maybe<Scalars['numeric']['output']>;
  pmax?: Maybe<Scalars['numeric']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Model_Generators_Min_Fields = {
  __typename?: 'model_generators_min_fields';
  bus_number?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  gen_id?: Maybe<Scalars['String']['output']>;
  generator_name?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  pgen?: Maybe<Scalars['numeric']['output']>;
  pmax?: Maybe<Scalars['numeric']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "model_generators" */
export type Model_Generators_Mutation_Response = {
  __typename?: 'model_generators_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Generators>;
};

/** input type for inserting object relation for remote table "model_generators" */
export type Model_Generators_Obj_Rel_Insert_Input = {
  data: Model_Generators_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_Generators_On_Conflict>;
};

/** on_conflict condition type for table "model_generators" */
export type Model_Generators_On_Conflict = {
  constraint: Model_Generators_Constraint;
  update_columns?: Array<Model_Generators_Update_Column>;
  where?: InputMaybe<Model_Generators_Bool_Exp>;
};

/** Ordering options when selecting data from "model_generators". */
export type Model_Generators_Order_By = {
  bus_number?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  fuel_type?: InputMaybe<Order_By>;
  gen_id?: InputMaybe<Order_By>;
  generator_name?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  pgen?: InputMaybe<Order_By>;
  pmax?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: model_generators */
export type Model_Generators_Pk_Columns_Input = {
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};

/** select columns of table "model_generators" */
export enum Model_Generators_Select_Column {
  /** column name */
  BusNumber = 'bus_number',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  FuelType = 'fuel_type',
  /** column name */
  GenId = 'gen_id',
  /** column name */
  GeneratorName = 'generator_name',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Pgen = 'pgen',
  /** column name */
  Pmax = 'pmax',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope'
}

/** input type for updating data in table "model_generators" */
export type Model_Generators_Set_Input = {
  bus_number?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  gen_id?: InputMaybe<Scalars['String']['input']>;
  generator_name?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  pgen?: InputMaybe<Scalars['numeric']['input']>;
  pmax?: InputMaybe<Scalars['numeric']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Model_Generators_Stddev_Fields = {
  __typename?: 'model_generators_stddev_fields';
  pgen?: Maybe<Scalars['Float']['output']>;
  pmax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Model_Generators_Stddev_Pop_Fields = {
  __typename?: 'model_generators_stddev_pop_fields';
  pgen?: Maybe<Scalars['Float']['output']>;
  pmax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Model_Generators_Stddev_Samp_Fields = {
  __typename?: 'model_generators_stddev_samp_fields';
  pgen?: Maybe<Scalars['Float']['output']>;
  pmax?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "model_generators" */
export type Model_Generators_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Generators_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Generators_Stream_Cursor_Value_Input = {
  bus_number?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  gen_id?: InputMaybe<Scalars['String']['input']>;
  generator_name?: InputMaybe<Scalars['String']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  pgen?: InputMaybe<Scalars['numeric']['input']>;
  pmax?: InputMaybe<Scalars['numeric']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Model_Generators_Sum_Fields = {
  __typename?: 'model_generators_sum_fields';
  pgen?: Maybe<Scalars['numeric']['output']>;
  pmax?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "model_generators" */
export enum Model_Generators_Update_Column {
  /** column name */
  BusNumber = 'bus_number',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  FuelType = 'fuel_type',
  /** column name */
  GenId = 'gen_id',
  /** column name */
  GeneratorName = 'generator_name',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  Pgen = 'pgen',
  /** column name */
  Pmax = 'pmax',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope'
}

export type Model_Generators_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Generators_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Generators_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Generators_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Model_Generators_Var_Pop_Fields = {
  __typename?: 'model_generators_var_pop_fields';
  pgen?: Maybe<Scalars['Float']['output']>;
  pmax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Model_Generators_Var_Samp_Fields = {
  __typename?: 'model_generators_var_samp_fields';
  pgen?: Maybe<Scalars['Float']['output']>;
  pmax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Model_Generators_Variance_Fields = {
  __typename?: 'model_generators_variance_fields';
  pgen?: Maybe<Scalars['Float']['output']>;
  pmax?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "model_lines" */
export type Model_Lines = {
  __typename?: 'model_lines';
  circuit_id: Scalars['String']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  facility_id: Scalars['String']['output'];
  /** An object relationship */
  from_bus?: Maybe<Buses>;
  from_bus_id: Scalars['String']['output'];
  /** An object relationship */
  from_bus_without_overrides: Buses_Without_Overrides;
  from_nira_bus_id: Scalars['String']['output'];
  /** An array relationship */
  line_capacity_costs: Array<Line_Capacity_Costs>;
  /** An aggregate relationship */
  line_capacity_costs_aggregate: Line_Capacity_Costs_Aggregate;
  /** An array relationship */
  line_constraint_stacks: Array<Line_Constraint_Stacks>;
  /** An aggregate relationship */
  line_constraint_stacks_aggregate: Line_Constraint_Stacks_Aggregate;
  line_length: Scalars['numeric']['output'];
  rating: Scalars['numeric']['output'];
  scope: Scalars['String']['output'];
  scope_view: Scalars['String']['output'];
  /** An object relationship */
  to_bus?: Maybe<Buses>;
  to_bus_id: Scalars['String']['output'];
  /** An object relationship */
  to_bus_without_overrides: Buses_Without_Overrides;
  to_nira_bus_id: Scalars['String']['output'];
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
  voltage: Scalars['numeric']['output'];
};


/** columns and relationships of "model_lines" */
export type Model_LinesLine_Capacity_CostsArgs = {
  distinct_on?: InputMaybe<Array<Line_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Capacity_Costs_Order_By>>;
  where?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
};


/** columns and relationships of "model_lines" */
export type Model_LinesLine_Capacity_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Capacity_Costs_Order_By>>;
  where?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
};


/** columns and relationships of "model_lines" */
export type Model_LinesLine_Constraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Line_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
};


/** columns and relationships of "model_lines" */
export type Model_LinesLine_Constraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
};


/** columns and relationships of "model_lines" */
export type Model_LinesUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "model_lines" */
export type Model_LinesUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "model_lines" */
export type Model_Lines_Aggregate = {
  __typename?: 'model_lines_aggregate';
  aggregate?: Maybe<Model_Lines_Aggregate_Fields>;
  nodes: Array<Model_Lines>;
};

/** aggregate fields of "model_lines" */
export type Model_Lines_Aggregate_Fields = {
  __typename?: 'model_lines_aggregate_fields';
  avg?: Maybe<Model_Lines_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Model_Lines_Max_Fields>;
  min?: Maybe<Model_Lines_Min_Fields>;
  stddev?: Maybe<Model_Lines_Stddev_Fields>;
  stddev_pop?: Maybe<Model_Lines_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Model_Lines_Stddev_Samp_Fields>;
  sum?: Maybe<Model_Lines_Sum_Fields>;
  var_pop?: Maybe<Model_Lines_Var_Pop_Fields>;
  var_samp?: Maybe<Model_Lines_Var_Samp_Fields>;
  variance?: Maybe<Model_Lines_Variance_Fields>;
};


/** aggregate fields of "model_lines" */
export type Model_Lines_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Lines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Model_Lines_Avg_Fields = {
  __typename?: 'model_lines_avg_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "model_lines". All fields are combined with a logical 'AND'. */
export type Model_Lines_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Lines_Bool_Exp>>;
  _not?: InputMaybe<Model_Lines_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Lines_Bool_Exp>>;
  circuit_id?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  facility_id?: InputMaybe<String_Comparison_Exp>;
  from_bus?: InputMaybe<Buses_Bool_Exp>;
  from_bus_id?: InputMaybe<String_Comparison_Exp>;
  from_bus_without_overrides?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
  from_nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  line_capacity_costs?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
  line_capacity_costs_aggregate?: InputMaybe<Line_Capacity_Costs_Aggregate_Bool_Exp>;
  line_constraint_stacks?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
  line_constraint_stacks_aggregate?: InputMaybe<Line_Constraint_Stacks_Aggregate_Bool_Exp>;
  line_length?: InputMaybe<Numeric_Comparison_Exp>;
  rating?: InputMaybe<Numeric_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  to_bus?: InputMaybe<Buses_Bool_Exp>;
  to_bus_id?: InputMaybe<String_Comparison_Exp>;
  to_bus_without_overrides?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
  to_nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
  voltage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "model_lines" */
export enum Model_Lines_Constraint {
  /** unique or primary key constraint on columns "scope", "facility_id", "scope_view" */
  ModelLinesPkey = 'model_lines_pkey'
}

/** input type for incrementing numeric columns in table "model_lines" */
export type Model_Lines_Inc_Input = {
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "model_lines" */
export type Model_Lines_Insert_Input = {
  circuit_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  from_bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  from_bus_id?: InputMaybe<Scalars['String']['input']>;
  from_bus_without_overrides?: InputMaybe<Buses_Without_Overrides_Obj_Rel_Insert_Input>;
  from_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  line_capacity_costs?: InputMaybe<Line_Capacity_Costs_Arr_Rel_Insert_Input>;
  line_constraint_stacks?: InputMaybe<Line_Constraint_Stacks_Arr_Rel_Insert_Input>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  to_bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  to_bus_id?: InputMaybe<Scalars['String']['input']>;
  to_bus_without_overrides?: InputMaybe<Buses_Without_Overrides_Obj_Rel_Insert_Input>;
  to_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Model_Lines_Max_Fields = {
  __typename?: 'model_lines_max_fields';
  circuit_id?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  from_bus_id?: Maybe<Scalars['String']['output']>;
  from_nira_bus_id?: Maybe<Scalars['String']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  to_bus_id?: Maybe<Scalars['String']['output']>;
  to_nira_bus_id?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Model_Lines_Min_Fields = {
  __typename?: 'model_lines_min_fields';
  circuit_id?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  from_bus_id?: Maybe<Scalars['String']['output']>;
  from_nira_bus_id?: Maybe<Scalars['String']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  to_bus_id?: Maybe<Scalars['String']['output']>;
  to_nira_bus_id?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "model_lines" */
export type Model_Lines_Mutation_Response = {
  __typename?: 'model_lines_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Lines>;
};

/** input type for inserting object relation for remote table "model_lines" */
export type Model_Lines_Obj_Rel_Insert_Input = {
  data: Model_Lines_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_Lines_On_Conflict>;
};

/** on_conflict condition type for table "model_lines" */
export type Model_Lines_On_Conflict = {
  constraint: Model_Lines_Constraint;
  update_columns?: Array<Model_Lines_Update_Column>;
  where?: InputMaybe<Model_Lines_Bool_Exp>;
};

/** Ordering options when selecting data from "model_lines". */
export type Model_Lines_Order_By = {
  circuit_id?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  from_bus?: InputMaybe<Buses_Order_By>;
  from_bus_id?: InputMaybe<Order_By>;
  from_bus_without_overrides?: InputMaybe<Buses_Without_Overrides_Order_By>;
  from_nira_bus_id?: InputMaybe<Order_By>;
  line_capacity_costs_aggregate?: InputMaybe<Line_Capacity_Costs_Aggregate_Order_By>;
  line_constraint_stacks_aggregate?: InputMaybe<Line_Constraint_Stacks_Aggregate_Order_By>;
  line_length?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  to_bus?: InputMaybe<Buses_Order_By>;
  to_bus_id?: InputMaybe<Order_By>;
  to_bus_without_overrides?: InputMaybe<Buses_Without_Overrides_Order_By>;
  to_nira_bus_id?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
  voltage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: model_lines */
export type Model_Lines_Pk_Columns_Input = {
  facility_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};

/** select columns of table "model_lines" */
export enum Model_Lines_Select_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FromBusId = 'from_bus_id',
  /** column name */
  FromNiraBusId = 'from_nira_bus_id',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  Rating = 'rating',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  ToBusId = 'to_bus_id',
  /** column name */
  ToNiraBusId = 'to_nira_bus_id',
  /** column name */
  Voltage = 'voltage'
}

/** input type for updating data in table "model_lines" */
export type Model_Lines_Set_Input = {
  circuit_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  from_bus_id?: InputMaybe<Scalars['String']['input']>;
  from_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  to_bus_id?: InputMaybe<Scalars['String']['input']>;
  to_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Model_Lines_Stddev_Fields = {
  __typename?: 'model_lines_stddev_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Model_Lines_Stddev_Pop_Fields = {
  __typename?: 'model_lines_stddev_pop_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Model_Lines_Stddev_Samp_Fields = {
  __typename?: 'model_lines_stddev_samp_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "model_lines" */
export type Model_Lines_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Lines_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Lines_Stream_Cursor_Value_Input = {
  circuit_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  from_bus_id?: InputMaybe<Scalars['String']['input']>;
  from_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  to_bus_id?: InputMaybe<Scalars['String']['input']>;
  to_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Model_Lines_Sum_Fields = {
  __typename?: 'model_lines_sum_fields';
  line_length?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** columns and relationships of "model_lines_to_branches" */
export type Model_Lines_To_Branches = {
  __typename?: 'model_lines_to_branches';
  /** An object relationship */
  branch: Branches;
  branch_id: Scalars['String']['output'];
  confidence: Scalars['String']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  facility_id: Scalars['String']['output'];
  gis_source_key: Scalars['String']['output'];
  region: Scalars['String']['output'];
  /** An array relationship */
  scopes: Array<Scopes>;
  /** An aggregate relationship */
  scopes_aggregate: Scopes_Aggregate;
  segment_index: Scalars['Int']['output'];
};


/** columns and relationships of "model_lines_to_branches" */
export type Model_Lines_To_BranchesScopesArgs = {
  distinct_on?: InputMaybe<Array<Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scopes_Order_By>>;
  where?: InputMaybe<Scopes_Bool_Exp>;
};


/** columns and relationships of "model_lines_to_branches" */
export type Model_Lines_To_BranchesScopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scopes_Order_By>>;
  where?: InputMaybe<Scopes_Bool_Exp>;
};

/** aggregated selection of "model_lines_to_branches" */
export type Model_Lines_To_Branches_Aggregate = {
  __typename?: 'model_lines_to_branches_aggregate';
  aggregate?: Maybe<Model_Lines_To_Branches_Aggregate_Fields>;
  nodes: Array<Model_Lines_To_Branches>;
};

export type Model_Lines_To_Branches_Aggregate_Bool_Exp = {
  count?: InputMaybe<Model_Lines_To_Branches_Aggregate_Bool_Exp_Count>;
};

export type Model_Lines_To_Branches_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Model_Lines_To_Branches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "model_lines_to_branches" */
export type Model_Lines_To_Branches_Aggregate_Fields = {
  __typename?: 'model_lines_to_branches_aggregate_fields';
  avg?: Maybe<Model_Lines_To_Branches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Model_Lines_To_Branches_Max_Fields>;
  min?: Maybe<Model_Lines_To_Branches_Min_Fields>;
  stddev?: Maybe<Model_Lines_To_Branches_Stddev_Fields>;
  stddev_pop?: Maybe<Model_Lines_To_Branches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Model_Lines_To_Branches_Stddev_Samp_Fields>;
  sum?: Maybe<Model_Lines_To_Branches_Sum_Fields>;
  var_pop?: Maybe<Model_Lines_To_Branches_Var_Pop_Fields>;
  var_samp?: Maybe<Model_Lines_To_Branches_Var_Samp_Fields>;
  variance?: Maybe<Model_Lines_To_Branches_Variance_Fields>;
};


/** aggregate fields of "model_lines_to_branches" */
export type Model_Lines_To_Branches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Lines_To_Branches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Aggregate_Order_By = {
  avg?: InputMaybe<Model_Lines_To_Branches_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Model_Lines_To_Branches_Max_Order_By>;
  min?: InputMaybe<Model_Lines_To_Branches_Min_Order_By>;
  stddev?: InputMaybe<Model_Lines_To_Branches_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Model_Lines_To_Branches_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Model_Lines_To_Branches_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Model_Lines_To_Branches_Sum_Order_By>;
  var_pop?: InputMaybe<Model_Lines_To_Branches_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Model_Lines_To_Branches_Var_Samp_Order_By>;
  variance?: InputMaybe<Model_Lines_To_Branches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Arr_Rel_Insert_Input = {
  data: Array<Model_Lines_To_Branches_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Model_Lines_To_Branches_On_Conflict>;
};

/** aggregate avg on columns */
export type Model_Lines_To_Branches_Avg_Fields = {
  __typename?: 'model_lines_to_branches_avg_fields';
  segment_index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Avg_Order_By = {
  segment_index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "model_lines_to_branches". All fields are combined with a logical 'AND'. */
export type Model_Lines_To_Branches_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Lines_To_Branches_Bool_Exp>>;
  _not?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Lines_To_Branches_Bool_Exp>>;
  branch?: InputMaybe<Branches_Bool_Exp>;
  branch_id?: InputMaybe<String_Comparison_Exp>;
  confidence?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  facility_id?: InputMaybe<String_Comparison_Exp>;
  gis_source_key?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scopes?: InputMaybe<Scopes_Bool_Exp>;
  scopes_aggregate?: InputMaybe<Scopes_Aggregate_Bool_Exp>;
  segment_index?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "model_lines_to_branches" */
export enum Model_Lines_To_Branches_Constraint {
  /** unique or primary key constraint on columns "branch_id", "facility_id", "region" */
  ModelLinesToBranchesPkey = 'model_lines_to_branches_pkey',
  /** unique or primary key constraint on columns "facility_id", "segment_index", "region" */
  ModelLinesToBranchesSegmentIndexKey = 'model_lines_to_branches_segment_index_key'
}

/** input type for incrementing numeric columns in table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Inc_Input = {
  segment_index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Insert_Input = {
  branch?: InputMaybe<Branches_Obj_Rel_Insert_Input>;
  branch_id?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  gis_source_key?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scopes_Arr_Rel_Insert_Input>;
  segment_index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Model_Lines_To_Branches_Max_Fields = {
  __typename?: 'model_lines_to_branches_max_fields';
  branch_id?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  gis_source_key?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segment_index?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Max_Order_By = {
  branch_id?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  gis_source_key?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Model_Lines_To_Branches_Min_Fields = {
  __typename?: 'model_lines_to_branches_min_fields';
  branch_id?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  gis_source_key?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  segment_index?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Min_Order_By = {
  branch_id?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  gis_source_key?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Mutation_Response = {
  __typename?: 'model_lines_to_branches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Lines_To_Branches>;
};

/** on_conflict condition type for table "model_lines_to_branches" */
export type Model_Lines_To_Branches_On_Conflict = {
  constraint: Model_Lines_To_Branches_Constraint;
  update_columns?: Array<Model_Lines_To_Branches_Update_Column>;
  where?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
};

/** Ordering options when selecting data from "model_lines_to_branches". */
export type Model_Lines_To_Branches_Order_By = {
  branch?: InputMaybe<Branches_Order_By>;
  branch_id?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  gis_source_key?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scopes_aggregate?: InputMaybe<Scopes_Aggregate_Order_By>;
  segment_index?: InputMaybe<Order_By>;
};

/** primary key columns input for table: model_lines_to_branches */
export type Model_Lines_To_Branches_Pk_Columns_Input = {
  branch_id: Scalars['String']['input'];
  facility_id: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

/** select columns of table "model_lines_to_branches" */
export enum Model_Lines_To_Branches_Select_Column {
  /** column name */
  BranchId = 'branch_id',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  GisSourceKey = 'gis_source_key',
  /** column name */
  Region = 'region',
  /** column name */
  SegmentIndex = 'segment_index'
}

/** input type for updating data in table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Set_Input = {
  branch_id?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  gis_source_key?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  segment_index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Model_Lines_To_Branches_Stddev_Fields = {
  __typename?: 'model_lines_to_branches_stddev_fields';
  segment_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Stddev_Order_By = {
  segment_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Model_Lines_To_Branches_Stddev_Pop_Fields = {
  __typename?: 'model_lines_to_branches_stddev_pop_fields';
  segment_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Stddev_Pop_Order_By = {
  segment_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Model_Lines_To_Branches_Stddev_Samp_Fields = {
  __typename?: 'model_lines_to_branches_stddev_samp_fields';
  segment_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Stddev_Samp_Order_By = {
  segment_index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Lines_To_Branches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Lines_To_Branches_Stream_Cursor_Value_Input = {
  branch_id?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  gis_source_key?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  segment_index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Model_Lines_To_Branches_Sum_Fields = {
  __typename?: 'model_lines_to_branches_sum_fields';
  segment_index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Sum_Order_By = {
  segment_index?: InputMaybe<Order_By>;
};

/** update columns of table "model_lines_to_branches" */
export enum Model_Lines_To_Branches_Update_Column {
  /** column name */
  BranchId = 'branch_id',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  GisSourceKey = 'gis_source_key',
  /** column name */
  Region = 'region',
  /** column name */
  SegmentIndex = 'segment_index'
}

export type Model_Lines_To_Branches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Lines_To_Branches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Lines_To_Branches_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Lines_To_Branches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Model_Lines_To_Branches_Var_Pop_Fields = {
  __typename?: 'model_lines_to_branches_var_pop_fields';
  segment_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Var_Pop_Order_By = {
  segment_index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Model_Lines_To_Branches_Var_Samp_Fields = {
  __typename?: 'model_lines_to_branches_var_samp_fields';
  segment_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Var_Samp_Order_By = {
  segment_index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Model_Lines_To_Branches_Variance_Fields = {
  __typename?: 'model_lines_to_branches_variance_fields';
  segment_index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "model_lines_to_branches" */
export type Model_Lines_To_Branches_Variance_Order_By = {
  segment_index?: InputMaybe<Order_By>;
};

/** columns and relationships of "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses = {
  __typename?: 'model_lines_to_missing_buses';
  circuit_id: Scalars['String']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  facility_id: Scalars['String']['output'];
  /** An object relationship */
  from_bus?: Maybe<Buses>;
  from_bus_id: Scalars['String']['output'];
  /** An object relationship */
  from_bus_without_overrides: Buses_Without_Overrides;
  from_nira_bus_id: Scalars['String']['output'];
  line_length: Scalars['numeric']['output'];
  missing_bus_id: Scalars['String']['output'];
  queued_projects_at_missing_bus?: Maybe<Scalars['String']['output']>;
  rating: Scalars['numeric']['output'];
  scope: Scalars['String']['output'];
  scope_view: Scalars['String']['output'];
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
  voltage: Scalars['numeric']['output'];
};


/** columns and relationships of "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_BusesUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_BusesUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses_Aggregate = {
  __typename?: 'model_lines_to_missing_buses_aggregate';
  aggregate?: Maybe<Model_Lines_To_Missing_Buses_Aggregate_Fields>;
  nodes: Array<Model_Lines_To_Missing_Buses>;
};

/** aggregate fields of "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses_Aggregate_Fields = {
  __typename?: 'model_lines_to_missing_buses_aggregate_fields';
  avg?: Maybe<Model_Lines_To_Missing_Buses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Model_Lines_To_Missing_Buses_Max_Fields>;
  min?: Maybe<Model_Lines_To_Missing_Buses_Min_Fields>;
  stddev?: Maybe<Model_Lines_To_Missing_Buses_Stddev_Fields>;
  stddev_pop?: Maybe<Model_Lines_To_Missing_Buses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Model_Lines_To_Missing_Buses_Stddev_Samp_Fields>;
  sum?: Maybe<Model_Lines_To_Missing_Buses_Sum_Fields>;
  var_pop?: Maybe<Model_Lines_To_Missing_Buses_Var_Pop_Fields>;
  var_samp?: Maybe<Model_Lines_To_Missing_Buses_Var_Samp_Fields>;
  variance?: Maybe<Model_Lines_To_Missing_Buses_Variance_Fields>;
};


/** aggregate fields of "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Model_Lines_To_Missing_Buses_Avg_Fields = {
  __typename?: 'model_lines_to_missing_buses_avg_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "model_lines_to_missing_buses". All fields are combined with a logical 'AND'. */
export type Model_Lines_To_Missing_Buses_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Bool_Exp>>;
  _not?: InputMaybe<Model_Lines_To_Missing_Buses_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Bool_Exp>>;
  circuit_id?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  facility_id?: InputMaybe<String_Comparison_Exp>;
  from_bus?: InputMaybe<Buses_Bool_Exp>;
  from_bus_id?: InputMaybe<String_Comparison_Exp>;
  from_bus_without_overrides?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
  from_nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  line_length?: InputMaybe<Numeric_Comparison_Exp>;
  missing_bus_id?: InputMaybe<String_Comparison_Exp>;
  queued_projects_at_missing_bus?: InputMaybe<String_Comparison_Exp>;
  rating?: InputMaybe<Numeric_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
  voltage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "model_lines_to_missing_buses" */
export enum Model_Lines_To_Missing_Buses_Constraint {
  /** unique or primary key constraint on columns "scope", "facility_id", "scope_view" */
  ModelLinesToMissingBusesPkey = 'model_lines_to_missing_buses_pkey'
}

/** input type for incrementing numeric columns in table "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses_Inc_Input = {
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses_Insert_Input = {
  circuit_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  from_bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  from_bus_id?: InputMaybe<Scalars['String']['input']>;
  from_bus_without_overrides?: InputMaybe<Buses_Without_Overrides_Obj_Rel_Insert_Input>;
  from_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  missing_bus_id?: InputMaybe<Scalars['String']['input']>;
  queued_projects_at_missing_bus?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Model_Lines_To_Missing_Buses_Max_Fields = {
  __typename?: 'model_lines_to_missing_buses_max_fields';
  circuit_id?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  from_bus_id?: Maybe<Scalars['String']['output']>;
  from_nira_bus_id?: Maybe<Scalars['String']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  missing_bus_id?: Maybe<Scalars['String']['output']>;
  queued_projects_at_missing_bus?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Model_Lines_To_Missing_Buses_Min_Fields = {
  __typename?: 'model_lines_to_missing_buses_min_fields';
  circuit_id?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  from_bus_id?: Maybe<Scalars['String']['output']>;
  from_nira_bus_id?: Maybe<Scalars['String']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  missing_bus_id?: Maybe<Scalars['String']['output']>;
  queued_projects_at_missing_bus?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses_Mutation_Response = {
  __typename?: 'model_lines_to_missing_buses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Lines_To_Missing_Buses>;
};

/** on_conflict condition type for table "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses_On_Conflict = {
  constraint: Model_Lines_To_Missing_Buses_Constraint;
  update_columns?: Array<Model_Lines_To_Missing_Buses_Update_Column>;
  where?: InputMaybe<Model_Lines_To_Missing_Buses_Bool_Exp>;
};

/** Ordering options when selecting data from "model_lines_to_missing_buses". */
export type Model_Lines_To_Missing_Buses_Order_By = {
  circuit_id?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  from_bus?: InputMaybe<Buses_Order_By>;
  from_bus_id?: InputMaybe<Order_By>;
  from_bus_without_overrides?: InputMaybe<Buses_Without_Overrides_Order_By>;
  from_nira_bus_id?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  missing_bus_id?: InputMaybe<Order_By>;
  queued_projects_at_missing_bus?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
  voltage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: model_lines_to_missing_buses */
export type Model_Lines_To_Missing_Buses_Pk_Columns_Input = {
  facility_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};

/** select columns of table "model_lines_to_missing_buses" */
export enum Model_Lines_To_Missing_Buses_Select_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FromBusId = 'from_bus_id',
  /** column name */
  FromNiraBusId = 'from_nira_bus_id',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  MissingBusId = 'missing_bus_id',
  /** column name */
  QueuedProjectsAtMissingBus = 'queued_projects_at_missing_bus',
  /** column name */
  Rating = 'rating',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  Voltage = 'voltage'
}

/** input type for updating data in table "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses_Set_Input = {
  circuit_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  from_bus_id?: InputMaybe<Scalars['String']['input']>;
  from_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  missing_bus_id?: InputMaybe<Scalars['String']['input']>;
  queued_projects_at_missing_bus?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Model_Lines_To_Missing_Buses_Stddev_Fields = {
  __typename?: 'model_lines_to_missing_buses_stddev_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Model_Lines_To_Missing_Buses_Stddev_Pop_Fields = {
  __typename?: 'model_lines_to_missing_buses_stddev_pop_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Model_Lines_To_Missing_Buses_Stddev_Samp_Fields = {
  __typename?: 'model_lines_to_missing_buses_stddev_samp_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "model_lines_to_missing_buses" */
export type Model_Lines_To_Missing_Buses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Lines_To_Missing_Buses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Lines_To_Missing_Buses_Stream_Cursor_Value_Input = {
  circuit_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  from_bus_id?: InputMaybe<Scalars['String']['input']>;
  from_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  missing_bus_id?: InputMaybe<Scalars['String']['input']>;
  queued_projects_at_missing_bus?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['numeric']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  voltage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Model_Lines_To_Missing_Buses_Sum_Fields = {
  __typename?: 'model_lines_to_missing_buses_sum_fields';
  line_length?: Maybe<Scalars['numeric']['output']>;
  rating?: Maybe<Scalars['numeric']['output']>;
  voltage?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "model_lines_to_missing_buses" */
export enum Model_Lines_To_Missing_Buses_Update_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FromBusId = 'from_bus_id',
  /** column name */
  FromNiraBusId = 'from_nira_bus_id',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  MissingBusId = 'missing_bus_id',
  /** column name */
  QueuedProjectsAtMissingBus = 'queued_projects_at_missing_bus',
  /** column name */
  Rating = 'rating',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  Voltage = 'voltage'
}

export type Model_Lines_To_Missing_Buses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Lines_To_Missing_Buses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Lines_To_Missing_Buses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Lines_To_Missing_Buses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Model_Lines_To_Missing_Buses_Var_Pop_Fields = {
  __typename?: 'model_lines_to_missing_buses_var_pop_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Model_Lines_To_Missing_Buses_Var_Samp_Fields = {
  __typename?: 'model_lines_to_missing_buses_var_samp_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Model_Lines_To_Missing_Buses_Variance_Fields = {
  __typename?: 'model_lines_to_missing_buses_variance_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "model_lines" */
export enum Model_Lines_Update_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FromBusId = 'from_bus_id',
  /** column name */
  FromNiraBusId = 'from_nira_bus_id',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  Rating = 'rating',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  ToBusId = 'to_bus_id',
  /** column name */
  ToNiraBusId = 'to_nira_bus_id',
  /** column name */
  Voltage = 'voltage'
}

export type Model_Lines_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Lines_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Lines_Set_Input>;
  /** filter the rows which have to be updated */
  where: Model_Lines_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Model_Lines_Var_Pop_Fields = {
  __typename?: 'model_lines_var_pop_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Model_Lines_Var_Samp_Fields = {
  __typename?: 'model_lines_var_samp_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Model_Lines_Variance_Fields = {
  __typename?: 'model_lines_variance_fields';
  line_length?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "additional_column_configs" */
  delete_additional_column_configs?: Maybe<Additional_Column_Configs_Mutation_Response>;
  /** delete single row from the table: "additional_column_configs" */
  delete_additional_column_configs_by_pk?: Maybe<Additional_Column_Configs>;
  /** delete data from the table: "admin_app.audit_log" */
  delete_admin_app_audit_log?: Maybe<Admin_App_Audit_Log_Mutation_Response>;
  /** delete single row from the table: "admin_app.audit_log" */
  delete_admin_app_audit_log_by_pk?: Maybe<Admin_App_Audit_Log>;
  /** delete data from the table: "admin_app.audit_log_targets" */
  delete_admin_app_audit_log_targets?: Maybe<Admin_App_Audit_Log_Targets_Mutation_Response>;
  /** delete single row from the table: "admin_app.audit_log_targets" */
  delete_admin_app_audit_log_targets_by_pk?: Maybe<Admin_App_Audit_Log_Targets>;
  /** delete data from the table: "advanced_studies" */
  delete_advanced_studies?: Maybe<Advanced_Studies_Mutation_Response>;
  /** delete single row from the table: "advanced_studies" */
  delete_advanced_studies_by_pk?: Maybe<Advanced_Studies>;
  /** delete data from the table: "advanced_study_constraint_stacks" */
  delete_advanced_study_constraint_stacks?: Maybe<Advanced_Study_Constraint_Stacks_Mutation_Response>;
  /** delete single row from the table: "advanced_study_constraint_stacks" */
  delete_advanced_study_constraint_stacks_by_pk?: Maybe<Advanced_Study_Constraint_Stacks>;
  /** delete data from the table: "advanced_study_loads" */
  delete_advanced_study_loads?: Maybe<Advanced_Study_Loads_Mutation_Response>;
  /** delete single row from the table: "advanced_study_loads" */
  delete_advanced_study_loads_by_pk?: Maybe<Advanced_Study_Loads>;
  /** delete data from the table: "all_projects" */
  delete_all_projects?: Maybe<All_Projects_Mutation_Response>;
  /** delete single row from the table: "all_projects" */
  delete_all_projects_by_pk?: Maybe<All_Projects>;
  /** delete data from the table: "branches" */
  delete_branches?: Maybe<Branches_Mutation_Response>;
  /** delete single row from the table: "branches" */
  delete_branches_by_pk?: Maybe<Branches>;
  /** delete data from the table: "brand_colors" */
  delete_brand_colors?: Maybe<Brand_Colors_Mutation_Response>;
  /** delete single row from the table: "brand_colors" */
  delete_brand_colors_by_pk?: Maybe<Brand_Colors>;
  /** delete data from the table: "bus_overrides" */
  delete_bus_overrides?: Maybe<Bus_Overrides_Mutation_Response>;
  /** delete single row from the table: "bus_overrides" */
  delete_bus_overrides_by_pk?: Maybe<Bus_Overrides>;
  /** delete data from the table: "buses_to_scopes" */
  delete_buses_to_scopes?: Maybe<Buses_To_Scopes_Mutation_Response>;
  /** delete single row from the table: "buses_to_scopes" */
  delete_buses_to_scopes_by_pk?: Maybe<Buses_To_Scopes>;
  /** delete data from the table: "buses_without_overrides" */
  delete_buses_without_overrides?: Maybe<Buses_Without_Overrides_Mutation_Response>;
  /** delete single row from the table: "buses_without_overrides" */
  delete_buses_without_overrides_by_pk?: Maybe<Buses_Without_Overrides>;
  /** delete data from the table: "capacity_costs" */
  delete_capacity_costs?: Maybe<Capacity_Costs_Mutation_Response>;
  /** delete single row from the table: "capacity_costs" */
  delete_capacity_costs_by_pk?: Maybe<Capacity_Costs>;
  /** delete data from the table: "ceii_access" */
  delete_ceii_access?: Maybe<Ceii_Access_Mutation_Response>;
  /** delete single row from the table: "ceii_access" */
  delete_ceii_access_by_pk?: Maybe<Ceii_Access>;
  /** delete data from the table: "constraint_stacks" */
  delete_constraint_stacks?: Maybe<Constraint_Stacks_Mutation_Response>;
  /** delete single row from the table: "constraint_stacks" */
  delete_constraint_stacks_by_pk?: Maybe<Constraint_Stacks>;
  /** delete data from the table: "constraint_types" */
  delete_constraint_types?: Maybe<Constraint_Types_Mutation_Response>;
  /** delete single row from the table: "constraint_types" */
  delete_constraint_types_by_pk?: Maybe<Constraint_Types>;
  /** delete data from the table: "custom_upgrade_files" */
  delete_custom_upgrade_files?: Maybe<Custom_Upgrade_Files_Mutation_Response>;
  /** delete single row from the table: "custom_upgrade_files" */
  delete_custom_upgrade_files_by_pk?: Maybe<Custom_Upgrade_Files>;
  /** delete data from the table: "custom_upgrade_model_set_validation_failures" */
  delete_custom_upgrade_model_set_validation_failures?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Mutation_Response>;
  /** delete single row from the table: "custom_upgrade_model_set_validation_failures" */
  delete_custom_upgrade_model_set_validation_failures_by_pk?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures>;
  /** delete data from the table: "custom_upgrade_model_set_validations" */
  delete_custom_upgrade_model_set_validations?: Maybe<Custom_Upgrade_Model_Set_Validations_Mutation_Response>;
  /** delete single row from the table: "custom_upgrade_model_set_validations" */
  delete_custom_upgrade_model_set_validations_by_pk?: Maybe<Custom_Upgrade_Model_Set_Validations>;
  /** delete data from the table: "custom_upgrade_validation_failure_codes" */
  delete_custom_upgrade_validation_failure_codes?: Maybe<Custom_Upgrade_Validation_Failure_Codes_Mutation_Response>;
  /** delete single row from the table: "custom_upgrade_validation_failure_codes" */
  delete_custom_upgrade_validation_failure_codes_by_pk?: Maybe<Custom_Upgrade_Validation_Failure_Codes>;
  /** delete data from the table: "custom_upgrade_validation_failure_severities" */
  delete_custom_upgrade_validation_failure_severities?: Maybe<Custom_Upgrade_Validation_Failure_Severities_Mutation_Response>;
  /** delete single row from the table: "custom_upgrade_validation_failure_severities" */
  delete_custom_upgrade_validation_failure_severities_by_pk?: Maybe<Custom_Upgrade_Validation_Failure_Severities>;
  /** delete data from the table: "custom_upgrade_validation_statuses" */
  delete_custom_upgrade_validation_statuses?: Maybe<Custom_Upgrade_Validation_Statuses_Mutation_Response>;
  /** delete single row from the table: "custom_upgrade_validation_statuses" */
  delete_custom_upgrade_validation_statuses_by_pk?: Maybe<Custom_Upgrade_Validation_Statuses>;
  /** delete data from the table: "custom_upgrades" */
  delete_custom_upgrades?: Maybe<Custom_Upgrades_Mutation_Response>;
  /** delete single row from the table: "custom_upgrades" */
  delete_custom_upgrades_by_pk?: Maybe<Custom_Upgrades>;
  /** delete data from the table: "data_versions" */
  delete_data_versions?: Maybe<Data_Versions_Mutation_Response>;
  /** delete single row from the table: "data_versions" */
  delete_data_versions_by_pk?: Maybe<Data_Versions>;
  /** delete data from the table: "external_api_scopes" */
  delete_external_api_scopes?: Maybe<External_Api_Scopes_Mutation_Response>;
  /** delete data from the table: "favorite_buses" */
  delete_favorite_buses?: Maybe<Favorite_Buses_Mutation_Response>;
  /** delete single row from the table: "favorite_buses" */
  delete_favorite_buses_by_pk?: Maybe<Favorite_Buses>;
  /** delete data from the table: "gtc_exposure" */
  delete_gtc_exposure?: Maybe<Gtc_Exposure_Mutation_Response>;
  /** delete single row from the table: "gtc_exposure" */
  delete_gtc_exposure_by_pk?: Maybe<Gtc_Exposure>;
  /** delete data from the table: "in_queue_cluster_model_set_statuses" */
  delete_in_queue_cluster_model_set_statuses?: Maybe<In_Queue_Cluster_Model_Set_Statuses_Mutation_Response>;
  /** delete single row from the table: "in_queue_cluster_model_set_statuses" */
  delete_in_queue_cluster_model_set_statuses_by_pk?: Maybe<In_Queue_Cluster_Model_Set_Statuses>;
  /** delete data from the table: "in_queue_cluster_model_sets" */
  delete_in_queue_cluster_model_sets?: Maybe<In_Queue_Cluster_Model_Sets_Mutation_Response>;
  /** delete single row from the table: "in_queue_cluster_model_sets" */
  delete_in_queue_cluster_model_sets_by_pk?: Maybe<In_Queue_Cluster_Model_Sets>;
  /** delete data from the table: "in_queue_cluster_statuses" */
  delete_in_queue_cluster_statuses?: Maybe<In_Queue_Cluster_Statuses_Mutation_Response>;
  /** delete single row from the table: "in_queue_cluster_statuses" */
  delete_in_queue_cluster_statuses_by_pk?: Maybe<In_Queue_Cluster_Statuses>;
  /** delete data from the table: "in_queue_clusters" */
  delete_in_queue_clusters?: Maybe<In_Queue_Clusters_Mutation_Response>;
  /** delete single row from the table: "in_queue_clusters" */
  delete_in_queue_clusters_by_pk?: Maybe<In_Queue_Clusters>;
  /** delete data from the table: "in_queue_model_pois" */
  delete_in_queue_model_pois?: Maybe<In_Queue_Model_Pois_Mutation_Response>;
  /** delete single row from the table: "in_queue_model_pois" */
  delete_in_queue_model_pois_by_pk?: Maybe<In_Queue_Model_Pois>;
  /** delete data from the table: "in_queue_model_variants" */
  delete_in_queue_model_variants?: Maybe<In_Queue_Model_Variants_Mutation_Response>;
  /** delete single row from the table: "in_queue_model_variants" */
  delete_in_queue_model_variants_by_pk?: Maybe<In_Queue_Model_Variants>;
  /** delete data from the table: "in_queue_region_model_variants" */
  delete_in_queue_region_model_variants?: Maybe<In_Queue_Region_Model_Variants_Mutation_Response>;
  /** delete single row from the table: "in_queue_region_model_variants" */
  delete_in_queue_region_model_variants_by_pk?: Maybe<In_Queue_Region_Model_Variants>;
  /** delete data from the table: "in_queue_speculative_projects" */
  delete_in_queue_speculative_projects?: Maybe<In_Queue_Speculative_Projects_Mutation_Response>;
  /** delete single row from the table: "in_queue_speculative_projects" */
  delete_in_queue_speculative_projects_by_pk?: Maybe<In_Queue_Speculative_Projects>;
  /** delete data from the table: "in_queue_subscription_add_ons" */
  delete_in_queue_subscription_add_ons?: Maybe<In_Queue_Subscription_Add_Ons_Mutation_Response>;
  /** delete single row from the table: "in_queue_subscription_add_ons" */
  delete_in_queue_subscription_add_ons_by_pk?: Maybe<In_Queue_Subscription_Add_Ons>;
  /** delete data from the table: "in_queue_subscriptions" */
  delete_in_queue_subscriptions?: Maybe<In_Queue_Subscriptions_Mutation_Response>;
  /** delete single row from the table: "in_queue_subscriptions" */
  delete_in_queue_subscriptions_by_pk?: Maybe<In_Queue_Subscriptions>;
  /** delete data from the table: "line_capacity_costs" */
  delete_line_capacity_costs?: Maybe<Line_Capacity_Costs_Mutation_Response>;
  /** delete single row from the table: "line_capacity_costs" */
  delete_line_capacity_costs_by_pk?: Maybe<Line_Capacity_Costs>;
  /** delete data from the table: "line_constraint_stacks" */
  delete_line_constraint_stacks?: Maybe<Line_Constraint_Stacks_Mutation_Response>;
  /** delete single row from the table: "line_constraint_stacks" */
  delete_line_constraint_stacks_by_pk?: Maybe<Line_Constraint_Stacks>;
  /** delete data from the table: "model_generator_facility_dfax" */
  delete_model_generator_facility_dfax?: Maybe<Model_Generator_Facility_Dfax_Mutation_Response>;
  /** delete single row from the table: "model_generator_facility_dfax" */
  delete_model_generator_facility_dfax_by_pk?: Maybe<Model_Generator_Facility_Dfax>;
  /** delete data from the table: "model_generators" */
  delete_model_generators?: Maybe<Model_Generators_Mutation_Response>;
  /** delete single row from the table: "model_generators" */
  delete_model_generators_by_pk?: Maybe<Model_Generators>;
  /** delete data from the table: "model_lines" */
  delete_model_lines?: Maybe<Model_Lines_Mutation_Response>;
  /** delete single row from the table: "model_lines" */
  delete_model_lines_by_pk?: Maybe<Model_Lines>;
  /** delete data from the table: "model_lines_to_branches" */
  delete_model_lines_to_branches?: Maybe<Model_Lines_To_Branches_Mutation_Response>;
  /** delete single row from the table: "model_lines_to_branches" */
  delete_model_lines_to_branches_by_pk?: Maybe<Model_Lines_To_Branches>;
  /** delete data from the table: "model_lines_to_missing_buses" */
  delete_model_lines_to_missing_buses?: Maybe<Model_Lines_To_Missing_Buses_Mutation_Response>;
  /** delete single row from the table: "model_lines_to_missing_buses" */
  delete_model_lines_to_missing_buses_by_pk?: Maybe<Model_Lines_To_Missing_Buses>;
  /** delete data from the table: "planned_interconnection_locations" */
  delete_planned_interconnection_locations?: Maybe<Planned_Interconnection_Locations_Mutation_Response>;
  /** delete single row from the table: "planned_interconnection_locations" */
  delete_planned_interconnection_locations_by_pk?: Maybe<Planned_Interconnection_Locations>;
  /** delete data from the table: "project_additional_costs" */
  delete_project_additional_costs?: Maybe<Project_Additional_Costs_Mutation_Response>;
  /** delete single row from the table: "project_additional_costs" */
  delete_project_additional_costs_by_pk?: Maybe<Project_Additional_Costs>;
  /** delete data from the table: "project_configurations" */
  delete_project_configurations?: Maybe<Project_Configurations_Mutation_Response>;
  /** delete single row from the table: "project_configurations" */
  delete_project_configurations_by_pk?: Maybe<Project_Configurations>;
  /** delete data from the table: "project_cost_sources" */
  delete_project_cost_sources?: Maybe<Project_Cost_Sources_Mutation_Response>;
  /** delete single row from the table: "project_cost_sources" */
  delete_project_cost_sources_by_pk?: Maybe<Project_Cost_Sources>;
  /** delete data from the table: "project_cost_types" */
  delete_project_cost_types?: Maybe<Project_Cost_Types_Mutation_Response>;
  /** delete single row from the table: "project_cost_types" */
  delete_project_cost_types_by_pk?: Maybe<Project_Cost_Types>;
  /** delete data from the table: "project_tag_assignments" */
  delete_project_tag_assignments?: Maybe<Project_Tag_Assignments_Mutation_Response>;
  /** delete single row from the table: "project_tag_assignments" */
  delete_project_tag_assignments_by_pk?: Maybe<Project_Tag_Assignments>;
  /** delete data from the table: "project_tags" */
  delete_project_tags?: Maybe<Project_Tags_Mutation_Response>;
  /** delete single row from the table: "project_tags" */
  delete_project_tags_by_pk?: Maybe<Project_Tags>;
  /** delete data from the table: "queue_project_connection_points" */
  delete_queue_project_connection_points?: Maybe<Queue_Project_Connection_Points_Mutation_Response>;
  /** delete single row from the table: "queue_project_connection_points" */
  delete_queue_project_connection_points_by_pk?: Maybe<Queue_Project_Connection_Points>;
  /** delete data from the table: "queue_project_connection_types" */
  delete_queue_project_connection_types?: Maybe<Queue_Project_Connection_Types_Mutation_Response>;
  /** delete single row from the table: "queue_project_connection_types" */
  delete_queue_project_connection_types_by_pk?: Maybe<Queue_Project_Connection_Types>;
  /** delete data from the table: "queue_project_facility_dfax" */
  delete_queue_project_facility_dfax?: Maybe<Queue_Project_Facility_Dfax_Mutation_Response>;
  /** delete single row from the table: "queue_project_facility_dfax" */
  delete_queue_project_facility_dfax_by_pk?: Maybe<Queue_Project_Facility_Dfax>;
  /** delete data from the table: "queue_project_hops" */
  delete_queue_project_hops?: Maybe<Queue_Project_Hops_Mutation_Response>;
  /** delete single row from the table: "queue_project_hops" */
  delete_queue_project_hops_by_pk?: Maybe<Queue_Project_Hops>;
  /** delete data from the table: "queue_projects" */
  delete_queue_projects?: Maybe<Queue_Projects_Mutation_Response>;
  /** delete single row from the table: "queue_projects" */
  delete_queue_projects_by_pk?: Maybe<Queue_Projects>;
  /** delete data from the table: "scenario_allocated_upgrades" */
  delete_scenario_allocated_upgrades?: Maybe<Scenario_Allocated_Upgrades_Mutation_Response>;
  /** delete single row from the table: "scenario_allocated_upgrades" */
  delete_scenario_allocated_upgrades_by_pk?: Maybe<Scenario_Allocated_Upgrades>;
  /** delete data from the table: "scenario_configurations" */
  delete_scenario_configurations?: Maybe<Scenario_Configurations_Mutation_Response>;
  /** delete single row from the table: "scenario_configurations" */
  delete_scenario_configurations_by_pk?: Maybe<Scenario_Configurations>;
  /** delete data from the table: "scenario_constraints" */
  delete_scenario_constraints?: Maybe<Scenario_Constraints_Mutation_Response>;
  /** delete single row from the table: "scenario_constraints" */
  delete_scenario_constraints_by_pk?: Maybe<Scenario_Constraints>;
  /** delete data from the table: "scenario_origins" */
  delete_scenario_origins?: Maybe<Scenario_Origins_Mutation_Response>;
  /** delete single row from the table: "scenario_origins" */
  delete_scenario_origins_by_pk?: Maybe<Scenario_Origins>;
  /** delete data from the table: "scenario_project_ranks" */
  delete_scenario_project_ranks?: Maybe<Scenario_Project_Ranks_Mutation_Response>;
  /** delete single row from the table: "scenario_project_ranks" */
  delete_scenario_project_ranks_by_pk?: Maybe<Scenario_Project_Ranks>;
  /** delete data from the table: "scenario_projects" */
  delete_scenario_projects?: Maybe<Scenario_Projects_Mutation_Response>;
  /** delete single row from the table: "scenario_projects" */
  delete_scenario_projects_by_pk?: Maybe<Scenario_Projects>;
  /** delete data from the table: "scenario_statuses" */
  delete_scenario_statuses?: Maybe<Scenario_Statuses_Mutation_Response>;
  /** delete single row from the table: "scenario_statuses" */
  delete_scenario_statuses_by_pk?: Maybe<Scenario_Statuses>;
  /** delete data from the table: "scenarios" */
  delete_scenarios?: Maybe<Scenarios_Mutation_Response>;
  /** delete single row from the table: "scenarios" */
  delete_scenarios_by_pk?: Maybe<Scenarios>;
  /** delete data from the table: "scopes" */
  delete_scopes?: Maybe<Scopes_Mutation_Response>;
  /** delete single row from the table: "scopes" */
  delete_scopes_by_pk?: Maybe<Scopes>;
  /** delete data from the table: "screening_views" */
  delete_screening_views?: Maybe<Screening_Views_Mutation_Response>;
  /** delete single row from the table: "screening_views" */
  delete_screening_views_by_pk?: Maybe<Screening_Views>;
  /** delete data from the table: "sis_project_cost_type_metadata" */
  delete_sis_project_cost_type_metadata?: Maybe<Sis_Project_Cost_Type_Metadata_Mutation_Response>;
  /** delete single row from the table: "sis_project_cost_type_metadata" */
  delete_sis_project_cost_type_metadata_by_pk?: Maybe<Sis_Project_Cost_Type_Metadata>;
  /** delete data from the table: "sis_report_postings" */
  delete_sis_report_postings?: Maybe<Sis_Report_Postings_Mutation_Response>;
  /** delete single row from the table: "sis_report_postings" */
  delete_sis_report_postings_by_pk?: Maybe<Sis_Report_Postings>;
  /** delete data from the table: "subscription_add_ons" */
  delete_subscription_add_ons?: Maybe<Subscription_Add_Ons_Mutation_Response>;
  /** delete single row from the table: "subscription_add_ons" */
  delete_subscription_add_ons_by_pk?: Maybe<Subscription_Add_Ons>;
  /** delete data from the table: "subscriptions" */
  delete_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** delete single row from the table: "subscriptions" */
  delete_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** delete data from the table: "teams" */
  delete_teams?: Maybe<Teams_Mutation_Response>;
  /** delete single row from the table: "teams" */
  delete_teams_by_pk?: Maybe<Teams>;
  /** delete data from the table: "tracked_projects" */
  delete_tracked_projects?: Maybe<Tracked_Projects_Mutation_Response>;
  /** delete single row from the table: "tracked_projects" */
  delete_tracked_projects_by_pk?: Maybe<Tracked_Projects>;
  /** delete data from the table: "unlocked_buses" */
  delete_unlocked_buses?: Maybe<Unlocked_Buses_Mutation_Response>;
  /** delete single row from the table: "unlocked_buses" */
  delete_unlocked_buses_by_pk?: Maybe<Unlocked_Buses>;
  /** delete data from the table: "user_scope_configs" */
  delete_user_scope_configs?: Maybe<User_Scope_Configs_Mutation_Response>;
  /** delete single row from the table: "user_scope_configs" */
  delete_user_scope_configs_by_pk?: Maybe<User_Scope_Configs>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "additional_column_configs" */
  insert_additional_column_configs?: Maybe<Additional_Column_Configs_Mutation_Response>;
  /** insert a single row into the table: "additional_column_configs" */
  insert_additional_column_configs_one?: Maybe<Additional_Column_Configs>;
  /** insert data into the table: "admin_app.audit_log" */
  insert_admin_app_audit_log?: Maybe<Admin_App_Audit_Log_Mutation_Response>;
  /** insert a single row into the table: "admin_app.audit_log" */
  insert_admin_app_audit_log_one?: Maybe<Admin_App_Audit_Log>;
  /** insert data into the table: "admin_app.audit_log_targets" */
  insert_admin_app_audit_log_targets?: Maybe<Admin_App_Audit_Log_Targets_Mutation_Response>;
  /** insert a single row into the table: "admin_app.audit_log_targets" */
  insert_admin_app_audit_log_targets_one?: Maybe<Admin_App_Audit_Log_Targets>;
  /** insert data into the table: "advanced_studies" */
  insert_advanced_studies?: Maybe<Advanced_Studies_Mutation_Response>;
  /** insert a single row into the table: "advanced_studies" */
  insert_advanced_studies_one?: Maybe<Advanced_Studies>;
  /** insert data into the table: "advanced_study_constraint_stacks" */
  insert_advanced_study_constraint_stacks?: Maybe<Advanced_Study_Constraint_Stacks_Mutation_Response>;
  /** insert a single row into the table: "advanced_study_constraint_stacks" */
  insert_advanced_study_constraint_stacks_one?: Maybe<Advanced_Study_Constraint_Stacks>;
  /** insert data into the table: "advanced_study_loads" */
  insert_advanced_study_loads?: Maybe<Advanced_Study_Loads_Mutation_Response>;
  /** insert a single row into the table: "advanced_study_loads" */
  insert_advanced_study_loads_one?: Maybe<Advanced_Study_Loads>;
  /** insert data into the table: "all_projects" */
  insert_all_projects?: Maybe<All_Projects_Mutation_Response>;
  /** insert a single row into the table: "all_projects" */
  insert_all_projects_one?: Maybe<All_Projects>;
  /** insert data into the table: "branches" */
  insert_branches?: Maybe<Branches_Mutation_Response>;
  /** insert a single row into the table: "branches" */
  insert_branches_one?: Maybe<Branches>;
  /** insert data into the table: "brand_colors" */
  insert_brand_colors?: Maybe<Brand_Colors_Mutation_Response>;
  /** insert a single row into the table: "brand_colors" */
  insert_brand_colors_one?: Maybe<Brand_Colors>;
  /** insert data into the table: "bus_overrides" */
  insert_bus_overrides?: Maybe<Bus_Overrides_Mutation_Response>;
  /** insert a single row into the table: "bus_overrides" */
  insert_bus_overrides_one?: Maybe<Bus_Overrides>;
  /** insert data into the table: "buses_to_scopes" */
  insert_buses_to_scopes?: Maybe<Buses_To_Scopes_Mutation_Response>;
  /** insert a single row into the table: "buses_to_scopes" */
  insert_buses_to_scopes_one?: Maybe<Buses_To_Scopes>;
  /** insert data into the table: "buses_without_overrides" */
  insert_buses_without_overrides?: Maybe<Buses_Without_Overrides_Mutation_Response>;
  /** insert a single row into the table: "buses_without_overrides" */
  insert_buses_without_overrides_one?: Maybe<Buses_Without_Overrides>;
  /** insert data into the table: "capacity_costs" */
  insert_capacity_costs?: Maybe<Capacity_Costs_Mutation_Response>;
  /** insert a single row into the table: "capacity_costs" */
  insert_capacity_costs_one?: Maybe<Capacity_Costs>;
  /** insert data into the table: "ceii_access" */
  insert_ceii_access?: Maybe<Ceii_Access_Mutation_Response>;
  /** insert a single row into the table: "ceii_access" */
  insert_ceii_access_one?: Maybe<Ceii_Access>;
  /** insert data into the table: "constraint_stacks" */
  insert_constraint_stacks?: Maybe<Constraint_Stacks_Mutation_Response>;
  /** insert a single row into the table: "constraint_stacks" */
  insert_constraint_stacks_one?: Maybe<Constraint_Stacks>;
  /** insert data into the table: "constraint_types" */
  insert_constraint_types?: Maybe<Constraint_Types_Mutation_Response>;
  /** insert a single row into the table: "constraint_types" */
  insert_constraint_types_one?: Maybe<Constraint_Types>;
  /** insert data into the table: "custom_upgrade_files" */
  insert_custom_upgrade_files?: Maybe<Custom_Upgrade_Files_Mutation_Response>;
  /** insert a single row into the table: "custom_upgrade_files" */
  insert_custom_upgrade_files_one?: Maybe<Custom_Upgrade_Files>;
  /** insert data into the table: "custom_upgrade_model_set_validation_failures" */
  insert_custom_upgrade_model_set_validation_failures?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Mutation_Response>;
  /** insert a single row into the table: "custom_upgrade_model_set_validation_failures" */
  insert_custom_upgrade_model_set_validation_failures_one?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures>;
  /** insert data into the table: "custom_upgrade_model_set_validations" */
  insert_custom_upgrade_model_set_validations?: Maybe<Custom_Upgrade_Model_Set_Validations_Mutation_Response>;
  /** insert a single row into the table: "custom_upgrade_model_set_validations" */
  insert_custom_upgrade_model_set_validations_one?: Maybe<Custom_Upgrade_Model_Set_Validations>;
  /** insert data into the table: "custom_upgrade_validation_failure_codes" */
  insert_custom_upgrade_validation_failure_codes?: Maybe<Custom_Upgrade_Validation_Failure_Codes_Mutation_Response>;
  /** insert a single row into the table: "custom_upgrade_validation_failure_codes" */
  insert_custom_upgrade_validation_failure_codes_one?: Maybe<Custom_Upgrade_Validation_Failure_Codes>;
  /** insert data into the table: "custom_upgrade_validation_failure_severities" */
  insert_custom_upgrade_validation_failure_severities?: Maybe<Custom_Upgrade_Validation_Failure_Severities_Mutation_Response>;
  /** insert a single row into the table: "custom_upgrade_validation_failure_severities" */
  insert_custom_upgrade_validation_failure_severities_one?: Maybe<Custom_Upgrade_Validation_Failure_Severities>;
  /** insert data into the table: "custom_upgrade_validation_statuses" */
  insert_custom_upgrade_validation_statuses?: Maybe<Custom_Upgrade_Validation_Statuses_Mutation_Response>;
  /** insert a single row into the table: "custom_upgrade_validation_statuses" */
  insert_custom_upgrade_validation_statuses_one?: Maybe<Custom_Upgrade_Validation_Statuses>;
  /** insert data into the table: "custom_upgrades" */
  insert_custom_upgrades?: Maybe<Custom_Upgrades_Mutation_Response>;
  /** insert a single row into the table: "custom_upgrades" */
  insert_custom_upgrades_one?: Maybe<Custom_Upgrades>;
  /** insert data into the table: "data_versions" */
  insert_data_versions?: Maybe<Data_Versions_Mutation_Response>;
  /** insert a single row into the table: "data_versions" */
  insert_data_versions_one?: Maybe<Data_Versions>;
  /** insert data into the table: "external_api_scopes" */
  insert_external_api_scopes?: Maybe<External_Api_Scopes_Mutation_Response>;
  /** insert a single row into the table: "external_api_scopes" */
  insert_external_api_scopes_one?: Maybe<External_Api_Scopes>;
  /** insert data into the table: "favorite_buses" */
  insert_favorite_buses?: Maybe<Favorite_Buses_Mutation_Response>;
  /** insert a single row into the table: "favorite_buses" */
  insert_favorite_buses_one?: Maybe<Favorite_Buses>;
  /** insert data into the table: "gtc_exposure" */
  insert_gtc_exposure?: Maybe<Gtc_Exposure_Mutation_Response>;
  /** insert a single row into the table: "gtc_exposure" */
  insert_gtc_exposure_one?: Maybe<Gtc_Exposure>;
  /** insert data into the table: "in_queue_cluster_model_set_statuses" */
  insert_in_queue_cluster_model_set_statuses?: Maybe<In_Queue_Cluster_Model_Set_Statuses_Mutation_Response>;
  /** insert a single row into the table: "in_queue_cluster_model_set_statuses" */
  insert_in_queue_cluster_model_set_statuses_one?: Maybe<In_Queue_Cluster_Model_Set_Statuses>;
  /** insert data into the table: "in_queue_cluster_model_sets" */
  insert_in_queue_cluster_model_sets?: Maybe<In_Queue_Cluster_Model_Sets_Mutation_Response>;
  /** insert a single row into the table: "in_queue_cluster_model_sets" */
  insert_in_queue_cluster_model_sets_one?: Maybe<In_Queue_Cluster_Model_Sets>;
  /** insert data into the table: "in_queue_cluster_statuses" */
  insert_in_queue_cluster_statuses?: Maybe<In_Queue_Cluster_Statuses_Mutation_Response>;
  /** insert a single row into the table: "in_queue_cluster_statuses" */
  insert_in_queue_cluster_statuses_one?: Maybe<In_Queue_Cluster_Statuses>;
  /** insert data into the table: "in_queue_clusters" */
  insert_in_queue_clusters?: Maybe<In_Queue_Clusters_Mutation_Response>;
  /** insert a single row into the table: "in_queue_clusters" */
  insert_in_queue_clusters_one?: Maybe<In_Queue_Clusters>;
  /** insert data into the table: "in_queue_model_pois" */
  insert_in_queue_model_pois?: Maybe<In_Queue_Model_Pois_Mutation_Response>;
  /** insert a single row into the table: "in_queue_model_pois" */
  insert_in_queue_model_pois_one?: Maybe<In_Queue_Model_Pois>;
  /** insert data into the table: "in_queue_model_variants" */
  insert_in_queue_model_variants?: Maybe<In_Queue_Model_Variants_Mutation_Response>;
  /** insert a single row into the table: "in_queue_model_variants" */
  insert_in_queue_model_variants_one?: Maybe<In_Queue_Model_Variants>;
  /** insert data into the table: "in_queue_region_model_variants" */
  insert_in_queue_region_model_variants?: Maybe<In_Queue_Region_Model_Variants_Mutation_Response>;
  /** insert a single row into the table: "in_queue_region_model_variants" */
  insert_in_queue_region_model_variants_one?: Maybe<In_Queue_Region_Model_Variants>;
  /** insert data into the table: "in_queue_speculative_projects" */
  insert_in_queue_speculative_projects?: Maybe<In_Queue_Speculative_Projects_Mutation_Response>;
  /** insert a single row into the table: "in_queue_speculative_projects" */
  insert_in_queue_speculative_projects_one?: Maybe<In_Queue_Speculative_Projects>;
  /** insert data into the table: "in_queue_subscription_add_ons" */
  insert_in_queue_subscription_add_ons?: Maybe<In_Queue_Subscription_Add_Ons_Mutation_Response>;
  /** insert a single row into the table: "in_queue_subscription_add_ons" */
  insert_in_queue_subscription_add_ons_one?: Maybe<In_Queue_Subscription_Add_Ons>;
  /** insert data into the table: "in_queue_subscriptions" */
  insert_in_queue_subscriptions?: Maybe<In_Queue_Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "in_queue_subscriptions" */
  insert_in_queue_subscriptions_one?: Maybe<In_Queue_Subscriptions>;
  /** insert data into the table: "line_capacity_costs" */
  insert_line_capacity_costs?: Maybe<Line_Capacity_Costs_Mutation_Response>;
  /** insert a single row into the table: "line_capacity_costs" */
  insert_line_capacity_costs_one?: Maybe<Line_Capacity_Costs>;
  /** insert data into the table: "line_constraint_stacks" */
  insert_line_constraint_stacks?: Maybe<Line_Constraint_Stacks_Mutation_Response>;
  /** insert a single row into the table: "line_constraint_stacks" */
  insert_line_constraint_stacks_one?: Maybe<Line_Constraint_Stacks>;
  /** insert data into the table: "model_generator_facility_dfax" */
  insert_model_generator_facility_dfax?: Maybe<Model_Generator_Facility_Dfax_Mutation_Response>;
  /** insert a single row into the table: "model_generator_facility_dfax" */
  insert_model_generator_facility_dfax_one?: Maybe<Model_Generator_Facility_Dfax>;
  /** insert data into the table: "model_generators" */
  insert_model_generators?: Maybe<Model_Generators_Mutation_Response>;
  /** insert a single row into the table: "model_generators" */
  insert_model_generators_one?: Maybe<Model_Generators>;
  /** insert data into the table: "model_lines" */
  insert_model_lines?: Maybe<Model_Lines_Mutation_Response>;
  /** insert a single row into the table: "model_lines" */
  insert_model_lines_one?: Maybe<Model_Lines>;
  /** insert data into the table: "model_lines_to_branches" */
  insert_model_lines_to_branches?: Maybe<Model_Lines_To_Branches_Mutation_Response>;
  /** insert a single row into the table: "model_lines_to_branches" */
  insert_model_lines_to_branches_one?: Maybe<Model_Lines_To_Branches>;
  /** insert data into the table: "model_lines_to_missing_buses" */
  insert_model_lines_to_missing_buses?: Maybe<Model_Lines_To_Missing_Buses_Mutation_Response>;
  /** insert a single row into the table: "model_lines_to_missing_buses" */
  insert_model_lines_to_missing_buses_one?: Maybe<Model_Lines_To_Missing_Buses>;
  /** insert data into the table: "planned_interconnection_locations" */
  insert_planned_interconnection_locations?: Maybe<Planned_Interconnection_Locations_Mutation_Response>;
  /** insert a single row into the table: "planned_interconnection_locations" */
  insert_planned_interconnection_locations_one?: Maybe<Planned_Interconnection_Locations>;
  /** insert data into the table: "project_additional_costs" */
  insert_project_additional_costs?: Maybe<Project_Additional_Costs_Mutation_Response>;
  /** insert a single row into the table: "project_additional_costs" */
  insert_project_additional_costs_one?: Maybe<Project_Additional_Costs>;
  /** insert data into the table: "project_configurations" */
  insert_project_configurations?: Maybe<Project_Configurations_Mutation_Response>;
  /** insert a single row into the table: "project_configurations" */
  insert_project_configurations_one?: Maybe<Project_Configurations>;
  /** insert data into the table: "project_cost_sources" */
  insert_project_cost_sources?: Maybe<Project_Cost_Sources_Mutation_Response>;
  /** insert a single row into the table: "project_cost_sources" */
  insert_project_cost_sources_one?: Maybe<Project_Cost_Sources>;
  /** insert data into the table: "project_cost_types" */
  insert_project_cost_types?: Maybe<Project_Cost_Types_Mutation_Response>;
  /** insert a single row into the table: "project_cost_types" */
  insert_project_cost_types_one?: Maybe<Project_Cost_Types>;
  /** insert data into the table: "project_tag_assignments" */
  insert_project_tag_assignments?: Maybe<Project_Tag_Assignments_Mutation_Response>;
  /** insert a single row into the table: "project_tag_assignments" */
  insert_project_tag_assignments_one?: Maybe<Project_Tag_Assignments>;
  /** insert data into the table: "project_tags" */
  insert_project_tags?: Maybe<Project_Tags_Mutation_Response>;
  /** insert a single row into the table: "project_tags" */
  insert_project_tags_one?: Maybe<Project_Tags>;
  /** insert data into the table: "queue_project_connection_points" */
  insert_queue_project_connection_points?: Maybe<Queue_Project_Connection_Points_Mutation_Response>;
  /** insert a single row into the table: "queue_project_connection_points" */
  insert_queue_project_connection_points_one?: Maybe<Queue_Project_Connection_Points>;
  /** insert data into the table: "queue_project_connection_types" */
  insert_queue_project_connection_types?: Maybe<Queue_Project_Connection_Types_Mutation_Response>;
  /** insert a single row into the table: "queue_project_connection_types" */
  insert_queue_project_connection_types_one?: Maybe<Queue_Project_Connection_Types>;
  /** insert data into the table: "queue_project_facility_dfax" */
  insert_queue_project_facility_dfax?: Maybe<Queue_Project_Facility_Dfax_Mutation_Response>;
  /** insert a single row into the table: "queue_project_facility_dfax" */
  insert_queue_project_facility_dfax_one?: Maybe<Queue_Project_Facility_Dfax>;
  /** insert data into the table: "queue_project_hops" */
  insert_queue_project_hops?: Maybe<Queue_Project_Hops_Mutation_Response>;
  /** insert a single row into the table: "queue_project_hops" */
  insert_queue_project_hops_one?: Maybe<Queue_Project_Hops>;
  /** insert data into the table: "queue_projects" */
  insert_queue_projects?: Maybe<Queue_Projects_Mutation_Response>;
  /** insert a single row into the table: "queue_projects" */
  insert_queue_projects_one?: Maybe<Queue_Projects>;
  /** insert data into the table: "scenario_allocated_upgrades" */
  insert_scenario_allocated_upgrades?: Maybe<Scenario_Allocated_Upgrades_Mutation_Response>;
  /** insert a single row into the table: "scenario_allocated_upgrades" */
  insert_scenario_allocated_upgrades_one?: Maybe<Scenario_Allocated_Upgrades>;
  /** insert data into the table: "scenario_configurations" */
  insert_scenario_configurations?: Maybe<Scenario_Configurations_Mutation_Response>;
  /** insert a single row into the table: "scenario_configurations" */
  insert_scenario_configurations_one?: Maybe<Scenario_Configurations>;
  /** insert data into the table: "scenario_constraints" */
  insert_scenario_constraints?: Maybe<Scenario_Constraints_Mutation_Response>;
  /** insert a single row into the table: "scenario_constraints" */
  insert_scenario_constraints_one?: Maybe<Scenario_Constraints>;
  /** insert data into the table: "scenario_origins" */
  insert_scenario_origins?: Maybe<Scenario_Origins_Mutation_Response>;
  /** insert a single row into the table: "scenario_origins" */
  insert_scenario_origins_one?: Maybe<Scenario_Origins>;
  /** insert data into the table: "scenario_project_ranks" */
  insert_scenario_project_ranks?: Maybe<Scenario_Project_Ranks_Mutation_Response>;
  /** insert a single row into the table: "scenario_project_ranks" */
  insert_scenario_project_ranks_one?: Maybe<Scenario_Project_Ranks>;
  /** insert data into the table: "scenario_projects" */
  insert_scenario_projects?: Maybe<Scenario_Projects_Mutation_Response>;
  /** insert a single row into the table: "scenario_projects" */
  insert_scenario_projects_one?: Maybe<Scenario_Projects>;
  /** insert data into the table: "scenario_statuses" */
  insert_scenario_statuses?: Maybe<Scenario_Statuses_Mutation_Response>;
  /** insert a single row into the table: "scenario_statuses" */
  insert_scenario_statuses_one?: Maybe<Scenario_Statuses>;
  /** insert data into the table: "scenarios" */
  insert_scenarios?: Maybe<Scenarios_Mutation_Response>;
  /** insert a single row into the table: "scenarios" */
  insert_scenarios_one?: Maybe<Scenarios>;
  /** insert data into the table: "scopes" */
  insert_scopes?: Maybe<Scopes_Mutation_Response>;
  /** insert a single row into the table: "scopes" */
  insert_scopes_one?: Maybe<Scopes>;
  /** insert data into the table: "screening_views" */
  insert_screening_views?: Maybe<Screening_Views_Mutation_Response>;
  /** insert a single row into the table: "screening_views" */
  insert_screening_views_one?: Maybe<Screening_Views>;
  /** insert data into the table: "sis_project_cost_type_metadata" */
  insert_sis_project_cost_type_metadata?: Maybe<Sis_Project_Cost_Type_Metadata_Mutation_Response>;
  /** insert a single row into the table: "sis_project_cost_type_metadata" */
  insert_sis_project_cost_type_metadata_one?: Maybe<Sis_Project_Cost_Type_Metadata>;
  /** insert data into the table: "sis_report_postings" */
  insert_sis_report_postings?: Maybe<Sis_Report_Postings_Mutation_Response>;
  /** insert a single row into the table: "sis_report_postings" */
  insert_sis_report_postings_one?: Maybe<Sis_Report_Postings>;
  /** insert data into the table: "subscription_add_ons" */
  insert_subscription_add_ons?: Maybe<Subscription_Add_Ons_Mutation_Response>;
  /** insert a single row into the table: "subscription_add_ons" */
  insert_subscription_add_ons_one?: Maybe<Subscription_Add_Ons>;
  /** insert data into the table: "subscriptions" */
  insert_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "subscriptions" */
  insert_subscriptions_one?: Maybe<Subscriptions>;
  /** insert data into the table: "teams" */
  insert_teams?: Maybe<Teams_Mutation_Response>;
  /** insert a single row into the table: "teams" */
  insert_teams_one?: Maybe<Teams>;
  /** insert data into the table: "tracked_projects" */
  insert_tracked_projects?: Maybe<Tracked_Projects_Mutation_Response>;
  /** insert a single row into the table: "tracked_projects" */
  insert_tracked_projects_one?: Maybe<Tracked_Projects>;
  /** insert data into the table: "unlocked_buses" */
  insert_unlocked_buses?: Maybe<Unlocked_Buses_Mutation_Response>;
  /** insert a single row into the table: "unlocked_buses" */
  insert_unlocked_buses_one?: Maybe<Unlocked_Buses>;
  /** insert data into the table: "user_scope_configs" */
  insert_user_scope_configs?: Maybe<User_Scope_Configs_Mutation_Response>;
  /** insert a single row into the table: "user_scope_configs" */
  insert_user_scope_configs_one?: Maybe<User_Scope_Configs>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** execute VOLATILE function "publish_custom_upgrade" which returns "custom_upgrades" */
  publish_custom_upgrade: Array<Custom_Upgrades>;
  /** execute VOLATILE function "publish_scenario" which returns "scenarios" */
  publish_scenario: Array<Scenarios>;
  /** execute VOLATILE function "unlock_bus" which returns "unlocked_buses" */
  unlock_bus?: Maybe<Unlocked_Buses>;
  /** execute VOLATILE function "unpublish_custom_upgrade" which returns "custom_upgrades" */
  unpublish_custom_upgrade: Array<Custom_Upgrades>;
  /** execute VOLATILE function "unpublish_scenario" which returns "scenarios" */
  unpublish_scenario: Array<Scenarios>;
  /** update data of the table: "additional_column_configs" */
  update_additional_column_configs?: Maybe<Additional_Column_Configs_Mutation_Response>;
  /** update single row of the table: "additional_column_configs" */
  update_additional_column_configs_by_pk?: Maybe<Additional_Column_Configs>;
  /** update multiples rows of table: "additional_column_configs" */
  update_additional_column_configs_many?: Maybe<Array<Maybe<Additional_Column_Configs_Mutation_Response>>>;
  /** update data of the table: "admin_app.audit_log" */
  update_admin_app_audit_log?: Maybe<Admin_App_Audit_Log_Mutation_Response>;
  /** update single row of the table: "admin_app.audit_log" */
  update_admin_app_audit_log_by_pk?: Maybe<Admin_App_Audit_Log>;
  /** update multiples rows of table: "admin_app.audit_log" */
  update_admin_app_audit_log_many?: Maybe<Array<Maybe<Admin_App_Audit_Log_Mutation_Response>>>;
  /** update data of the table: "admin_app.audit_log_targets" */
  update_admin_app_audit_log_targets?: Maybe<Admin_App_Audit_Log_Targets_Mutation_Response>;
  /** update single row of the table: "admin_app.audit_log_targets" */
  update_admin_app_audit_log_targets_by_pk?: Maybe<Admin_App_Audit_Log_Targets>;
  /** update multiples rows of table: "admin_app.audit_log_targets" */
  update_admin_app_audit_log_targets_many?: Maybe<Array<Maybe<Admin_App_Audit_Log_Targets_Mutation_Response>>>;
  /** update data of the table: "advanced_studies" */
  update_advanced_studies?: Maybe<Advanced_Studies_Mutation_Response>;
  /** update single row of the table: "advanced_studies" */
  update_advanced_studies_by_pk?: Maybe<Advanced_Studies>;
  /** update multiples rows of table: "advanced_studies" */
  update_advanced_studies_many?: Maybe<Array<Maybe<Advanced_Studies_Mutation_Response>>>;
  /** update data of the table: "advanced_study_constraint_stacks" */
  update_advanced_study_constraint_stacks?: Maybe<Advanced_Study_Constraint_Stacks_Mutation_Response>;
  /** update single row of the table: "advanced_study_constraint_stacks" */
  update_advanced_study_constraint_stacks_by_pk?: Maybe<Advanced_Study_Constraint_Stacks>;
  /** update multiples rows of table: "advanced_study_constraint_stacks" */
  update_advanced_study_constraint_stacks_many?: Maybe<Array<Maybe<Advanced_Study_Constraint_Stacks_Mutation_Response>>>;
  /** update data of the table: "advanced_study_loads" */
  update_advanced_study_loads?: Maybe<Advanced_Study_Loads_Mutation_Response>;
  /** update single row of the table: "advanced_study_loads" */
  update_advanced_study_loads_by_pk?: Maybe<Advanced_Study_Loads>;
  /** update multiples rows of table: "advanced_study_loads" */
  update_advanced_study_loads_many?: Maybe<Array<Maybe<Advanced_Study_Loads_Mutation_Response>>>;
  /** update data of the table: "all_projects" */
  update_all_projects?: Maybe<All_Projects_Mutation_Response>;
  /** update single row of the table: "all_projects" */
  update_all_projects_by_pk?: Maybe<All_Projects>;
  /** update multiples rows of table: "all_projects" */
  update_all_projects_many?: Maybe<Array<Maybe<All_Projects_Mutation_Response>>>;
  /** update data of the table: "branches" */
  update_branches?: Maybe<Branches_Mutation_Response>;
  /** update single row of the table: "branches" */
  update_branches_by_pk?: Maybe<Branches>;
  /** update multiples rows of table: "branches" */
  update_branches_many?: Maybe<Array<Maybe<Branches_Mutation_Response>>>;
  /** update data of the table: "brand_colors" */
  update_brand_colors?: Maybe<Brand_Colors_Mutation_Response>;
  /** update single row of the table: "brand_colors" */
  update_brand_colors_by_pk?: Maybe<Brand_Colors>;
  /** update multiples rows of table: "brand_colors" */
  update_brand_colors_many?: Maybe<Array<Maybe<Brand_Colors_Mutation_Response>>>;
  /** update data of the table: "bus_overrides" */
  update_bus_overrides?: Maybe<Bus_Overrides_Mutation_Response>;
  /** update single row of the table: "bus_overrides" */
  update_bus_overrides_by_pk?: Maybe<Bus_Overrides>;
  /** update multiples rows of table: "bus_overrides" */
  update_bus_overrides_many?: Maybe<Array<Maybe<Bus_Overrides_Mutation_Response>>>;
  /** update data of the table: "buses_to_scopes" */
  update_buses_to_scopes?: Maybe<Buses_To_Scopes_Mutation_Response>;
  /** update single row of the table: "buses_to_scopes" */
  update_buses_to_scopes_by_pk?: Maybe<Buses_To_Scopes>;
  /** update multiples rows of table: "buses_to_scopes" */
  update_buses_to_scopes_many?: Maybe<Array<Maybe<Buses_To_Scopes_Mutation_Response>>>;
  /** update data of the table: "buses_without_overrides" */
  update_buses_without_overrides?: Maybe<Buses_Without_Overrides_Mutation_Response>;
  /** update single row of the table: "buses_without_overrides" */
  update_buses_without_overrides_by_pk?: Maybe<Buses_Without_Overrides>;
  /** update multiples rows of table: "buses_without_overrides" */
  update_buses_without_overrides_many?: Maybe<Array<Maybe<Buses_Without_Overrides_Mutation_Response>>>;
  /** update data of the table: "capacity_costs" */
  update_capacity_costs?: Maybe<Capacity_Costs_Mutation_Response>;
  /** update single row of the table: "capacity_costs" */
  update_capacity_costs_by_pk?: Maybe<Capacity_Costs>;
  /** update multiples rows of table: "capacity_costs" */
  update_capacity_costs_many?: Maybe<Array<Maybe<Capacity_Costs_Mutation_Response>>>;
  /** update data of the table: "ceii_access" */
  update_ceii_access?: Maybe<Ceii_Access_Mutation_Response>;
  /** update single row of the table: "ceii_access" */
  update_ceii_access_by_pk?: Maybe<Ceii_Access>;
  /** update multiples rows of table: "ceii_access" */
  update_ceii_access_many?: Maybe<Array<Maybe<Ceii_Access_Mutation_Response>>>;
  /** update data of the table: "constraint_stacks" */
  update_constraint_stacks?: Maybe<Constraint_Stacks_Mutation_Response>;
  /** update single row of the table: "constraint_stacks" */
  update_constraint_stacks_by_pk?: Maybe<Constraint_Stacks>;
  /** update multiples rows of table: "constraint_stacks" */
  update_constraint_stacks_many?: Maybe<Array<Maybe<Constraint_Stacks_Mutation_Response>>>;
  /** update data of the table: "constraint_types" */
  update_constraint_types?: Maybe<Constraint_Types_Mutation_Response>;
  /** update single row of the table: "constraint_types" */
  update_constraint_types_by_pk?: Maybe<Constraint_Types>;
  /** update multiples rows of table: "constraint_types" */
  update_constraint_types_many?: Maybe<Array<Maybe<Constraint_Types_Mutation_Response>>>;
  /** update data of the table: "custom_upgrade_files" */
  update_custom_upgrade_files?: Maybe<Custom_Upgrade_Files_Mutation_Response>;
  /** update single row of the table: "custom_upgrade_files" */
  update_custom_upgrade_files_by_pk?: Maybe<Custom_Upgrade_Files>;
  /** update multiples rows of table: "custom_upgrade_files" */
  update_custom_upgrade_files_many?: Maybe<Array<Maybe<Custom_Upgrade_Files_Mutation_Response>>>;
  /** update data of the table: "custom_upgrade_model_set_validation_failures" */
  update_custom_upgrade_model_set_validation_failures?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Mutation_Response>;
  /** update single row of the table: "custom_upgrade_model_set_validation_failures" */
  update_custom_upgrade_model_set_validation_failures_by_pk?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures>;
  /** update multiples rows of table: "custom_upgrade_model_set_validation_failures" */
  update_custom_upgrade_model_set_validation_failures_many?: Maybe<Array<Maybe<Custom_Upgrade_Model_Set_Validation_Failures_Mutation_Response>>>;
  /** update data of the table: "custom_upgrade_model_set_validations" */
  update_custom_upgrade_model_set_validations?: Maybe<Custom_Upgrade_Model_Set_Validations_Mutation_Response>;
  /** update single row of the table: "custom_upgrade_model_set_validations" */
  update_custom_upgrade_model_set_validations_by_pk?: Maybe<Custom_Upgrade_Model_Set_Validations>;
  /** update multiples rows of table: "custom_upgrade_model_set_validations" */
  update_custom_upgrade_model_set_validations_many?: Maybe<Array<Maybe<Custom_Upgrade_Model_Set_Validations_Mutation_Response>>>;
  /** update data of the table: "custom_upgrade_validation_failure_codes" */
  update_custom_upgrade_validation_failure_codes?: Maybe<Custom_Upgrade_Validation_Failure_Codes_Mutation_Response>;
  /** update single row of the table: "custom_upgrade_validation_failure_codes" */
  update_custom_upgrade_validation_failure_codes_by_pk?: Maybe<Custom_Upgrade_Validation_Failure_Codes>;
  /** update multiples rows of table: "custom_upgrade_validation_failure_codes" */
  update_custom_upgrade_validation_failure_codes_many?: Maybe<Array<Maybe<Custom_Upgrade_Validation_Failure_Codes_Mutation_Response>>>;
  /** update data of the table: "custom_upgrade_validation_failure_severities" */
  update_custom_upgrade_validation_failure_severities?: Maybe<Custom_Upgrade_Validation_Failure_Severities_Mutation_Response>;
  /** update single row of the table: "custom_upgrade_validation_failure_severities" */
  update_custom_upgrade_validation_failure_severities_by_pk?: Maybe<Custom_Upgrade_Validation_Failure_Severities>;
  /** update multiples rows of table: "custom_upgrade_validation_failure_severities" */
  update_custom_upgrade_validation_failure_severities_many?: Maybe<Array<Maybe<Custom_Upgrade_Validation_Failure_Severities_Mutation_Response>>>;
  /** update data of the table: "custom_upgrade_validation_statuses" */
  update_custom_upgrade_validation_statuses?: Maybe<Custom_Upgrade_Validation_Statuses_Mutation_Response>;
  /** update single row of the table: "custom_upgrade_validation_statuses" */
  update_custom_upgrade_validation_statuses_by_pk?: Maybe<Custom_Upgrade_Validation_Statuses>;
  /** update multiples rows of table: "custom_upgrade_validation_statuses" */
  update_custom_upgrade_validation_statuses_many?: Maybe<Array<Maybe<Custom_Upgrade_Validation_Statuses_Mutation_Response>>>;
  /** update data of the table: "custom_upgrades" */
  update_custom_upgrades?: Maybe<Custom_Upgrades_Mutation_Response>;
  /** update single row of the table: "custom_upgrades" */
  update_custom_upgrades_by_pk?: Maybe<Custom_Upgrades>;
  /** update multiples rows of table: "custom_upgrades" */
  update_custom_upgrades_many?: Maybe<Array<Maybe<Custom_Upgrades_Mutation_Response>>>;
  /** update data of the table: "data_versions" */
  update_data_versions?: Maybe<Data_Versions_Mutation_Response>;
  /** update single row of the table: "data_versions" */
  update_data_versions_by_pk?: Maybe<Data_Versions>;
  /** update multiples rows of table: "data_versions" */
  update_data_versions_many?: Maybe<Array<Maybe<Data_Versions_Mutation_Response>>>;
  /** update data of the table: "external_api_scopes" */
  update_external_api_scopes?: Maybe<External_Api_Scopes_Mutation_Response>;
  /** update multiples rows of table: "external_api_scopes" */
  update_external_api_scopes_many?: Maybe<Array<Maybe<External_Api_Scopes_Mutation_Response>>>;
  /** update data of the table: "favorite_buses" */
  update_favorite_buses?: Maybe<Favorite_Buses_Mutation_Response>;
  /** update single row of the table: "favorite_buses" */
  update_favorite_buses_by_pk?: Maybe<Favorite_Buses>;
  /** update multiples rows of table: "favorite_buses" */
  update_favorite_buses_many?: Maybe<Array<Maybe<Favorite_Buses_Mutation_Response>>>;
  /** update data of the table: "gtc_exposure" */
  update_gtc_exposure?: Maybe<Gtc_Exposure_Mutation_Response>;
  /** update single row of the table: "gtc_exposure" */
  update_gtc_exposure_by_pk?: Maybe<Gtc_Exposure>;
  /** update multiples rows of table: "gtc_exposure" */
  update_gtc_exposure_many?: Maybe<Array<Maybe<Gtc_Exposure_Mutation_Response>>>;
  /** update data of the table: "in_queue_cluster_model_set_statuses" */
  update_in_queue_cluster_model_set_statuses?: Maybe<In_Queue_Cluster_Model_Set_Statuses_Mutation_Response>;
  /** update single row of the table: "in_queue_cluster_model_set_statuses" */
  update_in_queue_cluster_model_set_statuses_by_pk?: Maybe<In_Queue_Cluster_Model_Set_Statuses>;
  /** update multiples rows of table: "in_queue_cluster_model_set_statuses" */
  update_in_queue_cluster_model_set_statuses_many?: Maybe<Array<Maybe<In_Queue_Cluster_Model_Set_Statuses_Mutation_Response>>>;
  /** update data of the table: "in_queue_cluster_model_sets" */
  update_in_queue_cluster_model_sets?: Maybe<In_Queue_Cluster_Model_Sets_Mutation_Response>;
  /** update single row of the table: "in_queue_cluster_model_sets" */
  update_in_queue_cluster_model_sets_by_pk?: Maybe<In_Queue_Cluster_Model_Sets>;
  /** update multiples rows of table: "in_queue_cluster_model_sets" */
  update_in_queue_cluster_model_sets_many?: Maybe<Array<Maybe<In_Queue_Cluster_Model_Sets_Mutation_Response>>>;
  /** update data of the table: "in_queue_cluster_statuses" */
  update_in_queue_cluster_statuses?: Maybe<In_Queue_Cluster_Statuses_Mutation_Response>;
  /** update single row of the table: "in_queue_cluster_statuses" */
  update_in_queue_cluster_statuses_by_pk?: Maybe<In_Queue_Cluster_Statuses>;
  /** update multiples rows of table: "in_queue_cluster_statuses" */
  update_in_queue_cluster_statuses_many?: Maybe<Array<Maybe<In_Queue_Cluster_Statuses_Mutation_Response>>>;
  /** update data of the table: "in_queue_clusters" */
  update_in_queue_clusters?: Maybe<In_Queue_Clusters_Mutation_Response>;
  /** update single row of the table: "in_queue_clusters" */
  update_in_queue_clusters_by_pk?: Maybe<In_Queue_Clusters>;
  /** update multiples rows of table: "in_queue_clusters" */
  update_in_queue_clusters_many?: Maybe<Array<Maybe<In_Queue_Clusters_Mutation_Response>>>;
  /** update data of the table: "in_queue_model_pois" */
  update_in_queue_model_pois?: Maybe<In_Queue_Model_Pois_Mutation_Response>;
  /** update single row of the table: "in_queue_model_pois" */
  update_in_queue_model_pois_by_pk?: Maybe<In_Queue_Model_Pois>;
  /** update multiples rows of table: "in_queue_model_pois" */
  update_in_queue_model_pois_many?: Maybe<Array<Maybe<In_Queue_Model_Pois_Mutation_Response>>>;
  /** update data of the table: "in_queue_model_variants" */
  update_in_queue_model_variants?: Maybe<In_Queue_Model_Variants_Mutation_Response>;
  /** update single row of the table: "in_queue_model_variants" */
  update_in_queue_model_variants_by_pk?: Maybe<In_Queue_Model_Variants>;
  /** update multiples rows of table: "in_queue_model_variants" */
  update_in_queue_model_variants_many?: Maybe<Array<Maybe<In_Queue_Model_Variants_Mutation_Response>>>;
  /** update data of the table: "in_queue_region_model_variants" */
  update_in_queue_region_model_variants?: Maybe<In_Queue_Region_Model_Variants_Mutation_Response>;
  /** update single row of the table: "in_queue_region_model_variants" */
  update_in_queue_region_model_variants_by_pk?: Maybe<In_Queue_Region_Model_Variants>;
  /** update multiples rows of table: "in_queue_region_model_variants" */
  update_in_queue_region_model_variants_many?: Maybe<Array<Maybe<In_Queue_Region_Model_Variants_Mutation_Response>>>;
  /** update data of the table: "in_queue_speculative_projects" */
  update_in_queue_speculative_projects?: Maybe<In_Queue_Speculative_Projects_Mutation_Response>;
  /** update single row of the table: "in_queue_speculative_projects" */
  update_in_queue_speculative_projects_by_pk?: Maybe<In_Queue_Speculative_Projects>;
  /** update multiples rows of table: "in_queue_speculative_projects" */
  update_in_queue_speculative_projects_many?: Maybe<Array<Maybe<In_Queue_Speculative_Projects_Mutation_Response>>>;
  /** update data of the table: "in_queue_subscription_add_ons" */
  update_in_queue_subscription_add_ons?: Maybe<In_Queue_Subscription_Add_Ons_Mutation_Response>;
  /** update single row of the table: "in_queue_subscription_add_ons" */
  update_in_queue_subscription_add_ons_by_pk?: Maybe<In_Queue_Subscription_Add_Ons>;
  /** update multiples rows of table: "in_queue_subscription_add_ons" */
  update_in_queue_subscription_add_ons_many?: Maybe<Array<Maybe<In_Queue_Subscription_Add_Ons_Mutation_Response>>>;
  /** update data of the table: "in_queue_subscriptions" */
  update_in_queue_subscriptions?: Maybe<In_Queue_Subscriptions_Mutation_Response>;
  /** update single row of the table: "in_queue_subscriptions" */
  update_in_queue_subscriptions_by_pk?: Maybe<In_Queue_Subscriptions>;
  /** update multiples rows of table: "in_queue_subscriptions" */
  update_in_queue_subscriptions_many?: Maybe<Array<Maybe<In_Queue_Subscriptions_Mutation_Response>>>;
  /** update data of the table: "line_capacity_costs" */
  update_line_capacity_costs?: Maybe<Line_Capacity_Costs_Mutation_Response>;
  /** update single row of the table: "line_capacity_costs" */
  update_line_capacity_costs_by_pk?: Maybe<Line_Capacity_Costs>;
  /** update multiples rows of table: "line_capacity_costs" */
  update_line_capacity_costs_many?: Maybe<Array<Maybe<Line_Capacity_Costs_Mutation_Response>>>;
  /** update data of the table: "line_constraint_stacks" */
  update_line_constraint_stacks?: Maybe<Line_Constraint_Stacks_Mutation_Response>;
  /** update single row of the table: "line_constraint_stacks" */
  update_line_constraint_stacks_by_pk?: Maybe<Line_Constraint_Stacks>;
  /** update multiples rows of table: "line_constraint_stacks" */
  update_line_constraint_stacks_many?: Maybe<Array<Maybe<Line_Constraint_Stacks_Mutation_Response>>>;
  /** update data of the table: "model_generator_facility_dfax" */
  update_model_generator_facility_dfax?: Maybe<Model_Generator_Facility_Dfax_Mutation_Response>;
  /** update single row of the table: "model_generator_facility_dfax" */
  update_model_generator_facility_dfax_by_pk?: Maybe<Model_Generator_Facility_Dfax>;
  /** update multiples rows of table: "model_generator_facility_dfax" */
  update_model_generator_facility_dfax_many?: Maybe<Array<Maybe<Model_Generator_Facility_Dfax_Mutation_Response>>>;
  /** update data of the table: "model_generators" */
  update_model_generators?: Maybe<Model_Generators_Mutation_Response>;
  /** update single row of the table: "model_generators" */
  update_model_generators_by_pk?: Maybe<Model_Generators>;
  /** update multiples rows of table: "model_generators" */
  update_model_generators_many?: Maybe<Array<Maybe<Model_Generators_Mutation_Response>>>;
  /** update data of the table: "model_lines" */
  update_model_lines?: Maybe<Model_Lines_Mutation_Response>;
  /** update single row of the table: "model_lines" */
  update_model_lines_by_pk?: Maybe<Model_Lines>;
  /** update multiples rows of table: "model_lines" */
  update_model_lines_many?: Maybe<Array<Maybe<Model_Lines_Mutation_Response>>>;
  /** update data of the table: "model_lines_to_branches" */
  update_model_lines_to_branches?: Maybe<Model_Lines_To_Branches_Mutation_Response>;
  /** update single row of the table: "model_lines_to_branches" */
  update_model_lines_to_branches_by_pk?: Maybe<Model_Lines_To_Branches>;
  /** update multiples rows of table: "model_lines_to_branches" */
  update_model_lines_to_branches_many?: Maybe<Array<Maybe<Model_Lines_To_Branches_Mutation_Response>>>;
  /** update data of the table: "model_lines_to_missing_buses" */
  update_model_lines_to_missing_buses?: Maybe<Model_Lines_To_Missing_Buses_Mutation_Response>;
  /** update single row of the table: "model_lines_to_missing_buses" */
  update_model_lines_to_missing_buses_by_pk?: Maybe<Model_Lines_To_Missing_Buses>;
  /** update multiples rows of table: "model_lines_to_missing_buses" */
  update_model_lines_to_missing_buses_many?: Maybe<Array<Maybe<Model_Lines_To_Missing_Buses_Mutation_Response>>>;
  /** update data of the table: "planned_interconnection_locations" */
  update_planned_interconnection_locations?: Maybe<Planned_Interconnection_Locations_Mutation_Response>;
  /** update single row of the table: "planned_interconnection_locations" */
  update_planned_interconnection_locations_by_pk?: Maybe<Planned_Interconnection_Locations>;
  /** update multiples rows of table: "planned_interconnection_locations" */
  update_planned_interconnection_locations_many?: Maybe<Array<Maybe<Planned_Interconnection_Locations_Mutation_Response>>>;
  /** update data of the table: "project_additional_costs" */
  update_project_additional_costs?: Maybe<Project_Additional_Costs_Mutation_Response>;
  /** update single row of the table: "project_additional_costs" */
  update_project_additional_costs_by_pk?: Maybe<Project_Additional_Costs>;
  /** update multiples rows of table: "project_additional_costs" */
  update_project_additional_costs_many?: Maybe<Array<Maybe<Project_Additional_Costs_Mutation_Response>>>;
  /** update data of the table: "project_configurations" */
  update_project_configurations?: Maybe<Project_Configurations_Mutation_Response>;
  /** update single row of the table: "project_configurations" */
  update_project_configurations_by_pk?: Maybe<Project_Configurations>;
  /** update multiples rows of table: "project_configurations" */
  update_project_configurations_many?: Maybe<Array<Maybe<Project_Configurations_Mutation_Response>>>;
  /** update data of the table: "project_cost_sources" */
  update_project_cost_sources?: Maybe<Project_Cost_Sources_Mutation_Response>;
  /** update single row of the table: "project_cost_sources" */
  update_project_cost_sources_by_pk?: Maybe<Project_Cost_Sources>;
  /** update multiples rows of table: "project_cost_sources" */
  update_project_cost_sources_many?: Maybe<Array<Maybe<Project_Cost_Sources_Mutation_Response>>>;
  /** update data of the table: "project_cost_types" */
  update_project_cost_types?: Maybe<Project_Cost_Types_Mutation_Response>;
  /** update single row of the table: "project_cost_types" */
  update_project_cost_types_by_pk?: Maybe<Project_Cost_Types>;
  /** update multiples rows of table: "project_cost_types" */
  update_project_cost_types_many?: Maybe<Array<Maybe<Project_Cost_Types_Mutation_Response>>>;
  /** update data of the table: "project_tag_assignments" */
  update_project_tag_assignments?: Maybe<Project_Tag_Assignments_Mutation_Response>;
  /** update single row of the table: "project_tag_assignments" */
  update_project_tag_assignments_by_pk?: Maybe<Project_Tag_Assignments>;
  /** update multiples rows of table: "project_tag_assignments" */
  update_project_tag_assignments_many?: Maybe<Array<Maybe<Project_Tag_Assignments_Mutation_Response>>>;
  /** update data of the table: "project_tags" */
  update_project_tags?: Maybe<Project_Tags_Mutation_Response>;
  /** update single row of the table: "project_tags" */
  update_project_tags_by_pk?: Maybe<Project_Tags>;
  /** update multiples rows of table: "project_tags" */
  update_project_tags_many?: Maybe<Array<Maybe<Project_Tags_Mutation_Response>>>;
  /** update data of the table: "queue_project_connection_points" */
  update_queue_project_connection_points?: Maybe<Queue_Project_Connection_Points_Mutation_Response>;
  /** update single row of the table: "queue_project_connection_points" */
  update_queue_project_connection_points_by_pk?: Maybe<Queue_Project_Connection_Points>;
  /** update multiples rows of table: "queue_project_connection_points" */
  update_queue_project_connection_points_many?: Maybe<Array<Maybe<Queue_Project_Connection_Points_Mutation_Response>>>;
  /** update data of the table: "queue_project_connection_types" */
  update_queue_project_connection_types?: Maybe<Queue_Project_Connection_Types_Mutation_Response>;
  /** update single row of the table: "queue_project_connection_types" */
  update_queue_project_connection_types_by_pk?: Maybe<Queue_Project_Connection_Types>;
  /** update multiples rows of table: "queue_project_connection_types" */
  update_queue_project_connection_types_many?: Maybe<Array<Maybe<Queue_Project_Connection_Types_Mutation_Response>>>;
  /** update data of the table: "queue_project_facility_dfax" */
  update_queue_project_facility_dfax?: Maybe<Queue_Project_Facility_Dfax_Mutation_Response>;
  /** update single row of the table: "queue_project_facility_dfax" */
  update_queue_project_facility_dfax_by_pk?: Maybe<Queue_Project_Facility_Dfax>;
  /** update multiples rows of table: "queue_project_facility_dfax" */
  update_queue_project_facility_dfax_many?: Maybe<Array<Maybe<Queue_Project_Facility_Dfax_Mutation_Response>>>;
  /** update data of the table: "queue_project_hops" */
  update_queue_project_hops?: Maybe<Queue_Project_Hops_Mutation_Response>;
  /** update single row of the table: "queue_project_hops" */
  update_queue_project_hops_by_pk?: Maybe<Queue_Project_Hops>;
  /** update multiples rows of table: "queue_project_hops" */
  update_queue_project_hops_many?: Maybe<Array<Maybe<Queue_Project_Hops_Mutation_Response>>>;
  /** update data of the table: "queue_projects" */
  update_queue_projects?: Maybe<Queue_Projects_Mutation_Response>;
  /** update single row of the table: "queue_projects" */
  update_queue_projects_by_pk?: Maybe<Queue_Projects>;
  /** update multiples rows of table: "queue_projects" */
  update_queue_projects_many?: Maybe<Array<Maybe<Queue_Projects_Mutation_Response>>>;
  /** update data of the table: "scenario_allocated_upgrades" */
  update_scenario_allocated_upgrades?: Maybe<Scenario_Allocated_Upgrades_Mutation_Response>;
  /** update single row of the table: "scenario_allocated_upgrades" */
  update_scenario_allocated_upgrades_by_pk?: Maybe<Scenario_Allocated_Upgrades>;
  /** update multiples rows of table: "scenario_allocated_upgrades" */
  update_scenario_allocated_upgrades_many?: Maybe<Array<Maybe<Scenario_Allocated_Upgrades_Mutation_Response>>>;
  /** update data of the table: "scenario_configurations" */
  update_scenario_configurations?: Maybe<Scenario_Configurations_Mutation_Response>;
  /** update single row of the table: "scenario_configurations" */
  update_scenario_configurations_by_pk?: Maybe<Scenario_Configurations>;
  /** update multiples rows of table: "scenario_configurations" */
  update_scenario_configurations_many?: Maybe<Array<Maybe<Scenario_Configurations_Mutation_Response>>>;
  /** update data of the table: "scenario_constraints" */
  update_scenario_constraints?: Maybe<Scenario_Constraints_Mutation_Response>;
  /** update single row of the table: "scenario_constraints" */
  update_scenario_constraints_by_pk?: Maybe<Scenario_Constraints>;
  /** update multiples rows of table: "scenario_constraints" */
  update_scenario_constraints_many?: Maybe<Array<Maybe<Scenario_Constraints_Mutation_Response>>>;
  /** update data of the table: "scenario_origins" */
  update_scenario_origins?: Maybe<Scenario_Origins_Mutation_Response>;
  /** update single row of the table: "scenario_origins" */
  update_scenario_origins_by_pk?: Maybe<Scenario_Origins>;
  /** update multiples rows of table: "scenario_origins" */
  update_scenario_origins_many?: Maybe<Array<Maybe<Scenario_Origins_Mutation_Response>>>;
  /** update data of the table: "scenario_project_ranks" */
  update_scenario_project_ranks?: Maybe<Scenario_Project_Ranks_Mutation_Response>;
  /** update single row of the table: "scenario_project_ranks" */
  update_scenario_project_ranks_by_pk?: Maybe<Scenario_Project_Ranks>;
  /** update multiples rows of table: "scenario_project_ranks" */
  update_scenario_project_ranks_many?: Maybe<Array<Maybe<Scenario_Project_Ranks_Mutation_Response>>>;
  /** update data of the table: "scenario_projects" */
  update_scenario_projects?: Maybe<Scenario_Projects_Mutation_Response>;
  /** update single row of the table: "scenario_projects" */
  update_scenario_projects_by_pk?: Maybe<Scenario_Projects>;
  /** update multiples rows of table: "scenario_projects" */
  update_scenario_projects_many?: Maybe<Array<Maybe<Scenario_Projects_Mutation_Response>>>;
  /** update data of the table: "scenario_statuses" */
  update_scenario_statuses?: Maybe<Scenario_Statuses_Mutation_Response>;
  /** update single row of the table: "scenario_statuses" */
  update_scenario_statuses_by_pk?: Maybe<Scenario_Statuses>;
  /** update multiples rows of table: "scenario_statuses" */
  update_scenario_statuses_many?: Maybe<Array<Maybe<Scenario_Statuses_Mutation_Response>>>;
  /** update data of the table: "scenarios" */
  update_scenarios?: Maybe<Scenarios_Mutation_Response>;
  /** update single row of the table: "scenarios" */
  update_scenarios_by_pk?: Maybe<Scenarios>;
  /** update multiples rows of table: "scenarios" */
  update_scenarios_many?: Maybe<Array<Maybe<Scenarios_Mutation_Response>>>;
  /** update data of the table: "scopes" */
  update_scopes?: Maybe<Scopes_Mutation_Response>;
  /** update single row of the table: "scopes" */
  update_scopes_by_pk?: Maybe<Scopes>;
  /** update multiples rows of table: "scopes" */
  update_scopes_many?: Maybe<Array<Maybe<Scopes_Mutation_Response>>>;
  /** update data of the table: "screening_views" */
  update_screening_views?: Maybe<Screening_Views_Mutation_Response>;
  /** update single row of the table: "screening_views" */
  update_screening_views_by_pk?: Maybe<Screening_Views>;
  /** update multiples rows of table: "screening_views" */
  update_screening_views_many?: Maybe<Array<Maybe<Screening_Views_Mutation_Response>>>;
  /** update data of the table: "sis_project_cost_type_metadata" */
  update_sis_project_cost_type_metadata?: Maybe<Sis_Project_Cost_Type_Metadata_Mutation_Response>;
  /** update single row of the table: "sis_project_cost_type_metadata" */
  update_sis_project_cost_type_metadata_by_pk?: Maybe<Sis_Project_Cost_Type_Metadata>;
  /** update multiples rows of table: "sis_project_cost_type_metadata" */
  update_sis_project_cost_type_metadata_many?: Maybe<Array<Maybe<Sis_Project_Cost_Type_Metadata_Mutation_Response>>>;
  /** update data of the table: "sis_report_postings" */
  update_sis_report_postings?: Maybe<Sis_Report_Postings_Mutation_Response>;
  /** update single row of the table: "sis_report_postings" */
  update_sis_report_postings_by_pk?: Maybe<Sis_Report_Postings>;
  /** update multiples rows of table: "sis_report_postings" */
  update_sis_report_postings_many?: Maybe<Array<Maybe<Sis_Report_Postings_Mutation_Response>>>;
  /** update data of the table: "subscription_add_ons" */
  update_subscription_add_ons?: Maybe<Subscription_Add_Ons_Mutation_Response>;
  /** update single row of the table: "subscription_add_ons" */
  update_subscription_add_ons_by_pk?: Maybe<Subscription_Add_Ons>;
  /** update multiples rows of table: "subscription_add_ons" */
  update_subscription_add_ons_many?: Maybe<Array<Maybe<Subscription_Add_Ons_Mutation_Response>>>;
  /** update data of the table: "subscriptions" */
  update_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** update single row of the table: "subscriptions" */
  update_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** update multiples rows of table: "subscriptions" */
  update_subscriptions_many?: Maybe<Array<Maybe<Subscriptions_Mutation_Response>>>;
  /** update data of the table: "teams" */
  update_teams?: Maybe<Teams_Mutation_Response>;
  /** update single row of the table: "teams" */
  update_teams_by_pk?: Maybe<Teams>;
  /** update multiples rows of table: "teams" */
  update_teams_many?: Maybe<Array<Maybe<Teams_Mutation_Response>>>;
  /** update data of the table: "tracked_projects" */
  update_tracked_projects?: Maybe<Tracked_Projects_Mutation_Response>;
  /** update single row of the table: "tracked_projects" */
  update_tracked_projects_by_pk?: Maybe<Tracked_Projects>;
  /** update multiples rows of table: "tracked_projects" */
  update_tracked_projects_many?: Maybe<Array<Maybe<Tracked_Projects_Mutation_Response>>>;
  /** update data of the table: "unlocked_buses" */
  update_unlocked_buses?: Maybe<Unlocked_Buses_Mutation_Response>;
  /** update single row of the table: "unlocked_buses" */
  update_unlocked_buses_by_pk?: Maybe<Unlocked_Buses>;
  /** update multiples rows of table: "unlocked_buses" */
  update_unlocked_buses_many?: Maybe<Array<Maybe<Unlocked_Buses_Mutation_Response>>>;
  /** update data of the table: "user_scope_configs" */
  update_user_scope_configs?: Maybe<User_Scope_Configs_Mutation_Response>;
  /** update single row of the table: "user_scope_configs" */
  update_user_scope_configs_by_pk?: Maybe<User_Scope_Configs>;
  /** update multiples rows of table: "user_scope_configs" */
  update_user_scope_configs_many?: Maybe<Array<Maybe<User_Scope_Configs_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Additional_Column_ConfigsArgs = {
  where: Additional_Column_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Additional_Column_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin_App_Audit_LogArgs = {
  where: Admin_App_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_App_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Admin_App_Audit_Log_TargetsArgs = {
  where: Admin_App_Audit_Log_Targets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Admin_App_Audit_Log_Targets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Advanced_StudiesArgs = {
  where: Advanced_Studies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Advanced_Studies_By_PkArgs = {
  advanced_study_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Advanced_Study_Constraint_StacksArgs = {
  where: Advanced_Study_Constraint_Stacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Advanced_Study_Constraint_Stacks_By_PkArgs = {
  advanced_study_id: Scalars['uuid']['input'];
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Advanced_Study_LoadsArgs = {
  where: Advanced_Study_Loads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Advanced_Study_Loads_By_PkArgs = {
  advanced_study_id: Scalars['uuid']['input'];
  facility_type: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_All_ProjectsArgs = {
  where: All_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_All_Projects_By_PkArgs = {
  cluster_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BranchesArgs = {
  where: Branches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Branches_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_ColorsArgs = {
  where: Brand_Colors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Colors_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Bus_OverridesArgs = {
  where: Bus_Overrides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bus_Overrides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Buses_To_ScopesArgs = {
  where: Buses_To_Scopes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Buses_To_Scopes_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Buses_Without_OverridesArgs = {
  where: Buses_Without_Overrides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Buses_Without_Overrides_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Capacity_CostsArgs = {
  where: Capacity_Costs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Capacity_Costs_By_PkArgs = {
  energy_size: Scalars['numeric']['input'];
  includes_pre_existing: Scalars['Boolean']['input'];
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ceii_AccessArgs = {
  where: Ceii_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ceii_Access_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Constraint_StacksArgs = {
  where: Constraint_Stacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Constraint_Stacks_By_PkArgs = {
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  resource_type: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Constraint_TypesArgs = {
  where: Constraint_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Constraint_Types_By_PkArgs = {
  constraint_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_FilesArgs = {
  where: Custom_Upgrade_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Model_Set_Validation_FailuresArgs = {
  where: Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Model_Set_Validation_Failures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Model_Set_ValidationsArgs = {
  where: Custom_Upgrade_Model_Set_Validations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Model_Set_Validations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Validation_Failure_CodesArgs = {
  where: Custom_Upgrade_Validation_Failure_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Validation_Failure_Codes_By_PkArgs = {
  code: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Validation_Failure_SeveritiesArgs = {
  where: Custom_Upgrade_Validation_Failure_Severities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Validation_Failure_Severities_By_PkArgs = {
  severity: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Validation_StatusesArgs = {
  where: Custom_Upgrade_Validation_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrade_Validation_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Custom_UpgradesArgs = {
  where: Custom_Upgrades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Custom_Upgrades_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Data_VersionsArgs = {
  where: Data_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Data_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_External_Api_ScopesArgs = {
  where: External_Api_Scopes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Favorite_BusesArgs = {
  where: Favorite_Buses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Favorite_Buses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Gtc_ExposureArgs = {
  where: Gtc_Exposure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gtc_Exposure_By_PkArgs = {
  interface_acronym: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  region: Scalars['String']['input'];
  source_case: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Cluster_Model_Set_StatusesArgs = {
  where: In_Queue_Cluster_Model_Set_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Cluster_Model_Set_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Cluster_Model_SetsArgs = {
  where: In_Queue_Cluster_Model_Sets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Cluster_Model_Sets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Cluster_StatusesArgs = {
  where: In_Queue_Cluster_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Cluster_Statuses_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_ClustersArgs = {
  where: In_Queue_Clusters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Clusters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Model_PoisArgs = {
  where: In_Queue_Model_Pois_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Model_Pois_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Model_VariantsArgs = {
  where: In_Queue_Model_Variants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Model_Variants_By_PkArgs = {
  variant: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Region_Model_VariantsArgs = {
  where: In_Queue_Region_Model_Variants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Region_Model_Variants_By_PkArgs = {
  region: Scalars['String']['input'];
  variant: In_Queue_Model_Variants_Enum;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Speculative_ProjectsArgs = {
  where: In_Queue_Speculative_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Speculative_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Subscription_Add_OnsArgs = {
  where: In_Queue_Subscription_Add_Ons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Subscription_Add_Ons_By_PkArgs = {
  add_on: Subscription_Add_Ons_Enum;
  subscription_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_SubscriptionsArgs = {
  where: In_Queue_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_In_Queue_Subscriptions_By_PkArgs = {
  subscription_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Line_Capacity_CostsArgs = {
  where: Line_Capacity_Costs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Line_Capacity_Costs_By_PkArgs = {
  energy_size: Scalars['numeric']['input'];
  includes_pre_existing: Scalars['Boolean']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  tap_facility_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Line_Constraint_StacksArgs = {
  where: Line_Constraint_Stacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Line_Constraint_Stacks_By_PkArgs = {
  monitored_facility_id: Scalars['String']['input'];
  resource_type: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  tap_facility_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Model_Generator_Facility_DfaxArgs = {
  where: Model_Generator_Facility_Dfax_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_Generator_Facility_Dfax_By_PkArgs = {
  contingency: Scalars['String']['input'];
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Model_GeneratorsArgs = {
  where: Model_Generators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_Generators_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Model_LinesArgs = {
  where: Model_Lines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_Lines_By_PkArgs = {
  facility_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Model_Lines_To_BranchesArgs = {
  where: Model_Lines_To_Branches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_Lines_To_Branches_By_PkArgs = {
  branch_id: Scalars['String']['input'];
  facility_id: Scalars['String']['input'];
  region: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Model_Lines_To_Missing_BusesArgs = {
  where: Model_Lines_To_Missing_Buses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Model_Lines_To_Missing_Buses_By_PkArgs = {
  facility_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Planned_Interconnection_LocationsArgs = {
  where: Planned_Interconnection_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Planned_Interconnection_Locations_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Additional_CostsArgs = {
  where: Project_Additional_Costs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Additional_Costs_By_PkArgs = {
  cost_type: Project_Cost_Types_Enum;
  posting_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
  source: Project_Cost_Sources_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Project_ConfigurationsArgs = {
  where: Project_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Configurations_By_PkArgs = {
  cluster_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
  team_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Cost_SourcesArgs = {
  where: Project_Cost_Sources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Cost_Sources_By_PkArgs = {
  source: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Cost_TypesArgs = {
  where: Project_Cost_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Cost_Types_By_PkArgs = {
  cost_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_Tag_AssignmentsArgs = {
  where: Project_Tag_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Tag_Assignments_By_PkArgs = {
  project_id: Scalars['String']['input'];
  tag_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Project_TagsArgs = {
  where: Project_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Queue_Project_Connection_PointsArgs = {
  where: Queue_Project_Connection_Points_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queue_Project_Connection_Points_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Queue_Project_Connection_TypesArgs = {
  where: Queue_Project_Connection_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queue_Project_Connection_Types_By_PkArgs = {
  connection_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Queue_Project_Facility_DfaxArgs = {
  where: Queue_Project_Facility_Dfax_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queue_Project_Facility_Dfax_By_PkArgs = {
  contingency: Scalars['String']['input'];
  monitored_facility_id: Scalars['String']['input'];
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Queue_Project_HopsArgs = {
  where: Queue_Project_Hops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queue_Project_Hops_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Queue_ProjectsArgs = {
  where: Queue_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Queue_Projects_By_PkArgs = {
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Allocated_UpgradesArgs = {
  where: Scenario_Allocated_Upgrades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Allocated_Upgrades_By_PkArgs = {
  constraint_type: Constraint_Types_Enum;
  network_upgrade_id: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scenario_ConfigurationsArgs = {
  where: Scenario_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Configurations_By_PkArgs = {
  scenario_id: Scalars['uuid']['input'];
  team_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scenario_ConstraintsArgs = {
  where: Scenario_Constraints_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Constraints_By_PkArgs = {
  constraint_type: Constraint_Types_Enum;
  facility_id: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
  worst_contingency_name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scenario_OriginsArgs = {
  where: Scenario_Origins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Origins_By_PkArgs = {
  origin: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Project_RanksArgs = {
  where: Scenario_Project_Ranks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Project_Ranks_By_PkArgs = {
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scenario_ProjectsArgs = {
  where: Scenario_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Projects_By_PkArgs = {
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Scenario_StatusesArgs = {
  where: Scenario_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scenario_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ScenariosArgs = {
  where: Scenarios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scenarios_By_PkArgs = {
  scenario_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ScopesArgs = {
  where: Scopes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scopes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Screening_ViewsArgs = {
  where: Screening_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Screening_Views_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Sis_Project_Cost_Type_MetadataArgs = {
  where: Sis_Project_Cost_Type_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sis_Project_Cost_Type_Metadata_By_PkArgs = {
  cost_type: Project_Cost_Types_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Sis_Report_PostingsArgs = {
  where: Sis_Report_Postings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sis_Report_Postings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Add_OnsArgs = {
  where: Subscription_Add_Ons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscription_Add_Ons_By_PkArgs = {
  add_on: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SubscriptionsArgs = {
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TeamsArgs = {
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tracked_ProjectsArgs = {
  where: Tracked_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tracked_Projects_By_PkArgs = {
  project_id: Scalars['String']['input'];
  subscription_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Unlocked_BusesArgs = {
  where: Unlocked_Buses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unlocked_Buses_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Scope_ConfigsArgs = {
  where: User_Scope_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Scope_Configs_By_PkArgs = {
  scope: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  auth0_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Additional_Column_ConfigsArgs = {
  objects: Array<Additional_Column_Configs_Insert_Input>;
  on_conflict?: InputMaybe<Additional_Column_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Additional_Column_Configs_OneArgs = {
  object: Additional_Column_Configs_Insert_Input;
  on_conflict?: InputMaybe<Additional_Column_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_App_Audit_LogArgs = {
  objects: Array<Admin_App_Audit_Log_Insert_Input>;
  on_conflict?: InputMaybe<Admin_App_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_App_Audit_Log_OneArgs = {
  object: Admin_App_Audit_Log_Insert_Input;
  on_conflict?: InputMaybe<Admin_App_Audit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_App_Audit_Log_TargetsArgs = {
  objects: Array<Admin_App_Audit_Log_Targets_Insert_Input>;
  on_conflict?: InputMaybe<Admin_App_Audit_Log_Targets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Admin_App_Audit_Log_Targets_OneArgs = {
  object: Admin_App_Audit_Log_Targets_Insert_Input;
  on_conflict?: InputMaybe<Admin_App_Audit_Log_Targets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advanced_StudiesArgs = {
  objects: Array<Advanced_Studies_Insert_Input>;
  on_conflict?: InputMaybe<Advanced_Studies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advanced_Studies_OneArgs = {
  object: Advanced_Studies_Insert_Input;
  on_conflict?: InputMaybe<Advanced_Studies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advanced_Study_Constraint_StacksArgs = {
  objects: Array<Advanced_Study_Constraint_Stacks_Insert_Input>;
  on_conflict?: InputMaybe<Advanced_Study_Constraint_Stacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advanced_Study_Constraint_Stacks_OneArgs = {
  object: Advanced_Study_Constraint_Stacks_Insert_Input;
  on_conflict?: InputMaybe<Advanced_Study_Constraint_Stacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advanced_Study_LoadsArgs = {
  objects: Array<Advanced_Study_Loads_Insert_Input>;
  on_conflict?: InputMaybe<Advanced_Study_Loads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advanced_Study_Loads_OneArgs = {
  object: Advanced_Study_Loads_Insert_Input;
  on_conflict?: InputMaybe<Advanced_Study_Loads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_All_ProjectsArgs = {
  objects: Array<All_Projects_Insert_Input>;
  on_conflict?: InputMaybe<All_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_All_Projects_OneArgs = {
  object: All_Projects_Insert_Input;
  on_conflict?: InputMaybe<All_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BranchesArgs = {
  objects: Array<Branches_Insert_Input>;
  on_conflict?: InputMaybe<Branches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Branches_OneArgs = {
  object: Branches_Insert_Input;
  on_conflict?: InputMaybe<Branches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_ColorsArgs = {
  objects: Array<Brand_Colors_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Colors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Colors_OneArgs = {
  object: Brand_Colors_Insert_Input;
  on_conflict?: InputMaybe<Brand_Colors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bus_OverridesArgs = {
  objects: Array<Bus_Overrides_Insert_Input>;
  on_conflict?: InputMaybe<Bus_Overrides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bus_Overrides_OneArgs = {
  object: Bus_Overrides_Insert_Input;
  on_conflict?: InputMaybe<Bus_Overrides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buses_To_ScopesArgs = {
  objects: Array<Buses_To_Scopes_Insert_Input>;
  on_conflict?: InputMaybe<Buses_To_Scopes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buses_To_Scopes_OneArgs = {
  object: Buses_To_Scopes_Insert_Input;
  on_conflict?: InputMaybe<Buses_To_Scopes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buses_Without_OverridesArgs = {
  objects: Array<Buses_Without_Overrides_Insert_Input>;
  on_conflict?: InputMaybe<Buses_Without_Overrides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buses_Without_Overrides_OneArgs = {
  object: Buses_Without_Overrides_Insert_Input;
  on_conflict?: InputMaybe<Buses_Without_Overrides_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Capacity_CostsArgs = {
  objects: Array<Capacity_Costs_Insert_Input>;
  on_conflict?: InputMaybe<Capacity_Costs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Capacity_Costs_OneArgs = {
  object: Capacity_Costs_Insert_Input;
  on_conflict?: InputMaybe<Capacity_Costs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ceii_AccessArgs = {
  objects: Array<Ceii_Access_Insert_Input>;
  on_conflict?: InputMaybe<Ceii_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ceii_Access_OneArgs = {
  object: Ceii_Access_Insert_Input;
  on_conflict?: InputMaybe<Ceii_Access_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Constraint_StacksArgs = {
  objects: Array<Constraint_Stacks_Insert_Input>;
  on_conflict?: InputMaybe<Constraint_Stacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Constraint_Stacks_OneArgs = {
  object: Constraint_Stacks_Insert_Input;
  on_conflict?: InputMaybe<Constraint_Stacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Constraint_TypesArgs = {
  objects: Array<Constraint_Types_Insert_Input>;
  on_conflict?: InputMaybe<Constraint_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Constraint_Types_OneArgs = {
  object: Constraint_Types_Insert_Input;
  on_conflict?: InputMaybe<Constraint_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_FilesArgs = {
  objects: Array<Custom_Upgrade_Files_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Upgrade_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Files_OneArgs = {
  object: Custom_Upgrade_Files_Insert_Input;
  on_conflict?: InputMaybe<Custom_Upgrade_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Model_Set_Validation_FailuresArgs = {
  objects: Array<Custom_Upgrade_Model_Set_Validation_Failures_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Model_Set_Validation_Failures_OneArgs = {
  object: Custom_Upgrade_Model_Set_Validation_Failures_Insert_Input;
  on_conflict?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Model_Set_ValidationsArgs = {
  objects: Array<Custom_Upgrade_Model_Set_Validations_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Upgrade_Model_Set_Validations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Model_Set_Validations_OneArgs = {
  object: Custom_Upgrade_Model_Set_Validations_Insert_Input;
  on_conflict?: InputMaybe<Custom_Upgrade_Model_Set_Validations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Validation_Failure_CodesArgs = {
  objects: Array<Custom_Upgrade_Validation_Failure_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Validation_Failure_Codes_OneArgs = {
  object: Custom_Upgrade_Validation_Failure_Codes_Insert_Input;
  on_conflict?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Validation_Failure_SeveritiesArgs = {
  objects: Array<Custom_Upgrade_Validation_Failure_Severities_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Validation_Failure_Severities_OneArgs = {
  object: Custom_Upgrade_Validation_Failure_Severities_Insert_Input;
  on_conflict?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Validation_StatusesArgs = {
  objects: Array<Custom_Upgrade_Validation_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Upgrade_Validation_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrade_Validation_Statuses_OneArgs = {
  object: Custom_Upgrade_Validation_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Custom_Upgrade_Validation_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_UpgradesArgs = {
  objects: Array<Custom_Upgrades_Insert_Input>;
  on_conflict?: InputMaybe<Custom_Upgrades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Custom_Upgrades_OneArgs = {
  object: Custom_Upgrades_Insert_Input;
  on_conflict?: InputMaybe<Custom_Upgrades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_VersionsArgs = {
  objects: Array<Data_Versions_Insert_Input>;
  on_conflict?: InputMaybe<Data_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data_Versions_OneArgs = {
  object: Data_Versions_Insert_Input;
  on_conflict?: InputMaybe<Data_Versions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_Api_ScopesArgs = {
  objects: Array<External_Api_Scopes_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_External_Api_Scopes_OneArgs = {
  object: External_Api_Scopes_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Favorite_BusesArgs = {
  objects: Array<Favorite_Buses_Insert_Input>;
  on_conflict?: InputMaybe<Favorite_Buses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Favorite_Buses_OneArgs = {
  object: Favorite_Buses_Insert_Input;
  on_conflict?: InputMaybe<Favorite_Buses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gtc_ExposureArgs = {
  objects: Array<Gtc_Exposure_Insert_Input>;
  on_conflict?: InputMaybe<Gtc_Exposure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gtc_Exposure_OneArgs = {
  object: Gtc_Exposure_Insert_Input;
  on_conflict?: InputMaybe<Gtc_Exposure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Cluster_Model_Set_StatusesArgs = {
  objects: Array<In_Queue_Cluster_Model_Set_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Cluster_Model_Set_Statuses_OneArgs = {
  object: In_Queue_Cluster_Model_Set_Statuses_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Cluster_Model_SetsArgs = {
  objects: Array<In_Queue_Cluster_Model_Sets_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Cluster_Model_Sets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Cluster_Model_Sets_OneArgs = {
  object: In_Queue_Cluster_Model_Sets_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Cluster_Model_Sets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Cluster_StatusesArgs = {
  objects: Array<In_Queue_Cluster_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Cluster_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Cluster_Statuses_OneArgs = {
  object: In_Queue_Cluster_Statuses_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Cluster_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_ClustersArgs = {
  objects: Array<In_Queue_Clusters_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Clusters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Clusters_OneArgs = {
  object: In_Queue_Clusters_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Clusters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Model_PoisArgs = {
  objects: Array<In_Queue_Model_Pois_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Model_Pois_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Model_Pois_OneArgs = {
  object: In_Queue_Model_Pois_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Model_Pois_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Model_VariantsArgs = {
  objects: Array<In_Queue_Model_Variants_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Model_Variants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Model_Variants_OneArgs = {
  object: In_Queue_Model_Variants_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Model_Variants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Region_Model_VariantsArgs = {
  objects: Array<In_Queue_Region_Model_Variants_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Region_Model_Variants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Region_Model_Variants_OneArgs = {
  object: In_Queue_Region_Model_Variants_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Region_Model_Variants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Speculative_ProjectsArgs = {
  objects: Array<In_Queue_Speculative_Projects_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Speculative_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Speculative_Projects_OneArgs = {
  object: In_Queue_Speculative_Projects_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Speculative_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Subscription_Add_OnsArgs = {
  objects: Array<In_Queue_Subscription_Add_Ons_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Subscription_Add_Ons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Subscription_Add_Ons_OneArgs = {
  object: In_Queue_Subscription_Add_Ons_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Subscription_Add_Ons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_SubscriptionsArgs = {
  objects: Array<In_Queue_Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<In_Queue_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_In_Queue_Subscriptions_OneArgs = {
  object: In_Queue_Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<In_Queue_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Capacity_CostsArgs = {
  objects: Array<Line_Capacity_Costs_Insert_Input>;
  on_conflict?: InputMaybe<Line_Capacity_Costs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Capacity_Costs_OneArgs = {
  object: Line_Capacity_Costs_Insert_Input;
  on_conflict?: InputMaybe<Line_Capacity_Costs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Constraint_StacksArgs = {
  objects: Array<Line_Constraint_Stacks_Insert_Input>;
  on_conflict?: InputMaybe<Line_Constraint_Stacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Line_Constraint_Stacks_OneArgs = {
  object: Line_Constraint_Stacks_Insert_Input;
  on_conflict?: InputMaybe<Line_Constraint_Stacks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Generator_Facility_DfaxArgs = {
  objects: Array<Model_Generator_Facility_Dfax_Insert_Input>;
  on_conflict?: InputMaybe<Model_Generator_Facility_Dfax_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Generator_Facility_Dfax_OneArgs = {
  object: Model_Generator_Facility_Dfax_Insert_Input;
  on_conflict?: InputMaybe<Model_Generator_Facility_Dfax_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_GeneratorsArgs = {
  objects: Array<Model_Generators_Insert_Input>;
  on_conflict?: InputMaybe<Model_Generators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Generators_OneArgs = {
  object: Model_Generators_Insert_Input;
  on_conflict?: InputMaybe<Model_Generators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_LinesArgs = {
  objects: Array<Model_Lines_Insert_Input>;
  on_conflict?: InputMaybe<Model_Lines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Lines_OneArgs = {
  object: Model_Lines_Insert_Input;
  on_conflict?: InputMaybe<Model_Lines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Lines_To_BranchesArgs = {
  objects: Array<Model_Lines_To_Branches_Insert_Input>;
  on_conflict?: InputMaybe<Model_Lines_To_Branches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Lines_To_Branches_OneArgs = {
  object: Model_Lines_To_Branches_Insert_Input;
  on_conflict?: InputMaybe<Model_Lines_To_Branches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Lines_To_Missing_BusesArgs = {
  objects: Array<Model_Lines_To_Missing_Buses_Insert_Input>;
  on_conflict?: InputMaybe<Model_Lines_To_Missing_Buses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Lines_To_Missing_Buses_OneArgs = {
  object: Model_Lines_To_Missing_Buses_Insert_Input;
  on_conflict?: InputMaybe<Model_Lines_To_Missing_Buses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Planned_Interconnection_LocationsArgs = {
  objects: Array<Planned_Interconnection_Locations_Insert_Input>;
  on_conflict?: InputMaybe<Planned_Interconnection_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Planned_Interconnection_Locations_OneArgs = {
  object: Planned_Interconnection_Locations_Insert_Input;
  on_conflict?: InputMaybe<Planned_Interconnection_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Additional_CostsArgs = {
  objects: Array<Project_Additional_Costs_Insert_Input>;
  on_conflict?: InputMaybe<Project_Additional_Costs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Additional_Costs_OneArgs = {
  object: Project_Additional_Costs_Insert_Input;
  on_conflict?: InputMaybe<Project_Additional_Costs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_ConfigurationsArgs = {
  objects: Array<Project_Configurations_Insert_Input>;
  on_conflict?: InputMaybe<Project_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Configurations_OneArgs = {
  object: Project_Configurations_Insert_Input;
  on_conflict?: InputMaybe<Project_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Cost_SourcesArgs = {
  objects: Array<Project_Cost_Sources_Insert_Input>;
  on_conflict?: InputMaybe<Project_Cost_Sources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Cost_Sources_OneArgs = {
  object: Project_Cost_Sources_Insert_Input;
  on_conflict?: InputMaybe<Project_Cost_Sources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Cost_TypesArgs = {
  objects: Array<Project_Cost_Types_Insert_Input>;
  on_conflict?: InputMaybe<Project_Cost_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Cost_Types_OneArgs = {
  object: Project_Cost_Types_Insert_Input;
  on_conflict?: InputMaybe<Project_Cost_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Tag_AssignmentsArgs = {
  objects: Array<Project_Tag_Assignments_Insert_Input>;
  on_conflict?: InputMaybe<Project_Tag_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Tag_Assignments_OneArgs = {
  object: Project_Tag_Assignments_Insert_Input;
  on_conflict?: InputMaybe<Project_Tag_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_TagsArgs = {
  objects: Array<Project_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Project_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Tags_OneArgs = {
  object: Project_Tags_Insert_Input;
  on_conflict?: InputMaybe<Project_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Project_Connection_PointsArgs = {
  objects: Array<Queue_Project_Connection_Points_Insert_Input>;
  on_conflict?: InputMaybe<Queue_Project_Connection_Points_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Project_Connection_Points_OneArgs = {
  object: Queue_Project_Connection_Points_Insert_Input;
  on_conflict?: InputMaybe<Queue_Project_Connection_Points_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Project_Connection_TypesArgs = {
  objects: Array<Queue_Project_Connection_Types_Insert_Input>;
  on_conflict?: InputMaybe<Queue_Project_Connection_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Project_Connection_Types_OneArgs = {
  object: Queue_Project_Connection_Types_Insert_Input;
  on_conflict?: InputMaybe<Queue_Project_Connection_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Project_Facility_DfaxArgs = {
  objects: Array<Queue_Project_Facility_Dfax_Insert_Input>;
  on_conflict?: InputMaybe<Queue_Project_Facility_Dfax_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Project_Facility_Dfax_OneArgs = {
  object: Queue_Project_Facility_Dfax_Insert_Input;
  on_conflict?: InputMaybe<Queue_Project_Facility_Dfax_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Project_HopsArgs = {
  objects: Array<Queue_Project_Hops_Insert_Input>;
  on_conflict?: InputMaybe<Queue_Project_Hops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Project_Hops_OneArgs = {
  object: Queue_Project_Hops_Insert_Input;
  on_conflict?: InputMaybe<Queue_Project_Hops_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_ProjectsArgs = {
  objects: Array<Queue_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Queue_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Queue_Projects_OneArgs = {
  object: Queue_Projects_Insert_Input;
  on_conflict?: InputMaybe<Queue_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Allocated_UpgradesArgs = {
  objects: Array<Scenario_Allocated_Upgrades_Insert_Input>;
  on_conflict?: InputMaybe<Scenario_Allocated_Upgrades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Allocated_Upgrades_OneArgs = {
  object: Scenario_Allocated_Upgrades_Insert_Input;
  on_conflict?: InputMaybe<Scenario_Allocated_Upgrades_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_ConfigurationsArgs = {
  objects: Array<Scenario_Configurations_Insert_Input>;
  on_conflict?: InputMaybe<Scenario_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Configurations_OneArgs = {
  object: Scenario_Configurations_Insert_Input;
  on_conflict?: InputMaybe<Scenario_Configurations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_ConstraintsArgs = {
  objects: Array<Scenario_Constraints_Insert_Input>;
  on_conflict?: InputMaybe<Scenario_Constraints_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Constraints_OneArgs = {
  object: Scenario_Constraints_Insert_Input;
  on_conflict?: InputMaybe<Scenario_Constraints_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_OriginsArgs = {
  objects: Array<Scenario_Origins_Insert_Input>;
  on_conflict?: InputMaybe<Scenario_Origins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Origins_OneArgs = {
  object: Scenario_Origins_Insert_Input;
  on_conflict?: InputMaybe<Scenario_Origins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Project_RanksArgs = {
  objects: Array<Scenario_Project_Ranks_Insert_Input>;
  on_conflict?: InputMaybe<Scenario_Project_Ranks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Project_Ranks_OneArgs = {
  object: Scenario_Project_Ranks_Insert_Input;
  on_conflict?: InputMaybe<Scenario_Project_Ranks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_ProjectsArgs = {
  objects: Array<Scenario_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Scenario_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Projects_OneArgs = {
  object: Scenario_Projects_Insert_Input;
  on_conflict?: InputMaybe<Scenario_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_StatusesArgs = {
  objects: Array<Scenario_Statuses_Insert_Input>;
  on_conflict?: InputMaybe<Scenario_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenario_Statuses_OneArgs = {
  object: Scenario_Statuses_Insert_Input;
  on_conflict?: InputMaybe<Scenario_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScenariosArgs = {
  objects: Array<Scenarios_Insert_Input>;
  on_conflict?: InputMaybe<Scenarios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scenarios_OneArgs = {
  object: Scenarios_Insert_Input;
  on_conflict?: InputMaybe<Scenarios_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScopesArgs = {
  objects: Array<Scopes_Insert_Input>;
  on_conflict?: InputMaybe<Scopes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scopes_OneArgs = {
  object: Scopes_Insert_Input;
  on_conflict?: InputMaybe<Scopes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Screening_ViewsArgs = {
  objects: Array<Screening_Views_Insert_Input>;
  on_conflict?: InputMaybe<Screening_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Screening_Views_OneArgs = {
  object: Screening_Views_Insert_Input;
  on_conflict?: InputMaybe<Screening_Views_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sis_Project_Cost_Type_MetadataArgs = {
  objects: Array<Sis_Project_Cost_Type_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Sis_Project_Cost_Type_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sis_Project_Cost_Type_Metadata_OneArgs = {
  object: Sis_Project_Cost_Type_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Sis_Project_Cost_Type_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sis_Report_PostingsArgs = {
  objects: Array<Sis_Report_Postings_Insert_Input>;
  on_conflict?: InputMaybe<Sis_Report_Postings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sis_Report_Postings_OneArgs = {
  object: Sis_Report_Postings_Insert_Input;
  on_conflict?: InputMaybe<Sis_Report_Postings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Add_OnsArgs = {
  objects: Array<Subscription_Add_Ons_Insert_Input>;
  on_conflict?: InputMaybe<Subscription_Add_Ons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscription_Add_Ons_OneArgs = {
  object: Subscription_Add_Ons_Insert_Input;
  on_conflict?: InputMaybe<Subscription_Add_Ons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubscriptionsArgs = {
  objects: Array<Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_OneArgs = {
  object: Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeamsArgs = {
  objects: Array<Teams_Insert_Input>;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_OneArgs = {
  object: Teams_Insert_Input;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tracked_ProjectsArgs = {
  objects: Array<Tracked_Projects_Insert_Input>;
  on_conflict?: InputMaybe<Tracked_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tracked_Projects_OneArgs = {
  object: Tracked_Projects_Insert_Input;
  on_conflict?: InputMaybe<Tracked_Projects_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unlocked_BusesArgs = {
  objects: Array<Unlocked_Buses_Insert_Input>;
  on_conflict?: InputMaybe<Unlocked_Buses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unlocked_Buses_OneArgs = {
  object: Unlocked_Buses_Insert_Input;
  on_conflict?: InputMaybe<Unlocked_Buses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Scope_ConfigsArgs = {
  objects: Array<User_Scope_Configs_Insert_Input>;
  on_conflict?: InputMaybe<User_Scope_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Scope_Configs_OneArgs = {
  object: User_Scope_Configs_Insert_Input;
  on_conflict?: InputMaybe<User_Scope_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootPublish_Custom_UpgradeArgs = {
  args: Publish_Custom_Upgrade_Args;
  distinct_on?: InputMaybe<Array<Custom_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrades_Order_By>>;
  where?: InputMaybe<Custom_Upgrades_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootPublish_ScenarioArgs = {
  args: Publish_Scenario_Args;
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUnlock_BusArgs = {
  args: Unlock_Bus_Args;
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUnpublish_Custom_UpgradeArgs = {
  args: Unpublish_Custom_Upgrade_Args;
  distinct_on?: InputMaybe<Array<Custom_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrades_Order_By>>;
  where?: InputMaybe<Custom_Upgrades_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUnpublish_ScenarioArgs = {
  args: Unpublish_Scenario_Args;
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_Additional_Column_ConfigsArgs = {
  _set?: InputMaybe<Additional_Column_Configs_Set_Input>;
  where: Additional_Column_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Additional_Column_Configs_By_PkArgs = {
  _set?: InputMaybe<Additional_Column_Configs_Set_Input>;
  pk_columns: Additional_Column_Configs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Additional_Column_Configs_ManyArgs = {
  updates: Array<Additional_Column_Configs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_App_Audit_LogArgs = {
  _set?: InputMaybe<Admin_App_Audit_Log_Set_Input>;
  where: Admin_App_Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_App_Audit_Log_By_PkArgs = {
  _set?: InputMaybe<Admin_App_Audit_Log_Set_Input>;
  pk_columns: Admin_App_Audit_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_App_Audit_Log_ManyArgs = {
  updates: Array<Admin_App_Audit_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_App_Audit_Log_TargetsArgs = {
  _set?: InputMaybe<Admin_App_Audit_Log_Targets_Set_Input>;
  where: Admin_App_Audit_Log_Targets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_App_Audit_Log_Targets_By_PkArgs = {
  _set?: InputMaybe<Admin_App_Audit_Log_Targets_Set_Input>;
  pk_columns: Admin_App_Audit_Log_Targets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Admin_App_Audit_Log_Targets_ManyArgs = {
  updates: Array<Admin_App_Audit_Log_Targets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Advanced_StudiesArgs = {
  _inc?: InputMaybe<Advanced_Studies_Inc_Input>;
  _set?: InputMaybe<Advanced_Studies_Set_Input>;
  where: Advanced_Studies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advanced_Studies_By_PkArgs = {
  _inc?: InputMaybe<Advanced_Studies_Inc_Input>;
  _set?: InputMaybe<Advanced_Studies_Set_Input>;
  pk_columns: Advanced_Studies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advanced_Studies_ManyArgs = {
  updates: Array<Advanced_Studies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Advanced_Study_Constraint_StacksArgs = {
  _inc?: InputMaybe<Advanced_Study_Constraint_Stacks_Inc_Input>;
  _set?: InputMaybe<Advanced_Study_Constraint_Stacks_Set_Input>;
  where: Advanced_Study_Constraint_Stacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advanced_Study_Constraint_Stacks_By_PkArgs = {
  _inc?: InputMaybe<Advanced_Study_Constraint_Stacks_Inc_Input>;
  _set?: InputMaybe<Advanced_Study_Constraint_Stacks_Set_Input>;
  pk_columns: Advanced_Study_Constraint_Stacks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advanced_Study_Constraint_Stacks_ManyArgs = {
  updates: Array<Advanced_Study_Constraint_Stacks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Advanced_Study_LoadsArgs = {
  _inc?: InputMaybe<Advanced_Study_Loads_Inc_Input>;
  _set?: InputMaybe<Advanced_Study_Loads_Set_Input>;
  where: Advanced_Study_Loads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advanced_Study_Loads_By_PkArgs = {
  _inc?: InputMaybe<Advanced_Study_Loads_Inc_Input>;
  _set?: InputMaybe<Advanced_Study_Loads_Set_Input>;
  pk_columns: Advanced_Study_Loads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advanced_Study_Loads_ManyArgs = {
  updates: Array<Advanced_Study_Loads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_All_ProjectsArgs = {
  _append?: InputMaybe<All_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<All_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<All_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<All_Projects_Delete_Key_Input>;
  _inc?: InputMaybe<All_Projects_Inc_Input>;
  _prepend?: InputMaybe<All_Projects_Prepend_Input>;
  _set?: InputMaybe<All_Projects_Set_Input>;
  where: All_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_All_Projects_By_PkArgs = {
  _append?: InputMaybe<All_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<All_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<All_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<All_Projects_Delete_Key_Input>;
  _inc?: InputMaybe<All_Projects_Inc_Input>;
  _prepend?: InputMaybe<All_Projects_Prepend_Input>;
  _set?: InputMaybe<All_Projects_Set_Input>;
  pk_columns: All_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_All_Projects_ManyArgs = {
  updates: Array<All_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BranchesArgs = {
  _append?: InputMaybe<Branches_Append_Input>;
  _delete_at_path?: InputMaybe<Branches_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Branches_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Branches_Delete_Key_Input>;
  _inc?: InputMaybe<Branches_Inc_Input>;
  _prepend?: InputMaybe<Branches_Prepend_Input>;
  _set?: InputMaybe<Branches_Set_Input>;
  where: Branches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Branches_By_PkArgs = {
  _append?: InputMaybe<Branches_Append_Input>;
  _delete_at_path?: InputMaybe<Branches_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Branches_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Branches_Delete_Key_Input>;
  _inc?: InputMaybe<Branches_Inc_Input>;
  _prepend?: InputMaybe<Branches_Prepend_Input>;
  _set?: InputMaybe<Branches_Set_Input>;
  pk_columns: Branches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Branches_ManyArgs = {
  updates: Array<Branches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_ColorsArgs = {
  _set?: InputMaybe<Brand_Colors_Set_Input>;
  where: Brand_Colors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Colors_By_PkArgs = {
  _set?: InputMaybe<Brand_Colors_Set_Input>;
  pk_columns: Brand_Colors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Colors_ManyArgs = {
  updates: Array<Brand_Colors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bus_OverridesArgs = {
  _inc?: InputMaybe<Bus_Overrides_Inc_Input>;
  _set?: InputMaybe<Bus_Overrides_Set_Input>;
  where: Bus_Overrides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bus_Overrides_By_PkArgs = {
  _inc?: InputMaybe<Bus_Overrides_Inc_Input>;
  _set?: InputMaybe<Bus_Overrides_Set_Input>;
  pk_columns: Bus_Overrides_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bus_Overrides_ManyArgs = {
  updates: Array<Bus_Overrides_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buses_To_ScopesArgs = {
  _set?: InputMaybe<Buses_To_Scopes_Set_Input>;
  where: Buses_To_Scopes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Buses_To_Scopes_By_PkArgs = {
  _set?: InputMaybe<Buses_To_Scopes_Set_Input>;
  pk_columns: Buses_To_Scopes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Buses_To_Scopes_ManyArgs = {
  updates: Array<Buses_To_Scopes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buses_Without_OverridesArgs = {
  _append?: InputMaybe<Buses_Without_Overrides_Append_Input>;
  _delete_at_path?: InputMaybe<Buses_Without_Overrides_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Buses_Without_Overrides_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Buses_Without_Overrides_Delete_Key_Input>;
  _inc?: InputMaybe<Buses_Without_Overrides_Inc_Input>;
  _prepend?: InputMaybe<Buses_Without_Overrides_Prepend_Input>;
  _set?: InputMaybe<Buses_Without_Overrides_Set_Input>;
  where: Buses_Without_Overrides_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Buses_Without_Overrides_By_PkArgs = {
  _append?: InputMaybe<Buses_Without_Overrides_Append_Input>;
  _delete_at_path?: InputMaybe<Buses_Without_Overrides_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Buses_Without_Overrides_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Buses_Without_Overrides_Delete_Key_Input>;
  _inc?: InputMaybe<Buses_Without_Overrides_Inc_Input>;
  _prepend?: InputMaybe<Buses_Without_Overrides_Prepend_Input>;
  _set?: InputMaybe<Buses_Without_Overrides_Set_Input>;
  pk_columns: Buses_Without_Overrides_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Buses_Without_Overrides_ManyArgs = {
  updates: Array<Buses_Without_Overrides_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Capacity_CostsArgs = {
  _inc?: InputMaybe<Capacity_Costs_Inc_Input>;
  _set?: InputMaybe<Capacity_Costs_Set_Input>;
  where: Capacity_Costs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Capacity_Costs_By_PkArgs = {
  _inc?: InputMaybe<Capacity_Costs_Inc_Input>;
  _set?: InputMaybe<Capacity_Costs_Set_Input>;
  pk_columns: Capacity_Costs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Capacity_Costs_ManyArgs = {
  updates: Array<Capacity_Costs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ceii_AccessArgs = {
  _inc?: InputMaybe<Ceii_Access_Inc_Input>;
  _set?: InputMaybe<Ceii_Access_Set_Input>;
  where: Ceii_Access_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ceii_Access_By_PkArgs = {
  _inc?: InputMaybe<Ceii_Access_Inc_Input>;
  _set?: InputMaybe<Ceii_Access_Set_Input>;
  pk_columns: Ceii_Access_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ceii_Access_ManyArgs = {
  updates: Array<Ceii_Access_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Constraint_StacksArgs = {
  _inc?: InputMaybe<Constraint_Stacks_Inc_Input>;
  _set?: InputMaybe<Constraint_Stacks_Set_Input>;
  where: Constraint_Stacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Constraint_Stacks_By_PkArgs = {
  _inc?: InputMaybe<Constraint_Stacks_Inc_Input>;
  _set?: InputMaybe<Constraint_Stacks_Set_Input>;
  pk_columns: Constraint_Stacks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Constraint_Stacks_ManyArgs = {
  updates: Array<Constraint_Stacks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Constraint_TypesArgs = {
  _set?: InputMaybe<Constraint_Types_Set_Input>;
  where: Constraint_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Constraint_Types_By_PkArgs = {
  _set?: InputMaybe<Constraint_Types_Set_Input>;
  pk_columns: Constraint_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Constraint_Types_ManyArgs = {
  updates: Array<Constraint_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_FilesArgs = {
  _set?: InputMaybe<Custom_Upgrade_Files_Set_Input>;
  where: Custom_Upgrade_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Files_By_PkArgs = {
  _set?: InputMaybe<Custom_Upgrade_Files_Set_Input>;
  pk_columns: Custom_Upgrade_Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Files_ManyArgs = {
  updates: Array<Custom_Upgrade_Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Model_Set_Validation_FailuresArgs = {
  _inc?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Inc_Input>;
  _set?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Set_Input>;
  where: Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Model_Set_Validation_Failures_By_PkArgs = {
  _inc?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Inc_Input>;
  _set?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Set_Input>;
  pk_columns: Custom_Upgrade_Model_Set_Validation_Failures_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Model_Set_Validation_Failures_ManyArgs = {
  updates: Array<Custom_Upgrade_Model_Set_Validation_Failures_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Model_Set_ValidationsArgs = {
  _set?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Set_Input>;
  where: Custom_Upgrade_Model_Set_Validations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Model_Set_Validations_By_PkArgs = {
  _set?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Set_Input>;
  pk_columns: Custom_Upgrade_Model_Set_Validations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Model_Set_Validations_ManyArgs = {
  updates: Array<Custom_Upgrade_Model_Set_Validations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Validation_Failure_CodesArgs = {
  _set?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Set_Input>;
  where: Custom_Upgrade_Validation_Failure_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Validation_Failure_Codes_By_PkArgs = {
  _set?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Set_Input>;
  pk_columns: Custom_Upgrade_Validation_Failure_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Validation_Failure_Codes_ManyArgs = {
  updates: Array<Custom_Upgrade_Validation_Failure_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Validation_Failure_SeveritiesArgs = {
  _set?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Set_Input>;
  where: Custom_Upgrade_Validation_Failure_Severities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Validation_Failure_Severities_By_PkArgs = {
  _set?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Set_Input>;
  pk_columns: Custom_Upgrade_Validation_Failure_Severities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Validation_Failure_Severities_ManyArgs = {
  updates: Array<Custom_Upgrade_Validation_Failure_Severities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Validation_StatusesArgs = {
  _set?: InputMaybe<Custom_Upgrade_Validation_Statuses_Set_Input>;
  where: Custom_Upgrade_Validation_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Validation_Statuses_By_PkArgs = {
  _set?: InputMaybe<Custom_Upgrade_Validation_Statuses_Set_Input>;
  pk_columns: Custom_Upgrade_Validation_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrade_Validation_Statuses_ManyArgs = {
  updates: Array<Custom_Upgrade_Validation_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_UpgradesArgs = {
  _inc?: InputMaybe<Custom_Upgrades_Inc_Input>;
  _set?: InputMaybe<Custom_Upgrades_Set_Input>;
  where: Custom_Upgrades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrades_By_PkArgs = {
  _inc?: InputMaybe<Custom_Upgrades_Inc_Input>;
  _set?: InputMaybe<Custom_Upgrades_Set_Input>;
  pk_columns: Custom_Upgrades_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Custom_Upgrades_ManyArgs = {
  updates: Array<Custom_Upgrades_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Data_VersionsArgs = {
  _set?: InputMaybe<Data_Versions_Set_Input>;
  where: Data_Versions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Data_Versions_By_PkArgs = {
  _set?: InputMaybe<Data_Versions_Set_Input>;
  pk_columns: Data_Versions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Data_Versions_ManyArgs = {
  updates: Array<Data_Versions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_External_Api_ScopesArgs = {
  _append?: InputMaybe<External_Api_Scopes_Append_Input>;
  _delete_at_path?: InputMaybe<External_Api_Scopes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Api_Scopes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Api_Scopes_Delete_Key_Input>;
  _prepend?: InputMaybe<External_Api_Scopes_Prepend_Input>;
  _set?: InputMaybe<External_Api_Scopes_Set_Input>;
  where: External_Api_Scopes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_External_Api_Scopes_ManyArgs = {
  updates: Array<External_Api_Scopes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Favorite_BusesArgs = {
  _set?: InputMaybe<Favorite_Buses_Set_Input>;
  where: Favorite_Buses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Favorite_Buses_By_PkArgs = {
  _set?: InputMaybe<Favorite_Buses_Set_Input>;
  pk_columns: Favorite_Buses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Favorite_Buses_ManyArgs = {
  updates: Array<Favorite_Buses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gtc_ExposureArgs = {
  _inc?: InputMaybe<Gtc_Exposure_Inc_Input>;
  _set?: InputMaybe<Gtc_Exposure_Set_Input>;
  where: Gtc_Exposure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gtc_Exposure_By_PkArgs = {
  _inc?: InputMaybe<Gtc_Exposure_Inc_Input>;
  _set?: InputMaybe<Gtc_Exposure_Set_Input>;
  pk_columns: Gtc_Exposure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gtc_Exposure_ManyArgs = {
  updates: Array<Gtc_Exposure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Cluster_Model_Set_StatusesArgs = {
  _set?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Set_Input>;
  where: In_Queue_Cluster_Model_Set_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Cluster_Model_Set_Statuses_By_PkArgs = {
  _set?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Set_Input>;
  pk_columns: In_Queue_Cluster_Model_Set_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Cluster_Model_Set_Statuses_ManyArgs = {
  updates: Array<In_Queue_Cluster_Model_Set_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Cluster_Model_SetsArgs = {
  _set?: InputMaybe<In_Queue_Cluster_Model_Sets_Set_Input>;
  where: In_Queue_Cluster_Model_Sets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Cluster_Model_Sets_By_PkArgs = {
  _set?: InputMaybe<In_Queue_Cluster_Model_Sets_Set_Input>;
  pk_columns: In_Queue_Cluster_Model_Sets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Cluster_Model_Sets_ManyArgs = {
  updates: Array<In_Queue_Cluster_Model_Sets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Cluster_StatusesArgs = {
  _set?: InputMaybe<In_Queue_Cluster_Statuses_Set_Input>;
  where: In_Queue_Cluster_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Cluster_Statuses_By_PkArgs = {
  _set?: InputMaybe<In_Queue_Cluster_Statuses_Set_Input>;
  pk_columns: In_Queue_Cluster_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Cluster_Statuses_ManyArgs = {
  updates: Array<In_Queue_Cluster_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_ClustersArgs = {
  _set?: InputMaybe<In_Queue_Clusters_Set_Input>;
  where: In_Queue_Clusters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Clusters_By_PkArgs = {
  _set?: InputMaybe<In_Queue_Clusters_Set_Input>;
  pk_columns: In_Queue_Clusters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Clusters_ManyArgs = {
  updates: Array<In_Queue_Clusters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Model_PoisArgs = {
  _set?: InputMaybe<In_Queue_Model_Pois_Set_Input>;
  where: In_Queue_Model_Pois_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Model_Pois_By_PkArgs = {
  _set?: InputMaybe<In_Queue_Model_Pois_Set_Input>;
  pk_columns: In_Queue_Model_Pois_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Model_Pois_ManyArgs = {
  updates: Array<In_Queue_Model_Pois_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Model_VariantsArgs = {
  _set?: InputMaybe<In_Queue_Model_Variants_Set_Input>;
  where: In_Queue_Model_Variants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Model_Variants_By_PkArgs = {
  _set?: InputMaybe<In_Queue_Model_Variants_Set_Input>;
  pk_columns: In_Queue_Model_Variants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Model_Variants_ManyArgs = {
  updates: Array<In_Queue_Model_Variants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Region_Model_VariantsArgs = {
  _set?: InputMaybe<In_Queue_Region_Model_Variants_Set_Input>;
  where: In_Queue_Region_Model_Variants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Region_Model_Variants_By_PkArgs = {
  _set?: InputMaybe<In_Queue_Region_Model_Variants_Set_Input>;
  pk_columns: In_Queue_Region_Model_Variants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Region_Model_Variants_ManyArgs = {
  updates: Array<In_Queue_Region_Model_Variants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Speculative_ProjectsArgs = {
  _inc?: InputMaybe<In_Queue_Speculative_Projects_Inc_Input>;
  _set?: InputMaybe<In_Queue_Speculative_Projects_Set_Input>;
  where: In_Queue_Speculative_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Speculative_Projects_By_PkArgs = {
  _inc?: InputMaybe<In_Queue_Speculative_Projects_Inc_Input>;
  _set?: InputMaybe<In_Queue_Speculative_Projects_Set_Input>;
  pk_columns: In_Queue_Speculative_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Speculative_Projects_ManyArgs = {
  updates: Array<In_Queue_Speculative_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Subscription_Add_OnsArgs = {
  _set?: InputMaybe<In_Queue_Subscription_Add_Ons_Set_Input>;
  where: In_Queue_Subscription_Add_Ons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Subscription_Add_Ons_By_PkArgs = {
  _set?: InputMaybe<In_Queue_Subscription_Add_Ons_Set_Input>;
  pk_columns: In_Queue_Subscription_Add_Ons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Subscription_Add_Ons_ManyArgs = {
  updates: Array<In_Queue_Subscription_Add_Ons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_SubscriptionsArgs = {
  _inc?: InputMaybe<In_Queue_Subscriptions_Inc_Input>;
  _set?: InputMaybe<In_Queue_Subscriptions_Set_Input>;
  where: In_Queue_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Subscriptions_By_PkArgs = {
  _inc?: InputMaybe<In_Queue_Subscriptions_Inc_Input>;
  _set?: InputMaybe<In_Queue_Subscriptions_Set_Input>;
  pk_columns: In_Queue_Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_In_Queue_Subscriptions_ManyArgs = {
  updates: Array<In_Queue_Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Capacity_CostsArgs = {
  _inc?: InputMaybe<Line_Capacity_Costs_Inc_Input>;
  _set?: InputMaybe<Line_Capacity_Costs_Set_Input>;
  where: Line_Capacity_Costs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Capacity_Costs_By_PkArgs = {
  _inc?: InputMaybe<Line_Capacity_Costs_Inc_Input>;
  _set?: InputMaybe<Line_Capacity_Costs_Set_Input>;
  pk_columns: Line_Capacity_Costs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Capacity_Costs_ManyArgs = {
  updates: Array<Line_Capacity_Costs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Constraint_StacksArgs = {
  _inc?: InputMaybe<Line_Constraint_Stacks_Inc_Input>;
  _set?: InputMaybe<Line_Constraint_Stacks_Set_Input>;
  where: Line_Constraint_Stacks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Constraint_Stacks_By_PkArgs = {
  _inc?: InputMaybe<Line_Constraint_Stacks_Inc_Input>;
  _set?: InputMaybe<Line_Constraint_Stacks_Set_Input>;
  pk_columns: Line_Constraint_Stacks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Line_Constraint_Stacks_ManyArgs = {
  updates: Array<Line_Constraint_Stacks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Generator_Facility_DfaxArgs = {
  _inc?: InputMaybe<Model_Generator_Facility_Dfax_Inc_Input>;
  _set?: InputMaybe<Model_Generator_Facility_Dfax_Set_Input>;
  where: Model_Generator_Facility_Dfax_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Generator_Facility_Dfax_By_PkArgs = {
  _inc?: InputMaybe<Model_Generator_Facility_Dfax_Inc_Input>;
  _set?: InputMaybe<Model_Generator_Facility_Dfax_Set_Input>;
  pk_columns: Model_Generator_Facility_Dfax_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Generator_Facility_Dfax_ManyArgs = {
  updates: Array<Model_Generator_Facility_Dfax_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_GeneratorsArgs = {
  _inc?: InputMaybe<Model_Generators_Inc_Input>;
  _set?: InputMaybe<Model_Generators_Set_Input>;
  where: Model_Generators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Generators_By_PkArgs = {
  _inc?: InputMaybe<Model_Generators_Inc_Input>;
  _set?: InputMaybe<Model_Generators_Set_Input>;
  pk_columns: Model_Generators_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Generators_ManyArgs = {
  updates: Array<Model_Generators_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_LinesArgs = {
  _inc?: InputMaybe<Model_Lines_Inc_Input>;
  _set?: InputMaybe<Model_Lines_Set_Input>;
  where: Model_Lines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Lines_By_PkArgs = {
  _inc?: InputMaybe<Model_Lines_Inc_Input>;
  _set?: InputMaybe<Model_Lines_Set_Input>;
  pk_columns: Model_Lines_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Lines_ManyArgs = {
  updates: Array<Model_Lines_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Lines_To_BranchesArgs = {
  _inc?: InputMaybe<Model_Lines_To_Branches_Inc_Input>;
  _set?: InputMaybe<Model_Lines_To_Branches_Set_Input>;
  where: Model_Lines_To_Branches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Lines_To_Branches_By_PkArgs = {
  _inc?: InputMaybe<Model_Lines_To_Branches_Inc_Input>;
  _set?: InputMaybe<Model_Lines_To_Branches_Set_Input>;
  pk_columns: Model_Lines_To_Branches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Lines_To_Branches_ManyArgs = {
  updates: Array<Model_Lines_To_Branches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Lines_To_Missing_BusesArgs = {
  _inc?: InputMaybe<Model_Lines_To_Missing_Buses_Inc_Input>;
  _set?: InputMaybe<Model_Lines_To_Missing_Buses_Set_Input>;
  where: Model_Lines_To_Missing_Buses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Lines_To_Missing_Buses_By_PkArgs = {
  _inc?: InputMaybe<Model_Lines_To_Missing_Buses_Inc_Input>;
  _set?: InputMaybe<Model_Lines_To_Missing_Buses_Set_Input>;
  pk_columns: Model_Lines_To_Missing_Buses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Lines_To_Missing_Buses_ManyArgs = {
  updates: Array<Model_Lines_To_Missing_Buses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Planned_Interconnection_LocationsArgs = {
  _inc?: InputMaybe<Planned_Interconnection_Locations_Inc_Input>;
  _set?: InputMaybe<Planned_Interconnection_Locations_Set_Input>;
  where: Planned_Interconnection_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Planned_Interconnection_Locations_By_PkArgs = {
  _inc?: InputMaybe<Planned_Interconnection_Locations_Inc_Input>;
  _set?: InputMaybe<Planned_Interconnection_Locations_Set_Input>;
  pk_columns: Planned_Interconnection_Locations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Planned_Interconnection_Locations_ManyArgs = {
  updates: Array<Planned_Interconnection_Locations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Additional_CostsArgs = {
  _inc?: InputMaybe<Project_Additional_Costs_Inc_Input>;
  _set?: InputMaybe<Project_Additional_Costs_Set_Input>;
  where: Project_Additional_Costs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Additional_Costs_By_PkArgs = {
  _inc?: InputMaybe<Project_Additional_Costs_Inc_Input>;
  _set?: InputMaybe<Project_Additional_Costs_Set_Input>;
  pk_columns: Project_Additional_Costs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Additional_Costs_ManyArgs = {
  updates: Array<Project_Additional_Costs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ConfigurationsArgs = {
  _inc?: InputMaybe<Project_Configurations_Inc_Input>;
  _set?: InputMaybe<Project_Configurations_Set_Input>;
  where: Project_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Configurations_By_PkArgs = {
  _inc?: InputMaybe<Project_Configurations_Inc_Input>;
  _set?: InputMaybe<Project_Configurations_Set_Input>;
  pk_columns: Project_Configurations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Configurations_ManyArgs = {
  updates: Array<Project_Configurations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Cost_SourcesArgs = {
  _set?: InputMaybe<Project_Cost_Sources_Set_Input>;
  where: Project_Cost_Sources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Cost_Sources_By_PkArgs = {
  _set?: InputMaybe<Project_Cost_Sources_Set_Input>;
  pk_columns: Project_Cost_Sources_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Cost_Sources_ManyArgs = {
  updates: Array<Project_Cost_Sources_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Cost_TypesArgs = {
  _set?: InputMaybe<Project_Cost_Types_Set_Input>;
  where: Project_Cost_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Cost_Types_By_PkArgs = {
  _set?: InputMaybe<Project_Cost_Types_Set_Input>;
  pk_columns: Project_Cost_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Cost_Types_ManyArgs = {
  updates: Array<Project_Cost_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Tag_AssignmentsArgs = {
  _inc?: InputMaybe<Project_Tag_Assignments_Inc_Input>;
  _set?: InputMaybe<Project_Tag_Assignments_Set_Input>;
  where: Project_Tag_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Tag_Assignments_By_PkArgs = {
  _inc?: InputMaybe<Project_Tag_Assignments_Inc_Input>;
  _set?: InputMaybe<Project_Tag_Assignments_Set_Input>;
  pk_columns: Project_Tag_Assignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Tag_Assignments_ManyArgs = {
  updates: Array<Project_Tag_Assignments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_TagsArgs = {
  _inc?: InputMaybe<Project_Tags_Inc_Input>;
  _set?: InputMaybe<Project_Tags_Set_Input>;
  where: Project_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Tags_By_PkArgs = {
  _inc?: InputMaybe<Project_Tags_Inc_Input>;
  _set?: InputMaybe<Project_Tags_Set_Input>;
  pk_columns: Project_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Tags_ManyArgs = {
  updates: Array<Project_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Connection_PointsArgs = {
  _inc?: InputMaybe<Queue_Project_Connection_Points_Inc_Input>;
  _set?: InputMaybe<Queue_Project_Connection_Points_Set_Input>;
  where: Queue_Project_Connection_Points_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Connection_Points_By_PkArgs = {
  _inc?: InputMaybe<Queue_Project_Connection_Points_Inc_Input>;
  _set?: InputMaybe<Queue_Project_Connection_Points_Set_Input>;
  pk_columns: Queue_Project_Connection_Points_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Connection_Points_ManyArgs = {
  updates: Array<Queue_Project_Connection_Points_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Connection_TypesArgs = {
  _set?: InputMaybe<Queue_Project_Connection_Types_Set_Input>;
  where: Queue_Project_Connection_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Connection_Types_By_PkArgs = {
  _set?: InputMaybe<Queue_Project_Connection_Types_Set_Input>;
  pk_columns: Queue_Project_Connection_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Connection_Types_ManyArgs = {
  updates: Array<Queue_Project_Connection_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Facility_DfaxArgs = {
  _inc?: InputMaybe<Queue_Project_Facility_Dfax_Inc_Input>;
  _set?: InputMaybe<Queue_Project_Facility_Dfax_Set_Input>;
  where: Queue_Project_Facility_Dfax_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Facility_Dfax_By_PkArgs = {
  _inc?: InputMaybe<Queue_Project_Facility_Dfax_Inc_Input>;
  _set?: InputMaybe<Queue_Project_Facility_Dfax_Set_Input>;
  pk_columns: Queue_Project_Facility_Dfax_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Facility_Dfax_ManyArgs = {
  updates: Array<Queue_Project_Facility_Dfax_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_HopsArgs = {
  _inc?: InputMaybe<Queue_Project_Hops_Inc_Input>;
  _set?: InputMaybe<Queue_Project_Hops_Set_Input>;
  where: Queue_Project_Hops_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Hops_By_PkArgs = {
  _inc?: InputMaybe<Queue_Project_Hops_Inc_Input>;
  _set?: InputMaybe<Queue_Project_Hops_Set_Input>;
  pk_columns: Queue_Project_Hops_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Project_Hops_ManyArgs = {
  updates: Array<Queue_Project_Hops_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_ProjectsArgs = {
  _inc?: InputMaybe<Queue_Projects_Inc_Input>;
  _set?: InputMaybe<Queue_Projects_Set_Input>;
  where: Queue_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Projects_By_PkArgs = {
  _inc?: InputMaybe<Queue_Projects_Inc_Input>;
  _set?: InputMaybe<Queue_Projects_Set_Input>;
  pk_columns: Queue_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Queue_Projects_ManyArgs = {
  updates: Array<Queue_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Allocated_UpgradesArgs = {
  _append?: InputMaybe<Scenario_Allocated_Upgrades_Append_Input>;
  _delete_at_path?: InputMaybe<Scenario_Allocated_Upgrades_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scenario_Allocated_Upgrades_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scenario_Allocated_Upgrades_Delete_Key_Input>;
  _inc?: InputMaybe<Scenario_Allocated_Upgrades_Inc_Input>;
  _prepend?: InputMaybe<Scenario_Allocated_Upgrades_Prepend_Input>;
  _set?: InputMaybe<Scenario_Allocated_Upgrades_Set_Input>;
  where: Scenario_Allocated_Upgrades_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Allocated_Upgrades_By_PkArgs = {
  _append?: InputMaybe<Scenario_Allocated_Upgrades_Append_Input>;
  _delete_at_path?: InputMaybe<Scenario_Allocated_Upgrades_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scenario_Allocated_Upgrades_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scenario_Allocated_Upgrades_Delete_Key_Input>;
  _inc?: InputMaybe<Scenario_Allocated_Upgrades_Inc_Input>;
  _prepend?: InputMaybe<Scenario_Allocated_Upgrades_Prepend_Input>;
  _set?: InputMaybe<Scenario_Allocated_Upgrades_Set_Input>;
  pk_columns: Scenario_Allocated_Upgrades_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Allocated_Upgrades_ManyArgs = {
  updates: Array<Scenario_Allocated_Upgrades_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_ConfigurationsArgs = {
  _inc?: InputMaybe<Scenario_Configurations_Inc_Input>;
  _set?: InputMaybe<Scenario_Configurations_Set_Input>;
  where: Scenario_Configurations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Configurations_By_PkArgs = {
  _inc?: InputMaybe<Scenario_Configurations_Inc_Input>;
  _set?: InputMaybe<Scenario_Configurations_Set_Input>;
  pk_columns: Scenario_Configurations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Configurations_ManyArgs = {
  updates: Array<Scenario_Configurations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_ConstraintsArgs = {
  _append?: InputMaybe<Scenario_Constraints_Append_Input>;
  _delete_at_path?: InputMaybe<Scenario_Constraints_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scenario_Constraints_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scenario_Constraints_Delete_Key_Input>;
  _inc?: InputMaybe<Scenario_Constraints_Inc_Input>;
  _prepend?: InputMaybe<Scenario_Constraints_Prepend_Input>;
  _set?: InputMaybe<Scenario_Constraints_Set_Input>;
  where: Scenario_Constraints_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Constraints_By_PkArgs = {
  _append?: InputMaybe<Scenario_Constraints_Append_Input>;
  _delete_at_path?: InputMaybe<Scenario_Constraints_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scenario_Constraints_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scenario_Constraints_Delete_Key_Input>;
  _inc?: InputMaybe<Scenario_Constraints_Inc_Input>;
  _prepend?: InputMaybe<Scenario_Constraints_Prepend_Input>;
  _set?: InputMaybe<Scenario_Constraints_Set_Input>;
  pk_columns: Scenario_Constraints_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Constraints_ManyArgs = {
  updates: Array<Scenario_Constraints_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_OriginsArgs = {
  _set?: InputMaybe<Scenario_Origins_Set_Input>;
  where: Scenario_Origins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Origins_By_PkArgs = {
  _set?: InputMaybe<Scenario_Origins_Set_Input>;
  pk_columns: Scenario_Origins_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Origins_ManyArgs = {
  updates: Array<Scenario_Origins_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Project_RanksArgs = {
  _inc?: InputMaybe<Scenario_Project_Ranks_Inc_Input>;
  _set?: InputMaybe<Scenario_Project_Ranks_Set_Input>;
  where: Scenario_Project_Ranks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Project_Ranks_By_PkArgs = {
  _inc?: InputMaybe<Scenario_Project_Ranks_Inc_Input>;
  _set?: InputMaybe<Scenario_Project_Ranks_Set_Input>;
  pk_columns: Scenario_Project_Ranks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Project_Ranks_ManyArgs = {
  updates: Array<Scenario_Project_Ranks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_ProjectsArgs = {
  _append?: InputMaybe<Scenario_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Scenario_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scenario_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scenario_Projects_Delete_Key_Input>;
  _inc?: InputMaybe<Scenario_Projects_Inc_Input>;
  _prepend?: InputMaybe<Scenario_Projects_Prepend_Input>;
  _set?: InputMaybe<Scenario_Projects_Set_Input>;
  where: Scenario_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Projects_By_PkArgs = {
  _append?: InputMaybe<Scenario_Projects_Append_Input>;
  _delete_at_path?: InputMaybe<Scenario_Projects_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scenario_Projects_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scenario_Projects_Delete_Key_Input>;
  _inc?: InputMaybe<Scenario_Projects_Inc_Input>;
  _prepend?: InputMaybe<Scenario_Projects_Prepend_Input>;
  _set?: InputMaybe<Scenario_Projects_Set_Input>;
  pk_columns: Scenario_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Projects_ManyArgs = {
  updates: Array<Scenario_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_StatusesArgs = {
  _set?: InputMaybe<Scenario_Statuses_Set_Input>;
  where: Scenario_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Statuses_By_PkArgs = {
  _set?: InputMaybe<Scenario_Statuses_Set_Input>;
  pk_columns: Scenario_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scenario_Statuses_ManyArgs = {
  updates: Array<Scenario_Statuses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ScenariosArgs = {
  _append?: InputMaybe<Scenarios_Append_Input>;
  _delete_at_path?: InputMaybe<Scenarios_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scenarios_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scenarios_Delete_Key_Input>;
  _inc?: InputMaybe<Scenarios_Inc_Input>;
  _prepend?: InputMaybe<Scenarios_Prepend_Input>;
  _set?: InputMaybe<Scenarios_Set_Input>;
  where: Scenarios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scenarios_By_PkArgs = {
  _append?: InputMaybe<Scenarios_Append_Input>;
  _delete_at_path?: InputMaybe<Scenarios_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scenarios_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scenarios_Delete_Key_Input>;
  _inc?: InputMaybe<Scenarios_Inc_Input>;
  _prepend?: InputMaybe<Scenarios_Prepend_Input>;
  _set?: InputMaybe<Scenarios_Set_Input>;
  pk_columns: Scenarios_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scenarios_ManyArgs = {
  updates: Array<Scenarios_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ScopesArgs = {
  _append?: InputMaybe<Scopes_Append_Input>;
  _delete_at_path?: InputMaybe<Scopes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scopes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scopes_Delete_Key_Input>;
  _inc?: InputMaybe<Scopes_Inc_Input>;
  _prepend?: InputMaybe<Scopes_Prepend_Input>;
  _set?: InputMaybe<Scopes_Set_Input>;
  where: Scopes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scopes_By_PkArgs = {
  _append?: InputMaybe<Scopes_Append_Input>;
  _delete_at_path?: InputMaybe<Scopes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scopes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scopes_Delete_Key_Input>;
  _inc?: InputMaybe<Scopes_Inc_Input>;
  _prepend?: InputMaybe<Scopes_Prepend_Input>;
  _set?: InputMaybe<Scopes_Set_Input>;
  pk_columns: Scopes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scopes_ManyArgs = {
  updates: Array<Scopes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Screening_ViewsArgs = {
  _append?: InputMaybe<Screening_Views_Append_Input>;
  _delete_at_path?: InputMaybe<Screening_Views_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Screening_Views_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Screening_Views_Delete_Key_Input>;
  _inc?: InputMaybe<Screening_Views_Inc_Input>;
  _prepend?: InputMaybe<Screening_Views_Prepend_Input>;
  _set?: InputMaybe<Screening_Views_Set_Input>;
  where: Screening_Views_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Screening_Views_By_PkArgs = {
  _append?: InputMaybe<Screening_Views_Append_Input>;
  _delete_at_path?: InputMaybe<Screening_Views_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Screening_Views_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Screening_Views_Delete_Key_Input>;
  _inc?: InputMaybe<Screening_Views_Inc_Input>;
  _prepend?: InputMaybe<Screening_Views_Prepend_Input>;
  _set?: InputMaybe<Screening_Views_Set_Input>;
  pk_columns: Screening_Views_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Screening_Views_ManyArgs = {
  updates: Array<Screening_Views_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sis_Project_Cost_Type_MetadataArgs = {
  _set?: InputMaybe<Sis_Project_Cost_Type_Metadata_Set_Input>;
  where: Sis_Project_Cost_Type_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sis_Project_Cost_Type_Metadata_By_PkArgs = {
  _set?: InputMaybe<Sis_Project_Cost_Type_Metadata_Set_Input>;
  pk_columns: Sis_Project_Cost_Type_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sis_Project_Cost_Type_Metadata_ManyArgs = {
  updates: Array<Sis_Project_Cost_Type_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sis_Report_PostingsArgs = {
  _set?: InputMaybe<Sis_Report_Postings_Set_Input>;
  where: Sis_Report_Postings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sis_Report_Postings_By_PkArgs = {
  _set?: InputMaybe<Sis_Report_Postings_Set_Input>;
  pk_columns: Sis_Report_Postings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sis_Report_Postings_ManyArgs = {
  updates: Array<Sis_Report_Postings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Add_OnsArgs = {
  _set?: InputMaybe<Subscription_Add_Ons_Set_Input>;
  where: Subscription_Add_Ons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Add_Ons_By_PkArgs = {
  _set?: InputMaybe<Subscription_Add_Ons_Set_Input>;
  pk_columns: Subscription_Add_Ons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscription_Add_Ons_ManyArgs = {
  updates: Array<Subscription_Add_Ons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionsArgs = {
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  pk_columns: Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_ManyArgs = {
  updates: Array<Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeamsArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_By_PkArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  pk_columns: Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_ManyArgs = {
  updates: Array<Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tracked_ProjectsArgs = {
  _inc?: InputMaybe<Tracked_Projects_Inc_Input>;
  _set?: InputMaybe<Tracked_Projects_Set_Input>;
  where: Tracked_Projects_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tracked_Projects_By_PkArgs = {
  _inc?: InputMaybe<Tracked_Projects_Inc_Input>;
  _set?: InputMaybe<Tracked_Projects_Set_Input>;
  pk_columns: Tracked_Projects_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tracked_Projects_ManyArgs = {
  updates: Array<Tracked_Projects_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unlocked_BusesArgs = {
  _inc?: InputMaybe<Unlocked_Buses_Inc_Input>;
  _set?: InputMaybe<Unlocked_Buses_Set_Input>;
  where: Unlocked_Buses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unlocked_Buses_By_PkArgs = {
  _inc?: InputMaybe<Unlocked_Buses_Inc_Input>;
  _set?: InputMaybe<Unlocked_Buses_Set_Input>;
  pk_columns: Unlocked_Buses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unlocked_Buses_ManyArgs = {
  updates: Array<Unlocked_Buses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Scope_ConfigsArgs = {
  _set?: InputMaybe<User_Scope_Configs_Set_Input>;
  where: User_Scope_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Scope_Configs_By_PkArgs = {
  _set?: InputMaybe<User_Scope_Configs_Set_Input>;
  pk_columns: User_Scope_Configs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Scope_Configs_ManyArgs = {
  updates: Array<User_Scope_Configs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Boolean expression to compare columns of type "path". All fields are combined with logical 'AND'. */
export type Path_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['path']['input']>;
  _gt?: InputMaybe<Scalars['path']['input']>;
  _gte?: InputMaybe<Scalars['path']['input']>;
  _in?: InputMaybe<Array<Scalars['path']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['path']['input']>;
  _lte?: InputMaybe<Scalars['path']['input']>;
  _neq?: InputMaybe<Scalars['path']['input']>;
  _nin?: InputMaybe<Array<Scalars['path']['input']>>;
};

/** columns and relationships of "planned_interconnection_locations" */
export type Planned_Interconnection_Locations = {
  __typename?: 'planned_interconnection_locations';
  /** An object relationship */
  bus?: Maybe<Buses>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id: Scalars['String']['output'];
  planned_mw: Scalars['numeric']['output'];
};

/** aggregated selection of "planned_interconnection_locations" */
export type Planned_Interconnection_Locations_Aggregate = {
  __typename?: 'planned_interconnection_locations_aggregate';
  aggregate?: Maybe<Planned_Interconnection_Locations_Aggregate_Fields>;
  nodes: Array<Planned_Interconnection_Locations>;
};

/** aggregate fields of "planned_interconnection_locations" */
export type Planned_Interconnection_Locations_Aggregate_Fields = {
  __typename?: 'planned_interconnection_locations_aggregate_fields';
  avg?: Maybe<Planned_Interconnection_Locations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Planned_Interconnection_Locations_Max_Fields>;
  min?: Maybe<Planned_Interconnection_Locations_Min_Fields>;
  stddev?: Maybe<Planned_Interconnection_Locations_Stddev_Fields>;
  stddev_pop?: Maybe<Planned_Interconnection_Locations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Planned_Interconnection_Locations_Stddev_Samp_Fields>;
  sum?: Maybe<Planned_Interconnection_Locations_Sum_Fields>;
  var_pop?: Maybe<Planned_Interconnection_Locations_Var_Pop_Fields>;
  var_samp?: Maybe<Planned_Interconnection_Locations_Var_Samp_Fields>;
  variance?: Maybe<Planned_Interconnection_Locations_Variance_Fields>;
};


/** aggregate fields of "planned_interconnection_locations" */
export type Planned_Interconnection_Locations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Planned_Interconnection_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Planned_Interconnection_Locations_Avg_Fields = {
  __typename?: 'planned_interconnection_locations_avg_fields';
  planned_mw?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "planned_interconnection_locations". All fields are combined with a logical 'AND'. */
export type Planned_Interconnection_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Planned_Interconnection_Locations_Bool_Exp>>;
  _not?: InputMaybe<Planned_Interconnection_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Planned_Interconnection_Locations_Bool_Exp>>;
  bus?: InputMaybe<Buses_Bool_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  planned_mw?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "planned_interconnection_locations" */
export enum Planned_Interconnection_Locations_Constraint {
  /** unique or primary key constraint on columns "nira_bus_id" */
  PlannedInterconnectionLocationsPkey = 'planned_interconnection_locations_pkey'
}

/** input type for incrementing numeric columns in table "planned_interconnection_locations" */
export type Planned_Interconnection_Locations_Inc_Input = {
  planned_mw?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "planned_interconnection_locations" */
export type Planned_Interconnection_Locations_Insert_Input = {
  bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  planned_mw?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Planned_Interconnection_Locations_Max_Fields = {
  __typename?: 'planned_interconnection_locations_max_fields';
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  planned_mw?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Planned_Interconnection_Locations_Min_Fields = {
  __typename?: 'planned_interconnection_locations_min_fields';
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  planned_mw?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "planned_interconnection_locations" */
export type Planned_Interconnection_Locations_Mutation_Response = {
  __typename?: 'planned_interconnection_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Planned_Interconnection_Locations>;
};

/** on_conflict condition type for table "planned_interconnection_locations" */
export type Planned_Interconnection_Locations_On_Conflict = {
  constraint: Planned_Interconnection_Locations_Constraint;
  update_columns?: Array<Planned_Interconnection_Locations_Update_Column>;
  where?: InputMaybe<Planned_Interconnection_Locations_Bool_Exp>;
};

/** Ordering options when selecting data from "planned_interconnection_locations". */
export type Planned_Interconnection_Locations_Order_By = {
  bus?: InputMaybe<Buses_Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  planned_mw?: InputMaybe<Order_By>;
};

/** primary key columns input for table: planned_interconnection_locations */
export type Planned_Interconnection_Locations_Pk_Columns_Input = {
  nira_bus_id: Scalars['String']['input'];
};

/** select columns of table "planned_interconnection_locations" */
export enum Planned_Interconnection_Locations_Select_Column {
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  PlannedMw = 'planned_mw'
}

/** input type for updating data in table "planned_interconnection_locations" */
export type Planned_Interconnection_Locations_Set_Input = {
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  planned_mw?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Planned_Interconnection_Locations_Stddev_Fields = {
  __typename?: 'planned_interconnection_locations_stddev_fields';
  planned_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Planned_Interconnection_Locations_Stddev_Pop_Fields = {
  __typename?: 'planned_interconnection_locations_stddev_pop_fields';
  planned_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Planned_Interconnection_Locations_Stddev_Samp_Fields = {
  __typename?: 'planned_interconnection_locations_stddev_samp_fields';
  planned_mw?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "planned_interconnection_locations" */
export type Planned_Interconnection_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Planned_Interconnection_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Planned_Interconnection_Locations_Stream_Cursor_Value_Input = {
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  planned_mw?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Planned_Interconnection_Locations_Sum_Fields = {
  __typename?: 'planned_interconnection_locations_sum_fields';
  planned_mw?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "planned_interconnection_locations" */
export enum Planned_Interconnection_Locations_Update_Column {
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  PlannedMw = 'planned_mw'
}

export type Planned_Interconnection_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Planned_Interconnection_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Planned_Interconnection_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Planned_Interconnection_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Planned_Interconnection_Locations_Var_Pop_Fields = {
  __typename?: 'planned_interconnection_locations_var_pop_fields';
  planned_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Planned_Interconnection_Locations_Var_Samp_Fields = {
  __typename?: 'planned_interconnection_locations_var_samp_fields';
  planned_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Planned_Interconnection_Locations_Variance_Fields = {
  __typename?: 'planned_interconnection_locations_variance_fields';
  planned_mw?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "project_additional_costs" */
export type Project_Additional_Costs = {
  __typename?: 'project_additional_costs';
  amount?: Maybe<Scalars['numeric']['output']>;
  cluster_id: Scalars['uuid']['output'];
  cost_type: Project_Cost_Types_Enum;
  /** An object relationship */
  cost_type_properties?: Maybe<Sis_Project_Cost_Type_Metadata>;
  /** An object relationship */
  in_queue_cluster: In_Queue_Clusters;
  /** An object relationship */
  posting: Sis_Report_Postings;
  posting_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_cost_type: Project_Cost_Types;
  project_id: Scalars['String']['output'];
  source: Project_Cost_Sources_Enum;
};

/** aggregated selection of "project_additional_costs" */
export type Project_Additional_Costs_Aggregate = {
  __typename?: 'project_additional_costs_aggregate';
  aggregate?: Maybe<Project_Additional_Costs_Aggregate_Fields>;
  nodes: Array<Project_Additional_Costs>;
};

export type Project_Additional_Costs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Additional_Costs_Aggregate_Bool_Exp_Count>;
};

export type Project_Additional_Costs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Additional_Costs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_additional_costs" */
export type Project_Additional_Costs_Aggregate_Fields = {
  __typename?: 'project_additional_costs_aggregate_fields';
  avg?: Maybe<Project_Additional_Costs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Additional_Costs_Max_Fields>;
  min?: Maybe<Project_Additional_Costs_Min_Fields>;
  stddev?: Maybe<Project_Additional_Costs_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Additional_Costs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Additional_Costs_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Additional_Costs_Sum_Fields>;
  var_pop?: Maybe<Project_Additional_Costs_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Additional_Costs_Var_Samp_Fields>;
  variance?: Maybe<Project_Additional_Costs_Variance_Fields>;
};


/** aggregate fields of "project_additional_costs" */
export type Project_Additional_Costs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Additional_Costs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_additional_costs" */
export type Project_Additional_Costs_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Additional_Costs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Additional_Costs_Max_Order_By>;
  min?: InputMaybe<Project_Additional_Costs_Min_Order_By>;
  stddev?: InputMaybe<Project_Additional_Costs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Additional_Costs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Additional_Costs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Additional_Costs_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Additional_Costs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Additional_Costs_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Additional_Costs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_additional_costs" */
export type Project_Additional_Costs_Arr_Rel_Insert_Input = {
  data: Array<Project_Additional_Costs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Additional_Costs_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Additional_Costs_Avg_Fields = {
  __typename?: 'project_additional_costs_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_additional_costs". All fields are combined with a logical 'AND'. */
export type Project_Additional_Costs_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Additional_Costs_Bool_Exp>>;
  _not?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Additional_Costs_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  cost_type?: InputMaybe<Project_Cost_Types_Enum_Comparison_Exp>;
  cost_type_properties?: InputMaybe<Sis_Project_Cost_Type_Metadata_Bool_Exp>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  posting?: InputMaybe<Sis_Report_Postings_Bool_Exp>;
  posting_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_cost_type?: InputMaybe<Project_Cost_Types_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Project_Cost_Sources_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_additional_costs" */
export enum Project_Additional_Costs_Constraint {
  /** unique or primary key constraint on columns "cost_type", "project_id", "posting_id", "source" */
  ProjectAdditionalCostsPkey = 'project_additional_costs_pkey'
}

/** input type for incrementing numeric columns in table "project_additional_costs" */
export type Project_Additional_Costs_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "project_additional_costs" */
export type Project_Additional_Costs_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  cost_type?: InputMaybe<Project_Cost_Types_Enum>;
  cost_type_properties?: InputMaybe<Sis_Project_Cost_Type_Metadata_Obj_Rel_Insert_Input>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  posting?: InputMaybe<Sis_Report_Postings_Obj_Rel_Insert_Input>;
  posting_id?: InputMaybe<Scalars['uuid']['input']>;
  project_cost_type?: InputMaybe<Project_Cost_Types_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Project_Cost_Sources_Enum>;
};

/** aggregate max on columns */
export type Project_Additional_Costs_Max_Fields = {
  __typename?: 'project_additional_costs_max_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  posting_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Additional_Costs_Min_Fields = {
  __typename?: 'project_additional_costs_min_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  posting_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_additional_costs" */
export type Project_Additional_Costs_Mutation_Response = {
  __typename?: 'project_additional_costs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Additional_Costs>;
};

/** on_conflict condition type for table "project_additional_costs" */
export type Project_Additional_Costs_On_Conflict = {
  constraint: Project_Additional_Costs_Constraint;
  update_columns?: Array<Project_Additional_Costs_Update_Column>;
  where?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
};

/** Ordering options when selecting data from "project_additional_costs". */
export type Project_Additional_Costs_Order_By = {
  amount?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  cost_type?: InputMaybe<Order_By>;
  cost_type_properties?: InputMaybe<Sis_Project_Cost_Type_Metadata_Order_By>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  posting?: InputMaybe<Sis_Report_Postings_Order_By>;
  posting_id?: InputMaybe<Order_By>;
  project_cost_type?: InputMaybe<Project_Cost_Types_Order_By>;
  project_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_additional_costs */
export type Project_Additional_Costs_Pk_Columns_Input = {
  cost_type: Project_Cost_Types_Enum;
  posting_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
  source: Project_Cost_Sources_Enum;
};

/** select columns of table "project_additional_costs" */
export enum Project_Additional_Costs_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CostType = 'cost_type',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "project_additional_costs" */
export type Project_Additional_Costs_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  cost_type?: InputMaybe<Project_Cost_Types_Enum>;
  posting_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Project_Cost_Sources_Enum>;
};

/** aggregate stddev on columns */
export type Project_Additional_Costs_Stddev_Fields = {
  __typename?: 'project_additional_costs_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Additional_Costs_Stddev_Pop_Fields = {
  __typename?: 'project_additional_costs_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Additional_Costs_Stddev_Samp_Fields = {
  __typename?: 'project_additional_costs_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_additional_costs" */
export type Project_Additional_Costs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Additional_Costs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Additional_Costs_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  cost_type?: InputMaybe<Project_Cost_Types_Enum>;
  posting_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Project_Cost_Sources_Enum>;
};

/** aggregate sum on columns */
export type Project_Additional_Costs_Sum_Fields = {
  __typename?: 'project_additional_costs_sum_fields';
  amount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "project_additional_costs" */
export enum Project_Additional_Costs_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CostType = 'cost_type',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Source = 'source'
}

export type Project_Additional_Costs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Additional_Costs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Additional_Costs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Additional_Costs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Additional_Costs_Var_Pop_Fields = {
  __typename?: 'project_additional_costs_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Additional_Costs_Var_Samp_Fields = {
  __typename?: 'project_additional_costs_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Additional_Costs_Variance_Fields = {
  __typename?: 'project_additional_costs_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_additional_costs" */
export type Project_Additional_Costs_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_configurations" */
export type Project_Configurations = {
  __typename?: 'project_configurations';
  auto_drop_for_scenarios: Scalars['Boolean']['output'];
  cluster_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  in_queue_cluster: In_Queue_Clusters;
  is_favorited: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  project_id: Scalars['String']['output'];
  project_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tag_assignments: Array<Project_Tag_Assignments>;
  /** An aggregate relationship */
  tag_assignments_aggregate: Project_Tag_Assignments_Aggregate;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "project_configurations" */
export type Project_ConfigurationsTag_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tag_Assignments_Order_By>>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};


/** columns and relationships of "project_configurations" */
export type Project_ConfigurationsTag_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tag_Assignments_Order_By>>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};

/** aggregated selection of "project_configurations" */
export type Project_Configurations_Aggregate = {
  __typename?: 'project_configurations_aggregate';
  aggregate?: Maybe<Project_Configurations_Aggregate_Fields>;
  nodes: Array<Project_Configurations>;
};

export type Project_Configurations_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Configurations_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Configurations_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Configurations_Aggregate_Bool_Exp_Count>;
};

export type Project_Configurations_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Configurations_Select_Column_Project_Configurations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Configurations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Configurations_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Configurations_Select_Column_Project_Configurations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Configurations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Configurations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Configurations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Configurations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_configurations" */
export type Project_Configurations_Aggregate_Fields = {
  __typename?: 'project_configurations_aggregate_fields';
  avg?: Maybe<Project_Configurations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Configurations_Max_Fields>;
  min?: Maybe<Project_Configurations_Min_Fields>;
  stddev?: Maybe<Project_Configurations_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Configurations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Configurations_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Configurations_Sum_Fields>;
  var_pop?: Maybe<Project_Configurations_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Configurations_Var_Samp_Fields>;
  variance?: Maybe<Project_Configurations_Variance_Fields>;
};


/** aggregate fields of "project_configurations" */
export type Project_Configurations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Configurations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_configurations" */
export type Project_Configurations_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Configurations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Configurations_Max_Order_By>;
  min?: InputMaybe<Project_Configurations_Min_Order_By>;
  stddev?: InputMaybe<Project_Configurations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Configurations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Configurations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Configurations_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Configurations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Configurations_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Configurations_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Project_Configurations_Avg_Fields = {
  __typename?: 'project_configurations_avg_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_configurations" */
export type Project_Configurations_Avg_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_configurations". All fields are combined with a logical 'AND'. */
export type Project_Configurations_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Configurations_Bool_Exp>>;
  _not?: InputMaybe<Project_Configurations_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Configurations_Bool_Exp>>;
  auto_drop_for_scenarios?: InputMaybe<Boolean_Comparison_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  is_favorited?: InputMaybe<Boolean_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  tag_assignments?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
  tag_assignments_aggregate?: InputMaybe<Project_Tag_Assignments_Aggregate_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_configurations" */
export enum Project_Configurations_Constraint {
  /** unique or primary key constraint on columns "cluster_id", "project_id", "team_id" */
  ProjectConfigurationsPkey = 'project_configurations_pkey',
  /** unique or primary key constraint on columns "project_name", "cluster_id", "team_id" */
  ProjectConfigurationsTeamIdClusterIdProjectNameKey = 'project_configurations_team_id_cluster_id_project_name_key'
}

/** input type for incrementing numeric columns in table "project_configurations" */
export type Project_Configurations_Inc_Input = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_configurations" */
export type Project_Configurations_Insert_Input = {
  auto_drop_for_scenarios?: InputMaybe<Scalars['Boolean']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  tag_assignments?: InputMaybe<Project_Tag_Assignments_Arr_Rel_Insert_Input>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Project_Configurations_Max_Fields = {
  __typename?: 'project_configurations_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "project_configurations" */
export type Project_Configurations_Max_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Configurations_Min_Fields = {
  __typename?: 'project_configurations_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "project_configurations" */
export type Project_Configurations_Min_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_configurations" */
export type Project_Configurations_Mutation_Response = {
  __typename?: 'project_configurations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Configurations>;
};

/** input type for inserting object relation for remote table "project_configurations" */
export type Project_Configurations_Obj_Rel_Insert_Input = {
  data: Project_Configurations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Configurations_On_Conflict>;
};

/** on_conflict condition type for table "project_configurations" */
export type Project_Configurations_On_Conflict = {
  constraint: Project_Configurations_Constraint;
  update_columns?: Array<Project_Configurations_Update_Column>;
  where?: InputMaybe<Project_Configurations_Bool_Exp>;
};

/** Ordering options when selecting data from "project_configurations". */
export type Project_Configurations_Order_By = {
  auto_drop_for_scenarios?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  is_favorited?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  tag_assignments_aggregate?: InputMaybe<Project_Tag_Assignments_Aggregate_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_configurations */
export type Project_Configurations_Pk_Columns_Input = {
  cluster_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
  team_id: Scalars['Int']['input'];
};

/** select columns of table "project_configurations" */
export enum Project_Configurations_Select_Column {
  /** column name */
  AutoDropForScenarios = 'auto_drop_for_scenarios',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsFavorited = 'is_favorited',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "project_configurations_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_configurations" */
export enum Project_Configurations_Select_Column_Project_Configurations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AutoDropForScenarios = 'auto_drop_for_scenarios',
  /** column name */
  IsFavorited = 'is_favorited'
}

/** select "project_configurations_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_configurations" */
export enum Project_Configurations_Select_Column_Project_Configurations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AutoDropForScenarios = 'auto_drop_for_scenarios',
  /** column name */
  IsFavorited = 'is_favorited'
}

/** input type for updating data in table "project_configurations" */
export type Project_Configurations_Set_Input = {
  auto_drop_for_scenarios?: InputMaybe<Scalars['Boolean']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Project_Configurations_Stddev_Fields = {
  __typename?: 'project_configurations_stddev_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_configurations" */
export type Project_Configurations_Stddev_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Configurations_Stddev_Pop_Fields = {
  __typename?: 'project_configurations_stddev_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_configurations" */
export type Project_Configurations_Stddev_Pop_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Configurations_Stddev_Samp_Fields = {
  __typename?: 'project_configurations_stddev_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_configurations" */
export type Project_Configurations_Stddev_Samp_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_configurations" */
export type Project_Configurations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Configurations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Configurations_Stream_Cursor_Value_Input = {
  auto_drop_for_scenarios?: InputMaybe<Scalars['Boolean']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_favorited?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Project_Configurations_Sum_Fields = {
  __typename?: 'project_configurations_sum_fields';
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "project_configurations" */
export type Project_Configurations_Sum_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "project_configurations" */
export enum Project_Configurations_Update_Column {
  /** column name */
  AutoDropForScenarios = 'auto_drop_for_scenarios',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  IsFavorited = 'is_favorited',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Configurations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Configurations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Configurations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Configurations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Configurations_Var_Pop_Fields = {
  __typename?: 'project_configurations_var_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_configurations" */
export type Project_Configurations_Var_Pop_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Configurations_Var_Samp_Fields = {
  __typename?: 'project_configurations_var_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_configurations" */
export type Project_Configurations_Var_Samp_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Configurations_Variance_Fields = {
  __typename?: 'project_configurations_variance_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_configurations" */
export type Project_Configurations_Variance_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_cost_sources" */
export type Project_Cost_Sources = {
  __typename?: 'project_cost_sources';
  description: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

/** aggregated selection of "project_cost_sources" */
export type Project_Cost_Sources_Aggregate = {
  __typename?: 'project_cost_sources_aggregate';
  aggregate?: Maybe<Project_Cost_Sources_Aggregate_Fields>;
  nodes: Array<Project_Cost_Sources>;
};

/** aggregate fields of "project_cost_sources" */
export type Project_Cost_Sources_Aggregate_Fields = {
  __typename?: 'project_cost_sources_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Cost_Sources_Max_Fields>;
  min?: Maybe<Project_Cost_Sources_Min_Fields>;
};


/** aggregate fields of "project_cost_sources" */
export type Project_Cost_Sources_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Cost_Sources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_cost_sources". All fields are combined with a logical 'AND'. */
export type Project_Cost_Sources_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Cost_Sources_Bool_Exp>>;
  _not?: InputMaybe<Project_Cost_Sources_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Cost_Sources_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_cost_sources" */
export enum Project_Cost_Sources_Constraint {
  /** unique or primary key constraint on columns "source" */
  ProjectCostSourcesPkey = 'project_cost_sources_pkey'
}

export enum Project_Cost_Sources_Enum {
  /** Published by the ISO in an SIS report */
  IsoReported = 'ISO_REPORTED'
}

/** Boolean expression to compare columns of type "project_cost_sources_enum". All fields are combined with logical 'AND'. */
export type Project_Cost_Sources_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Cost_Sources_Enum>;
  _in?: InputMaybe<Array<Project_Cost_Sources_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Project_Cost_Sources_Enum>;
  _nin?: InputMaybe<Array<Project_Cost_Sources_Enum>>;
};

/** input type for inserting data into table "project_cost_sources" */
export type Project_Cost_Sources_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_Cost_Sources_Max_Fields = {
  __typename?: 'project_cost_sources_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Cost_Sources_Min_Fields = {
  __typename?: 'project_cost_sources_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_cost_sources" */
export type Project_Cost_Sources_Mutation_Response = {
  __typename?: 'project_cost_sources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Cost_Sources>;
};

/** on_conflict condition type for table "project_cost_sources" */
export type Project_Cost_Sources_On_Conflict = {
  constraint: Project_Cost_Sources_Constraint;
  update_columns?: Array<Project_Cost_Sources_Update_Column>;
  where?: InputMaybe<Project_Cost_Sources_Bool_Exp>;
};

/** Ordering options when selecting data from "project_cost_sources". */
export type Project_Cost_Sources_Order_By = {
  description?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_cost_sources */
export type Project_Cost_Sources_Pk_Columns_Input = {
  source: Scalars['String']['input'];
};

/** select columns of table "project_cost_sources" */
export enum Project_Cost_Sources_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "project_cost_sources" */
export type Project_Cost_Sources_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "project_cost_sources" */
export type Project_Cost_Sources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Cost_Sources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Cost_Sources_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_cost_sources" */
export enum Project_Cost_Sources_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Source = 'source'
}

export type Project_Cost_Sources_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Cost_Sources_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Cost_Sources_Bool_Exp;
};

/** columns and relationships of "project_cost_types" */
export type Project_Cost_Types = {
  __typename?: 'project_cost_types';
  cost_type: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

/** aggregated selection of "project_cost_types" */
export type Project_Cost_Types_Aggregate = {
  __typename?: 'project_cost_types_aggregate';
  aggregate?: Maybe<Project_Cost_Types_Aggregate_Fields>;
  nodes: Array<Project_Cost_Types>;
};

/** aggregate fields of "project_cost_types" */
export type Project_Cost_Types_Aggregate_Fields = {
  __typename?: 'project_cost_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Cost_Types_Max_Fields>;
  min?: Maybe<Project_Cost_Types_Min_Fields>;
};


/** aggregate fields of "project_cost_types" */
export type Project_Cost_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Cost_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "project_cost_types". All fields are combined with a logical 'AND'. */
export type Project_Cost_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Cost_Types_Bool_Exp>>;
  _not?: InputMaybe<Project_Cost_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Cost_Types_Bool_Exp>>;
  cost_type?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_cost_types" */
export enum Project_Cost_Types_Constraint {
  /** unique or primary key constraint on columns "cost_type" */
  ProjectCostTypesPkey = 'project_cost_types_pkey'
}

export enum Project_Cost_Types_Enum {
  /** Affected system upgrades */
  AffectedSystem = 'AFFECTED_SYSTEM',
  /** Backbone upgrades */
  Backbone = 'BACKBONE',
  /** Deliverability network upgrades */
  Deliverability = 'DELIVERABILITY',
  /** Interconnection facilities */
  InterconnectionFacilities = 'INTERCONNECTION_FACILITIES',
  /** Joint targeted interconnection queue upgrades */
  Jtiq = 'JTIQ',
  /** Transmission owner local planning criteria upgrades */
  LocalStudies = 'LOCAL_STUDIES',
  /** Network upgrades at the point of interconnection */
  PoiNetworkUpgrades = 'POI_NETWORK_UPGRADES',
  /** Shared network upgrades */
  SharedNetworkUpgrades = 'SHARED_NETWORK_UPGRADES',
  /** Short circuit upgrades */
  ShortCircuit = 'SHORT_CIRCUIT',
  /** Stability upgrades */
  Stability = 'STABILITY',
  /** Steady-state thermal and voltage upgrades */
  SteadyState = 'STEADY_STATE',
  /** The ISO's stated total cost */
  TotalNetworkUpgrades = 'TOTAL_NETWORK_UPGRADES',
  /** Transmission owner analysis */
  ToAnalysis = 'TO_ANALYSIS',
  /** Number of network upgrades the report lists for the project. A count, not a cost */
  UpgradeCountAll = 'UPGRADE_COUNT_ALL',
  /** Number of network upgrades with cost allocated to the project, excluding $0, TBD and contingent upgrades. A count, not a cost */
  UpgradeCountAllocated = 'UPGRADE_COUNT_ALLOCATED'
}

/** Boolean expression to compare columns of type "project_cost_types_enum". All fields are combined with logical 'AND'. */
export type Project_Cost_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Project_Cost_Types_Enum>;
  _in?: InputMaybe<Array<Project_Cost_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Project_Cost_Types_Enum>;
  _nin?: InputMaybe<Array<Project_Cost_Types_Enum>>;
};

/** input type for inserting data into table "project_cost_types" */
export type Project_Cost_Types_Insert_Input = {
  cost_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Project_Cost_Types_Max_Fields = {
  __typename?: 'project_cost_types_max_fields';
  cost_type?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Project_Cost_Types_Min_Fields = {
  __typename?: 'project_cost_types_min_fields';
  cost_type?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "project_cost_types" */
export type Project_Cost_Types_Mutation_Response = {
  __typename?: 'project_cost_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Cost_Types>;
};

/** input type for inserting object relation for remote table "project_cost_types" */
export type Project_Cost_Types_Obj_Rel_Insert_Input = {
  data: Project_Cost_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Cost_Types_On_Conflict>;
};

/** on_conflict condition type for table "project_cost_types" */
export type Project_Cost_Types_On_Conflict = {
  constraint: Project_Cost_Types_Constraint;
  update_columns?: Array<Project_Cost_Types_Update_Column>;
  where?: InputMaybe<Project_Cost_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "project_cost_types". */
export type Project_Cost_Types_Order_By = {
  cost_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_cost_types */
export type Project_Cost_Types_Pk_Columns_Input = {
  cost_type: Scalars['String']['input'];
};

/** select columns of table "project_cost_types" */
export enum Project_Cost_Types_Select_Column {
  /** column name */
  CostType = 'cost_type',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "project_cost_types" */
export type Project_Cost_Types_Set_Input = {
  cost_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "project_cost_types" */
export type Project_Cost_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Cost_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Cost_Types_Stream_Cursor_Value_Input = {
  cost_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "project_cost_types" */
export enum Project_Cost_Types_Update_Column {
  /** column name */
  CostType = 'cost_type',
  /** column name */
  Description = 'description'
}

export type Project_Cost_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Cost_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Cost_Types_Bool_Exp;
};

/** columns and relationships of "project_tag_assignments" */
export type Project_Tag_Assignments = {
  __typename?: 'project_tag_assignments';
  cluster_id: Scalars['uuid']['output'];
  /** An object relationship */
  project_configuration: Project_Configurations;
  project_id: Scalars['String']['output'];
  /** An object relationship */
  project_tag: Project_Tags;
  tag_id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int']['output'];
};

/** aggregated selection of "project_tag_assignments" */
export type Project_Tag_Assignments_Aggregate = {
  __typename?: 'project_tag_assignments_aggregate';
  aggregate?: Maybe<Project_Tag_Assignments_Aggregate_Fields>;
  nodes: Array<Project_Tag_Assignments>;
};

export type Project_Tag_Assignments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Tag_Assignments_Aggregate_Bool_Exp_Count>;
};

export type Project_Tag_Assignments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_tag_assignments" */
export type Project_Tag_Assignments_Aggregate_Fields = {
  __typename?: 'project_tag_assignments_aggregate_fields';
  avg?: Maybe<Project_Tag_Assignments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Tag_Assignments_Max_Fields>;
  min?: Maybe<Project_Tag_Assignments_Min_Fields>;
  stddev?: Maybe<Project_Tag_Assignments_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Tag_Assignments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Tag_Assignments_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Tag_Assignments_Sum_Fields>;
  var_pop?: Maybe<Project_Tag_Assignments_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Tag_Assignments_Var_Samp_Fields>;
  variance?: Maybe<Project_Tag_Assignments_Variance_Fields>;
};


/** aggregate fields of "project_tag_assignments" */
export type Project_Tag_Assignments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "project_tag_assignments" */
export type Project_Tag_Assignments_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Tag_Assignments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Tag_Assignments_Max_Order_By>;
  min?: InputMaybe<Project_Tag_Assignments_Min_Order_By>;
  stddev?: InputMaybe<Project_Tag_Assignments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Tag_Assignments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Tag_Assignments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Tag_Assignments_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Tag_Assignments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Tag_Assignments_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Tag_Assignments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_tag_assignments" */
export type Project_Tag_Assignments_Arr_Rel_Insert_Input = {
  data: Array<Project_Tag_Assignments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Tag_Assignments_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Tag_Assignments_Avg_Fields = {
  __typename?: 'project_tag_assignments_avg_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Avg_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_tag_assignments". All fields are combined with a logical 'AND'. */
export type Project_Tag_Assignments_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Tag_Assignments_Bool_Exp>>;
  _not?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Tag_Assignments_Bool_Exp>>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_configuration?: InputMaybe<Project_Configurations_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_tag?: InputMaybe<Project_Tags_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_tag_assignments" */
export enum Project_Tag_Assignments_Constraint {
  /** unique or primary key constraint on columns "tag_id", "project_id" */
  ProjectTagAssignmentsPkey = 'project_tag_assignments_pkey'
}

/** input type for incrementing numeric columns in table "project_tag_assignments" */
export type Project_Tag_Assignments_Inc_Input = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_tag_assignments" */
export type Project_Tag_Assignments_Insert_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  project_configuration?: InputMaybe<Project_Configurations_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_tag?: InputMaybe<Project_Tags_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Project_Tag_Assignments_Max_Fields = {
  __typename?: 'project_tag_assignments_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  tag_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Max_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Tag_Assignments_Min_Fields = {
  __typename?: 'project_tag_assignments_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  tag_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Min_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_tag_assignments" */
export type Project_Tag_Assignments_Mutation_Response = {
  __typename?: 'project_tag_assignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Tag_Assignments>;
};

/** on_conflict condition type for table "project_tag_assignments" */
export type Project_Tag_Assignments_On_Conflict = {
  constraint: Project_Tag_Assignments_Constraint;
  update_columns?: Array<Project_Tag_Assignments_Update_Column>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};

/** Ordering options when selecting data from "project_tag_assignments". */
export type Project_Tag_Assignments_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  project_configuration?: InputMaybe<Project_Configurations_Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_tag?: InputMaybe<Project_Tags_Order_By>;
  tag_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_tag_assignments */
export type Project_Tag_Assignments_Pk_Columns_Input = {
  project_id: Scalars['String']['input'];
  tag_id: Scalars['uuid']['input'];
};

/** select columns of table "project_tag_assignments" */
export enum Project_Tag_Assignments_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "project_tag_assignments" */
export type Project_Tag_Assignments_Set_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Project_Tag_Assignments_Stddev_Fields = {
  __typename?: 'project_tag_assignments_stddev_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Stddev_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Tag_Assignments_Stddev_Pop_Fields = {
  __typename?: 'project_tag_assignments_stddev_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Stddev_Pop_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Tag_Assignments_Stddev_Samp_Fields = {
  __typename?: 'project_tag_assignments_stddev_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Stddev_Samp_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_tag_assignments" */
export type Project_Tag_Assignments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Tag_Assignments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Tag_Assignments_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Project_Tag_Assignments_Sum_Fields = {
  __typename?: 'project_tag_assignments_sum_fields';
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Sum_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "project_tag_assignments" */
export enum Project_Tag_Assignments_Update_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TagId = 'tag_id',
  /** column name */
  TeamId = 'team_id'
}

export type Project_Tag_Assignments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Tag_Assignments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Tag_Assignments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Tag_Assignments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Tag_Assignments_Var_Pop_Fields = {
  __typename?: 'project_tag_assignments_var_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Var_Pop_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Tag_Assignments_Var_Samp_Fields = {
  __typename?: 'project_tag_assignments_var_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Var_Samp_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Tag_Assignments_Variance_Fields = {
  __typename?: 'project_tag_assignments_variance_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "project_tag_assignments" */
export type Project_Tag_Assignments_Variance_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_tags" */
export type Project_Tags = {
  __typename?: 'project_tags';
  /** An array relationship */
  assignments: Array<Project_Tag_Assignments>;
  /** An aggregate relationship */
  assignments_aggregate: Project_Tag_Assignments_Aggregate;
  cluster_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  in_queue_cluster: In_Queue_Clusters;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tag_color: Brand_Colors_Enum;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "project_tags" */
export type Project_TagsAssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tag_Assignments_Order_By>>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};


/** columns and relationships of "project_tags" */
export type Project_TagsAssignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tag_Assignments_Order_By>>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};

/** aggregated selection of "project_tags" */
export type Project_Tags_Aggregate = {
  __typename?: 'project_tags_aggregate';
  aggregate?: Maybe<Project_Tags_Aggregate_Fields>;
  nodes: Array<Project_Tags>;
};

/** aggregate fields of "project_tags" */
export type Project_Tags_Aggregate_Fields = {
  __typename?: 'project_tags_aggregate_fields';
  avg?: Maybe<Project_Tags_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Project_Tags_Max_Fields>;
  min?: Maybe<Project_Tags_Min_Fields>;
  stddev?: Maybe<Project_Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Tags_Sum_Fields>;
  var_pop?: Maybe<Project_Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Tags_Var_Samp_Fields>;
  variance?: Maybe<Project_Tags_Variance_Fields>;
};


/** aggregate fields of "project_tags" */
export type Project_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Project_Tags_Avg_Fields = {
  __typename?: 'project_tags_avg_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "project_tags". All fields are combined with a logical 'AND'. */
export type Project_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Tags_Bool_Exp>>;
  _not?: InputMaybe<Project_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Tags_Bool_Exp>>;
  assignments?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
  assignments_aggregate?: InputMaybe<Project_Tag_Assignments_Aggregate_Bool_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  tag_color?: InputMaybe<Brand_Colors_Enum_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_tags" */
export enum Project_Tags_Constraint {
  /** unique or primary key constraint on columns "id", "cluster_id", "team_id" */
  ProjectTagsIdTeamIdClusterIdKey = 'project_tags_id_team_id_cluster_id_key',
  /** unique or primary key constraint on columns "id" */
  ProjectTagsPkey = 'project_tags_pkey',
  /** unique or primary key constraint on columns "cluster_id", "name", "team_id" */
  ProjectTagsTeamIdClusterIdNameKey = 'project_tags_team_id_cluster_id_name_key'
}

/** input type for incrementing numeric columns in table "project_tags" */
export type Project_Tags_Inc_Input = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "project_tags" */
export type Project_Tags_Insert_Input = {
  assignments?: InputMaybe<Project_Tag_Assignments_Arr_Rel_Insert_Input>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tag_color?: InputMaybe<Brand_Colors_Enum>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Project_Tags_Max_Fields = {
  __typename?: 'project_tags_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Project_Tags_Min_Fields = {
  __typename?: 'project_tags_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "project_tags" */
export type Project_Tags_Mutation_Response = {
  __typename?: 'project_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Tags>;
};

/** input type for inserting object relation for remote table "project_tags" */
export type Project_Tags_Obj_Rel_Insert_Input = {
  data: Project_Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Tags_On_Conflict>;
};

/** on_conflict condition type for table "project_tags" */
export type Project_Tags_On_Conflict = {
  constraint: Project_Tags_Constraint;
  update_columns?: Array<Project_Tags_Update_Column>;
  where?: InputMaybe<Project_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "project_tags". */
export type Project_Tags_Order_By = {
  assignments_aggregate?: InputMaybe<Project_Tag_Assignments_Aggregate_Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  tag_color?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_tags */
export type Project_Tags_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "project_tags" */
export enum Project_Tags_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  TagColor = 'tag_color',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_tags" */
export type Project_Tags_Set_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tag_color?: InputMaybe<Brand_Colors_Enum>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Project_Tags_Stddev_Fields = {
  __typename?: 'project_tags_stddev_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Project_Tags_Stddev_Pop_Fields = {
  __typename?: 'project_tags_stddev_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Project_Tags_Stddev_Samp_Fields = {
  __typename?: 'project_tags_stddev_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "project_tags" */
export type Project_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Tags_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tag_color?: InputMaybe<Brand_Colors_Enum>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Project_Tags_Sum_Fields = {
  __typename?: 'project_tags_sum_fields';
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "project_tags" */
export enum Project_Tags_Update_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  TagColor = 'tag_color',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Tags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Tags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Tags_Var_Pop_Fields = {
  __typename?: 'project_tags_var_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Project_Tags_Var_Samp_Fields = {
  __typename?: 'project_tags_var_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Project_Tags_Variance_Fields = {
  __typename?: 'project_tags_variance_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

export type Publish_Custom_Upgrade_Args = {
  custom_upgrade_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Publish_Scenario_Args = {
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "additional_column_configs" */
  additional_column_configs: Array<Additional_Column_Configs>;
  /** fetch aggregated fields from the table: "additional_column_configs" */
  additional_column_configs_aggregate: Additional_Column_Configs_Aggregate;
  /** fetch data from the table: "additional_column_configs" using primary key columns */
  additional_column_configs_by_pk?: Maybe<Additional_Column_Configs>;
  /** fetch data from the table: "admin_app.audit_log" */
  admin_app_audit_log: Array<Admin_App_Audit_Log>;
  /** fetch aggregated fields from the table: "admin_app.audit_log" */
  admin_app_audit_log_aggregate: Admin_App_Audit_Log_Aggregate;
  /** fetch data from the table: "admin_app.audit_log" using primary key columns */
  admin_app_audit_log_by_pk?: Maybe<Admin_App_Audit_Log>;
  /** fetch data from the table: "admin_app.audit_log_targets" */
  admin_app_audit_log_targets: Array<Admin_App_Audit_Log_Targets>;
  /** fetch aggregated fields from the table: "admin_app.audit_log_targets" */
  admin_app_audit_log_targets_aggregate: Admin_App_Audit_Log_Targets_Aggregate;
  /** fetch data from the table: "admin_app.audit_log_targets" using primary key columns */
  admin_app_audit_log_targets_by_pk?: Maybe<Admin_App_Audit_Log_Targets>;
  /** fetch data from the table: "advanced_studies" */
  advanced_studies: Array<Advanced_Studies>;
  /** fetch aggregated fields from the table: "advanced_studies" */
  advanced_studies_aggregate: Advanced_Studies_Aggregate;
  /** fetch data from the table: "advanced_studies" using primary key columns */
  advanced_studies_by_pk?: Maybe<Advanced_Studies>;
  /** An array relationship */
  advanced_study_constraint_stacks: Array<Advanced_Study_Constraint_Stacks>;
  /** An aggregate relationship */
  advanced_study_constraint_stacks_aggregate: Advanced_Study_Constraint_Stacks_Aggregate;
  /** fetch data from the table: "advanced_study_constraint_stacks" using primary key columns */
  advanced_study_constraint_stacks_by_pk?: Maybe<Advanced_Study_Constraint_Stacks>;
  /** An array relationship */
  advanced_study_loads: Array<Advanced_Study_Loads>;
  /** An aggregate relationship */
  advanced_study_loads_aggregate: Advanced_Study_Loads_Aggregate;
  /** fetch data from the table: "advanced_study_loads" using primary key columns */
  advanced_study_loads_by_pk?: Maybe<Advanced_Study_Loads>;
  /** fetch data from the table: "all_projects" */
  all_projects: Array<All_Projects>;
  /** fetch aggregated fields from the table: "all_projects" */
  all_projects_aggregate: All_Projects_Aggregate;
  /** fetch data from the table: "all_projects" using primary key columns */
  all_projects_by_pk?: Maybe<All_Projects>;
  /** fetch data from the table: "branches" */
  branches: Array<Branches>;
  /** fetch aggregated fields from the table: "branches" */
  branches_aggregate: Branches_Aggregate;
  /** fetch data from the table: "branches" using primary key columns */
  branches_by_pk?: Maybe<Branches>;
  /** fetch data from the table: "brand_colors" */
  brand_colors: Array<Brand_Colors>;
  /** fetch aggregated fields from the table: "brand_colors" */
  brand_colors_aggregate: Brand_Colors_Aggregate;
  /** fetch data from the table: "brand_colors" using primary key columns */
  brand_colors_by_pk?: Maybe<Brand_Colors>;
  /** fetch data from the table: "bus_overrides" */
  bus_overrides: Array<Bus_Overrides>;
  /** fetch aggregated fields from the table: "bus_overrides" */
  bus_overrides_aggregate: Bus_Overrides_Aggregate;
  /** fetch data from the table: "bus_overrides" using primary key columns */
  bus_overrides_by_pk?: Maybe<Bus_Overrides>;
  /** fetch data from the table: "buses" */
  buses: Array<Buses>;
  /** fetch aggregated fields from the table: "buses" */
  buses_aggregate: Buses_Aggregate;
  /** An array relationship */
  buses_to_scopes: Array<Buses_To_Scopes>;
  /** An aggregate relationship */
  buses_to_scopes_aggregate: Buses_To_Scopes_Aggregate;
  /** fetch data from the table: "buses_to_scopes" using primary key columns */
  buses_to_scopes_by_pk?: Maybe<Buses_To_Scopes>;
  /** fetch data from the table: "buses_without_overrides" */
  buses_without_overrides: Array<Buses_Without_Overrides>;
  /** fetch aggregated fields from the table: "buses_without_overrides" */
  buses_without_overrides_aggregate: Buses_Without_Overrides_Aggregate;
  /** fetch data from the table: "buses_without_overrides" using primary key columns */
  buses_without_overrides_by_pk?: Maybe<Buses_Without_Overrides>;
  /** An array relationship */
  capacity_costs: Array<Capacity_Costs>;
  /** An aggregate relationship */
  capacity_costs_aggregate: Capacity_Costs_Aggregate;
  /** fetch data from the table: "capacity_costs" using primary key columns */
  capacity_costs_by_pk?: Maybe<Capacity_Costs>;
  /** fetch data from the table: "ceii_access" */
  ceii_access: Array<Ceii_Access>;
  /** fetch aggregated fields from the table: "ceii_access" */
  ceii_access_aggregate: Ceii_Access_Aggregate;
  /** fetch data from the table: "ceii_access" using primary key columns */
  ceii_access_by_pk?: Maybe<Ceii_Access>;
  /** fetch data from the table: "cluster_current_sis_report_posting" */
  cluster_current_sis_report_posting: Array<Cluster_Current_Sis_Report_Posting>;
  /** fetch aggregated fields from the table: "cluster_current_sis_report_posting" */
  cluster_current_sis_report_posting_aggregate: Cluster_Current_Sis_Report_Posting_Aggregate;
  /** fetch data from the table: "cluster_projects" */
  cluster_projects: Array<Cluster_Projects>;
  /** fetch aggregated fields from the table: "cluster_projects" */
  cluster_projects_aggregate: Cluster_Projects_Aggregate;
  /** An array relationship */
  constraint_stacks: Array<Constraint_Stacks>;
  /** An aggregate relationship */
  constraint_stacks_aggregate: Constraint_Stacks_Aggregate;
  /** fetch data from the table: "constraint_stacks" using primary key columns */
  constraint_stacks_by_pk?: Maybe<Constraint_Stacks>;
  /** fetch data from the table: "constraint_types" */
  constraint_types: Array<Constraint_Types>;
  /** fetch aggregated fields from the table: "constraint_types" */
  constraint_types_aggregate: Constraint_Types_Aggregate;
  /** fetch data from the table: "constraint_types" using primary key columns */
  constraint_types_by_pk?: Maybe<Constraint_Types>;
  /** fetch data from the table: "current_base_scenarios" */
  current_base_scenarios: Array<Current_Base_Scenarios>;
  /** fetch aggregated fields from the table: "current_base_scenarios" */
  current_base_scenarios_aggregate: Current_Base_Scenarios_Aggregate;
  /** fetch data from the table: "current_project_sis_reported_values" */
  current_project_sis_reported_values: Array<Current_Project_Sis_Reported_Values>;
  /** fetch aggregated fields from the table: "current_project_sis_reported_values" */
  current_project_sis_reported_values_aggregate: Current_Project_Sis_Reported_Values_Aggregate;
  /** An array relationship */
  custom_upgrade_files: Array<Custom_Upgrade_Files>;
  /** An aggregate relationship */
  custom_upgrade_files_aggregate: Custom_Upgrade_Files_Aggregate;
  /** fetch data from the table: "custom_upgrade_files" using primary key columns */
  custom_upgrade_files_by_pk?: Maybe<Custom_Upgrade_Files>;
  /** fetch data from the table: "custom_upgrade_model_set_validation_failures" */
  custom_upgrade_model_set_validation_failures: Array<Custom_Upgrade_Model_Set_Validation_Failures>;
  /** fetch aggregated fields from the table: "custom_upgrade_model_set_validation_failures" */
  custom_upgrade_model_set_validation_failures_aggregate: Custom_Upgrade_Model_Set_Validation_Failures_Aggregate;
  /** fetch data from the table: "custom_upgrade_model_set_validation_failures" using primary key columns */
  custom_upgrade_model_set_validation_failures_by_pk?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures>;
  /** fetch data from the table: "custom_upgrade_model_set_validations" */
  custom_upgrade_model_set_validations: Array<Custom_Upgrade_Model_Set_Validations>;
  /** fetch aggregated fields from the table: "custom_upgrade_model_set_validations" */
  custom_upgrade_model_set_validations_aggregate: Custom_Upgrade_Model_Set_Validations_Aggregate;
  /** fetch data from the table: "custom_upgrade_model_set_validations" using primary key columns */
  custom_upgrade_model_set_validations_by_pk?: Maybe<Custom_Upgrade_Model_Set_Validations>;
  /** fetch data from the table: "custom_upgrade_validation_failure_codes" */
  custom_upgrade_validation_failure_codes: Array<Custom_Upgrade_Validation_Failure_Codes>;
  /** fetch aggregated fields from the table: "custom_upgrade_validation_failure_codes" */
  custom_upgrade_validation_failure_codes_aggregate: Custom_Upgrade_Validation_Failure_Codes_Aggregate;
  /** fetch data from the table: "custom_upgrade_validation_failure_codes" using primary key columns */
  custom_upgrade_validation_failure_codes_by_pk?: Maybe<Custom_Upgrade_Validation_Failure_Codes>;
  /** fetch data from the table: "custom_upgrade_validation_failure_severities" */
  custom_upgrade_validation_failure_severities: Array<Custom_Upgrade_Validation_Failure_Severities>;
  /** fetch aggregated fields from the table: "custom_upgrade_validation_failure_severities" */
  custom_upgrade_validation_failure_severities_aggregate: Custom_Upgrade_Validation_Failure_Severities_Aggregate;
  /** fetch data from the table: "custom_upgrade_validation_failure_severities" using primary key columns */
  custom_upgrade_validation_failure_severities_by_pk?: Maybe<Custom_Upgrade_Validation_Failure_Severities>;
  /** fetch data from the table: "custom_upgrade_validation_statuses" */
  custom_upgrade_validation_statuses: Array<Custom_Upgrade_Validation_Statuses>;
  /** fetch aggregated fields from the table: "custom_upgrade_validation_statuses" */
  custom_upgrade_validation_statuses_aggregate: Custom_Upgrade_Validation_Statuses_Aggregate;
  /** fetch data from the table: "custom_upgrade_validation_statuses" using primary key columns */
  custom_upgrade_validation_statuses_by_pk?: Maybe<Custom_Upgrade_Validation_Statuses>;
  /** fetch data from the table: "custom_upgrades" */
  custom_upgrades: Array<Custom_Upgrades>;
  /** fetch aggregated fields from the table: "custom_upgrades" */
  custom_upgrades_aggregate: Custom_Upgrades_Aggregate;
  /** fetch data from the table: "custom_upgrades" using primary key columns */
  custom_upgrades_by_pk?: Maybe<Custom_Upgrades>;
  /** fetch data from the table: "data_versions" */
  data_versions: Array<Data_Versions>;
  /** fetch aggregated fields from the table: "data_versions" */
  data_versions_aggregate: Data_Versions_Aggregate;
  /** fetch data from the table: "data_versions" using primary key columns */
  data_versions_by_pk?: Maybe<Data_Versions>;
  /** execute function "external_api_bus" which returns "external_api_buses" */
  external_api_bus: Array<External_Api_Buses>;
  /** execute function "external_api_bus" and query aggregates on result of table type "external_api_buses" */
  external_api_bus_aggregate: External_Api_Buses_Aggregate;
  /** fetch data from the table: "external_api_buses" */
  external_api_buses: Array<External_Api_Buses>;
  /** fetch aggregated fields from the table: "external_api_buses" */
  external_api_buses_aggregate: External_Api_Buses_Aggregate;
  /** execute function "external_api_buses_page" which returns "external_api_buses" */
  external_api_buses_page: Array<External_Api_Buses>;
  /** execute function "external_api_buses_page" and query aggregates on result of table type "external_api_buses" */
  external_api_buses_page_aggregate: External_Api_Buses_Aggregate;
  /** execute function "external_api_capacity_cost" which returns "external_api_capacity_costs" */
  external_api_capacity_cost: Array<External_Api_Capacity_Costs>;
  /** execute function "external_api_capacity_cost" and query aggregates on result of table type "external_api_capacity_costs" */
  external_api_capacity_cost_aggregate: External_Api_Capacity_Costs_Aggregate;
  /** fetch data from the table: "external_api_capacity_costs" */
  external_api_capacity_costs: Array<External_Api_Capacity_Costs>;
  /** fetch aggregated fields from the table: "external_api_capacity_costs" */
  external_api_capacity_costs_aggregate: External_Api_Capacity_Costs_Aggregate;
  /** execute function "external_api_capacity_costs_page" which returns "external_api_capacity_costs" */
  external_api_capacity_costs_page: Array<External_Api_Capacity_Costs>;
  /** execute function "external_api_capacity_costs_page" and query aggregates on result of table type "external_api_capacity_costs" */
  external_api_capacity_costs_page_aggregate: External_Api_Capacity_Costs_Aggregate;
  /** execute function "external_api_constraint" which returns "external_api_constraints" */
  external_api_constraint: Array<External_Api_Constraints>;
  /** execute function "external_api_constraint" and query aggregates on result of table type "external_api_constraints" */
  external_api_constraint_aggregate: External_Api_Constraints_Aggregate;
  /** fetch data from the table: "external_api_constraints" */
  external_api_constraints: Array<External_Api_Constraints>;
  /** fetch aggregated fields from the table: "external_api_constraints" */
  external_api_constraints_aggregate: External_Api_Constraints_Aggregate;
  /** execute function "external_api_constraints_page" which returns "external_api_constraints" */
  external_api_constraints_page: Array<External_Api_Constraints>;
  /** execute function "external_api_constraints_page" and query aggregates on result of table type "external_api_constraints" */
  external_api_constraints_page_aggregate: External_Api_Constraints_Aggregate;
  /** fetch data from the table: "external_api_scopes" */
  external_api_scopes: Array<External_Api_Scopes>;
  /** fetch aggregated fields from the table: "external_api_scopes" */
  external_api_scopes_aggregate: External_Api_Scopes_Aggregate;
  /** execute function "external_api_scopes_list" which returns "external_api_scopes" */
  external_api_scopes_list: Array<External_Api_Scopes>;
  /** execute function "external_api_scopes_list" and query aggregates on result of table type "external_api_scopes" */
  external_api_scopes_list_aggregate: External_Api_Scopes_Aggregate;
  /** fetch data from the table: "favorite_buses" */
  favorite_buses: Array<Favorite_Buses>;
  /** fetch aggregated fields from the table: "favorite_buses" */
  favorite_buses_aggregate: Favorite_Buses_Aggregate;
  /** fetch data from the table: "favorite_buses" using primary key columns */
  favorite_buses_by_pk?: Maybe<Favorite_Buses>;
  /** fetch data from the table: "gtc_exposure" */
  gtc_exposure: Array<Gtc_Exposure>;
  /** fetch aggregated fields from the table: "gtc_exposure" */
  gtc_exposure_aggregate: Gtc_Exposure_Aggregate;
  /** fetch data from the table: "gtc_exposure" using primary key columns */
  gtc_exposure_by_pk?: Maybe<Gtc_Exposure>;
  /** fetch data from the table: "in_queue_cluster_model_set_statuses" */
  in_queue_cluster_model_set_statuses: Array<In_Queue_Cluster_Model_Set_Statuses>;
  /** fetch aggregated fields from the table: "in_queue_cluster_model_set_statuses" */
  in_queue_cluster_model_set_statuses_aggregate: In_Queue_Cluster_Model_Set_Statuses_Aggregate;
  /** fetch data from the table: "in_queue_cluster_model_set_statuses" using primary key columns */
  in_queue_cluster_model_set_statuses_by_pk?: Maybe<In_Queue_Cluster_Model_Set_Statuses>;
  /** An array relationship */
  in_queue_cluster_model_sets: Array<In_Queue_Cluster_Model_Sets>;
  /** An aggregate relationship */
  in_queue_cluster_model_sets_aggregate: In_Queue_Cluster_Model_Sets_Aggregate;
  /** fetch data from the table: "in_queue_cluster_model_sets" using primary key columns */
  in_queue_cluster_model_sets_by_pk?: Maybe<In_Queue_Cluster_Model_Sets>;
  /** fetch data from the table: "in_queue_cluster_statuses" */
  in_queue_cluster_statuses: Array<In_Queue_Cluster_Statuses>;
  /** fetch aggregated fields from the table: "in_queue_cluster_statuses" */
  in_queue_cluster_statuses_aggregate: In_Queue_Cluster_Statuses_Aggregate;
  /** fetch data from the table: "in_queue_cluster_statuses" using primary key columns */
  in_queue_cluster_statuses_by_pk?: Maybe<In_Queue_Cluster_Statuses>;
  /** fetch data from the table: "in_queue_clusters" */
  in_queue_clusters: Array<In_Queue_Clusters>;
  /** fetch aggregated fields from the table: "in_queue_clusters" */
  in_queue_clusters_aggregate: In_Queue_Clusters_Aggregate;
  /** fetch data from the table: "in_queue_clusters" using primary key columns */
  in_queue_clusters_by_pk?: Maybe<In_Queue_Clusters>;
  /** fetch data from the table: "in_queue_model_pois" */
  in_queue_model_pois: Array<In_Queue_Model_Pois>;
  /** fetch aggregated fields from the table: "in_queue_model_pois" */
  in_queue_model_pois_aggregate: In_Queue_Model_Pois_Aggregate;
  /** fetch data from the table: "in_queue_model_pois" using primary key columns */
  in_queue_model_pois_by_pk?: Maybe<In_Queue_Model_Pois>;
  /** fetch data from the table: "in_queue_model_variants" */
  in_queue_model_variants: Array<In_Queue_Model_Variants>;
  /** fetch aggregated fields from the table: "in_queue_model_variants" */
  in_queue_model_variants_aggregate: In_Queue_Model_Variants_Aggregate;
  /** fetch data from the table: "in_queue_model_variants" using primary key columns */
  in_queue_model_variants_by_pk?: Maybe<In_Queue_Model_Variants>;
  /** fetch data from the table: "in_queue_region_model_variants" */
  in_queue_region_model_variants: Array<In_Queue_Region_Model_Variants>;
  /** fetch aggregated fields from the table: "in_queue_region_model_variants" */
  in_queue_region_model_variants_aggregate: In_Queue_Region_Model_Variants_Aggregate;
  /** fetch data from the table: "in_queue_region_model_variants" using primary key columns */
  in_queue_region_model_variants_by_pk?: Maybe<In_Queue_Region_Model_Variants>;
  /** An array relationship */
  in_queue_speculative_projects: Array<In_Queue_Speculative_Projects>;
  /** An aggregate relationship */
  in_queue_speculative_projects_aggregate: In_Queue_Speculative_Projects_Aggregate;
  /** fetch data from the table: "in_queue_speculative_projects" using primary key columns */
  in_queue_speculative_projects_by_pk?: Maybe<In_Queue_Speculative_Projects>;
  /** An array relationship */
  in_queue_subscription_add_ons: Array<In_Queue_Subscription_Add_Ons>;
  /** An aggregate relationship */
  in_queue_subscription_add_ons_aggregate: In_Queue_Subscription_Add_Ons_Aggregate;
  /** fetch data from the table: "in_queue_subscription_add_ons" using primary key columns */
  in_queue_subscription_add_ons_by_pk?: Maybe<In_Queue_Subscription_Add_Ons>;
  /** An array relationship */
  in_queue_subscriptions: Array<In_Queue_Subscriptions>;
  /** An aggregate relationship */
  in_queue_subscriptions_aggregate: In_Queue_Subscriptions_Aggregate;
  /** fetch data from the table: "in_queue_subscriptions" using primary key columns */
  in_queue_subscriptions_by_pk?: Maybe<In_Queue_Subscriptions>;
  /** An array relationship */
  line_capacity_costs: Array<Line_Capacity_Costs>;
  /** An aggregate relationship */
  line_capacity_costs_aggregate: Line_Capacity_Costs_Aggregate;
  /** fetch data from the table: "line_capacity_costs" using primary key columns */
  line_capacity_costs_by_pk?: Maybe<Line_Capacity_Costs>;
  /** An array relationship */
  line_constraint_stacks: Array<Line_Constraint_Stacks>;
  /** An aggregate relationship */
  line_constraint_stacks_aggregate: Line_Constraint_Stacks_Aggregate;
  /** fetch data from the table: "line_constraint_stacks" using primary key columns */
  line_constraint_stacks_by_pk?: Maybe<Line_Constraint_Stacks>;
  /** fetch data from the table: "model_generator_facility_dfax" */
  model_generator_facility_dfax: Array<Model_Generator_Facility_Dfax>;
  /** fetch aggregated fields from the table: "model_generator_facility_dfax" */
  model_generator_facility_dfax_aggregate: Model_Generator_Facility_Dfax_Aggregate;
  /** fetch data from the table: "model_generator_facility_dfax" using primary key columns */
  model_generator_facility_dfax_by_pk?: Maybe<Model_Generator_Facility_Dfax>;
  /** fetch data from the table: "model_generators" */
  model_generators: Array<Model_Generators>;
  /** fetch aggregated fields from the table: "model_generators" */
  model_generators_aggregate: Model_Generators_Aggregate;
  /** fetch data from the table: "model_generators" using primary key columns */
  model_generators_by_pk?: Maybe<Model_Generators>;
  /** fetch data from the table: "model_lines" */
  model_lines: Array<Model_Lines>;
  /** fetch aggregated fields from the table: "model_lines" */
  model_lines_aggregate: Model_Lines_Aggregate;
  /** fetch data from the table: "model_lines" using primary key columns */
  model_lines_by_pk?: Maybe<Model_Lines>;
  /** An array relationship */
  model_lines_to_branches: Array<Model_Lines_To_Branches>;
  /** An aggregate relationship */
  model_lines_to_branches_aggregate: Model_Lines_To_Branches_Aggregate;
  /** fetch data from the table: "model_lines_to_branches" using primary key columns */
  model_lines_to_branches_by_pk?: Maybe<Model_Lines_To_Branches>;
  /** fetch data from the table: "model_lines_to_missing_buses" */
  model_lines_to_missing_buses: Array<Model_Lines_To_Missing_Buses>;
  /** fetch aggregated fields from the table: "model_lines_to_missing_buses" */
  model_lines_to_missing_buses_aggregate: Model_Lines_To_Missing_Buses_Aggregate;
  /** fetch data from the table: "model_lines_to_missing_buses" using primary key columns */
  model_lines_to_missing_buses_by_pk?: Maybe<Model_Lines_To_Missing_Buses>;
  /** fetch data from the table: "planned_interconnection_locations" */
  planned_interconnection_locations: Array<Planned_Interconnection_Locations>;
  /** fetch aggregated fields from the table: "planned_interconnection_locations" */
  planned_interconnection_locations_aggregate: Planned_Interconnection_Locations_Aggregate;
  /** fetch data from the table: "planned_interconnection_locations" using primary key columns */
  planned_interconnection_locations_by_pk?: Maybe<Planned_Interconnection_Locations>;
  /** An array relationship */
  project_additional_costs: Array<Project_Additional_Costs>;
  /** An aggregate relationship */
  project_additional_costs_aggregate: Project_Additional_Costs_Aggregate;
  /** fetch data from the table: "project_additional_costs" using primary key columns */
  project_additional_costs_by_pk?: Maybe<Project_Additional_Costs>;
  /** fetch data from the table: "project_configurations" */
  project_configurations: Array<Project_Configurations>;
  /** fetch aggregated fields from the table: "project_configurations" */
  project_configurations_aggregate: Project_Configurations_Aggregate;
  /** fetch data from the table: "project_configurations" using primary key columns */
  project_configurations_by_pk?: Maybe<Project_Configurations>;
  /** fetch data from the table: "project_cost_sources" */
  project_cost_sources: Array<Project_Cost_Sources>;
  /** fetch aggregated fields from the table: "project_cost_sources" */
  project_cost_sources_aggregate: Project_Cost_Sources_Aggregate;
  /** fetch data from the table: "project_cost_sources" using primary key columns */
  project_cost_sources_by_pk?: Maybe<Project_Cost_Sources>;
  /** fetch data from the table: "project_cost_types" */
  project_cost_types: Array<Project_Cost_Types>;
  /** fetch aggregated fields from the table: "project_cost_types" */
  project_cost_types_aggregate: Project_Cost_Types_Aggregate;
  /** fetch data from the table: "project_cost_types" using primary key columns */
  project_cost_types_by_pk?: Maybe<Project_Cost_Types>;
  /** fetch data from the table: "project_tag_assignments" */
  project_tag_assignments: Array<Project_Tag_Assignments>;
  /** fetch aggregated fields from the table: "project_tag_assignments" */
  project_tag_assignments_aggregate: Project_Tag_Assignments_Aggregate;
  /** fetch data from the table: "project_tag_assignments" using primary key columns */
  project_tag_assignments_by_pk?: Maybe<Project_Tag_Assignments>;
  /** fetch data from the table: "project_tags" */
  project_tags: Array<Project_Tags>;
  /** fetch aggregated fields from the table: "project_tags" */
  project_tags_aggregate: Project_Tags_Aggregate;
  /** fetch data from the table: "project_tags" using primary key columns */
  project_tags_by_pk?: Maybe<Project_Tags>;
  /** fetch data from the table: "queue_project_connection_points" */
  queue_project_connection_points: Array<Queue_Project_Connection_Points>;
  /** fetch aggregated fields from the table: "queue_project_connection_points" */
  queue_project_connection_points_aggregate: Queue_Project_Connection_Points_Aggregate;
  /** fetch data from the table: "queue_project_connection_points" using primary key columns */
  queue_project_connection_points_by_pk?: Maybe<Queue_Project_Connection_Points>;
  /** fetch data from the table: "queue_project_connection_types" */
  queue_project_connection_types: Array<Queue_Project_Connection_Types>;
  /** fetch aggregated fields from the table: "queue_project_connection_types" */
  queue_project_connection_types_aggregate: Queue_Project_Connection_Types_Aggregate;
  /** fetch data from the table: "queue_project_connection_types" using primary key columns */
  queue_project_connection_types_by_pk?: Maybe<Queue_Project_Connection_Types>;
  /** fetch data from the table: "queue_project_facility_dfax" */
  queue_project_facility_dfax: Array<Queue_Project_Facility_Dfax>;
  /** fetch aggregated fields from the table: "queue_project_facility_dfax" */
  queue_project_facility_dfax_aggregate: Queue_Project_Facility_Dfax_Aggregate;
  /** fetch data from the table: "queue_project_facility_dfax" using primary key columns */
  queue_project_facility_dfax_by_pk?: Maybe<Queue_Project_Facility_Dfax>;
  /** An array relationship */
  queue_project_hops: Array<Queue_Project_Hops>;
  /** An aggregate relationship */
  queue_project_hops_aggregate: Queue_Project_Hops_Aggregate;
  /** fetch data from the table: "queue_project_hops" using primary key columns */
  queue_project_hops_by_pk?: Maybe<Queue_Project_Hops>;
  /** fetch data from the table: "queue_projects" */
  queue_projects: Array<Queue_Projects>;
  /** fetch aggregated fields from the table: "queue_projects" */
  queue_projects_aggregate: Queue_Projects_Aggregate;
  /** fetch data from the table: "queue_projects" using primary key columns */
  queue_projects_by_pk?: Maybe<Queue_Projects>;
  /** An array relationship */
  scenario_allocated_upgrades: Array<Scenario_Allocated_Upgrades>;
  /** An aggregate relationship */
  scenario_allocated_upgrades_aggregate: Scenario_Allocated_Upgrades_Aggregate;
  /** fetch data from the table: "scenario_allocated_upgrades" using primary key columns */
  scenario_allocated_upgrades_by_pk?: Maybe<Scenario_Allocated_Upgrades>;
  /** fetch data from the table: "scenario_configurations" */
  scenario_configurations: Array<Scenario_Configurations>;
  /** fetch aggregated fields from the table: "scenario_configurations" */
  scenario_configurations_aggregate: Scenario_Configurations_Aggregate;
  /** fetch data from the table: "scenario_configurations" using primary key columns */
  scenario_configurations_by_pk?: Maybe<Scenario_Configurations>;
  /** An array relationship */
  scenario_constraints: Array<Scenario_Constraints>;
  /** An aggregate relationship */
  scenario_constraints_aggregate: Scenario_Constraints_Aggregate;
  /** fetch data from the table: "scenario_constraints" using primary key columns */
  scenario_constraints_by_pk?: Maybe<Scenario_Constraints>;
  /** fetch data from the table: "scenario_origins" */
  scenario_origins: Array<Scenario_Origins>;
  /** fetch aggregated fields from the table: "scenario_origins" */
  scenario_origins_aggregate: Scenario_Origins_Aggregate;
  /** fetch data from the table: "scenario_origins" using primary key columns */
  scenario_origins_by_pk?: Maybe<Scenario_Origins>;
  /** fetch data from the table: "scenario_project_ranks" */
  scenario_project_ranks: Array<Scenario_Project_Ranks>;
  /** fetch aggregated fields from the table: "scenario_project_ranks" */
  scenario_project_ranks_aggregate: Scenario_Project_Ranks_Aggregate;
  /** fetch data from the table: "scenario_project_ranks" using primary key columns */
  scenario_project_ranks_by_pk?: Maybe<Scenario_Project_Ranks>;
  /** An array relationship */
  scenario_projects: Array<Scenario_Projects>;
  /** An aggregate relationship */
  scenario_projects_aggregate: Scenario_Projects_Aggregate;
  /** fetch data from the table: "scenario_projects" using primary key columns */
  scenario_projects_by_pk?: Maybe<Scenario_Projects>;
  /** fetch data from the table: "scenario_statuses" */
  scenario_statuses: Array<Scenario_Statuses>;
  /** fetch aggregated fields from the table: "scenario_statuses" */
  scenario_statuses_aggregate: Scenario_Statuses_Aggregate;
  /** fetch data from the table: "scenario_statuses" using primary key columns */
  scenario_statuses_by_pk?: Maybe<Scenario_Statuses>;
  /** An array relationship */
  scenarios: Array<Scenarios>;
  /** An aggregate relationship */
  scenarios_aggregate: Scenarios_Aggregate;
  /** fetch data from the table: "scenarios" using primary key columns */
  scenarios_by_pk?: Maybe<Scenarios>;
  /** An array relationship */
  scopes: Array<Scopes>;
  /** An aggregate relationship */
  scopes_aggregate: Scopes_Aggregate;
  /** fetch data from the table: "scopes" using primary key columns */
  scopes_by_pk?: Maybe<Scopes>;
  /** An array relationship */
  screening_views: Array<Screening_Views>;
  /** An aggregate relationship */
  screening_views_aggregate: Screening_Views_Aggregate;
  /** fetch data from the table: "screening_views" using primary key columns */
  screening_views_by_pk?: Maybe<Screening_Views>;
  /** fetch data from the table: "sis_project_cost_type_metadata" */
  sis_project_cost_type_metadata: Array<Sis_Project_Cost_Type_Metadata>;
  /** fetch aggregated fields from the table: "sis_project_cost_type_metadata" */
  sis_project_cost_type_metadata_aggregate: Sis_Project_Cost_Type_Metadata_Aggregate;
  /** fetch data from the table: "sis_project_cost_type_metadata" using primary key columns */
  sis_project_cost_type_metadata_by_pk?: Maybe<Sis_Project_Cost_Type_Metadata>;
  /** fetch data from the table: "sis_report_postings" */
  sis_report_postings: Array<Sis_Report_Postings>;
  /** fetch aggregated fields from the table: "sis_report_postings" */
  sis_report_postings_aggregate: Sis_Report_Postings_Aggregate;
  /** fetch data from the table: "sis_report_postings" using primary key columns */
  sis_report_postings_by_pk?: Maybe<Sis_Report_Postings>;
  /** fetch data from the table: "subscription_add_ons" */
  subscription_add_ons: Array<Subscription_Add_Ons>;
  /** fetch aggregated fields from the table: "subscription_add_ons" */
  subscription_add_ons_aggregate: Subscription_Add_Ons_Aggregate;
  /** fetch data from the table: "subscription_add_ons" using primary key columns */
  subscription_add_ons_by_pk?: Maybe<Subscription_Add_Ons>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table: "teams" */
  teams: Array<Teams>;
  /** fetch aggregated fields from the table: "teams" */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** An array relationship */
  tracked_projects: Array<Tracked_Projects>;
  /** An aggregate relationship */
  tracked_projects_aggregate: Tracked_Projects_Aggregate;
  /** fetch data from the table: "tracked_projects" using primary key columns */
  tracked_projects_by_pk?: Maybe<Tracked_Projects>;
  /** An array relationship */
  unlocked_buses: Array<Unlocked_Buses>;
  /** An aggregate relationship */
  unlocked_buses_aggregate: Unlocked_Buses_Aggregate;
  /** fetch data from the table: "unlocked_buses" using primary key columns */
  unlocked_buses_by_pk?: Maybe<Unlocked_Buses>;
  /** fetch data from the table: "user_scope_configs" */
  user_scope_configs: Array<User_Scope_Configs>;
  /** fetch aggregated fields from the table: "user_scope_configs" */
  user_scope_configs_aggregate: User_Scope_Configs_Aggregate;
  /** fetch data from the table: "user_scope_configs" using primary key columns */
  user_scope_configs_by_pk?: Maybe<User_Scope_Configs>;
  /** fetch data from the table: "user_scope_permissions" */
  user_scope_permissions: Array<User_Scope_Permissions>;
  /** fetch aggregated fields from the table: "user_scope_permissions" */
  user_scope_permissions_aggregate: User_Scope_Permissions_Aggregate;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootAdditional_Column_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Additional_Column_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Additional_Column_Configs_Order_By>>;
  where?: InputMaybe<Additional_Column_Configs_Bool_Exp>;
};


export type Query_RootAdditional_Column_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Additional_Column_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Additional_Column_Configs_Order_By>>;
  where?: InputMaybe<Additional_Column_Configs_Bool_Exp>;
};


export type Query_RootAdditional_Column_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAdmin_App_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Bool_Exp>;
};


export type Query_RootAdmin_App_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Bool_Exp>;
};


export type Query_RootAdmin_App_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAdmin_App_Audit_Log_TargetsArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
};


export type Query_RootAdmin_App_Audit_Log_Targets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
};


export type Query_RootAdmin_App_Audit_Log_Targets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAdvanced_StudiesArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Studies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Studies_Order_By>>;
  where?: InputMaybe<Advanced_Studies_Bool_Exp>;
};


export type Query_RootAdvanced_Studies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Studies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Studies_Order_By>>;
  where?: InputMaybe<Advanced_Studies_Bool_Exp>;
};


export type Query_RootAdvanced_Studies_By_PkArgs = {
  advanced_study_id: Scalars['uuid']['input'];
};


export type Query_RootAdvanced_Study_Constraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
};


export type Query_RootAdvanced_Study_Constraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
};


export type Query_RootAdvanced_Study_Constraint_Stacks_By_PkArgs = {
  advanced_study_id: Scalars['uuid']['input'];
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
};


export type Query_RootAdvanced_Study_LoadsArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Loads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Loads_Order_By>>;
  where?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
};


export type Query_RootAdvanced_Study_Loads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Loads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Loads_Order_By>>;
  where?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
};


export type Query_RootAdvanced_Study_Loads_By_PkArgs = {
  advanced_study_id: Scalars['uuid']['input'];
  facility_type: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
};


export type Query_RootAll_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<All_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<All_Projects_Order_By>>;
  where?: InputMaybe<All_Projects_Bool_Exp>;
};


export type Query_RootAll_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<All_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<All_Projects_Order_By>>;
  where?: InputMaybe<All_Projects_Bool_Exp>;
};


export type Query_RootAll_Projects_By_PkArgs = {
  cluster_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
};


export type Query_RootBranchesArgs = {
  distinct_on?: InputMaybe<Array<Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Branches_Order_By>>;
  where?: InputMaybe<Branches_Bool_Exp>;
};


export type Query_RootBranches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Branches_Order_By>>;
  where?: InputMaybe<Branches_Bool_Exp>;
};


export type Query_RootBranches_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootBrand_ColorsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Colors_Order_By>>;
  where?: InputMaybe<Brand_Colors_Bool_Exp>;
};


export type Query_RootBrand_Colors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Colors_Order_By>>;
  where?: InputMaybe<Brand_Colors_Bool_Exp>;
};


export type Query_RootBrand_Colors_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootBus_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Bus_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bus_Overrides_Order_By>>;
  where?: InputMaybe<Bus_Overrides_Bool_Exp>;
};


export type Query_RootBus_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bus_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bus_Overrides_Order_By>>;
  where?: InputMaybe<Bus_Overrides_Bool_Exp>;
};


export type Query_RootBus_Overrides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBusesArgs = {
  distinct_on?: InputMaybe<Array<Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_Order_By>>;
  where?: InputMaybe<Buses_Bool_Exp>;
};


export type Query_RootBuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_Order_By>>;
  where?: InputMaybe<Buses_Bool_Exp>;
};


export type Query_RootBuses_To_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


export type Query_RootBuses_To_Scopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


export type Query_RootBuses_To_Scopes_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Query_RootBuses_Without_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Buses_Without_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_Without_Overrides_Order_By>>;
  where?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
};


export type Query_RootBuses_Without_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buses_Without_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_Without_Overrides_Order_By>>;
  where?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
};


export type Query_RootBuses_Without_Overrides_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
};


export type Query_RootCapacity_CostsArgs = {
  distinct_on?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capacity_Costs_Order_By>>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};


export type Query_RootCapacity_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capacity_Costs_Order_By>>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};


export type Query_RootCapacity_Costs_By_PkArgs = {
  energy_size: Scalars['numeric']['input'];
  includes_pre_existing: Scalars['Boolean']['input'];
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Query_RootCeii_AccessArgs = {
  distinct_on?: InputMaybe<Array<Ceii_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ceii_Access_Order_By>>;
  where?: InputMaybe<Ceii_Access_Bool_Exp>;
};


export type Query_RootCeii_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ceii_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ceii_Access_Order_By>>;
  where?: InputMaybe<Ceii_Access_Bool_Exp>;
};


export type Query_RootCeii_Access_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCluster_Current_Sis_Report_PostingArgs = {
  distinct_on?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Order_By>>;
  where?: InputMaybe<Cluster_Current_Sis_Report_Posting_Bool_Exp>;
};


export type Query_RootCluster_Current_Sis_Report_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Order_By>>;
  where?: InputMaybe<Cluster_Current_Sis_Report_Posting_Bool_Exp>;
};


export type Query_RootCluster_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Cluster_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cluster_Projects_Order_By>>;
  where?: InputMaybe<Cluster_Projects_Bool_Exp>;
};


export type Query_RootCluster_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cluster_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cluster_Projects_Order_By>>;
  where?: InputMaybe<Cluster_Projects_Bool_Exp>;
};


export type Query_RootConstraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};


export type Query_RootConstraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};


export type Query_RootConstraint_Stacks_By_PkArgs = {
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  resource_type: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Query_RootConstraint_TypesArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Types_Order_By>>;
  where?: InputMaybe<Constraint_Types_Bool_Exp>;
};


export type Query_RootConstraint_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Types_Order_By>>;
  where?: InputMaybe<Constraint_Types_Bool_Exp>;
};


export type Query_RootConstraint_Types_By_PkArgs = {
  constraint_type: Scalars['String']['input'];
};


export type Query_RootCurrent_Base_ScenariosArgs = {
  distinct_on?: InputMaybe<Array<Current_Base_Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Base_Scenarios_Order_By>>;
  where?: InputMaybe<Current_Base_Scenarios_Bool_Exp>;
};


export type Query_RootCurrent_Base_Scenarios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Current_Base_Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Base_Scenarios_Order_By>>;
  where?: InputMaybe<Current_Base_Scenarios_Bool_Exp>;
};


export type Query_RootCurrent_Project_Sis_Reported_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Order_By>>;
  where?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
};


export type Query_RootCurrent_Project_Sis_Reported_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Order_By>>;
  where?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_FilesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Files_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Files_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustom_Upgrade_Model_Set_Validation_FailuresArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Model_Set_Validation_Failures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Model_Set_Validation_Failures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustom_Upgrade_Model_Set_ValidationsArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Model_Set_Validations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Model_Set_Validations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCustom_Upgrade_Validation_Failure_CodesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Validation_Failure_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Validation_Failure_Codes_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type Query_RootCustom_Upgrade_Validation_Failure_SeveritiesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Validation_Failure_Severities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Validation_Failure_Severities_By_PkArgs = {
  severity: Scalars['String']['input'];
};


export type Query_RootCustom_Upgrade_Validation_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Statuses_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Validation_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Statuses_Bool_Exp>;
};


export type Query_RootCustom_Upgrade_Validation_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootCustom_UpgradesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrades_Order_By>>;
  where?: InputMaybe<Custom_Upgrades_Bool_Exp>;
};


export type Query_RootCustom_Upgrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrades_Order_By>>;
  where?: InputMaybe<Custom_Upgrades_Bool_Exp>;
};


export type Query_RootCustom_Upgrades_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootData_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Data_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Versions_Order_By>>;
  where?: InputMaybe<Data_Versions_Bool_Exp>;
};


export type Query_RootData_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Versions_Order_By>>;
  where?: InputMaybe<Data_Versions_Bool_Exp>;
};


export type Query_RootData_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootExternal_Api_BusArgs = {
  args: External_Api_Bus_Args;
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Query_RootExternal_Api_Bus_AggregateArgs = {
  args: External_Api_Bus_Args;
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Query_RootExternal_Api_BusesArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Query_RootExternal_Api_Buses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Query_RootExternal_Api_Buses_PageArgs = {
  args: External_Api_Buses_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Query_RootExternal_Api_Buses_Page_AggregateArgs = {
  args: External_Api_Buses_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Query_RootExternal_Api_Capacity_CostArgs = {
  args: External_Api_Capacity_Cost_Args;
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Query_RootExternal_Api_Capacity_Cost_AggregateArgs = {
  args: External_Api_Capacity_Cost_Args;
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Query_RootExternal_Api_Capacity_CostsArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Query_RootExternal_Api_Capacity_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Query_RootExternal_Api_Capacity_Costs_PageArgs = {
  args: External_Api_Capacity_Costs_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Query_RootExternal_Api_Capacity_Costs_Page_AggregateArgs = {
  args: External_Api_Capacity_Costs_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Query_RootExternal_Api_ConstraintArgs = {
  args: External_Api_Constraint_Args;
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Query_RootExternal_Api_Constraint_AggregateArgs = {
  args: External_Api_Constraint_Args;
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Query_RootExternal_Api_ConstraintsArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Query_RootExternal_Api_Constraints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Query_RootExternal_Api_Constraints_PageArgs = {
  args: External_Api_Constraints_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Query_RootExternal_Api_Constraints_Page_AggregateArgs = {
  args: External_Api_Constraints_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Query_RootExternal_Api_ScopesArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Scopes_Order_By>>;
  where?: InputMaybe<External_Api_Scopes_Bool_Exp>;
};


export type Query_RootExternal_Api_Scopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Scopes_Order_By>>;
  where?: InputMaybe<External_Api_Scopes_Bool_Exp>;
};


export type Query_RootExternal_Api_Scopes_ListArgs = {
  args: External_Api_Scopes_List_Args;
  distinct_on?: InputMaybe<Array<External_Api_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Scopes_Order_By>>;
  where?: InputMaybe<External_Api_Scopes_Bool_Exp>;
};


export type Query_RootExternal_Api_Scopes_List_AggregateArgs = {
  args: External_Api_Scopes_List_Args;
  distinct_on?: InputMaybe<Array<External_Api_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Scopes_Order_By>>;
  where?: InputMaybe<External_Api_Scopes_Bool_Exp>;
};


export type Query_RootFavorite_BusesArgs = {
  distinct_on?: InputMaybe<Array<Favorite_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_Buses_Order_By>>;
  where?: InputMaybe<Favorite_Buses_Bool_Exp>;
};


export type Query_RootFavorite_Buses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorite_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_Buses_Order_By>>;
  where?: InputMaybe<Favorite_Buses_Bool_Exp>;
};


export type Query_RootFavorite_Buses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGtc_ExposureArgs = {
  distinct_on?: InputMaybe<Array<Gtc_Exposure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gtc_Exposure_Order_By>>;
  where?: InputMaybe<Gtc_Exposure_Bool_Exp>;
};


export type Query_RootGtc_Exposure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gtc_Exposure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gtc_Exposure_Order_By>>;
  where?: InputMaybe<Gtc_Exposure_Bool_Exp>;
};


export type Query_RootGtc_Exposure_By_PkArgs = {
  interface_acronym: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  region: Scalars['String']['input'];
  source_case: Scalars['String']['input'];
};


export type Query_RootIn_Queue_Cluster_Model_Set_StatusesArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Bool_Exp>;
};


export type Query_RootIn_Queue_Cluster_Model_Set_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Bool_Exp>;
};


export type Query_RootIn_Queue_Cluster_Model_Set_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootIn_Queue_Cluster_Model_SetsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};


export type Query_RootIn_Queue_Cluster_Model_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};


export type Query_RootIn_Queue_Cluster_Model_Sets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIn_Queue_Cluster_StatusesArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Statuses_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Statuses_Bool_Exp>;
};


export type Query_RootIn_Queue_Cluster_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Statuses_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Statuses_Bool_Exp>;
};


export type Query_RootIn_Queue_Cluster_Statuses_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootIn_Queue_ClustersArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Clusters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Clusters_Order_By>>;
  where?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
};


export type Query_RootIn_Queue_Clusters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Clusters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Clusters_Order_By>>;
  where?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
};


export type Query_RootIn_Queue_Clusters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIn_Queue_Model_PoisArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Model_Pois_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Model_Pois_Order_By>>;
  where?: InputMaybe<In_Queue_Model_Pois_Bool_Exp>;
};


export type Query_RootIn_Queue_Model_Pois_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Model_Pois_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Model_Pois_Order_By>>;
  where?: InputMaybe<In_Queue_Model_Pois_Bool_Exp>;
};


export type Query_RootIn_Queue_Model_Pois_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIn_Queue_Model_VariantsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
};


export type Query_RootIn_Queue_Model_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
};


export type Query_RootIn_Queue_Model_Variants_By_PkArgs = {
  variant: Scalars['String']['input'];
};


export type Query_RootIn_Queue_Region_Model_VariantsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Region_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Region_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
};


export type Query_RootIn_Queue_Region_Model_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Region_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Region_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
};


export type Query_RootIn_Queue_Region_Model_Variants_By_PkArgs = {
  region: Scalars['String']['input'];
  variant: In_Queue_Model_Variants_Enum;
};


export type Query_RootIn_Queue_Speculative_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};


export type Query_RootIn_Queue_Speculative_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};


export type Query_RootIn_Queue_Speculative_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIn_Queue_Subscription_Add_OnsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
};


export type Query_RootIn_Queue_Subscription_Add_Ons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
};


export type Query_RootIn_Queue_Subscription_Add_Ons_By_PkArgs = {
  add_on: Subscription_Add_Ons_Enum;
  subscription_id: Scalars['uuid']['input'];
};


export type Query_RootIn_Queue_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscriptions_Order_By>>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};


export type Query_RootIn_Queue_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscriptions_Order_By>>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};


export type Query_RootIn_Queue_Subscriptions_By_PkArgs = {
  subscription_id: Scalars['uuid']['input'];
};


export type Query_RootLine_Capacity_CostsArgs = {
  distinct_on?: InputMaybe<Array<Line_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Capacity_Costs_Order_By>>;
  where?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
};


export type Query_RootLine_Capacity_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Capacity_Costs_Order_By>>;
  where?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
};


export type Query_RootLine_Capacity_Costs_By_PkArgs = {
  energy_size: Scalars['numeric']['input'];
  includes_pre_existing: Scalars['Boolean']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  tap_facility_id: Scalars['String']['input'];
};


export type Query_RootLine_Constraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Line_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
};


export type Query_RootLine_Constraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
};


export type Query_RootLine_Constraint_Stacks_By_PkArgs = {
  monitored_facility_id: Scalars['String']['input'];
  resource_type: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  tap_facility_id: Scalars['String']['input'];
};


export type Query_RootModel_Generator_Facility_DfaxArgs = {
  distinct_on?: InputMaybe<Array<Model_Generator_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generator_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
};


export type Query_RootModel_Generator_Facility_Dfax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Generator_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generator_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
};


export type Query_RootModel_Generator_Facility_Dfax_By_PkArgs = {
  contingency: Scalars['String']['input'];
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};


export type Query_RootModel_GeneratorsArgs = {
  distinct_on?: InputMaybe<Array<Model_Generators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generators_Order_By>>;
  where?: InputMaybe<Model_Generators_Bool_Exp>;
};


export type Query_RootModel_Generators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Generators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generators_Order_By>>;
  where?: InputMaybe<Model_Generators_Bool_Exp>;
};


export type Query_RootModel_Generators_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};


export type Query_RootModel_LinesArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_Order_By>>;
  where?: InputMaybe<Model_Lines_Bool_Exp>;
};


export type Query_RootModel_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_Order_By>>;
  where?: InputMaybe<Model_Lines_Bool_Exp>;
};


export type Query_RootModel_Lines_By_PkArgs = {
  facility_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Query_RootModel_Lines_To_BranchesArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Branches_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
};


export type Query_RootModel_Lines_To_Branches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Branches_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
};


export type Query_RootModel_Lines_To_Branches_By_PkArgs = {
  branch_id: Scalars['String']['input'];
  facility_id: Scalars['String']['input'];
  region: Scalars['String']['input'];
};


export type Query_RootModel_Lines_To_Missing_BusesArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Missing_Buses_Bool_Exp>;
};


export type Query_RootModel_Lines_To_Missing_Buses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Missing_Buses_Bool_Exp>;
};


export type Query_RootModel_Lines_To_Missing_Buses_By_PkArgs = {
  facility_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Query_RootPlanned_Interconnection_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Planned_Interconnection_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planned_Interconnection_Locations_Order_By>>;
  where?: InputMaybe<Planned_Interconnection_Locations_Bool_Exp>;
};


export type Query_RootPlanned_Interconnection_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planned_Interconnection_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planned_Interconnection_Locations_Order_By>>;
  where?: InputMaybe<Planned_Interconnection_Locations_Bool_Exp>;
};


export type Query_RootPlanned_Interconnection_Locations_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
};


export type Query_RootProject_Additional_CostsArgs = {
  distinct_on?: InputMaybe<Array<Project_Additional_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Additional_Costs_Order_By>>;
  where?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
};


export type Query_RootProject_Additional_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Additional_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Additional_Costs_Order_By>>;
  where?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
};


export type Query_RootProject_Additional_Costs_By_PkArgs = {
  cost_type: Project_Cost_Types_Enum;
  posting_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
  source: Project_Cost_Sources_Enum;
};


export type Query_RootProject_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Configurations_Order_By>>;
  where?: InputMaybe<Project_Configurations_Bool_Exp>;
};


export type Query_RootProject_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Configurations_Order_By>>;
  where?: InputMaybe<Project_Configurations_Bool_Exp>;
};


export type Query_RootProject_Configurations_By_PkArgs = {
  cluster_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
  team_id: Scalars['Int']['input'];
};


export type Query_RootProject_Cost_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Project_Cost_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Cost_Sources_Order_By>>;
  where?: InputMaybe<Project_Cost_Sources_Bool_Exp>;
};


export type Query_RootProject_Cost_Sources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Cost_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Cost_Sources_Order_By>>;
  where?: InputMaybe<Project_Cost_Sources_Bool_Exp>;
};


export type Query_RootProject_Cost_Sources_By_PkArgs = {
  source: Scalars['String']['input'];
};


export type Query_RootProject_Cost_TypesArgs = {
  distinct_on?: InputMaybe<Array<Project_Cost_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Cost_Types_Order_By>>;
  where?: InputMaybe<Project_Cost_Types_Bool_Exp>;
};


export type Query_RootProject_Cost_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Cost_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Cost_Types_Order_By>>;
  where?: InputMaybe<Project_Cost_Types_Bool_Exp>;
};


export type Query_RootProject_Cost_Types_By_PkArgs = {
  cost_type: Scalars['String']['input'];
};


export type Query_RootProject_Tag_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tag_Assignments_Order_By>>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};


export type Query_RootProject_Tag_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tag_Assignments_Order_By>>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};


export type Query_RootProject_Tag_Assignments_By_PkArgs = {
  project_id: Scalars['String']['input'];
  tag_id: Scalars['uuid']['input'];
};


export type Query_RootProject_TagsArgs = {
  distinct_on?: InputMaybe<Array<Project_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tags_Order_By>>;
  where?: InputMaybe<Project_Tags_Bool_Exp>;
};


export type Query_RootProject_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tags_Order_By>>;
  where?: InputMaybe<Project_Tags_Bool_Exp>;
};


export type Query_RootProject_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQueue_Project_Connection_PointsArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Points_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Points_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
};


export type Query_RootQueue_Project_Connection_Points_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Points_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Points_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
};


export type Query_RootQueue_Project_Connection_Points_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQueue_Project_Connection_TypesArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Types_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Types_Bool_Exp>;
};


export type Query_RootQueue_Project_Connection_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Types_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Types_Bool_Exp>;
};


export type Query_RootQueue_Project_Connection_Types_By_PkArgs = {
  connection_type: Scalars['String']['input'];
};


export type Query_RootQueue_Project_Facility_DfaxArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
};


export type Query_RootQueue_Project_Facility_Dfax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
};


export type Query_RootQueue_Project_Facility_Dfax_By_PkArgs = {
  contingency: Scalars['String']['input'];
  monitored_facility_id: Scalars['String']['input'];
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
};


export type Query_RootQueue_Project_HopsArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Hops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Hops_Order_By>>;
  where?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
};


export type Query_RootQueue_Project_Hops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Hops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Hops_Order_By>>;
  where?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
};


export type Query_RootQueue_Project_Hops_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Query_RootQueue_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Queue_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Projects_Order_By>>;
  where?: InputMaybe<Queue_Projects_Bool_Exp>;
};


export type Query_RootQueue_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Projects_Order_By>>;
  where?: InputMaybe<Queue_Projects_Bool_Exp>;
};


export type Query_RootQueue_Projects_By_PkArgs = {
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Query_RootScenario_Allocated_UpgradesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Allocated_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Allocated_Upgrades_Order_By>>;
  where?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
};


export type Query_RootScenario_Allocated_Upgrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Allocated_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Allocated_Upgrades_Order_By>>;
  where?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
};


export type Query_RootScenario_Allocated_Upgrades_By_PkArgs = {
  constraint_type: Constraint_Types_Enum;
  network_upgrade_id: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};


export type Query_RootScenario_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Configurations_Order_By>>;
  where?: InputMaybe<Scenario_Configurations_Bool_Exp>;
};


export type Query_RootScenario_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Configurations_Order_By>>;
  where?: InputMaybe<Scenario_Configurations_Bool_Exp>;
};


export type Query_RootScenario_Configurations_By_PkArgs = {
  scenario_id: Scalars['uuid']['input'];
  team_id: Scalars['Int']['input'];
};


export type Query_RootScenario_ConstraintsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Constraints_Order_By>>;
  where?: InputMaybe<Scenario_Constraints_Bool_Exp>;
};


export type Query_RootScenario_Constraints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Constraints_Order_By>>;
  where?: InputMaybe<Scenario_Constraints_Bool_Exp>;
};


export type Query_RootScenario_Constraints_By_PkArgs = {
  constraint_type: Constraint_Types_Enum;
  facility_id: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
  worst_contingency_name: Scalars['String']['input'];
};


export type Query_RootScenario_OriginsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Origins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Origins_Order_By>>;
  where?: InputMaybe<Scenario_Origins_Bool_Exp>;
};


export type Query_RootScenario_Origins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Origins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Origins_Order_By>>;
  where?: InputMaybe<Scenario_Origins_Bool_Exp>;
};


export type Query_RootScenario_Origins_By_PkArgs = {
  origin: Scalars['String']['input'];
};


export type Query_RootScenario_Project_RanksArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Project_Ranks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Project_Ranks_Order_By>>;
  where?: InputMaybe<Scenario_Project_Ranks_Bool_Exp>;
};


export type Query_RootScenario_Project_Ranks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Project_Ranks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Project_Ranks_Order_By>>;
  where?: InputMaybe<Scenario_Project_Ranks_Bool_Exp>;
};


export type Query_RootScenario_Project_Ranks_By_PkArgs = {
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};


export type Query_RootScenario_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Projects_Order_By>>;
  where?: InputMaybe<Scenario_Projects_Bool_Exp>;
};


export type Query_RootScenario_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Projects_Order_By>>;
  where?: InputMaybe<Scenario_Projects_Bool_Exp>;
};


export type Query_RootScenario_Projects_By_PkArgs = {
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};


export type Query_RootScenario_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Statuses_Order_By>>;
  where?: InputMaybe<Scenario_Statuses_Bool_Exp>;
};


export type Query_RootScenario_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Statuses_Order_By>>;
  where?: InputMaybe<Scenario_Statuses_Bool_Exp>;
};


export type Query_RootScenario_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Query_RootScenariosArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Query_RootScenarios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Query_RootScenarios_By_PkArgs = {
  scenario_id: Scalars['uuid']['input'];
};


export type Query_RootScopesArgs = {
  distinct_on?: InputMaybe<Array<Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scopes_Order_By>>;
  where?: InputMaybe<Scopes_Bool_Exp>;
};


export type Query_RootScopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scopes_Order_By>>;
  where?: InputMaybe<Scopes_Bool_Exp>;
};


export type Query_RootScopes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootScreening_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Screening_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screening_Views_Order_By>>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};


export type Query_RootScreening_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Screening_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screening_Views_Order_By>>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};


export type Query_RootScreening_Views_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootSis_Project_Cost_Type_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Order_By>>;
  where?: InputMaybe<Sis_Project_Cost_Type_Metadata_Bool_Exp>;
};


export type Query_RootSis_Project_Cost_Type_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Order_By>>;
  where?: InputMaybe<Sis_Project_Cost_Type_Metadata_Bool_Exp>;
};


export type Query_RootSis_Project_Cost_Type_Metadata_By_PkArgs = {
  cost_type: Project_Cost_Types_Enum;
};


export type Query_RootSis_Report_PostingsArgs = {
  distinct_on?: InputMaybe<Array<Sis_Report_Postings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sis_Report_Postings_Order_By>>;
  where?: InputMaybe<Sis_Report_Postings_Bool_Exp>;
};


export type Query_RootSis_Report_Postings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sis_Report_Postings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sis_Report_Postings_Order_By>>;
  where?: InputMaybe<Sis_Report_Postings_Bool_Exp>;
};


export type Query_RootSis_Report_Postings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSubscription_Add_OnsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<Subscription_Add_Ons_Bool_Exp>;
};


export type Query_RootSubscription_Add_Ons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<Subscription_Add_Ons_Bool_Exp>;
};


export type Query_RootSubscription_Add_Ons_By_PkArgs = {
  add_on: Scalars['String']['input'];
};


export type Query_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTracked_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tracked_Projects_Order_By>>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};


export type Query_RootTracked_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tracked_Projects_Order_By>>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};


export type Query_RootTracked_Projects_By_PkArgs = {
  project_id: Scalars['String']['input'];
  subscription_id: Scalars['uuid']['input'];
};


export type Query_RootUnlocked_BusesArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};


export type Query_RootUnlocked_Buses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};


export type Query_RootUnlocked_Buses_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUser_Scope_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Configs_Order_By>>;
  where?: InputMaybe<User_Scope_Configs_Bool_Exp>;
};


export type Query_RootUser_Scope_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Configs_Order_By>>;
  where?: InputMaybe<User_Scope_Configs_Bool_Exp>;
};


export type Query_RootUser_Scope_Configs_By_PkArgs = {
  scope: Scalars['String']['input'];
};


export type Query_RootUser_Scope_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


export type Query_RootUser_Scope_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  auth0_id: Scalars['String']['input'];
};

/** columns and relationships of "queue_project_connection_points" */
export type Queue_Project_Connection_Points = {
  __typename?: 'queue_project_connection_points';
  /** An array relationship */
  cluster_model_sets: Array<In_Queue_Cluster_Model_Sets>;
  /** An aggregate relationship */
  cluster_model_sets_aggregate: In_Queue_Cluster_Model_Sets_Aggregate;
  connection_type: Queue_Project_Connection_Types_Enum;
  county?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  latitude?: Maybe<Scalars['numeric']['output']>;
  line_tap_circuit_id?: Maybe<Scalars['String']['output']>;
  line_tap_from_bus?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  line_tap_from_bus_location?: Maybe<Buses>;
  line_tap_from_nira_bus_id?: Maybe<Scalars['String']['output']>;
  line_tap_to_bus?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  line_tap_to_bus_location?: Maybe<Buses>;
  line_tap_to_nira_bus_id?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  model_set_id: Scalars['uuid']['output'];
  poi_bus?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  poi_bus_location?: Maybe<Buses>;
  poi_nira_bus_id?: Maybe<Scalars['String']['output']>;
  project_id: Scalars['String']['output'];
  region: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "queue_project_connection_points" */
export type Queue_Project_Connection_PointsCluster_Model_SetsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};


/** columns and relationships of "queue_project_connection_points" */
export type Queue_Project_Connection_PointsCluster_Model_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};

/** aggregated selection of "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Aggregate = {
  __typename?: 'queue_project_connection_points_aggregate';
  aggregate?: Maybe<Queue_Project_Connection_Points_Aggregate_Fields>;
  nodes: Array<Queue_Project_Connection_Points>;
};

export type Queue_Project_Connection_Points_Aggregate_Bool_Exp = {
  count?: InputMaybe<Queue_Project_Connection_Points_Aggregate_Bool_Exp_Count>;
};

export type Queue_Project_Connection_Points_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Queue_Project_Connection_Points_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Aggregate_Fields = {
  __typename?: 'queue_project_connection_points_aggregate_fields';
  avg?: Maybe<Queue_Project_Connection_Points_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Queue_Project_Connection_Points_Max_Fields>;
  min?: Maybe<Queue_Project_Connection_Points_Min_Fields>;
  stddev?: Maybe<Queue_Project_Connection_Points_Stddev_Fields>;
  stddev_pop?: Maybe<Queue_Project_Connection_Points_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Queue_Project_Connection_Points_Stddev_Samp_Fields>;
  sum?: Maybe<Queue_Project_Connection_Points_Sum_Fields>;
  var_pop?: Maybe<Queue_Project_Connection_Points_Var_Pop_Fields>;
  var_samp?: Maybe<Queue_Project_Connection_Points_Var_Samp_Fields>;
  variance?: Maybe<Queue_Project_Connection_Points_Variance_Fields>;
};


/** aggregate fields of "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queue_Project_Connection_Points_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Aggregate_Order_By = {
  avg?: InputMaybe<Queue_Project_Connection_Points_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Queue_Project_Connection_Points_Max_Order_By>;
  min?: InputMaybe<Queue_Project_Connection_Points_Min_Order_By>;
  stddev?: InputMaybe<Queue_Project_Connection_Points_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Queue_Project_Connection_Points_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Queue_Project_Connection_Points_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Queue_Project_Connection_Points_Sum_Order_By>;
  var_pop?: InputMaybe<Queue_Project_Connection_Points_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Queue_Project_Connection_Points_Var_Samp_Order_By>;
  variance?: InputMaybe<Queue_Project_Connection_Points_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Arr_Rel_Insert_Input = {
  data: Array<Queue_Project_Connection_Points_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Queue_Project_Connection_Points_On_Conflict>;
};

/** aggregate avg on columns */
export type Queue_Project_Connection_Points_Avg_Fields = {
  __typename?: 'queue_project_connection_points_avg_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Avg_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "queue_project_connection_points". All fields are combined with a logical 'AND'. */
export type Queue_Project_Connection_Points_Bool_Exp = {
  _and?: InputMaybe<Array<Queue_Project_Connection_Points_Bool_Exp>>;
  _not?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
  _or?: InputMaybe<Array<Queue_Project_Connection_Points_Bool_Exp>>;
  cluster_model_sets?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
  cluster_model_sets_aggregate?: InputMaybe<In_Queue_Cluster_Model_Sets_Aggregate_Bool_Exp>;
  connection_type?: InputMaybe<Queue_Project_Connection_Types_Enum_Comparison_Exp>;
  county?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  line_tap_circuit_id?: InputMaybe<String_Comparison_Exp>;
  line_tap_from_bus?: InputMaybe<String_Comparison_Exp>;
  line_tap_from_bus_location?: InputMaybe<Buses_Bool_Exp>;
  line_tap_from_nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  line_tap_to_bus?: InputMaybe<String_Comparison_Exp>;
  line_tap_to_bus_location?: InputMaybe<Buses_Bool_Exp>;
  line_tap_to_nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
  model_set_id?: InputMaybe<Uuid_Comparison_Exp>;
  poi_bus?: InputMaybe<String_Comparison_Exp>;
  poi_bus_location?: InputMaybe<Buses_Bool_Exp>;
  poi_nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "queue_project_connection_points" */
export enum Queue_Project_Connection_Points_Constraint {
  /** unique or primary key constraint on columns "poi_bus", "connection_type", "project_id", "line_tap_to_bus", "line_tap_from_bus", "line_tap_circuit_id", "model_set_id" */
  QueueProjectConnectionPointsKey = 'queue_project_connection_points_key',
  /** unique or primary key constraint on columns "id" */
  QueueProjectConnectionPointsPkey = 'queue_project_connection_points_pkey'
}

/** input type for incrementing numeric columns in table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Inc_Input = {
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Insert_Input = {
  cluster_model_sets?: InputMaybe<In_Queue_Cluster_Model_Sets_Arr_Rel_Insert_Input>;
  connection_type?: InputMaybe<Queue_Project_Connection_Types_Enum>;
  county?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  line_tap_circuit_id?: InputMaybe<Scalars['String']['input']>;
  line_tap_from_bus?: InputMaybe<Scalars['String']['input']>;
  line_tap_from_bus_location?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  line_tap_from_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  line_tap_to_bus?: InputMaybe<Scalars['String']['input']>;
  line_tap_to_bus_location?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  line_tap_to_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  poi_bus?: InputMaybe<Scalars['String']['input']>;
  poi_bus_location?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  poi_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Queue_Project_Connection_Points_Max_Fields = {
  __typename?: 'queue_project_connection_points_max_fields';
  county?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  line_tap_circuit_id?: Maybe<Scalars['String']['output']>;
  line_tap_from_bus?: Maybe<Scalars['String']['output']>;
  line_tap_from_nira_bus_id?: Maybe<Scalars['String']['output']>;
  line_tap_to_bus?: Maybe<Scalars['String']['output']>;
  line_tap_to_nira_bus_id?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  model_set_id?: Maybe<Scalars['uuid']['output']>;
  poi_bus?: Maybe<Scalars['String']['output']>;
  poi_nira_bus_id?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Max_Order_By = {
  county?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  line_tap_circuit_id?: InputMaybe<Order_By>;
  line_tap_from_bus?: InputMaybe<Order_By>;
  line_tap_from_nira_bus_id?: InputMaybe<Order_By>;
  line_tap_to_bus?: InputMaybe<Order_By>;
  line_tap_to_nira_bus_id?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  model_set_id?: InputMaybe<Order_By>;
  poi_bus?: InputMaybe<Order_By>;
  poi_nira_bus_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Queue_Project_Connection_Points_Min_Fields = {
  __typename?: 'queue_project_connection_points_min_fields';
  county?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  line_tap_circuit_id?: Maybe<Scalars['String']['output']>;
  line_tap_from_bus?: Maybe<Scalars['String']['output']>;
  line_tap_from_nira_bus_id?: Maybe<Scalars['String']['output']>;
  line_tap_to_bus?: Maybe<Scalars['String']['output']>;
  line_tap_to_nira_bus_id?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  model_set_id?: Maybe<Scalars['uuid']['output']>;
  poi_bus?: Maybe<Scalars['String']['output']>;
  poi_nira_bus_id?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Min_Order_By = {
  county?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  line_tap_circuit_id?: InputMaybe<Order_By>;
  line_tap_from_bus?: InputMaybe<Order_By>;
  line_tap_from_nira_bus_id?: InputMaybe<Order_By>;
  line_tap_to_bus?: InputMaybe<Order_By>;
  line_tap_to_nira_bus_id?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  model_set_id?: InputMaybe<Order_By>;
  poi_bus?: InputMaybe<Order_By>;
  poi_nira_bus_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Mutation_Response = {
  __typename?: 'queue_project_connection_points_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Queue_Project_Connection_Points>;
};

/** on_conflict condition type for table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_On_Conflict = {
  constraint: Queue_Project_Connection_Points_Constraint;
  update_columns?: Array<Queue_Project_Connection_Points_Update_Column>;
  where?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
};

/** Ordering options when selecting data from "queue_project_connection_points". */
export type Queue_Project_Connection_Points_Order_By = {
  cluster_model_sets_aggregate?: InputMaybe<In_Queue_Cluster_Model_Sets_Aggregate_Order_By>;
  connection_type?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  line_tap_circuit_id?: InputMaybe<Order_By>;
  line_tap_from_bus?: InputMaybe<Order_By>;
  line_tap_from_bus_location?: InputMaybe<Buses_Order_By>;
  line_tap_from_nira_bus_id?: InputMaybe<Order_By>;
  line_tap_to_bus?: InputMaybe<Order_By>;
  line_tap_to_bus_location?: InputMaybe<Buses_Order_By>;
  line_tap_to_nira_bus_id?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  model_set_id?: InputMaybe<Order_By>;
  poi_bus?: InputMaybe<Order_By>;
  poi_bus_location?: InputMaybe<Buses_Order_By>;
  poi_nira_bus_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: queue_project_connection_points */
export type Queue_Project_Connection_Points_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "queue_project_connection_points" */
export enum Queue_Project_Connection_Points_Select_Column {
  /** column name */
  ConnectionType = 'connection_type',
  /** column name */
  County = 'county',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LineTapCircuitId = 'line_tap_circuit_id',
  /** column name */
  LineTapFromBus = 'line_tap_from_bus',
  /** column name */
  LineTapFromNiraBusId = 'line_tap_from_nira_bus_id',
  /** column name */
  LineTapToBus = 'line_tap_to_bus',
  /** column name */
  LineTapToNiraBusId = 'line_tap_to_nira_bus_id',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  ModelSetId = 'model_set_id',
  /** column name */
  PoiBus = 'poi_bus',
  /** column name */
  PoiNiraBusId = 'poi_nira_bus_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Region = 'region',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Set_Input = {
  connection_type?: InputMaybe<Queue_Project_Connection_Types_Enum>;
  county?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  line_tap_circuit_id?: InputMaybe<Scalars['String']['input']>;
  line_tap_from_bus?: InputMaybe<Scalars['String']['input']>;
  line_tap_from_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  line_tap_to_bus?: InputMaybe<Scalars['String']['input']>;
  line_tap_to_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  poi_bus?: InputMaybe<Scalars['String']['input']>;
  poi_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Queue_Project_Connection_Points_Stddev_Fields = {
  __typename?: 'queue_project_connection_points_stddev_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Stddev_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Queue_Project_Connection_Points_Stddev_Pop_Fields = {
  __typename?: 'queue_project_connection_points_stddev_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Stddev_Pop_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Queue_Project_Connection_Points_Stddev_Samp_Fields = {
  __typename?: 'queue_project_connection_points_stddev_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Stddev_Samp_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queue_Project_Connection_Points_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queue_Project_Connection_Points_Stream_Cursor_Value_Input = {
  connection_type?: InputMaybe<Queue_Project_Connection_Types_Enum>;
  county?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  line_tap_circuit_id?: InputMaybe<Scalars['String']['input']>;
  line_tap_from_bus?: InputMaybe<Scalars['String']['input']>;
  line_tap_from_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  line_tap_to_bus?: InputMaybe<Scalars['String']['input']>;
  line_tap_to_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  model_set_id?: InputMaybe<Scalars['uuid']['input']>;
  poi_bus?: InputMaybe<Scalars['String']['input']>;
  poi_nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Queue_Project_Connection_Points_Sum_Fields = {
  __typename?: 'queue_project_connection_points_sum_fields';
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Sum_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** update columns of table "queue_project_connection_points" */
export enum Queue_Project_Connection_Points_Update_Column {
  /** column name */
  ConnectionType = 'connection_type',
  /** column name */
  County = 'county',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  LineTapCircuitId = 'line_tap_circuit_id',
  /** column name */
  LineTapFromBus = 'line_tap_from_bus',
  /** column name */
  LineTapFromNiraBusId = 'line_tap_from_nira_bus_id',
  /** column name */
  LineTapToBus = 'line_tap_to_bus',
  /** column name */
  LineTapToNiraBusId = 'line_tap_to_nira_bus_id',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  ModelSetId = 'model_set_id',
  /** column name */
  PoiBus = 'poi_bus',
  /** column name */
  PoiNiraBusId = 'poi_nira_bus_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Region = 'region',
  /** column name */
  State = 'state'
}

export type Queue_Project_Connection_Points_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Queue_Project_Connection_Points_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queue_Project_Connection_Points_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queue_Project_Connection_Points_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Queue_Project_Connection_Points_Var_Pop_Fields = {
  __typename?: 'queue_project_connection_points_var_pop_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Var_Pop_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Queue_Project_Connection_Points_Var_Samp_Fields = {
  __typename?: 'queue_project_connection_points_var_samp_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Var_Samp_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Queue_Project_Connection_Points_Variance_Fields = {
  __typename?: 'queue_project_connection_points_variance_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "queue_project_connection_points" */
export type Queue_Project_Connection_Points_Variance_Order_By = {
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** columns and relationships of "queue_project_connection_types" */
export type Queue_Project_Connection_Types = {
  __typename?: 'queue_project_connection_types';
  connection_type: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

/** aggregated selection of "queue_project_connection_types" */
export type Queue_Project_Connection_Types_Aggregate = {
  __typename?: 'queue_project_connection_types_aggregate';
  aggregate?: Maybe<Queue_Project_Connection_Types_Aggregate_Fields>;
  nodes: Array<Queue_Project_Connection_Types>;
};

/** aggregate fields of "queue_project_connection_types" */
export type Queue_Project_Connection_Types_Aggregate_Fields = {
  __typename?: 'queue_project_connection_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Queue_Project_Connection_Types_Max_Fields>;
  min?: Maybe<Queue_Project_Connection_Types_Min_Fields>;
};


/** aggregate fields of "queue_project_connection_types" */
export type Queue_Project_Connection_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queue_Project_Connection_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "queue_project_connection_types". All fields are combined with a logical 'AND'. */
export type Queue_Project_Connection_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Queue_Project_Connection_Types_Bool_Exp>>;
  _not?: InputMaybe<Queue_Project_Connection_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Queue_Project_Connection_Types_Bool_Exp>>;
  connection_type?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "queue_project_connection_types" */
export enum Queue_Project_Connection_Types_Constraint {
  /** unique or primary key constraint on columns "connection_type" */
  QueueProjectConnectionTypesPkey = 'queue_project_connection_types_pkey'
}

export enum Queue_Project_Connection_Types_Enum {
  /** At a single grid bus */
  Bus = 'BUS',
  /** At three or more grid buses that do not pair into one tapped line */
  Junction = 'JUNCTION',
  /** On a tapped line between two grid buses */
  LineTap = 'LINE_TAP'
}

/** Boolean expression to compare columns of type "queue_project_connection_types_enum". All fields are combined with logical 'AND'. */
export type Queue_Project_Connection_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Queue_Project_Connection_Types_Enum>;
  _in?: InputMaybe<Array<Queue_Project_Connection_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Queue_Project_Connection_Types_Enum>;
  _nin?: InputMaybe<Array<Queue_Project_Connection_Types_Enum>>;
};

/** input type for inserting data into table "queue_project_connection_types" */
export type Queue_Project_Connection_Types_Insert_Input = {
  connection_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Queue_Project_Connection_Types_Max_Fields = {
  __typename?: 'queue_project_connection_types_max_fields';
  connection_type?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Queue_Project_Connection_Types_Min_Fields = {
  __typename?: 'queue_project_connection_types_min_fields';
  connection_type?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "queue_project_connection_types" */
export type Queue_Project_Connection_Types_Mutation_Response = {
  __typename?: 'queue_project_connection_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Queue_Project_Connection_Types>;
};

/** on_conflict condition type for table "queue_project_connection_types" */
export type Queue_Project_Connection_Types_On_Conflict = {
  constraint: Queue_Project_Connection_Types_Constraint;
  update_columns?: Array<Queue_Project_Connection_Types_Update_Column>;
  where?: InputMaybe<Queue_Project_Connection_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "queue_project_connection_types". */
export type Queue_Project_Connection_Types_Order_By = {
  connection_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
};

/** primary key columns input for table: queue_project_connection_types */
export type Queue_Project_Connection_Types_Pk_Columns_Input = {
  connection_type: Scalars['String']['input'];
};

/** select columns of table "queue_project_connection_types" */
export enum Queue_Project_Connection_Types_Select_Column {
  /** column name */
  ConnectionType = 'connection_type',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "queue_project_connection_types" */
export type Queue_Project_Connection_Types_Set_Input = {
  connection_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "queue_project_connection_types" */
export type Queue_Project_Connection_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queue_Project_Connection_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queue_Project_Connection_Types_Stream_Cursor_Value_Input = {
  connection_type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "queue_project_connection_types" */
export enum Queue_Project_Connection_Types_Update_Column {
  /** column name */
  ConnectionType = 'connection_type',
  /** column name */
  Description = 'description'
}

export type Queue_Project_Connection_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queue_Project_Connection_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queue_Project_Connection_Types_Bool_Exp;
};

/** columns and relationships of "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax = {
  __typename?: 'queue_project_facility_dfax';
  contingency: Scalars['String']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax: Scalars['numeric']['output'];
  monitored_facility_id: Scalars['String']['output'];
  project_number: Scalars['String']['output'];
  /** An object relationship */
  queue_project?: Maybe<Queue_Projects>;
  region: Scalars['String']['output'];
};

/** aggregated selection of "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Aggregate = {
  __typename?: 'queue_project_facility_dfax_aggregate';
  aggregate?: Maybe<Queue_Project_Facility_Dfax_Aggregate_Fields>;
  nodes: Array<Queue_Project_Facility_Dfax>;
};

export type Queue_Project_Facility_Dfax_Aggregate_Bool_Exp = {
  count?: InputMaybe<Queue_Project_Facility_Dfax_Aggregate_Bool_Exp_Count>;
};

export type Queue_Project_Facility_Dfax_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Queue_Project_Facility_Dfax_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Aggregate_Fields = {
  __typename?: 'queue_project_facility_dfax_aggregate_fields';
  avg?: Maybe<Queue_Project_Facility_Dfax_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Queue_Project_Facility_Dfax_Max_Fields>;
  min?: Maybe<Queue_Project_Facility_Dfax_Min_Fields>;
  stddev?: Maybe<Queue_Project_Facility_Dfax_Stddev_Fields>;
  stddev_pop?: Maybe<Queue_Project_Facility_Dfax_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Queue_Project_Facility_Dfax_Stddev_Samp_Fields>;
  sum?: Maybe<Queue_Project_Facility_Dfax_Sum_Fields>;
  var_pop?: Maybe<Queue_Project_Facility_Dfax_Var_Pop_Fields>;
  var_samp?: Maybe<Queue_Project_Facility_Dfax_Var_Samp_Fields>;
  variance?: Maybe<Queue_Project_Facility_Dfax_Variance_Fields>;
};


/** aggregate fields of "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queue_Project_Facility_Dfax_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Aggregate_Order_By = {
  avg?: InputMaybe<Queue_Project_Facility_Dfax_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Queue_Project_Facility_Dfax_Max_Order_By>;
  min?: InputMaybe<Queue_Project_Facility_Dfax_Min_Order_By>;
  stddev?: InputMaybe<Queue_Project_Facility_Dfax_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Queue_Project_Facility_Dfax_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Queue_Project_Facility_Dfax_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Queue_Project_Facility_Dfax_Sum_Order_By>;
  var_pop?: InputMaybe<Queue_Project_Facility_Dfax_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Queue_Project_Facility_Dfax_Var_Samp_Order_By>;
  variance?: InputMaybe<Queue_Project_Facility_Dfax_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Arr_Rel_Insert_Input = {
  data: Array<Queue_Project_Facility_Dfax_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Queue_Project_Facility_Dfax_On_Conflict>;
};

/** aggregate avg on columns */
export type Queue_Project_Facility_Dfax_Avg_Fields = {
  __typename?: 'queue_project_facility_dfax_avg_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Avg_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "queue_project_facility_dfax". All fields are combined with a logical 'AND'. */
export type Queue_Project_Facility_Dfax_Bool_Exp = {
  _and?: InputMaybe<Array<Queue_Project_Facility_Dfax_Bool_Exp>>;
  _not?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
  _or?: InputMaybe<Array<Queue_Project_Facility_Dfax_Bool_Exp>>;
  contingency?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  dfax?: InputMaybe<Numeric_Comparison_Exp>;
  monitored_facility_id?: InputMaybe<String_Comparison_Exp>;
  project_number?: InputMaybe<String_Comparison_Exp>;
  queue_project?: InputMaybe<Queue_Projects_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "queue_project_facility_dfax" */
export enum Queue_Project_Facility_Dfax_Constraint {
  /** unique or primary key constraint on columns "contingency", "region", "project_number", "monitored_facility_id" */
  QueueProjectFacilityDfaxPkey = 'queue_project_facility_dfax_pkey'
}

/** input type for incrementing numeric columns in table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Inc_Input = {
  dfax?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Insert_Input = {
  contingency?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  project_number?: InputMaybe<Scalars['String']['input']>;
  queue_project?: InputMaybe<Queue_Projects_Obj_Rel_Insert_Input>;
  region?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Queue_Project_Facility_Dfax_Max_Fields = {
  __typename?: 'queue_project_facility_dfax_max_fields';
  contingency?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  project_number?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Max_Order_By = {
  contingency?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  project_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Queue_Project_Facility_Dfax_Min_Fields = {
  __typename?: 'queue_project_facility_dfax_min_fields';
  contingency?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  monitored_facility_id?: Maybe<Scalars['String']['output']>;
  project_number?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Min_Order_By = {
  contingency?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  project_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Mutation_Response = {
  __typename?: 'queue_project_facility_dfax_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Queue_Project_Facility_Dfax>;
};

/** on_conflict condition type for table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_On_Conflict = {
  constraint: Queue_Project_Facility_Dfax_Constraint;
  update_columns?: Array<Queue_Project_Facility_Dfax_Update_Column>;
  where?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
};

/** Ordering options when selecting data from "queue_project_facility_dfax". */
export type Queue_Project_Facility_Dfax_Order_By = {
  contingency?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  monitored_facility_id?: InputMaybe<Order_By>;
  project_number?: InputMaybe<Order_By>;
  queue_project?: InputMaybe<Queue_Projects_Order_By>;
  region?: InputMaybe<Order_By>;
};

/** primary key columns input for table: queue_project_facility_dfax */
export type Queue_Project_Facility_Dfax_Pk_Columns_Input = {
  contingency: Scalars['String']['input'];
  monitored_facility_id: Scalars['String']['input'];
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

/** select columns of table "queue_project_facility_dfax" */
export enum Queue_Project_Facility_Dfax_Select_Column {
  /** column name */
  Contingency = 'contingency',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  ProjectNumber = 'project_number',
  /** column name */
  Region = 'region'
}

/** input type for updating data in table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Set_Input = {
  contingency?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  project_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Queue_Project_Facility_Dfax_Stddev_Fields = {
  __typename?: 'queue_project_facility_dfax_stddev_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Stddev_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Queue_Project_Facility_Dfax_Stddev_Pop_Fields = {
  __typename?: 'queue_project_facility_dfax_stddev_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Stddev_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Queue_Project_Facility_Dfax_Stddev_Samp_Fields = {
  __typename?: 'queue_project_facility_dfax_stddev_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Stddev_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queue_Project_Facility_Dfax_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queue_Project_Facility_Dfax_Stream_Cursor_Value_Input = {
  contingency?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  monitored_facility_id?: InputMaybe<Scalars['String']['input']>;
  project_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Queue_Project_Facility_Dfax_Sum_Fields = {
  __typename?: 'queue_project_facility_dfax_sum_fields';
  dfax?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Sum_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** update columns of table "queue_project_facility_dfax" */
export enum Queue_Project_Facility_Dfax_Update_Column {
  /** column name */
  Contingency = 'contingency',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  MonitoredFacilityId = 'monitored_facility_id',
  /** column name */
  ProjectNumber = 'project_number',
  /** column name */
  Region = 'region'
}

export type Queue_Project_Facility_Dfax_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Queue_Project_Facility_Dfax_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queue_Project_Facility_Dfax_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queue_Project_Facility_Dfax_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Queue_Project_Facility_Dfax_Var_Pop_Fields = {
  __typename?: 'queue_project_facility_dfax_var_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Var_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Queue_Project_Facility_Dfax_Var_Samp_Fields = {
  __typename?: 'queue_project_facility_dfax_var_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Var_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Queue_Project_Facility_Dfax_Variance_Fields = {
  __typename?: 'queue_project_facility_dfax_variance_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "queue_project_facility_dfax" */
export type Queue_Project_Facility_Dfax_Variance_Order_By = {
  dfax?: InputMaybe<Order_By>;
};

/** columns and relationships of "queue_project_hops" */
export type Queue_Project_Hops = {
  __typename?: 'queue_project_hops';
  bus_id: Scalars['String']['output'];
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id: Scalars['String']['output'];
  num_hops: Scalars['Int']['output'];
  project_number: Scalars['String']['output'];
  /** An object relationship */
  queue_project?: Maybe<Queue_Projects>;
  region: Scalars['String']['output'];
  scope_view: Scalars['String']['output'];
};

/** aggregated selection of "queue_project_hops" */
export type Queue_Project_Hops_Aggregate = {
  __typename?: 'queue_project_hops_aggregate';
  aggregate?: Maybe<Queue_Project_Hops_Aggregate_Fields>;
  nodes: Array<Queue_Project_Hops>;
};

export type Queue_Project_Hops_Aggregate_Bool_Exp = {
  count?: InputMaybe<Queue_Project_Hops_Aggregate_Bool_Exp_Count>;
};

export type Queue_Project_Hops_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Queue_Project_Hops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "queue_project_hops" */
export type Queue_Project_Hops_Aggregate_Fields = {
  __typename?: 'queue_project_hops_aggregate_fields';
  avg?: Maybe<Queue_Project_Hops_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Queue_Project_Hops_Max_Fields>;
  min?: Maybe<Queue_Project_Hops_Min_Fields>;
  stddev?: Maybe<Queue_Project_Hops_Stddev_Fields>;
  stddev_pop?: Maybe<Queue_Project_Hops_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Queue_Project_Hops_Stddev_Samp_Fields>;
  sum?: Maybe<Queue_Project_Hops_Sum_Fields>;
  var_pop?: Maybe<Queue_Project_Hops_Var_Pop_Fields>;
  var_samp?: Maybe<Queue_Project_Hops_Var_Samp_Fields>;
  variance?: Maybe<Queue_Project_Hops_Variance_Fields>;
};


/** aggregate fields of "queue_project_hops" */
export type Queue_Project_Hops_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queue_Project_Hops_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "queue_project_hops" */
export type Queue_Project_Hops_Aggregate_Order_By = {
  avg?: InputMaybe<Queue_Project_Hops_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Queue_Project_Hops_Max_Order_By>;
  min?: InputMaybe<Queue_Project_Hops_Min_Order_By>;
  stddev?: InputMaybe<Queue_Project_Hops_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Queue_Project_Hops_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Queue_Project_Hops_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Queue_Project_Hops_Sum_Order_By>;
  var_pop?: InputMaybe<Queue_Project_Hops_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Queue_Project_Hops_Var_Samp_Order_By>;
  variance?: InputMaybe<Queue_Project_Hops_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "queue_project_hops" */
export type Queue_Project_Hops_Arr_Rel_Insert_Input = {
  data: Array<Queue_Project_Hops_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Queue_Project_Hops_On_Conflict>;
};

/** aggregate avg on columns */
export type Queue_Project_Hops_Avg_Fields = {
  __typename?: 'queue_project_hops_avg_fields';
  num_hops?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Avg_Order_By = {
  num_hops?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "queue_project_hops". All fields are combined with a logical 'AND'. */
export type Queue_Project_Hops_Bool_Exp = {
  _and?: InputMaybe<Array<Queue_Project_Hops_Bool_Exp>>;
  _not?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
  _or?: InputMaybe<Array<Queue_Project_Hops_Bool_Exp>>;
  bus_id?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  num_hops?: InputMaybe<Int_Comparison_Exp>;
  project_number?: InputMaybe<String_Comparison_Exp>;
  queue_project?: InputMaybe<Queue_Projects_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "queue_project_hops" */
export enum Queue_Project_Hops_Constraint {
  /** unique or primary key constraint on columns "nira_bus_id", "scope_view", "region", "project_number" */
  QueueProjectHopsPkey = 'queue_project_hops_pkey'
}

/** input type for incrementing numeric columns in table "queue_project_hops" */
export type Queue_Project_Hops_Inc_Input = {
  num_hops?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "queue_project_hops" */
export type Queue_Project_Hops_Insert_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  num_hops?: InputMaybe<Scalars['Int']['input']>;
  project_number?: InputMaybe<Scalars['String']['input']>;
  queue_project?: InputMaybe<Queue_Projects_Obj_Rel_Insert_Input>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Queue_Project_Hops_Max_Fields = {
  __typename?: 'queue_project_hops_max_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  num_hops?: Maybe<Scalars['Int']['output']>;
  project_number?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Max_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  num_hops?: InputMaybe<Order_By>;
  project_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Queue_Project_Hops_Min_Fields = {
  __typename?: 'queue_project_hops_min_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  num_hops?: Maybe<Scalars['Int']['output']>;
  project_number?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Min_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  num_hops?: InputMaybe<Order_By>;
  project_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "queue_project_hops" */
export type Queue_Project_Hops_Mutation_Response = {
  __typename?: 'queue_project_hops_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Queue_Project_Hops>;
};

/** on_conflict condition type for table "queue_project_hops" */
export type Queue_Project_Hops_On_Conflict = {
  constraint: Queue_Project_Hops_Constraint;
  update_columns?: Array<Queue_Project_Hops_Update_Column>;
  where?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
};

/** Ordering options when selecting data from "queue_project_hops". */
export type Queue_Project_Hops_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  num_hops?: InputMaybe<Order_By>;
  project_number?: InputMaybe<Order_By>;
  queue_project?: InputMaybe<Queue_Projects_Order_By>;
  region?: InputMaybe<Order_By>;
  scope_view?: InputMaybe<Order_By>;
};

/** primary key columns input for table: queue_project_hops */
export type Queue_Project_Hops_Pk_Columns_Input = {
  nira_bus_id: Scalars['String']['input'];
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};

/** select columns of table "queue_project_hops" */
export enum Queue_Project_Hops_Select_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  NumHops = 'num_hops',
  /** column name */
  ProjectNumber = 'project_number',
  /** column name */
  Region = 'region',
  /** column name */
  ScopeView = 'scope_view'
}

/** input type for updating data in table "queue_project_hops" */
export type Queue_Project_Hops_Set_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  num_hops?: InputMaybe<Scalars['Int']['input']>;
  project_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Queue_Project_Hops_Stddev_Fields = {
  __typename?: 'queue_project_hops_stddev_fields';
  num_hops?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Stddev_Order_By = {
  num_hops?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Queue_Project_Hops_Stddev_Pop_Fields = {
  __typename?: 'queue_project_hops_stddev_pop_fields';
  num_hops?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Stddev_Pop_Order_By = {
  num_hops?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Queue_Project_Hops_Stddev_Samp_Fields = {
  __typename?: 'queue_project_hops_stddev_samp_fields';
  num_hops?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Stddev_Samp_Order_By = {
  num_hops?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "queue_project_hops" */
export type Queue_Project_Hops_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queue_Project_Hops_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queue_Project_Hops_Stream_Cursor_Value_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  num_hops?: InputMaybe<Scalars['Int']['input']>;
  project_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Queue_Project_Hops_Sum_Fields = {
  __typename?: 'queue_project_hops_sum_fields';
  num_hops?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Sum_Order_By = {
  num_hops?: InputMaybe<Order_By>;
};

/** update columns of table "queue_project_hops" */
export enum Queue_Project_Hops_Update_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  NumHops = 'num_hops',
  /** column name */
  ProjectNumber = 'project_number',
  /** column name */
  Region = 'region',
  /** column name */
  ScopeView = 'scope_view'
}

export type Queue_Project_Hops_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Queue_Project_Hops_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queue_Project_Hops_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queue_Project_Hops_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Queue_Project_Hops_Var_Pop_Fields = {
  __typename?: 'queue_project_hops_var_pop_fields';
  num_hops?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Var_Pop_Order_By = {
  num_hops?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Queue_Project_Hops_Var_Samp_Fields = {
  __typename?: 'queue_project_hops_var_samp_fields';
  num_hops?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Var_Samp_Order_By = {
  num_hops?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Queue_Project_Hops_Variance_Fields = {
  __typename?: 'queue_project_hops_variance_fields';
  num_hops?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "queue_project_hops" */
export type Queue_Project_Hops_Variance_Order_By = {
  num_hops?: InputMaybe<Order_By>;
};

/** columns and relationships of "queue_projects" */
export type Queue_Projects = {
  __typename?: 'queue_projects';
  bus_id?: Maybe<Scalars['String']['output']>;
  charging_capacity_mw?: Maybe<Scalars['float8']['output']>;
  cluster?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  eris_capacity_mw: Scalars['numeric']['output'];
  facility_id?: Maybe<Scalars['String']['output']>;
  fuel_type: Scalars['String']['output'];
  included: Scalars['Boolean']['output'];
  is_speculative: Scalars['Boolean']['output'];
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  poi_description: Scalars['String']['output'];
  project_number: Scalars['String']['output'];
  region: Scalars['String']['output'];
  /** An array relationship */
  region_subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  region_subscriptions_aggregate: Subscriptions_Aggregate;
  scope: Scalars['String']['output'];
  /** An object relationship */
  scope_info?: Maybe<Scopes>;
  scope_view: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  sub_region: Scalars['String']['output'];
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
};


/** columns and relationships of "queue_projects" */
export type Queue_ProjectsRegion_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "queue_projects" */
export type Queue_ProjectsRegion_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "queue_projects" */
export type Queue_ProjectsUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "queue_projects" */
export type Queue_ProjectsUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "queue_projects" */
export type Queue_Projects_Aggregate = {
  __typename?: 'queue_projects_aggregate';
  aggregate?: Maybe<Queue_Projects_Aggregate_Fields>;
  nodes: Array<Queue_Projects>;
};

/** aggregate fields of "queue_projects" */
export type Queue_Projects_Aggregate_Fields = {
  __typename?: 'queue_projects_aggregate_fields';
  avg?: Maybe<Queue_Projects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Queue_Projects_Max_Fields>;
  min?: Maybe<Queue_Projects_Min_Fields>;
  stddev?: Maybe<Queue_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Queue_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Queue_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Queue_Projects_Sum_Fields>;
  var_pop?: Maybe<Queue_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Queue_Projects_Var_Samp_Fields>;
  variance?: Maybe<Queue_Projects_Variance_Fields>;
};


/** aggregate fields of "queue_projects" */
export type Queue_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Queue_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Queue_Projects_Avg_Fields = {
  __typename?: 'queue_projects_avg_fields';
  charging_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "queue_projects". All fields are combined with a logical 'AND'. */
export type Queue_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Queue_Projects_Bool_Exp>>;
  _not?: InputMaybe<Queue_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Queue_Projects_Bool_Exp>>;
  bus_id?: InputMaybe<String_Comparison_Exp>;
  charging_capacity_mw?: InputMaybe<Float8_Comparison_Exp>;
  cluster?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  eris_capacity_mw?: InputMaybe<Numeric_Comparison_Exp>;
  facility_id?: InputMaybe<String_Comparison_Exp>;
  fuel_type?: InputMaybe<String_Comparison_Exp>;
  included?: InputMaybe<Boolean_Comparison_Exp>;
  is_speculative?: InputMaybe<Boolean_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  nris_capacity_mw?: InputMaybe<Numeric_Comparison_Exp>;
  poi_description?: InputMaybe<String_Comparison_Exp>;
  project_number?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  region_subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  region_subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_info?: InputMaybe<Scopes_Bool_Exp>;
  scope_view?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  sub_region?: InputMaybe<String_Comparison_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "queue_projects" */
export enum Queue_Projects_Constraint {
  /** unique or primary key constraint on columns "scope", "scope_view", "region", "project_number" */
  QueueProjectsPkey = 'queue_projects_pkey'
}

/** input type for incrementing numeric columns in table "queue_projects" */
export type Queue_Projects_Inc_Input = {
  charging_capacity_mw?: InputMaybe<Scalars['float8']['input']>;
  eris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  nris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "queue_projects" */
export type Queue_Projects_Insert_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  charging_capacity_mw?: InputMaybe<Scalars['float8']['input']>;
  cluster?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  eris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  included?: InputMaybe<Scalars['Boolean']['input']>;
  is_speculative?: InputMaybe<Scalars['Boolean']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  nris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  poi_description?: InputMaybe<Scalars['String']['input']>;
  project_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  region_subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_info?: InputMaybe<Scopes_Obj_Rel_Insert_Input>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_region?: InputMaybe<Scalars['String']['input']>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Queue_Projects_Max_Fields = {
  __typename?: 'queue_projects_max_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  charging_capacity_mw?: Maybe<Scalars['float8']['output']>;
  cluster?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  poi_description?: Maybe<Scalars['String']['output']>;
  project_number?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_region?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Queue_Projects_Min_Fields = {
  __typename?: 'queue_projects_min_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  charging_capacity_mw?: Maybe<Scalars['float8']['output']>;
  cluster?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  fuel_type?: Maybe<Scalars['String']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  poi_description?: Maybe<Scalars['String']['output']>;
  project_number?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scope_view?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_region?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "queue_projects" */
export type Queue_Projects_Mutation_Response = {
  __typename?: 'queue_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Queue_Projects>;
};

/** input type for inserting object relation for remote table "queue_projects" */
export type Queue_Projects_Obj_Rel_Insert_Input = {
  data: Queue_Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Queue_Projects_On_Conflict>;
};

/** on_conflict condition type for table "queue_projects" */
export type Queue_Projects_On_Conflict = {
  constraint: Queue_Projects_Constraint;
  update_columns?: Array<Queue_Projects_Update_Column>;
  where?: InputMaybe<Queue_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "queue_projects". */
export type Queue_Projects_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  charging_capacity_mw?: InputMaybe<Order_By>;
  cluster?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  eris_capacity_mw?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  fuel_type?: InputMaybe<Order_By>;
  included?: InputMaybe<Order_By>;
  is_speculative?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  nris_capacity_mw?: InputMaybe<Order_By>;
  poi_description?: InputMaybe<Order_By>;
  project_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  region_subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_info?: InputMaybe<Scopes_Order_By>;
  scope_view?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_region?: InputMaybe<Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: queue_projects */
export type Queue_Projects_Pk_Columns_Input = {
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};

/** select columns of table "queue_projects" */
export enum Queue_Projects_Select_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  ChargingCapacityMw = 'charging_capacity_mw',
  /** column name */
  Cluster = 'cluster',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  ErisCapacityMw = 'eris_capacity_mw',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FuelType = 'fuel_type',
  /** column name */
  Included = 'included',
  /** column name */
  IsSpeculative = 'is_speculative',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  NrisCapacityMw = 'nris_capacity_mw',
  /** column name */
  PoiDescription = 'poi_description',
  /** column name */
  ProjectNumber = 'project_number',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  Status = 'status',
  /** column name */
  SubRegion = 'sub_region'
}

/** input type for updating data in table "queue_projects" */
export type Queue_Projects_Set_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  charging_capacity_mw?: InputMaybe<Scalars['float8']['input']>;
  cluster?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  eris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  included?: InputMaybe<Scalars['Boolean']['input']>;
  is_speculative?: InputMaybe<Scalars['Boolean']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  nris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  poi_description?: InputMaybe<Scalars['String']['input']>;
  project_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_region?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Queue_Projects_Stddev_Fields = {
  __typename?: 'queue_projects_stddev_fields';
  charging_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Queue_Projects_Stddev_Pop_Fields = {
  __typename?: 'queue_projects_stddev_pop_fields';
  charging_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Queue_Projects_Stddev_Samp_Fields = {
  __typename?: 'queue_projects_stddev_samp_fields';
  charging_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "queue_projects" */
export type Queue_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Queue_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Queue_Projects_Stream_Cursor_Value_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  charging_capacity_mw?: InputMaybe<Scalars['float8']['input']>;
  cluster?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  eris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  fuel_type?: InputMaybe<Scalars['String']['input']>;
  included?: InputMaybe<Scalars['Boolean']['input']>;
  is_speculative?: InputMaybe<Scalars['Boolean']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  nris_capacity_mw?: InputMaybe<Scalars['numeric']['input']>;
  poi_description?: InputMaybe<Scalars['String']['input']>;
  project_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_view?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sub_region?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Queue_Projects_Sum_Fields = {
  __typename?: 'queue_projects_sum_fields';
  charging_capacity_mw?: Maybe<Scalars['float8']['output']>;
  eris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
  nris_capacity_mw?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "queue_projects" */
export enum Queue_Projects_Update_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  ChargingCapacityMw = 'charging_capacity_mw',
  /** column name */
  Cluster = 'cluster',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  ErisCapacityMw = 'eris_capacity_mw',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FuelType = 'fuel_type',
  /** column name */
  Included = 'included',
  /** column name */
  IsSpeculative = 'is_speculative',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  NrisCapacityMw = 'nris_capacity_mw',
  /** column name */
  PoiDescription = 'poi_description',
  /** column name */
  ProjectNumber = 'project_number',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeView = 'scope_view',
  /** column name */
  Status = 'status',
  /** column name */
  SubRegion = 'sub_region'
}

export type Queue_Projects_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Queue_Projects_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Queue_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Queue_Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Queue_Projects_Var_Pop_Fields = {
  __typename?: 'queue_projects_var_pop_fields';
  charging_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Queue_Projects_Var_Samp_Fields = {
  __typename?: 'queue_projects_var_samp_fields';
  charging_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Queue_Projects_Variance_Fields = {
  __typename?: 'queue_projects_variance_fields';
  charging_capacity_mw?: Maybe<Scalars['Float']['output']>;
  eris_capacity_mw?: Maybe<Scalars['Float']['output']>;
  nris_capacity_mw?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades = {
  __typename?: 'scenario_allocated_upgrades';
  allocated_cost: Scalars['numeric']['output'];
  constraint_type: Constraint_Types_Enum;
  max_dfax: Scalars['numeric']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  monitored_facility_names: Scalars['jsonb']['output'];
  network_upgrade_id: Scalars['String']['output'];
  network_upgrade_name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  percent_allocation?: Maybe<Scalars['numeric']['output']>;
  project_id: Scalars['String']['output'];
  /** An object relationship */
  scenario: Scenarios;
  scenario_id: Scalars['uuid']['output'];
  sum_mw_impact: Scalars['numeric']['output'];
  total_cost: Scalars['numeric']['output'];
};


/** columns and relationships of "scenario_allocated_upgrades" */
export type Scenario_Allocated_UpgradesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenario_allocated_upgrades" */
export type Scenario_Allocated_UpgradesMonitored_Facility_NamesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Aggregate = {
  __typename?: 'scenario_allocated_upgrades_aggregate';
  aggregate?: Maybe<Scenario_Allocated_Upgrades_Aggregate_Fields>;
  nodes: Array<Scenario_Allocated_Upgrades>;
};

export type Scenario_Allocated_Upgrades_Aggregate_Bool_Exp = {
  count?: InputMaybe<Scenario_Allocated_Upgrades_Aggregate_Bool_Exp_Count>;
};

export type Scenario_Allocated_Upgrades_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenario_Allocated_Upgrades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Aggregate_Fields = {
  __typename?: 'scenario_allocated_upgrades_aggregate_fields';
  avg?: Maybe<Scenario_Allocated_Upgrades_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Allocated_Upgrades_Max_Fields>;
  min?: Maybe<Scenario_Allocated_Upgrades_Min_Fields>;
  stddev?: Maybe<Scenario_Allocated_Upgrades_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Allocated_Upgrades_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Allocated_Upgrades_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Allocated_Upgrades_Sum_Fields>;
  var_pop?: Maybe<Scenario_Allocated_Upgrades_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Allocated_Upgrades_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Allocated_Upgrades_Variance_Fields>;
};


/** aggregate fields of "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Allocated_Upgrades_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Aggregate_Order_By = {
  avg?: InputMaybe<Scenario_Allocated_Upgrades_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenario_Allocated_Upgrades_Max_Order_By>;
  min?: InputMaybe<Scenario_Allocated_Upgrades_Min_Order_By>;
  stddev?: InputMaybe<Scenario_Allocated_Upgrades_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Scenario_Allocated_Upgrades_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Scenario_Allocated_Upgrades_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Scenario_Allocated_Upgrades_Sum_Order_By>;
  var_pop?: InputMaybe<Scenario_Allocated_Upgrades_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Scenario_Allocated_Upgrades_Var_Samp_Order_By>;
  variance?: InputMaybe<Scenario_Allocated_Upgrades_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Scenario_Allocated_Upgrades_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  monitored_facility_names?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Arr_Rel_Insert_Input = {
  data: Array<Scenario_Allocated_Upgrades_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Scenario_Allocated_Upgrades_On_Conflict>;
};

/** aggregate avg on columns */
export type Scenario_Allocated_Upgrades_Avg_Fields = {
  __typename?: 'scenario_allocated_upgrades_avg_fields';
  allocated_cost?: Maybe<Scalars['Float']['output']>;
  max_dfax?: Maybe<Scalars['Float']['output']>;
  percent_allocation?: Maybe<Scalars['Float']['output']>;
  sum_mw_impact?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Avg_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scenario_allocated_upgrades". All fields are combined with a logical 'AND'. */
export type Scenario_Allocated_Upgrades_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Allocated_Upgrades_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Allocated_Upgrades_Bool_Exp>>;
  allocated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  constraint_type?: InputMaybe<Constraint_Types_Enum_Comparison_Exp>;
  max_dfax?: InputMaybe<Numeric_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  monitored_facility_names?: InputMaybe<Jsonb_Comparison_Exp>;
  network_upgrade_id?: InputMaybe<String_Comparison_Exp>;
  network_upgrade_name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  percent_allocation?: InputMaybe<Numeric_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  scenario?: InputMaybe<Scenarios_Bool_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  sum_mw_impact?: InputMaybe<Numeric_Comparison_Exp>;
  total_cost?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "scenario_allocated_upgrades" */
export enum Scenario_Allocated_Upgrades_Constraint {
  /** unique or primary key constraint on columns "constraint_type", "project_id", "network_upgrade_id", "scenario_id" */
  ScenarioAllocatedUpgradesPkey = 'scenario_allocated_upgrades_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Scenario_Allocated_Upgrades_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  monitored_facility_names?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Scenario_Allocated_Upgrades_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
  monitored_facility_names?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Scenario_Allocated_Upgrades_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_names?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Inc_Input = {
  allocated_cost?: InputMaybe<Scalars['numeric']['input']>;
  max_dfax?: InputMaybe<Scalars['numeric']['input']>;
  percent_allocation?: InputMaybe<Scalars['numeric']['input']>;
  sum_mw_impact?: InputMaybe<Scalars['numeric']['input']>;
  total_cost?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Insert_Input = {
  allocated_cost?: InputMaybe<Scalars['numeric']['input']>;
  constraint_type?: InputMaybe<Constraint_Types_Enum>;
  max_dfax?: InputMaybe<Scalars['numeric']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  monitored_facility_names?: InputMaybe<Scalars['jsonb']['input']>;
  network_upgrade_id?: InputMaybe<Scalars['String']['input']>;
  network_upgrade_name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  percent_allocation?: InputMaybe<Scalars['numeric']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  scenario?: InputMaybe<Scenarios_Obj_Rel_Insert_Input>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  sum_mw_impact?: InputMaybe<Scalars['numeric']['input']>;
  total_cost?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Scenario_Allocated_Upgrades_Max_Fields = {
  __typename?: 'scenario_allocated_upgrades_max_fields';
  allocated_cost?: Maybe<Scalars['numeric']['output']>;
  max_dfax?: Maybe<Scalars['numeric']['output']>;
  network_upgrade_id?: Maybe<Scalars['String']['output']>;
  network_upgrade_name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  percent_allocation?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  sum_mw_impact?: Maybe<Scalars['numeric']['output']>;
  total_cost?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Max_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  network_upgrade_id?: InputMaybe<Order_By>;
  network_upgrade_name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenario_Allocated_Upgrades_Min_Fields = {
  __typename?: 'scenario_allocated_upgrades_min_fields';
  allocated_cost?: Maybe<Scalars['numeric']['output']>;
  max_dfax?: Maybe<Scalars['numeric']['output']>;
  network_upgrade_id?: Maybe<Scalars['String']['output']>;
  network_upgrade_name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  percent_allocation?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  sum_mw_impact?: Maybe<Scalars['numeric']['output']>;
  total_cost?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Min_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  network_upgrade_id?: InputMaybe<Order_By>;
  network_upgrade_name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Mutation_Response = {
  __typename?: 'scenario_allocated_upgrades_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenario_Allocated_Upgrades>;
};

/** on_conflict condition type for table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_On_Conflict = {
  constraint: Scenario_Allocated_Upgrades_Constraint;
  update_columns?: Array<Scenario_Allocated_Upgrades_Update_Column>;
  where?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
};

/** Ordering options when selecting data from "scenario_allocated_upgrades". */
export type Scenario_Allocated_Upgrades_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  constraint_type?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  monitored_facility_names?: InputMaybe<Order_By>;
  network_upgrade_id?: InputMaybe<Order_By>;
  network_upgrade_name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  scenario?: InputMaybe<Scenarios_Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scenario_allocated_upgrades */
export type Scenario_Allocated_Upgrades_Pk_Columns_Input = {
  constraint_type: Constraint_Types_Enum;
  network_upgrade_id: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Scenario_Allocated_Upgrades_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  monitored_facility_names?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "scenario_allocated_upgrades" */
export enum Scenario_Allocated_Upgrades_Select_Column {
  /** column name */
  AllocatedCost = 'allocated_cost',
  /** column name */
  ConstraintType = 'constraint_type',
  /** column name */
  MaxDfax = 'max_dfax',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MonitoredFacilityNames = 'monitored_facility_names',
  /** column name */
  NetworkUpgradeId = 'network_upgrade_id',
  /** column name */
  NetworkUpgradeName = 'network_upgrade_name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PercentAllocation = 'percent_allocation',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  SumMwImpact = 'sum_mw_impact',
  /** column name */
  TotalCost = 'total_cost'
}

/** input type for updating data in table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Set_Input = {
  allocated_cost?: InputMaybe<Scalars['numeric']['input']>;
  constraint_type?: InputMaybe<Constraint_Types_Enum>;
  max_dfax?: InputMaybe<Scalars['numeric']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  monitored_facility_names?: InputMaybe<Scalars['jsonb']['input']>;
  network_upgrade_id?: InputMaybe<Scalars['String']['input']>;
  network_upgrade_name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  percent_allocation?: InputMaybe<Scalars['numeric']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  sum_mw_impact?: InputMaybe<Scalars['numeric']['input']>;
  total_cost?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Scenario_Allocated_Upgrades_Stddev_Fields = {
  __typename?: 'scenario_allocated_upgrades_stddev_fields';
  allocated_cost?: Maybe<Scalars['Float']['output']>;
  max_dfax?: Maybe<Scalars['Float']['output']>;
  percent_allocation?: Maybe<Scalars['Float']['output']>;
  sum_mw_impact?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Stddev_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Allocated_Upgrades_Stddev_Pop_Fields = {
  __typename?: 'scenario_allocated_upgrades_stddev_pop_fields';
  allocated_cost?: Maybe<Scalars['Float']['output']>;
  max_dfax?: Maybe<Scalars['Float']['output']>;
  percent_allocation?: Maybe<Scalars['Float']['output']>;
  sum_mw_impact?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Stddev_Pop_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Allocated_Upgrades_Stddev_Samp_Fields = {
  __typename?: 'scenario_allocated_upgrades_stddev_samp_fields';
  allocated_cost?: Maybe<Scalars['Float']['output']>;
  max_dfax?: Maybe<Scalars['Float']['output']>;
  percent_allocation?: Maybe<Scalars['Float']['output']>;
  sum_mw_impact?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Stddev_Samp_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Allocated_Upgrades_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Allocated_Upgrades_Stream_Cursor_Value_Input = {
  allocated_cost?: InputMaybe<Scalars['numeric']['input']>;
  constraint_type?: InputMaybe<Constraint_Types_Enum>;
  max_dfax?: InputMaybe<Scalars['numeric']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  monitored_facility_names?: InputMaybe<Scalars['jsonb']['input']>;
  network_upgrade_id?: InputMaybe<Scalars['String']['input']>;
  network_upgrade_name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  percent_allocation?: InputMaybe<Scalars['numeric']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  sum_mw_impact?: InputMaybe<Scalars['numeric']['input']>;
  total_cost?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Allocated_Upgrades_Sum_Fields = {
  __typename?: 'scenario_allocated_upgrades_sum_fields';
  allocated_cost?: Maybe<Scalars['numeric']['output']>;
  max_dfax?: Maybe<Scalars['numeric']['output']>;
  percent_allocation?: Maybe<Scalars['numeric']['output']>;
  sum_mw_impact?: Maybe<Scalars['numeric']['output']>;
  total_cost?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Sum_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** update columns of table "scenario_allocated_upgrades" */
export enum Scenario_Allocated_Upgrades_Update_Column {
  /** column name */
  AllocatedCost = 'allocated_cost',
  /** column name */
  ConstraintType = 'constraint_type',
  /** column name */
  MaxDfax = 'max_dfax',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  MonitoredFacilityNames = 'monitored_facility_names',
  /** column name */
  NetworkUpgradeId = 'network_upgrade_id',
  /** column name */
  NetworkUpgradeName = 'network_upgrade_name',
  /** column name */
  Notes = 'notes',
  /** column name */
  PercentAllocation = 'percent_allocation',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  SumMwImpact = 'sum_mw_impact',
  /** column name */
  TotalCost = 'total_cost'
}

export type Scenario_Allocated_Upgrades_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Scenario_Allocated_Upgrades_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Scenario_Allocated_Upgrades_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Scenario_Allocated_Upgrades_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Scenario_Allocated_Upgrades_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scenario_Allocated_Upgrades_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Scenario_Allocated_Upgrades_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scenario_Allocated_Upgrades_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scenario_Allocated_Upgrades_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Scenario_Allocated_Upgrades_Var_Pop_Fields = {
  __typename?: 'scenario_allocated_upgrades_var_pop_fields';
  allocated_cost?: Maybe<Scalars['Float']['output']>;
  max_dfax?: Maybe<Scalars['Float']['output']>;
  percent_allocation?: Maybe<Scalars['Float']['output']>;
  sum_mw_impact?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Var_Pop_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scenario_Allocated_Upgrades_Var_Samp_Fields = {
  __typename?: 'scenario_allocated_upgrades_var_samp_fields';
  allocated_cost?: Maybe<Scalars['Float']['output']>;
  max_dfax?: Maybe<Scalars['Float']['output']>;
  percent_allocation?: Maybe<Scalars['Float']['output']>;
  sum_mw_impact?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Var_Samp_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Scenario_Allocated_Upgrades_Variance_Fields = {
  __typename?: 'scenario_allocated_upgrades_variance_fields';
  allocated_cost?: Maybe<Scalars['Float']['output']>;
  max_dfax?: Maybe<Scalars['Float']['output']>;
  percent_allocation?: Maybe<Scalars['Float']['output']>;
  sum_mw_impact?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "scenario_allocated_upgrades" */
export type Scenario_Allocated_Upgrades_Variance_Order_By = {
  allocated_cost?: InputMaybe<Order_By>;
  max_dfax?: InputMaybe<Order_By>;
  percent_allocation?: InputMaybe<Order_By>;
  sum_mw_impact?: InputMaybe<Order_By>;
  total_cost?: InputMaybe<Order_By>;
};

/** columns and relationships of "scenario_configurations" */
export type Scenario_Configurations = {
  __typename?: 'scenario_configurations';
  archived: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  scenario: Scenarios;
  scenario_id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "scenario_configurations" */
export type Scenario_Configurations_Aggregate = {
  __typename?: 'scenario_configurations_aggregate';
  aggregate?: Maybe<Scenario_Configurations_Aggregate_Fields>;
  nodes: Array<Scenario_Configurations>;
};

/** aggregate fields of "scenario_configurations" */
export type Scenario_Configurations_Aggregate_Fields = {
  __typename?: 'scenario_configurations_aggregate_fields';
  avg?: Maybe<Scenario_Configurations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Configurations_Max_Fields>;
  min?: Maybe<Scenario_Configurations_Min_Fields>;
  stddev?: Maybe<Scenario_Configurations_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Configurations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Configurations_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Configurations_Sum_Fields>;
  var_pop?: Maybe<Scenario_Configurations_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Configurations_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Configurations_Variance_Fields>;
};


/** aggregate fields of "scenario_configurations" */
export type Scenario_Configurations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Configurations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Scenario_Configurations_Avg_Fields = {
  __typename?: 'scenario_configurations_avg_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "scenario_configurations". All fields are combined with a logical 'AND'. */
export type Scenario_Configurations_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Configurations_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Configurations_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Configurations_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  scenario?: InputMaybe<Scenarios_Bool_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "scenario_configurations" */
export enum Scenario_Configurations_Constraint {
  /** unique or primary key constraint on columns "team_id", "scenario_id" */
  ScenarioConfigurationsPkey = 'scenario_configurations_pkey'
}

/** input type for incrementing numeric columns in table "scenario_configurations" */
export type Scenario_Configurations_Inc_Input = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "scenario_configurations" */
export type Scenario_Configurations_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  scenario?: InputMaybe<Scenarios_Obj_Rel_Insert_Input>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Scenario_Configurations_Max_Fields = {
  __typename?: 'scenario_configurations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Scenario_Configurations_Min_Fields = {
  __typename?: 'scenario_configurations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "scenario_configurations" */
export type Scenario_Configurations_Mutation_Response = {
  __typename?: 'scenario_configurations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenario_Configurations>;
};

/** on_conflict condition type for table "scenario_configurations" */
export type Scenario_Configurations_On_Conflict = {
  constraint: Scenario_Configurations_Constraint;
  update_columns?: Array<Scenario_Configurations_Update_Column>;
  where?: InputMaybe<Scenario_Configurations_Bool_Exp>;
};

/** Ordering options when selecting data from "scenario_configurations". */
export type Scenario_Configurations_Order_By = {
  archived?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  scenario?: InputMaybe<Scenarios_Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scenario_configurations */
export type Scenario_Configurations_Pk_Columns_Input = {
  scenario_id: Scalars['uuid']['input'];
  team_id: Scalars['Int']['input'];
};

/** select columns of table "scenario_configurations" */
export enum Scenario_Configurations_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "scenario_configurations" */
export type Scenario_Configurations_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Scenario_Configurations_Stddev_Fields = {
  __typename?: 'scenario_configurations_stddev_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Configurations_Stddev_Pop_Fields = {
  __typename?: 'scenario_configurations_stddev_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Configurations_Stddev_Samp_Fields = {
  __typename?: 'scenario_configurations_stddev_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "scenario_configurations" */
export type Scenario_Configurations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Configurations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Configurations_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Configurations_Sum_Fields = {
  __typename?: 'scenario_configurations_sum_fields';
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "scenario_configurations" */
export enum Scenario_Configurations_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Scenario_Configurations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scenario_Configurations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scenario_Configurations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scenario_Configurations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Scenario_Configurations_Var_Pop_Fields = {
  __typename?: 'scenario_configurations_var_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Scenario_Configurations_Var_Samp_Fields = {
  __typename?: 'scenario_configurations_var_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Scenario_Configurations_Variance_Fields = {
  __typename?: 'scenario_configurations_variance_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "scenario_constraints" */
export type Scenario_Constraints = {
  __typename?: 'scenario_constraints';
  area?: Maybe<Scalars['String']['output']>;
  constraint_type: Constraint_Types_Enum;
  dfax: Scalars['numeric']['output'];
  element_type?: Maybe<Scalars['String']['output']>;
  facility_id: Scalars['String']['output'];
  line_length?: Maybe<Scalars['numeric']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  monitored_facility_name: Scalars['String']['output'];
  mw_impact: Scalars['numeric']['output'];
  network_upgrade_names: Scalars['jsonb']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  post_study_flow?: Maybe<Scalars['String']['output']>;
  post_study_load?: Maybe<Scalars['numeric']['output']>;
  post_study_load_ac?: Maybe<Scalars['String']['output']>;
  post_study_load_dc?: Maybe<Scalars['numeric']['output']>;
  post_study_rating?: Maybe<Scalars['numeric']['output']>;
  pre_study_flow?: Maybe<Scalars['numeric']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  pre_study_rating: Scalars['numeric']['output'];
  project_id: Scalars['String']['output'];
  /** An object relationship */
  scenario: Scenarios;
  scenario_id: Scalars['uuid']['output'];
  voltage?: Maybe<Scalars['String']['output']>;
  worst_contingency_name: Scalars['String']['output'];
};


/** columns and relationships of "scenario_constraints" */
export type Scenario_ConstraintsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenario_constraints" */
export type Scenario_ConstraintsNetwork_Upgrade_NamesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "scenario_constraints" */
export type Scenario_Constraints_Aggregate = {
  __typename?: 'scenario_constraints_aggregate';
  aggregate?: Maybe<Scenario_Constraints_Aggregate_Fields>;
  nodes: Array<Scenario_Constraints>;
};

export type Scenario_Constraints_Aggregate_Bool_Exp = {
  count?: InputMaybe<Scenario_Constraints_Aggregate_Bool_Exp_Count>;
};

export type Scenario_Constraints_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenario_Constraints_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Constraints_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenario_constraints" */
export type Scenario_Constraints_Aggregate_Fields = {
  __typename?: 'scenario_constraints_aggregate_fields';
  avg?: Maybe<Scenario_Constraints_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Constraints_Max_Fields>;
  min?: Maybe<Scenario_Constraints_Min_Fields>;
  stddev?: Maybe<Scenario_Constraints_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Constraints_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Constraints_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Constraints_Sum_Fields>;
  var_pop?: Maybe<Scenario_Constraints_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Constraints_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Constraints_Variance_Fields>;
};


/** aggregate fields of "scenario_constraints" */
export type Scenario_Constraints_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Constraints_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenario_constraints" */
export type Scenario_Constraints_Aggregate_Order_By = {
  avg?: InputMaybe<Scenario_Constraints_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenario_Constraints_Max_Order_By>;
  min?: InputMaybe<Scenario_Constraints_Min_Order_By>;
  stddev?: InputMaybe<Scenario_Constraints_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Scenario_Constraints_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Scenario_Constraints_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Scenario_Constraints_Sum_Order_By>;
  var_pop?: InputMaybe<Scenario_Constraints_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Scenario_Constraints_Var_Samp_Order_By>;
  variance?: InputMaybe<Scenario_Constraints_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Scenario_Constraints_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network_upgrade_names?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "scenario_constraints" */
export type Scenario_Constraints_Arr_Rel_Insert_Input = {
  data: Array<Scenario_Constraints_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Scenario_Constraints_On_Conflict>;
};

/** aggregate avg on columns */
export type Scenario_Constraints_Avg_Fields = {
  __typename?: 'scenario_constraints_avg_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  mw_impact?: Maybe<Scalars['Float']['output']>;
  post_study_load?: Maybe<Scalars['Float']['output']>;
  post_study_load_dc?: Maybe<Scalars['Float']['output']>;
  post_study_rating?: Maybe<Scalars['Float']['output']>;
  pre_study_flow?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  pre_study_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Avg_Order_By = {
  dfax?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scenario_constraints". All fields are combined with a logical 'AND'. */
export type Scenario_Constraints_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Constraints_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Constraints_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Constraints_Bool_Exp>>;
  area?: InputMaybe<String_Comparison_Exp>;
  constraint_type?: InputMaybe<Constraint_Types_Enum_Comparison_Exp>;
  dfax?: InputMaybe<Numeric_Comparison_Exp>;
  element_type?: InputMaybe<String_Comparison_Exp>;
  facility_id?: InputMaybe<String_Comparison_Exp>;
  line_length?: InputMaybe<Numeric_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  monitored_facility_name?: InputMaybe<String_Comparison_Exp>;
  mw_impact?: InputMaybe<Numeric_Comparison_Exp>;
  network_upgrade_names?: InputMaybe<Jsonb_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  post_study_flow?: InputMaybe<String_Comparison_Exp>;
  post_study_load?: InputMaybe<Numeric_Comparison_Exp>;
  post_study_load_ac?: InputMaybe<String_Comparison_Exp>;
  post_study_load_dc?: InputMaybe<Numeric_Comparison_Exp>;
  post_study_rating?: InputMaybe<Numeric_Comparison_Exp>;
  pre_study_flow?: InputMaybe<Numeric_Comparison_Exp>;
  pre_study_load?: InputMaybe<Numeric_Comparison_Exp>;
  pre_study_rating?: InputMaybe<Numeric_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  scenario?: InputMaybe<Scenarios_Bool_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  voltage?: InputMaybe<String_Comparison_Exp>;
  worst_contingency_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "scenario_constraints" */
export enum Scenario_Constraints_Constraint {
  /** unique or primary key constraint on columns "facility_id", "constraint_type", "project_id", "worst_contingency_name", "scenario_id" */
  ScenarioConstraintsPkey = 'scenario_constraints_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Scenario_Constraints_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  network_upgrade_names?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Scenario_Constraints_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
  network_upgrade_names?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Scenario_Constraints_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
  network_upgrade_names?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "scenario_constraints" */
export type Scenario_Constraints_Inc_Input = {
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  mw_impact?: InputMaybe<Scalars['numeric']['input']>;
  post_study_load?: InputMaybe<Scalars['numeric']['input']>;
  post_study_load_dc?: InputMaybe<Scalars['numeric']['input']>;
  post_study_rating?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_flow?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_rating?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "scenario_constraints" */
export type Scenario_Constraints_Insert_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  constraint_type?: InputMaybe<Constraint_Types_Enum>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  mw_impact?: InputMaybe<Scalars['numeric']['input']>;
  network_upgrade_names?: InputMaybe<Scalars['jsonb']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  post_study_flow?: InputMaybe<Scalars['String']['input']>;
  post_study_load?: InputMaybe<Scalars['numeric']['input']>;
  post_study_load_ac?: InputMaybe<Scalars['String']['input']>;
  post_study_load_dc?: InputMaybe<Scalars['numeric']['input']>;
  post_study_rating?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_flow?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_rating?: InputMaybe<Scalars['numeric']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  scenario?: InputMaybe<Scenarios_Obj_Rel_Insert_Input>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  voltage?: InputMaybe<Scalars['String']['input']>;
  worst_contingency_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Scenario_Constraints_Max_Fields = {
  __typename?: 'scenario_constraints_max_fields';
  area?: Maybe<Scalars['String']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  mw_impact?: Maybe<Scalars['numeric']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  post_study_flow?: Maybe<Scalars['String']['output']>;
  post_study_load?: Maybe<Scalars['numeric']['output']>;
  post_study_load_ac?: Maybe<Scalars['String']['output']>;
  post_study_load_dc?: Maybe<Scalars['numeric']['output']>;
  post_study_rating?: Maybe<Scalars['numeric']['output']>;
  pre_study_flow?: Maybe<Scalars['numeric']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  pre_study_rating?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  voltage?: Maybe<Scalars['String']['output']>;
  worst_contingency_name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Max_Order_By = {
  area?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  post_study_flow?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_ac?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  voltage?: InputMaybe<Order_By>;
  worst_contingency_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenario_Constraints_Min_Fields = {
  __typename?: 'scenario_constraints_min_fields';
  area?: Maybe<Scalars['String']['output']>;
  dfax?: Maybe<Scalars['numeric']['output']>;
  element_type?: Maybe<Scalars['String']['output']>;
  facility_id?: Maybe<Scalars['String']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  monitored_facility_name?: Maybe<Scalars['String']['output']>;
  mw_impact?: Maybe<Scalars['numeric']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  post_study_flow?: Maybe<Scalars['String']['output']>;
  post_study_load?: Maybe<Scalars['numeric']['output']>;
  post_study_load_ac?: Maybe<Scalars['String']['output']>;
  post_study_load_dc?: Maybe<Scalars['numeric']['output']>;
  post_study_rating?: Maybe<Scalars['numeric']['output']>;
  pre_study_flow?: Maybe<Scalars['numeric']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  pre_study_rating?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  voltage?: Maybe<Scalars['String']['output']>;
  worst_contingency_name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Min_Order_By = {
  area?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  post_study_flow?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_ac?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  voltage?: InputMaybe<Order_By>;
  worst_contingency_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "scenario_constraints" */
export type Scenario_Constraints_Mutation_Response = {
  __typename?: 'scenario_constraints_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenario_Constraints>;
};

/** on_conflict condition type for table "scenario_constraints" */
export type Scenario_Constraints_On_Conflict = {
  constraint: Scenario_Constraints_Constraint;
  update_columns?: Array<Scenario_Constraints_Update_Column>;
  where?: InputMaybe<Scenario_Constraints_Bool_Exp>;
};

/** Ordering options when selecting data from "scenario_constraints". */
export type Scenario_Constraints_Order_By = {
  area?: InputMaybe<Order_By>;
  constraint_type?: InputMaybe<Order_By>;
  dfax?: InputMaybe<Order_By>;
  element_type?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  monitored_facility_name?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  network_upgrade_names?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  post_study_flow?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_ac?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  scenario?: InputMaybe<Scenarios_Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  voltage?: InputMaybe<Order_By>;
  worst_contingency_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scenario_constraints */
export type Scenario_Constraints_Pk_Columns_Input = {
  constraint_type: Constraint_Types_Enum;
  facility_id: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
  worst_contingency_name: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Scenario_Constraints_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  network_upgrade_names?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "scenario_constraints" */
export enum Scenario_Constraints_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  ConstraintType = 'constraint_type',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  ElementType = 'element_type',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Model = 'model',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  MwImpact = 'mw_impact',
  /** column name */
  NetworkUpgradeNames = 'network_upgrade_names',
  /** column name */
  Notes = 'notes',
  /** column name */
  PostStudyFlow = 'post_study_flow',
  /** column name */
  PostStudyLoad = 'post_study_load',
  /** column name */
  PostStudyLoadAc = 'post_study_load_ac',
  /** column name */
  PostStudyLoadDc = 'post_study_load_dc',
  /** column name */
  PostStudyRating = 'post_study_rating',
  /** column name */
  PreStudyFlow = 'pre_study_flow',
  /** column name */
  PreStudyLoad = 'pre_study_load',
  /** column name */
  PreStudyRating = 'pre_study_rating',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  Voltage = 'voltage',
  /** column name */
  WorstContingencyName = 'worst_contingency_name'
}

/** input type for updating data in table "scenario_constraints" */
export type Scenario_Constraints_Set_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  constraint_type?: InputMaybe<Constraint_Types_Enum>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  mw_impact?: InputMaybe<Scalars['numeric']['input']>;
  network_upgrade_names?: InputMaybe<Scalars['jsonb']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  post_study_flow?: InputMaybe<Scalars['String']['input']>;
  post_study_load?: InputMaybe<Scalars['numeric']['input']>;
  post_study_load_ac?: InputMaybe<Scalars['String']['input']>;
  post_study_load_dc?: InputMaybe<Scalars['numeric']['input']>;
  post_study_rating?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_flow?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_rating?: InputMaybe<Scalars['numeric']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  voltage?: InputMaybe<Scalars['String']['input']>;
  worst_contingency_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Scenario_Constraints_Stddev_Fields = {
  __typename?: 'scenario_constraints_stddev_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  mw_impact?: Maybe<Scalars['Float']['output']>;
  post_study_load?: Maybe<Scalars['Float']['output']>;
  post_study_load_dc?: Maybe<Scalars['Float']['output']>;
  post_study_rating?: Maybe<Scalars['Float']['output']>;
  pre_study_flow?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  pre_study_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Stddev_Order_By = {
  dfax?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Constraints_Stddev_Pop_Fields = {
  __typename?: 'scenario_constraints_stddev_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  mw_impact?: Maybe<Scalars['Float']['output']>;
  post_study_load?: Maybe<Scalars['Float']['output']>;
  post_study_load_dc?: Maybe<Scalars['Float']['output']>;
  post_study_rating?: Maybe<Scalars['Float']['output']>;
  pre_study_flow?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  pre_study_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Stddev_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Constraints_Stddev_Samp_Fields = {
  __typename?: 'scenario_constraints_stddev_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  mw_impact?: Maybe<Scalars['Float']['output']>;
  post_study_load?: Maybe<Scalars['Float']['output']>;
  post_study_load_dc?: Maybe<Scalars['Float']['output']>;
  post_study_rating?: Maybe<Scalars['Float']['output']>;
  pre_study_flow?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  pre_study_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Stddev_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "scenario_constraints" */
export type Scenario_Constraints_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Constraints_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Constraints_Stream_Cursor_Value_Input = {
  area?: InputMaybe<Scalars['String']['input']>;
  constraint_type?: InputMaybe<Constraint_Types_Enum>;
  dfax?: InputMaybe<Scalars['numeric']['input']>;
  element_type?: InputMaybe<Scalars['String']['input']>;
  facility_id?: InputMaybe<Scalars['String']['input']>;
  line_length?: InputMaybe<Scalars['numeric']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  monitored_facility_name?: InputMaybe<Scalars['String']['input']>;
  mw_impact?: InputMaybe<Scalars['numeric']['input']>;
  network_upgrade_names?: InputMaybe<Scalars['jsonb']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  post_study_flow?: InputMaybe<Scalars['String']['input']>;
  post_study_load?: InputMaybe<Scalars['numeric']['input']>;
  post_study_load_ac?: InputMaybe<Scalars['String']['input']>;
  post_study_load_dc?: InputMaybe<Scalars['numeric']['input']>;
  post_study_rating?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_flow?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_load?: InputMaybe<Scalars['numeric']['input']>;
  pre_study_rating?: InputMaybe<Scalars['numeric']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  voltage?: InputMaybe<Scalars['String']['input']>;
  worst_contingency_name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Constraints_Sum_Fields = {
  __typename?: 'scenario_constraints_sum_fields';
  dfax?: Maybe<Scalars['numeric']['output']>;
  line_length?: Maybe<Scalars['numeric']['output']>;
  mw_impact?: Maybe<Scalars['numeric']['output']>;
  post_study_load?: Maybe<Scalars['numeric']['output']>;
  post_study_load_dc?: Maybe<Scalars['numeric']['output']>;
  post_study_rating?: Maybe<Scalars['numeric']['output']>;
  pre_study_flow?: Maybe<Scalars['numeric']['output']>;
  pre_study_load?: Maybe<Scalars['numeric']['output']>;
  pre_study_rating?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Sum_Order_By = {
  dfax?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
};

/** update columns of table "scenario_constraints" */
export enum Scenario_Constraints_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  ConstraintType = 'constraint_type',
  /** column name */
  Dfax = 'dfax',
  /** column name */
  ElementType = 'element_type',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  LineLength = 'line_length',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Model = 'model',
  /** column name */
  MonitoredFacilityName = 'monitored_facility_name',
  /** column name */
  MwImpact = 'mw_impact',
  /** column name */
  NetworkUpgradeNames = 'network_upgrade_names',
  /** column name */
  Notes = 'notes',
  /** column name */
  PostStudyFlow = 'post_study_flow',
  /** column name */
  PostStudyLoad = 'post_study_load',
  /** column name */
  PostStudyLoadAc = 'post_study_load_ac',
  /** column name */
  PostStudyLoadDc = 'post_study_load_dc',
  /** column name */
  PostStudyRating = 'post_study_rating',
  /** column name */
  PreStudyFlow = 'pre_study_flow',
  /** column name */
  PreStudyLoad = 'pre_study_load',
  /** column name */
  PreStudyRating = 'pre_study_rating',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  Voltage = 'voltage',
  /** column name */
  WorstContingencyName = 'worst_contingency_name'
}

export type Scenario_Constraints_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Scenario_Constraints_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Scenario_Constraints_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Scenario_Constraints_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Scenario_Constraints_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scenario_Constraints_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Scenario_Constraints_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scenario_Constraints_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scenario_Constraints_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Scenario_Constraints_Var_Pop_Fields = {
  __typename?: 'scenario_constraints_var_pop_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  mw_impact?: Maybe<Scalars['Float']['output']>;
  post_study_load?: Maybe<Scalars['Float']['output']>;
  post_study_load_dc?: Maybe<Scalars['Float']['output']>;
  post_study_rating?: Maybe<Scalars['Float']['output']>;
  pre_study_flow?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  pre_study_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Var_Pop_Order_By = {
  dfax?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scenario_Constraints_Var_Samp_Fields = {
  __typename?: 'scenario_constraints_var_samp_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  mw_impact?: Maybe<Scalars['Float']['output']>;
  post_study_load?: Maybe<Scalars['Float']['output']>;
  post_study_load_dc?: Maybe<Scalars['Float']['output']>;
  post_study_rating?: Maybe<Scalars['Float']['output']>;
  pre_study_flow?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  pre_study_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Var_Samp_Order_By = {
  dfax?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Scenario_Constraints_Variance_Fields = {
  __typename?: 'scenario_constraints_variance_fields';
  dfax?: Maybe<Scalars['Float']['output']>;
  line_length?: Maybe<Scalars['Float']['output']>;
  mw_impact?: Maybe<Scalars['Float']['output']>;
  post_study_load?: Maybe<Scalars['Float']['output']>;
  post_study_load_dc?: Maybe<Scalars['Float']['output']>;
  post_study_rating?: Maybe<Scalars['Float']['output']>;
  pre_study_flow?: Maybe<Scalars['Float']['output']>;
  pre_study_load?: Maybe<Scalars['Float']['output']>;
  pre_study_rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "scenario_constraints" */
export type Scenario_Constraints_Variance_Order_By = {
  dfax?: InputMaybe<Order_By>;
  line_length?: InputMaybe<Order_By>;
  mw_impact?: InputMaybe<Order_By>;
  post_study_load?: InputMaybe<Order_By>;
  post_study_load_dc?: InputMaybe<Order_By>;
  post_study_rating?: InputMaybe<Order_By>;
  pre_study_flow?: InputMaybe<Order_By>;
  pre_study_load?: InputMaybe<Order_By>;
  pre_study_rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "scenario_origins" */
export type Scenario_Origins = {
  __typename?: 'scenario_origins';
  description: Scalars['String']['output'];
  origin: Scalars['String']['output'];
};

/** aggregated selection of "scenario_origins" */
export type Scenario_Origins_Aggregate = {
  __typename?: 'scenario_origins_aggregate';
  aggregate?: Maybe<Scenario_Origins_Aggregate_Fields>;
  nodes: Array<Scenario_Origins>;
};

/** aggregate fields of "scenario_origins" */
export type Scenario_Origins_Aggregate_Fields = {
  __typename?: 'scenario_origins_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Origins_Max_Fields>;
  min?: Maybe<Scenario_Origins_Min_Fields>;
};


/** aggregate fields of "scenario_origins" */
export type Scenario_Origins_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Origins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "scenario_origins". All fields are combined with a logical 'AND'. */
export type Scenario_Origins_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Origins_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Origins_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Origins_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  origin?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "scenario_origins" */
export enum Scenario_Origins_Constraint {
  /** unique or primary key constraint on columns "origin" */
  ScenarioOriginsPkey = 'scenario_origins_pkey'
}

export enum Scenario_Origins_Enum {
  /** Base scenario */
  BaseScenario = 'BASE_SCENARIO',
  /** Custom */
  Custom = 'CUSTOM',
  /** Nira published scenario */
  NiraPublished = 'NIRA_PUBLISHED'
}

/** Boolean expression to compare columns of type "scenario_origins_enum". All fields are combined with logical 'AND'. */
export type Scenario_Origins_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scenario_Origins_Enum>;
  _in?: InputMaybe<Array<Scenario_Origins_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scenario_Origins_Enum>;
  _nin?: InputMaybe<Array<Scenario_Origins_Enum>>;
};

/** input type for inserting data into table "scenario_origins" */
export type Scenario_Origins_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Scenario_Origins_Max_Fields = {
  __typename?: 'scenario_origins_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Scenario_Origins_Min_Fields = {
  __typename?: 'scenario_origins_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "scenario_origins" */
export type Scenario_Origins_Mutation_Response = {
  __typename?: 'scenario_origins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenario_Origins>;
};

/** on_conflict condition type for table "scenario_origins" */
export type Scenario_Origins_On_Conflict = {
  constraint: Scenario_Origins_Constraint;
  update_columns?: Array<Scenario_Origins_Update_Column>;
  where?: InputMaybe<Scenario_Origins_Bool_Exp>;
};

/** Ordering options when selecting data from "scenario_origins". */
export type Scenario_Origins_Order_By = {
  description?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scenario_origins */
export type Scenario_Origins_Pk_Columns_Input = {
  origin: Scalars['String']['input'];
};

/** select columns of table "scenario_origins" */
export enum Scenario_Origins_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Origin = 'origin'
}

/** input type for updating data in table "scenario_origins" */
export type Scenario_Origins_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "scenario_origins" */
export type Scenario_Origins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Origins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Origins_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "scenario_origins" */
export enum Scenario_Origins_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Origin = 'origin'
}

export type Scenario_Origins_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scenario_Origins_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scenario_Origins_Bool_Exp;
};

/** columns and relationships of "scenario_project_ranks" */
export type Scenario_Project_Ranks = {
  __typename?: 'scenario_project_ranks';
  percentile: Scalars['Int']['output'];
  percentile_within_group?: Maybe<Scalars['Int']['output']>;
  project_id: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  rank_within_group?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  scenario?: Maybe<Scenarios>;
  scenario_id: Scalars['uuid']['output'];
  /** An object relationship */
  scenario_project?: Maybe<Scenario_Projects>;
  study_group?: Maybe<Scalars['String']['output']>;
  total_ranked: Scalars['Int']['output'];
  total_ranked_within_group?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "scenario_project_ranks" */
export type Scenario_Project_Ranks_Aggregate = {
  __typename?: 'scenario_project_ranks_aggregate';
  aggregate?: Maybe<Scenario_Project_Ranks_Aggregate_Fields>;
  nodes: Array<Scenario_Project_Ranks>;
};

/** aggregate fields of "scenario_project_ranks" */
export type Scenario_Project_Ranks_Aggregate_Fields = {
  __typename?: 'scenario_project_ranks_aggregate_fields';
  avg?: Maybe<Scenario_Project_Ranks_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Project_Ranks_Max_Fields>;
  min?: Maybe<Scenario_Project_Ranks_Min_Fields>;
  stddev?: Maybe<Scenario_Project_Ranks_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Project_Ranks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Project_Ranks_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Project_Ranks_Sum_Fields>;
  var_pop?: Maybe<Scenario_Project_Ranks_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Project_Ranks_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Project_Ranks_Variance_Fields>;
};


/** aggregate fields of "scenario_project_ranks" */
export type Scenario_Project_Ranks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Project_Ranks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Scenario_Project_Ranks_Avg_Fields = {
  __typename?: 'scenario_project_ranks_avg_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  percentile_within_group?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  rank_within_group?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "scenario_project_ranks". All fields are combined with a logical 'AND'. */
export type Scenario_Project_Ranks_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Project_Ranks_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Project_Ranks_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Project_Ranks_Bool_Exp>>;
  percentile?: InputMaybe<Int_Comparison_Exp>;
  percentile_within_group?: InputMaybe<Int_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  rank_within_group?: InputMaybe<Int_Comparison_Exp>;
  scenario?: InputMaybe<Scenarios_Bool_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_project?: InputMaybe<Scenario_Projects_Bool_Exp>;
  study_group?: InputMaybe<String_Comparison_Exp>;
  total_ranked?: InputMaybe<Int_Comparison_Exp>;
  total_ranked_within_group?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "scenario_project_ranks" */
export enum Scenario_Project_Ranks_Constraint {
  /** unique or primary key constraint on columns "project_id", "scenario_id" */
  ScenarioProjectRanksPkey = 'scenario_project_ranks_pkey'
}

/** input type for incrementing numeric columns in table "scenario_project_ranks" */
export type Scenario_Project_Ranks_Inc_Input = {
  percentile?: InputMaybe<Scalars['Int']['input']>;
  percentile_within_group?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rank_within_group?: InputMaybe<Scalars['Int']['input']>;
  total_ranked?: InputMaybe<Scalars['Int']['input']>;
  total_ranked_within_group?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "scenario_project_ranks" */
export type Scenario_Project_Ranks_Insert_Input = {
  percentile?: InputMaybe<Scalars['Int']['input']>;
  percentile_within_group?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rank_within_group?: InputMaybe<Scalars['Int']['input']>;
  scenario?: InputMaybe<Scenarios_Obj_Rel_Insert_Input>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_project?: InputMaybe<Scenario_Projects_Obj_Rel_Insert_Input>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  total_ranked?: InputMaybe<Scalars['Int']['input']>;
  total_ranked_within_group?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Scenario_Project_Ranks_Max_Fields = {
  __typename?: 'scenario_project_ranks_max_fields';
  percentile?: Maybe<Scalars['Int']['output']>;
  percentile_within_group?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  rank_within_group?: Maybe<Scalars['Int']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  total_ranked?: Maybe<Scalars['Int']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Scenario_Project_Ranks_Min_Fields = {
  __typename?: 'scenario_project_ranks_min_fields';
  percentile?: Maybe<Scalars['Int']['output']>;
  percentile_within_group?: Maybe<Scalars['Int']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  rank_within_group?: Maybe<Scalars['Int']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  total_ranked?: Maybe<Scalars['Int']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "scenario_project_ranks" */
export type Scenario_Project_Ranks_Mutation_Response = {
  __typename?: 'scenario_project_ranks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenario_Project_Ranks>;
};

/** input type for inserting object relation for remote table "scenario_project_ranks" */
export type Scenario_Project_Ranks_Obj_Rel_Insert_Input = {
  data: Scenario_Project_Ranks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Scenario_Project_Ranks_On_Conflict>;
};

/** on_conflict condition type for table "scenario_project_ranks" */
export type Scenario_Project_Ranks_On_Conflict = {
  constraint: Scenario_Project_Ranks_Constraint;
  update_columns?: Array<Scenario_Project_Ranks_Update_Column>;
  where?: InputMaybe<Scenario_Project_Ranks_Bool_Exp>;
};

/** Ordering options when selecting data from "scenario_project_ranks". */
export type Scenario_Project_Ranks_Order_By = {
  percentile?: InputMaybe<Order_By>;
  percentile_within_group?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  rank_within_group?: InputMaybe<Order_By>;
  scenario?: InputMaybe<Scenarios_Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  scenario_project?: InputMaybe<Scenario_Projects_Order_By>;
  study_group?: InputMaybe<Order_By>;
  total_ranked?: InputMaybe<Order_By>;
  total_ranked_within_group?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scenario_project_ranks */
export type Scenario_Project_Ranks_Pk_Columns_Input = {
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};

/** select columns of table "scenario_project_ranks" */
export enum Scenario_Project_Ranks_Select_Column {
  /** column name */
  Percentile = 'percentile',
  /** column name */
  PercentileWithinGroup = 'percentile_within_group',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  RankWithinGroup = 'rank_within_group',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  TotalRanked = 'total_ranked',
  /** column name */
  TotalRankedWithinGroup = 'total_ranked_within_group'
}

/** input type for updating data in table "scenario_project_ranks" */
export type Scenario_Project_Ranks_Set_Input = {
  percentile?: InputMaybe<Scalars['Int']['input']>;
  percentile_within_group?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rank_within_group?: InputMaybe<Scalars['Int']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  total_ranked?: InputMaybe<Scalars['Int']['input']>;
  total_ranked_within_group?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Scenario_Project_Ranks_Stddev_Fields = {
  __typename?: 'scenario_project_ranks_stddev_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  percentile_within_group?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  rank_within_group?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Project_Ranks_Stddev_Pop_Fields = {
  __typename?: 'scenario_project_ranks_stddev_pop_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  percentile_within_group?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  rank_within_group?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Project_Ranks_Stddev_Samp_Fields = {
  __typename?: 'scenario_project_ranks_stddev_samp_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  percentile_within_group?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  rank_within_group?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "scenario_project_ranks" */
export type Scenario_Project_Ranks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Project_Ranks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Project_Ranks_Stream_Cursor_Value_Input = {
  percentile?: InputMaybe<Scalars['Int']['input']>;
  percentile_within_group?: InputMaybe<Scalars['Int']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rank_within_group?: InputMaybe<Scalars['Int']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  total_ranked?: InputMaybe<Scalars['Int']['input']>;
  total_ranked_within_group?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Project_Ranks_Sum_Fields = {
  __typename?: 'scenario_project_ranks_sum_fields';
  percentile?: Maybe<Scalars['Int']['output']>;
  percentile_within_group?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  rank_within_group?: Maybe<Scalars['Int']['output']>;
  total_ranked?: Maybe<Scalars['Int']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "scenario_project_ranks" */
export enum Scenario_Project_Ranks_Update_Column {
  /** column name */
  Percentile = 'percentile',
  /** column name */
  PercentileWithinGroup = 'percentile_within_group',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Rank = 'rank',
  /** column name */
  RankWithinGroup = 'rank_within_group',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  TotalRanked = 'total_ranked',
  /** column name */
  TotalRankedWithinGroup = 'total_ranked_within_group'
}

export type Scenario_Project_Ranks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scenario_Project_Ranks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scenario_Project_Ranks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scenario_Project_Ranks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Scenario_Project_Ranks_Var_Pop_Fields = {
  __typename?: 'scenario_project_ranks_var_pop_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  percentile_within_group?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  rank_within_group?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Scenario_Project_Ranks_Var_Samp_Fields = {
  __typename?: 'scenario_project_ranks_var_samp_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  percentile_within_group?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  rank_within_group?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Scenario_Project_Ranks_Variance_Fields = {
  __typename?: 'scenario_project_ranks_variance_fields';
  percentile?: Maybe<Scalars['Float']['output']>;
  percentile_within_group?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  rank_within_group?: Maybe<Scalars['Float']['output']>;
  total_ranked?: Maybe<Scalars['Float']['output']>;
  total_ranked_within_group?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "scenario_projects" */
export type Scenario_Projects = {
  __typename?: 'scenario_projects';
  assigned_upgrades: Scalars['jsonb']['output'];
  cost_per_mw: Scalars['numeric']['output'];
  eris_size_mw: Scalars['numeric']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  nris_size_mw: Scalars['numeric']['output'];
  overloaded_facilities: Scalars['jsonb']['output'];
  project_id: Scalars['String']['output'];
  /** An object relationship */
  ranks?: Maybe<Scenario_Project_Ranks>;
  /** An object relationship */
  scenario: Scenarios;
  scenario_id: Scalars['uuid']['output'];
  sum_allocated_cost: Scalars['numeric']['output'];
  sum_allocated_cost_by_constraint_type?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "scenario_projects" */
export type Scenario_ProjectsAssigned_UpgradesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenario_projects" */
export type Scenario_ProjectsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenario_projects" */
export type Scenario_ProjectsOverloaded_FacilitiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenario_projects" */
export type Scenario_ProjectsSum_Allocated_Cost_By_Constraint_TypeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "scenario_projects" */
export type Scenario_Projects_Aggregate = {
  __typename?: 'scenario_projects_aggregate';
  aggregate?: Maybe<Scenario_Projects_Aggregate_Fields>;
  nodes: Array<Scenario_Projects>;
};

export type Scenario_Projects_Aggregate_Bool_Exp = {
  count?: InputMaybe<Scenario_Projects_Aggregate_Bool_Exp_Count>;
};

export type Scenario_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenario_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenario_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenario_projects" */
export type Scenario_Projects_Aggregate_Fields = {
  __typename?: 'scenario_projects_aggregate_fields';
  avg?: Maybe<Scenario_Projects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Projects_Max_Fields>;
  min?: Maybe<Scenario_Projects_Min_Fields>;
  stddev?: Maybe<Scenario_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Scenario_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenario_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Scenario_Projects_Sum_Fields>;
  var_pop?: Maybe<Scenario_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Scenario_Projects_Var_Samp_Fields>;
  variance?: Maybe<Scenario_Projects_Variance_Fields>;
};


/** aggregate fields of "scenario_projects" */
export type Scenario_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenario_projects" */
export type Scenario_Projects_Aggregate_Order_By = {
  avg?: InputMaybe<Scenario_Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenario_Projects_Max_Order_By>;
  min?: InputMaybe<Scenario_Projects_Min_Order_By>;
  stddev?: InputMaybe<Scenario_Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Scenario_Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Scenario_Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Scenario_Projects_Sum_Order_By>;
  var_pop?: InputMaybe<Scenario_Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Scenario_Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<Scenario_Projects_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Scenario_Projects_Append_Input = {
  assigned_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  overloaded_facilities?: InputMaybe<Scalars['jsonb']['input']>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "scenario_projects" */
export type Scenario_Projects_Arr_Rel_Insert_Input = {
  data: Array<Scenario_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Scenario_Projects_On_Conflict>;
};

/** aggregate avg on columns */
export type Scenario_Projects_Avg_Fields = {
  __typename?: 'scenario_projects_avg_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_size_mw?: Maybe<Scalars['Float']['output']>;
  nris_size_mw?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "scenario_projects" */
export type Scenario_Projects_Avg_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scenario_projects". All fields are combined with a logical 'AND'. */
export type Scenario_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Projects_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Projects_Bool_Exp>>;
  assigned_upgrades?: InputMaybe<Jsonb_Comparison_Exp>;
  cost_per_mw?: InputMaybe<Numeric_Comparison_Exp>;
  eris_size_mw?: InputMaybe<Numeric_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  nris_size_mw?: InputMaybe<Numeric_Comparison_Exp>;
  overloaded_facilities?: InputMaybe<Jsonb_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  ranks?: InputMaybe<Scenario_Project_Ranks_Bool_Exp>;
  scenario?: InputMaybe<Scenarios_Bool_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  sum_allocated_cost?: InputMaybe<Numeric_Comparison_Exp>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "scenario_projects" */
export enum Scenario_Projects_Constraint {
  /** unique or primary key constraint on columns "project_id", "scenario_id" */
  ScenarioProjectsPkey = 'scenario_projects_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Scenario_Projects_Delete_At_Path_Input = {
  assigned_upgrades?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  overloaded_facilities?: InputMaybe<Array<Scalars['String']['input']>>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Scenario_Projects_Delete_Elem_Input = {
  assigned_upgrades?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
  overloaded_facilities?: InputMaybe<Scalars['Int']['input']>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Scenario_Projects_Delete_Key_Input = {
  assigned_upgrades?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  overloaded_facilities?: InputMaybe<Scalars['String']['input']>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "scenario_projects" */
export type Scenario_Projects_Inc_Input = {
  cost_per_mw?: InputMaybe<Scalars['numeric']['input']>;
  eris_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  nris_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  sum_allocated_cost?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "scenario_projects" */
export type Scenario_Projects_Insert_Input = {
  assigned_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  cost_per_mw?: InputMaybe<Scalars['numeric']['input']>;
  eris_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  nris_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  overloaded_facilities?: InputMaybe<Scalars['jsonb']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  ranks?: InputMaybe<Scenario_Project_Ranks_Obj_Rel_Insert_Input>;
  scenario?: InputMaybe<Scenarios_Obj_Rel_Insert_Input>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  sum_allocated_cost?: InputMaybe<Scalars['numeric']['input']>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Scenario_Projects_Max_Fields = {
  __typename?: 'scenario_projects_max_fields';
  cost_per_mw?: Maybe<Scalars['numeric']['output']>;
  eris_size_mw?: Maybe<Scalars['numeric']['output']>;
  nris_size_mw?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  sum_allocated_cost?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "scenario_projects" */
export type Scenario_Projects_Max_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenario_Projects_Min_Fields = {
  __typename?: 'scenario_projects_min_fields';
  cost_per_mw?: Maybe<Scalars['numeric']['output']>;
  eris_size_mw?: Maybe<Scalars['numeric']['output']>;
  nris_size_mw?: Maybe<Scalars['numeric']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  sum_allocated_cost?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "scenario_projects" */
export type Scenario_Projects_Min_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "scenario_projects" */
export type Scenario_Projects_Mutation_Response = {
  __typename?: 'scenario_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenario_Projects>;
};

/** input type for inserting object relation for remote table "scenario_projects" */
export type Scenario_Projects_Obj_Rel_Insert_Input = {
  data: Scenario_Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Scenario_Projects_On_Conflict>;
};

/** on_conflict condition type for table "scenario_projects" */
export type Scenario_Projects_On_Conflict = {
  constraint: Scenario_Projects_Constraint;
  update_columns?: Array<Scenario_Projects_Update_Column>;
  where?: InputMaybe<Scenario_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "scenario_projects". */
export type Scenario_Projects_Order_By = {
  assigned_upgrades?: InputMaybe<Order_By>;
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  overloaded_facilities?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  ranks?: InputMaybe<Scenario_Project_Ranks_Order_By>;
  scenario?: InputMaybe<Scenarios_Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scenario_projects */
export type Scenario_Projects_Pk_Columns_Input = {
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Scenario_Projects_Prepend_Input = {
  assigned_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  overloaded_facilities?: InputMaybe<Scalars['jsonb']['input']>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "scenario_projects" */
export enum Scenario_Projects_Select_Column {
  /** column name */
  AssignedUpgrades = 'assigned_upgrades',
  /** column name */
  CostPerMw = 'cost_per_mw',
  /** column name */
  ErisSizeMw = 'eris_size_mw',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NrisSizeMw = 'nris_size_mw',
  /** column name */
  OverloadedFacilities = 'overloaded_facilities',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  SumAllocatedCost = 'sum_allocated_cost',
  /** column name */
  SumAllocatedCostByConstraintType = 'sum_allocated_cost_by_constraint_type'
}

/** input type for updating data in table "scenario_projects" */
export type Scenario_Projects_Set_Input = {
  assigned_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  cost_per_mw?: InputMaybe<Scalars['numeric']['input']>;
  eris_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  nris_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  overloaded_facilities?: InputMaybe<Scalars['jsonb']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  sum_allocated_cost?: InputMaybe<Scalars['numeric']['input']>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Scenario_Projects_Stddev_Fields = {
  __typename?: 'scenario_projects_stddev_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_size_mw?: Maybe<Scalars['Float']['output']>;
  nris_size_mw?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "scenario_projects" */
export type Scenario_Projects_Stddev_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scenario_Projects_Stddev_Pop_Fields = {
  __typename?: 'scenario_projects_stddev_pop_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_size_mw?: Maybe<Scalars['Float']['output']>;
  nris_size_mw?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "scenario_projects" */
export type Scenario_Projects_Stddev_Pop_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scenario_Projects_Stddev_Samp_Fields = {
  __typename?: 'scenario_projects_stddev_samp_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_size_mw?: Maybe<Scalars['Float']['output']>;
  nris_size_mw?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "scenario_projects" */
export type Scenario_Projects_Stddev_Samp_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "scenario_projects" */
export type Scenario_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Projects_Stream_Cursor_Value_Input = {
  assigned_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  cost_per_mw?: InputMaybe<Scalars['numeric']['input']>;
  eris_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  nris_size_mw?: InputMaybe<Scalars['numeric']['input']>;
  overloaded_facilities?: InputMaybe<Scalars['jsonb']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  sum_allocated_cost?: InputMaybe<Scalars['numeric']['input']>;
  sum_allocated_cost_by_constraint_type?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Scenario_Projects_Sum_Fields = {
  __typename?: 'scenario_projects_sum_fields';
  cost_per_mw?: Maybe<Scalars['numeric']['output']>;
  eris_size_mw?: Maybe<Scalars['numeric']['output']>;
  nris_size_mw?: Maybe<Scalars['numeric']['output']>;
  sum_allocated_cost?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "scenario_projects" */
export type Scenario_Projects_Sum_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** update columns of table "scenario_projects" */
export enum Scenario_Projects_Update_Column {
  /** column name */
  AssignedUpgrades = 'assigned_upgrades',
  /** column name */
  CostPerMw = 'cost_per_mw',
  /** column name */
  ErisSizeMw = 'eris_size_mw',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NrisSizeMw = 'nris_size_mw',
  /** column name */
  OverloadedFacilities = 'overloaded_facilities',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  SumAllocatedCost = 'sum_allocated_cost',
  /** column name */
  SumAllocatedCostByConstraintType = 'sum_allocated_cost_by_constraint_type'
}

export type Scenario_Projects_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Scenario_Projects_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Scenario_Projects_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Scenario_Projects_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Scenario_Projects_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scenario_Projects_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Scenario_Projects_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scenario_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scenario_Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Scenario_Projects_Var_Pop_Fields = {
  __typename?: 'scenario_projects_var_pop_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_size_mw?: Maybe<Scalars['Float']['output']>;
  nris_size_mw?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "scenario_projects" */
export type Scenario_Projects_Var_Pop_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scenario_Projects_Var_Samp_Fields = {
  __typename?: 'scenario_projects_var_samp_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_size_mw?: Maybe<Scalars['Float']['output']>;
  nris_size_mw?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "scenario_projects" */
export type Scenario_Projects_Var_Samp_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Scenario_Projects_Variance_Fields = {
  __typename?: 'scenario_projects_variance_fields';
  cost_per_mw?: Maybe<Scalars['Float']['output']>;
  eris_size_mw?: Maybe<Scalars['Float']['output']>;
  nris_size_mw?: Maybe<Scalars['Float']['output']>;
  sum_allocated_cost?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "scenario_projects" */
export type Scenario_Projects_Variance_Order_By = {
  cost_per_mw?: InputMaybe<Order_By>;
  eris_size_mw?: InputMaybe<Order_By>;
  nris_size_mw?: InputMaybe<Order_By>;
  sum_allocated_cost?: InputMaybe<Order_By>;
};

/** columns and relationships of "scenario_statuses" */
export type Scenario_Statuses = {
  __typename?: 'scenario_statuses';
  description: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** aggregated selection of "scenario_statuses" */
export type Scenario_Statuses_Aggregate = {
  __typename?: 'scenario_statuses_aggregate';
  aggregate?: Maybe<Scenario_Statuses_Aggregate_Fields>;
  nodes: Array<Scenario_Statuses>;
};

/** aggregate fields of "scenario_statuses" */
export type Scenario_Statuses_Aggregate_Fields = {
  __typename?: 'scenario_statuses_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Scenario_Statuses_Max_Fields>;
  min?: Maybe<Scenario_Statuses_Min_Fields>;
};


/** aggregate fields of "scenario_statuses" */
export type Scenario_Statuses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenario_Statuses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "scenario_statuses". All fields are combined with a logical 'AND'. */
export type Scenario_Statuses_Bool_Exp = {
  _and?: InputMaybe<Array<Scenario_Statuses_Bool_Exp>>;
  _not?: InputMaybe<Scenario_Statuses_Bool_Exp>;
  _or?: InputMaybe<Array<Scenario_Statuses_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "scenario_statuses" */
export enum Scenario_Statuses_Constraint {
  /** unique or primary key constraint on columns "status" */
  ScenarioStatusesPkey = 'scenario_statuses_pkey'
}

export enum Scenario_Statuses_Enum {
  /** The scenario was successfully completed; however, it has since been archived and is no longer accessible. */
  Archived = 'ARCHIVED',
  /** Scenario has been created in a draft state */
  Draft = 'DRAFT',
  /** The first step of the pipeline has been run */
  Running = 'RUNNING',
  /** The run completed with a failure */
  RunFailed = 'RUN_FAILED',
  /** The user has requested a run of this scenario; it is no longer editable */
  RunRequested = 'RUN_REQUESTED',
  /** The pipeline sensor has submitted a run for the scenario */
  RunSubmitted = 'RUN_SUBMITTED',
  /** The run completed and successfully wrote results to the database */
  RunSucceeded = 'RUN_SUCCEEDED'
}

/** Boolean expression to compare columns of type "scenario_statuses_enum". All fields are combined with logical 'AND'. */
export type Scenario_Statuses_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Scenario_Statuses_Enum>;
  _in?: InputMaybe<Array<Scenario_Statuses_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scenario_Statuses_Enum>;
  _nin?: InputMaybe<Array<Scenario_Statuses_Enum>>;
};

/** input type for inserting data into table "scenario_statuses" */
export type Scenario_Statuses_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Scenario_Statuses_Max_Fields = {
  __typename?: 'scenario_statuses_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Scenario_Statuses_Min_Fields = {
  __typename?: 'scenario_statuses_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "scenario_statuses" */
export type Scenario_Statuses_Mutation_Response = {
  __typename?: 'scenario_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenario_Statuses>;
};

/** on_conflict condition type for table "scenario_statuses" */
export type Scenario_Statuses_On_Conflict = {
  constraint: Scenario_Statuses_Constraint;
  update_columns?: Array<Scenario_Statuses_Update_Column>;
  where?: InputMaybe<Scenario_Statuses_Bool_Exp>;
};

/** Ordering options when selecting data from "scenario_statuses". */
export type Scenario_Statuses_Order_By = {
  description?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scenario_statuses */
export type Scenario_Statuses_Pk_Columns_Input = {
  status: Scalars['String']['input'];
};

/** select columns of table "scenario_statuses" */
export enum Scenario_Statuses_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "scenario_statuses" */
export type Scenario_Statuses_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "scenario_statuses" */
export type Scenario_Statuses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenario_Statuses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenario_Statuses_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "scenario_statuses" */
export enum Scenario_Statuses_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

export type Scenario_Statuses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scenario_Statuses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scenario_Statuses_Bool_Exp;
};

/** columns and relationships of "scenarios" */
export type Scenarios = {
  __typename?: 'scenarios';
  archived: Scalars['Boolean']['output'];
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  cost_assumptions: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  custom_upgrades?: Maybe<Scalars['jsonb']['output']>;
  dagster_run_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  in_queue_subscription?: Maybe<In_Queue_Subscriptions>;
  input_data_used?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "scenario_is_archived" */
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "scenario_is_stale" */
  is_stale?: Maybe<Scalars['Boolean']['output']>;
  last_archived_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_project_id?: Maybe<Scalars['String']['output']>;
  parent_speculative_project_id?: Maybe<Scalars['uuid']['output']>;
  project_additions?: Maybe<Scalars['jsonb']['output']>;
  project_size_assumptions: Scalars['jsonb']['output'];
  region: Scalars['String']['output'];
  /** An object relationship */
  relevant_subscriptions?: Maybe<In_Queue_Subscriptions>;
  run_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  run_started_at?: Maybe<Scalars['timestamptz']['output']>;
  run_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  run_submitted_by?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  scenario_allocated_upgrades: Array<Scenario_Allocated_Upgrades>;
  /** An aggregate relationship */
  scenario_allocated_upgrades_aggregate: Scenario_Allocated_Upgrades_Aggregate;
  /** An array relationship */
  scenario_constraints: Array<Scenario_Constraints>;
  /** An aggregate relationship */
  scenario_constraints_aggregate: Scenario_Constraints_Aggregate;
  scenario_id: Scalars['uuid']['output'];
  scenario_origin?: Maybe<Scenario_Origins_Enum>;
  /** An array relationship */
  scenario_projects: Array<Scenario_Projects>;
  /** An aggregate relationship */
  scenario_projects_aggregate: Scenario_Projects_Aggregate;
  scenario_stage: Scalars['String']['output'];
  scenario_type: Scalars['String']['output'];
  status: Scenario_Statuses_Enum;
  study_cycle: Scalars['String']['output'];
  study_group: Scalars['String']['output'];
  study_phase: Scalars['String']['output'];
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "scenarios" */
export type ScenariosCost_AssumptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenarios" */
export type ScenariosCustom_UpgradesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenarios" */
export type ScenariosInput_Data_UsedArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenarios" */
export type ScenariosProject_AdditionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenarios" */
export type ScenariosProject_Size_AssumptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scenarios" */
export type ScenariosScenario_Allocated_UpgradesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Allocated_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Allocated_Upgrades_Order_By>>;
  where?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
};


/** columns and relationships of "scenarios" */
export type ScenariosScenario_Allocated_Upgrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Allocated_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Allocated_Upgrades_Order_By>>;
  where?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
};


/** columns and relationships of "scenarios" */
export type ScenariosScenario_ConstraintsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Constraints_Order_By>>;
  where?: InputMaybe<Scenario_Constraints_Bool_Exp>;
};


/** columns and relationships of "scenarios" */
export type ScenariosScenario_Constraints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Constraints_Order_By>>;
  where?: InputMaybe<Scenario_Constraints_Bool_Exp>;
};


/** columns and relationships of "scenarios" */
export type ScenariosScenario_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Projects_Order_By>>;
  where?: InputMaybe<Scenario_Projects_Bool_Exp>;
};


/** columns and relationships of "scenarios" */
export type ScenariosScenario_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Projects_Order_By>>;
  where?: InputMaybe<Scenario_Projects_Bool_Exp>;
};

/** aggregated selection of "scenarios" */
export type Scenarios_Aggregate = {
  __typename?: 'scenarios_aggregate';
  aggregate?: Maybe<Scenarios_Aggregate_Fields>;
  nodes: Array<Scenarios>;
};

export type Scenarios_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Scenarios_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Scenarios_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Scenarios_Aggregate_Bool_Exp_Count>;
};

export type Scenarios_Aggregate_Bool_Exp_Bool_And = {
  arguments: Scenarios_Select_Column_Scenarios_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenarios_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scenarios_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Scenarios_Select_Column_Scenarios_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenarios_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Scenarios_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scenarios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scenarios_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scenarios" */
export type Scenarios_Aggregate_Fields = {
  __typename?: 'scenarios_aggregate_fields';
  avg?: Maybe<Scenarios_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scenarios_Max_Fields>;
  min?: Maybe<Scenarios_Min_Fields>;
  stddev?: Maybe<Scenarios_Stddev_Fields>;
  stddev_pop?: Maybe<Scenarios_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scenarios_Stddev_Samp_Fields>;
  sum?: Maybe<Scenarios_Sum_Fields>;
  var_pop?: Maybe<Scenarios_Var_Pop_Fields>;
  var_samp?: Maybe<Scenarios_Var_Samp_Fields>;
  variance?: Maybe<Scenarios_Variance_Fields>;
};


/** aggregate fields of "scenarios" */
export type Scenarios_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scenarios_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenarios" */
export type Scenarios_Aggregate_Order_By = {
  avg?: InputMaybe<Scenarios_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scenarios_Max_Order_By>;
  min?: InputMaybe<Scenarios_Min_Order_By>;
  stddev?: InputMaybe<Scenarios_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Scenarios_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Scenarios_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Scenarios_Sum_Order_By>;
  var_pop?: InputMaybe<Scenarios_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Scenarios_Var_Samp_Order_By>;
  variance?: InputMaybe<Scenarios_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Scenarios_Append_Input = {
  cost_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
  custom_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  input_data_used?: InputMaybe<Scalars['jsonb']['input']>;
  project_additions?: InputMaybe<Scalars['jsonb']['input']>;
  project_size_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "scenarios" */
export type Scenarios_Arr_Rel_Insert_Input = {
  data: Array<Scenarios_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Scenarios_On_Conflict>;
};

/** aggregate avg on columns */
export type Scenarios_Avg_Fields = {
  __typename?: 'scenarios_avg_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "scenarios" */
export type Scenarios_Avg_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scenarios". All fields are combined with a logical 'AND'. */
export type Scenarios_Bool_Exp = {
  _and?: InputMaybe<Array<Scenarios_Bool_Exp>>;
  _not?: InputMaybe<Scenarios_Bool_Exp>;
  _or?: InputMaybe<Array<Scenarios_Bool_Exp>>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  cost_assumptions?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  custom_upgrades?: InputMaybe<Jsonb_Comparison_Exp>;
  dagster_run_id?: InputMaybe<String_Comparison_Exp>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
  input_data_used?: InputMaybe<Jsonb_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  is_stale?: InputMaybe<Boolean_Comparison_Exp>;
  last_archived_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  parent_project_id?: InputMaybe<String_Comparison_Exp>;
  parent_speculative_project_id?: InputMaybe<Uuid_Comparison_Exp>;
  project_additions?: InputMaybe<Jsonb_Comparison_Exp>;
  project_size_assumptions?: InputMaybe<Jsonb_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  relevant_subscriptions?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
  run_completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  run_started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  run_submitted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  run_submitted_by?: InputMaybe<String_Comparison_Exp>;
  scenario_allocated_upgrades?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
  scenario_allocated_upgrades_aggregate?: InputMaybe<Scenario_Allocated_Upgrades_Aggregate_Bool_Exp>;
  scenario_constraints?: InputMaybe<Scenario_Constraints_Bool_Exp>;
  scenario_constraints_aggregate?: InputMaybe<Scenario_Constraints_Aggregate_Bool_Exp>;
  scenario_id?: InputMaybe<Uuid_Comparison_Exp>;
  scenario_origin?: InputMaybe<Scenario_Origins_Enum_Comparison_Exp>;
  scenario_projects?: InputMaybe<Scenario_Projects_Bool_Exp>;
  scenario_projects_aggregate?: InputMaybe<Scenario_Projects_Aggregate_Bool_Exp>;
  scenario_stage?: InputMaybe<String_Comparison_Exp>;
  scenario_type?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Scenario_Statuses_Enum_Comparison_Exp>;
  study_cycle?: InputMaybe<String_Comparison_Exp>;
  study_group?: InputMaybe<String_Comparison_Exp>;
  study_phase?: InputMaybe<String_Comparison_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "scenarios" */
export enum Scenarios_Constraint {
  /** unique or primary key constraint on columns "scenario_id" */
  ScenariosPkey = 'scenarios_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Scenarios_Delete_At_Path_Input = {
  cost_assumptions?: InputMaybe<Array<Scalars['String']['input']>>;
  custom_upgrades?: InputMaybe<Array<Scalars['String']['input']>>;
  input_data_used?: InputMaybe<Array<Scalars['String']['input']>>;
  project_additions?: InputMaybe<Array<Scalars['String']['input']>>;
  project_size_assumptions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Scenarios_Delete_Elem_Input = {
  cost_assumptions?: InputMaybe<Scalars['Int']['input']>;
  custom_upgrades?: InputMaybe<Scalars['Int']['input']>;
  input_data_used?: InputMaybe<Scalars['Int']['input']>;
  project_additions?: InputMaybe<Scalars['Int']['input']>;
  project_size_assumptions?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Scenarios_Delete_Key_Input = {
  cost_assumptions?: InputMaybe<Scalars['String']['input']>;
  custom_upgrades?: InputMaybe<Scalars['String']['input']>;
  input_data_used?: InputMaybe<Scalars['String']['input']>;
  project_additions?: InputMaybe<Scalars['String']['input']>;
  project_size_assumptions?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "scenarios" */
export type Scenarios_Inc_Input = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "scenarios" */
export type Scenarios_Insert_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  cost_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  custom_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  dagster_run_id?: InputMaybe<Scalars['String']['input']>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Obj_Rel_Insert_Input>;
  input_data_used?: InputMaybe<Scalars['jsonb']['input']>;
  last_archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_project_id?: InputMaybe<Scalars['String']['input']>;
  parent_speculative_project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_additions?: InputMaybe<Scalars['jsonb']['input']>;
  project_size_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  relevant_subscriptions?: InputMaybe<In_Queue_Subscriptions_Obj_Rel_Insert_Input>;
  run_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  run_started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  run_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  run_submitted_by?: InputMaybe<Scalars['String']['input']>;
  scenario_allocated_upgrades?: InputMaybe<Scenario_Allocated_Upgrades_Arr_Rel_Insert_Input>;
  scenario_constraints?: InputMaybe<Scenario_Constraints_Arr_Rel_Insert_Input>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_origin?: InputMaybe<Scenario_Origins_Enum>;
  scenario_projects?: InputMaybe<Scenario_Projects_Arr_Rel_Insert_Input>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  scenario_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scenario_Statuses_Enum>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Scenarios_Max_Fields = {
  __typename?: 'scenarios_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  dagster_run_id?: Maybe<Scalars['String']['output']>;
  last_archived_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_project_id?: Maybe<Scalars['String']['output']>;
  parent_speculative_project_id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  run_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  run_started_at?: Maybe<Scalars['timestamptz']['output']>;
  run_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  run_submitted_by?: Maybe<Scalars['String']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  scenario_stage?: Maybe<Scalars['String']['output']>;
  scenario_type?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  study_phase?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "scenarios" */
export type Scenarios_Max_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  dagster_run_id?: InputMaybe<Order_By>;
  last_archived_at?: InputMaybe<Order_By>;
  parent_project_id?: InputMaybe<Order_By>;
  parent_speculative_project_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  run_completed_at?: InputMaybe<Order_By>;
  run_started_at?: InputMaybe<Order_By>;
  run_submitted_at?: InputMaybe<Order_By>;
  run_submitted_by?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  scenario_stage?: InputMaybe<Order_By>;
  scenario_type?: InputMaybe<Order_By>;
  study_cycle?: InputMaybe<Order_By>;
  study_group?: InputMaybe<Order_By>;
  study_phase?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scenarios_Min_Fields = {
  __typename?: 'scenarios_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  dagster_run_id?: Maybe<Scalars['String']['output']>;
  last_archived_at?: Maybe<Scalars['timestamptz']['output']>;
  parent_project_id?: Maybe<Scalars['String']['output']>;
  parent_speculative_project_id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  run_completed_at?: Maybe<Scalars['timestamptz']['output']>;
  run_started_at?: Maybe<Scalars['timestamptz']['output']>;
  run_submitted_at?: Maybe<Scalars['timestamptz']['output']>;
  run_submitted_by?: Maybe<Scalars['String']['output']>;
  scenario_id?: Maybe<Scalars['uuid']['output']>;
  scenario_stage?: Maybe<Scalars['String']['output']>;
  scenario_type?: Maybe<Scalars['String']['output']>;
  study_cycle?: Maybe<Scalars['String']['output']>;
  study_group?: Maybe<Scalars['String']['output']>;
  study_phase?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "scenarios" */
export type Scenarios_Min_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  dagster_run_id?: InputMaybe<Order_By>;
  last_archived_at?: InputMaybe<Order_By>;
  parent_project_id?: InputMaybe<Order_By>;
  parent_speculative_project_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  run_completed_at?: InputMaybe<Order_By>;
  run_started_at?: InputMaybe<Order_By>;
  run_submitted_at?: InputMaybe<Order_By>;
  run_submitted_by?: InputMaybe<Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  scenario_stage?: InputMaybe<Order_By>;
  scenario_type?: InputMaybe<Order_By>;
  study_cycle?: InputMaybe<Order_By>;
  study_group?: InputMaybe<Order_By>;
  study_phase?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "scenarios" */
export type Scenarios_Mutation_Response = {
  __typename?: 'scenarios_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scenarios>;
};

/** input type for inserting object relation for remote table "scenarios" */
export type Scenarios_Obj_Rel_Insert_Input = {
  data: Scenarios_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Scenarios_On_Conflict>;
};

/** on_conflict condition type for table "scenarios" */
export type Scenarios_On_Conflict = {
  constraint: Scenarios_Constraint;
  update_columns?: Array<Scenarios_Update_Column>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};

/** Ordering options when selecting data from "scenarios". */
export type Scenarios_Order_By = {
  archived?: InputMaybe<Order_By>;
  cluster_id?: InputMaybe<Order_By>;
  cost_assumptions?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  custom_upgrades?: InputMaybe<Order_By>;
  dagster_run_id?: InputMaybe<Order_By>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Order_By>;
  input_data_used?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  is_stale?: InputMaybe<Order_By>;
  last_archived_at?: InputMaybe<Order_By>;
  parent_project_id?: InputMaybe<Order_By>;
  parent_speculative_project_id?: InputMaybe<Order_By>;
  project_additions?: InputMaybe<Order_By>;
  project_size_assumptions?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  relevant_subscriptions?: InputMaybe<In_Queue_Subscriptions_Order_By>;
  run_completed_at?: InputMaybe<Order_By>;
  run_started_at?: InputMaybe<Order_By>;
  run_submitted_at?: InputMaybe<Order_By>;
  run_submitted_by?: InputMaybe<Order_By>;
  scenario_allocated_upgrades_aggregate?: InputMaybe<Scenario_Allocated_Upgrades_Aggregate_Order_By>;
  scenario_constraints_aggregate?: InputMaybe<Scenario_Constraints_Aggregate_Order_By>;
  scenario_id?: InputMaybe<Order_By>;
  scenario_origin?: InputMaybe<Order_By>;
  scenario_projects_aggregate?: InputMaybe<Scenario_Projects_Aggregate_Order_By>;
  scenario_stage?: InputMaybe<Order_By>;
  scenario_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  study_cycle?: InputMaybe<Order_By>;
  study_group?: InputMaybe<Order_By>;
  study_phase?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scenarios */
export type Scenarios_Pk_Columns_Input = {
  scenario_id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Scenarios_Prepend_Input = {
  cost_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
  custom_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  input_data_used?: InputMaybe<Scalars['jsonb']['input']>;
  project_additions?: InputMaybe<Scalars['jsonb']['input']>;
  project_size_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "scenarios" */
export enum Scenarios_Select_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CostAssumptions = 'cost_assumptions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomUpgrades = 'custom_upgrades',
  /** column name */
  DagsterRunId = 'dagster_run_id',
  /** column name */
  InputDataUsed = 'input_data_used',
  /** column name */
  LastArchivedAt = 'last_archived_at',
  /** column name */
  ParentProjectId = 'parent_project_id',
  /** column name */
  ParentSpeculativeProjectId = 'parent_speculative_project_id',
  /** column name */
  ProjectAdditions = 'project_additions',
  /** column name */
  ProjectSizeAssumptions = 'project_size_assumptions',
  /** column name */
  Region = 'region',
  /** column name */
  RunCompletedAt = 'run_completed_at',
  /** column name */
  RunStartedAt = 'run_started_at',
  /** column name */
  RunSubmittedAt = 'run_submitted_at',
  /** column name */
  RunSubmittedBy = 'run_submitted_by',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  ScenarioOrigin = 'scenario_origin',
  /** column name */
  ScenarioStage = 'scenario_stage',
  /** column name */
  ScenarioType = 'scenario_type',
  /** column name */
  Status = 'status',
  /** column name */
  StudyCycle = 'study_cycle',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  StudyPhase = 'study_phase',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** select "scenarios_aggregate_bool_exp_bool_and_arguments_columns" columns of table "scenarios" */
export enum Scenarios_Select_Column_Scenarios_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Archived = 'archived'
}

/** select "scenarios_aggregate_bool_exp_bool_or_arguments_columns" columns of table "scenarios" */
export enum Scenarios_Select_Column_Scenarios_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Archived = 'archived'
}

/** input type for updating data in table "scenarios" */
export type Scenarios_Set_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  cost_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  custom_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  dagster_run_id?: InputMaybe<Scalars['String']['input']>;
  input_data_used?: InputMaybe<Scalars['jsonb']['input']>;
  last_archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_project_id?: InputMaybe<Scalars['String']['input']>;
  parent_speculative_project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_additions?: InputMaybe<Scalars['jsonb']['input']>;
  project_size_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  run_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  run_started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  run_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  run_submitted_by?: InputMaybe<Scalars['String']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_origin?: InputMaybe<Scenario_Origins_Enum>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  scenario_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scenario_Statuses_Enum>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Scenarios_Stddev_Fields = {
  __typename?: 'scenarios_stddev_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "scenarios" */
export type Scenarios_Stddev_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scenarios_Stddev_Pop_Fields = {
  __typename?: 'scenarios_stddev_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "scenarios" */
export type Scenarios_Stddev_Pop_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scenarios_Stddev_Samp_Fields = {
  __typename?: 'scenarios_stddev_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "scenarios" */
export type Scenarios_Stddev_Samp_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "scenarios" */
export type Scenarios_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scenarios_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scenarios_Stream_Cursor_Value_Input = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  cost_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  custom_upgrades?: InputMaybe<Scalars['jsonb']['input']>;
  dagster_run_id?: InputMaybe<Scalars['String']['input']>;
  input_data_used?: InputMaybe<Scalars['jsonb']['input']>;
  last_archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  parent_project_id?: InputMaybe<Scalars['String']['input']>;
  parent_speculative_project_id?: InputMaybe<Scalars['uuid']['input']>;
  project_additions?: InputMaybe<Scalars['jsonb']['input']>;
  project_size_assumptions?: InputMaybe<Scalars['jsonb']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  run_completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  run_started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  run_submitted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  run_submitted_by?: InputMaybe<Scalars['String']['input']>;
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
  scenario_origin?: InputMaybe<Scenario_Origins_Enum>;
  scenario_stage?: InputMaybe<Scalars['String']['input']>;
  scenario_type?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scenario_Statuses_Enum>;
  study_cycle?: InputMaybe<Scalars['String']['input']>;
  study_group?: InputMaybe<Scalars['String']['input']>;
  study_phase?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Scenarios_Sum_Fields = {
  __typename?: 'scenarios_sum_fields';
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "scenarios" */
export type Scenarios_Sum_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "scenarios" */
export enum Scenarios_Update_Column {
  /** column name */
  Archived = 'archived',
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  CostAssumptions = 'cost_assumptions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CustomUpgrades = 'custom_upgrades',
  /** column name */
  DagsterRunId = 'dagster_run_id',
  /** column name */
  InputDataUsed = 'input_data_used',
  /** column name */
  LastArchivedAt = 'last_archived_at',
  /** column name */
  ParentProjectId = 'parent_project_id',
  /** column name */
  ParentSpeculativeProjectId = 'parent_speculative_project_id',
  /** column name */
  ProjectAdditions = 'project_additions',
  /** column name */
  ProjectSizeAssumptions = 'project_size_assumptions',
  /** column name */
  Region = 'region',
  /** column name */
  RunCompletedAt = 'run_completed_at',
  /** column name */
  RunStartedAt = 'run_started_at',
  /** column name */
  RunSubmittedAt = 'run_submitted_at',
  /** column name */
  RunSubmittedBy = 'run_submitted_by',
  /** column name */
  ScenarioId = 'scenario_id',
  /** column name */
  ScenarioOrigin = 'scenario_origin',
  /** column name */
  ScenarioStage = 'scenario_stage',
  /** column name */
  ScenarioType = 'scenario_type',
  /** column name */
  Status = 'status',
  /** column name */
  StudyCycle = 'study_cycle',
  /** column name */
  StudyGroup = 'study_group',
  /** column name */
  StudyPhase = 'study_phase',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Scenarios_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Scenarios_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Scenarios_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Scenarios_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Scenarios_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scenarios_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Scenarios_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scenarios_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scenarios_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Scenarios_Var_Pop_Fields = {
  __typename?: 'scenarios_var_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "scenarios" */
export type Scenarios_Var_Pop_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scenarios_Var_Samp_Fields = {
  __typename?: 'scenarios_var_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "scenarios" */
export type Scenarios_Var_Samp_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Scenarios_Variance_Fields = {
  __typename?: 'scenarios_variance_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "scenarios" */
export type Scenarios_Variance_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "scopes" */
export type Scopes = {
  __typename?: 'scopes';
  /** An array relationship */
  buses_to_scopes: Array<Buses_To_Scopes>;
  /** An aggregate relationship */
  buses_to_scopes_aggregate: Buses_To_Scopes_Aggregate;
  data_freshness_date?: Maybe<Scalars['date']['output']>;
  data_freshness_markdown: Scalars['String']['output'];
  data_freshness_model?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  display_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  region: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  scope_views: Scalars['jsonb']['output'];
  /** An object relationship */
  subscription?: Maybe<Subscriptions>;
  subscription_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  user_scope_config?: Maybe<User_Scope_Configs>;
  /** An array relationship */
  user_scope_permission: Array<User_Scope_Permissions>;
  /** An aggregate relationship */
  user_scope_permission_aggregate: User_Scope_Permissions_Aggregate;
};


/** columns and relationships of "scopes" */
export type ScopesBuses_To_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


/** columns and relationships of "scopes" */
export type ScopesBuses_To_Scopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


/** columns and relationships of "scopes" */
export type ScopesScope_ViewsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "scopes" */
export type ScopesUser_Scope_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


/** columns and relationships of "scopes" */
export type ScopesUser_Scope_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** aggregated selection of "scopes" */
export type Scopes_Aggregate = {
  __typename?: 'scopes_aggregate';
  aggregate?: Maybe<Scopes_Aggregate_Fields>;
  nodes: Array<Scopes>;
};

export type Scopes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Scopes_Aggregate_Bool_Exp_Count>;
};

export type Scopes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scopes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scopes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scopes" */
export type Scopes_Aggregate_Fields = {
  __typename?: 'scopes_aggregate_fields';
  avg?: Maybe<Scopes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Scopes_Max_Fields>;
  min?: Maybe<Scopes_Min_Fields>;
  stddev?: Maybe<Scopes_Stddev_Fields>;
  stddev_pop?: Maybe<Scopes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scopes_Stddev_Samp_Fields>;
  sum?: Maybe<Scopes_Sum_Fields>;
  var_pop?: Maybe<Scopes_Var_Pop_Fields>;
  var_samp?: Maybe<Scopes_Var_Samp_Fields>;
  variance?: Maybe<Scopes_Variance_Fields>;
};


/** aggregate fields of "scopes" */
export type Scopes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scopes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scopes" */
export type Scopes_Aggregate_Order_By = {
  avg?: InputMaybe<Scopes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scopes_Max_Order_By>;
  min?: InputMaybe<Scopes_Min_Order_By>;
  stddev?: InputMaybe<Scopes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Scopes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Scopes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Scopes_Sum_Order_By>;
  var_pop?: InputMaybe<Scopes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Scopes_Var_Samp_Order_By>;
  variance?: InputMaybe<Scopes_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Scopes_Append_Input = {
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "scopes" */
export type Scopes_Arr_Rel_Insert_Input = {
  data: Array<Scopes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Scopes_On_Conflict>;
};

/** aggregate avg on columns */
export type Scopes_Avg_Fields = {
  __typename?: 'scopes_avg_fields';
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "scopes" */
export type Scopes_Avg_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "scopes". All fields are combined with a logical 'AND'. */
export type Scopes_Bool_Exp = {
  _and?: InputMaybe<Array<Scopes_Bool_Exp>>;
  _not?: InputMaybe<Scopes_Bool_Exp>;
  _or?: InputMaybe<Array<Scopes_Bool_Exp>>;
  buses_to_scopes?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
  buses_to_scopes_aggregate?: InputMaybe<Buses_To_Scopes_Aggregate_Bool_Exp>;
  data_freshness_date?: InputMaybe<Date_Comparison_Exp>;
  data_freshness_markdown?: InputMaybe<String_Comparison_Exp>;
  data_freshness_model?: InputMaybe<String_Comparison_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_views?: InputMaybe<Jsonb_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscription_id?: InputMaybe<Int_Comparison_Exp>;
  user_scope_config?: InputMaybe<User_Scope_Configs_Bool_Exp>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "scopes" */
export enum Scopes_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScopesPkey = 'scopes_pkey',
  /** unique or primary key constraint on columns "scope" */
  ScopesScopeKey = 'scopes_scope_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Scopes_Delete_At_Path_Input = {
  scope_views?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Scopes_Delete_Elem_Input = {
  scope_views?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Scopes_Delete_Key_Input = {
  scope_views?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "scopes" */
export type Scopes_Inc_Input = {
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "scopes" */
export type Scopes_Insert_Input = {
  buses_to_scopes?: InputMaybe<Buses_To_Scopes_Arr_Rel_Insert_Input>;
  data_freshness_date?: InputMaybe<Scalars['date']['input']>;
  data_freshness_markdown?: InputMaybe<Scalars['String']['input']>;
  data_freshness_model?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
  user_scope_config?: InputMaybe<User_Scope_Configs_Obj_Rel_Insert_Input>;
  user_scope_permission?: InputMaybe<User_Scope_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Scopes_Max_Fields = {
  __typename?: 'scopes_max_fields';
  data_freshness_date?: Maybe<Scalars['date']['output']>;
  data_freshness_markdown?: Maybe<Scalars['String']['output']>;
  data_freshness_model?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "scopes" */
export type Scopes_Max_Order_By = {
  data_freshness_date?: InputMaybe<Order_By>;
  data_freshness_markdown?: InputMaybe<Order_By>;
  data_freshness_model?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scopes_Min_Fields = {
  __typename?: 'scopes_min_fields';
  data_freshness_date?: Maybe<Scalars['date']['output']>;
  data_freshness_markdown?: Maybe<Scalars['String']['output']>;
  data_freshness_model?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "scopes" */
export type Scopes_Min_Order_By = {
  data_freshness_date?: InputMaybe<Order_By>;
  data_freshness_markdown?: InputMaybe<Order_By>;
  data_freshness_model?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "scopes" */
export type Scopes_Mutation_Response = {
  __typename?: 'scopes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Scopes>;
};

/** input type for inserting object relation for remote table "scopes" */
export type Scopes_Obj_Rel_Insert_Input = {
  data: Scopes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Scopes_On_Conflict>;
};

/** on_conflict condition type for table "scopes" */
export type Scopes_On_Conflict = {
  constraint: Scopes_Constraint;
  update_columns?: Array<Scopes_Update_Column>;
  where?: InputMaybe<Scopes_Bool_Exp>;
};

/** Ordering options when selecting data from "scopes". */
export type Scopes_Order_By = {
  buses_to_scopes_aggregate?: InputMaybe<Buses_To_Scopes_Aggregate_Order_By>;
  data_freshness_date?: InputMaybe<Order_By>;
  data_freshness_markdown?: InputMaybe<Order_By>;
  data_freshness_model?: InputMaybe<Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_views?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  user_scope_config?: InputMaybe<User_Scope_Configs_Order_By>;
  user_scope_permission_aggregate?: InputMaybe<User_Scope_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: scopes */
export type Scopes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Scopes_Prepend_Input = {
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "scopes" */
export enum Scopes_Select_Column {
  /** column name */
  DataFreshnessDate = 'data_freshness_date',
  /** column name */
  DataFreshnessMarkdown = 'data_freshness_markdown',
  /** column name */
  DataFreshnessModel = 'data_freshness_model',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeViews = 'scope_views',
  /** column name */
  SubscriptionId = 'subscription_id'
}

/** input type for updating data in table "scopes" */
export type Scopes_Set_Input = {
  data_freshness_date?: InputMaybe<Scalars['date']['input']>;
  data_freshness_markdown?: InputMaybe<Scalars['String']['input']>;
  data_freshness_model?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Scopes_Stddev_Fields = {
  __typename?: 'scopes_stddev_fields';
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "scopes" */
export type Scopes_Stddev_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Scopes_Stddev_Pop_Fields = {
  __typename?: 'scopes_stddev_pop_fields';
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "scopes" */
export type Scopes_Stddev_Pop_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Scopes_Stddev_Samp_Fields = {
  __typename?: 'scopes_stddev_samp_fields';
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "scopes" */
export type Scopes_Stddev_Samp_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "scopes" */
export type Scopes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scopes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scopes_Stream_Cursor_Value_Input = {
  data_freshness_date?: InputMaybe<Scalars['date']['input']>;
  data_freshness_markdown?: InputMaybe<Scalars['String']['input']>;
  data_freshness_model?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_views?: InputMaybe<Scalars['jsonb']['input']>;
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Scopes_Sum_Fields = {
  __typename?: 'scopes_sum_fields';
  subscription_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "scopes" */
export type Scopes_Sum_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** update columns of table "scopes" */
export enum Scopes_Update_Column {
  /** column name */
  DataFreshnessDate = 'data_freshness_date',
  /** column name */
  DataFreshnessMarkdown = 'data_freshness_markdown',
  /** column name */
  DataFreshnessModel = 'data_freshness_model',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  ScopeViews = 'scope_views',
  /** column name */
  SubscriptionId = 'subscription_id'
}

export type Scopes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Scopes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Scopes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Scopes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Scopes_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scopes_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Scopes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scopes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scopes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Scopes_Var_Pop_Fields = {
  __typename?: 'scopes_var_pop_fields';
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "scopes" */
export type Scopes_Var_Pop_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Scopes_Var_Samp_Fields = {
  __typename?: 'scopes_var_samp_fields';
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "scopes" */
export type Scopes_Var_Samp_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Scopes_Variance_Fields = {
  __typename?: 'scopes_variance_fields';
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "scopes" */
export type Scopes_Variance_Order_By = {
  subscription_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "screening_views" */
export type Screening_Views = {
  __typename?: 'screening_views';
  color_mode?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['String']['output'];
  description: Scalars['String']['output'];
  generator_type: Scalars['String']['output'];
  hide_locked_buses: Scalars['Boolean']['output'];
  hide_low_confidence_buses: Scalars['Boolean']['output'];
  high_threshold: Scalars['numeric']['output'];
  id: Scalars['String']['output'];
  includes_pre_existing: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  location_filter?: Maybe<Scalars['String']['output']>;
  low_threshold: Scalars['numeric']['output'];
  max_allocated_costs?: Maybe<Scalars['numeric']['output']>;
  max_total_costs?: Maybe<Scalars['numeric']['output']>;
  medium_threshold: Scalars['numeric']['output'];
  owners?: Maybe<Scalars['jsonb']['output']>;
  region: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  states: Scalars['jsonb']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
  voltages: Scalars['jsonb']['output'];
};


/** columns and relationships of "screening_views" */
export type Screening_ViewsOwnersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "screening_views" */
export type Screening_ViewsStatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "screening_views" */
export type Screening_ViewsVoltagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "screening_views" */
export type Screening_Views_Aggregate = {
  __typename?: 'screening_views_aggregate';
  aggregate?: Maybe<Screening_Views_Aggregate_Fields>;
  nodes: Array<Screening_Views>;
};

export type Screening_Views_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Screening_Views_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Screening_Views_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Screening_Views_Aggregate_Bool_Exp_Count>;
};

export type Screening_Views_Aggregate_Bool_Exp_Bool_And = {
  arguments: Screening_Views_Select_Column_Screening_Views_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Screening_Views_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Screening_Views_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Screening_Views_Select_Column_Screening_Views_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Screening_Views_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Screening_Views_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Screening_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Screening_Views_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "screening_views" */
export type Screening_Views_Aggregate_Fields = {
  __typename?: 'screening_views_aggregate_fields';
  avg?: Maybe<Screening_Views_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Screening_Views_Max_Fields>;
  min?: Maybe<Screening_Views_Min_Fields>;
  stddev?: Maybe<Screening_Views_Stddev_Fields>;
  stddev_pop?: Maybe<Screening_Views_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Screening_Views_Stddev_Samp_Fields>;
  sum?: Maybe<Screening_Views_Sum_Fields>;
  var_pop?: Maybe<Screening_Views_Var_Pop_Fields>;
  var_samp?: Maybe<Screening_Views_Var_Samp_Fields>;
  variance?: Maybe<Screening_Views_Variance_Fields>;
};


/** aggregate fields of "screening_views" */
export type Screening_Views_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Screening_Views_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "screening_views" */
export type Screening_Views_Aggregate_Order_By = {
  avg?: InputMaybe<Screening_Views_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Screening_Views_Max_Order_By>;
  min?: InputMaybe<Screening_Views_Min_Order_By>;
  stddev?: InputMaybe<Screening_Views_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Screening_Views_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Screening_Views_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Screening_Views_Sum_Order_By>;
  var_pop?: InputMaybe<Screening_Views_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Screening_Views_Var_Samp_Order_By>;
  variance?: InputMaybe<Screening_Views_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Screening_Views_Append_Input = {
  owners?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  voltages?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "screening_views" */
export type Screening_Views_Arr_Rel_Insert_Input = {
  data: Array<Screening_Views_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Screening_Views_On_Conflict>;
};

/** aggregate avg on columns */
export type Screening_Views_Avg_Fields = {
  __typename?: 'screening_views_avg_fields';
  high_threshold?: Maybe<Scalars['Float']['output']>;
  low_threshold?: Maybe<Scalars['Float']['output']>;
  max_allocated_costs?: Maybe<Scalars['Float']['output']>;
  max_total_costs?: Maybe<Scalars['Float']['output']>;
  medium_threshold?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "screening_views" */
export type Screening_Views_Avg_Order_By = {
  high_threshold?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "screening_views". All fields are combined with a logical 'AND'. */
export type Screening_Views_Bool_Exp = {
  _and?: InputMaybe<Array<Screening_Views_Bool_Exp>>;
  _not?: InputMaybe<Screening_Views_Bool_Exp>;
  _or?: InputMaybe<Array<Screening_Views_Bool_Exp>>;
  color_mode?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  generator_type?: InputMaybe<String_Comparison_Exp>;
  hide_locked_buses?: InputMaybe<Boolean_Comparison_Exp>;
  hide_low_confidence_buses?: InputMaybe<Boolean_Comparison_Exp>;
  high_threshold?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  includes_pre_existing?: InputMaybe<Boolean_Comparison_Exp>;
  is_archived?: InputMaybe<Boolean_Comparison_Exp>;
  location_filter?: InputMaybe<String_Comparison_Exp>;
  low_threshold?: InputMaybe<Numeric_Comparison_Exp>;
  max_allocated_costs?: InputMaybe<Numeric_Comparison_Exp>;
  max_total_costs?: InputMaybe<Numeric_Comparison_Exp>;
  medium_threshold?: InputMaybe<Numeric_Comparison_Exp>;
  owners?: InputMaybe<Jsonb_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  states?: InputMaybe<Jsonb_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  voltages?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "screening_views" */
export enum Screening_Views_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScreeningViewsPkey = 'screening_views_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Screening_Views_Delete_At_Path_Input = {
  owners?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  voltages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Screening_Views_Delete_Elem_Input = {
  owners?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Scalars['Int']['input']>;
  voltages?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Screening_Views_Delete_Key_Input = {
  owners?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Scalars['String']['input']>;
  voltages?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "screening_views" */
export type Screening_Views_Inc_Input = {
  high_threshold?: InputMaybe<Scalars['numeric']['input']>;
  low_threshold?: InputMaybe<Scalars['numeric']['input']>;
  max_allocated_costs?: InputMaybe<Scalars['numeric']['input']>;
  max_total_costs?: InputMaybe<Scalars['numeric']['input']>;
  medium_threshold?: InputMaybe<Scalars['numeric']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "screening_views" */
export type Screening_Views_Insert_Input = {
  color_mode?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  generator_type?: InputMaybe<Scalars['String']['input']>;
  hide_locked_buses?: InputMaybe<Scalars['Boolean']['input']>;
  hide_low_confidence_buses?: InputMaybe<Scalars['Boolean']['input']>;
  high_threshold?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  location_filter?: InputMaybe<Scalars['String']['input']>;
  low_threshold?: InputMaybe<Scalars['numeric']['input']>;
  max_allocated_costs?: InputMaybe<Scalars['numeric']['input']>;
  max_total_costs?: InputMaybe<Scalars['numeric']['input']>;
  medium_threshold?: InputMaybe<Scalars['numeric']['input']>;
  owners?: InputMaybe<Scalars['jsonb']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  voltages?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Screening_Views_Max_Fields = {
  __typename?: 'screening_views_max_fields';
  color_mode?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  generator_type?: Maybe<Scalars['String']['output']>;
  high_threshold?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location_filter?: Maybe<Scalars['String']['output']>;
  low_threshold?: Maybe<Scalars['numeric']['output']>;
  max_allocated_costs?: Maybe<Scalars['numeric']['output']>;
  max_total_costs?: Maybe<Scalars['numeric']['output']>;
  medium_threshold?: Maybe<Scalars['numeric']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "screening_views" */
export type Screening_Views_Max_Order_By = {
  color_mode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  generator_type?: InputMaybe<Order_By>;
  high_threshold?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_filter?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Screening_Views_Min_Fields = {
  __typename?: 'screening_views_min_fields';
  color_mode?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  generator_type?: Maybe<Scalars['String']['output']>;
  high_threshold?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location_filter?: Maybe<Scalars['String']['output']>;
  low_threshold?: Maybe<Scalars['numeric']['output']>;
  max_allocated_costs?: Maybe<Scalars['numeric']['output']>;
  max_total_costs?: Maybe<Scalars['numeric']['output']>;
  medium_threshold?: Maybe<Scalars['numeric']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "screening_views" */
export type Screening_Views_Min_Order_By = {
  color_mode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  generator_type?: InputMaybe<Order_By>;
  high_threshold?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_filter?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "screening_views" */
export type Screening_Views_Mutation_Response = {
  __typename?: 'screening_views_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Screening_Views>;
};

/** on_conflict condition type for table "screening_views" */
export type Screening_Views_On_Conflict = {
  constraint: Screening_Views_Constraint;
  update_columns?: Array<Screening_Views_Update_Column>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};

/** Ordering options when selecting data from "screening_views". */
export type Screening_Views_Order_By = {
  color_mode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  generator_type?: InputMaybe<Order_By>;
  hide_locked_buses?: InputMaybe<Order_By>;
  hide_low_confidence_buses?: InputMaybe<Order_By>;
  high_threshold?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  includes_pre_existing?: InputMaybe<Order_By>;
  is_archived?: InputMaybe<Order_By>;
  location_filter?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  owners?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  states?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  voltages?: InputMaybe<Order_By>;
};

/** primary key columns input for table: screening_views */
export type Screening_Views_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Screening_Views_Prepend_Input = {
  owners?: InputMaybe<Scalars['jsonb']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  voltages?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "screening_views" */
export enum Screening_Views_Select_Column {
  /** column name */
  ColorMode = 'color_mode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  GeneratorType = 'generator_type',
  /** column name */
  HideLockedBuses = 'hide_locked_buses',
  /** column name */
  HideLowConfidenceBuses = 'hide_low_confidence_buses',
  /** column name */
  HighThreshold = 'high_threshold',
  /** column name */
  Id = 'id',
  /** column name */
  IncludesPreExisting = 'includes_pre_existing',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  LocationFilter = 'location_filter',
  /** column name */
  LowThreshold = 'low_threshold',
  /** column name */
  MaxAllocatedCosts = 'max_allocated_costs',
  /** column name */
  MaxTotalCosts = 'max_total_costs',
  /** column name */
  MediumThreshold = 'medium_threshold',
  /** column name */
  Owners = 'owners',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  States = 'states',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  Voltages = 'voltages'
}

/** select "screening_views_aggregate_bool_exp_bool_and_arguments_columns" columns of table "screening_views" */
export enum Screening_Views_Select_Column_Screening_Views_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HideLockedBuses = 'hide_locked_buses',
  /** column name */
  HideLowConfidenceBuses = 'hide_low_confidence_buses',
  /** column name */
  IncludesPreExisting = 'includes_pre_existing',
  /** column name */
  IsArchived = 'is_archived'
}

/** select "screening_views_aggregate_bool_exp_bool_or_arguments_columns" columns of table "screening_views" */
export enum Screening_Views_Select_Column_Screening_Views_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HideLockedBuses = 'hide_locked_buses',
  /** column name */
  HideLowConfidenceBuses = 'hide_low_confidence_buses',
  /** column name */
  IncludesPreExisting = 'includes_pre_existing',
  /** column name */
  IsArchived = 'is_archived'
}

/** input type for updating data in table "screening_views" */
export type Screening_Views_Set_Input = {
  color_mode?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  generator_type?: InputMaybe<Scalars['String']['input']>;
  hide_locked_buses?: InputMaybe<Scalars['Boolean']['input']>;
  hide_low_confidence_buses?: InputMaybe<Scalars['Boolean']['input']>;
  high_threshold?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  location_filter?: InputMaybe<Scalars['String']['input']>;
  low_threshold?: InputMaybe<Scalars['numeric']['input']>;
  max_allocated_costs?: InputMaybe<Scalars['numeric']['input']>;
  max_total_costs?: InputMaybe<Scalars['numeric']['input']>;
  medium_threshold?: InputMaybe<Scalars['numeric']['input']>;
  owners?: InputMaybe<Scalars['jsonb']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  voltages?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Screening_Views_Stddev_Fields = {
  __typename?: 'screening_views_stddev_fields';
  high_threshold?: Maybe<Scalars['Float']['output']>;
  low_threshold?: Maybe<Scalars['Float']['output']>;
  max_allocated_costs?: Maybe<Scalars['Float']['output']>;
  max_total_costs?: Maybe<Scalars['Float']['output']>;
  medium_threshold?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "screening_views" */
export type Screening_Views_Stddev_Order_By = {
  high_threshold?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Screening_Views_Stddev_Pop_Fields = {
  __typename?: 'screening_views_stddev_pop_fields';
  high_threshold?: Maybe<Scalars['Float']['output']>;
  low_threshold?: Maybe<Scalars['Float']['output']>;
  max_allocated_costs?: Maybe<Scalars['Float']['output']>;
  max_total_costs?: Maybe<Scalars['Float']['output']>;
  medium_threshold?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "screening_views" */
export type Screening_Views_Stddev_Pop_Order_By = {
  high_threshold?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Screening_Views_Stddev_Samp_Fields = {
  __typename?: 'screening_views_stddev_samp_fields';
  high_threshold?: Maybe<Scalars['Float']['output']>;
  low_threshold?: Maybe<Scalars['Float']['output']>;
  max_allocated_costs?: Maybe<Scalars['Float']['output']>;
  max_total_costs?: Maybe<Scalars['Float']['output']>;
  medium_threshold?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "screening_views" */
export type Screening_Views_Stddev_Samp_Order_By = {
  high_threshold?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "screening_views" */
export type Screening_Views_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Screening_Views_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Screening_Views_Stream_Cursor_Value_Input = {
  color_mode?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  generator_type?: InputMaybe<Scalars['String']['input']>;
  hide_locked_buses?: InputMaybe<Scalars['Boolean']['input']>;
  hide_low_confidence_buses?: InputMaybe<Scalars['Boolean']['input']>;
  high_threshold?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  includes_pre_existing?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  location_filter?: InputMaybe<Scalars['String']['input']>;
  low_threshold?: InputMaybe<Scalars['numeric']['input']>;
  max_allocated_costs?: InputMaybe<Scalars['numeric']['input']>;
  max_total_costs?: InputMaybe<Scalars['numeric']['input']>;
  medium_threshold?: InputMaybe<Scalars['numeric']['input']>;
  owners?: InputMaybe<Scalars['jsonb']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Scalars['jsonb']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  voltages?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Screening_Views_Sum_Fields = {
  __typename?: 'screening_views_sum_fields';
  high_threshold?: Maybe<Scalars['numeric']['output']>;
  low_threshold?: Maybe<Scalars['numeric']['output']>;
  max_allocated_costs?: Maybe<Scalars['numeric']['output']>;
  max_total_costs?: Maybe<Scalars['numeric']['output']>;
  medium_threshold?: Maybe<Scalars['numeric']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "screening_views" */
export type Screening_Views_Sum_Order_By = {
  high_threshold?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "screening_views" */
export enum Screening_Views_Update_Column {
  /** column name */
  ColorMode = 'color_mode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  GeneratorType = 'generator_type',
  /** column name */
  HideLockedBuses = 'hide_locked_buses',
  /** column name */
  HideLowConfidenceBuses = 'hide_low_confidence_buses',
  /** column name */
  HighThreshold = 'high_threshold',
  /** column name */
  Id = 'id',
  /** column name */
  IncludesPreExisting = 'includes_pre_existing',
  /** column name */
  IsArchived = 'is_archived',
  /** column name */
  LocationFilter = 'location_filter',
  /** column name */
  LowThreshold = 'low_threshold',
  /** column name */
  MaxAllocatedCosts = 'max_allocated_costs',
  /** column name */
  MaxTotalCosts = 'max_total_costs',
  /** column name */
  MediumThreshold = 'medium_threshold',
  /** column name */
  Owners = 'owners',
  /** column name */
  Region = 'region',
  /** column name */
  Scope = 'scope',
  /** column name */
  States = 'states',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  Voltages = 'voltages'
}

export type Screening_Views_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Screening_Views_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Screening_Views_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Screening_Views_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Screening_Views_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Screening_Views_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Screening_Views_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Screening_Views_Set_Input>;
  /** filter the rows which have to be updated */
  where: Screening_Views_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Screening_Views_Var_Pop_Fields = {
  __typename?: 'screening_views_var_pop_fields';
  high_threshold?: Maybe<Scalars['Float']['output']>;
  low_threshold?: Maybe<Scalars['Float']['output']>;
  max_allocated_costs?: Maybe<Scalars['Float']['output']>;
  max_total_costs?: Maybe<Scalars['Float']['output']>;
  medium_threshold?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "screening_views" */
export type Screening_Views_Var_Pop_Order_By = {
  high_threshold?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Screening_Views_Var_Samp_Fields = {
  __typename?: 'screening_views_var_samp_fields';
  high_threshold?: Maybe<Scalars['Float']['output']>;
  low_threshold?: Maybe<Scalars['Float']['output']>;
  max_allocated_costs?: Maybe<Scalars['Float']['output']>;
  max_total_costs?: Maybe<Scalars['Float']['output']>;
  medium_threshold?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "screening_views" */
export type Screening_Views_Var_Samp_Order_By = {
  high_threshold?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Screening_Views_Variance_Fields = {
  __typename?: 'screening_views_variance_fields';
  high_threshold?: Maybe<Scalars['Float']['output']>;
  low_threshold?: Maybe<Scalars['Float']['output']>;
  max_allocated_costs?: Maybe<Scalars['Float']['output']>;
  max_total_costs?: Maybe<Scalars['Float']['output']>;
  medium_threshold?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "screening_views" */
export type Screening_Views_Variance_Order_By = {
  high_threshold?: InputMaybe<Order_By>;
  low_threshold?: InputMaybe<Order_By>;
  max_allocated_costs?: InputMaybe<Order_By>;
  max_total_costs?: InputMaybe<Order_By>;
  medium_threshold?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata = {
  __typename?: 'sis_project_cost_type_metadata';
  cost_type: Project_Cost_Types_Enum;
  is_cost_component: Scalars['Boolean']['output'];
};

/** aggregated selection of "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata_Aggregate = {
  __typename?: 'sis_project_cost_type_metadata_aggregate';
  aggregate?: Maybe<Sis_Project_Cost_Type_Metadata_Aggregate_Fields>;
  nodes: Array<Sis_Project_Cost_Type_Metadata>;
};

/** aggregate fields of "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata_Aggregate_Fields = {
  __typename?: 'sis_project_cost_type_metadata_aggregate_fields';
  count: Scalars['Int']['output'];
};


/** aggregate fields of "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sis_project_cost_type_metadata". All fields are combined with a logical 'AND'. */
export type Sis_Project_Cost_Type_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Sis_Project_Cost_Type_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Bool_Exp>>;
  cost_type?: InputMaybe<Project_Cost_Types_Enum_Comparison_Exp>;
  is_cost_component?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "sis_project_cost_type_metadata" */
export enum Sis_Project_Cost_Type_Metadata_Constraint {
  /** unique or primary key constraint on columns "cost_type" */
  SisProjectCostTypeMetadataPkey = 'sis_project_cost_type_metadata_pkey'
}

/** input type for inserting data into table "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata_Insert_Input = {
  cost_type?: InputMaybe<Project_Cost_Types_Enum>;
  is_cost_component?: InputMaybe<Scalars['Boolean']['input']>;
};

/** response of any mutation on the table "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata_Mutation_Response = {
  __typename?: 'sis_project_cost_type_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sis_Project_Cost_Type_Metadata>;
};

/** input type for inserting object relation for remote table "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata_Obj_Rel_Insert_Input = {
  data: Sis_Project_Cost_Type_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sis_Project_Cost_Type_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata_On_Conflict = {
  constraint: Sis_Project_Cost_Type_Metadata_Constraint;
  update_columns?: Array<Sis_Project_Cost_Type_Metadata_Update_Column>;
  where?: InputMaybe<Sis_Project_Cost_Type_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "sis_project_cost_type_metadata". */
export type Sis_Project_Cost_Type_Metadata_Order_By = {
  cost_type?: InputMaybe<Order_By>;
  is_cost_component?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sis_project_cost_type_metadata */
export type Sis_Project_Cost_Type_Metadata_Pk_Columns_Input = {
  cost_type: Project_Cost_Types_Enum;
};

/** select columns of table "sis_project_cost_type_metadata" */
export enum Sis_Project_Cost_Type_Metadata_Select_Column {
  /** column name */
  CostType = 'cost_type',
  /** column name */
  IsCostComponent = 'is_cost_component'
}

/** input type for updating data in table "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata_Set_Input = {
  cost_type?: InputMaybe<Project_Cost_Types_Enum>;
  is_cost_component?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "sis_project_cost_type_metadata" */
export type Sis_Project_Cost_Type_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sis_Project_Cost_Type_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sis_Project_Cost_Type_Metadata_Stream_Cursor_Value_Input = {
  cost_type?: InputMaybe<Project_Cost_Types_Enum>;
  is_cost_component?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "sis_project_cost_type_metadata" */
export enum Sis_Project_Cost_Type_Metadata_Update_Column {
  /** column name */
  CostType = 'cost_type',
  /** column name */
  IsCostComponent = 'is_cost_component'
}

export type Sis_Project_Cost_Type_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sis_Project_Cost_Type_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sis_Project_Cost_Type_Metadata_Bool_Exp;
};

/** columns and relationships of "sis_report_postings" */
export type Sis_Report_Postings = {
  __typename?: 'sis_report_postings';
  cluster_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  in_queue_cluster: In_Queue_Clusters;
  name: Scalars['String']['output'];
  posted_at: Scalars['date']['output'];
  /** An array relationship */
  project_additional_costs: Array<Project_Additional_Costs>;
  /** An aggregate relationship */
  project_additional_costs_aggregate: Project_Additional_Costs_Aggregate;
  report_link?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "sis_report_postings" */
export type Sis_Report_PostingsProject_Additional_CostsArgs = {
  distinct_on?: InputMaybe<Array<Project_Additional_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Additional_Costs_Order_By>>;
  where?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
};


/** columns and relationships of "sis_report_postings" */
export type Sis_Report_PostingsProject_Additional_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Additional_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Additional_Costs_Order_By>>;
  where?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
};

/** aggregated selection of "sis_report_postings" */
export type Sis_Report_Postings_Aggregate = {
  __typename?: 'sis_report_postings_aggregate';
  aggregate?: Maybe<Sis_Report_Postings_Aggregate_Fields>;
  nodes: Array<Sis_Report_Postings>;
};

/** aggregate fields of "sis_report_postings" */
export type Sis_Report_Postings_Aggregate_Fields = {
  __typename?: 'sis_report_postings_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sis_Report_Postings_Max_Fields>;
  min?: Maybe<Sis_Report_Postings_Min_Fields>;
};


/** aggregate fields of "sis_report_postings" */
export type Sis_Report_Postings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sis_Report_Postings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sis_report_postings". All fields are combined with a logical 'AND'. */
export type Sis_Report_Postings_Bool_Exp = {
  _and?: InputMaybe<Array<Sis_Report_Postings_Bool_Exp>>;
  _not?: InputMaybe<Sis_Report_Postings_Bool_Exp>;
  _or?: InputMaybe<Array<Sis_Report_Postings_Bool_Exp>>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  posted_at?: InputMaybe<Date_Comparison_Exp>;
  project_additional_costs?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
  project_additional_costs_aggregate?: InputMaybe<Project_Additional_Costs_Aggregate_Bool_Exp>;
  report_link?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sis_report_postings" */
export enum Sis_Report_Postings_Constraint {
  /** unique or primary key constraint on columns "cluster_id", "name" */
  SisReportPostingsClusterIdNameKey = 'sis_report_postings_cluster_id_name_key',
  /** unique or primary key constraint on columns "id" */
  SisReportPostingsPkey = 'sis_report_postings_pkey'
}

/** input type for inserting data into table "sis_report_postings" */
export type Sis_Report_Postings_Insert_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  posted_at?: InputMaybe<Scalars['date']['input']>;
  project_additional_costs?: InputMaybe<Project_Additional_Costs_Arr_Rel_Insert_Input>;
  report_link?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Sis_Report_Postings_Max_Fields = {
  __typename?: 'sis_report_postings_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  report_link?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Sis_Report_Postings_Min_Fields = {
  __typename?: 'sis_report_postings_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  posted_at?: Maybe<Scalars['date']['output']>;
  report_link?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "sis_report_postings" */
export type Sis_Report_Postings_Mutation_Response = {
  __typename?: 'sis_report_postings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sis_Report_Postings>;
};

/** input type for inserting object relation for remote table "sis_report_postings" */
export type Sis_Report_Postings_Obj_Rel_Insert_Input = {
  data: Sis_Report_Postings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sis_Report_Postings_On_Conflict>;
};

/** on_conflict condition type for table "sis_report_postings" */
export type Sis_Report_Postings_On_Conflict = {
  constraint: Sis_Report_Postings_Constraint;
  update_columns?: Array<Sis_Report_Postings_Update_Column>;
  where?: InputMaybe<Sis_Report_Postings_Bool_Exp>;
};

/** Ordering options when selecting data from "sis_report_postings". */
export type Sis_Report_Postings_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_cluster?: InputMaybe<In_Queue_Clusters_Order_By>;
  name?: InputMaybe<Order_By>;
  posted_at?: InputMaybe<Order_By>;
  project_additional_costs_aggregate?: InputMaybe<Project_Additional_Costs_Aggregate_Order_By>;
  report_link?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sis_report_postings */
export type Sis_Report_Postings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "sis_report_postings" */
export enum Sis_Report_Postings_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostedAt = 'posted_at',
  /** column name */
  ReportLink = 'report_link'
}

/** input type for updating data in table "sis_report_postings" */
export type Sis_Report_Postings_Set_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  posted_at?: InputMaybe<Scalars['date']['input']>;
  report_link?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "sis_report_postings" */
export type Sis_Report_Postings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sis_Report_Postings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sis_Report_Postings_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  posted_at?: InputMaybe<Scalars['date']['input']>;
  report_link?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "sis_report_postings" */
export enum Sis_Report_Postings_Update_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostedAt = 'posted_at',
  /** column name */
  ReportLink = 'report_link'
}

export type Sis_Report_Postings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sis_Report_Postings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sis_Report_Postings_Bool_Exp;
};

/** columns and relationships of "subscription_add_ons" */
export type Subscription_Add_Ons = {
  __typename?: 'subscription_add_ons';
  add_on: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

/** aggregated selection of "subscription_add_ons" */
export type Subscription_Add_Ons_Aggregate = {
  __typename?: 'subscription_add_ons_aggregate';
  aggregate?: Maybe<Subscription_Add_Ons_Aggregate_Fields>;
  nodes: Array<Subscription_Add_Ons>;
};

/** aggregate fields of "subscription_add_ons" */
export type Subscription_Add_Ons_Aggregate_Fields = {
  __typename?: 'subscription_add_ons_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Subscription_Add_Ons_Max_Fields>;
  min?: Maybe<Subscription_Add_Ons_Min_Fields>;
};


/** aggregate fields of "subscription_add_ons" */
export type Subscription_Add_Ons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscription_Add_Ons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "subscription_add_ons". All fields are combined with a logical 'AND'. */
export type Subscription_Add_Ons_Bool_Exp = {
  _and?: InputMaybe<Array<Subscription_Add_Ons_Bool_Exp>>;
  _not?: InputMaybe<Subscription_Add_Ons_Bool_Exp>;
  _or?: InputMaybe<Array<Subscription_Add_Ons_Bool_Exp>>;
  add_on?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_add_ons" */
export enum Subscription_Add_Ons_Constraint {
  /** unique or primary key constraint on columns "add_on" */
  SubscriptionAddOnsPkey = 'subscription_add_ons_pkey'
}

export enum Subscription_Add_Ons_Enum {
  /** Custom upgrades */
  CustomUpgrades = 'CUSTOM_UPGRADES'
}

/** Boolean expression to compare columns of type "subscription_add_ons_enum". All fields are combined with logical 'AND'. */
export type Subscription_Add_Ons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Subscription_Add_Ons_Enum>;
  _in?: InputMaybe<Array<Subscription_Add_Ons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Subscription_Add_Ons_Enum>;
  _nin?: InputMaybe<Array<Subscription_Add_Ons_Enum>>;
};

/** input type for inserting data into table "subscription_add_ons" */
export type Subscription_Add_Ons_Insert_Input = {
  add_on?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Subscription_Add_Ons_Max_Fields = {
  __typename?: 'subscription_add_ons_max_fields';
  add_on?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Subscription_Add_Ons_Min_Fields = {
  __typename?: 'subscription_add_ons_min_fields';
  add_on?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "subscription_add_ons" */
export type Subscription_Add_Ons_Mutation_Response = {
  __typename?: 'subscription_add_ons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscription_Add_Ons>;
};

/** on_conflict condition type for table "subscription_add_ons" */
export type Subscription_Add_Ons_On_Conflict = {
  constraint: Subscription_Add_Ons_Constraint;
  update_columns?: Array<Subscription_Add_Ons_Update_Column>;
  where?: InputMaybe<Subscription_Add_Ons_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_add_ons". */
export type Subscription_Add_Ons_Order_By = {
  add_on?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscription_add_ons */
export type Subscription_Add_Ons_Pk_Columns_Input = {
  add_on: Scalars['String']['input'];
};

/** select columns of table "subscription_add_ons" */
export enum Subscription_Add_Ons_Select_Column {
  /** column name */
  AddOn = 'add_on',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "subscription_add_ons" */
export type Subscription_Add_Ons_Set_Input = {
  add_on?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "subscription_add_ons" */
export type Subscription_Add_Ons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscription_Add_Ons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscription_Add_Ons_Stream_Cursor_Value_Input = {
  add_on?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "subscription_add_ons" */
export enum Subscription_Add_Ons_Update_Column {
  /** column name */
  AddOn = 'add_on',
  /** column name */
  Description = 'description'
}

export type Subscription_Add_Ons_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscription_Add_Ons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscription_Add_Ons_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "additional_column_configs" */
  additional_column_configs: Array<Additional_Column_Configs>;
  /** fetch aggregated fields from the table: "additional_column_configs" */
  additional_column_configs_aggregate: Additional_Column_Configs_Aggregate;
  /** fetch data from the table: "additional_column_configs" using primary key columns */
  additional_column_configs_by_pk?: Maybe<Additional_Column_Configs>;
  /** fetch data from the table in a streaming manner: "additional_column_configs" */
  additional_column_configs_stream: Array<Additional_Column_Configs>;
  /** fetch data from the table: "admin_app.audit_log" */
  admin_app_audit_log: Array<Admin_App_Audit_Log>;
  /** fetch aggregated fields from the table: "admin_app.audit_log" */
  admin_app_audit_log_aggregate: Admin_App_Audit_Log_Aggregate;
  /** fetch data from the table: "admin_app.audit_log" using primary key columns */
  admin_app_audit_log_by_pk?: Maybe<Admin_App_Audit_Log>;
  /** fetch data from the table in a streaming manner: "admin_app.audit_log" */
  admin_app_audit_log_stream: Array<Admin_App_Audit_Log>;
  /** fetch data from the table: "admin_app.audit_log_targets" */
  admin_app_audit_log_targets: Array<Admin_App_Audit_Log_Targets>;
  /** fetch aggregated fields from the table: "admin_app.audit_log_targets" */
  admin_app_audit_log_targets_aggregate: Admin_App_Audit_Log_Targets_Aggregate;
  /** fetch data from the table: "admin_app.audit_log_targets" using primary key columns */
  admin_app_audit_log_targets_by_pk?: Maybe<Admin_App_Audit_Log_Targets>;
  /** fetch data from the table in a streaming manner: "admin_app.audit_log_targets" */
  admin_app_audit_log_targets_stream: Array<Admin_App_Audit_Log_Targets>;
  /** fetch data from the table: "advanced_studies" */
  advanced_studies: Array<Advanced_Studies>;
  /** fetch aggregated fields from the table: "advanced_studies" */
  advanced_studies_aggregate: Advanced_Studies_Aggregate;
  /** fetch data from the table: "advanced_studies" using primary key columns */
  advanced_studies_by_pk?: Maybe<Advanced_Studies>;
  /** fetch data from the table in a streaming manner: "advanced_studies" */
  advanced_studies_stream: Array<Advanced_Studies>;
  /** An array relationship */
  advanced_study_constraint_stacks: Array<Advanced_Study_Constraint_Stacks>;
  /** An aggregate relationship */
  advanced_study_constraint_stacks_aggregate: Advanced_Study_Constraint_Stacks_Aggregate;
  /** fetch data from the table: "advanced_study_constraint_stacks" using primary key columns */
  advanced_study_constraint_stacks_by_pk?: Maybe<Advanced_Study_Constraint_Stacks>;
  /** fetch data from the table in a streaming manner: "advanced_study_constraint_stacks" */
  advanced_study_constraint_stacks_stream: Array<Advanced_Study_Constraint_Stacks>;
  /** An array relationship */
  advanced_study_loads: Array<Advanced_Study_Loads>;
  /** An aggregate relationship */
  advanced_study_loads_aggregate: Advanced_Study_Loads_Aggregate;
  /** fetch data from the table: "advanced_study_loads" using primary key columns */
  advanced_study_loads_by_pk?: Maybe<Advanced_Study_Loads>;
  /** fetch data from the table in a streaming manner: "advanced_study_loads" */
  advanced_study_loads_stream: Array<Advanced_Study_Loads>;
  /** fetch data from the table: "all_projects" */
  all_projects: Array<All_Projects>;
  /** fetch aggregated fields from the table: "all_projects" */
  all_projects_aggregate: All_Projects_Aggregate;
  /** fetch data from the table: "all_projects" using primary key columns */
  all_projects_by_pk?: Maybe<All_Projects>;
  /** fetch data from the table in a streaming manner: "all_projects" */
  all_projects_stream: Array<All_Projects>;
  /** fetch data from the table: "branches" */
  branches: Array<Branches>;
  /** fetch aggregated fields from the table: "branches" */
  branches_aggregate: Branches_Aggregate;
  /** fetch data from the table: "branches" using primary key columns */
  branches_by_pk?: Maybe<Branches>;
  /** fetch data from the table in a streaming manner: "branches" */
  branches_stream: Array<Branches>;
  /** fetch data from the table: "brand_colors" */
  brand_colors: Array<Brand_Colors>;
  /** fetch aggregated fields from the table: "brand_colors" */
  brand_colors_aggregate: Brand_Colors_Aggregate;
  /** fetch data from the table: "brand_colors" using primary key columns */
  brand_colors_by_pk?: Maybe<Brand_Colors>;
  /** fetch data from the table in a streaming manner: "brand_colors" */
  brand_colors_stream: Array<Brand_Colors>;
  /** fetch data from the table: "bus_overrides" */
  bus_overrides: Array<Bus_Overrides>;
  /** fetch aggregated fields from the table: "bus_overrides" */
  bus_overrides_aggregate: Bus_Overrides_Aggregate;
  /** fetch data from the table: "bus_overrides" using primary key columns */
  bus_overrides_by_pk?: Maybe<Bus_Overrides>;
  /** fetch data from the table in a streaming manner: "bus_overrides" */
  bus_overrides_stream: Array<Bus_Overrides>;
  /** fetch data from the table: "buses" */
  buses: Array<Buses>;
  /** fetch aggregated fields from the table: "buses" */
  buses_aggregate: Buses_Aggregate;
  /** fetch data from the table in a streaming manner: "buses" */
  buses_stream: Array<Buses>;
  /** An array relationship */
  buses_to_scopes: Array<Buses_To_Scopes>;
  /** An aggregate relationship */
  buses_to_scopes_aggregate: Buses_To_Scopes_Aggregate;
  /** fetch data from the table: "buses_to_scopes" using primary key columns */
  buses_to_scopes_by_pk?: Maybe<Buses_To_Scopes>;
  /** fetch data from the table in a streaming manner: "buses_to_scopes" */
  buses_to_scopes_stream: Array<Buses_To_Scopes>;
  /** fetch data from the table: "buses_without_overrides" */
  buses_without_overrides: Array<Buses_Without_Overrides>;
  /** fetch aggregated fields from the table: "buses_without_overrides" */
  buses_without_overrides_aggregate: Buses_Without_Overrides_Aggregate;
  /** fetch data from the table: "buses_without_overrides" using primary key columns */
  buses_without_overrides_by_pk?: Maybe<Buses_Without_Overrides>;
  /** fetch data from the table in a streaming manner: "buses_without_overrides" */
  buses_without_overrides_stream: Array<Buses_Without_Overrides>;
  /** An array relationship */
  capacity_costs: Array<Capacity_Costs>;
  /** An aggregate relationship */
  capacity_costs_aggregate: Capacity_Costs_Aggregate;
  /** fetch data from the table: "capacity_costs" using primary key columns */
  capacity_costs_by_pk?: Maybe<Capacity_Costs>;
  /** fetch data from the table in a streaming manner: "capacity_costs" */
  capacity_costs_stream: Array<Capacity_Costs>;
  /** fetch data from the table: "ceii_access" */
  ceii_access: Array<Ceii_Access>;
  /** fetch aggregated fields from the table: "ceii_access" */
  ceii_access_aggregate: Ceii_Access_Aggregate;
  /** fetch data from the table: "ceii_access" using primary key columns */
  ceii_access_by_pk?: Maybe<Ceii_Access>;
  /** fetch data from the table in a streaming manner: "ceii_access" */
  ceii_access_stream: Array<Ceii_Access>;
  /** fetch data from the table: "cluster_current_sis_report_posting" */
  cluster_current_sis_report_posting: Array<Cluster_Current_Sis_Report_Posting>;
  /** fetch aggregated fields from the table: "cluster_current_sis_report_posting" */
  cluster_current_sis_report_posting_aggregate: Cluster_Current_Sis_Report_Posting_Aggregate;
  /** fetch data from the table in a streaming manner: "cluster_current_sis_report_posting" */
  cluster_current_sis_report_posting_stream: Array<Cluster_Current_Sis_Report_Posting>;
  /** fetch data from the table: "cluster_projects" */
  cluster_projects: Array<Cluster_Projects>;
  /** fetch aggregated fields from the table: "cluster_projects" */
  cluster_projects_aggregate: Cluster_Projects_Aggregate;
  /** fetch data from the table in a streaming manner: "cluster_projects" */
  cluster_projects_stream: Array<Cluster_Projects>;
  /** An array relationship */
  constraint_stacks: Array<Constraint_Stacks>;
  /** An aggregate relationship */
  constraint_stacks_aggregate: Constraint_Stacks_Aggregate;
  /** fetch data from the table: "constraint_stacks" using primary key columns */
  constraint_stacks_by_pk?: Maybe<Constraint_Stacks>;
  /** fetch data from the table in a streaming manner: "constraint_stacks" */
  constraint_stacks_stream: Array<Constraint_Stacks>;
  /** fetch data from the table: "constraint_types" */
  constraint_types: Array<Constraint_Types>;
  /** fetch aggregated fields from the table: "constraint_types" */
  constraint_types_aggregate: Constraint_Types_Aggregate;
  /** fetch data from the table: "constraint_types" using primary key columns */
  constraint_types_by_pk?: Maybe<Constraint_Types>;
  /** fetch data from the table in a streaming manner: "constraint_types" */
  constraint_types_stream: Array<Constraint_Types>;
  /** fetch data from the table: "current_base_scenarios" */
  current_base_scenarios: Array<Current_Base_Scenarios>;
  /** fetch aggregated fields from the table: "current_base_scenarios" */
  current_base_scenarios_aggregate: Current_Base_Scenarios_Aggregate;
  /** fetch data from the table in a streaming manner: "current_base_scenarios" */
  current_base_scenarios_stream: Array<Current_Base_Scenarios>;
  /** fetch data from the table: "current_project_sis_reported_values" */
  current_project_sis_reported_values: Array<Current_Project_Sis_Reported_Values>;
  /** fetch aggregated fields from the table: "current_project_sis_reported_values" */
  current_project_sis_reported_values_aggregate: Current_Project_Sis_Reported_Values_Aggregate;
  /** fetch data from the table in a streaming manner: "current_project_sis_reported_values" */
  current_project_sis_reported_values_stream: Array<Current_Project_Sis_Reported_Values>;
  /** An array relationship */
  custom_upgrade_files: Array<Custom_Upgrade_Files>;
  /** An aggregate relationship */
  custom_upgrade_files_aggregate: Custom_Upgrade_Files_Aggregate;
  /** fetch data from the table: "custom_upgrade_files" using primary key columns */
  custom_upgrade_files_by_pk?: Maybe<Custom_Upgrade_Files>;
  /** fetch data from the table in a streaming manner: "custom_upgrade_files" */
  custom_upgrade_files_stream: Array<Custom_Upgrade_Files>;
  /** fetch data from the table: "custom_upgrade_model_set_validation_failures" */
  custom_upgrade_model_set_validation_failures: Array<Custom_Upgrade_Model_Set_Validation_Failures>;
  /** fetch aggregated fields from the table: "custom_upgrade_model_set_validation_failures" */
  custom_upgrade_model_set_validation_failures_aggregate: Custom_Upgrade_Model_Set_Validation_Failures_Aggregate;
  /** fetch data from the table: "custom_upgrade_model_set_validation_failures" using primary key columns */
  custom_upgrade_model_set_validation_failures_by_pk?: Maybe<Custom_Upgrade_Model_Set_Validation_Failures>;
  /** fetch data from the table in a streaming manner: "custom_upgrade_model_set_validation_failures" */
  custom_upgrade_model_set_validation_failures_stream: Array<Custom_Upgrade_Model_Set_Validation_Failures>;
  /** fetch data from the table: "custom_upgrade_model_set_validations" */
  custom_upgrade_model_set_validations: Array<Custom_Upgrade_Model_Set_Validations>;
  /** fetch aggregated fields from the table: "custom_upgrade_model_set_validations" */
  custom_upgrade_model_set_validations_aggregate: Custom_Upgrade_Model_Set_Validations_Aggregate;
  /** fetch data from the table: "custom_upgrade_model_set_validations" using primary key columns */
  custom_upgrade_model_set_validations_by_pk?: Maybe<Custom_Upgrade_Model_Set_Validations>;
  /** fetch data from the table in a streaming manner: "custom_upgrade_model_set_validations" */
  custom_upgrade_model_set_validations_stream: Array<Custom_Upgrade_Model_Set_Validations>;
  /** fetch data from the table: "custom_upgrade_validation_failure_codes" */
  custom_upgrade_validation_failure_codes: Array<Custom_Upgrade_Validation_Failure_Codes>;
  /** fetch aggregated fields from the table: "custom_upgrade_validation_failure_codes" */
  custom_upgrade_validation_failure_codes_aggregate: Custom_Upgrade_Validation_Failure_Codes_Aggregate;
  /** fetch data from the table: "custom_upgrade_validation_failure_codes" using primary key columns */
  custom_upgrade_validation_failure_codes_by_pk?: Maybe<Custom_Upgrade_Validation_Failure_Codes>;
  /** fetch data from the table in a streaming manner: "custom_upgrade_validation_failure_codes" */
  custom_upgrade_validation_failure_codes_stream: Array<Custom_Upgrade_Validation_Failure_Codes>;
  /** fetch data from the table: "custom_upgrade_validation_failure_severities" */
  custom_upgrade_validation_failure_severities: Array<Custom_Upgrade_Validation_Failure_Severities>;
  /** fetch aggregated fields from the table: "custom_upgrade_validation_failure_severities" */
  custom_upgrade_validation_failure_severities_aggregate: Custom_Upgrade_Validation_Failure_Severities_Aggregate;
  /** fetch data from the table: "custom_upgrade_validation_failure_severities" using primary key columns */
  custom_upgrade_validation_failure_severities_by_pk?: Maybe<Custom_Upgrade_Validation_Failure_Severities>;
  /** fetch data from the table in a streaming manner: "custom_upgrade_validation_failure_severities" */
  custom_upgrade_validation_failure_severities_stream: Array<Custom_Upgrade_Validation_Failure_Severities>;
  /** fetch data from the table: "custom_upgrade_validation_statuses" */
  custom_upgrade_validation_statuses: Array<Custom_Upgrade_Validation_Statuses>;
  /** fetch aggregated fields from the table: "custom_upgrade_validation_statuses" */
  custom_upgrade_validation_statuses_aggregate: Custom_Upgrade_Validation_Statuses_Aggregate;
  /** fetch data from the table: "custom_upgrade_validation_statuses" using primary key columns */
  custom_upgrade_validation_statuses_by_pk?: Maybe<Custom_Upgrade_Validation_Statuses>;
  /** fetch data from the table in a streaming manner: "custom_upgrade_validation_statuses" */
  custom_upgrade_validation_statuses_stream: Array<Custom_Upgrade_Validation_Statuses>;
  /** fetch data from the table: "custom_upgrades" */
  custom_upgrades: Array<Custom_Upgrades>;
  /** fetch aggregated fields from the table: "custom_upgrades" */
  custom_upgrades_aggregate: Custom_Upgrades_Aggregate;
  /** fetch data from the table: "custom_upgrades" using primary key columns */
  custom_upgrades_by_pk?: Maybe<Custom_Upgrades>;
  /** fetch data from the table in a streaming manner: "custom_upgrades" */
  custom_upgrades_stream: Array<Custom_Upgrades>;
  /** fetch data from the table: "data_versions" */
  data_versions: Array<Data_Versions>;
  /** fetch aggregated fields from the table: "data_versions" */
  data_versions_aggregate: Data_Versions_Aggregate;
  /** fetch data from the table: "data_versions" using primary key columns */
  data_versions_by_pk?: Maybe<Data_Versions>;
  /** fetch data from the table in a streaming manner: "data_versions" */
  data_versions_stream: Array<Data_Versions>;
  /** execute function "external_api_bus" which returns "external_api_buses" */
  external_api_bus: Array<External_Api_Buses>;
  /** execute function "external_api_bus" and query aggregates on result of table type "external_api_buses" */
  external_api_bus_aggregate: External_Api_Buses_Aggregate;
  /** fetch data from the table: "external_api_buses" */
  external_api_buses: Array<External_Api_Buses>;
  /** fetch aggregated fields from the table: "external_api_buses" */
  external_api_buses_aggregate: External_Api_Buses_Aggregate;
  /** execute function "external_api_buses_page" which returns "external_api_buses" */
  external_api_buses_page: Array<External_Api_Buses>;
  /** execute function "external_api_buses_page" and query aggregates on result of table type "external_api_buses" */
  external_api_buses_page_aggregate: External_Api_Buses_Aggregate;
  /** fetch data from the table in a streaming manner: "external_api_buses" */
  external_api_buses_stream: Array<External_Api_Buses>;
  /** execute function "external_api_capacity_cost" which returns "external_api_capacity_costs" */
  external_api_capacity_cost: Array<External_Api_Capacity_Costs>;
  /** execute function "external_api_capacity_cost" and query aggregates on result of table type "external_api_capacity_costs" */
  external_api_capacity_cost_aggregate: External_Api_Capacity_Costs_Aggregate;
  /** fetch data from the table: "external_api_capacity_costs" */
  external_api_capacity_costs: Array<External_Api_Capacity_Costs>;
  /** fetch aggregated fields from the table: "external_api_capacity_costs" */
  external_api_capacity_costs_aggregate: External_Api_Capacity_Costs_Aggregate;
  /** execute function "external_api_capacity_costs_page" which returns "external_api_capacity_costs" */
  external_api_capacity_costs_page: Array<External_Api_Capacity_Costs>;
  /** execute function "external_api_capacity_costs_page" and query aggregates on result of table type "external_api_capacity_costs" */
  external_api_capacity_costs_page_aggregate: External_Api_Capacity_Costs_Aggregate;
  /** fetch data from the table in a streaming manner: "external_api_capacity_costs" */
  external_api_capacity_costs_stream: Array<External_Api_Capacity_Costs>;
  /** execute function "external_api_constraint" which returns "external_api_constraints" */
  external_api_constraint: Array<External_Api_Constraints>;
  /** execute function "external_api_constraint" and query aggregates on result of table type "external_api_constraints" */
  external_api_constraint_aggregate: External_Api_Constraints_Aggregate;
  /** fetch data from the table: "external_api_constraints" */
  external_api_constraints: Array<External_Api_Constraints>;
  /** fetch aggregated fields from the table: "external_api_constraints" */
  external_api_constraints_aggregate: External_Api_Constraints_Aggregate;
  /** execute function "external_api_constraints_page" which returns "external_api_constraints" */
  external_api_constraints_page: Array<External_Api_Constraints>;
  /** execute function "external_api_constraints_page" and query aggregates on result of table type "external_api_constraints" */
  external_api_constraints_page_aggregate: External_Api_Constraints_Aggregate;
  /** fetch data from the table in a streaming manner: "external_api_constraints" */
  external_api_constraints_stream: Array<External_Api_Constraints>;
  /** fetch data from the table: "external_api_scopes" */
  external_api_scopes: Array<External_Api_Scopes>;
  /** fetch aggregated fields from the table: "external_api_scopes" */
  external_api_scopes_aggregate: External_Api_Scopes_Aggregate;
  /** execute function "external_api_scopes_list" which returns "external_api_scopes" */
  external_api_scopes_list: Array<External_Api_Scopes>;
  /** execute function "external_api_scopes_list" and query aggregates on result of table type "external_api_scopes" */
  external_api_scopes_list_aggregate: External_Api_Scopes_Aggregate;
  /** fetch data from the table in a streaming manner: "external_api_scopes" */
  external_api_scopes_stream: Array<External_Api_Scopes>;
  /** fetch data from the table: "favorite_buses" */
  favorite_buses: Array<Favorite_Buses>;
  /** fetch aggregated fields from the table: "favorite_buses" */
  favorite_buses_aggregate: Favorite_Buses_Aggregate;
  /** fetch data from the table: "favorite_buses" using primary key columns */
  favorite_buses_by_pk?: Maybe<Favorite_Buses>;
  /** fetch data from the table in a streaming manner: "favorite_buses" */
  favorite_buses_stream: Array<Favorite_Buses>;
  /** fetch data from the table: "gtc_exposure" */
  gtc_exposure: Array<Gtc_Exposure>;
  /** fetch aggregated fields from the table: "gtc_exposure" */
  gtc_exposure_aggregate: Gtc_Exposure_Aggregate;
  /** fetch data from the table: "gtc_exposure" using primary key columns */
  gtc_exposure_by_pk?: Maybe<Gtc_Exposure>;
  /** fetch data from the table in a streaming manner: "gtc_exposure" */
  gtc_exposure_stream: Array<Gtc_Exposure>;
  /** fetch data from the table: "in_queue_cluster_model_set_statuses" */
  in_queue_cluster_model_set_statuses: Array<In_Queue_Cluster_Model_Set_Statuses>;
  /** fetch aggregated fields from the table: "in_queue_cluster_model_set_statuses" */
  in_queue_cluster_model_set_statuses_aggregate: In_Queue_Cluster_Model_Set_Statuses_Aggregate;
  /** fetch data from the table: "in_queue_cluster_model_set_statuses" using primary key columns */
  in_queue_cluster_model_set_statuses_by_pk?: Maybe<In_Queue_Cluster_Model_Set_Statuses>;
  /** fetch data from the table in a streaming manner: "in_queue_cluster_model_set_statuses" */
  in_queue_cluster_model_set_statuses_stream: Array<In_Queue_Cluster_Model_Set_Statuses>;
  /** An array relationship */
  in_queue_cluster_model_sets: Array<In_Queue_Cluster_Model_Sets>;
  /** An aggregate relationship */
  in_queue_cluster_model_sets_aggregate: In_Queue_Cluster_Model_Sets_Aggregate;
  /** fetch data from the table: "in_queue_cluster_model_sets" using primary key columns */
  in_queue_cluster_model_sets_by_pk?: Maybe<In_Queue_Cluster_Model_Sets>;
  /** fetch data from the table in a streaming manner: "in_queue_cluster_model_sets" */
  in_queue_cluster_model_sets_stream: Array<In_Queue_Cluster_Model_Sets>;
  /** fetch data from the table: "in_queue_cluster_statuses" */
  in_queue_cluster_statuses: Array<In_Queue_Cluster_Statuses>;
  /** fetch aggregated fields from the table: "in_queue_cluster_statuses" */
  in_queue_cluster_statuses_aggregate: In_Queue_Cluster_Statuses_Aggregate;
  /** fetch data from the table: "in_queue_cluster_statuses" using primary key columns */
  in_queue_cluster_statuses_by_pk?: Maybe<In_Queue_Cluster_Statuses>;
  /** fetch data from the table in a streaming manner: "in_queue_cluster_statuses" */
  in_queue_cluster_statuses_stream: Array<In_Queue_Cluster_Statuses>;
  /** fetch data from the table: "in_queue_clusters" */
  in_queue_clusters: Array<In_Queue_Clusters>;
  /** fetch aggregated fields from the table: "in_queue_clusters" */
  in_queue_clusters_aggregate: In_Queue_Clusters_Aggregate;
  /** fetch data from the table: "in_queue_clusters" using primary key columns */
  in_queue_clusters_by_pk?: Maybe<In_Queue_Clusters>;
  /** fetch data from the table in a streaming manner: "in_queue_clusters" */
  in_queue_clusters_stream: Array<In_Queue_Clusters>;
  /** fetch data from the table: "in_queue_model_pois" */
  in_queue_model_pois: Array<In_Queue_Model_Pois>;
  /** fetch aggregated fields from the table: "in_queue_model_pois" */
  in_queue_model_pois_aggregate: In_Queue_Model_Pois_Aggregate;
  /** fetch data from the table: "in_queue_model_pois" using primary key columns */
  in_queue_model_pois_by_pk?: Maybe<In_Queue_Model_Pois>;
  /** fetch data from the table in a streaming manner: "in_queue_model_pois" */
  in_queue_model_pois_stream: Array<In_Queue_Model_Pois>;
  /** fetch data from the table: "in_queue_model_variants" */
  in_queue_model_variants: Array<In_Queue_Model_Variants>;
  /** fetch aggregated fields from the table: "in_queue_model_variants" */
  in_queue_model_variants_aggregate: In_Queue_Model_Variants_Aggregate;
  /** fetch data from the table: "in_queue_model_variants" using primary key columns */
  in_queue_model_variants_by_pk?: Maybe<In_Queue_Model_Variants>;
  /** fetch data from the table in a streaming manner: "in_queue_model_variants" */
  in_queue_model_variants_stream: Array<In_Queue_Model_Variants>;
  /** fetch data from the table: "in_queue_region_model_variants" */
  in_queue_region_model_variants: Array<In_Queue_Region_Model_Variants>;
  /** fetch aggregated fields from the table: "in_queue_region_model_variants" */
  in_queue_region_model_variants_aggregate: In_Queue_Region_Model_Variants_Aggregate;
  /** fetch data from the table: "in_queue_region_model_variants" using primary key columns */
  in_queue_region_model_variants_by_pk?: Maybe<In_Queue_Region_Model_Variants>;
  /** fetch data from the table in a streaming manner: "in_queue_region_model_variants" */
  in_queue_region_model_variants_stream: Array<In_Queue_Region_Model_Variants>;
  /** An array relationship */
  in_queue_speculative_projects: Array<In_Queue_Speculative_Projects>;
  /** An aggregate relationship */
  in_queue_speculative_projects_aggregate: In_Queue_Speculative_Projects_Aggregate;
  /** fetch data from the table: "in_queue_speculative_projects" using primary key columns */
  in_queue_speculative_projects_by_pk?: Maybe<In_Queue_Speculative_Projects>;
  /** fetch data from the table in a streaming manner: "in_queue_speculative_projects" */
  in_queue_speculative_projects_stream: Array<In_Queue_Speculative_Projects>;
  /** An array relationship */
  in_queue_subscription_add_ons: Array<In_Queue_Subscription_Add_Ons>;
  /** An aggregate relationship */
  in_queue_subscription_add_ons_aggregate: In_Queue_Subscription_Add_Ons_Aggregate;
  /** fetch data from the table: "in_queue_subscription_add_ons" using primary key columns */
  in_queue_subscription_add_ons_by_pk?: Maybe<In_Queue_Subscription_Add_Ons>;
  /** fetch data from the table in a streaming manner: "in_queue_subscription_add_ons" */
  in_queue_subscription_add_ons_stream: Array<In_Queue_Subscription_Add_Ons>;
  /** An array relationship */
  in_queue_subscriptions: Array<In_Queue_Subscriptions>;
  /** An aggregate relationship */
  in_queue_subscriptions_aggregate: In_Queue_Subscriptions_Aggregate;
  /** fetch data from the table: "in_queue_subscriptions" using primary key columns */
  in_queue_subscriptions_by_pk?: Maybe<In_Queue_Subscriptions>;
  /** fetch data from the table in a streaming manner: "in_queue_subscriptions" */
  in_queue_subscriptions_stream: Array<In_Queue_Subscriptions>;
  /** An array relationship */
  line_capacity_costs: Array<Line_Capacity_Costs>;
  /** An aggregate relationship */
  line_capacity_costs_aggregate: Line_Capacity_Costs_Aggregate;
  /** fetch data from the table: "line_capacity_costs" using primary key columns */
  line_capacity_costs_by_pk?: Maybe<Line_Capacity_Costs>;
  /** fetch data from the table in a streaming manner: "line_capacity_costs" */
  line_capacity_costs_stream: Array<Line_Capacity_Costs>;
  /** An array relationship */
  line_constraint_stacks: Array<Line_Constraint_Stacks>;
  /** An aggregate relationship */
  line_constraint_stacks_aggregate: Line_Constraint_Stacks_Aggregate;
  /** fetch data from the table: "line_constraint_stacks" using primary key columns */
  line_constraint_stacks_by_pk?: Maybe<Line_Constraint_Stacks>;
  /** fetch data from the table in a streaming manner: "line_constraint_stacks" */
  line_constraint_stacks_stream: Array<Line_Constraint_Stacks>;
  /** fetch data from the table: "model_generator_facility_dfax" */
  model_generator_facility_dfax: Array<Model_Generator_Facility_Dfax>;
  /** fetch aggregated fields from the table: "model_generator_facility_dfax" */
  model_generator_facility_dfax_aggregate: Model_Generator_Facility_Dfax_Aggregate;
  /** fetch data from the table: "model_generator_facility_dfax" using primary key columns */
  model_generator_facility_dfax_by_pk?: Maybe<Model_Generator_Facility_Dfax>;
  /** fetch data from the table in a streaming manner: "model_generator_facility_dfax" */
  model_generator_facility_dfax_stream: Array<Model_Generator_Facility_Dfax>;
  /** fetch data from the table: "model_generators" */
  model_generators: Array<Model_Generators>;
  /** fetch aggregated fields from the table: "model_generators" */
  model_generators_aggregate: Model_Generators_Aggregate;
  /** fetch data from the table: "model_generators" using primary key columns */
  model_generators_by_pk?: Maybe<Model_Generators>;
  /** fetch data from the table in a streaming manner: "model_generators" */
  model_generators_stream: Array<Model_Generators>;
  /** fetch data from the table: "model_lines" */
  model_lines: Array<Model_Lines>;
  /** fetch aggregated fields from the table: "model_lines" */
  model_lines_aggregate: Model_Lines_Aggregate;
  /** fetch data from the table: "model_lines" using primary key columns */
  model_lines_by_pk?: Maybe<Model_Lines>;
  /** fetch data from the table in a streaming manner: "model_lines" */
  model_lines_stream: Array<Model_Lines>;
  /** An array relationship */
  model_lines_to_branches: Array<Model_Lines_To_Branches>;
  /** An aggregate relationship */
  model_lines_to_branches_aggregate: Model_Lines_To_Branches_Aggregate;
  /** fetch data from the table: "model_lines_to_branches" using primary key columns */
  model_lines_to_branches_by_pk?: Maybe<Model_Lines_To_Branches>;
  /** fetch data from the table in a streaming manner: "model_lines_to_branches" */
  model_lines_to_branches_stream: Array<Model_Lines_To_Branches>;
  /** fetch data from the table: "model_lines_to_missing_buses" */
  model_lines_to_missing_buses: Array<Model_Lines_To_Missing_Buses>;
  /** fetch aggregated fields from the table: "model_lines_to_missing_buses" */
  model_lines_to_missing_buses_aggregate: Model_Lines_To_Missing_Buses_Aggregate;
  /** fetch data from the table: "model_lines_to_missing_buses" using primary key columns */
  model_lines_to_missing_buses_by_pk?: Maybe<Model_Lines_To_Missing_Buses>;
  /** fetch data from the table in a streaming manner: "model_lines_to_missing_buses" */
  model_lines_to_missing_buses_stream: Array<Model_Lines_To_Missing_Buses>;
  /** fetch data from the table: "planned_interconnection_locations" */
  planned_interconnection_locations: Array<Planned_Interconnection_Locations>;
  /** fetch aggregated fields from the table: "planned_interconnection_locations" */
  planned_interconnection_locations_aggregate: Planned_Interconnection_Locations_Aggregate;
  /** fetch data from the table: "planned_interconnection_locations" using primary key columns */
  planned_interconnection_locations_by_pk?: Maybe<Planned_Interconnection_Locations>;
  /** fetch data from the table in a streaming manner: "planned_interconnection_locations" */
  planned_interconnection_locations_stream: Array<Planned_Interconnection_Locations>;
  /** An array relationship */
  project_additional_costs: Array<Project_Additional_Costs>;
  /** An aggregate relationship */
  project_additional_costs_aggregate: Project_Additional_Costs_Aggregate;
  /** fetch data from the table: "project_additional_costs" using primary key columns */
  project_additional_costs_by_pk?: Maybe<Project_Additional_Costs>;
  /** fetch data from the table in a streaming manner: "project_additional_costs" */
  project_additional_costs_stream: Array<Project_Additional_Costs>;
  /** fetch data from the table: "project_configurations" */
  project_configurations: Array<Project_Configurations>;
  /** fetch aggregated fields from the table: "project_configurations" */
  project_configurations_aggregate: Project_Configurations_Aggregate;
  /** fetch data from the table: "project_configurations" using primary key columns */
  project_configurations_by_pk?: Maybe<Project_Configurations>;
  /** fetch data from the table in a streaming manner: "project_configurations" */
  project_configurations_stream: Array<Project_Configurations>;
  /** fetch data from the table: "project_cost_sources" */
  project_cost_sources: Array<Project_Cost_Sources>;
  /** fetch aggregated fields from the table: "project_cost_sources" */
  project_cost_sources_aggregate: Project_Cost_Sources_Aggregate;
  /** fetch data from the table: "project_cost_sources" using primary key columns */
  project_cost_sources_by_pk?: Maybe<Project_Cost_Sources>;
  /** fetch data from the table in a streaming manner: "project_cost_sources" */
  project_cost_sources_stream: Array<Project_Cost_Sources>;
  /** fetch data from the table: "project_cost_types" */
  project_cost_types: Array<Project_Cost_Types>;
  /** fetch aggregated fields from the table: "project_cost_types" */
  project_cost_types_aggregate: Project_Cost_Types_Aggregate;
  /** fetch data from the table: "project_cost_types" using primary key columns */
  project_cost_types_by_pk?: Maybe<Project_Cost_Types>;
  /** fetch data from the table in a streaming manner: "project_cost_types" */
  project_cost_types_stream: Array<Project_Cost_Types>;
  /** fetch data from the table: "project_tag_assignments" */
  project_tag_assignments: Array<Project_Tag_Assignments>;
  /** fetch aggregated fields from the table: "project_tag_assignments" */
  project_tag_assignments_aggregate: Project_Tag_Assignments_Aggregate;
  /** fetch data from the table: "project_tag_assignments" using primary key columns */
  project_tag_assignments_by_pk?: Maybe<Project_Tag_Assignments>;
  /** fetch data from the table in a streaming manner: "project_tag_assignments" */
  project_tag_assignments_stream: Array<Project_Tag_Assignments>;
  /** fetch data from the table: "project_tags" */
  project_tags: Array<Project_Tags>;
  /** fetch aggregated fields from the table: "project_tags" */
  project_tags_aggregate: Project_Tags_Aggregate;
  /** fetch data from the table: "project_tags" using primary key columns */
  project_tags_by_pk?: Maybe<Project_Tags>;
  /** fetch data from the table in a streaming manner: "project_tags" */
  project_tags_stream: Array<Project_Tags>;
  /** fetch data from the table: "queue_project_connection_points" */
  queue_project_connection_points: Array<Queue_Project_Connection_Points>;
  /** fetch aggregated fields from the table: "queue_project_connection_points" */
  queue_project_connection_points_aggregate: Queue_Project_Connection_Points_Aggregate;
  /** fetch data from the table: "queue_project_connection_points" using primary key columns */
  queue_project_connection_points_by_pk?: Maybe<Queue_Project_Connection_Points>;
  /** fetch data from the table in a streaming manner: "queue_project_connection_points" */
  queue_project_connection_points_stream: Array<Queue_Project_Connection_Points>;
  /** fetch data from the table: "queue_project_connection_types" */
  queue_project_connection_types: Array<Queue_Project_Connection_Types>;
  /** fetch aggregated fields from the table: "queue_project_connection_types" */
  queue_project_connection_types_aggregate: Queue_Project_Connection_Types_Aggregate;
  /** fetch data from the table: "queue_project_connection_types" using primary key columns */
  queue_project_connection_types_by_pk?: Maybe<Queue_Project_Connection_Types>;
  /** fetch data from the table in a streaming manner: "queue_project_connection_types" */
  queue_project_connection_types_stream: Array<Queue_Project_Connection_Types>;
  /** fetch data from the table: "queue_project_facility_dfax" */
  queue_project_facility_dfax: Array<Queue_Project_Facility_Dfax>;
  /** fetch aggregated fields from the table: "queue_project_facility_dfax" */
  queue_project_facility_dfax_aggregate: Queue_Project_Facility_Dfax_Aggregate;
  /** fetch data from the table: "queue_project_facility_dfax" using primary key columns */
  queue_project_facility_dfax_by_pk?: Maybe<Queue_Project_Facility_Dfax>;
  /** fetch data from the table in a streaming manner: "queue_project_facility_dfax" */
  queue_project_facility_dfax_stream: Array<Queue_Project_Facility_Dfax>;
  /** An array relationship */
  queue_project_hops: Array<Queue_Project_Hops>;
  /** An aggregate relationship */
  queue_project_hops_aggregate: Queue_Project_Hops_Aggregate;
  /** fetch data from the table: "queue_project_hops" using primary key columns */
  queue_project_hops_by_pk?: Maybe<Queue_Project_Hops>;
  /** fetch data from the table in a streaming manner: "queue_project_hops" */
  queue_project_hops_stream: Array<Queue_Project_Hops>;
  /** fetch data from the table: "queue_projects" */
  queue_projects: Array<Queue_Projects>;
  /** fetch aggregated fields from the table: "queue_projects" */
  queue_projects_aggregate: Queue_Projects_Aggregate;
  /** fetch data from the table: "queue_projects" using primary key columns */
  queue_projects_by_pk?: Maybe<Queue_Projects>;
  /** fetch data from the table in a streaming manner: "queue_projects" */
  queue_projects_stream: Array<Queue_Projects>;
  /** An array relationship */
  scenario_allocated_upgrades: Array<Scenario_Allocated_Upgrades>;
  /** An aggregate relationship */
  scenario_allocated_upgrades_aggregate: Scenario_Allocated_Upgrades_Aggregate;
  /** fetch data from the table: "scenario_allocated_upgrades" using primary key columns */
  scenario_allocated_upgrades_by_pk?: Maybe<Scenario_Allocated_Upgrades>;
  /** fetch data from the table in a streaming manner: "scenario_allocated_upgrades" */
  scenario_allocated_upgrades_stream: Array<Scenario_Allocated_Upgrades>;
  /** fetch data from the table: "scenario_configurations" */
  scenario_configurations: Array<Scenario_Configurations>;
  /** fetch aggregated fields from the table: "scenario_configurations" */
  scenario_configurations_aggregate: Scenario_Configurations_Aggregate;
  /** fetch data from the table: "scenario_configurations" using primary key columns */
  scenario_configurations_by_pk?: Maybe<Scenario_Configurations>;
  /** fetch data from the table in a streaming manner: "scenario_configurations" */
  scenario_configurations_stream: Array<Scenario_Configurations>;
  /** An array relationship */
  scenario_constraints: Array<Scenario_Constraints>;
  /** An aggregate relationship */
  scenario_constraints_aggregate: Scenario_Constraints_Aggregate;
  /** fetch data from the table: "scenario_constraints" using primary key columns */
  scenario_constraints_by_pk?: Maybe<Scenario_Constraints>;
  /** fetch data from the table in a streaming manner: "scenario_constraints" */
  scenario_constraints_stream: Array<Scenario_Constraints>;
  /** fetch data from the table: "scenario_origins" */
  scenario_origins: Array<Scenario_Origins>;
  /** fetch aggregated fields from the table: "scenario_origins" */
  scenario_origins_aggregate: Scenario_Origins_Aggregate;
  /** fetch data from the table: "scenario_origins" using primary key columns */
  scenario_origins_by_pk?: Maybe<Scenario_Origins>;
  /** fetch data from the table in a streaming manner: "scenario_origins" */
  scenario_origins_stream: Array<Scenario_Origins>;
  /** fetch data from the table: "scenario_project_ranks" */
  scenario_project_ranks: Array<Scenario_Project_Ranks>;
  /** fetch aggregated fields from the table: "scenario_project_ranks" */
  scenario_project_ranks_aggregate: Scenario_Project_Ranks_Aggregate;
  /** fetch data from the table: "scenario_project_ranks" using primary key columns */
  scenario_project_ranks_by_pk?: Maybe<Scenario_Project_Ranks>;
  /** fetch data from the table in a streaming manner: "scenario_project_ranks" */
  scenario_project_ranks_stream: Array<Scenario_Project_Ranks>;
  /** An array relationship */
  scenario_projects: Array<Scenario_Projects>;
  /** An aggregate relationship */
  scenario_projects_aggregate: Scenario_Projects_Aggregate;
  /** fetch data from the table: "scenario_projects" using primary key columns */
  scenario_projects_by_pk?: Maybe<Scenario_Projects>;
  /** fetch data from the table in a streaming manner: "scenario_projects" */
  scenario_projects_stream: Array<Scenario_Projects>;
  /** fetch data from the table: "scenario_statuses" */
  scenario_statuses: Array<Scenario_Statuses>;
  /** fetch aggregated fields from the table: "scenario_statuses" */
  scenario_statuses_aggregate: Scenario_Statuses_Aggregate;
  /** fetch data from the table: "scenario_statuses" using primary key columns */
  scenario_statuses_by_pk?: Maybe<Scenario_Statuses>;
  /** fetch data from the table in a streaming manner: "scenario_statuses" */
  scenario_statuses_stream: Array<Scenario_Statuses>;
  /** An array relationship */
  scenarios: Array<Scenarios>;
  /** An aggregate relationship */
  scenarios_aggregate: Scenarios_Aggregate;
  /** fetch data from the table: "scenarios" using primary key columns */
  scenarios_by_pk?: Maybe<Scenarios>;
  /** fetch data from the table in a streaming manner: "scenarios" */
  scenarios_stream: Array<Scenarios>;
  /** An array relationship */
  scopes: Array<Scopes>;
  /** An aggregate relationship */
  scopes_aggregate: Scopes_Aggregate;
  /** fetch data from the table: "scopes" using primary key columns */
  scopes_by_pk?: Maybe<Scopes>;
  /** fetch data from the table in a streaming manner: "scopes" */
  scopes_stream: Array<Scopes>;
  /** An array relationship */
  screening_views: Array<Screening_Views>;
  /** An aggregate relationship */
  screening_views_aggregate: Screening_Views_Aggregate;
  /** fetch data from the table: "screening_views" using primary key columns */
  screening_views_by_pk?: Maybe<Screening_Views>;
  /** fetch data from the table in a streaming manner: "screening_views" */
  screening_views_stream: Array<Screening_Views>;
  /** fetch data from the table: "sis_project_cost_type_metadata" */
  sis_project_cost_type_metadata: Array<Sis_Project_Cost_Type_Metadata>;
  /** fetch aggregated fields from the table: "sis_project_cost_type_metadata" */
  sis_project_cost_type_metadata_aggregate: Sis_Project_Cost_Type_Metadata_Aggregate;
  /** fetch data from the table: "sis_project_cost_type_metadata" using primary key columns */
  sis_project_cost_type_metadata_by_pk?: Maybe<Sis_Project_Cost_Type_Metadata>;
  /** fetch data from the table in a streaming manner: "sis_project_cost_type_metadata" */
  sis_project_cost_type_metadata_stream: Array<Sis_Project_Cost_Type_Metadata>;
  /** fetch data from the table: "sis_report_postings" */
  sis_report_postings: Array<Sis_Report_Postings>;
  /** fetch aggregated fields from the table: "sis_report_postings" */
  sis_report_postings_aggregate: Sis_Report_Postings_Aggregate;
  /** fetch data from the table: "sis_report_postings" using primary key columns */
  sis_report_postings_by_pk?: Maybe<Sis_Report_Postings>;
  /** fetch data from the table in a streaming manner: "sis_report_postings" */
  sis_report_postings_stream: Array<Sis_Report_Postings>;
  /** fetch data from the table: "subscription_add_ons" */
  subscription_add_ons: Array<Subscription_Add_Ons>;
  /** fetch aggregated fields from the table: "subscription_add_ons" */
  subscription_add_ons_aggregate: Subscription_Add_Ons_Aggregate;
  /** fetch data from the table: "subscription_add_ons" using primary key columns */
  subscription_add_ons_by_pk?: Maybe<Subscription_Add_Ons>;
  /** fetch data from the table in a streaming manner: "subscription_add_ons" */
  subscription_add_ons_stream: Array<Subscription_Add_Ons>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table in a streaming manner: "subscriptions" */
  subscriptions_stream: Array<Subscriptions>;
  /** fetch data from the table: "teams" */
  teams: Array<Teams>;
  /** fetch aggregated fields from the table: "teams" */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** fetch data from the table in a streaming manner: "teams" */
  teams_stream: Array<Teams>;
  /** An array relationship */
  tracked_projects: Array<Tracked_Projects>;
  /** An aggregate relationship */
  tracked_projects_aggregate: Tracked_Projects_Aggregate;
  /** fetch data from the table: "tracked_projects" using primary key columns */
  tracked_projects_by_pk?: Maybe<Tracked_Projects>;
  /** fetch data from the table in a streaming manner: "tracked_projects" */
  tracked_projects_stream: Array<Tracked_Projects>;
  /** An array relationship */
  unlocked_buses: Array<Unlocked_Buses>;
  /** An aggregate relationship */
  unlocked_buses_aggregate: Unlocked_Buses_Aggregate;
  /** fetch data from the table: "unlocked_buses" using primary key columns */
  unlocked_buses_by_pk?: Maybe<Unlocked_Buses>;
  /** fetch data from the table in a streaming manner: "unlocked_buses" */
  unlocked_buses_stream: Array<Unlocked_Buses>;
  /** fetch data from the table: "user_scope_configs" */
  user_scope_configs: Array<User_Scope_Configs>;
  /** fetch aggregated fields from the table: "user_scope_configs" */
  user_scope_configs_aggregate: User_Scope_Configs_Aggregate;
  /** fetch data from the table: "user_scope_configs" using primary key columns */
  user_scope_configs_by_pk?: Maybe<User_Scope_Configs>;
  /** fetch data from the table in a streaming manner: "user_scope_configs" */
  user_scope_configs_stream: Array<User_Scope_Configs>;
  /** fetch data from the table: "user_scope_permissions" */
  user_scope_permissions: Array<User_Scope_Permissions>;
  /** fetch aggregated fields from the table: "user_scope_permissions" */
  user_scope_permissions_aggregate: User_Scope_Permissions_Aggregate;
  /** fetch data from the table in a streaming manner: "user_scope_permissions" */
  user_scope_permissions_stream: Array<User_Scope_Permissions>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootAdditional_Column_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Additional_Column_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Additional_Column_Configs_Order_By>>;
  where?: InputMaybe<Additional_Column_Configs_Bool_Exp>;
};


export type Subscription_RootAdditional_Column_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Additional_Column_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Additional_Column_Configs_Order_By>>;
  where?: InputMaybe<Additional_Column_Configs_Bool_Exp>;
};


export type Subscription_RootAdditional_Column_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdditional_Column_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Additional_Column_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Additional_Column_Configs_Bool_Exp>;
};


export type Subscription_RootAdmin_App_Audit_LogArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Bool_Exp>;
};


export type Subscription_RootAdmin_App_Audit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Bool_Exp>;
};


export type Subscription_RootAdmin_App_Audit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdmin_App_Audit_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_App_Audit_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_App_Audit_Log_Bool_Exp>;
};


export type Subscription_RootAdmin_App_Audit_Log_TargetsArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
};


export type Subscription_RootAdmin_App_Audit_Log_Targets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Admin_App_Audit_Log_Targets_Order_By>>;
  where?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
};


export type Subscription_RootAdmin_App_Audit_Log_Targets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAdmin_App_Audit_Log_Targets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Admin_App_Audit_Log_Targets_Stream_Cursor_Input>>;
  where?: InputMaybe<Admin_App_Audit_Log_Targets_Bool_Exp>;
};


export type Subscription_RootAdvanced_StudiesArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Studies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Studies_Order_By>>;
  where?: InputMaybe<Advanced_Studies_Bool_Exp>;
};


export type Subscription_RootAdvanced_Studies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Studies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Studies_Order_By>>;
  where?: InputMaybe<Advanced_Studies_Bool_Exp>;
};


export type Subscription_RootAdvanced_Studies_By_PkArgs = {
  advanced_study_id: Scalars['uuid']['input'];
};


export type Subscription_RootAdvanced_Studies_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Advanced_Studies_Stream_Cursor_Input>>;
  where?: InputMaybe<Advanced_Studies_Bool_Exp>;
};


export type Subscription_RootAdvanced_Study_Constraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
};


export type Subscription_RootAdvanced_Study_Constraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
};


export type Subscription_RootAdvanced_Study_Constraint_Stacks_By_PkArgs = {
  advanced_study_id: Scalars['uuid']['input'];
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
};


export type Subscription_RootAdvanced_Study_Constraint_Stacks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Advanced_Study_Constraint_Stacks_Stream_Cursor_Input>>;
  where?: InputMaybe<Advanced_Study_Constraint_Stacks_Bool_Exp>;
};


export type Subscription_RootAdvanced_Study_LoadsArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Loads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Loads_Order_By>>;
  where?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
};


export type Subscription_RootAdvanced_Study_Loads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advanced_Study_Loads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Advanced_Study_Loads_Order_By>>;
  where?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
};


export type Subscription_RootAdvanced_Study_Loads_By_PkArgs = {
  advanced_study_id: Scalars['uuid']['input'];
  facility_type: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
};


export type Subscription_RootAdvanced_Study_Loads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Advanced_Study_Loads_Stream_Cursor_Input>>;
  where?: InputMaybe<Advanced_Study_Loads_Bool_Exp>;
};


export type Subscription_RootAll_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<All_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<All_Projects_Order_By>>;
  where?: InputMaybe<All_Projects_Bool_Exp>;
};


export type Subscription_RootAll_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<All_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<All_Projects_Order_By>>;
  where?: InputMaybe<All_Projects_Bool_Exp>;
};


export type Subscription_RootAll_Projects_By_PkArgs = {
  cluster_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
};


export type Subscription_RootAll_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<All_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<All_Projects_Bool_Exp>;
};


export type Subscription_RootBranchesArgs = {
  distinct_on?: InputMaybe<Array<Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Branches_Order_By>>;
  where?: InputMaybe<Branches_Bool_Exp>;
};


export type Subscription_RootBranches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Branches_Order_By>>;
  where?: InputMaybe<Branches_Bool_Exp>;
};


export type Subscription_RootBranches_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootBranches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Branches_Stream_Cursor_Input>>;
  where?: InputMaybe<Branches_Bool_Exp>;
};


export type Subscription_RootBrand_ColorsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Colors_Order_By>>;
  where?: InputMaybe<Brand_Colors_Bool_Exp>;
};


export type Subscription_RootBrand_Colors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Colors_Order_By>>;
  where?: InputMaybe<Brand_Colors_Bool_Exp>;
};


export type Subscription_RootBrand_Colors_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootBrand_Colors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Colors_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Colors_Bool_Exp>;
};


export type Subscription_RootBus_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Bus_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bus_Overrides_Order_By>>;
  where?: InputMaybe<Bus_Overrides_Bool_Exp>;
};


export type Subscription_RootBus_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bus_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bus_Overrides_Order_By>>;
  where?: InputMaybe<Bus_Overrides_Bool_Exp>;
};


export type Subscription_RootBus_Overrides_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBus_Overrides_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bus_Overrides_Stream_Cursor_Input>>;
  where?: InputMaybe<Bus_Overrides_Bool_Exp>;
};


export type Subscription_RootBusesArgs = {
  distinct_on?: InputMaybe<Array<Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_Order_By>>;
  where?: InputMaybe<Buses_Bool_Exp>;
};


export type Subscription_RootBuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_Order_By>>;
  where?: InputMaybe<Buses_Bool_Exp>;
};


export type Subscription_RootBuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buses_Stream_Cursor_Input>>;
  where?: InputMaybe<Buses_Bool_Exp>;
};


export type Subscription_RootBuses_To_ScopesArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


export type Subscription_RootBuses_To_Scopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buses_To_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_To_Scopes_Order_By>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


export type Subscription_RootBuses_To_Scopes_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Subscription_RootBuses_To_Scopes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buses_To_Scopes_Stream_Cursor_Input>>;
  where?: InputMaybe<Buses_To_Scopes_Bool_Exp>;
};


export type Subscription_RootBuses_Without_OverridesArgs = {
  distinct_on?: InputMaybe<Array<Buses_Without_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_Without_Overrides_Order_By>>;
  where?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
};


export type Subscription_RootBuses_Without_Overrides_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buses_Without_Overrides_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buses_Without_Overrides_Order_By>>;
  where?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
};


export type Subscription_RootBuses_Without_Overrides_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
};


export type Subscription_RootBuses_Without_Overrides_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buses_Without_Overrides_Stream_Cursor_Input>>;
  where?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
};


export type Subscription_RootCapacity_CostsArgs = {
  distinct_on?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capacity_Costs_Order_By>>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootCapacity_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Capacity_Costs_Order_By>>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootCapacity_Costs_By_PkArgs = {
  energy_size: Scalars['numeric']['input'];
  includes_pre_existing: Scalars['Boolean']['input'];
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Subscription_RootCapacity_Costs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Capacity_Costs_Stream_Cursor_Input>>;
  where?: InputMaybe<Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootCeii_AccessArgs = {
  distinct_on?: InputMaybe<Array<Ceii_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ceii_Access_Order_By>>;
  where?: InputMaybe<Ceii_Access_Bool_Exp>;
};


export type Subscription_RootCeii_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ceii_Access_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ceii_Access_Order_By>>;
  where?: InputMaybe<Ceii_Access_Bool_Exp>;
};


export type Subscription_RootCeii_Access_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCeii_Access_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ceii_Access_Stream_Cursor_Input>>;
  where?: InputMaybe<Ceii_Access_Bool_Exp>;
};


export type Subscription_RootCluster_Current_Sis_Report_PostingArgs = {
  distinct_on?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Order_By>>;
  where?: InputMaybe<Cluster_Current_Sis_Report_Posting_Bool_Exp>;
};


export type Subscription_RootCluster_Current_Sis_Report_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cluster_Current_Sis_Report_Posting_Order_By>>;
  where?: InputMaybe<Cluster_Current_Sis_Report_Posting_Bool_Exp>;
};


export type Subscription_RootCluster_Current_Sis_Report_Posting_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cluster_Current_Sis_Report_Posting_Stream_Cursor_Input>>;
  where?: InputMaybe<Cluster_Current_Sis_Report_Posting_Bool_Exp>;
};


export type Subscription_RootCluster_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Cluster_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cluster_Projects_Order_By>>;
  where?: InputMaybe<Cluster_Projects_Bool_Exp>;
};


export type Subscription_RootCluster_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cluster_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cluster_Projects_Order_By>>;
  where?: InputMaybe<Cluster_Projects_Bool_Exp>;
};


export type Subscription_RootCluster_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cluster_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Cluster_Projects_Bool_Exp>;
};


export type Subscription_RootConstraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};


export type Subscription_RootConstraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};


export type Subscription_RootConstraint_Stacks_By_PkArgs = {
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  resource_type: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Subscription_RootConstraint_Stacks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Constraint_Stacks_Stream_Cursor_Input>>;
  where?: InputMaybe<Constraint_Stacks_Bool_Exp>;
};


export type Subscription_RootConstraint_TypesArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Types_Order_By>>;
  where?: InputMaybe<Constraint_Types_Bool_Exp>;
};


export type Subscription_RootConstraint_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Constraint_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Constraint_Types_Order_By>>;
  where?: InputMaybe<Constraint_Types_Bool_Exp>;
};


export type Subscription_RootConstraint_Types_By_PkArgs = {
  constraint_type: Scalars['String']['input'];
};


export type Subscription_RootConstraint_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Constraint_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Constraint_Types_Bool_Exp>;
};


export type Subscription_RootCurrent_Base_ScenariosArgs = {
  distinct_on?: InputMaybe<Array<Current_Base_Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Base_Scenarios_Order_By>>;
  where?: InputMaybe<Current_Base_Scenarios_Bool_Exp>;
};


export type Subscription_RootCurrent_Base_Scenarios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Current_Base_Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Base_Scenarios_Order_By>>;
  where?: InputMaybe<Current_Base_Scenarios_Bool_Exp>;
};


export type Subscription_RootCurrent_Base_Scenarios_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Current_Base_Scenarios_Stream_Cursor_Input>>;
  where?: InputMaybe<Current_Base_Scenarios_Bool_Exp>;
};


export type Subscription_RootCurrent_Project_Sis_Reported_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Order_By>>;
  where?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
};


export type Subscription_RootCurrent_Project_Sis_Reported_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Project_Sis_Reported_Values_Order_By>>;
  where?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
};


export type Subscription_RootCurrent_Project_Sis_Reported_Values_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Current_Project_Sis_Reported_Values_Stream_Cursor_Input>>;
  where?: InputMaybe<Current_Project_Sis_Reported_Values_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_FilesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Files_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Files_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Upgrade_Files_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Upgrade_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Upgrade_Files_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Model_Set_Validation_FailuresArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Model_Set_Validation_Failures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validation_Failures_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Model_Set_Validation_Failures_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Upgrade_Model_Set_Validation_Failures_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validation_Failures_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Model_Set_ValidationsArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Model_Set_Validations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Model_Set_Validations_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Model_Set_Validations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Upgrade_Model_Set_Validations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Upgrade_Model_Set_Validations_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Upgrade_Model_Set_Validations_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Validation_Failure_CodesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Validation_Failure_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Codes_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Validation_Failure_Codes_By_PkArgs = {
  code: Scalars['String']['input'];
};


export type Subscription_RootCustom_Upgrade_Validation_Failure_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Codes_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Validation_Failure_SeveritiesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Validation_Failure_Severities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Failure_Severities_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Validation_Failure_Severities_By_PkArgs = {
  severity: Scalars['String']['input'];
};


export type Subscription_RootCustom_Upgrade_Validation_Failure_Severities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Failure_Severities_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Validation_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Statuses_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Validation_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrade_Validation_Statuses_Order_By>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Statuses_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrade_Validation_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootCustom_Upgrade_Validation_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Upgrade_Validation_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Upgrade_Validation_Statuses_Bool_Exp>;
};


export type Subscription_RootCustom_UpgradesArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrades_Order_By>>;
  where?: InputMaybe<Custom_Upgrades_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Custom_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Custom_Upgrades_Order_By>>;
  where?: InputMaybe<Custom_Upgrades_Bool_Exp>;
};


export type Subscription_RootCustom_Upgrades_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCustom_Upgrades_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Custom_Upgrades_Stream_Cursor_Input>>;
  where?: InputMaybe<Custom_Upgrades_Bool_Exp>;
};


export type Subscription_RootData_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Data_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Versions_Order_By>>;
  where?: InputMaybe<Data_Versions_Bool_Exp>;
};


export type Subscription_RootData_Versions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Data_Versions_Order_By>>;
  where?: InputMaybe<Data_Versions_Bool_Exp>;
};


export type Subscription_RootData_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootData_Versions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Data_Versions_Stream_Cursor_Input>>;
  where?: InputMaybe<Data_Versions_Bool_Exp>;
};


export type Subscription_RootExternal_Api_BusArgs = {
  args: External_Api_Bus_Args;
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Bus_AggregateArgs = {
  args: External_Api_Bus_Args;
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Subscription_RootExternal_Api_BusesArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Buses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Buses_PageArgs = {
  args: External_Api_Buses_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Buses_Page_AggregateArgs = {
  args: External_Api_Buses_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Buses_Order_By>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Buses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<External_Api_Buses_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Api_Buses_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Capacity_CostArgs = {
  args: External_Api_Capacity_Cost_Args;
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Capacity_Cost_AggregateArgs = {
  args: External_Api_Capacity_Cost_Args;
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Capacity_CostsArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Capacity_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Capacity_Costs_PageArgs = {
  args: External_Api_Capacity_Costs_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Capacity_Costs_Page_AggregateArgs = {
  args: External_Api_Capacity_Costs_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Capacity_Costs_Order_By>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Capacity_Costs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<External_Api_Capacity_Costs_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Api_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootExternal_Api_ConstraintArgs = {
  args: External_Api_Constraint_Args;
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Constraint_AggregateArgs = {
  args: External_Api_Constraint_Args;
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Subscription_RootExternal_Api_ConstraintsArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Constraints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Constraints_PageArgs = {
  args: External_Api_Constraints_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Constraints_Page_AggregateArgs = {
  args: External_Api_Constraints_Page_Args;
  distinct_on?: InputMaybe<Array<External_Api_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Constraints_Order_By>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Constraints_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<External_Api_Constraints_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Api_Constraints_Bool_Exp>;
};


export type Subscription_RootExternal_Api_ScopesArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Scopes_Order_By>>;
  where?: InputMaybe<External_Api_Scopes_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Scopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Api_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Scopes_Order_By>>;
  where?: InputMaybe<External_Api_Scopes_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Scopes_ListArgs = {
  args: External_Api_Scopes_List_Args;
  distinct_on?: InputMaybe<Array<External_Api_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Scopes_Order_By>>;
  where?: InputMaybe<External_Api_Scopes_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Scopes_List_AggregateArgs = {
  args: External_Api_Scopes_List_Args;
  distinct_on?: InputMaybe<Array<External_Api_Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Api_Scopes_Order_By>>;
  where?: InputMaybe<External_Api_Scopes_Bool_Exp>;
};


export type Subscription_RootExternal_Api_Scopes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<External_Api_Scopes_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Api_Scopes_Bool_Exp>;
};


export type Subscription_RootFavorite_BusesArgs = {
  distinct_on?: InputMaybe<Array<Favorite_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_Buses_Order_By>>;
  where?: InputMaybe<Favorite_Buses_Bool_Exp>;
};


export type Subscription_RootFavorite_Buses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorite_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Favorite_Buses_Order_By>>;
  where?: InputMaybe<Favorite_Buses_Bool_Exp>;
};


export type Subscription_RootFavorite_Buses_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFavorite_Buses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Favorite_Buses_Stream_Cursor_Input>>;
  where?: InputMaybe<Favorite_Buses_Bool_Exp>;
};


export type Subscription_RootGtc_ExposureArgs = {
  distinct_on?: InputMaybe<Array<Gtc_Exposure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gtc_Exposure_Order_By>>;
  where?: InputMaybe<Gtc_Exposure_Bool_Exp>;
};


export type Subscription_RootGtc_Exposure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gtc_Exposure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Gtc_Exposure_Order_By>>;
  where?: InputMaybe<Gtc_Exposure_Bool_Exp>;
};


export type Subscription_RootGtc_Exposure_By_PkArgs = {
  interface_acronym: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  region: Scalars['String']['input'];
  source_case: Scalars['String']['input'];
};


export type Subscription_RootGtc_Exposure_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Gtc_Exposure_Stream_Cursor_Input>>;
  where?: InputMaybe<Gtc_Exposure_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Cluster_Model_Set_StatusesArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Cluster_Model_Set_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Set_Statuses_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Cluster_Model_Set_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootIn_Queue_Cluster_Model_Set_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Set_Statuses_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Cluster_Model_SetsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Cluster_Model_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Model_Sets_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Cluster_Model_Sets_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIn_Queue_Cluster_Model_Sets_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Cluster_Model_Sets_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Cluster_Model_Sets_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Cluster_StatusesArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Statuses_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Statuses_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Cluster_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Cluster_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Cluster_Statuses_Order_By>>;
  where?: InputMaybe<In_Queue_Cluster_Statuses_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Cluster_Statuses_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootIn_Queue_Cluster_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Cluster_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Cluster_Statuses_Bool_Exp>;
};


export type Subscription_RootIn_Queue_ClustersArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Clusters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Clusters_Order_By>>;
  where?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Clusters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Clusters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Clusters_Order_By>>;
  where?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Clusters_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIn_Queue_Clusters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Clusters_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Clusters_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Model_PoisArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Model_Pois_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Model_Pois_Order_By>>;
  where?: InputMaybe<In_Queue_Model_Pois_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Model_Pois_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Model_Pois_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Model_Pois_Order_By>>;
  where?: InputMaybe<In_Queue_Model_Pois_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Model_Pois_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIn_Queue_Model_Pois_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Model_Pois_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Model_Pois_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Model_VariantsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Model_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Model_Variants_By_PkArgs = {
  variant: Scalars['String']['input'];
};


export type Subscription_RootIn_Queue_Model_Variants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Model_Variants_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Model_Variants_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Region_Model_VariantsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Region_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Region_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Region_Model_Variants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Region_Model_Variants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Region_Model_Variants_Order_By>>;
  where?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Region_Model_Variants_By_PkArgs = {
  region: Scalars['String']['input'];
  variant: In_Queue_Model_Variants_Enum;
};


export type Subscription_RootIn_Queue_Region_Model_Variants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Region_Model_Variants_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Region_Model_Variants_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Speculative_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Speculative_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Speculative_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Speculative_Projects_Order_By>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Speculative_Projects_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIn_Queue_Speculative_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Speculative_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Speculative_Projects_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Subscription_Add_OnsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Subscription_Add_Ons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Subscription_Add_Ons_By_PkArgs = {
  add_on: Subscription_Add_Ons_Enum;
  subscription_id: Scalars['uuid']['input'];
};


export type Subscription_RootIn_Queue_Subscription_Add_Ons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Subscription_Add_Ons_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Subscription_Add_Ons_Bool_Exp>;
};


export type Subscription_RootIn_Queue_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscriptions_Order_By>>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscriptions_Order_By>>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};


export type Subscription_RootIn_Queue_Subscriptions_By_PkArgs = {
  subscription_id: Scalars['uuid']['input'];
};


export type Subscription_RootIn_Queue_Subscriptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<In_Queue_Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};


export type Subscription_RootLine_Capacity_CostsArgs = {
  distinct_on?: InputMaybe<Array<Line_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Capacity_Costs_Order_By>>;
  where?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootLine_Capacity_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Capacity_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Capacity_Costs_Order_By>>;
  where?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootLine_Capacity_Costs_By_PkArgs = {
  energy_size: Scalars['numeric']['input'];
  includes_pre_existing: Scalars['Boolean']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  tap_facility_id: Scalars['String']['input'];
};


export type Subscription_RootLine_Capacity_Costs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Line_Capacity_Costs_Stream_Cursor_Input>>;
  where?: InputMaybe<Line_Capacity_Costs_Bool_Exp>;
};


export type Subscription_RootLine_Constraint_StacksArgs = {
  distinct_on?: InputMaybe<Array<Line_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
};


export type Subscription_RootLine_Constraint_Stacks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Line_Constraint_Stacks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Line_Constraint_Stacks_Order_By>>;
  where?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
};


export type Subscription_RootLine_Constraint_Stacks_By_PkArgs = {
  monitored_facility_id: Scalars['String']['input'];
  resource_type: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  tap_facility_id: Scalars['String']['input'];
};


export type Subscription_RootLine_Constraint_Stacks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Line_Constraint_Stacks_Stream_Cursor_Input>>;
  where?: InputMaybe<Line_Constraint_Stacks_Bool_Exp>;
};


export type Subscription_RootModel_Generator_Facility_DfaxArgs = {
  distinct_on?: InputMaybe<Array<Model_Generator_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generator_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
};


export type Subscription_RootModel_Generator_Facility_Dfax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Generator_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generator_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
};


export type Subscription_RootModel_Generator_Facility_Dfax_By_PkArgs = {
  contingency: Scalars['String']['input'];
  monitored_facility_id: Scalars['String']['input'];
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};


export type Subscription_RootModel_Generator_Facility_Dfax_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Model_Generator_Facility_Dfax_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Generator_Facility_Dfax_Bool_Exp>;
};


export type Subscription_RootModel_GeneratorsArgs = {
  distinct_on?: InputMaybe<Array<Model_Generators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generators_Order_By>>;
  where?: InputMaybe<Model_Generators_Bool_Exp>;
};


export type Subscription_RootModel_Generators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Generators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Generators_Order_By>>;
  where?: InputMaybe<Model_Generators_Bool_Exp>;
};


export type Subscription_RootModel_Generators_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};


export type Subscription_RootModel_Generators_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Model_Generators_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Generators_Bool_Exp>;
};


export type Subscription_RootModel_LinesArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_Order_By>>;
  where?: InputMaybe<Model_Lines_Bool_Exp>;
};


export type Subscription_RootModel_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_Order_By>>;
  where?: InputMaybe<Model_Lines_Bool_Exp>;
};


export type Subscription_RootModel_Lines_By_PkArgs = {
  facility_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Subscription_RootModel_Lines_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Model_Lines_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Lines_Bool_Exp>;
};


export type Subscription_RootModel_Lines_To_BranchesArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Branches_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
};


export type Subscription_RootModel_Lines_To_Branches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Branches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Branches_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
};


export type Subscription_RootModel_Lines_To_Branches_By_PkArgs = {
  branch_id: Scalars['String']['input'];
  facility_id: Scalars['String']['input'];
  region: Scalars['String']['input'];
};


export type Subscription_RootModel_Lines_To_Branches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Model_Lines_To_Branches_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Lines_To_Branches_Bool_Exp>;
};


export type Subscription_RootModel_Lines_To_Missing_BusesArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Missing_Buses_Bool_Exp>;
};


export type Subscription_RootModel_Lines_To_Missing_Buses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Model_Lines_To_Missing_Buses_Order_By>>;
  where?: InputMaybe<Model_Lines_To_Missing_Buses_Bool_Exp>;
};


export type Subscription_RootModel_Lines_To_Missing_Buses_By_PkArgs = {
  facility_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Subscription_RootModel_Lines_To_Missing_Buses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Model_Lines_To_Missing_Buses_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Lines_To_Missing_Buses_Bool_Exp>;
};


export type Subscription_RootPlanned_Interconnection_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Planned_Interconnection_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planned_Interconnection_Locations_Order_By>>;
  where?: InputMaybe<Planned_Interconnection_Locations_Bool_Exp>;
};


export type Subscription_RootPlanned_Interconnection_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Planned_Interconnection_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planned_Interconnection_Locations_Order_By>>;
  where?: InputMaybe<Planned_Interconnection_Locations_Bool_Exp>;
};


export type Subscription_RootPlanned_Interconnection_Locations_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
};


export type Subscription_RootPlanned_Interconnection_Locations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Planned_Interconnection_Locations_Stream_Cursor_Input>>;
  where?: InputMaybe<Planned_Interconnection_Locations_Bool_Exp>;
};


export type Subscription_RootProject_Additional_CostsArgs = {
  distinct_on?: InputMaybe<Array<Project_Additional_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Additional_Costs_Order_By>>;
  where?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
};


export type Subscription_RootProject_Additional_Costs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Additional_Costs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Additional_Costs_Order_By>>;
  where?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
};


export type Subscription_RootProject_Additional_Costs_By_PkArgs = {
  cost_type: Project_Cost_Types_Enum;
  posting_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
  source: Project_Cost_Sources_Enum;
};


export type Subscription_RootProject_Additional_Costs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Additional_Costs_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Additional_Costs_Bool_Exp>;
};


export type Subscription_RootProject_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Configurations_Order_By>>;
  where?: InputMaybe<Project_Configurations_Bool_Exp>;
};


export type Subscription_RootProject_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Configurations_Order_By>>;
  where?: InputMaybe<Project_Configurations_Bool_Exp>;
};


export type Subscription_RootProject_Configurations_By_PkArgs = {
  cluster_id: Scalars['uuid']['input'];
  project_id: Scalars['String']['input'];
  team_id: Scalars['Int']['input'];
};


export type Subscription_RootProject_Configurations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Configurations_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Configurations_Bool_Exp>;
};


export type Subscription_RootProject_Cost_SourcesArgs = {
  distinct_on?: InputMaybe<Array<Project_Cost_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Cost_Sources_Order_By>>;
  where?: InputMaybe<Project_Cost_Sources_Bool_Exp>;
};


export type Subscription_RootProject_Cost_Sources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Cost_Sources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Cost_Sources_Order_By>>;
  where?: InputMaybe<Project_Cost_Sources_Bool_Exp>;
};


export type Subscription_RootProject_Cost_Sources_By_PkArgs = {
  source: Scalars['String']['input'];
};


export type Subscription_RootProject_Cost_Sources_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Cost_Sources_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Cost_Sources_Bool_Exp>;
};


export type Subscription_RootProject_Cost_TypesArgs = {
  distinct_on?: InputMaybe<Array<Project_Cost_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Cost_Types_Order_By>>;
  where?: InputMaybe<Project_Cost_Types_Bool_Exp>;
};


export type Subscription_RootProject_Cost_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Cost_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Cost_Types_Order_By>>;
  where?: InputMaybe<Project_Cost_Types_Bool_Exp>;
};


export type Subscription_RootProject_Cost_Types_By_PkArgs = {
  cost_type: Scalars['String']['input'];
};


export type Subscription_RootProject_Cost_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Cost_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Cost_Types_Bool_Exp>;
};


export type Subscription_RootProject_Tag_AssignmentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tag_Assignments_Order_By>>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};


export type Subscription_RootProject_Tag_Assignments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tag_Assignments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tag_Assignments_Order_By>>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};


export type Subscription_RootProject_Tag_Assignments_By_PkArgs = {
  project_id: Scalars['String']['input'];
  tag_id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Tag_Assignments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Tag_Assignments_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Tag_Assignments_Bool_Exp>;
};


export type Subscription_RootProject_TagsArgs = {
  distinct_on?: InputMaybe<Array<Project_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tags_Order_By>>;
  where?: InputMaybe<Project_Tags_Bool_Exp>;
};


export type Subscription_RootProject_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Project_Tags_Order_By>>;
  where?: InputMaybe<Project_Tags_Bool_Exp>;
};


export type Subscription_RootProject_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProject_Tags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Project_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Tags_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Connection_PointsArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Points_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Points_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Connection_Points_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Points_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Points_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Connection_Points_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQueue_Project_Connection_Points_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Queue_Project_Connection_Points_Stream_Cursor_Input>>;
  where?: InputMaybe<Queue_Project_Connection_Points_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Connection_TypesArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Types_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Types_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Connection_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Connection_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Connection_Types_Order_By>>;
  where?: InputMaybe<Queue_Project_Connection_Types_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Connection_Types_By_PkArgs = {
  connection_type: Scalars['String']['input'];
};


export type Subscription_RootQueue_Project_Connection_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Queue_Project_Connection_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Queue_Project_Connection_Types_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Facility_DfaxArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Facility_Dfax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Facility_Dfax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Facility_Dfax_Order_By>>;
  where?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Facility_Dfax_By_PkArgs = {
  contingency: Scalars['String']['input'];
  monitored_facility_id: Scalars['String']['input'];
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
};


export type Subscription_RootQueue_Project_Facility_Dfax_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Queue_Project_Facility_Dfax_Stream_Cursor_Input>>;
  where?: InputMaybe<Queue_Project_Facility_Dfax_Bool_Exp>;
};


export type Subscription_RootQueue_Project_HopsArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Hops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Hops_Order_By>>;
  where?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Hops_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Project_Hops_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Project_Hops_Order_By>>;
  where?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
};


export type Subscription_RootQueue_Project_Hops_By_PkArgs = {
  nira_bus_id: Scalars['String']['input'];
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Subscription_RootQueue_Project_Hops_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Queue_Project_Hops_Stream_Cursor_Input>>;
  where?: InputMaybe<Queue_Project_Hops_Bool_Exp>;
};


export type Subscription_RootQueue_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Queue_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Projects_Order_By>>;
  where?: InputMaybe<Queue_Projects_Bool_Exp>;
};


export type Subscription_RootQueue_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Queue_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Queue_Projects_Order_By>>;
  where?: InputMaybe<Queue_Projects_Bool_Exp>;
};


export type Subscription_RootQueue_Projects_By_PkArgs = {
  project_number: Scalars['String']['input'];
  region: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
};


export type Subscription_RootQueue_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Queue_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Queue_Projects_Bool_Exp>;
};


export type Subscription_RootScenario_Allocated_UpgradesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Allocated_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Allocated_Upgrades_Order_By>>;
  where?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
};


export type Subscription_RootScenario_Allocated_Upgrades_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Allocated_Upgrades_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Allocated_Upgrades_Order_By>>;
  where?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
};


export type Subscription_RootScenario_Allocated_Upgrades_By_PkArgs = {
  constraint_type: Constraint_Types_Enum;
  network_upgrade_id: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};


export type Subscription_RootScenario_Allocated_Upgrades_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Allocated_Upgrades_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Allocated_Upgrades_Bool_Exp>;
};


export type Subscription_RootScenario_ConfigurationsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Configurations_Order_By>>;
  where?: InputMaybe<Scenario_Configurations_Bool_Exp>;
};


export type Subscription_RootScenario_Configurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Configurations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Configurations_Order_By>>;
  where?: InputMaybe<Scenario_Configurations_Bool_Exp>;
};


export type Subscription_RootScenario_Configurations_By_PkArgs = {
  scenario_id: Scalars['uuid']['input'];
  team_id: Scalars['Int']['input'];
};


export type Subscription_RootScenario_Configurations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Configurations_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Configurations_Bool_Exp>;
};


export type Subscription_RootScenario_ConstraintsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Constraints_Order_By>>;
  where?: InputMaybe<Scenario_Constraints_Bool_Exp>;
};


export type Subscription_RootScenario_Constraints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Constraints_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Constraints_Order_By>>;
  where?: InputMaybe<Scenario_Constraints_Bool_Exp>;
};


export type Subscription_RootScenario_Constraints_By_PkArgs = {
  constraint_type: Constraint_Types_Enum;
  facility_id: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
  worst_contingency_name: Scalars['String']['input'];
};


export type Subscription_RootScenario_Constraints_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Constraints_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Constraints_Bool_Exp>;
};


export type Subscription_RootScenario_OriginsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Origins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Origins_Order_By>>;
  where?: InputMaybe<Scenario_Origins_Bool_Exp>;
};


export type Subscription_RootScenario_Origins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Origins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Origins_Order_By>>;
  where?: InputMaybe<Scenario_Origins_Bool_Exp>;
};


export type Subscription_RootScenario_Origins_By_PkArgs = {
  origin: Scalars['String']['input'];
};


export type Subscription_RootScenario_Origins_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Origins_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Origins_Bool_Exp>;
};


export type Subscription_RootScenario_Project_RanksArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Project_Ranks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Project_Ranks_Order_By>>;
  where?: InputMaybe<Scenario_Project_Ranks_Bool_Exp>;
};


export type Subscription_RootScenario_Project_Ranks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Project_Ranks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Project_Ranks_Order_By>>;
  where?: InputMaybe<Scenario_Project_Ranks_Bool_Exp>;
};


export type Subscription_RootScenario_Project_Ranks_By_PkArgs = {
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};


export type Subscription_RootScenario_Project_Ranks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Project_Ranks_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Project_Ranks_Bool_Exp>;
};


export type Subscription_RootScenario_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Projects_Order_By>>;
  where?: InputMaybe<Scenario_Projects_Bool_Exp>;
};


export type Subscription_RootScenario_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Projects_Order_By>>;
  where?: InputMaybe<Scenario_Projects_Bool_Exp>;
};


export type Subscription_RootScenario_Projects_By_PkArgs = {
  project_id: Scalars['String']['input'];
  scenario_id: Scalars['uuid']['input'];
};


export type Subscription_RootScenario_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Projects_Bool_Exp>;
};


export type Subscription_RootScenario_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Statuses_Order_By>>;
  where?: InputMaybe<Scenario_Statuses_Bool_Exp>;
};


export type Subscription_RootScenario_Statuses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenario_Statuses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenario_Statuses_Order_By>>;
  where?: InputMaybe<Scenario_Statuses_Bool_Exp>;
};


export type Subscription_RootScenario_Statuses_By_PkArgs = {
  status: Scalars['String']['input'];
};


export type Subscription_RootScenario_Statuses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenario_Statuses_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenario_Statuses_Bool_Exp>;
};


export type Subscription_RootScenariosArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Subscription_RootScenarios_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scenarios_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scenarios_Order_By>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Subscription_RootScenarios_By_PkArgs = {
  scenario_id: Scalars['uuid']['input'];
};


export type Subscription_RootScenarios_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scenarios_Stream_Cursor_Input>>;
  where?: InputMaybe<Scenarios_Bool_Exp>;
};


export type Subscription_RootScopesArgs = {
  distinct_on?: InputMaybe<Array<Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scopes_Order_By>>;
  where?: InputMaybe<Scopes_Bool_Exp>;
};


export type Subscription_RootScopes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scopes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Scopes_Order_By>>;
  where?: InputMaybe<Scopes_Bool_Exp>;
};


export type Subscription_RootScopes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootScopes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Scopes_Stream_Cursor_Input>>;
  where?: InputMaybe<Scopes_Bool_Exp>;
};


export type Subscription_RootScreening_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Screening_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screening_Views_Order_By>>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};


export type Subscription_RootScreening_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Screening_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screening_Views_Order_By>>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};


export type Subscription_RootScreening_Views_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootScreening_Views_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Screening_Views_Stream_Cursor_Input>>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};


export type Subscription_RootSis_Project_Cost_Type_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Order_By>>;
  where?: InputMaybe<Sis_Project_Cost_Type_Metadata_Bool_Exp>;
};


export type Subscription_RootSis_Project_Cost_Type_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sis_Project_Cost_Type_Metadata_Order_By>>;
  where?: InputMaybe<Sis_Project_Cost_Type_Metadata_Bool_Exp>;
};


export type Subscription_RootSis_Project_Cost_Type_Metadata_By_PkArgs = {
  cost_type: Project_Cost_Types_Enum;
};


export type Subscription_RootSis_Project_Cost_Type_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sis_Project_Cost_Type_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Sis_Project_Cost_Type_Metadata_Bool_Exp>;
};


export type Subscription_RootSis_Report_PostingsArgs = {
  distinct_on?: InputMaybe<Array<Sis_Report_Postings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sis_Report_Postings_Order_By>>;
  where?: InputMaybe<Sis_Report_Postings_Bool_Exp>;
};


export type Subscription_RootSis_Report_Postings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sis_Report_Postings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sis_Report_Postings_Order_By>>;
  where?: InputMaybe<Sis_Report_Postings_Bool_Exp>;
};


export type Subscription_RootSis_Report_Postings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSis_Report_Postings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sis_Report_Postings_Stream_Cursor_Input>>;
  where?: InputMaybe<Sis_Report_Postings_Bool_Exp>;
};


export type Subscription_RootSubscription_Add_OnsArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<Subscription_Add_Ons_Bool_Exp>;
};


export type Subscription_RootSubscription_Add_Ons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscription_Add_Ons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscription_Add_Ons_Order_By>>;
  where?: InputMaybe<Subscription_Add_Ons_Bool_Exp>;
};


export type Subscription_RootSubscription_Add_Ons_By_PkArgs = {
  add_on: Scalars['String']['input'];
};


export type Subscription_RootSubscription_Add_Ons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscription_Add_Ons_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscription_Add_Ons_Bool_Exp>;
};


export type Subscription_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSubscriptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootTeams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTracked_ProjectsArgs = {
  distinct_on?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tracked_Projects_Order_By>>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};


export type Subscription_RootTracked_Projects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tracked_Projects_Order_By>>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};


export type Subscription_RootTracked_Projects_By_PkArgs = {
  project_id: Scalars['String']['input'];
  subscription_id: Scalars['uuid']['input'];
};


export type Subscription_RootTracked_Projects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tracked_Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};


export type Subscription_RootUnlocked_BusesArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};


export type Subscription_RootUnlocked_Buses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};


export type Subscription_RootUnlocked_Buses_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUnlocked_Buses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Unlocked_Buses_Stream_Cursor_Input>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};


export type Subscription_RootUser_Scope_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Configs_Order_By>>;
  where?: InputMaybe<User_Scope_Configs_Bool_Exp>;
};


export type Subscription_RootUser_Scope_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Configs_Order_By>>;
  where?: InputMaybe<User_Scope_Configs_Bool_Exp>;
};


export type Subscription_RootUser_Scope_Configs_By_PkArgs = {
  scope: Scalars['String']['input'];
};


export type Subscription_RootUser_Scope_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Scope_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Scope_Configs_Bool_Exp>;
};


export type Subscription_RootUser_Scope_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Scope_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Scope_Permissions_Order_By>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Scope_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Scope_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  auth0_id: Scalars['String']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "subscriptions" */
export type Subscriptions = {
  __typename?: 'subscriptions';
  created_at: Scalars['timestamptz']['output'];
  end_date: Scalars['date']['output'];
  has_arcgis_access: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  num_buses: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int']['output'];
  unlimited: Scalars['Boolean']['output'];
  /** An array relationship */
  unlocked_buses: Array<Unlocked_Buses>;
  /** An aggregate relationship */
  unlocked_buses_aggregate: Unlocked_Buses_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsUnlocked_BusesArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsUnlocked_Buses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unlocked_Buses_Order_By>>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};

/** aggregated selection of "subscriptions" */
export type Subscriptions_Aggregate = {
  __typename?: 'subscriptions_aggregate';
  aggregate?: Maybe<Subscriptions_Aggregate_Fields>;
  nodes: Array<Subscriptions>;
};

export type Subscriptions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_Fields = {
  __typename?: 'subscriptions_aggregate_fields';
  avg?: Maybe<Subscriptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Max_Fields>;
  min?: Maybe<Subscriptions_Min_Fields>;
  stddev?: Maybe<Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Variance_Fields>;
};


/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscriptions" */
export type Subscriptions_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscriptions" */
export type Subscriptions_Arr_Rel_Insert_Input = {
  data: Array<Subscriptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};

/** aggregate avg on columns */
export type Subscriptions_Avg_Fields = {
  __typename?: 'subscriptions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_buses?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscriptions" */
export type Subscriptions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions". All fields are combined with a logical 'AND'. */
export type Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  has_arcgis_access?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  num_buses?: InputMaybe<Int_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
  unlimited?: InputMaybe<Boolean_Comparison_Exp>;
  unlocked_buses?: InputMaybe<Unlocked_Buses_Bool_Exp>;
  unlocked_buses_aggregate?: InputMaybe<Unlocked_Buses_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions" */
export enum Subscriptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPkey = 'subscriptions_pkey',
  /** unique or primary key constraint on columns "region", "team_id" */
  SubscriptionsTeamIdRegionIdx = 'subscriptions_team_id_region_idx'
}

/** input type for incrementing numeric columns in table "subscriptions" */
export type Subscriptions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  num_buses?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscriptions" */
export type Subscriptions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  has_arcgis_access?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  num_buses?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  unlimited?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked_buses?: InputMaybe<Unlocked_Buses_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subscriptions_Max_Fields = {
  __typename?: 'subscriptions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  num_buses?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "subscriptions" */
export type Subscriptions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Min_Fields = {
  __typename?: 'subscriptions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  num_buses?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "subscriptions" */
export type Subscriptions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions" */
export type Subscriptions_Mutation_Response = {
  __typename?: 'subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions>;
};

/** input type for inserting object relation for remote table "subscriptions" */
export type Subscriptions_Obj_Rel_Insert_Input = {
  data: Subscriptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};

/** on_conflict condition type for table "subscriptions" */
export type Subscriptions_On_Conflict = {
  constraint: Subscriptions_Constraint;
  update_columns?: Array<Subscriptions_Update_Column>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions". */
export type Subscriptions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  has_arcgis_access?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  unlimited?: InputMaybe<Order_By>;
  unlocked_buses_aggregate?: InputMaybe<Unlocked_Buses_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions */
export type Subscriptions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscriptions" */
export enum Subscriptions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  HasArcgisAccess = 'has_arcgis_access',
  /** column name */
  Id = 'id',
  /** column name */
  NumBuses = 'num_buses',
  /** column name */
  Region = 'region',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Unlimited = 'unlimited',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "subscriptions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscriptions" */
export enum Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasArcgisAccess = 'has_arcgis_access',
  /** column name */
  Unlimited = 'unlimited'
}

/** select "subscriptions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscriptions" */
export enum Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasArcgisAccess = 'has_arcgis_access',
  /** column name */
  Unlimited = 'unlimited'
}

/** input type for updating data in table "subscriptions" */
export type Subscriptions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  has_arcgis_access?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  num_buses?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  unlimited?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Stddev_Fields = {
  __typename?: 'subscriptions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_buses?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_buses?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_buses?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions" */
export type Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  has_arcgis_access?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  num_buses?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
  unlimited?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Sum_Fields = {
  __typename?: 'subscriptions_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  num_buses?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscriptions" */
export type Subscriptions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions" */
export enum Subscriptions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  HasArcgisAccess = 'has_arcgis_access',
  /** column name */
  Id = 'id',
  /** column name */
  NumBuses = 'num_buses',
  /** column name */
  Region = 'region',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Unlimited = 'unlimited',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Var_Pop_Fields = {
  __typename?: 'subscriptions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_buses?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscriptions" */
export type Subscriptions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Var_Samp_Fields = {
  __typename?: 'subscriptions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_buses?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscriptions" */
export type Subscriptions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscriptions_Variance_Fields = {
  __typename?: 'subscriptions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  num_buses?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscriptions" */
export type Subscriptions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  num_buses?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "teams" */
export type Teams = {
  __typename?: 'teams';
  arcgis_group_id?: Maybe<Scalars['String']['output']>;
  auth0_client_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  exclude_from_emails: Scalars['Boolean']['output'];
  feature_flags: Scalars['jsonb']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  in_queue_subscriptions: Array<In_Queue_Subscriptions>;
  /** An aggregate relationship */
  in_queue_subscriptions_aggregate: In_Queue_Subscriptions_Aggregate;
  is_nira: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  screening_views: Array<Screening_Views>;
  /** An aggregate relationship */
  screening_views_aggregate: Screening_Views_Aggregate;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "teams" */
export type TeamsFeature_FlagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "teams" */
export type TeamsIn_Queue_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscriptions_Order_By>>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsIn_Queue_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<In_Queue_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<In_Queue_Subscriptions_Order_By>>;
  where?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsScreening_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Screening_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screening_Views_Order_By>>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsScreening_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Screening_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screening_Views_Order_By>>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "teams" */
export type TeamsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "teams" */
export type Teams_Aggregate = {
  __typename?: 'teams_aggregate';
  aggregate?: Maybe<Teams_Aggregate_Fields>;
  nodes: Array<Teams>;
};

/** aggregate fields of "teams" */
export type Teams_Aggregate_Fields = {
  __typename?: 'teams_aggregate_fields';
  avg?: Maybe<Teams_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Teams_Max_Fields>;
  min?: Maybe<Teams_Min_Fields>;
  stddev?: Maybe<Teams_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Sum_Fields>;
  var_pop?: Maybe<Teams_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Var_Samp_Fields>;
  variance?: Maybe<Teams_Variance_Fields>;
};


/** aggregate fields of "teams" */
export type Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Teams_Append_Input = {
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Teams_Avg_Fields = {
  __typename?: 'teams_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Bool_Exp>>;
  _not?: InputMaybe<Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Bool_Exp>>;
  arcgis_group_id?: InputMaybe<String_Comparison_Exp>;
  auth0_client_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exclude_from_emails?: InputMaybe<Boolean_Comparison_Exp>;
  feature_flags?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  in_queue_subscriptions?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
  in_queue_subscriptions_aggregate?: InputMaybe<In_Queue_Subscriptions_Aggregate_Bool_Exp>;
  is_nira?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  screening_views?: InputMaybe<Screening_Views_Bool_Exp>;
  screening_views_aggregate?: InputMaybe<Screening_Views_Aggregate_Bool_Exp>;
  stripe_customer_id?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "teams" */
export enum Teams_Constraint {
  /** unique or primary key constraint on columns "auth0_client_id" */
  TeamsAuth0ClientIdKey = 'teams_auth0_client_id_key',
  /** unique or primary key constraint on columns "id" */
  TeamsPkey = 'teams_pkey',
  /** unique or primary key constraint on columns "is_nira" */
  TeamsSingleNira = 'teams_single_nira'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Teams_Delete_At_Path_Input = {
  feature_flags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Teams_Delete_Elem_Input = {
  feature_flags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Teams_Delete_Key_Input = {
  feature_flags?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "teams" */
export type Teams_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "teams" */
export type Teams_Insert_Input = {
  arcgis_group_id?: InputMaybe<Scalars['String']['input']>;
  auth0_client_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exclude_from_emails?: InputMaybe<Scalars['Boolean']['input']>;
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  in_queue_subscriptions?: InputMaybe<In_Queue_Subscriptions_Arr_Rel_Insert_Input>;
  is_nira?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  screening_views?: InputMaybe<Screening_Views_Arr_Rel_Insert_Input>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<Subscriptions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Teams_Max_Fields = {
  __typename?: 'teams_max_fields';
  arcgis_group_id?: Maybe<Scalars['String']['output']>;
  auth0_client_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Teams_Min_Fields = {
  __typename?: 'teams_min_fields';
  arcgis_group_id?: Maybe<Scalars['String']['output']>;
  auth0_client_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "teams" */
export type Teams_Mutation_Response = {
  __typename?: 'teams_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams>;
};

/** input type for inserting object relation for remote table "teams" */
export type Teams_Obj_Rel_Insert_Input = {
  data: Teams_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** on_conflict condition type for table "teams" */
export type Teams_On_Conflict = {
  constraint: Teams_Constraint;
  update_columns?: Array<Teams_Update_Column>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "teams". */
export type Teams_Order_By = {
  arcgis_group_id?: InputMaybe<Order_By>;
  auth0_client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  exclude_from_emails?: InputMaybe<Order_By>;
  feature_flags?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_queue_subscriptions_aggregate?: InputMaybe<In_Queue_Subscriptions_Aggregate_Order_By>;
  is_nira?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  screening_views_aggregate?: InputMaybe<Screening_Views_Aggregate_Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: teams */
export type Teams_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Teams_Prepend_Input = {
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "teams" */
export enum Teams_Select_Column {
  /** column name */
  ArcgisGroupId = 'arcgis_group_id',
  /** column name */
  Auth0ClientId = 'auth0_client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExcludeFromEmails = 'exclude_from_emails',
  /** column name */
  FeatureFlags = 'feature_flags',
  /** column name */
  Id = 'id',
  /** column name */
  IsNira = 'is_nira',
  /** column name */
  Name = 'name',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "teams" */
export type Teams_Set_Input = {
  arcgis_group_id?: InputMaybe<Scalars['String']['input']>;
  auth0_client_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exclude_from_emails?: InputMaybe<Scalars['Boolean']['input']>;
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_nira?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Teams_Stddev_Fields = {
  __typename?: 'teams_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Teams_Stddev_Pop_Fields = {
  __typename?: 'teams_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Teams_Stddev_Samp_Fields = {
  __typename?: 'teams_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "teams" */
export type Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Stream_Cursor_Value_Input = {
  arcgis_group_id?: InputMaybe<Scalars['String']['input']>;
  auth0_client_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  exclude_from_emails?: InputMaybe<Scalars['Boolean']['input']>;
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_nira?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Teams_Sum_Fields = {
  __typename?: 'teams_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "teams" */
export enum Teams_Update_Column {
  /** column name */
  ArcgisGroupId = 'arcgis_group_id',
  /** column name */
  Auth0ClientId = 'auth0_client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExcludeFromEmails = 'exclude_from_emails',
  /** column name */
  FeatureFlags = 'feature_flags',
  /** column name */
  Id = 'id',
  /** column name */
  IsNira = 'is_nira',
  /** column name */
  Name = 'name',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Teams_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Teams_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_Var_Pop_Fields = {
  __typename?: 'teams_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Teams_Var_Samp_Fields = {
  __typename?: 'teams_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Teams_Variance_Fields = {
  __typename?: 'teams_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "tracked_projects" */
export type Tracked_Projects = {
  __typename?: 'tracked_projects';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  in_queue_subscription: In_Queue_Subscriptions;
  project_id: Scalars['String']['output'];
  project_name?: Maybe<Scalars['String']['output']>;
  requires_benchmark: Scalars['Boolean']['output'];
  subscription_id: Scalars['uuid']['output'];
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "tracked_projects" */
export type Tracked_Projects_Aggregate = {
  __typename?: 'tracked_projects_aggregate';
  aggregate?: Maybe<Tracked_Projects_Aggregate_Fields>;
  nodes: Array<Tracked_Projects>;
};

export type Tracked_Projects_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Tracked_Projects_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Tracked_Projects_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Tracked_Projects_Aggregate_Bool_Exp_Count>;
};

export type Tracked_Projects_Aggregate_Bool_Exp_Bool_And = {
  arguments: Tracked_Projects_Select_Column_Tracked_Projects_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tracked_Projects_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tracked_Projects_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Tracked_Projects_Select_Column_Tracked_Projects_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tracked_Projects_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Tracked_Projects_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tracked_Projects_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tracked_projects" */
export type Tracked_Projects_Aggregate_Fields = {
  __typename?: 'tracked_projects_aggregate_fields';
  avg?: Maybe<Tracked_Projects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tracked_Projects_Max_Fields>;
  min?: Maybe<Tracked_Projects_Min_Fields>;
  stddev?: Maybe<Tracked_Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Tracked_Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tracked_Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Tracked_Projects_Sum_Fields>;
  var_pop?: Maybe<Tracked_Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Tracked_Projects_Var_Samp_Fields>;
  variance?: Maybe<Tracked_Projects_Variance_Fields>;
};


/** aggregate fields of "tracked_projects" */
export type Tracked_Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tracked_Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tracked_projects" */
export type Tracked_Projects_Aggregate_Order_By = {
  avg?: InputMaybe<Tracked_Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tracked_Projects_Max_Order_By>;
  min?: InputMaybe<Tracked_Projects_Min_Order_By>;
  stddev?: InputMaybe<Tracked_Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tracked_Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tracked_Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tracked_Projects_Sum_Order_By>;
  var_pop?: InputMaybe<Tracked_Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tracked_Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<Tracked_Projects_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tracked_projects" */
export type Tracked_Projects_Arr_Rel_Insert_Input = {
  data: Array<Tracked_Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tracked_Projects_On_Conflict>;
};

/** aggregate avg on columns */
export type Tracked_Projects_Avg_Fields = {
  __typename?: 'tracked_projects_avg_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tracked_projects" */
export type Tracked_Projects_Avg_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tracked_projects". All fields are combined with a logical 'AND'. */
export type Tracked_Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Tracked_Projects_Bool_Exp>>;
  _not?: InputMaybe<Tracked_Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Tracked_Projects_Bool_Exp>>;
  cluster_id?: InputMaybe<Uuid_Comparison_Exp>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  requires_benchmark?: InputMaybe<Boolean_Comparison_Exp>;
  subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "tracked_projects" */
export enum Tracked_Projects_Constraint {
  /** unique or primary key constraint on columns "cluster_id", "project_id", "team_id" */
  TrackedProjectsClusterTeamProjectIdx = 'tracked_projects_cluster_team_project_idx',
  /** unique or primary key constraint on columns "subscription_id", "project_id" */
  TrackedProjectsPkey = 'tracked_projects_pkey',
  /** unique or primary key constraint on columns "project_name", "subscription_id" */
  TrackedProjectsSubscriptionIdProjectNameKey = 'tracked_projects_subscription_id_project_name_key'
}

/** input type for incrementing numeric columns in table "tracked_projects" */
export type Tracked_Projects_Inc_Input = {
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tracked_projects" */
export type Tracked_Projects_Insert_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  requires_benchmark?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Tracked_Projects_Max_Fields = {
  __typename?: 'tracked_projects_max_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "tracked_projects" */
export type Tracked_Projects_Max_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tracked_Projects_Min_Fields = {
  __typename?: 'tracked_projects_min_fields';
  cluster_id?: Maybe<Scalars['uuid']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "tracked_projects" */
export type Tracked_Projects_Min_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tracked_projects" */
export type Tracked_Projects_Mutation_Response = {
  __typename?: 'tracked_projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tracked_Projects>;
};

/** on_conflict condition type for table "tracked_projects" */
export type Tracked_Projects_On_Conflict = {
  constraint: Tracked_Projects_Constraint;
  update_columns?: Array<Tracked_Projects_Update_Column>;
  where?: InputMaybe<Tracked_Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "tracked_projects". */
export type Tracked_Projects_Order_By = {
  cluster_id?: InputMaybe<Order_By>;
  in_queue_subscription?: InputMaybe<In_Queue_Subscriptions_Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  requires_benchmark?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tracked_projects */
export type Tracked_Projects_Pk_Columns_Input = {
  project_id: Scalars['String']['input'];
  subscription_id: Scalars['uuid']['input'];
};

/** select columns of table "tracked_projects" */
export enum Tracked_Projects_Select_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  RequiresBenchmark = 'requires_benchmark',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TeamId = 'team_id'
}

/** select "tracked_projects_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tracked_projects" */
export enum Tracked_Projects_Select_Column_Tracked_Projects_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  RequiresBenchmark = 'requires_benchmark'
}

/** select "tracked_projects_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tracked_projects" */
export enum Tracked_Projects_Select_Column_Tracked_Projects_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  RequiresBenchmark = 'requires_benchmark'
}

/** input type for updating data in table "tracked_projects" */
export type Tracked_Projects_Set_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  requires_benchmark?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Tracked_Projects_Stddev_Fields = {
  __typename?: 'tracked_projects_stddev_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tracked_projects" */
export type Tracked_Projects_Stddev_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tracked_Projects_Stddev_Pop_Fields = {
  __typename?: 'tracked_projects_stddev_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tracked_projects" */
export type Tracked_Projects_Stddev_Pop_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tracked_Projects_Stddev_Samp_Fields = {
  __typename?: 'tracked_projects_stddev_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tracked_projects" */
export type Tracked_Projects_Stddev_Samp_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tracked_projects" */
export type Tracked_Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tracked_Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tracked_Projects_Stream_Cursor_Value_Input = {
  cluster_id?: InputMaybe<Scalars['uuid']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  requires_benchmark?: InputMaybe<Scalars['Boolean']['input']>;
  subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Tracked_Projects_Sum_Fields = {
  __typename?: 'tracked_projects_sum_fields';
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tracked_projects" */
export type Tracked_Projects_Sum_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "tracked_projects" */
export enum Tracked_Projects_Update_Column {
  /** column name */
  ClusterId = 'cluster_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  RequiresBenchmark = 'requires_benchmark',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  TeamId = 'team_id'
}

export type Tracked_Projects_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tracked_Projects_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tracked_Projects_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tracked_Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tracked_Projects_Var_Pop_Fields = {
  __typename?: 'tracked_projects_var_pop_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tracked_projects" */
export type Tracked_Projects_Var_Pop_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tracked_Projects_Var_Samp_Fields = {
  __typename?: 'tracked_projects_var_samp_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tracked_projects" */
export type Tracked_Projects_Var_Samp_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tracked_Projects_Variance_Fields = {
  __typename?: 'tracked_projects_variance_fields';
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tracked_projects" */
export type Tracked_Projects_Variance_Order_By = {
  team_id?: InputMaybe<Order_By>;
};

export type Unlock_Bus_Args = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "unlocked_buses" */
export type Unlocked_Buses = {
  __typename?: 'unlocked_buses';
  /** An object relationship */
  bus?: Maybe<Buses>;
  bus_id: Scalars['String']['output'];
  /** An object relationship */
  bus_without_override?: Maybe<Buses_Without_Overrides>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  nira_bus_id: Scalars['String']['output'];
  /** An object relationship */
  subscription: Subscriptions;
  subscription_id: Scalars['Int']['output'];
  unlocked: Scalars['Boolean']['output'];
  unlocked_by_user_auth0_id: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "unlocked_buses" */
export type Unlocked_Buses_Aggregate = {
  __typename?: 'unlocked_buses_aggregate';
  aggregate?: Maybe<Unlocked_Buses_Aggregate_Fields>;
  nodes: Array<Unlocked_Buses>;
};

export type Unlocked_Buses_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Unlocked_Buses_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Unlocked_Buses_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Unlocked_Buses_Aggregate_Bool_Exp_Count>;
};

export type Unlocked_Buses_Aggregate_Bool_Exp_Bool_And = {
  arguments: Unlocked_Buses_Select_Column_Unlocked_Buses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unlocked_Buses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Unlocked_Buses_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Unlocked_Buses_Select_Column_Unlocked_Buses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unlocked_Buses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Unlocked_Buses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Unlocked_Buses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unlocked_buses" */
export type Unlocked_Buses_Aggregate_Fields = {
  __typename?: 'unlocked_buses_aggregate_fields';
  avg?: Maybe<Unlocked_Buses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Unlocked_Buses_Max_Fields>;
  min?: Maybe<Unlocked_Buses_Min_Fields>;
  stddev?: Maybe<Unlocked_Buses_Stddev_Fields>;
  stddev_pop?: Maybe<Unlocked_Buses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unlocked_Buses_Stddev_Samp_Fields>;
  sum?: Maybe<Unlocked_Buses_Sum_Fields>;
  var_pop?: Maybe<Unlocked_Buses_Var_Pop_Fields>;
  var_samp?: Maybe<Unlocked_Buses_Var_Samp_Fields>;
  variance?: Maybe<Unlocked_Buses_Variance_Fields>;
};


/** aggregate fields of "unlocked_buses" */
export type Unlocked_Buses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unlocked_Buses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "unlocked_buses" */
export type Unlocked_Buses_Aggregate_Order_By = {
  avg?: InputMaybe<Unlocked_Buses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unlocked_Buses_Max_Order_By>;
  min?: InputMaybe<Unlocked_Buses_Min_Order_By>;
  stddev?: InputMaybe<Unlocked_Buses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Unlocked_Buses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Unlocked_Buses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Unlocked_Buses_Sum_Order_By>;
  var_pop?: InputMaybe<Unlocked_Buses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Unlocked_Buses_Var_Samp_Order_By>;
  variance?: InputMaybe<Unlocked_Buses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unlocked_buses" */
export type Unlocked_Buses_Arr_Rel_Insert_Input = {
  data: Array<Unlocked_Buses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Unlocked_Buses_On_Conflict>;
};

/** aggregate avg on columns */
export type Unlocked_Buses_Avg_Fields = {
  __typename?: 'unlocked_buses_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unlocked_buses". All fields are combined with a logical 'AND'. */
export type Unlocked_Buses_Bool_Exp = {
  _and?: InputMaybe<Array<Unlocked_Buses_Bool_Exp>>;
  _not?: InputMaybe<Unlocked_Buses_Bool_Exp>;
  _or?: InputMaybe<Array<Unlocked_Buses_Bool_Exp>>;
  bus?: InputMaybe<Buses_Bool_Exp>;
  bus_id?: InputMaybe<String_Comparison_Exp>;
  bus_without_override?: InputMaybe<Buses_Without_Overrides_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nira_bus_id?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscription_id?: InputMaybe<Int_Comparison_Exp>;
  unlocked?: InputMaybe<Boolean_Comparison_Exp>;
  unlocked_by_user_auth0_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "unlocked_buses" */
export enum Unlocked_Buses_Constraint {
  /** unique or primary key constraint on columns "id" */
  UnlockedBusesPkey = 'unlocked_buses_pkey',
  /** unique or primary key constraint on columns "nira_bus_id", "subscription_id" */
  UnlockedBusesSubscriptionIdNiraBusIdKey = 'unlocked_buses_subscription_id_nira_bus_id_key'
}

/** input type for incrementing numeric columns in table "unlocked_buses" */
export type Unlocked_Buses_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "unlocked_buses" */
export type Unlocked_Buses_Insert_Input = {
  bus?: InputMaybe<Buses_Obj_Rel_Insert_Input>;
  bus_id?: InputMaybe<Scalars['String']['input']>;
  bus_without_override?: InputMaybe<Buses_Without_Overrides_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked_by_user_auth0_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Unlocked_Buses_Max_Fields = {
  __typename?: 'unlocked_buses_max_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['Int']['output']>;
  unlocked_by_user_auth0_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Max_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  unlocked_by_user_auth0_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unlocked_Buses_Min_Fields = {
  __typename?: 'unlocked_buses_min_fields';
  bus_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nira_bus_id?: Maybe<Scalars['String']['output']>;
  subscription_id?: Maybe<Scalars['Int']['output']>;
  unlocked_by_user_auth0_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Min_Order_By = {
  bus_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  unlocked_by_user_auth0_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "unlocked_buses" */
export type Unlocked_Buses_Mutation_Response = {
  __typename?: 'unlocked_buses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Unlocked_Buses>;
};

/** on_conflict condition type for table "unlocked_buses" */
export type Unlocked_Buses_On_Conflict = {
  constraint: Unlocked_Buses_Constraint;
  update_columns?: Array<Unlocked_Buses_Update_Column>;
  where?: InputMaybe<Unlocked_Buses_Bool_Exp>;
};

/** Ordering options when selecting data from "unlocked_buses". */
export type Unlocked_Buses_Order_By = {
  bus?: InputMaybe<Buses_Order_By>;
  bus_id?: InputMaybe<Order_By>;
  bus_without_override?: InputMaybe<Buses_Without_Overrides_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nira_bus_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  unlocked?: InputMaybe<Order_By>;
  unlocked_by_user_auth0_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unlocked_buses */
export type Unlocked_Buses_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "unlocked_buses" */
export enum Unlocked_Buses_Select_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  Unlocked = 'unlocked',
  /** column name */
  UnlockedByUserAuth0Id = 'unlocked_by_user_auth0_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "unlocked_buses_aggregate_bool_exp_bool_and_arguments_columns" columns of table "unlocked_buses" */
export enum Unlocked_Buses_Select_Column_Unlocked_Buses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Unlocked = 'unlocked'
}

/** select "unlocked_buses_aggregate_bool_exp_bool_or_arguments_columns" columns of table "unlocked_buses" */
export enum Unlocked_Buses_Select_Column_Unlocked_Buses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Unlocked = 'unlocked'
}

/** input type for updating data in table "unlocked_buses" */
export type Unlocked_Buses_Set_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked_by_user_auth0_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Unlocked_Buses_Stddev_Fields = {
  __typename?: 'unlocked_buses_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unlocked_Buses_Stddev_Pop_Fields = {
  __typename?: 'unlocked_buses_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unlocked_Buses_Stddev_Samp_Fields = {
  __typename?: 'unlocked_buses_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "unlocked_buses" */
export type Unlocked_Buses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unlocked_Buses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unlocked_Buses_Stream_Cursor_Value_Input = {
  bus_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nira_bus_id?: InputMaybe<Scalars['String']['input']>;
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
  unlocked?: InputMaybe<Scalars['Boolean']['input']>;
  unlocked_by_user_auth0_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Unlocked_Buses_Sum_Fields = {
  __typename?: 'unlocked_buses_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  subscription_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** update columns of table "unlocked_buses" */
export enum Unlocked_Buses_Update_Column {
  /** column name */
  BusId = 'bus_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NiraBusId = 'nira_bus_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  Unlocked = 'unlocked',
  /** column name */
  UnlockedByUserAuth0Id = 'unlocked_by_user_auth0_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Unlocked_Buses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unlocked_Buses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unlocked_Buses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unlocked_Buses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unlocked_Buses_Var_Pop_Fields = {
  __typename?: 'unlocked_buses_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unlocked_Buses_Var_Samp_Fields = {
  __typename?: 'unlocked_buses_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Unlocked_Buses_Variance_Fields = {
  __typename?: 'unlocked_buses_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  subscription_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "unlocked_buses" */
export type Unlocked_Buses_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
};

export type Unpublish_Custom_Upgrade_Args = {
  custom_upgrade_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Unpublish_Scenario_Args = {
  scenario_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "user_scope_configs" */
export type User_Scope_Configs = {
  __typename?: 'user_scope_configs';
  base_scope: Scalars['String']['output'];
  /** An object relationship */
  base_scope_info?: Maybe<Scopes>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  scope: Scalars['String']['output'];
  /** An object relationship */
  scope_info?: Maybe<Scopes>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "user_scope_configs" */
export type User_Scope_Configs_Aggregate = {
  __typename?: 'user_scope_configs_aggregate';
  aggregate?: Maybe<User_Scope_Configs_Aggregate_Fields>;
  nodes: Array<User_Scope_Configs>;
};

/** aggregate fields of "user_scope_configs" */
export type User_Scope_Configs_Aggregate_Fields = {
  __typename?: 'user_scope_configs_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Scope_Configs_Max_Fields>;
  min?: Maybe<User_Scope_Configs_Min_Fields>;
};


/** aggregate fields of "user_scope_configs" */
export type User_Scope_Configs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Scope_Configs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_scope_configs". All fields are combined with a logical 'AND'. */
export type User_Scope_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<User_Scope_Configs_Bool_Exp>>;
  _not?: InputMaybe<User_Scope_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<User_Scope_Configs_Bool_Exp>>;
  base_scope?: InputMaybe<String_Comparison_Exp>;
  base_scope_info?: InputMaybe<Scopes_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  data_version_id?: InputMaybe<Uuid_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  scope_info?: InputMaybe<Scopes_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_scope_configs" */
export enum User_Scope_Configs_Constraint {
  /** unique or primary key constraint on columns "scope" */
  UserScopeConfigsPkey = 'user_scope_configs_pkey'
}

/** input type for inserting data into table "user_scope_configs" */
export type User_Scope_Configs_Insert_Input = {
  base_scope?: InputMaybe<Scalars['String']['input']>;
  base_scope_info?: InputMaybe<Scopes_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scope_info?: InputMaybe<Scopes_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type User_Scope_Configs_Max_Fields = {
  __typename?: 'user_scope_configs_max_fields';
  base_scope?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type User_Scope_Configs_Min_Fields = {
  __typename?: 'user_scope_configs_min_fields';
  base_scope?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  data_version_id?: Maybe<Scalars['uuid']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "user_scope_configs" */
export type User_Scope_Configs_Mutation_Response = {
  __typename?: 'user_scope_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Scope_Configs>;
};

/** input type for inserting object relation for remote table "user_scope_configs" */
export type User_Scope_Configs_Obj_Rel_Insert_Input = {
  data: User_Scope_Configs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Scope_Configs_On_Conflict>;
};

/** on_conflict condition type for table "user_scope_configs" */
export type User_Scope_Configs_On_Conflict = {
  constraint: User_Scope_Configs_Constraint;
  update_columns?: Array<User_Scope_Configs_Update_Column>;
  where?: InputMaybe<User_Scope_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "user_scope_configs". */
export type User_Scope_Configs_Order_By = {
  base_scope?: InputMaybe<Order_By>;
  base_scope_info?: InputMaybe<Scopes_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  data_version_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  scope_info?: InputMaybe<Scopes_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_scope_configs */
export type User_Scope_Configs_Pk_Columns_Input = {
  scope: Scalars['String']['input'];
};

/** select columns of table "user_scope_configs" */
export enum User_Scope_Configs_Select_Column {
  /** column name */
  BaseScope = 'base_scope',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Scope = 'scope',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user_scope_configs" */
export type User_Scope_Configs_Set_Input = {
  base_scope?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "user_scope_configs" */
export type User_Scope_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Scope_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Scope_Configs_Stream_Cursor_Value_Input = {
  base_scope?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  data_version_id?: InputMaybe<Scalars['uuid']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "user_scope_configs" */
export enum User_Scope_Configs_Update_Column {
  /** column name */
  BaseScope = 'base_scope',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DataVersionId = 'data_version_id',
  /** column name */
  Scope = 'scope',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Scope_Configs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Scope_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Scope_Configs_Bool_Exp;
};

/** columns and relationships of "user_scope_permissions" */
export type User_Scope_Permissions = {
  __typename?: 'user_scope_permissions';
  auth0_id?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "user_scope_permissions" */
export type User_Scope_Permissions_Aggregate = {
  __typename?: 'user_scope_permissions_aggregate';
  aggregate?: Maybe<User_Scope_Permissions_Aggregate_Fields>;
  nodes: Array<User_Scope_Permissions>;
};

export type User_Scope_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Scope_Permissions_Aggregate_Bool_Exp_Count>;
};

export type User_Scope_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_scope_permissions" */
export type User_Scope_Permissions_Aggregate_Fields = {
  __typename?: 'user_scope_permissions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Scope_Permissions_Max_Fields>;
  min?: Maybe<User_Scope_Permissions_Min_Fields>;
};


/** aggregate fields of "user_scope_permissions" */
export type User_Scope_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Scope_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_scope_permissions" */
export type User_Scope_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Scope_Permissions_Max_Order_By>;
  min?: InputMaybe<User_Scope_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_scope_permissions" */
export type User_Scope_Permissions_Arr_Rel_Insert_Input = {
  data: Array<User_Scope_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Scope_Permissions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_scope_permissions". All fields are combined with a logical 'AND'. */
export type User_Scope_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<User_Scope_Permissions_Bool_Exp>>;
  _not?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<User_Scope_Permissions_Bool_Exp>>;
  auth0_id?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_scope_permissions" */
export enum User_Scope_Permissions_Constraint {
  /** unique or primary key constraint on columns "scope", "auth0_id" */
  UserScopePermissionsUnique = 'user_scope_permissions_unique'
}

/** input type for inserting data into table "user_scope_permissions" */
export type User_Scope_Permissions_Insert_Input = {
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Scope_Permissions_Max_Fields = {
  __typename?: 'user_scope_permissions_max_fields';
  auth0_id?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "user_scope_permissions" */
export type User_Scope_Permissions_Max_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Scope_Permissions_Min_Fields = {
  __typename?: 'user_scope_permissions_min_fields';
  auth0_id?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "user_scope_permissions" */
export type User_Scope_Permissions_Min_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** on_conflict condition type for table "user_scope_permissions" */
export type User_Scope_Permissions_On_Conflict = {
  constraint: User_Scope_Permissions_Constraint;
  update_columns?: Array<User_Scope_Permissions_Update_Column>;
  where?: InputMaybe<User_Scope_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "user_scope_permissions". */
export type User_Scope_Permissions_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
};

/** select columns of table "user_scope_permissions" */
export enum User_Scope_Permissions_Select_Column {
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  Scope = 'scope'
}

/** Streaming cursor of the table "user_scope_permissions" */
export type User_Scope_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Scope_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Scope_Permissions_Stream_Cursor_Value_Input = {
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_scope_permissions" */
export enum User_Scope_Permissions_Update_Column {
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  Scope = 'scope'
}

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  auth0_id: Scalars['String']['output'];
  colorblind_mode: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  feature_flags: Scalars['jsonb']['output'];
  id: Scalars['Int']['output'];
  last_seen: Scalars['timestamptz']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  /** An array relationship */
  screening_views: Array<Screening_Views>;
  /** An aggregate relationship */
  screening_views_aggregate: Screening_Views_Aggregate;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['Int']['output'];
};


/** columns and relationships of "users" */
export type UsersFeature_FlagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "users" */
export type UsersScreening_ViewsArgs = {
  distinct_on?: InputMaybe<Array<Screening_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screening_Views_Order_By>>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersScreening_Views_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Screening_Views_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Screening_Views_Order_By>>;
  where?: InputMaybe<Screening_Views_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  auth0_id?: InputMaybe<String_Comparison_Exp>;
  colorblind_mode?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  feature_flags?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_seen?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  screening_views?: InputMaybe<Screening_Views_Bool_Exp>;
  screening_views_aggregate?: InputMaybe<Screening_Views_Aggregate_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "auth0_id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  feature_flags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  feature_flags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  feature_flags?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  colorblind_mode?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  screening_views?: InputMaybe<Screening_Views_Arr_Rel_Insert_Input>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  auth0_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  auth0_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_seen?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  auth0_id?: InputMaybe<Order_By>;
  colorblind_mode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  feature_flags?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  screening_views_aggregate?: InputMaybe<Screening_Views_Aggregate_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  auth0_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  ColorblindMode = 'colorblind_mode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FeatureFlags = 'feature_flags',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  Name = 'name',
  /** column name */
  Role = 'role',
  /** column name */
  TeamId = 'team_id'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ColorblindMode = 'colorblind_mode'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ColorblindMode = 'colorblind_mode'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  colorblind_mode?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  colorblind_mode?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feature_flags?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_seen?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Auth0Id = 'auth0_id',
  /** column name */
  ColorblindMode = 'colorblind_mode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FeatureFlags = 'feature_flags',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  Name = 'name',
  /** column name */
  Role = 'role',
  /** column name */
  TeamId = 'team_id'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type UnlockedBusFragment = { __typename?: 'buses', unlocked: Array<{ __typename?: 'unlocked_buses', unlocked: boolean }> };

export type AddFavoriteBusMutationVariables = Exact<{
  niraBusId: Scalars['String']['input'];
}>;


export type AddFavoriteBusMutation = { __typename?: 'mutation_root', insert_favorite_buses_one?: { __typename?: 'favorite_buses', nira_bus_id: string } | null };

export type ArchiveScreeningViewMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveScreeningViewMutation = { __typename?: 'mutation_root', update_screening_views_by_pk?: { __typename?: 'screening_views', id: string } | null };

export type CreateAdvancedStudyMutationVariables = Exact<{
  title: Scalars['String']['input'];
  advanced_study_loads: Array<Advanced_Study_Loads_Insert_Input> | Advanced_Study_Loads_Insert_Input;
  team_id: Scalars['Int']['input'];
  region: Scalars['String']['input'];
  scope: Scalars['String']['input'];
}>;


export type CreateAdvancedStudyMutation = { __typename?: 'mutation_root', insert_advanced_studies_one?: { __typename?: 'advanced_studies', advanced_study_id: any } | null };

export type CreateScreeningViewMutationVariables = Exact<{
  team_id: Scalars['Int']['input'];
  voltages: Scalars['jsonb']['input'];
  includes_pre_existing: Scalars['Boolean']['input'];
  max_allocated_costs?: InputMaybe<Scalars['numeric']['input']>;
  max_total_costs?: InputMaybe<Scalars['numeric']['input']>;
  scope: Scalars['String']['input'];
  hide_locked_buses: Scalars['Boolean']['input'];
  hide_low_confidence_buses: Scalars['Boolean']['input'];
  low_threshold: Scalars['numeric']['input'];
  medium_threshold: Scalars['numeric']['input'];
  high_threshold: Scalars['numeric']['input'];
  region: Scalars['String']['input'];
  generator_type: Scalars['String']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  states: Scalars['jsonb']['input'];
  owners?: InputMaybe<Scalars['jsonb']['input']>;
  color_mode?: InputMaybe<Scalars['String']['input']>;
  location_filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateScreeningViewMutation = { __typename?: 'mutation_root', insert_screening_views_one?: { __typename?: 'screening_views', id: string } | null };

export type CreateUserScopeConfigMutationVariables = Exact<{
  scope: Scalars['String']['input'];
  display_name: Scalars['String']['input'];
  region: Scalars['String']['input'];
  scope_views: Scalars['jsonb']['input'];
  data_freshness_markdown: Scalars['String']['input'];
  subscription_id: Scalars['Int']['input'];
  base_scope: Scalars['String']['input'];
  queue_projects: Array<Queue_Projects_Insert_Input> | Queue_Projects_Insert_Input;
  buses_to_scopes: Array<Buses_To_Scopes_Insert_Input> | Buses_To_Scopes_Insert_Input;
}>;


export type CreateUserScopeConfigMutation = { __typename?: 'mutation_root', insert_scopes_one?: { __typename?: 'scopes', id: any } | null, insert_user_scope_configs_one?: { __typename?: 'user_scope_configs', scope: string } | null, insert_queue_projects?: { __typename?: 'queue_projects_mutation_response', affected_rows: number } | null, insert_buses_to_scopes?: { __typename?: 'buses_to_scopes_mutation_response', affected_rows: number } | null };

export type GetAdvancedStudiesQueryVariables = Exact<{
  scope: Scalars['String']['input'];
}>;


export type GetAdvancedStudiesQuery = { __typename?: 'query_root', advanced_studies: Array<{ __typename?: 'advanced_studies', advanced_study_id: any, scope: string, status: string, title: string, advanced_study_loads: Array<{ __typename?: 'advanced_study_loads', mw_size: number, nira_bus_id: string, facility_type: string, bus?: { __typename?: 'buses', bus_display_name?: string | null } | null }> }> };

export type GetAdvancedStudyResultsQueryVariables = Exact<{
  advancedStudyId: Scalars['uuid']['input'];
}>;


export type GetAdvancedStudyResultsQuery = { __typename?: 'query_root', advanced_studies_by_pk?: { __typename?: 'advanced_studies', advanced_study_id: any, status: string, advanced_study_constraint_stacks: Array<{ __typename?: 'advanced_study_constraint_stacks', monitored_facility_id: string, monitored_facility_name: string, rating: number, bench_percent_loading: number, study_percent_loading: number, cost: number, nira_bus_id: string, dfax: number, contingency: string }> } | null };

export type GetBranchesQueryVariables = Exact<{
  voltages: Array<Scalars['numeric']['input']> | Scalars['numeric']['input'];
  region: Scalars['jsonb']['input'];
  filter_states_where_clause: Branches_Bool_Exp;
}>;


export type GetBranchesQuery = { __typename?: 'query_root', branches: Array<{ __typename?: 'branches', branch_path: string, id: string, voltage: number }> };

export type GetBusByNiraBusIdQueryVariables = Exact<{
  niraBusId: Scalars['String']['input'];
}>;


export type GetBusByNiraBusIdQuery = { __typename?: 'query_root', buses: Array<{ __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, voltage?: number | null, bus_display_name?: string | null, latitude?: number | null, longitude?: number | null, region?: string | null, location_code?: number | null, owner_name?: string | null, out_of_region?: boolean | null, utility_discharging?: string | null, utility_storage?: string | null, unlocked: Array<{ __typename?: 'unlocked_buses', unlocked: boolean }> }> };

export type GetBusCapacityCostsQueryVariables = Exact<{
  busId: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scopeView: Scalars['String']['input'];
  includesPreExisting: Scalars['Boolean']['input'];
}>;


export type GetBusCapacityCostsQuery = { __typename?: 'query_root', capacity_costs: Array<{ __typename?: 'capacity_costs', energy_size: number, capacity_size: number, charging_size: number }> };

export type GetBusScopeViewsQueryVariables = Exact<{
  niraBusId: Scalars['String']['input'];
}>;


export type GetBusScopeViewsQuery = { __typename?: 'query_root', buses_to_scopes: Array<{ __typename?: 'buses_to_scopes', scope: string, scope_view: string }> };

export type GetBusUnlockStatusQueryVariables = Exact<{
  niraBusId: Scalars['String']['input'];
}>;


export type GetBusUnlockStatusQuery = { __typename?: 'query_root', buses: Array<{ __typename?: 'buses', nira_bus_id?: string | null, unlocked: Array<{ __typename?: 'unlocked_buses', unlocked: boolean }> }>, subscriptions: Array<{ __typename?: 'subscriptions', id: number, region: string, unlimited: boolean, num_buses: number, end_date: string, unlocked_buses_aggregate: { __typename?: 'unlocked_buses_aggregate', aggregate?: { __typename?: 'unlocked_buses_aggregate_fields', count: number } | null } }> };

export type GetBusesByNameOrIdQueryVariables = Exact<{
  region: Scalars['String']['input'];
  query: Scalars['String']['input'];
  voltages: Array<Scalars['numeric']['input']> | Scalars['numeric']['input'];
  scope: Scalars['String']['input'];
  scopeView: Scalars['String']['input'];
  locationCodes: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  filter_locked_buses_where_clause: Buses_Bool_Exp;
  filter_states_where_clause: Buses_Bool_Exp;
}>;


export type GetBusesByNameOrIdQuery = { __typename?: 'query_root', buses: Array<{ __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, voltage?: number | null, bus_display_name?: string | null, latitude?: number | null, longitude?: number | null, region?: string | null, location_code?: number | null, owner_name?: string | null, out_of_region?: boolean | null }> };

export type GetBusesWithCapacityCostQueryVariables = Exact<{
  minLat: Scalars['numeric']['input'];
  minLong: Scalars['numeric']['input'];
  maxLat: Scalars['numeric']['input'];
  maxLong: Scalars['numeric']['input'];
  voltages: Array<Scalars['numeric']['input']> | Scalars['numeric']['input'];
  capacity_costs_where_clause: Capacity_Costs_Bool_Exp;
  region: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scopeView: Scalars['String']['input'];
  locationCodes: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  filter_locked_buses_where_clause: Buses_Bool_Exp;
  filter_states_where_clause: Buses_Bool_Exp;
  includeConstraintCount: Scalars['Boolean']['input'];
  constraint_stacks_where_clause?: InputMaybe<Constraint_Stacks_Bool_Exp>;
  filter_owners_where_clause: Buses_Bool_Exp;
}>;


export type GetBusesWithCapacityCostQuery = { __typename?: 'query_root', buses: Array<{ __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, voltage?: number | null, latitude?: number | null, longitude?: number | null, region?: string | null, bus_display_name?: string | null, location_code?: number | null, owner_name?: string | null, out_of_region?: boolean | null, capacity_costs: Array<{ __typename?: 'capacity_costs', capacity_size: number, energy_size: number, charging_size: number, upgrade_costs: number, total_upgrade_costs: number }>, constraint_stacks_aggregate?: { __typename?: 'constraint_stacks_aggregate', aggregate?: { __typename?: 'constraint_stacks_aggregate_fields', count: number } | null } }> };

export type GetConnectedLinesWithCapacityCostsQueryVariables = Exact<{
  scope: Scalars['String']['input'];
  scopeView: Scalars['String']['input'];
  niraBusId: Scalars['String']['input'];
  lineCapacityCostsWhereClause: Line_Capacity_Costs_Bool_Exp;
}>;


export type GetConnectedLinesWithCapacityCostsQuery = { __typename?: 'query_root', model_lines: Array<{ __typename?: 'model_lines', facility_id: string, line_length: number, from_bus_id: string, to_bus_id: string, from_nira_bus_id: string, to_nira_bus_id: string, rating: number, voltage: number, from_bus?: { __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, voltage?: number | null, bus_display_name?: string | null, latitude?: number | null, longitude?: number | null, region?: string | null, location_code?: number | null, owner_name?: string | null } | null, to_bus?: { __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, voltage?: number | null, bus_display_name?: string | null, latitude?: number | null, longitude?: number | null, region?: string | null, location_code?: number | null, owner_name?: string | null } | null, line_capacity_costs: Array<{ __typename?: 'line_capacity_costs', energy_size: number, capacity_size: number, charging_size: number, upgrade_costs: number, total_upgrade_costs: number }> }>, model_lines_to_missing_buses: Array<{ __typename?: 'model_lines_to_missing_buses', facility_id: string, line_length: number, rating: number, voltage: number, missing_bus_id: string, queued_projects_at_missing_bus?: string | null }> };

export type GetConstraintsQueryVariables = Exact<{
  constraintsWhereClause: Constraint_Stacks_Bool_Exp;
}>;


export type GetConstraintsQuery = { __typename?: 'query_root', constraint_stacks: Array<{ __typename?: 'constraint_stacks', bus_id: string, nira_bus_id: string, injection_threshold: number, monitored_facility_name: string, monitored_facility_id: string, resource_type: string, rating: number, pre_study_load: number, element_type: string, line_length?: number | null, dfax: number, estimated_cost?: number | null, scope: string, scope_view: string, contingency: string, contingency_buses?: string | null, contingency_type?: string | null }> };

export type GetFavoriteBusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFavoriteBusesQuery = { __typename?: 'query_root', favorite_buses: Array<{ __typename?: 'favorite_buses', nira_bus_id: string }> };

export type GetFavoriteBusesWithCapacityCostQueryVariables = Exact<{
  niraBusIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  capacity_costs_where_clause: Capacity_Costs_Bool_Exp;
  capped_capacity_costs_where_clause: Capacity_Costs_Bool_Exp;
  region: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scopeView: Scalars['String']['input'];
  filter_locked_buses_where_clause: Buses_Bool_Exp;
  includeConstraintCount: Scalars['Boolean']['input'];
  constraint_stacks_where_clause?: InputMaybe<Constraint_Stacks_Bool_Exp>;
}>;


export type GetFavoriteBusesWithCapacityCostQuery = { __typename?: 'query_root', buses: Array<{ __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, voltage?: number | null, latitude?: number | null, longitude?: number | null, region?: string | null, bus_display_name?: string | null, location_code?: number | null, owner_name?: string | null, out_of_region?: boolean | null, capacity_costs: Array<{ __typename?: 'capacity_costs', capacity_size: number, energy_size: number, charging_size: number, upgrade_costs: number, total_upgrade_costs: number }>, capped_capacity_costs: Array<{ __typename?: 'capacity_costs', capacity_size: number, energy_size: number, charging_size: number, upgrade_costs: number, total_upgrade_costs: number }>, constraint_stacks_aggregate?: { __typename?: 'constraint_stacks_aggregate', aggregate?: { __typename?: 'constraint_stacks_aggregate_fields', count: number } | null } }> };

export type GetLineTapCapacityCostsQueryVariables = Exact<{
  tapFacilityId: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scopeView: Scalars['String']['input'];
  includesPreExisting: Scalars['Boolean']['input'];
}>;


export type GetLineTapCapacityCostsQuery = { __typename?: 'query_root', line_capacity_costs: Array<{ __typename?: 'line_capacity_costs', energy_size: number, capacity_size: number, charging_size: number }> };

export type GetLineTapConstraintsQueryVariables = Exact<{
  constraintsWhereClause: Line_Constraint_Stacks_Bool_Exp;
}>;


export type GetLineTapConstraintsQuery = { __typename?: 'query_root', line_constraint_stacks: Array<{ __typename?: 'line_constraint_stacks', tap_facility_id: string, injection_threshold: number, monitored_facility_name: string, monitored_facility_id: string, resource_type: string, rating: number, pre_study_load: number, element_type: string, line_length?: number | null, dfax: number, estimated_cost?: number | null, scope: string, scope_view: string, contingency: string }> };

export type GetLineTapDataWithCapacityCostsQueryVariables = Exact<{
  scope: Scalars['String']['input'];
  scopeView: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  capacityCostsWhereClause: Capacity_Costs_Bool_Exp;
  lineCapacityCostsWhereClause: Line_Capacity_Costs_Bool_Exp;
}>;


export type GetLineTapDataWithCapacityCostsQuery = { __typename?: 'query_root', model_lines: Array<{ __typename?: 'model_lines', facility_id: string, rating: number, line_length: number, from_bus?: { __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, voltage?: number | null, bus_display_name?: string | null, latitude?: number | null, longitude?: number | null, region?: string | null, location_code?: number | null, owner_name?: string | null, capacity_costs: Array<{ __typename?: 'capacity_costs', energy_size: number, capacity_size: number, charging_size: number }>, unlocked: Array<{ __typename?: 'unlocked_buses', unlocked: boolean }> } | null, to_bus?: { __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, voltage?: number | null, bus_display_name?: string | null, latitude?: number | null, longitude?: number | null, region?: string | null, location_code?: number | null, owner_name?: string | null, capacity_costs: Array<{ __typename?: 'capacity_costs', energy_size: number, capacity_size: number, charging_size: number }>, unlocked: Array<{ __typename?: 'unlocked_buses', unlocked: boolean }> } | null, line_capacity_costs: Array<{ __typename?: 'line_capacity_costs', energy_size: number, capacity_size: number, charging_size: number, upgrade_costs: number, total_upgrade_costs: number }> }> };

export type GetOwnersByRegionAndScopeQueryVariables = Exact<{
  region: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scopeView: Scalars['String']['input'];
}>;


export type GetOwnersByRegionAndScopeQuery = { __typename?: 'query_root', buses: Array<{ __typename?: 'buses', owner_name?: string | null }> };

export type GetPlannedInterconnectionLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlannedInterconnectionLocationsQuery = { __typename?: 'query_root', planned_interconnection_locations: Array<{ __typename?: 'planned_interconnection_locations', nira_bus_id: string, planned_mw: number }> };

export type GetPoiBusesByNameOrIdQueryVariables = Exact<{
  region: Scalars['String']['input'];
  query: Scalars['String']['input'];
  scope_view_filters: Array<Buses_Bool_Exp> | Buses_Bool_Exp;
}>;


export type GetPoiBusesByNameOrIdQuery = { __typename?: 'query_root', buses: Array<{ __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, bus_display_name?: string | null, utility_discharging?: string | null, utility_storage?: string | null }> };

export type GetPoiBusesByNiraBusIdQueryVariables = Exact<{
  region: Scalars['String']['input'];
  nira_bus_ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  scope_view_filters: Array<Buses_Bool_Exp> | Buses_Bool_Exp;
}>;


export type GetPoiBusesByNiraBusIdQuery = { __typename?: 'query_root', buses: Array<{ __typename?: 'buses', id?: string | null, nira_bus_id?: string | null, bus_display_name?: string | null, utility_discharging?: string | null, utility_storage?: string | null }> };

export type GetQueueProjectHopsQueryVariables = Exact<{
  nira_bus_id: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  region: Scalars['String']['input'];
}>;


export type GetQueueProjectHopsQuery = { __typename?: 'query_root', queue_project_hops: Array<{ __typename?: 'queue_project_hops', project_number: string, num_hops: number, queue_project?: { __typename?: 'queue_projects', project_number: string, eris_capacity_mw: number, nris_capacity_mw?: number | null, fuel_type: string, poi_description: string, status?: string | null, sub_region: string, cluster?: string | null, bus_id?: string | null, facility_id?: string | null } | null }> };

export type GetQueueProjectScopeMembershipQueryVariables = Exact<{
  region: Scalars['String']['input'];
  current_scope: Scalars['String']['input'];
  realistic_scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  include_miso_realistic: Scalars['Boolean']['input'];
}>;


export type GetQueueProjectScopeMembershipQuery = { __typename?: 'query_root', in_current_scope: Array<{ __typename?: 'queue_projects', project_number: string }>, in_miso_realistic: Array<{ __typename?: 'queue_projects', project_number: string }> };

export type GetQueueProjectsQueryVariables = Exact<{
  scope: Scalars['String']['input'];
  scope_views: Array<Scalars['String']['input']> | Scalars['String']['input'];
  region: Scalars['String']['input'];
}>;


export type GetQueueProjectsQuery = { __typename?: 'query_root', queue_projects: Array<{ __typename?: 'queue_projects', bus_id?: string | null, nira_bus_id?: string | null, cluster?: string | null, eris_capacity_mw: number, facility_id?: string | null, fuel_type: string, included: boolean, is_speculative: boolean, nris_capacity_mw?: number | null, poi_description: string, project_number: string, scope_view: string, status?: string | null, sub_region: string }> };

export type GetRelatedQueueProjectsQueryVariables = Exact<{
  nira_bus_id: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  scope_view: Scalars['String']['input'];
  region: Scalars['String']['input'];
}>;


export type GetRelatedQueueProjectsQuery = { __typename?: 'query_root', constraint_stacks: Array<{ __typename?: 'constraint_stacks', monitored_facility_id: string, monitored_facility_name: string, contingency: string, resource_type: string, rating: number, injection_threshold: number, dfax: number, queue_project_facility_dfaxes: Array<{ __typename?: 'queue_project_facility_dfax', project_number: string, dfax: number, queue_project?: { __typename?: 'queue_projects', project_number: string, eris_capacity_mw: number, nris_capacity_mw?: number | null, fuel_type: string, poi_description: string, status?: string | null, sub_region: string, cluster?: string | null, bus_id?: string | null, facility_id?: string | null } | null }> }> };

export type GetRestudiedBusesQueryVariables = Exact<{
  region: Scalars['String']['input'];
}>;


export type GetRestudiedBusesQuery = { __typename?: 'query_root', buses_to_scopes: Array<{ __typename?: 'buses_to_scopes', nira_bus_id: string, scope: string, bus?: { __typename?: 'buses', bus_display_name?: string | null, region?: string | null } | null, scope_info?: { __typename?: 'scopes', display_name: string, user_scope_config?: { __typename?: 'user_scope_configs', status: string, created_at: any } | null } | null }> };

export type GetScopesForBusQueryVariables = Exact<{
  niraBusId: Scalars['String']['input'];
}>;


export type GetScopesForBusQuery = { __typename?: 'query_root', scopes: Array<{ __typename?: 'scopes', id: any, display_name: string, region: string, scope: string, scope_views: any, data_freshness_date?: string | null, data_freshness_markdown: string, data_freshness_model?: string | null, subscription_id?: number | null, user_scope_config?: { __typename?: 'user_scope_configs', base_scope: string, status: string, created_at: any } | null }> };

export type GetScopesWithQueueProjectsQueryVariables = Exact<{
  scopes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  scope_views: Array<Scalars['String']['input']> | Scalars['String']['input'];
  region: Scalars['String']['input'];
}>;


export type GetScopesWithQueueProjectsQuery = { __typename?: 'query_root', queue_projects: Array<{ __typename?: 'queue_projects', scope: string, scope_view: string }> };

export type GetScreeningViewsQueryVariables = Exact<{
  maybe_id_filter: Screening_Views_Bool_Exp;
}>;


export type GetScreeningViewsQuery = { __typename?: 'query_root', screening_views: Array<{ __typename?: 'screening_views', id: string, color_mode?: string | null, created_at: any, description: string, generator_type: string, hide_locked_buses: boolean, hide_low_confidence_buses: boolean, high_threshold: number, includes_pre_existing: boolean, location_filter?: string | null, low_threshold: number, max_allocated_costs?: number | null, max_total_costs?: number | null, medium_threshold: number, owners?: any | null, region: string, scope: string, states: any, title: string, voltages: any, user: { __typename?: 'users', auth0_id: string, email: string } }> };

export type GetSpeculativeProjectsForCopyQueryVariables = Exact<{
  region: Scalars['String']['input'];
}>;


export type GetSpeculativeProjectsForCopyQuery = { __typename?: 'query_root', queue_projects: Array<{ __typename?: 'queue_projects', scope: string, project_number: string, poi_description: string, bus_id?: string | null, nira_bus_id?: string | null, fuel_type: string, eris_capacity_mw: number, charging_capacity_mw?: any | null, scope_info?: { __typename?: 'scopes', display_name: string, user_scope_config?: { __typename?: 'user_scope_configs', status: string, created_at: any } | null, buses_to_scopes: Array<{ __typename?: 'buses_to_scopes', nira_bus_id: string, bus?: { __typename?: 'buses', bus_display_name?: string | null } | null }> } | null }> };

export type GetSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionsQuery = { __typename?: 'query_root', subscriptions: Array<{ __typename?: 'subscriptions', id: number, region: string, unlimited: boolean, num_buses: number, end_date: string, unlocked_buses_aggregate: { __typename?: 'unlocked_buses_aggregate', aggregate?: { __typename?: 'unlocked_buses_aggregate_fields', count: number } | null } }> };

export type GetUserDataQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserDataQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: number, auth0_id: string, team_id: number, role: string, feature_flags: any, colorblind_mode: boolean, team: { __typename?: 'teams', name: string, feature_flags: any, subscriptions: Array<{ __typename?: 'subscriptions', id: number, region: string, unlimited: boolean, num_buses: number, end_date: string, unlocked_buses_aggregate: { __typename?: 'unlocked_buses_aggregate', aggregate?: { __typename?: 'unlocked_buses_aggregate_fields', count: number } | null } }> } }>, scopes: Array<{ __typename?: 'scopes', id: any, display_name: string, region: string, scope: string, scope_views: any, data_freshness_date?: string | null, data_freshness_markdown: string, data_freshness_model?: string | null, subscription_id?: number | null, user_scope_config?: { __typename?: 'user_scope_configs', base_scope: string, status: string, created_at: any } | null }> };

export type AdditionalColumnConfigFieldsFragment = { __typename?: 'additional_column_configs', column_key: string, target_table: string, formatter: string, display_name?: string | null, anchor_to_column?: string | null, anchoring?: string | null };

export type ArchiveCustomUpgradeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ArchiveCustomUpgradeMutation = { __typename?: 'mutation_root', update_custom_upgrades_by_pk?: { __typename?: 'custom_upgrades', id: any, cluster_id: any, team_id?: number | null, type: string, name: string, status: string, notes?: string | null, created_at: any, updated_at: any, created_by?: string | null, custom_upgrade_files: Array<{ __typename?: 'custom_upgrade_files', id: any, source_file_format: string, source_file_name: string, variant?: In_Queue_Model_Variants_Enum | null, created_at: any, updated_at: any, model_variant?: { __typename?: 'in_queue_model_variants', description: string, variant: string } | null }> } | null };

export type ClusterFieldsFragment = { __typename?: 'in_queue_clusters', id: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: In_Queue_Cluster_Statuses_Enum, slug: string, in_queue_cluster_model_sets: Array<{ __typename?: 'in_queue_cluster_model_sets', id: any, name: string, status: In_Queue_Cluster_Model_Set_Statuses_Enum, iq_model_set_id: any, scenario_stage: string, created_at: any }> };

export type CreateCustomUpgradeMutationVariables = Exact<{
  clusterId: Scalars['uuid']['input'];
  teamId: Scalars['Int']['input'];
  authId: Scalars['String']['input'];
  sourceFileContents: Scalars['String']['input'];
  sourceFileFormat: Scalars['String']['input'];
  sourceFileName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  customUpgradeFiles: Array<Custom_Upgrade_Files_Insert_Input> | Custom_Upgrade_Files_Insert_Input;
}>;


export type CreateCustomUpgradeMutation = { __typename?: 'mutation_root', insert_custom_upgrades_one?: { __typename?: 'custom_upgrades', id: any, cluster_id: any, team_id?: number | null, type: string, name: string, status: string, notes?: string | null, created_at: any, updated_at: any, created_by?: string | null, custom_upgrade_files: Array<{ __typename?: 'custom_upgrade_files', id: any, source_file_format: string, source_file_name: string, variant?: In_Queue_Model_Variants_Enum | null, created_at: any, updated_at: any, model_variant?: { __typename?: 'in_queue_model_variants', description: string, variant: string } | null }> } | null };

export type CustomUpgradeFieldsFragment = { __typename?: 'custom_upgrades', id: any, cluster_id: any, team_id?: number | null, type: string, name: string, status: string, notes?: string | null, created_at: any, updated_at: any, created_by?: string | null, custom_upgrade_files: Array<{ __typename?: 'custom_upgrade_files', id: any, source_file_format: string, source_file_name: string, variant?: In_Queue_Model_Variants_Enum | null, created_at: any, updated_at: any, model_variant?: { __typename?: 'in_queue_model_variants', description: string, variant: string } | null }> };

export type CustomUpgradeValidationFieldsFragment = { __typename?: 'custom_upgrade_model_set_validations', id: any, custom_upgrade_id: any, in_queue_cluster_model_set_id: any, validation_status: Custom_Upgrade_Validation_Statuses_Enum, error_message?: string | null, submitted_at?: any | null, completed_at?: any | null, failures: Array<{ __typename?: 'custom_upgrade_model_set_validation_failures', id: any, severity: Custom_Upgrade_Validation_Failure_Severities_Enum, code: Custom_Upgrade_Validation_Failure_Codes_Enum, message: string, line_number?: number | null, offending_text?: string | null, suggested_fix?: string | null, warn_id?: string | null, variant: In_Queue_Model_Variants_Enum, model_variant: { __typename?: 'in_queue_model_variants', description: string } }> };

export type CustomUpgradeWithValidationsFieldsFragment = { __typename?: 'custom_upgrades', id: any, cluster_id: any, team_id?: number | null, type: string, name: string, status: string, notes?: string | null, created_at: any, updated_at: any, created_by?: string | null, current_validation?: Array<{ __typename?: 'custom_upgrade_model_set_validations', id: any, custom_upgrade_id: any, in_queue_cluster_model_set_id: any, validation_status: Custom_Upgrade_Validation_Statuses_Enum, error_message?: string | null, submitted_at?: any | null, completed_at?: any | null, failures: Array<{ __typename?: 'custom_upgrade_model_set_validation_failures', id: any, severity: Custom_Upgrade_Validation_Failure_Severities_Enum, code: Custom_Upgrade_Validation_Failure_Codes_Enum, message: string, line_number?: number | null, offending_text?: string | null, suggested_fix?: string | null, warn_id?: string | null, variant: In_Queue_Model_Variants_Enum, model_variant: { __typename?: 'in_queue_model_variants', description: string } }> }> | null, model_set_validations: Array<{ __typename?: 'custom_upgrade_model_set_validations', id: any, custom_upgrade_id: any, in_queue_cluster_model_set_id: any, validation_status: Custom_Upgrade_Validation_Statuses_Enum, error_message?: string | null, submitted_at?: any | null, completed_at?: any | null, failures: Array<{ __typename?: 'custom_upgrade_model_set_validation_failures', id: any, severity: Custom_Upgrade_Validation_Failure_Severities_Enum, code: Custom_Upgrade_Validation_Failure_Codes_Enum, message: string, line_number?: number | null, offending_text?: string | null, suggested_fix?: string | null, warn_id?: string | null, variant: In_Queue_Model_Variants_Enum, model_variant: { __typename?: 'in_queue_model_variants', description: string } }> }>, custom_upgrade_files: Array<{ __typename?: 'custom_upgrade_files', id: any, source_file_format: string, source_file_name: string, variant?: In_Queue_Model_Variants_Enum | null, created_at: any, updated_at: any, model_variant?: { __typename?: 'in_queue_model_variants', description: string, variant: string } | null }> };

export type InQueueScenarioFieldsFragment = { __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null };

export type RequestCustomUpgradeValidationMutationVariables = Exact<{
  customUpgradeId: Scalars['uuid']['input'];
  clusterModelSetId: Scalars['uuid']['input'];
}>;


export type RequestCustomUpgradeValidationMutation = { __typename?: 'mutation_root', insert_custom_upgrade_model_set_validations_one?: { __typename?: 'custom_upgrade_model_set_validations', id: any, custom_upgrade_id: any, in_queue_cluster_model_set_id: any, validation_status: Custom_Upgrade_Validation_Statuses_Enum, error_message?: string | null, submitted_at?: any | null, completed_at?: any | null, failures: Array<{ __typename?: 'custom_upgrade_model_set_validation_failures', id: any, severity: Custom_Upgrade_Validation_Failure_Severities_Enum, code: Custom_Upgrade_Validation_Failure_Codes_Enum, message: string, line_number?: number | null, offending_text?: string | null, suggested_fix?: string | null, warn_id?: string | null, variant: In_Queue_Model_Variants_Enum, model_variant: { __typename?: 'in_queue_model_variants', description: string } }> } | null };

export type ScenarioAllocatedUpgradeFieldsFragment = { __typename?: 'scenario_allocated_upgrades', scenario_id: any, allocated_cost: number, constraint_type: Constraint_Types_Enum, max_dfax: number, monitored_facility_names: any, sum_mw_impact: number, network_upgrade_id: string, network_upgrade_name: string, project_id: string, total_cost: number, notes?: string | null, percent_allocation?: number | null, metadata?: any | null };

export type ScenarioConstraintFieldsFragment = { __typename?: 'scenario_constraints', scenario_id: any, facility_id: string, constraint_type: Constraint_Types_Enum, monitored_facility_name: string, element_type?: string | null, line_length?: number | null, voltage?: string | null, post_study_flow?: string | null, post_study_load?: number | null, post_study_load_ac?: string | null, post_study_load_dc?: number | null, post_study_rating?: number | null, pre_study_flow?: number | null, pre_study_load?: number | null, pre_study_rating: number, worst_contingency_name: string, network_upgrade_names: any, project_id: string, dfax: number, mw_impact: number, notes?: string | null, model?: string | null, area?: string | null, metadata?: any | null };

export type AddTrackedProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  subscriptionId: Scalars['uuid']['input'];
  teamId: Scalars['Int']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  clusterId: Scalars['uuid']['input'];
}>;


export type AddTrackedProjectMutation = { __typename?: 'mutation_root', insert_tracked_projects_one?: { __typename?: 'tracked_projects', project_id: string, subscription_id: any, project_name?: string | null, cluster_id?: any | null } | null, insert_project_configurations_one?: { __typename?: 'project_configurations', team_id: number, cluster_id: any, project_id: string, project_name?: string | null } | null };

export type BulkArchiveScenariosMutationVariables = Exact<{
  customScenarioIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  lastArchivedAt: Scalars['timestamptz']['input'];
  teamScenarioConfigurations: Array<Scenario_Configurations_Insert_Input> | Scenario_Configurations_Insert_Input;
}>;


export type BulkArchiveScenariosMutation = { __typename?: 'mutation_root', update_scenarios?: { __typename?: 'scenarios_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null }> } | null, insert_scenario_configurations?: { __typename?: 'scenario_configurations_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'scenario_configurations', scenario: { __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null } }> } | null };

export type CreateScenariosMutationVariables = Exact<{
  objects: Array<Scenarios_Insert_Input> | Scenarios_Insert_Input;
  archiveOriginals: Scalars['Boolean']['input'];
  originalScenarioIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  lastArchivedAt: Scalars['timestamptz']['input'];
}>;


export type CreateScenariosMutation = { __typename?: 'mutation_root', insert_scenarios?: { __typename?: 'scenarios_mutation_response', returning: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null }> } | null, update_scenarios?: { __typename?: 'scenarios_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null }> } | null };

export type CreateSpeculativeProjectsMutationVariables = Exact<{
  objects: Array<In_Queue_Speculative_Projects_Insert_Input> | In_Queue_Speculative_Projects_Insert_Input;
}>;


export type CreateSpeculativeProjectsMutation = { __typename?: 'mutation_root', insert_in_queue_speculative_projects?: { __typename?: 'in_queue_speculative_projects_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'in_queue_speculative_projects', id: any, project_id: string }> } | null };

export type DeleteSpeculativeProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type DeleteSpeculativeProjectMutation = { __typename?: 'mutation_root', delete_in_queue_speculative_projects?: { __typename?: 'in_queue_speculative_projects_mutation_response', affected_rows: number } | null };

export type ModelPoiFragmentFragment = { __typename?: 'in_queue_model_pois', voltage: string, poi_type: string, poi_name: string, poi: string, id: any, deleted: boolean, cluster_id: any, area: string };

export type SpeculativeProjectFragmentFragment = { __typename?: 'in_queue_speculative_projects', fuel_type: string, id: any, mw_capacity: any, mw_energy: any, mw_mfo: any, project_id: string, project_name: string };

export type GetAdditionalColumnConfigsQueryVariables = Exact<{
  clusterId: Scalars['uuid']['input'];
  scenarioStage: Scalars['String']['input'];
}>;


export type GetAdditionalColumnConfigsQuery = { __typename?: 'query_root', additional_column_configs: Array<{ __typename?: 'additional_column_configs', column_key: string, target_table: string, formatter: string, display_name?: string | null, anchor_to_column?: string | null, anchoring?: string | null }> };

export type GetAllClustersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllClustersQuery = { __typename?: 'query_root', in_queue_clusters: Array<{ __typename?: 'in_queue_clusters', id: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: In_Queue_Cluster_Statuses_Enum, slug: string, in_queue_cluster_model_sets: Array<{ __typename?: 'in_queue_cluster_model_sets', id: any, name: string, status: In_Queue_Cluster_Model_Set_Statuses_Enum, iq_model_set_id: any, scenario_stage: string, created_at: any }> }> };

export type GetClusterProjectRowsQueryVariables = Exact<{
  clusterId: Scalars['uuid']['input'];
}>;


export type GetClusterProjectRowsQuery = { __typename?: 'query_root', cluster_projects: Array<{ __typename?: 'cluster_projects', project_id?: string | null, study_group?: string | null, fuel_type?: string | null, eris_mw?: number | null, nris_mw?: number | null, cost_per_mw?: number | null, sum_allocated_cost?: number | null, num_assigned_upgrades?: number | null, rank?: number | null, percentile?: number | null, total_ranked?: number | null, tracked_projects: Array<{ __typename?: 'tracked_projects', subscription_id: any, project_name?: string | null }>, project_configurations: Array<{ __typename?: 'project_configurations', team_id: number, cluster_id: any, project_id: string, is_favorited: boolean }> }>, current_base_scenarios: Array<{ __typename?: 'current_base_scenarios', title?: string | null, run_completed_at?: any | null }> };

export type GetClusterProjectsQueryVariables = Exact<{
  clusterId: Scalars['uuid']['input'];
}>;


export type GetClusterProjectsQuery = { __typename?: 'query_root', all_projects: Array<{ __typename?: 'all_projects', eris_capacity_mw: number, nris_capacity_mw: number, fuel_type: string, project_id: string, region: string, status: string, is_withdrawn: boolean, study_cycle: string, study_group: string, study_phase: string, is_editable: boolean, metadata?: any | null }> };

export type GetCustomUpgradesQueryVariables = Exact<{
  clusterId: Scalars['uuid']['input'];
  subscriptionId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetCustomUpgradesQuery = { __typename?: 'query_root', custom_upgrades: Array<{ __typename?: 'custom_upgrades', id: any, cluster_id: any, team_id?: number | null, type: string, name: string, status: string, notes?: string | null, created_at: any, updated_at: any, created_by?: string | null, current_validation?: Array<{ __typename?: 'custom_upgrade_model_set_validations', id: any, custom_upgrade_id: any, in_queue_cluster_model_set_id: any, validation_status: Custom_Upgrade_Validation_Statuses_Enum, error_message?: string | null, submitted_at?: any | null, completed_at?: any | null, failures: Array<{ __typename?: 'custom_upgrade_model_set_validation_failures', id: any, severity: Custom_Upgrade_Validation_Failure_Severities_Enum, code: Custom_Upgrade_Validation_Failure_Codes_Enum, message: string, line_number?: number | null, offending_text?: string | null, suggested_fix?: string | null, warn_id?: string | null, variant: In_Queue_Model_Variants_Enum, model_variant: { __typename?: 'in_queue_model_variants', description: string } }> }> | null, model_set_validations: Array<{ __typename?: 'custom_upgrade_model_set_validations', id: any, custom_upgrade_id: any, in_queue_cluster_model_set_id: any, validation_status: Custom_Upgrade_Validation_Statuses_Enum, error_message?: string | null, submitted_at?: any | null, completed_at?: any | null, failures: Array<{ __typename?: 'custom_upgrade_model_set_validation_failures', id: any, severity: Custom_Upgrade_Validation_Failure_Severities_Enum, code: Custom_Upgrade_Validation_Failure_Codes_Enum, message: string, line_number?: number | null, offending_text?: string | null, suggested_fix?: string | null, warn_id?: string | null, variant: In_Queue_Model_Variants_Enum, model_variant: { __typename?: 'in_queue_model_variants', description: string } }> }>, custom_upgrade_files: Array<{ __typename?: 'custom_upgrade_files', id: any, source_file_format: string, source_file_name: string, variant?: In_Queue_Model_Variants_Enum | null, created_at: any, updated_at: any, model_variant?: { __typename?: 'in_queue_model_variants', description: string, variant: string } | null }> }>, custom_upgrade_validation_failure_codes: Array<{ __typename?: 'custom_upgrade_validation_failure_codes', code: string, description: string }> };

export type GetInQueueScenariosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInQueueScenariosQuery = { __typename?: 'query_root', scenarios: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null }> };

export type GetInQueueSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInQueueSubscriptionsQuery = { __typename?: 'query_root', in_queue_subscriptions: Array<{ __typename?: 'in_queue_subscriptions', subscription_id: any, region: string, study_cycle: string, study_group: string, phase: string, scenario_limit: number, status_override?: In_Queue_Cluster_Statuses_Enum | null, project_limit?: number | null, in_queue_subscription_add_ons: Array<{ __typename?: 'in_queue_subscription_add_ons', add_on: Subscription_Add_Ons_Enum }> }> };

export type GetModelPoIsQueryVariables = Exact<{
  poiName: Scalars['String']['input'];
  poi: Scalars['String']['input'];
  poiType: Scalars['String']['input'];
  clusterId: Scalars['uuid']['input'];
}>;


export type GetModelPoIsQuery = { __typename?: 'query_root', in_queue_model_pois: Array<{ __typename?: 'in_queue_model_pois', voltage: string, poi_type: string, poi_name: string, poi: string, id: any, deleted: boolean, cluster_id: any, area: string }> };

export type GetRegionModelVariantsQueryVariables = Exact<{
  region: Scalars['String']['input'];
}>;


export type GetRegionModelVariantsQuery = { __typename?: 'query_root', in_queue_region_model_variants: Array<{ __typename?: 'in_queue_region_model_variants', variant: In_Queue_Model_Variants_Enum, model_variant: { __typename?: 'in_queue_model_variants', description: string } }> };

export type GetRelatedScenarioResultsQueryVariables = Exact<{
  scenarioId: Scalars['uuid']['input'];
  projectId: Scalars['String']['input'];
  networkUpgradeNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  monitoredFacilityNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetRelatedScenarioResultsQuery = { __typename?: 'query_root', scenarios: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_allocated_upgrades: Array<{ __typename?: 'scenario_allocated_upgrades', scenario_id: any, allocated_cost: number, constraint_type: Constraint_Types_Enum, max_dfax: number, monitored_facility_names: any, sum_mw_impact: number, network_upgrade_id: string, network_upgrade_name: string, project_id: string, total_cost: number, notes?: string | null, percent_allocation?: number | null, metadata?: any | null }>, scenario_constraints: Array<{ __typename?: 'scenario_constraints', scenario_id: any, facility_id: string, constraint_type: Constraint_Types_Enum, monitored_facility_name: string, element_type?: string | null, line_length?: number | null, voltage?: string | null, post_study_flow?: string | null, post_study_load?: number | null, post_study_load_ac?: string | null, post_study_load_dc?: number | null, post_study_rating?: number | null, pre_study_flow?: number | null, pre_study_load?: number | null, pre_study_rating: number, worst_contingency_name: string, network_upgrade_names: any, project_id: string, dfax: number, mw_impact: number, notes?: string | null, model?: string | null, area?: string | null, metadata?: any | null }> }> };

export type GetRemainingScenarioResultsQueryVariables = Exact<{
  scenarioId: Scalars['uuid']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetRemainingScenarioResultsQuery = { __typename?: 'query_root', scenarios: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_allocated_upgrades: Array<{ __typename?: 'scenario_allocated_upgrades', scenario_id: any, allocated_cost: number, constraint_type: Constraint_Types_Enum, max_dfax: number, monitored_facility_names: any, sum_mw_impact: number, network_upgrade_id: string, network_upgrade_name: string, project_id: string, total_cost: number, notes?: string | null, percent_allocation?: number | null, metadata?: any | null }>, scenario_constraints: Array<{ __typename?: 'scenario_constraints', scenario_id: any, facility_id: string, constraint_type: Constraint_Types_Enum, monitored_facility_name: string, element_type?: string | null, line_length?: number | null, voltage?: string | null, post_study_flow?: string | null, post_study_load?: number | null, post_study_load_ac?: string | null, post_study_load_dc?: number | null, post_study_rating?: number | null, pre_study_flow?: number | null, pre_study_load?: number | null, pre_study_rating: number, worst_contingency_name: string, network_upgrade_names: any, project_id: string, dfax: number, mw_impact: number, notes?: string | null, model?: string | null, area?: string | null, metadata?: any | null }> }> };

export type GetScenarioMetricsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  scenarioIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetScenarioMetricsQuery = { __typename?: 'query_root', scenarios: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_projects: Array<{ __typename?: 'scenario_projects', scenario_id: any, project_id: string, sum_allocated_cost: number, cost_per_mw: number, sum_allocated_cost_by_constraint_type?: any | null, ranks?: { __typename?: 'scenario_project_ranks', rank: number, percentile: number, total_ranked: number } | null }>, scenario_allocated_upgrades: Array<{ __typename?: 'scenario_allocated_upgrades', scenario_id: any, project_id: string, constraint_type: Constraint_Types_Enum, network_upgrade_id: string }> }> };

export type GetScenarioResultsByProjectIdQueryVariables = Exact<{
  scenarioId: Scalars['uuid']['input'];
  projectId: Scalars['String']['input'];
}>;


export type GetScenarioResultsByProjectIdQuery = { __typename?: 'query_root', scenarios: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_allocated_upgrades: Array<{ __typename?: 'scenario_allocated_upgrades', scenario_id: any, allocated_cost: number, constraint_type: Constraint_Types_Enum, max_dfax: number, monitored_facility_names: any, sum_mw_impact: number, network_upgrade_id: string, network_upgrade_name: string, project_id: string, total_cost: number, notes?: string | null, percent_allocation?: number | null, metadata?: any | null }>, scenario_constraints: Array<{ __typename?: 'scenario_constraints', scenario_id: any, facility_id: string, constraint_type: Constraint_Types_Enum, monitored_facility_name: string, element_type?: string | null, line_length?: number | null, voltage?: string | null, post_study_flow?: string | null, post_study_load?: number | null, post_study_load_ac?: string | null, post_study_load_dc?: number | null, post_study_rating?: number | null, pre_study_flow?: number | null, pre_study_load?: number | null, pre_study_rating: number, worst_contingency_name: string, network_upgrade_names: any, project_id: string, dfax: number, mw_impact: number, notes?: string | null, model?: string | null, area?: string | null, metadata?: any | null }>, scenario_projects: Array<{ __typename?: 'scenario_projects', scenario_id: any, assigned_upgrades: any, cost_per_mw: number, eris_size_mw: number, nris_size_mw: number, overloaded_facilities: any, project_id: string, sum_allocated_cost: number, sum_allocated_cost_by_constraint_type?: any | null, metadata?: any | null, ranks?: { __typename?: 'scenario_project_ranks', rank: number, percentile: number, total_ranked: number } | null }> }> };

export type GetSpeculativeProjectsQueryVariables = Exact<{
  subscriptionIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetSpeculativeProjectsQuery = { __typename?: 'query_root', in_queue_speculative_projects: Array<{ __typename?: 'in_queue_speculative_projects', cluster_id: any, subscription_id: any, fuel_type: string, poi_id: any, id: any, mw_capacity: any, mw_energy: any, mw_mfo: any, project_id: string, project_name: string, in_queue_speculative_projects_children: Array<{ __typename?: 'in_queue_speculative_projects', fuel_type: string, id: any, mw_capacity: any, mw_energy: any, mw_mfo: any, project_id: string, project_name: string }>, in_queue_model_poi: { __typename?: 'in_queue_model_pois', voltage: string, poi_type: string, poi_name: string, poi: string, id: any, deleted: boolean, cluster_id: any, area: string } }> };

export type GetTrackedProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrackedProjectsQuery = { __typename?: 'query_root', tracked_projects: Array<{ __typename?: 'tracked_projects', subscription_id: any, project_id: string, project_name?: string | null }> };

export type SetProjectFavoriteMutationVariables = Exact<{
  teamId: Scalars['Int']['input'];
  clusterId: Scalars['uuid']['input'];
  projectId: Scalars['String']['input'];
  isFavorited: Scalars['Boolean']['input'];
}>;


export type SetProjectFavoriteMutation = { __typename?: 'mutation_root', insert_project_configurations_one?: { __typename?: 'project_configurations', team_id: number, cluster_id: any, project_id: string, is_favorited: boolean } | null };

export type SetTeamScenarioArchivedMutationVariables = Exact<{
  scenarioId: Scalars['uuid']['input'];
  teamId: Scalars['Int']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type SetTeamScenarioArchivedMutation = { __typename?: 'mutation_root', insert_scenario_configurations_one?: { __typename?: 'scenario_configurations', scenario: { __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null } } | null };

export type SubmitScenarioMutationVariables = Exact<{
  scenarioId: Scalars['uuid']['input'];
  authId: Scalars['String']['input'];
  currentTime: Scalars['timestamptz']['input'];
}>;


export type SubmitScenarioMutation = { __typename?: 'mutation_root', update_scenarios?: { __typename?: 'scenarios_mutation_response', returning: Array<{ __typename?: 'scenarios', scenario_id: any, region: string, team_id: number, created_by?: string | null, updated_by?: string | null, study_group: string, study_cycle: string, study_phase: string, title: string, project_size_assumptions: any, custom_upgrades?: any | null, status: Scenario_Statuses_Enum }> } | null };

export type SubscribeToCustomUpgradesSubscriptionVariables = Exact<{
  clusterId: Scalars['uuid']['input'];
  subscriptionId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SubscribeToCustomUpgradesSubscription = { __typename?: 'subscription_root', custom_upgrades: Array<{ __typename?: 'custom_upgrades', id: any, cluster_id: any, team_id?: number | null, type: string, name: string, status: string, notes?: string | null, created_at: any, updated_at: any, created_by?: string | null, current_validation?: Array<{ __typename?: 'custom_upgrade_model_set_validations', id: any, custom_upgrade_id: any, in_queue_cluster_model_set_id: any, validation_status: Custom_Upgrade_Validation_Statuses_Enum, error_message?: string | null, submitted_at?: any | null, completed_at?: any | null, failures: Array<{ __typename?: 'custom_upgrade_model_set_validation_failures', id: any, severity: Custom_Upgrade_Validation_Failure_Severities_Enum, code: Custom_Upgrade_Validation_Failure_Codes_Enum, message: string, line_number?: number | null, offending_text?: string | null, suggested_fix?: string | null, warn_id?: string | null, variant: In_Queue_Model_Variants_Enum, model_variant: { __typename?: 'in_queue_model_variants', description: string } }> }> | null, model_set_validations: Array<{ __typename?: 'custom_upgrade_model_set_validations', id: any, custom_upgrade_id: any, in_queue_cluster_model_set_id: any, validation_status: Custom_Upgrade_Validation_Statuses_Enum, error_message?: string | null, submitted_at?: any | null, completed_at?: any | null, failures: Array<{ __typename?: 'custom_upgrade_model_set_validation_failures', id: any, severity: Custom_Upgrade_Validation_Failure_Severities_Enum, code: Custom_Upgrade_Validation_Failure_Codes_Enum, message: string, line_number?: number | null, offending_text?: string | null, suggested_fix?: string | null, warn_id?: string | null, variant: In_Queue_Model_Variants_Enum, model_variant: { __typename?: 'in_queue_model_variants', description: string } }> }>, custom_upgrade_files: Array<{ __typename?: 'custom_upgrade_files', id: any, source_file_format: string, source_file_name: string, variant?: In_Queue_Model_Variants_Enum | null, created_at: any, updated_at: any, model_variant?: { __typename?: 'in_queue_model_variants', description: string, variant: string } | null }> }> };

export type SubscribeToInQueueScenariosSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToInQueueScenariosSubscription = { __typename?: 'subscription_root', scenarios: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null }> };

export type GetInQueueSubscriptionUpdatesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetInQueueSubscriptionUpdatesSubscription = { __typename?: 'subscription_root', in_queue_subscriptions: Array<{ __typename?: 'in_queue_subscriptions', subscription_id: any, region: string, study_cycle: string, study_group: string, phase: string, scenario_limit: number, status_override?: In_Queue_Cluster_Statuses_Enum | null, project_limit?: number | null, in_queue_subscription_add_ons: Array<{ __typename?: 'in_queue_subscription_add_ons', add_on: Subscription_Add_Ons_Enum }> }> };

export type UpdateScenarioMutationVariables = Exact<{
  scenarioId: Scalars['uuid']['input'];
  authId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  status: Scenario_Statuses_Enum;
  projectSizeAssumptions: Scalars['jsonb']['input'];
  projectAdditions: Scalars['jsonb']['input'];
  customUpgrades: Scalars['jsonb']['input'];
  parentProjectId?: InputMaybe<Scalars['String']['input']>;
  costAssumptions: Scalars['jsonb']['input'];
  parentSpeculativeProjectId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateScenarioMutation = { __typename?: 'mutation_root', update_scenarios?: { __typename?: 'scenarios_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'scenarios', scenario_id: any, region: string, team_id: number, created_by?: string | null, updated_by?: string | null, study_group: string, study_cycle: string, study_phase: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, status: Scenario_Statuses_Enum, cost_assumptions: any }> } | null };

export type UpdateScenarioParentProjectMutationVariables = Exact<{
  scenarioId: Scalars['uuid']['input'];
  authId: Scalars['String']['input'];
  parentProjectId?: InputMaybe<Scalars['String']['input']>;
  parentSpeculativeProjectId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateScenarioParentProjectMutation = { __typename?: 'mutation_root', update_scenarios?: { __typename?: 'scenarios_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null }> } | null };

export type UpdateScenarioStatusMutationVariables = Exact<{
  scenarioId: Scalars['uuid']['input'];
  status: Scenario_Statuses_Enum;
  archived: Scalars['Boolean']['input'];
  lastArchivedAt?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateScenarioStatusMutation = { __typename?: 'mutation_root', update_scenarios?: { __typename?: 'scenarios_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null }> } | null };

export type UpdateScenarioTitleMutationVariables = Exact<{
  scenarioId: Scalars['uuid']['input'];
  authId: Scalars['String']['input'];
  title: Scalars['String']['input'];
}>;


export type UpdateScenarioTitleMutation = { __typename?: 'mutation_root', update_scenarios?: { __typename?: 'scenarios_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'scenarios', scenario_id: any, scenario_type: string, scenario_origin?: Scenario_Origins_Enum | null, scenario_stage: string, title: string, project_size_assumptions: any, project_additions?: any | null, custom_upgrades?: any | null, cost_assumptions: any, region: string, study_cycle: string, study_group: string, study_phase: string, status: Scenario_Statuses_Enum, input_data_used?: any | null, is_stale?: boolean | null, created_at: any, created_by?: string | null, updated_at: any, updated_by?: string | null, dagster_run_id?: string | null, run_completed_at?: any | null, run_started_at?: any | null, run_submitted_at?: any | null, run_submitted_by?: string | null, is_archived?: boolean | null, last_archived_at?: any | null, parent_project_id?: string | null, parent_speculative_project_id?: any | null, subscription_id?: any | null }> } | null };

export type UpdateSpeculativeProjectNameMutationVariables = Exact<{
  updates: Array<In_Queue_Speculative_Projects_Updates> | In_Queue_Speculative_Projects_Updates;
}>;


export type UpdateSpeculativeProjectNameMutation = { __typename?: 'mutation_root', update_in_queue_speculative_projects_many?: Array<{ __typename?: 'in_queue_speculative_projects_mutation_response', affected_rows: number } | null> | null };

export type UpdateTrackedProjectNameMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  subscriptionId: Scalars['uuid']['input'];
  teamId: Scalars['Int']['input'];
  clusterId: Scalars['uuid']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTrackedProjectNameMutation = { __typename?: 'mutation_root', update_tracked_projects?: { __typename?: 'tracked_projects_mutation_response', affected_rows: number } | null, insert_project_configurations_one?: { __typename?: 'project_configurations', team_id: number, cluster_id: any, project_id: string, project_name?: string | null } | null };

export type RemoveFavoriteBusMutationVariables = Exact<{
  niraBusId: Scalars['String']['input'];
}>;


export type RemoveFavoriteBusMutation = { __typename?: 'mutation_root', delete_favorite_buses?: { __typename?: 'favorite_buses_mutation_response', returning: Array<{ __typename?: 'favorite_buses', nira_bus_id: string }> } | null };

export type UnlockBusMutationVariables = Exact<{
  niraBusId: Scalars['String']['input'];
}>;


export type UnlockBusMutation = { __typename?: 'mutation_root', unlock_bus?: { __typename?: 'unlocked_buses', nira_bus_id: string } | null };

export type UpdateUserColorblindModeMutationVariables = Exact<{
  auth0Id: Scalars['String']['input'];
  colorblindMode: Scalars['Boolean']['input'];
}>;


export type UpdateUserColorblindModeMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', auth0_id: string, colorblind_mode: boolean } | null };

export const UnlockedBusFragmentDoc = gql`
    fragment UnlockedBus on buses {
  unlocked {
    unlocked
  }
}
    `;
export const AdditionalColumnConfigFieldsFragmentDoc = gql`
    fragment AdditionalColumnConfigFields on additional_column_configs {
  column_key
  target_table
  formatter
  display_name
  anchor_to_column
  anchoring
}
    `;
export const ClusterFieldsFragmentDoc = gql`
    fragment ClusterFields on in_queue_clusters {
  id
  region
  study_cycle
  study_group
  study_phase
  status
  slug
  in_queue_cluster_model_sets(where: {status: {_in: [CURRENT, SUPERSEDED]}}) {
    id
    name
    status
    iq_model_set_id
    scenario_stage
    created_at
  }
}
    `;
export const CustomUpgradeFieldsFragmentDoc = gql`
    fragment CustomUpgradeFields on custom_upgrades {
  id
  cluster_id
  team_id
  type
  name
  status
  notes
  created_at
  updated_at
  created_by
  custom_upgrade_files {
    id
    source_file_format
    source_file_name
    variant
    model_variant {
      description
      variant
    }
    created_at
    updated_at
  }
}
    `;
export const CustomUpgradeValidationFieldsFragmentDoc = gql`
    fragment CustomUpgradeValidationFields on custom_upgrade_model_set_validations {
  id
  custom_upgrade_id
  in_queue_cluster_model_set_id
  validation_status
  error_message
  submitted_at
  completed_at
  failures {
    id
    severity
    code
    message
    line_number
    offending_text
    suggested_fix
    warn_id
    variant
    model_variant {
      description
    }
  }
}
    `;
export const CustomUpgradeWithValidationsFieldsFragmentDoc = gql`
    fragment CustomUpgradeWithValidationsFields on custom_upgrades {
  ...CustomUpgradeFields
  current_validation(args: {subscription_id: $subscriptionId}) {
    ...CustomUpgradeValidationFields
  }
  model_set_validations {
    ...CustomUpgradeValidationFields
  }
}
    ${CustomUpgradeFieldsFragmentDoc}
${CustomUpgradeValidationFieldsFragmentDoc}`;
export const InQueueScenarioFieldsFragmentDoc = gql`
    fragment InQueueScenarioFields on scenarios {
  scenario_id
  scenario_type
  scenario_origin
  scenario_stage
  title
  project_size_assumptions
  project_additions
  custom_upgrades
  cost_assumptions
  region
  study_cycle
  study_group
  study_phase
  status
  input_data_used
  is_stale
  created_at
  created_by
  updated_at
  updated_by
  dagster_run_id
  run_completed_at
  run_started_at
  run_submitted_at
  run_submitted_by
  is_archived
  last_archived_at
  parent_project_id
  parent_speculative_project_id
  subscription_id
}
    `;
export const ScenarioAllocatedUpgradeFieldsFragmentDoc = gql`
    fragment ScenarioAllocatedUpgradeFields on scenario_allocated_upgrades {
  scenario_id
  allocated_cost
  constraint_type
  max_dfax
  monitored_facility_names
  sum_mw_impact
  network_upgrade_id
  network_upgrade_name
  project_id
  total_cost
  notes
  percent_allocation
  metadata
}
    `;
export const ScenarioConstraintFieldsFragmentDoc = gql`
    fragment ScenarioConstraintFields on scenario_constraints {
  scenario_id
  facility_id
  constraint_type
  monitored_facility_name
  element_type
  line_length
  voltage
  post_study_flow
  post_study_load
  post_study_load_ac
  post_study_load_dc
  post_study_rating
  pre_study_flow
  pre_study_load
  pre_study_rating
  worst_contingency_name
  network_upgrade_names
  project_id
  dfax
  mw_impact
  notes
  model
  area
  metadata
}
    `;
export const ModelPoiFragmentFragmentDoc = gql`
    fragment ModelPOIFragment on in_queue_model_pois {
  voltage
  poi_type
  poi_name
  poi
  id
  deleted
  cluster_id
  area
}
    `;
export const SpeculativeProjectFragmentFragmentDoc = gql`
    fragment SpeculativeProjectFragment on in_queue_speculative_projects {
  fuel_type
  id
  mw_capacity
  mw_energy
  mw_mfo
  project_id
  project_name
}
    `;
export const AddFavoriteBusDocument = gql`
    mutation AddFavoriteBus($niraBusId: String!) {
  insert_favorite_buses_one(
    object: {nira_bus_id: $niraBusId}
    on_conflict: {constraint: favorite_buses_auth0_id_nira_bus_id_key, update_columns: []}
  ) {
    nira_bus_id
  }
}
    `;
export type AddFavoriteBusMutationFn = Apollo.MutationFunction<AddFavoriteBusMutation, AddFavoriteBusMutationVariables>;

/**
 * __useAddFavoriteBusMutation__
 *
 * To run a mutation, you first call `useAddFavoriteBusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteBusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteBusMutation, { data, loading, error }] = useAddFavoriteBusMutation({
 *   variables: {
 *      niraBusId: // value for 'niraBusId'
 *   },
 * });
 */
export function useAddFavoriteBusMutation(baseOptions?: Apollo.MutationHookOptions<AddFavoriteBusMutation, AddFavoriteBusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavoriteBusMutation, AddFavoriteBusMutationVariables>(AddFavoriteBusDocument, options);
      }
export type AddFavoriteBusMutationHookResult = ReturnType<typeof useAddFavoriteBusMutation>;
export type AddFavoriteBusMutationResult = Apollo.MutationResult<AddFavoriteBusMutation>;
export type AddFavoriteBusMutationOptions = Apollo.BaseMutationOptions<AddFavoriteBusMutation, AddFavoriteBusMutationVariables>;
export const ArchiveScreeningViewDocument = gql`
    mutation ArchiveScreeningView($id: String!) {
  update_screening_views_by_pk(pk_columns: {id: $id}, _set: {is_archived: true}) {
    id
  }
}
    `;
export type ArchiveScreeningViewMutationFn = Apollo.MutationFunction<ArchiveScreeningViewMutation, ArchiveScreeningViewMutationVariables>;

/**
 * __useArchiveScreeningViewMutation__
 *
 * To run a mutation, you first call `useArchiveScreeningViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveScreeningViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveScreeningViewMutation, { data, loading, error }] = useArchiveScreeningViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveScreeningViewMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveScreeningViewMutation, ArchiveScreeningViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveScreeningViewMutation, ArchiveScreeningViewMutationVariables>(ArchiveScreeningViewDocument, options);
      }
export type ArchiveScreeningViewMutationHookResult = ReturnType<typeof useArchiveScreeningViewMutation>;
export type ArchiveScreeningViewMutationResult = Apollo.MutationResult<ArchiveScreeningViewMutation>;
export type ArchiveScreeningViewMutationOptions = Apollo.BaseMutationOptions<ArchiveScreeningViewMutation, ArchiveScreeningViewMutationVariables>;
export const CreateAdvancedStudyDocument = gql`
    mutation CreateAdvancedStudy($title: String!, $advanced_study_loads: [advanced_study_loads_insert_input!]!, $team_id: Int!, $region: String!, $scope: String!) {
  insert_advanced_studies_one(
    object: {title: $title, advanced_study_loads: {data: $advanced_study_loads}, status: "RUN_REQUESTED", team_id: $team_id, region: $region, scope: $scope}
  ) {
    advanced_study_id
  }
}
    `;
export type CreateAdvancedStudyMutationFn = Apollo.MutationFunction<CreateAdvancedStudyMutation, CreateAdvancedStudyMutationVariables>;

/**
 * __useCreateAdvancedStudyMutation__
 *
 * To run a mutation, you first call `useCreateAdvancedStudyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdvancedStudyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdvancedStudyMutation, { data, loading, error }] = useCreateAdvancedStudyMutation({
 *   variables: {
 *      title: // value for 'title'
 *      advanced_study_loads: // value for 'advanced_study_loads'
 *      team_id: // value for 'team_id'
 *      region: // value for 'region'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useCreateAdvancedStudyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdvancedStudyMutation, CreateAdvancedStudyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdvancedStudyMutation, CreateAdvancedStudyMutationVariables>(CreateAdvancedStudyDocument, options);
      }
export type CreateAdvancedStudyMutationHookResult = ReturnType<typeof useCreateAdvancedStudyMutation>;
export type CreateAdvancedStudyMutationResult = Apollo.MutationResult<CreateAdvancedStudyMutation>;
export type CreateAdvancedStudyMutationOptions = Apollo.BaseMutationOptions<CreateAdvancedStudyMutation, CreateAdvancedStudyMutationVariables>;
export const CreateScreeningViewDocument = gql`
    mutation CreateScreeningView($team_id: Int!, $voltages: jsonb!, $includes_pre_existing: Boolean!, $max_allocated_costs: numeric, $max_total_costs: numeric, $scope: String!, $hide_locked_buses: Boolean!, $hide_low_confidence_buses: Boolean!, $low_threshold: numeric!, $medium_threshold: numeric!, $high_threshold: numeric!, $region: String!, $generator_type: String!, $title: String!, $description: String!, $states: jsonb!, $owners: jsonb, $color_mode: String, $location_filter: String) {
  insert_screening_views_one(
    object: {team_id: $team_id, voltages: $voltages, includes_pre_existing: $includes_pre_existing, max_allocated_costs: $max_allocated_costs, max_total_costs: $max_total_costs, scope: $scope, hide_locked_buses: $hide_locked_buses, hide_low_confidence_buses: $hide_low_confidence_buses, low_threshold: $low_threshold, medium_threshold: $medium_threshold, high_threshold: $high_threshold, region: $region, generator_type: $generator_type, title: $title, description: $description, states: $states, owners: $owners, color_mode: $color_mode, location_filter: $location_filter}
  ) {
    id
  }
}
    `;
export type CreateScreeningViewMutationFn = Apollo.MutationFunction<CreateScreeningViewMutation, CreateScreeningViewMutationVariables>;

/**
 * __useCreateScreeningViewMutation__
 *
 * To run a mutation, you first call `useCreateScreeningViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScreeningViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScreeningViewMutation, { data, loading, error }] = useCreateScreeningViewMutation({
 *   variables: {
 *      team_id: // value for 'team_id'
 *      voltages: // value for 'voltages'
 *      includes_pre_existing: // value for 'includes_pre_existing'
 *      max_allocated_costs: // value for 'max_allocated_costs'
 *      max_total_costs: // value for 'max_total_costs'
 *      scope: // value for 'scope'
 *      hide_locked_buses: // value for 'hide_locked_buses'
 *      hide_low_confidence_buses: // value for 'hide_low_confidence_buses'
 *      low_threshold: // value for 'low_threshold'
 *      medium_threshold: // value for 'medium_threshold'
 *      high_threshold: // value for 'high_threshold'
 *      region: // value for 'region'
 *      generator_type: // value for 'generator_type'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      states: // value for 'states'
 *      owners: // value for 'owners'
 *      color_mode: // value for 'color_mode'
 *      location_filter: // value for 'location_filter'
 *   },
 * });
 */
export function useCreateScreeningViewMutation(baseOptions?: Apollo.MutationHookOptions<CreateScreeningViewMutation, CreateScreeningViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScreeningViewMutation, CreateScreeningViewMutationVariables>(CreateScreeningViewDocument, options);
      }
export type CreateScreeningViewMutationHookResult = ReturnType<typeof useCreateScreeningViewMutation>;
export type CreateScreeningViewMutationResult = Apollo.MutationResult<CreateScreeningViewMutation>;
export type CreateScreeningViewMutationOptions = Apollo.BaseMutationOptions<CreateScreeningViewMutation, CreateScreeningViewMutationVariables>;
export const CreateUserScopeConfigDocument = gql`
    mutation CreateUserScopeConfig($scope: String!, $display_name: String!, $region: String!, $scope_views: jsonb!, $data_freshness_markdown: String!, $subscription_id: Int!, $base_scope: String!, $queue_projects: [queue_projects_insert_input!]!, $buses_to_scopes: [buses_to_scopes_insert_input!]!) {
  insert_scopes_one(
    object: {scope: $scope, display_name: $display_name, region: $region, scope_views: $scope_views, data_freshness_markdown: $data_freshness_markdown, subscription_id: $subscription_id}
  ) {
    id
  }
  insert_user_scope_configs_one(object: {scope: $scope, base_scope: $base_scope}) {
    scope
  }
  insert_queue_projects(objects: $queue_projects) {
    affected_rows
  }
  insert_buses_to_scopes(objects: $buses_to_scopes) {
    affected_rows
  }
}
    `;
export type CreateUserScopeConfigMutationFn = Apollo.MutationFunction<CreateUserScopeConfigMutation, CreateUserScopeConfigMutationVariables>;

/**
 * __useCreateUserScopeConfigMutation__
 *
 * To run a mutation, you first call `useCreateUserScopeConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserScopeConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserScopeConfigMutation, { data, loading, error }] = useCreateUserScopeConfigMutation({
 *   variables: {
 *      scope: // value for 'scope'
 *      display_name: // value for 'display_name'
 *      region: // value for 'region'
 *      scope_views: // value for 'scope_views'
 *      data_freshness_markdown: // value for 'data_freshness_markdown'
 *      subscription_id: // value for 'subscription_id'
 *      base_scope: // value for 'base_scope'
 *      queue_projects: // value for 'queue_projects'
 *      buses_to_scopes: // value for 'buses_to_scopes'
 *   },
 * });
 */
export function useCreateUserScopeConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserScopeConfigMutation, CreateUserScopeConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserScopeConfigMutation, CreateUserScopeConfigMutationVariables>(CreateUserScopeConfigDocument, options);
      }
export type CreateUserScopeConfigMutationHookResult = ReturnType<typeof useCreateUserScopeConfigMutation>;
export type CreateUserScopeConfigMutationResult = Apollo.MutationResult<CreateUserScopeConfigMutation>;
export type CreateUserScopeConfigMutationOptions = Apollo.BaseMutationOptions<CreateUserScopeConfigMutation, CreateUserScopeConfigMutationVariables>;
export const GetAdvancedStudiesDocument = gql`
    query GetAdvancedStudies($scope: String!) {
  advanced_studies(where: {scope: {_eq: $scope}}) {
    advanced_study_id
    scope
    status
    title
    advanced_study_loads {
      mw_size
      nira_bus_id
      facility_type
      bus {
        bus_display_name
      }
    }
  }
}
    `;

/**
 * __useGetAdvancedStudiesQuery__
 *
 * To run a query within a React component, call `useGetAdvancedStudiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedStudiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedStudiesQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetAdvancedStudiesQuery(baseOptions: Apollo.QueryHookOptions<GetAdvancedStudiesQuery, GetAdvancedStudiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvancedStudiesQuery, GetAdvancedStudiesQueryVariables>(GetAdvancedStudiesDocument, options);
      }
export function useGetAdvancedStudiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedStudiesQuery, GetAdvancedStudiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvancedStudiesQuery, GetAdvancedStudiesQueryVariables>(GetAdvancedStudiesDocument, options);
        }
export type GetAdvancedStudiesQueryHookResult = ReturnType<typeof useGetAdvancedStudiesQuery>;
export type GetAdvancedStudiesLazyQueryHookResult = ReturnType<typeof useGetAdvancedStudiesLazyQuery>;
export type GetAdvancedStudiesQueryResult = Apollo.QueryResult<GetAdvancedStudiesQuery, GetAdvancedStudiesQueryVariables>;
export const GetAdvancedStudyResultsDocument = gql`
    query GetAdvancedStudyResults($advancedStudyId: uuid!) {
  advanced_studies_by_pk(advanced_study_id: $advancedStudyId) {
    advanced_study_id
    status
    advanced_study_constraint_stacks {
      monitored_facility_id
      monitored_facility_name
      rating
      bench_percent_loading
      study_percent_loading
      cost
      nira_bus_id
      dfax
      contingency
    }
  }
}
    `;

/**
 * __useGetAdvancedStudyResultsQuery__
 *
 * To run a query within a React component, call `useGetAdvancedStudyResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedStudyResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedStudyResultsQuery({
 *   variables: {
 *      advancedStudyId: // value for 'advancedStudyId'
 *   },
 * });
 */
export function useGetAdvancedStudyResultsQuery(baseOptions: Apollo.QueryHookOptions<GetAdvancedStudyResultsQuery, GetAdvancedStudyResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvancedStudyResultsQuery, GetAdvancedStudyResultsQueryVariables>(GetAdvancedStudyResultsDocument, options);
      }
export function useGetAdvancedStudyResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedStudyResultsQuery, GetAdvancedStudyResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvancedStudyResultsQuery, GetAdvancedStudyResultsQueryVariables>(GetAdvancedStudyResultsDocument, options);
        }
export type GetAdvancedStudyResultsQueryHookResult = ReturnType<typeof useGetAdvancedStudyResultsQuery>;
export type GetAdvancedStudyResultsLazyQueryHookResult = ReturnType<typeof useGetAdvancedStudyResultsLazyQuery>;
export type GetAdvancedStudyResultsQueryResult = Apollo.QueryResult<GetAdvancedStudyResultsQuery, GetAdvancedStudyResultsQueryVariables>;
export const GetBranchesDocument = gql`
    query getBranches($voltages: [numeric!]!, $region: jsonb!, $filter_states_where_clause: branches_bool_exp!) {
  branches(
    where: {_and: [{voltage: {_in: $voltages}}, {regions: {_contains: $region}}, $filter_states_where_clause]}
  ) {
    branch_path
    id
    voltage
  }
}
    `;

/**
 * __useGetBranchesQuery__
 *
 * To run a query within a React component, call `useGetBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchesQuery({
 *   variables: {
 *      voltages: // value for 'voltages'
 *      region: // value for 'region'
 *      filter_states_where_clause: // value for 'filter_states_where_clause'
 *   },
 * });
 */
export function useGetBranchesQuery(baseOptions: Apollo.QueryHookOptions<GetBranchesQuery, GetBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchesQuery, GetBranchesQueryVariables>(GetBranchesDocument, options);
      }
export function useGetBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchesQuery, GetBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchesQuery, GetBranchesQueryVariables>(GetBranchesDocument, options);
        }
export type GetBranchesQueryHookResult = ReturnType<typeof useGetBranchesQuery>;
export type GetBranchesLazyQueryHookResult = ReturnType<typeof useGetBranchesLazyQuery>;
export type GetBranchesQueryResult = Apollo.QueryResult<GetBranchesQuery, GetBranchesQueryVariables>;
export const GetBusByNiraBusIdDocument = gql`
    query getBusByNiraBusId($niraBusId: String!) {
  buses(where: {nira_bus_id: {_eq: $niraBusId}}) {
    id
    nira_bus_id
    voltage
    bus_display_name
    latitude
    longitude
    region
    location_code
    owner_name
    out_of_region
    utility_discharging
    utility_storage
    unlocked {
      unlocked
    }
  }
}
    `;

/**
 * __useGetBusByNiraBusIdQuery__
 *
 * To run a query within a React component, call `useGetBusByNiraBusIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusByNiraBusIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusByNiraBusIdQuery({
 *   variables: {
 *      niraBusId: // value for 'niraBusId'
 *   },
 * });
 */
export function useGetBusByNiraBusIdQuery(baseOptions: Apollo.QueryHookOptions<GetBusByNiraBusIdQuery, GetBusByNiraBusIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusByNiraBusIdQuery, GetBusByNiraBusIdQueryVariables>(GetBusByNiraBusIdDocument, options);
      }
export function useGetBusByNiraBusIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusByNiraBusIdQuery, GetBusByNiraBusIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusByNiraBusIdQuery, GetBusByNiraBusIdQueryVariables>(GetBusByNiraBusIdDocument, options);
        }
export type GetBusByNiraBusIdQueryHookResult = ReturnType<typeof useGetBusByNiraBusIdQuery>;
export type GetBusByNiraBusIdLazyQueryHookResult = ReturnType<typeof useGetBusByNiraBusIdLazyQuery>;
export type GetBusByNiraBusIdQueryResult = Apollo.QueryResult<GetBusByNiraBusIdQuery, GetBusByNiraBusIdQueryVariables>;
export const GetBusCapacityCostsDocument = gql`
    query getBusCapacityCosts($busId: String!, $scope: String!, $scopeView: String!, $includesPreExisting: Boolean!) {
  capacity_costs(
    where: {bus_id: {_eq: $busId}, scope: {_eq: $scope}, scope_view: {_eq: $scopeView}, includes_pre_existing: {_eq: $includesPreExisting}}
    order_by: {energy_size: asc}
  ) {
    energy_size
    capacity_size
    charging_size
  }
}
    `;

/**
 * __useGetBusCapacityCostsQuery__
 *
 * To run a query within a React component, call `useGetBusCapacityCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusCapacityCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusCapacityCostsQuery({
 *   variables: {
 *      busId: // value for 'busId'
 *      scope: // value for 'scope'
 *      scopeView: // value for 'scopeView'
 *      includesPreExisting: // value for 'includesPreExisting'
 *   },
 * });
 */
export function useGetBusCapacityCostsQuery(baseOptions: Apollo.QueryHookOptions<GetBusCapacityCostsQuery, GetBusCapacityCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusCapacityCostsQuery, GetBusCapacityCostsQueryVariables>(GetBusCapacityCostsDocument, options);
      }
export function useGetBusCapacityCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusCapacityCostsQuery, GetBusCapacityCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusCapacityCostsQuery, GetBusCapacityCostsQueryVariables>(GetBusCapacityCostsDocument, options);
        }
export type GetBusCapacityCostsQueryHookResult = ReturnType<typeof useGetBusCapacityCostsQuery>;
export type GetBusCapacityCostsLazyQueryHookResult = ReturnType<typeof useGetBusCapacityCostsLazyQuery>;
export type GetBusCapacityCostsQueryResult = Apollo.QueryResult<GetBusCapacityCostsQuery, GetBusCapacityCostsQueryVariables>;
export const GetBusScopeViewsDocument = gql`
    query getBusScopeViews($niraBusId: String!) {
  buses_to_scopes(where: {nira_bus_id: {_eq: $niraBusId}}) {
    scope
    scope_view
  }
}
    `;

/**
 * __useGetBusScopeViewsQuery__
 *
 * To run a query within a React component, call `useGetBusScopeViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusScopeViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusScopeViewsQuery({
 *   variables: {
 *      niraBusId: // value for 'niraBusId'
 *   },
 * });
 */
export function useGetBusScopeViewsQuery(baseOptions: Apollo.QueryHookOptions<GetBusScopeViewsQuery, GetBusScopeViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusScopeViewsQuery, GetBusScopeViewsQueryVariables>(GetBusScopeViewsDocument, options);
      }
export function useGetBusScopeViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusScopeViewsQuery, GetBusScopeViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusScopeViewsQuery, GetBusScopeViewsQueryVariables>(GetBusScopeViewsDocument, options);
        }
export type GetBusScopeViewsQueryHookResult = ReturnType<typeof useGetBusScopeViewsQuery>;
export type GetBusScopeViewsLazyQueryHookResult = ReturnType<typeof useGetBusScopeViewsLazyQuery>;
export type GetBusScopeViewsQueryResult = Apollo.QueryResult<GetBusScopeViewsQuery, GetBusScopeViewsQueryVariables>;
export const GetBusUnlockStatusDocument = gql`
    query getBusUnlockStatus($niraBusId: String!) {
  buses(where: {nira_bus_id: {_eq: $niraBusId}}) {
    nira_bus_id
    unlocked {
      unlocked
    }
  }
  subscriptions {
    id
    region
    unlimited
    num_buses
    end_date
    unlocked_buses_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetBusUnlockStatusQuery__
 *
 * To run a query within a React component, call `useGetBusUnlockStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusUnlockStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusUnlockStatusQuery({
 *   variables: {
 *      niraBusId: // value for 'niraBusId'
 *   },
 * });
 */
export function useGetBusUnlockStatusQuery(baseOptions: Apollo.QueryHookOptions<GetBusUnlockStatusQuery, GetBusUnlockStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusUnlockStatusQuery, GetBusUnlockStatusQueryVariables>(GetBusUnlockStatusDocument, options);
      }
export function useGetBusUnlockStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusUnlockStatusQuery, GetBusUnlockStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusUnlockStatusQuery, GetBusUnlockStatusQueryVariables>(GetBusUnlockStatusDocument, options);
        }
export type GetBusUnlockStatusQueryHookResult = ReturnType<typeof useGetBusUnlockStatusQuery>;
export type GetBusUnlockStatusLazyQueryHookResult = ReturnType<typeof useGetBusUnlockStatusLazyQuery>;
export type GetBusUnlockStatusQueryResult = Apollo.QueryResult<GetBusUnlockStatusQuery, GetBusUnlockStatusQueryVariables>;
export const GetBusesByNameOrIdDocument = gql`
    query getBusesByNameOrId($region: String!, $query: String!, $voltages: [numeric!]!, $scope: String!, $scopeView: String!, $locationCodes: [Int!]!, $filter_locked_buses_where_clause: buses_bool_exp!, $filter_states_where_clause: buses_bool_exp!) {
  buses(
    where: {_and: [{_or: [{bus_display_name: {_ilike: $query}}, {id: {_ilike: $query}}]}, {region: {_eq: $region}}, {voltage: {_in: $voltages}}, {bus_to_scopes: {_and: [{scope: {_eq: $scope}}, {scope_view: {_eq: $scopeView}}]}}, {location_code: {_in: $locationCodes}}, $filter_locked_buses_where_clause, $filter_states_where_clause]}
  ) {
    id
    nira_bus_id
    voltage
    bus_display_name
    latitude
    longitude
    region
    location_code
    owner_name
    out_of_region
  }
}
    `;

/**
 * __useGetBusesByNameOrIdQuery__
 *
 * To run a query within a React component, call `useGetBusesByNameOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusesByNameOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusesByNameOrIdQuery({
 *   variables: {
 *      region: // value for 'region'
 *      query: // value for 'query'
 *      voltages: // value for 'voltages'
 *      scope: // value for 'scope'
 *      scopeView: // value for 'scopeView'
 *      locationCodes: // value for 'locationCodes'
 *      filter_locked_buses_where_clause: // value for 'filter_locked_buses_where_clause'
 *      filter_states_where_clause: // value for 'filter_states_where_clause'
 *   },
 * });
 */
export function useGetBusesByNameOrIdQuery(baseOptions: Apollo.QueryHookOptions<GetBusesByNameOrIdQuery, GetBusesByNameOrIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusesByNameOrIdQuery, GetBusesByNameOrIdQueryVariables>(GetBusesByNameOrIdDocument, options);
      }
export function useGetBusesByNameOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusesByNameOrIdQuery, GetBusesByNameOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusesByNameOrIdQuery, GetBusesByNameOrIdQueryVariables>(GetBusesByNameOrIdDocument, options);
        }
export type GetBusesByNameOrIdQueryHookResult = ReturnType<typeof useGetBusesByNameOrIdQuery>;
export type GetBusesByNameOrIdLazyQueryHookResult = ReturnType<typeof useGetBusesByNameOrIdLazyQuery>;
export type GetBusesByNameOrIdQueryResult = Apollo.QueryResult<GetBusesByNameOrIdQuery, GetBusesByNameOrIdQueryVariables>;
export const GetBusesWithCapacityCostDocument = gql`
    query getBusesWithCapacityCost($minLat: numeric!, $minLong: numeric!, $maxLat: numeric!, $maxLong: numeric!, $voltages: [numeric!]!, $capacity_costs_where_clause: capacity_costs_bool_exp!, $region: String!, $scope: String!, $scopeView: String!, $locationCodes: [Int!]!, $filter_locked_buses_where_clause: buses_bool_exp!, $filter_states_where_clause: buses_bool_exp!, $includeConstraintCount: Boolean!, $constraint_stacks_where_clause: constraint_stacks_bool_exp, $filter_owners_where_clause: buses_bool_exp!) {
  buses(
    where: {_and: [{latitude: {_gte: $minLat}}, {latitude: {_lte: $maxLat}}, {longitude: {_lte: $maxLong}}, {longitude: {_gte: $minLong}}, {voltage: {_in: $voltages}}, {region: {_eq: $region}}, {bus_to_scopes: {_and: [{scope: {_eq: $scope}}, {scope_view: {_eq: $scopeView}}]}}, {location_code: {_in: $locationCodes}}, $filter_locked_buses_where_clause, $filter_states_where_clause, $filter_owners_where_clause]}
  ) {
    id
    nira_bus_id
    voltage
    latitude
    longitude
    region
    bus_display_name
    location_code
    owner_name
    out_of_region
    capacity_costs(
      where: $capacity_costs_where_clause
      order_by: {energy_size: desc}
      limit: 1
    ) {
      capacity_size
      energy_size
      charging_size
      upgrade_costs
      total_upgrade_costs
    }
    constraint_stacks_aggregate(where: $constraint_stacks_where_clause) @include(if: $includeConstraintCount) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetBusesWithCapacityCostQuery__
 *
 * To run a query within a React component, call `useGetBusesWithCapacityCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusesWithCapacityCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusesWithCapacityCostQuery({
 *   variables: {
 *      minLat: // value for 'minLat'
 *      minLong: // value for 'minLong'
 *      maxLat: // value for 'maxLat'
 *      maxLong: // value for 'maxLong'
 *      voltages: // value for 'voltages'
 *      capacity_costs_where_clause: // value for 'capacity_costs_where_clause'
 *      region: // value for 'region'
 *      scope: // value for 'scope'
 *      scopeView: // value for 'scopeView'
 *      locationCodes: // value for 'locationCodes'
 *      filter_locked_buses_where_clause: // value for 'filter_locked_buses_where_clause'
 *      filter_states_where_clause: // value for 'filter_states_where_clause'
 *      includeConstraintCount: // value for 'includeConstraintCount'
 *      constraint_stacks_where_clause: // value for 'constraint_stacks_where_clause'
 *      filter_owners_where_clause: // value for 'filter_owners_where_clause'
 *   },
 * });
 */
export function useGetBusesWithCapacityCostQuery(baseOptions: Apollo.QueryHookOptions<GetBusesWithCapacityCostQuery, GetBusesWithCapacityCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusesWithCapacityCostQuery, GetBusesWithCapacityCostQueryVariables>(GetBusesWithCapacityCostDocument, options);
      }
export function useGetBusesWithCapacityCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusesWithCapacityCostQuery, GetBusesWithCapacityCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusesWithCapacityCostQuery, GetBusesWithCapacityCostQueryVariables>(GetBusesWithCapacityCostDocument, options);
        }
export type GetBusesWithCapacityCostQueryHookResult = ReturnType<typeof useGetBusesWithCapacityCostQuery>;
export type GetBusesWithCapacityCostLazyQueryHookResult = ReturnType<typeof useGetBusesWithCapacityCostLazyQuery>;
export type GetBusesWithCapacityCostQueryResult = Apollo.QueryResult<GetBusesWithCapacityCostQuery, GetBusesWithCapacityCostQueryVariables>;
export const GetConnectedLinesWithCapacityCostsDocument = gql`
    query getConnectedLinesWithCapacityCosts($scope: String!, $scopeView: String!, $niraBusId: String!, $lineCapacityCostsWhereClause: line_capacity_costs_bool_exp!) {
  model_lines(
    where: {_and: [{_or: [{from_nira_bus_id: {_eq: $niraBusId}}, {to_nira_bus_id: {_eq: $niraBusId}}]}, {scope: {_eq: $scope}}, {scope_view: {_eq: $scopeView}}]}
  ) {
    facility_id
    line_length
    from_bus_id
    to_bus_id
    from_nira_bus_id
    to_nira_bus_id
    rating
    voltage
    from_bus {
      id
      nira_bus_id
      voltage
      bus_display_name
      latitude
      longitude
      region
      location_code
      owner_name
    }
    to_bus {
      id
      nira_bus_id
      voltage
      bus_display_name
      latitude
      longitude
      region
      location_code
      owner_name
    }
    line_capacity_costs(
      where: $lineCapacityCostsWhereClause
      order_by: {energy_size: desc}
      limit: 1
    ) {
      energy_size
      capacity_size
      charging_size
      upgrade_costs
      total_upgrade_costs
    }
  }
  model_lines_to_missing_buses(
    where: {_and: [{from_nira_bus_id: {_eq: $niraBusId}}, {scope: {_eq: $scope}}, {scope_view: {_eq: $scopeView}}]}
  ) {
    facility_id
    line_length
    rating
    voltage
    missing_bus_id
    queued_projects_at_missing_bus
  }
}
    `;

/**
 * __useGetConnectedLinesWithCapacityCostsQuery__
 *
 * To run a query within a React component, call `useGetConnectedLinesWithCapacityCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedLinesWithCapacityCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedLinesWithCapacityCostsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      scopeView: // value for 'scopeView'
 *      niraBusId: // value for 'niraBusId'
 *      lineCapacityCostsWhereClause: // value for 'lineCapacityCostsWhereClause'
 *   },
 * });
 */
export function useGetConnectedLinesWithCapacityCostsQuery(baseOptions: Apollo.QueryHookOptions<GetConnectedLinesWithCapacityCostsQuery, GetConnectedLinesWithCapacityCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectedLinesWithCapacityCostsQuery, GetConnectedLinesWithCapacityCostsQueryVariables>(GetConnectedLinesWithCapacityCostsDocument, options);
      }
export function useGetConnectedLinesWithCapacityCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectedLinesWithCapacityCostsQuery, GetConnectedLinesWithCapacityCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectedLinesWithCapacityCostsQuery, GetConnectedLinesWithCapacityCostsQueryVariables>(GetConnectedLinesWithCapacityCostsDocument, options);
        }
export type GetConnectedLinesWithCapacityCostsQueryHookResult = ReturnType<typeof useGetConnectedLinesWithCapacityCostsQuery>;
export type GetConnectedLinesWithCapacityCostsLazyQueryHookResult = ReturnType<typeof useGetConnectedLinesWithCapacityCostsLazyQuery>;
export type GetConnectedLinesWithCapacityCostsQueryResult = Apollo.QueryResult<GetConnectedLinesWithCapacityCostsQuery, GetConnectedLinesWithCapacityCostsQueryVariables>;
export const GetConstraintsDocument = gql`
    query getConstraints($constraintsWhereClause: constraint_stacks_bool_exp!) {
  constraint_stacks(where: $constraintsWhereClause) {
    bus_id
    nira_bus_id
    injection_threshold
    monitored_facility_name
    monitored_facility_id
    resource_type
    rating
    pre_study_load
    element_type
    line_length
    dfax
    estimated_cost
    scope
    scope_view
    contingency
    contingency_buses
    contingency_type
  }
}
    `;

/**
 * __useGetConstraintsQuery__
 *
 * To run a query within a React component, call `useGetConstraintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConstraintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConstraintsQuery({
 *   variables: {
 *      constraintsWhereClause: // value for 'constraintsWhereClause'
 *   },
 * });
 */
export function useGetConstraintsQuery(baseOptions: Apollo.QueryHookOptions<GetConstraintsQuery, GetConstraintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConstraintsQuery, GetConstraintsQueryVariables>(GetConstraintsDocument, options);
      }
export function useGetConstraintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConstraintsQuery, GetConstraintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConstraintsQuery, GetConstraintsQueryVariables>(GetConstraintsDocument, options);
        }
export type GetConstraintsQueryHookResult = ReturnType<typeof useGetConstraintsQuery>;
export type GetConstraintsLazyQueryHookResult = ReturnType<typeof useGetConstraintsLazyQuery>;
export type GetConstraintsQueryResult = Apollo.QueryResult<GetConstraintsQuery, GetConstraintsQueryVariables>;
export const GetFavoriteBusesDocument = gql`
    query getFavoriteBuses {
  favorite_buses(order_by: {created_at: desc}) {
    nira_bus_id
  }
}
    `;

/**
 * __useGetFavoriteBusesQuery__
 *
 * To run a query within a React component, call `useGetFavoriteBusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoriteBusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoriteBusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFavoriteBusesQuery(baseOptions?: Apollo.QueryHookOptions<GetFavoriteBusesQuery, GetFavoriteBusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoriteBusesQuery, GetFavoriteBusesQueryVariables>(GetFavoriteBusesDocument, options);
      }
export function useGetFavoriteBusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoriteBusesQuery, GetFavoriteBusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoriteBusesQuery, GetFavoriteBusesQueryVariables>(GetFavoriteBusesDocument, options);
        }
export type GetFavoriteBusesQueryHookResult = ReturnType<typeof useGetFavoriteBusesQuery>;
export type GetFavoriteBusesLazyQueryHookResult = ReturnType<typeof useGetFavoriteBusesLazyQuery>;
export type GetFavoriteBusesQueryResult = Apollo.QueryResult<GetFavoriteBusesQuery, GetFavoriteBusesQueryVariables>;
export const GetFavoriteBusesWithCapacityCostDocument = gql`
    query getFavoriteBusesWithCapacityCost($niraBusIds: [String!]!, $limit: Int!, $capacity_costs_where_clause: capacity_costs_bool_exp!, $capped_capacity_costs_where_clause: capacity_costs_bool_exp!, $region: String!, $scope: String!, $scopeView: String!, $filter_locked_buses_where_clause: buses_bool_exp!, $includeConstraintCount: Boolean!, $constraint_stacks_where_clause: constraint_stacks_bool_exp) {
  buses(
    limit: $limit
    where: {_and: [{nira_bus_id: {_in: $niraBusIds}}, {region: {_eq: $region}}, {bus_to_scopes: {_and: [{scope: {_eq: $scope}}, {scope_view: {_eq: $scopeView}}]}}, $filter_locked_buses_where_clause]}
  ) {
    id
    nira_bus_id
    voltage
    latitude
    longitude
    region
    bus_display_name
    location_code
    owner_name
    out_of_region
    capacity_costs(
      where: $capacity_costs_where_clause
      order_by: {energy_size: desc}
      limit: 1
    ) {
      capacity_size
      energy_size
      charging_size
      upgrade_costs
      total_upgrade_costs
    }
    capped_capacity_costs: capacity_costs(
      where: $capped_capacity_costs_where_clause
      order_by: {energy_size: desc}
      limit: 1
    ) {
      capacity_size
      energy_size
      charging_size
      upgrade_costs
      total_upgrade_costs
    }
    constraint_stacks_aggregate(where: $constraint_stacks_where_clause) @include(if: $includeConstraintCount) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetFavoriteBusesWithCapacityCostQuery__
 *
 * To run a query within a React component, call `useGetFavoriteBusesWithCapacityCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoriteBusesWithCapacityCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoriteBusesWithCapacityCostQuery({
 *   variables: {
 *      niraBusIds: // value for 'niraBusIds'
 *      limit: // value for 'limit'
 *      capacity_costs_where_clause: // value for 'capacity_costs_where_clause'
 *      capped_capacity_costs_where_clause: // value for 'capped_capacity_costs_where_clause'
 *      region: // value for 'region'
 *      scope: // value for 'scope'
 *      scopeView: // value for 'scopeView'
 *      filter_locked_buses_where_clause: // value for 'filter_locked_buses_where_clause'
 *      includeConstraintCount: // value for 'includeConstraintCount'
 *      constraint_stacks_where_clause: // value for 'constraint_stacks_where_clause'
 *   },
 * });
 */
export function useGetFavoriteBusesWithCapacityCostQuery(baseOptions: Apollo.QueryHookOptions<GetFavoriteBusesWithCapacityCostQuery, GetFavoriteBusesWithCapacityCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoriteBusesWithCapacityCostQuery, GetFavoriteBusesWithCapacityCostQueryVariables>(GetFavoriteBusesWithCapacityCostDocument, options);
      }
export function useGetFavoriteBusesWithCapacityCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoriteBusesWithCapacityCostQuery, GetFavoriteBusesWithCapacityCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoriteBusesWithCapacityCostQuery, GetFavoriteBusesWithCapacityCostQueryVariables>(GetFavoriteBusesWithCapacityCostDocument, options);
        }
export type GetFavoriteBusesWithCapacityCostQueryHookResult = ReturnType<typeof useGetFavoriteBusesWithCapacityCostQuery>;
export type GetFavoriteBusesWithCapacityCostLazyQueryHookResult = ReturnType<typeof useGetFavoriteBusesWithCapacityCostLazyQuery>;
export type GetFavoriteBusesWithCapacityCostQueryResult = Apollo.QueryResult<GetFavoriteBusesWithCapacityCostQuery, GetFavoriteBusesWithCapacityCostQueryVariables>;
export const GetLineTapCapacityCostsDocument = gql`
    query getLineTapCapacityCosts($tapFacilityId: String!, $scope: String!, $scopeView: String!, $includesPreExisting: Boolean!) {
  line_capacity_costs(
    where: {tap_facility_id: {_eq: $tapFacilityId}, scope: {_eq: $scope}, scope_view: {_eq: $scopeView}, includes_pre_existing: {_eq: $includesPreExisting}}
    order_by: {energy_size: asc}
  ) {
    energy_size
    capacity_size
    charging_size
  }
}
    `;

/**
 * __useGetLineTapCapacityCostsQuery__
 *
 * To run a query within a React component, call `useGetLineTapCapacityCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLineTapCapacityCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLineTapCapacityCostsQuery({
 *   variables: {
 *      tapFacilityId: // value for 'tapFacilityId'
 *      scope: // value for 'scope'
 *      scopeView: // value for 'scopeView'
 *      includesPreExisting: // value for 'includesPreExisting'
 *   },
 * });
 */
export function useGetLineTapCapacityCostsQuery(baseOptions: Apollo.QueryHookOptions<GetLineTapCapacityCostsQuery, GetLineTapCapacityCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLineTapCapacityCostsQuery, GetLineTapCapacityCostsQueryVariables>(GetLineTapCapacityCostsDocument, options);
      }
export function useGetLineTapCapacityCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLineTapCapacityCostsQuery, GetLineTapCapacityCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLineTapCapacityCostsQuery, GetLineTapCapacityCostsQueryVariables>(GetLineTapCapacityCostsDocument, options);
        }
export type GetLineTapCapacityCostsQueryHookResult = ReturnType<typeof useGetLineTapCapacityCostsQuery>;
export type GetLineTapCapacityCostsLazyQueryHookResult = ReturnType<typeof useGetLineTapCapacityCostsLazyQuery>;
export type GetLineTapCapacityCostsQueryResult = Apollo.QueryResult<GetLineTapCapacityCostsQuery, GetLineTapCapacityCostsQueryVariables>;
export const GetLineTapConstraintsDocument = gql`
    query getLineTapConstraints($constraintsWhereClause: line_constraint_stacks_bool_exp!) {
  line_constraint_stacks(where: $constraintsWhereClause) {
    tap_facility_id
    injection_threshold
    monitored_facility_name
    monitored_facility_id
    resource_type
    rating
    pre_study_load
    element_type
    line_length
    dfax
    estimated_cost
    scope
    scope_view
    contingency
  }
}
    `;

/**
 * __useGetLineTapConstraintsQuery__
 *
 * To run a query within a React component, call `useGetLineTapConstraintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLineTapConstraintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLineTapConstraintsQuery({
 *   variables: {
 *      constraintsWhereClause: // value for 'constraintsWhereClause'
 *   },
 * });
 */
export function useGetLineTapConstraintsQuery(baseOptions: Apollo.QueryHookOptions<GetLineTapConstraintsQuery, GetLineTapConstraintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLineTapConstraintsQuery, GetLineTapConstraintsQueryVariables>(GetLineTapConstraintsDocument, options);
      }
export function useGetLineTapConstraintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLineTapConstraintsQuery, GetLineTapConstraintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLineTapConstraintsQuery, GetLineTapConstraintsQueryVariables>(GetLineTapConstraintsDocument, options);
        }
export type GetLineTapConstraintsQueryHookResult = ReturnType<typeof useGetLineTapConstraintsQuery>;
export type GetLineTapConstraintsLazyQueryHookResult = ReturnType<typeof useGetLineTapConstraintsLazyQuery>;
export type GetLineTapConstraintsQueryResult = Apollo.QueryResult<GetLineTapConstraintsQuery, GetLineTapConstraintsQueryVariables>;
export const GetLineTapDataWithCapacityCostsDocument = gql`
    query getLineTapDataWithCapacityCosts($scope: String!, $scopeView: String!, $facilityId: String!, $capacityCostsWhereClause: capacity_costs_bool_exp!, $lineCapacityCostsWhereClause: line_capacity_costs_bool_exp!) {
  model_lines(
    where: {_and: [{scope: {_eq: $scope}}, {scope_view: {_eq: $scopeView}}, {facility_id: {_eq: $facilityId}}]}
  ) {
    facility_id
    rating
    line_length
    from_bus {
      id
      nira_bus_id
      voltage
      bus_display_name
      latitude
      longitude
      region
      location_code
      owner_name
      capacity_costs(
        where: $capacityCostsWhereClause
        order_by: {energy_size: desc}
        limit: 1
      ) {
        energy_size
        capacity_size
        charging_size
      }
      unlocked {
        unlocked
      }
    }
    to_bus {
      id
      nira_bus_id
      voltage
      bus_display_name
      latitude
      longitude
      region
      location_code
      owner_name
      capacity_costs(
        where: $capacityCostsWhereClause
        order_by: {energy_size: desc}
        limit: 1
      ) {
        energy_size
        capacity_size
        charging_size
      }
      unlocked {
        unlocked
      }
    }
    line_capacity_costs(
      where: $lineCapacityCostsWhereClause
      order_by: {energy_size: desc}
      limit: 1
    ) {
      energy_size
      capacity_size
      charging_size
      upgrade_costs
      total_upgrade_costs
    }
  }
}
    `;

/**
 * __useGetLineTapDataWithCapacityCostsQuery__
 *
 * To run a query within a React component, call `useGetLineTapDataWithCapacityCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLineTapDataWithCapacityCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLineTapDataWithCapacityCostsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      scopeView: // value for 'scopeView'
 *      facilityId: // value for 'facilityId'
 *      capacityCostsWhereClause: // value for 'capacityCostsWhereClause'
 *      lineCapacityCostsWhereClause: // value for 'lineCapacityCostsWhereClause'
 *   },
 * });
 */
export function useGetLineTapDataWithCapacityCostsQuery(baseOptions: Apollo.QueryHookOptions<GetLineTapDataWithCapacityCostsQuery, GetLineTapDataWithCapacityCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLineTapDataWithCapacityCostsQuery, GetLineTapDataWithCapacityCostsQueryVariables>(GetLineTapDataWithCapacityCostsDocument, options);
      }
export function useGetLineTapDataWithCapacityCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLineTapDataWithCapacityCostsQuery, GetLineTapDataWithCapacityCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLineTapDataWithCapacityCostsQuery, GetLineTapDataWithCapacityCostsQueryVariables>(GetLineTapDataWithCapacityCostsDocument, options);
        }
export type GetLineTapDataWithCapacityCostsQueryHookResult = ReturnType<typeof useGetLineTapDataWithCapacityCostsQuery>;
export type GetLineTapDataWithCapacityCostsLazyQueryHookResult = ReturnType<typeof useGetLineTapDataWithCapacityCostsLazyQuery>;
export type GetLineTapDataWithCapacityCostsQueryResult = Apollo.QueryResult<GetLineTapDataWithCapacityCostsQuery, GetLineTapDataWithCapacityCostsQueryVariables>;
export const GetOwnersByRegionAndScopeDocument = gql`
    query getOwnersByRegionAndScope($region: String!, $scope: String!, $scopeView: String!) {
  buses(
    where: {_and: [{region: {_eq: $region}}, {bus_to_scopes: {_and: [{scope: {_eq: $scope}}, {scope_view: {_eq: $scopeView}}]}}, {owner_name: {_is_null: false}}]}
    distinct_on: owner_name
  ) {
    owner_name
  }
}
    `;

/**
 * __useGetOwnersByRegionAndScopeQuery__
 *
 * To run a query within a React component, call `useGetOwnersByRegionAndScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnersByRegionAndScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnersByRegionAndScopeQuery({
 *   variables: {
 *      region: // value for 'region'
 *      scope: // value for 'scope'
 *      scopeView: // value for 'scopeView'
 *   },
 * });
 */
export function useGetOwnersByRegionAndScopeQuery(baseOptions: Apollo.QueryHookOptions<GetOwnersByRegionAndScopeQuery, GetOwnersByRegionAndScopeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnersByRegionAndScopeQuery, GetOwnersByRegionAndScopeQueryVariables>(GetOwnersByRegionAndScopeDocument, options);
      }
export function useGetOwnersByRegionAndScopeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnersByRegionAndScopeQuery, GetOwnersByRegionAndScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnersByRegionAndScopeQuery, GetOwnersByRegionAndScopeQueryVariables>(GetOwnersByRegionAndScopeDocument, options);
        }
export type GetOwnersByRegionAndScopeQueryHookResult = ReturnType<typeof useGetOwnersByRegionAndScopeQuery>;
export type GetOwnersByRegionAndScopeLazyQueryHookResult = ReturnType<typeof useGetOwnersByRegionAndScopeLazyQuery>;
export type GetOwnersByRegionAndScopeQueryResult = Apollo.QueryResult<GetOwnersByRegionAndScopeQuery, GetOwnersByRegionAndScopeQueryVariables>;
export const GetPlannedInterconnectionLocationsDocument = gql`
    query getPlannedInterconnectionLocations {
  planned_interconnection_locations {
    nira_bus_id
    planned_mw
  }
}
    `;

/**
 * __useGetPlannedInterconnectionLocationsQuery__
 *
 * To run a query within a React component, call `useGetPlannedInterconnectionLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannedInterconnectionLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannedInterconnectionLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlannedInterconnectionLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlannedInterconnectionLocationsQuery, GetPlannedInterconnectionLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannedInterconnectionLocationsQuery, GetPlannedInterconnectionLocationsQueryVariables>(GetPlannedInterconnectionLocationsDocument, options);
      }
export function useGetPlannedInterconnectionLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannedInterconnectionLocationsQuery, GetPlannedInterconnectionLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannedInterconnectionLocationsQuery, GetPlannedInterconnectionLocationsQueryVariables>(GetPlannedInterconnectionLocationsDocument, options);
        }
export type GetPlannedInterconnectionLocationsQueryHookResult = ReturnType<typeof useGetPlannedInterconnectionLocationsQuery>;
export type GetPlannedInterconnectionLocationsLazyQueryHookResult = ReturnType<typeof useGetPlannedInterconnectionLocationsLazyQuery>;
export type GetPlannedInterconnectionLocationsQueryResult = Apollo.QueryResult<GetPlannedInterconnectionLocationsQuery, GetPlannedInterconnectionLocationsQueryVariables>;
export const GetPoiBusesByNameOrIdDocument = gql`
    query getPoiBusesByNameOrId($region: String!, $query: String!, $scope_view_filters: [buses_bool_exp!]!) {
  buses(
    where: {_and: [{_or: [{bus_display_name: {_ilike: $query}}, {id: {_ilike: $query}}]}, {region: {_eq: $region}}, {_and: $scope_view_filters}]}
    order_by: {bus_display_name: asc}
    limit: 20
  ) {
    id
    nira_bus_id
    bus_display_name
    utility_discharging
    utility_storage
  }
}
    `;

/**
 * __useGetPoiBusesByNameOrIdQuery__
 *
 * To run a query within a React component, call `useGetPoiBusesByNameOrIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoiBusesByNameOrIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoiBusesByNameOrIdQuery({
 *   variables: {
 *      region: // value for 'region'
 *      query: // value for 'query'
 *      scope_view_filters: // value for 'scope_view_filters'
 *   },
 * });
 */
export function useGetPoiBusesByNameOrIdQuery(baseOptions: Apollo.QueryHookOptions<GetPoiBusesByNameOrIdQuery, GetPoiBusesByNameOrIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoiBusesByNameOrIdQuery, GetPoiBusesByNameOrIdQueryVariables>(GetPoiBusesByNameOrIdDocument, options);
      }
export function useGetPoiBusesByNameOrIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPoiBusesByNameOrIdQuery, GetPoiBusesByNameOrIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoiBusesByNameOrIdQuery, GetPoiBusesByNameOrIdQueryVariables>(GetPoiBusesByNameOrIdDocument, options);
        }
export type GetPoiBusesByNameOrIdQueryHookResult = ReturnType<typeof useGetPoiBusesByNameOrIdQuery>;
export type GetPoiBusesByNameOrIdLazyQueryHookResult = ReturnType<typeof useGetPoiBusesByNameOrIdLazyQuery>;
export type GetPoiBusesByNameOrIdQueryResult = Apollo.QueryResult<GetPoiBusesByNameOrIdQuery, GetPoiBusesByNameOrIdQueryVariables>;
export const GetPoiBusesByNiraBusIdDocument = gql`
    query getPoiBusesByNiraBusId($region: String!, $nira_bus_ids: [String!]!, $scope_view_filters: [buses_bool_exp!]!) {
  buses(
    where: {_and: [{region: {_eq: $region}}, {nira_bus_id: {_in: $nira_bus_ids}}, {_and: $scope_view_filters}]}
  ) {
    id
    nira_bus_id
    bus_display_name
    utility_discharging
    utility_storage
  }
}
    `;

/**
 * __useGetPoiBusesByNiraBusIdQuery__
 *
 * To run a query within a React component, call `useGetPoiBusesByNiraBusIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoiBusesByNiraBusIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoiBusesByNiraBusIdQuery({
 *   variables: {
 *      region: // value for 'region'
 *      nira_bus_ids: // value for 'nira_bus_ids'
 *      scope_view_filters: // value for 'scope_view_filters'
 *   },
 * });
 */
export function useGetPoiBusesByNiraBusIdQuery(baseOptions: Apollo.QueryHookOptions<GetPoiBusesByNiraBusIdQuery, GetPoiBusesByNiraBusIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoiBusesByNiraBusIdQuery, GetPoiBusesByNiraBusIdQueryVariables>(GetPoiBusesByNiraBusIdDocument, options);
      }
export function useGetPoiBusesByNiraBusIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPoiBusesByNiraBusIdQuery, GetPoiBusesByNiraBusIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoiBusesByNiraBusIdQuery, GetPoiBusesByNiraBusIdQueryVariables>(GetPoiBusesByNiraBusIdDocument, options);
        }
export type GetPoiBusesByNiraBusIdQueryHookResult = ReturnType<typeof useGetPoiBusesByNiraBusIdQuery>;
export type GetPoiBusesByNiraBusIdLazyQueryHookResult = ReturnType<typeof useGetPoiBusesByNiraBusIdLazyQuery>;
export type GetPoiBusesByNiraBusIdQueryResult = Apollo.QueryResult<GetPoiBusesByNiraBusIdQuery, GetPoiBusesByNiraBusIdQueryVariables>;
export const GetQueueProjectHopsDocument = gql`
    query getQueueProjectHops($nira_bus_id: String!, $scope_view: String!, $region: String!) {
  queue_project_hops(
    where: {nira_bus_id: {_eq: $nira_bus_id}, scope_view: {_eq: $scope_view}, region: {_eq: $region}}
  ) {
    project_number
    num_hops
    queue_project {
      project_number
      eris_capacity_mw
      nris_capacity_mw
      fuel_type
      poi_description
      status
      sub_region
      cluster
      bus_id
      facility_id
    }
  }
}
    `;

/**
 * __useGetQueueProjectHopsQuery__
 *
 * To run a query within a React component, call `useGetQueueProjectHopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueProjectHopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueProjectHopsQuery({
 *   variables: {
 *      nira_bus_id: // value for 'nira_bus_id'
 *      scope_view: // value for 'scope_view'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetQueueProjectHopsQuery(baseOptions: Apollo.QueryHookOptions<GetQueueProjectHopsQuery, GetQueueProjectHopsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueProjectHopsQuery, GetQueueProjectHopsQueryVariables>(GetQueueProjectHopsDocument, options);
      }
export function useGetQueueProjectHopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueProjectHopsQuery, GetQueueProjectHopsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueProjectHopsQuery, GetQueueProjectHopsQueryVariables>(GetQueueProjectHopsDocument, options);
        }
export type GetQueueProjectHopsQueryHookResult = ReturnType<typeof useGetQueueProjectHopsQuery>;
export type GetQueueProjectHopsLazyQueryHookResult = ReturnType<typeof useGetQueueProjectHopsLazyQuery>;
export type GetQueueProjectHopsQueryResult = Apollo.QueryResult<GetQueueProjectHopsQuery, GetQueueProjectHopsQueryVariables>;
export const GetQueueProjectScopeMembershipDocument = gql`
    query getQueueProjectScopeMembership($region: String!, $current_scope: String!, $realistic_scope: String!, $scope_view: String!, $include_miso_realistic: Boolean!) {
  in_current_scope: queue_projects(
    where: {region: {_eq: $region}, scope: {_eq: $current_scope}, scope_view: {_eq: $scope_view}, included: {_eq: true}}
  ) {
    project_number
  }
  in_miso_realistic: queue_projects(
    where: {region: {_eq: $region}, scope: {_eq: $realistic_scope}, scope_view: {_eq: $scope_view}, included: {_eq: true}}
  ) @include(if: $include_miso_realistic) {
    project_number
  }
}
    `;

/**
 * __useGetQueueProjectScopeMembershipQuery__
 *
 * To run a query within a React component, call `useGetQueueProjectScopeMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueProjectScopeMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueProjectScopeMembershipQuery({
 *   variables: {
 *      region: // value for 'region'
 *      current_scope: // value for 'current_scope'
 *      realistic_scope: // value for 'realistic_scope'
 *      scope_view: // value for 'scope_view'
 *      include_miso_realistic: // value for 'include_miso_realistic'
 *   },
 * });
 */
export function useGetQueueProjectScopeMembershipQuery(baseOptions: Apollo.QueryHookOptions<GetQueueProjectScopeMembershipQuery, GetQueueProjectScopeMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueProjectScopeMembershipQuery, GetQueueProjectScopeMembershipQueryVariables>(GetQueueProjectScopeMembershipDocument, options);
      }
export function useGetQueueProjectScopeMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueProjectScopeMembershipQuery, GetQueueProjectScopeMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueProjectScopeMembershipQuery, GetQueueProjectScopeMembershipQueryVariables>(GetQueueProjectScopeMembershipDocument, options);
        }
export type GetQueueProjectScopeMembershipQueryHookResult = ReturnType<typeof useGetQueueProjectScopeMembershipQuery>;
export type GetQueueProjectScopeMembershipLazyQueryHookResult = ReturnType<typeof useGetQueueProjectScopeMembershipLazyQuery>;
export type GetQueueProjectScopeMembershipQueryResult = Apollo.QueryResult<GetQueueProjectScopeMembershipQuery, GetQueueProjectScopeMembershipQueryVariables>;
export const GetQueueProjectsDocument = gql`
    query getQueueProjects($scope: String!, $scope_views: [String!]!, $region: String!) {
  queue_projects(
    where: {scope: {_eq: $scope}, scope_view: {_in: $scope_views}, region: {_eq: $region}}
  ) {
    bus_id
    nira_bus_id
    cluster
    eris_capacity_mw
    facility_id
    fuel_type
    included
    is_speculative
    nris_capacity_mw
    poi_description
    project_number
    scope_view
    status
    sub_region
  }
}
    `;

/**
 * __useGetQueueProjectsQuery__
 *
 * To run a query within a React component, call `useGetQueueProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueProjectsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      scope_views: // value for 'scope_views'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetQueueProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetQueueProjectsQuery, GetQueueProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueProjectsQuery, GetQueueProjectsQueryVariables>(GetQueueProjectsDocument, options);
      }
export function useGetQueueProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueProjectsQuery, GetQueueProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueProjectsQuery, GetQueueProjectsQueryVariables>(GetQueueProjectsDocument, options);
        }
export type GetQueueProjectsQueryHookResult = ReturnType<typeof useGetQueueProjectsQuery>;
export type GetQueueProjectsLazyQueryHookResult = ReturnType<typeof useGetQueueProjectsLazyQuery>;
export type GetQueueProjectsQueryResult = Apollo.QueryResult<GetQueueProjectsQuery, GetQueueProjectsQueryVariables>;
export const GetRelatedQueueProjectsDocument = gql`
    query getRelatedQueueProjects($nira_bus_id: String!, $scope: String!, $scope_view: String!, $region: String!) {
  constraint_stacks(
    where: {nira_bus_id: {_eq: $nira_bus_id}, scope: {_eq: $scope}, scope_view: {_eq: $scope_view}}
  ) {
    monitored_facility_id
    monitored_facility_name
    contingency
    resource_type
    rating
    injection_threshold
    dfax
    queue_project_facility_dfaxes(where: {region: {_eq: $region}}) {
      project_number
      dfax
      queue_project {
        project_number
        eris_capacity_mw
        nris_capacity_mw
        fuel_type
        poi_description
        status
        sub_region
        cluster
        bus_id
        facility_id
      }
    }
  }
}
    `;

/**
 * __useGetRelatedQueueProjectsQuery__
 *
 * To run a query within a React component, call `useGetRelatedQueueProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedQueueProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedQueueProjectsQuery({
 *   variables: {
 *      nira_bus_id: // value for 'nira_bus_id'
 *      scope: // value for 'scope'
 *      scope_view: // value for 'scope_view'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetRelatedQueueProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedQueueProjectsQuery, GetRelatedQueueProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedQueueProjectsQuery, GetRelatedQueueProjectsQueryVariables>(GetRelatedQueueProjectsDocument, options);
      }
export function useGetRelatedQueueProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedQueueProjectsQuery, GetRelatedQueueProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedQueueProjectsQuery, GetRelatedQueueProjectsQueryVariables>(GetRelatedQueueProjectsDocument, options);
        }
export type GetRelatedQueueProjectsQueryHookResult = ReturnType<typeof useGetRelatedQueueProjectsQuery>;
export type GetRelatedQueueProjectsLazyQueryHookResult = ReturnType<typeof useGetRelatedQueueProjectsLazyQuery>;
export type GetRelatedQueueProjectsQueryResult = Apollo.QueryResult<GetRelatedQueueProjectsQuery, GetRelatedQueueProjectsQueryVariables>;
export const GetRestudiedBusesDocument = gql`
    query getRestudiedBuses($region: String!) {
  buses_to_scopes(
    where: {scope_info: {user_scope_config: {}}, bus: {region: {_eq: $region}}}
    distinct_on: [nira_bus_id, scope]
    order_by: [{nira_bus_id: asc}, {scope: asc}]
  ) {
    nira_bus_id
    scope
    bus {
      bus_display_name
      region
    }
    scope_info {
      display_name
      user_scope_config {
        status
        created_at
      }
    }
  }
}
    `;

/**
 * __useGetRestudiedBusesQuery__
 *
 * To run a query within a React component, call `useGetRestudiedBusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestudiedBusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestudiedBusesQuery({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetRestudiedBusesQuery(baseOptions: Apollo.QueryHookOptions<GetRestudiedBusesQuery, GetRestudiedBusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestudiedBusesQuery, GetRestudiedBusesQueryVariables>(GetRestudiedBusesDocument, options);
      }
export function useGetRestudiedBusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestudiedBusesQuery, GetRestudiedBusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestudiedBusesQuery, GetRestudiedBusesQueryVariables>(GetRestudiedBusesDocument, options);
        }
export type GetRestudiedBusesQueryHookResult = ReturnType<typeof useGetRestudiedBusesQuery>;
export type GetRestudiedBusesLazyQueryHookResult = ReturnType<typeof useGetRestudiedBusesLazyQuery>;
export type GetRestudiedBusesQueryResult = Apollo.QueryResult<GetRestudiedBusesQuery, GetRestudiedBusesQueryVariables>;
export const GetScopesForBusDocument = gql`
    query getScopesForBus($niraBusId: String!) {
  scopes(
    where: {buses_to_scopes: {nira_bus_id: {_eq: $niraBusId}}}
    order_by: [{subscription_id: asc_nulls_first}, {display_name: asc}]
  ) {
    id
    display_name
    region
    scope
    scope_views
    data_freshness_date
    data_freshness_markdown
    data_freshness_model
    subscription_id
    user_scope_config {
      base_scope
      status
      created_at
    }
  }
}
    `;

/**
 * __useGetScopesForBusQuery__
 *
 * To run a query within a React component, call `useGetScopesForBusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopesForBusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopesForBusQuery({
 *   variables: {
 *      niraBusId: // value for 'niraBusId'
 *   },
 * });
 */
export function useGetScopesForBusQuery(baseOptions: Apollo.QueryHookOptions<GetScopesForBusQuery, GetScopesForBusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScopesForBusQuery, GetScopesForBusQueryVariables>(GetScopesForBusDocument, options);
      }
export function useGetScopesForBusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScopesForBusQuery, GetScopesForBusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScopesForBusQuery, GetScopesForBusQueryVariables>(GetScopesForBusDocument, options);
        }
export type GetScopesForBusQueryHookResult = ReturnType<typeof useGetScopesForBusQuery>;
export type GetScopesForBusLazyQueryHookResult = ReturnType<typeof useGetScopesForBusLazyQuery>;
export type GetScopesForBusQueryResult = Apollo.QueryResult<GetScopesForBusQuery, GetScopesForBusQueryVariables>;
export const GetScopesWithQueueProjectsDocument = gql`
    query getScopesWithQueueProjects($scopes: [String!]!, $scope_views: [String!]!, $region: String!) {
  queue_projects(
    where: {scope: {_in: $scopes}, scope_view: {_in: $scope_views}, region: {_eq: $region}}
    distinct_on: [scope, scope_view]
  ) {
    scope
    scope_view
  }
}
    `;

/**
 * __useGetScopesWithQueueProjectsQuery__
 *
 * To run a query within a React component, call `useGetScopesWithQueueProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopesWithQueueProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopesWithQueueProjectsQuery({
 *   variables: {
 *      scopes: // value for 'scopes'
 *      scope_views: // value for 'scope_views'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetScopesWithQueueProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetScopesWithQueueProjectsQuery, GetScopesWithQueueProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScopesWithQueueProjectsQuery, GetScopesWithQueueProjectsQueryVariables>(GetScopesWithQueueProjectsDocument, options);
      }
export function useGetScopesWithQueueProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScopesWithQueueProjectsQuery, GetScopesWithQueueProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScopesWithQueueProjectsQuery, GetScopesWithQueueProjectsQueryVariables>(GetScopesWithQueueProjectsDocument, options);
        }
export type GetScopesWithQueueProjectsQueryHookResult = ReturnType<typeof useGetScopesWithQueueProjectsQuery>;
export type GetScopesWithQueueProjectsLazyQueryHookResult = ReturnType<typeof useGetScopesWithQueueProjectsLazyQuery>;
export type GetScopesWithQueueProjectsQueryResult = Apollo.QueryResult<GetScopesWithQueueProjectsQuery, GetScopesWithQueueProjectsQueryVariables>;
export const GetScreeningViewsDocument = gql`
    query getScreeningViews($maybe_id_filter: screening_views_bool_exp!) {
  screening_views(where: {_and: [{is_archived: {_eq: false}}, $maybe_id_filter]}) {
    id
    color_mode
    created_at
    description
    generator_type
    hide_locked_buses
    hide_low_confidence_buses
    high_threshold
    includes_pre_existing
    location_filter
    low_threshold
    max_allocated_costs
    max_total_costs
    medium_threshold
    owners
    region
    scope
    states
    title
    voltages
    user {
      auth0_id
      email
    }
  }
}
    `;

/**
 * __useGetScreeningViewsQuery__
 *
 * To run a query within a React component, call `useGetScreeningViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreeningViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreeningViewsQuery({
 *   variables: {
 *      maybe_id_filter: // value for 'maybe_id_filter'
 *   },
 * });
 */
export function useGetScreeningViewsQuery(baseOptions: Apollo.QueryHookOptions<GetScreeningViewsQuery, GetScreeningViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScreeningViewsQuery, GetScreeningViewsQueryVariables>(GetScreeningViewsDocument, options);
      }
export function useGetScreeningViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScreeningViewsQuery, GetScreeningViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScreeningViewsQuery, GetScreeningViewsQueryVariables>(GetScreeningViewsDocument, options);
        }
export type GetScreeningViewsQueryHookResult = ReturnType<typeof useGetScreeningViewsQuery>;
export type GetScreeningViewsLazyQueryHookResult = ReturnType<typeof useGetScreeningViewsLazyQuery>;
export type GetScreeningViewsQueryResult = Apollo.QueryResult<GetScreeningViewsQuery, GetScreeningViewsQueryVariables>;
export const GetSpeculativeProjectsForCopyDocument = gql`
    query getSpeculativeProjectsForCopy($region: String!) {
  queue_projects(
    where: {region: {_eq: $region}, is_speculative: {_eq: true}, scope_info: {user_scope_config: {}}}
    distinct_on: [scope, project_number]
    order_by: [{scope: asc}, {project_number: asc}]
  ) {
    scope
    project_number
    poi_description
    bus_id
    nira_bus_id
    fuel_type
    eris_capacity_mw
    charging_capacity_mw
    scope_info {
      display_name
      user_scope_config {
        status
        created_at
      }
      buses_to_scopes(distinct_on: [nira_bus_id]) {
        nira_bus_id
        bus {
          bus_display_name
        }
      }
    }
  }
}
    `;

/**
 * __useGetSpeculativeProjectsForCopyQuery__
 *
 * To run a query within a React component, call `useGetSpeculativeProjectsForCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeculativeProjectsForCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeculativeProjectsForCopyQuery({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetSpeculativeProjectsForCopyQuery(baseOptions: Apollo.QueryHookOptions<GetSpeculativeProjectsForCopyQuery, GetSpeculativeProjectsForCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeculativeProjectsForCopyQuery, GetSpeculativeProjectsForCopyQueryVariables>(GetSpeculativeProjectsForCopyDocument, options);
      }
export function useGetSpeculativeProjectsForCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeculativeProjectsForCopyQuery, GetSpeculativeProjectsForCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeculativeProjectsForCopyQuery, GetSpeculativeProjectsForCopyQueryVariables>(GetSpeculativeProjectsForCopyDocument, options);
        }
export type GetSpeculativeProjectsForCopyQueryHookResult = ReturnType<typeof useGetSpeculativeProjectsForCopyQuery>;
export type GetSpeculativeProjectsForCopyLazyQueryHookResult = ReturnType<typeof useGetSpeculativeProjectsForCopyLazyQuery>;
export type GetSpeculativeProjectsForCopyQueryResult = Apollo.QueryResult<GetSpeculativeProjectsForCopyQuery, GetSpeculativeProjectsForCopyQueryVariables>;
export const GetSubscriptionsDocument = gql`
    query getSubscriptions {
  subscriptions {
    id
    region
    unlimited
    num_buses
    end_date
    unlocked_buses_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
      }
export function useGetSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export type GetSubscriptionsQueryHookResult = ReturnType<typeof useGetSubscriptionsQuery>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsLazyQuery>;
export type GetSubscriptionsQueryResult = Apollo.QueryResult<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>;
export const GetUserDataDocument = gql`
    query getUserData($userId: String!) {
  users(where: {auth0_id: {_eq: $userId}}) {
    id
    auth0_id
    team_id
    role
    feature_flags
    colorblind_mode
    team {
      name
      subscriptions {
        id
        region
        unlimited
        num_buses
        end_date
        unlocked_buses_aggregate {
          aggregate {
            count
          }
        }
      }
      feature_flags
    }
  }
  scopes(order_by: [{subscription_id: asc_nulls_first}, {display_name: asc}]) {
    id
    display_name
    region
    scope
    scope_views
    data_freshness_date
    data_freshness_markdown
    data_freshness_model
    subscription_id
    user_scope_config {
      base_scope
      status
      created_at
    }
  }
}
    `;

/**
 * __useGetUserDataQuery__
 *
 * To run a query within a React component, call `useGetUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDataQuery(baseOptions: Apollo.QueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
      }
export function useGetUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataQuery, GetUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataQuery, GetUserDataQueryVariables>(GetUserDataDocument, options);
        }
export type GetUserDataQueryHookResult = ReturnType<typeof useGetUserDataQuery>;
export type GetUserDataLazyQueryHookResult = ReturnType<typeof useGetUserDataLazyQuery>;
export type GetUserDataQueryResult = Apollo.QueryResult<GetUserDataQuery, GetUserDataQueryVariables>;
export const ArchiveCustomUpgradeDocument = gql`
    mutation ArchiveCustomUpgrade($id: uuid!) {
  update_custom_upgrades_by_pk(pk_columns: {id: $id}, _set: {status: "archived"}) {
    ...CustomUpgradeFields
  }
}
    ${CustomUpgradeFieldsFragmentDoc}`;
export type ArchiveCustomUpgradeMutationFn = Apollo.MutationFunction<ArchiveCustomUpgradeMutation, ArchiveCustomUpgradeMutationVariables>;

/**
 * __useArchiveCustomUpgradeMutation__
 *
 * To run a mutation, you first call `useArchiveCustomUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCustomUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCustomUpgradeMutation, { data, loading, error }] = useArchiveCustomUpgradeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveCustomUpgradeMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCustomUpgradeMutation, ArchiveCustomUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCustomUpgradeMutation, ArchiveCustomUpgradeMutationVariables>(ArchiveCustomUpgradeDocument, options);
      }
export type ArchiveCustomUpgradeMutationHookResult = ReturnType<typeof useArchiveCustomUpgradeMutation>;
export type ArchiveCustomUpgradeMutationResult = Apollo.MutationResult<ArchiveCustomUpgradeMutation>;
export type ArchiveCustomUpgradeMutationOptions = Apollo.BaseMutationOptions<ArchiveCustomUpgradeMutation, ArchiveCustomUpgradeMutationVariables>;
export const CreateCustomUpgradeDocument = gql`
    mutation CreateCustomUpgrade($clusterId: uuid!, $teamId: Int!, $authId: String!, $sourceFileContents: String!, $sourceFileFormat: String!, $sourceFileName: String!, $name: String!, $notes: String, $customUpgradeFiles: [custom_upgrade_files_insert_input!]!) {
  insert_custom_upgrades_one(
    object: {cluster_id: $clusterId, team_id: $teamId, type: "customer", source_file_contents: $sourceFileContents, source_file_format: $sourceFileFormat, source_file_name: $sourceFileName, custom_upgrade_files: {data: $customUpgradeFiles}, name: $name, notes: $notes, created_by: $authId}
  ) {
    ...CustomUpgradeFields
  }
}
    ${CustomUpgradeFieldsFragmentDoc}`;
export type CreateCustomUpgradeMutationFn = Apollo.MutationFunction<CreateCustomUpgradeMutation, CreateCustomUpgradeMutationVariables>;

/**
 * __useCreateCustomUpgradeMutation__
 *
 * To run a mutation, you first call `useCreateCustomUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomUpgradeMutation, { data, loading, error }] = useCreateCustomUpgradeMutation({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      teamId: // value for 'teamId'
 *      authId: // value for 'authId'
 *      sourceFileContents: // value for 'sourceFileContents'
 *      sourceFileFormat: // value for 'sourceFileFormat'
 *      sourceFileName: // value for 'sourceFileName'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      customUpgradeFiles: // value for 'customUpgradeFiles'
 *   },
 * });
 */
export function useCreateCustomUpgradeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomUpgradeMutation, CreateCustomUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomUpgradeMutation, CreateCustomUpgradeMutationVariables>(CreateCustomUpgradeDocument, options);
      }
export type CreateCustomUpgradeMutationHookResult = ReturnType<typeof useCreateCustomUpgradeMutation>;
export type CreateCustomUpgradeMutationResult = Apollo.MutationResult<CreateCustomUpgradeMutation>;
export type CreateCustomUpgradeMutationOptions = Apollo.BaseMutationOptions<CreateCustomUpgradeMutation, CreateCustomUpgradeMutationVariables>;
export const RequestCustomUpgradeValidationDocument = gql`
    mutation RequestCustomUpgradeValidation($customUpgradeId: uuid!, $clusterModelSetId: uuid!) {
  insert_custom_upgrade_model_set_validations_one(
    object: {custom_upgrade_id: $customUpgradeId, in_queue_cluster_model_set_id: $clusterModelSetId, validation_status: REQUESTED}
  ) {
    ...CustomUpgradeValidationFields
  }
}
    ${CustomUpgradeValidationFieldsFragmentDoc}`;
export type RequestCustomUpgradeValidationMutationFn = Apollo.MutationFunction<RequestCustomUpgradeValidationMutation, RequestCustomUpgradeValidationMutationVariables>;

/**
 * __useRequestCustomUpgradeValidationMutation__
 *
 * To run a mutation, you first call `useRequestCustomUpgradeValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCustomUpgradeValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCustomUpgradeValidationMutation, { data, loading, error }] = useRequestCustomUpgradeValidationMutation({
 *   variables: {
 *      customUpgradeId: // value for 'customUpgradeId'
 *      clusterModelSetId: // value for 'clusterModelSetId'
 *   },
 * });
 */
export function useRequestCustomUpgradeValidationMutation(baseOptions?: Apollo.MutationHookOptions<RequestCustomUpgradeValidationMutation, RequestCustomUpgradeValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCustomUpgradeValidationMutation, RequestCustomUpgradeValidationMutationVariables>(RequestCustomUpgradeValidationDocument, options);
      }
export type RequestCustomUpgradeValidationMutationHookResult = ReturnType<typeof useRequestCustomUpgradeValidationMutation>;
export type RequestCustomUpgradeValidationMutationResult = Apollo.MutationResult<RequestCustomUpgradeValidationMutation>;
export type RequestCustomUpgradeValidationMutationOptions = Apollo.BaseMutationOptions<RequestCustomUpgradeValidationMutation, RequestCustomUpgradeValidationMutationVariables>;
export const AddTrackedProjectDocument = gql`
    mutation AddTrackedProject($projectId: String!, $subscriptionId: uuid!, $teamId: Int!, $projectName: String, $clusterId: uuid!) {
  insert_tracked_projects_one(
    object: {project_id: $projectId, subscription_id: $subscriptionId, project_name: $projectName, cluster_id: $clusterId}
  ) {
    project_id
    subscription_id
    project_name
    cluster_id
  }
  insert_project_configurations_one(
    object: {team_id: $teamId, cluster_id: $clusterId, project_id: $projectId, project_name: $projectName}
    on_conflict: {constraint: project_configurations_pkey, update_columns: [project_name]}
  ) {
    team_id
    cluster_id
    project_id
    project_name
  }
}
    `;
export type AddTrackedProjectMutationFn = Apollo.MutationFunction<AddTrackedProjectMutation, AddTrackedProjectMutationVariables>;

/**
 * __useAddTrackedProjectMutation__
 *
 * To run a mutation, you first call `useAddTrackedProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrackedProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrackedProjectMutation, { data, loading, error }] = useAddTrackedProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      subscriptionId: // value for 'subscriptionId'
 *      teamId: // value for 'teamId'
 *      projectName: // value for 'projectName'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useAddTrackedProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddTrackedProjectMutation, AddTrackedProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrackedProjectMutation, AddTrackedProjectMutationVariables>(AddTrackedProjectDocument, options);
      }
export type AddTrackedProjectMutationHookResult = ReturnType<typeof useAddTrackedProjectMutation>;
export type AddTrackedProjectMutationResult = Apollo.MutationResult<AddTrackedProjectMutation>;
export type AddTrackedProjectMutationOptions = Apollo.BaseMutationOptions<AddTrackedProjectMutation, AddTrackedProjectMutationVariables>;
export const BulkArchiveScenariosDocument = gql`
    mutation BulkArchiveScenarios($customScenarioIds: [uuid!]!, $lastArchivedAt: timestamptz!, $teamScenarioConfigurations: [scenario_configurations_insert_input!]!) {
  update_scenarios(
    where: {scenario_id: {_in: $customScenarioIds}, archived: {_eq: false}}
    _set: {archived: true, last_archived_at: $lastArchivedAt}
  ) {
    affected_rows
    returning {
      ...InQueueScenarioFields
    }
  }
  insert_scenario_configurations(
    objects: $teamScenarioConfigurations
    on_conflict: {constraint: scenario_configurations_pkey, update_columns: [archived]}
  ) {
    affected_rows
    returning {
      scenario {
        ...InQueueScenarioFields
      }
    }
  }
}
    ${InQueueScenarioFieldsFragmentDoc}`;
export type BulkArchiveScenariosMutationFn = Apollo.MutationFunction<BulkArchiveScenariosMutation, BulkArchiveScenariosMutationVariables>;

/**
 * __useBulkArchiveScenariosMutation__
 *
 * To run a mutation, you first call `useBulkArchiveScenariosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkArchiveScenariosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkArchiveScenariosMutation, { data, loading, error }] = useBulkArchiveScenariosMutation({
 *   variables: {
 *      customScenarioIds: // value for 'customScenarioIds'
 *      lastArchivedAt: // value for 'lastArchivedAt'
 *      teamScenarioConfigurations: // value for 'teamScenarioConfigurations'
 *   },
 * });
 */
export function useBulkArchiveScenariosMutation(baseOptions?: Apollo.MutationHookOptions<BulkArchiveScenariosMutation, BulkArchiveScenariosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkArchiveScenariosMutation, BulkArchiveScenariosMutationVariables>(BulkArchiveScenariosDocument, options);
      }
export type BulkArchiveScenariosMutationHookResult = ReturnType<typeof useBulkArchiveScenariosMutation>;
export type BulkArchiveScenariosMutationResult = Apollo.MutationResult<BulkArchiveScenariosMutation>;
export type BulkArchiveScenariosMutationOptions = Apollo.BaseMutationOptions<BulkArchiveScenariosMutation, BulkArchiveScenariosMutationVariables>;
export const CreateScenariosDocument = gql`
    mutation CreateScenarios($objects: [scenarios_insert_input!]!, $archiveOriginals: Boolean!, $originalScenarioIds: [uuid!]!, $lastArchivedAt: timestamptz!) {
  insert_scenarios(objects: $objects) {
    returning {
      ...InQueueScenarioFields
    }
  }
  update_scenarios(
    where: {scenario_id: {_in: $originalScenarioIds}, archived: {_eq: false}}
    _set: {archived: true, last_archived_at: $lastArchivedAt}
  ) @include(if: $archiveOriginals) {
    affected_rows
    returning {
      ...InQueueScenarioFields
    }
  }
}
    ${InQueueScenarioFieldsFragmentDoc}`;
export type CreateScenariosMutationFn = Apollo.MutationFunction<CreateScenariosMutation, CreateScenariosMutationVariables>;

/**
 * __useCreateScenariosMutation__
 *
 * To run a mutation, you first call `useCreateScenariosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScenariosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScenariosMutation, { data, loading, error }] = useCreateScenariosMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      archiveOriginals: // value for 'archiveOriginals'
 *      originalScenarioIds: // value for 'originalScenarioIds'
 *      lastArchivedAt: // value for 'lastArchivedAt'
 *   },
 * });
 */
export function useCreateScenariosMutation(baseOptions?: Apollo.MutationHookOptions<CreateScenariosMutation, CreateScenariosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScenariosMutation, CreateScenariosMutationVariables>(CreateScenariosDocument, options);
      }
export type CreateScenariosMutationHookResult = ReturnType<typeof useCreateScenariosMutation>;
export type CreateScenariosMutationResult = Apollo.MutationResult<CreateScenariosMutation>;
export type CreateScenariosMutationOptions = Apollo.BaseMutationOptions<CreateScenariosMutation, CreateScenariosMutationVariables>;
export const CreateSpeculativeProjectsDocument = gql`
    mutation createSpeculativeProjects($objects: [in_queue_speculative_projects_insert_input!]!) {
  insert_in_queue_speculative_projects(objects: $objects) {
    affected_rows
    returning {
      id
      project_id
    }
  }
}
    `;
export type CreateSpeculativeProjectsMutationFn = Apollo.MutationFunction<CreateSpeculativeProjectsMutation, CreateSpeculativeProjectsMutationVariables>;

/**
 * __useCreateSpeculativeProjectsMutation__
 *
 * To run a mutation, you first call `useCreateSpeculativeProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpeculativeProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpeculativeProjectsMutation, { data, loading, error }] = useCreateSpeculativeProjectsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useCreateSpeculativeProjectsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSpeculativeProjectsMutation, CreateSpeculativeProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSpeculativeProjectsMutation, CreateSpeculativeProjectsMutationVariables>(CreateSpeculativeProjectsDocument, options);
      }
export type CreateSpeculativeProjectsMutationHookResult = ReturnType<typeof useCreateSpeculativeProjectsMutation>;
export type CreateSpeculativeProjectsMutationResult = Apollo.MutationResult<CreateSpeculativeProjectsMutation>;
export type CreateSpeculativeProjectsMutationOptions = Apollo.BaseMutationOptions<CreateSpeculativeProjectsMutation, CreateSpeculativeProjectsMutationVariables>;
export const DeleteSpeculativeProjectDocument = gql`
    mutation DeleteSpeculativeProject($projectId: String!) {
  delete_in_queue_speculative_projects(where: {project_id: {_eq: $projectId}}) {
    affected_rows
  }
}
    `;
export type DeleteSpeculativeProjectMutationFn = Apollo.MutationFunction<DeleteSpeculativeProjectMutation, DeleteSpeculativeProjectMutationVariables>;

/**
 * __useDeleteSpeculativeProjectMutation__
 *
 * To run a mutation, you first call `useDeleteSpeculativeProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpeculativeProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpeculativeProjectMutation, { data, loading, error }] = useDeleteSpeculativeProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteSpeculativeProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpeculativeProjectMutation, DeleteSpeculativeProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpeculativeProjectMutation, DeleteSpeculativeProjectMutationVariables>(DeleteSpeculativeProjectDocument, options);
      }
export type DeleteSpeculativeProjectMutationHookResult = ReturnType<typeof useDeleteSpeculativeProjectMutation>;
export type DeleteSpeculativeProjectMutationResult = Apollo.MutationResult<DeleteSpeculativeProjectMutation>;
export type DeleteSpeculativeProjectMutationOptions = Apollo.BaseMutationOptions<DeleteSpeculativeProjectMutation, DeleteSpeculativeProjectMutationVariables>;
export const GetAdditionalColumnConfigsDocument = gql`
    query getAdditionalColumnConfigs($clusterId: uuid!, $scenarioStage: String!) {
  additional_column_configs(
    where: {cluster_id: {_eq: $clusterId}, scenario_stage: {_eq: $scenarioStage}}
  ) {
    ...AdditionalColumnConfigFields
  }
}
    ${AdditionalColumnConfigFieldsFragmentDoc}`;

/**
 * __useGetAdditionalColumnConfigsQuery__
 *
 * To run a query within a React component, call `useGetAdditionalColumnConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalColumnConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalColumnConfigsQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      scenarioStage: // value for 'scenarioStage'
 *   },
 * });
 */
export function useGetAdditionalColumnConfigsQuery(baseOptions: Apollo.QueryHookOptions<GetAdditionalColumnConfigsQuery, GetAdditionalColumnConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalColumnConfigsQuery, GetAdditionalColumnConfigsQueryVariables>(GetAdditionalColumnConfigsDocument, options);
      }
export function useGetAdditionalColumnConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalColumnConfigsQuery, GetAdditionalColumnConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalColumnConfigsQuery, GetAdditionalColumnConfigsQueryVariables>(GetAdditionalColumnConfigsDocument, options);
        }
export type GetAdditionalColumnConfigsQueryHookResult = ReturnType<typeof useGetAdditionalColumnConfigsQuery>;
export type GetAdditionalColumnConfigsLazyQueryHookResult = ReturnType<typeof useGetAdditionalColumnConfigsLazyQuery>;
export type GetAdditionalColumnConfigsQueryResult = Apollo.QueryResult<GetAdditionalColumnConfigsQuery, GetAdditionalColumnConfigsQueryVariables>;
export const GetAllClustersDocument = gql`
    query getAllClusters {
  in_queue_clusters(where: {status: {_neq: hidden}}) {
    ...ClusterFields
  }
}
    ${ClusterFieldsFragmentDoc}`;

/**
 * __useGetAllClustersQuery__
 *
 * To run a query within a React component, call `useGetAllClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClustersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllClustersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClustersQuery, GetAllClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClustersQuery, GetAllClustersQueryVariables>(GetAllClustersDocument, options);
      }
export function useGetAllClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClustersQuery, GetAllClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClustersQuery, GetAllClustersQueryVariables>(GetAllClustersDocument, options);
        }
export type GetAllClustersQueryHookResult = ReturnType<typeof useGetAllClustersQuery>;
export type GetAllClustersLazyQueryHookResult = ReturnType<typeof useGetAllClustersLazyQuery>;
export type GetAllClustersQueryResult = Apollo.QueryResult<GetAllClustersQuery, GetAllClustersQueryVariables>;
export const GetClusterProjectRowsDocument = gql`
    query getClusterProjectRows($clusterId: uuid!) {
  cluster_projects(where: {cluster_id: {_eq: $clusterId}}) {
    project_id
    study_group
    fuel_type
    eris_mw
    nris_mw
    cost_per_mw
    sum_allocated_cost
    num_assigned_upgrades
    rank
    percentile
    total_ranked
    tracked_projects {
      subscription_id
      project_name
    }
    project_configurations {
      team_id
      cluster_id
      project_id
      is_favorited
    }
  }
  current_base_scenarios(where: {cluster_id: {_eq: $clusterId}}) {
    title
    run_completed_at
  }
}
    `;

/**
 * __useGetClusterProjectRowsQuery__
 *
 * To run a query within a React component, call `useGetClusterProjectRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClusterProjectRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClusterProjectRowsQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetClusterProjectRowsQuery(baseOptions: Apollo.QueryHookOptions<GetClusterProjectRowsQuery, GetClusterProjectRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClusterProjectRowsQuery, GetClusterProjectRowsQueryVariables>(GetClusterProjectRowsDocument, options);
      }
export function useGetClusterProjectRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClusterProjectRowsQuery, GetClusterProjectRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClusterProjectRowsQuery, GetClusterProjectRowsQueryVariables>(GetClusterProjectRowsDocument, options);
        }
export type GetClusterProjectRowsQueryHookResult = ReturnType<typeof useGetClusterProjectRowsQuery>;
export type GetClusterProjectRowsLazyQueryHookResult = ReturnType<typeof useGetClusterProjectRowsLazyQuery>;
export type GetClusterProjectRowsQueryResult = Apollo.QueryResult<GetClusterProjectRowsQuery, GetClusterProjectRowsQueryVariables>;
export const GetClusterProjectsDocument = gql`
    query getClusterProjects($clusterId: uuid!) {
  all_projects(where: {cluster_id: {_eq: $clusterId}}) {
    eris_capacity_mw
    nris_capacity_mw
    fuel_type
    project_id
    region
    status
    is_withdrawn
    study_cycle
    study_group
    study_phase
    is_editable
    metadata
  }
}
    `;

/**
 * __useGetClusterProjectsQuery__
 *
 * To run a query within a React component, call `useGetClusterProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClusterProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClusterProjectsQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetClusterProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetClusterProjectsQuery, GetClusterProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClusterProjectsQuery, GetClusterProjectsQueryVariables>(GetClusterProjectsDocument, options);
      }
export function useGetClusterProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClusterProjectsQuery, GetClusterProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClusterProjectsQuery, GetClusterProjectsQueryVariables>(GetClusterProjectsDocument, options);
        }
export type GetClusterProjectsQueryHookResult = ReturnType<typeof useGetClusterProjectsQuery>;
export type GetClusterProjectsLazyQueryHookResult = ReturnType<typeof useGetClusterProjectsLazyQuery>;
export type GetClusterProjectsQueryResult = Apollo.QueryResult<GetClusterProjectsQuery, GetClusterProjectsQueryVariables>;
export const GetCustomUpgradesDocument = gql`
    query getCustomUpgrades($clusterId: uuid!, $subscriptionId: uuid) {
  custom_upgrades(where: {cluster_id: {_eq: $clusterId}}) {
    ...CustomUpgradeWithValidationsFields
  }
  custom_upgrade_validation_failure_codes {
    code
    description
  }
}
    ${CustomUpgradeWithValidationsFieldsFragmentDoc}`;

/**
 * __useGetCustomUpgradesQuery__
 *
 * To run a query within a React component, call `useGetCustomUpgradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomUpgradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomUpgradesQuery({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useGetCustomUpgradesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomUpgradesQuery, GetCustomUpgradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomUpgradesQuery, GetCustomUpgradesQueryVariables>(GetCustomUpgradesDocument, options);
      }
export function useGetCustomUpgradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomUpgradesQuery, GetCustomUpgradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomUpgradesQuery, GetCustomUpgradesQueryVariables>(GetCustomUpgradesDocument, options);
        }
export type GetCustomUpgradesQueryHookResult = ReturnType<typeof useGetCustomUpgradesQuery>;
export type GetCustomUpgradesLazyQueryHookResult = ReturnType<typeof useGetCustomUpgradesLazyQuery>;
export type GetCustomUpgradesQueryResult = Apollo.QueryResult<GetCustomUpgradesQuery, GetCustomUpgradesQueryVariables>;
export const GetInQueueScenariosDocument = gql`
    query getInQueueScenarios {
  scenarios {
    ...InQueueScenarioFields
  }
}
    ${InQueueScenarioFieldsFragmentDoc}`;

/**
 * __useGetInQueueScenariosQuery__
 *
 * To run a query within a React component, call `useGetInQueueScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInQueueScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInQueueScenariosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInQueueScenariosQuery(baseOptions?: Apollo.QueryHookOptions<GetInQueueScenariosQuery, GetInQueueScenariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInQueueScenariosQuery, GetInQueueScenariosQueryVariables>(GetInQueueScenariosDocument, options);
      }
export function useGetInQueueScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInQueueScenariosQuery, GetInQueueScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInQueueScenariosQuery, GetInQueueScenariosQueryVariables>(GetInQueueScenariosDocument, options);
        }
export type GetInQueueScenariosQueryHookResult = ReturnType<typeof useGetInQueueScenariosQuery>;
export type GetInQueueScenariosLazyQueryHookResult = ReturnType<typeof useGetInQueueScenariosLazyQuery>;
export type GetInQueueScenariosQueryResult = Apollo.QueryResult<GetInQueueScenariosQuery, GetInQueueScenariosQueryVariables>;
export const GetInQueueSubscriptionsDocument = gql`
    query getInQueueSubscriptions {
  in_queue_subscriptions {
    subscription_id
    region
    study_cycle
    study_group
    phase
    scenario_limit
    status_override
    project_limit
    in_queue_subscription_add_ons {
      add_on
    }
  }
}
    `;

/**
 * __useGetInQueueSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetInQueueSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInQueueSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInQueueSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInQueueSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetInQueueSubscriptionsQuery, GetInQueueSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInQueueSubscriptionsQuery, GetInQueueSubscriptionsQueryVariables>(GetInQueueSubscriptionsDocument, options);
      }
export function useGetInQueueSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInQueueSubscriptionsQuery, GetInQueueSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInQueueSubscriptionsQuery, GetInQueueSubscriptionsQueryVariables>(GetInQueueSubscriptionsDocument, options);
        }
export type GetInQueueSubscriptionsQueryHookResult = ReturnType<typeof useGetInQueueSubscriptionsQuery>;
export type GetInQueueSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetInQueueSubscriptionsLazyQuery>;
export type GetInQueueSubscriptionsQueryResult = Apollo.QueryResult<GetInQueueSubscriptionsQuery, GetInQueueSubscriptionsQueryVariables>;
export const GetModelPoIsDocument = gql`
    query getModelPOIs($poiName: String!, $poi: String!, $poiType: String!, $clusterId: uuid!) {
  in_queue_model_pois(
    limit: 10
    where: {_or: [{poi_name: {_ilike: $poiName}}, {poi: {_ilike: $poi}}], poi_type: {_eq: $poiType}, deleted: {_eq: false}, cluster_id: {_eq: $clusterId}}
  ) {
    ...ModelPOIFragment
  }
}
    ${ModelPoiFragmentFragmentDoc}`;

/**
 * __useGetModelPoIsQuery__
 *
 * To run a query within a React component, call `useGetModelPoIsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelPoIsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelPoIsQuery({
 *   variables: {
 *      poiName: // value for 'poiName'
 *      poi: // value for 'poi'
 *      poiType: // value for 'poiType'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useGetModelPoIsQuery(baseOptions: Apollo.QueryHookOptions<GetModelPoIsQuery, GetModelPoIsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModelPoIsQuery, GetModelPoIsQueryVariables>(GetModelPoIsDocument, options);
      }
export function useGetModelPoIsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelPoIsQuery, GetModelPoIsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModelPoIsQuery, GetModelPoIsQueryVariables>(GetModelPoIsDocument, options);
        }
export type GetModelPoIsQueryHookResult = ReturnType<typeof useGetModelPoIsQuery>;
export type GetModelPoIsLazyQueryHookResult = ReturnType<typeof useGetModelPoIsLazyQuery>;
export type GetModelPoIsQueryResult = Apollo.QueryResult<GetModelPoIsQuery, GetModelPoIsQueryVariables>;
export const GetRegionModelVariantsDocument = gql`
    query GetRegionModelVariants($region: String!) {
  in_queue_region_model_variants(
    where: {region: {_eq: $region}}
    order_by: {variant: asc}
  ) {
    variant
    model_variant {
      description
    }
  }
}
    `;

/**
 * __useGetRegionModelVariantsQuery__
 *
 * To run a query within a React component, call `useGetRegionModelVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionModelVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionModelVariantsQuery({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetRegionModelVariantsQuery(baseOptions: Apollo.QueryHookOptions<GetRegionModelVariantsQuery, GetRegionModelVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionModelVariantsQuery, GetRegionModelVariantsQueryVariables>(GetRegionModelVariantsDocument, options);
      }
export function useGetRegionModelVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionModelVariantsQuery, GetRegionModelVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionModelVariantsQuery, GetRegionModelVariantsQueryVariables>(GetRegionModelVariantsDocument, options);
        }
export type GetRegionModelVariantsQueryHookResult = ReturnType<typeof useGetRegionModelVariantsQuery>;
export type GetRegionModelVariantsLazyQueryHookResult = ReturnType<typeof useGetRegionModelVariantsLazyQuery>;
export type GetRegionModelVariantsQueryResult = Apollo.QueryResult<GetRegionModelVariantsQuery, GetRegionModelVariantsQueryVariables>;
export const GetRelatedScenarioResultsDocument = gql`
    query getRelatedScenarioResults($scenarioId: uuid!, $projectId: String!, $networkUpgradeNames: [String!]!, $monitoredFacilityNames: [String!]!) {
  scenarios(where: {scenario_id: {_eq: $scenarioId}}) {
    scenario_id
    scenario_allocated_upgrades(
      where: {project_id: {_neq: $projectId}, network_upgrade_name: {_in: $networkUpgradeNames}}
    ) {
      ...ScenarioAllocatedUpgradeFields
    }
    scenario_constraints(
      where: {project_id: {_neq: $projectId}, _or: [{monitored_facility_name: {_in: $monitoredFacilityNames}}, {network_upgrade_names: {_has_keys_any: $networkUpgradeNames}}]}
    ) {
      ...ScenarioConstraintFields
    }
  }
}
    ${ScenarioAllocatedUpgradeFieldsFragmentDoc}
${ScenarioConstraintFieldsFragmentDoc}`;

/**
 * __useGetRelatedScenarioResultsQuery__
 *
 * To run a query within a React component, call `useGetRelatedScenarioResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedScenarioResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedScenarioResultsQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      projectId: // value for 'projectId'
 *      networkUpgradeNames: // value for 'networkUpgradeNames'
 *      monitoredFacilityNames: // value for 'monitoredFacilityNames'
 *   },
 * });
 */
export function useGetRelatedScenarioResultsQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedScenarioResultsQuery, GetRelatedScenarioResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedScenarioResultsQuery, GetRelatedScenarioResultsQueryVariables>(GetRelatedScenarioResultsDocument, options);
      }
export function useGetRelatedScenarioResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedScenarioResultsQuery, GetRelatedScenarioResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedScenarioResultsQuery, GetRelatedScenarioResultsQueryVariables>(GetRelatedScenarioResultsDocument, options);
        }
export type GetRelatedScenarioResultsQueryHookResult = ReturnType<typeof useGetRelatedScenarioResultsQuery>;
export type GetRelatedScenarioResultsLazyQueryHookResult = ReturnType<typeof useGetRelatedScenarioResultsLazyQuery>;
export type GetRelatedScenarioResultsQueryResult = Apollo.QueryResult<GetRelatedScenarioResultsQuery, GetRelatedScenarioResultsQueryVariables>;
export const GetRemainingScenarioResultsDocument = gql`
    query getRemainingScenarioResults($scenarioId: uuid!, $projectId: String!) {
  scenarios(where: {scenario_id: {_eq: $scenarioId}}) {
    scenario_id
    scenario_allocated_upgrades(where: {project_id: {_neq: $projectId}}) {
      ...ScenarioAllocatedUpgradeFields
    }
    scenario_constraints(where: {project_id: {_neq: $projectId}}) {
      ...ScenarioConstraintFields
    }
  }
}
    ${ScenarioAllocatedUpgradeFieldsFragmentDoc}
${ScenarioConstraintFieldsFragmentDoc}`;

/**
 * __useGetRemainingScenarioResultsQuery__
 *
 * To run a query within a React component, call `useGetRemainingScenarioResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemainingScenarioResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemainingScenarioResultsQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetRemainingScenarioResultsQuery(baseOptions: Apollo.QueryHookOptions<GetRemainingScenarioResultsQuery, GetRemainingScenarioResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemainingScenarioResultsQuery, GetRemainingScenarioResultsQueryVariables>(GetRemainingScenarioResultsDocument, options);
      }
export function useGetRemainingScenarioResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemainingScenarioResultsQuery, GetRemainingScenarioResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemainingScenarioResultsQuery, GetRemainingScenarioResultsQueryVariables>(GetRemainingScenarioResultsDocument, options);
        }
export type GetRemainingScenarioResultsQueryHookResult = ReturnType<typeof useGetRemainingScenarioResultsQuery>;
export type GetRemainingScenarioResultsLazyQueryHookResult = ReturnType<typeof useGetRemainingScenarioResultsLazyQuery>;
export type GetRemainingScenarioResultsQueryResult = Apollo.QueryResult<GetRemainingScenarioResultsQuery, GetRemainingScenarioResultsQueryVariables>;
export const GetScenarioMetricsDocument = gql`
    query getScenarioMetrics($projectId: String!, $scenarioIds: [uuid!]) {
  scenarios(where: {scenario_id: {_in: $scenarioIds}}) {
    scenario_id
    scenario_projects(where: {project_id: {_eq: $projectId}}) {
      scenario_id
      project_id
      sum_allocated_cost
      cost_per_mw
      sum_allocated_cost_by_constraint_type
      ranks {
        rank
        percentile
        total_ranked
      }
    }
    scenario_allocated_upgrades(
      where: {project_id: {_eq: $projectId}, allocated_cost: {_gt: 0}}
    ) {
      scenario_id
      project_id
      constraint_type
      network_upgrade_id
    }
  }
}
    `;

/**
 * __useGetScenarioMetricsQuery__
 *
 * To run a query within a React component, call `useGetScenarioMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenarioMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScenarioMetricsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      scenarioIds: // value for 'scenarioIds'
 *   },
 * });
 */
export function useGetScenarioMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetScenarioMetricsQuery, GetScenarioMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScenarioMetricsQuery, GetScenarioMetricsQueryVariables>(GetScenarioMetricsDocument, options);
      }
export function useGetScenarioMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScenarioMetricsQuery, GetScenarioMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScenarioMetricsQuery, GetScenarioMetricsQueryVariables>(GetScenarioMetricsDocument, options);
        }
export type GetScenarioMetricsQueryHookResult = ReturnType<typeof useGetScenarioMetricsQuery>;
export type GetScenarioMetricsLazyQueryHookResult = ReturnType<typeof useGetScenarioMetricsLazyQuery>;
export type GetScenarioMetricsQueryResult = Apollo.QueryResult<GetScenarioMetricsQuery, GetScenarioMetricsQueryVariables>;
export const GetScenarioResultsByProjectIdDocument = gql`
    query getScenarioResultsByProjectId($scenarioId: uuid!, $projectId: String!) {
  scenarios(where: {scenario_id: {_eq: $scenarioId}}) {
    scenario_id
    scenario_allocated_upgrades(where: {project_id: {_eq: $projectId}}) {
      ...ScenarioAllocatedUpgradeFields
    }
    scenario_constraints(where: {project_id: {_eq: $projectId}}) {
      ...ScenarioConstraintFields
    }
    scenario_projects {
      scenario_id
      assigned_upgrades
      cost_per_mw
      eris_size_mw
      nris_size_mw
      overloaded_facilities
      project_id
      sum_allocated_cost
      sum_allocated_cost_by_constraint_type
      metadata
      ranks {
        rank
        percentile
        total_ranked
      }
    }
  }
}
    ${ScenarioAllocatedUpgradeFieldsFragmentDoc}
${ScenarioConstraintFieldsFragmentDoc}`;

/**
 * __useGetScenarioResultsByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetScenarioResultsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenarioResultsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScenarioResultsByProjectIdQuery({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetScenarioResultsByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetScenarioResultsByProjectIdQuery, GetScenarioResultsByProjectIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScenarioResultsByProjectIdQuery, GetScenarioResultsByProjectIdQueryVariables>(GetScenarioResultsByProjectIdDocument, options);
      }
export function useGetScenarioResultsByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScenarioResultsByProjectIdQuery, GetScenarioResultsByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScenarioResultsByProjectIdQuery, GetScenarioResultsByProjectIdQueryVariables>(GetScenarioResultsByProjectIdDocument, options);
        }
export type GetScenarioResultsByProjectIdQueryHookResult = ReturnType<typeof useGetScenarioResultsByProjectIdQuery>;
export type GetScenarioResultsByProjectIdLazyQueryHookResult = ReturnType<typeof useGetScenarioResultsByProjectIdLazyQuery>;
export type GetScenarioResultsByProjectIdQueryResult = Apollo.QueryResult<GetScenarioResultsByProjectIdQuery, GetScenarioResultsByProjectIdQueryVariables>;
export const GetSpeculativeProjectsDocument = gql`
    query getSpeculativeProjects($subscriptionIds: [uuid!]!) {
  in_queue_speculative_projects(
    where: {hybrid_parent_project_id: {_is_null: true}, subscription_id: {_in: $subscriptionIds}}
  ) {
    cluster_id
    subscription_id
    fuel_type
    ...SpeculativeProjectFragment
    in_queue_speculative_projects_children {
      ...SpeculativeProjectFragment
    }
    poi_id
    in_queue_model_poi {
      ...ModelPOIFragment
    }
  }
}
    ${SpeculativeProjectFragmentFragmentDoc}
${ModelPoiFragmentFragmentDoc}`;

/**
 * __useGetSpeculativeProjectsQuery__
 *
 * To run a query within a React component, call `useGetSpeculativeProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeculativeProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeculativeProjectsQuery({
 *   variables: {
 *      subscriptionIds: // value for 'subscriptionIds'
 *   },
 * });
 */
export function useGetSpeculativeProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetSpeculativeProjectsQuery, GetSpeculativeProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeculativeProjectsQuery, GetSpeculativeProjectsQueryVariables>(GetSpeculativeProjectsDocument, options);
      }
export function useGetSpeculativeProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeculativeProjectsQuery, GetSpeculativeProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeculativeProjectsQuery, GetSpeculativeProjectsQueryVariables>(GetSpeculativeProjectsDocument, options);
        }
export type GetSpeculativeProjectsQueryHookResult = ReturnType<typeof useGetSpeculativeProjectsQuery>;
export type GetSpeculativeProjectsLazyQueryHookResult = ReturnType<typeof useGetSpeculativeProjectsLazyQuery>;
export type GetSpeculativeProjectsQueryResult = Apollo.QueryResult<GetSpeculativeProjectsQuery, GetSpeculativeProjectsQueryVariables>;
export const GetTrackedProjectsDocument = gql`
    query getTrackedProjects {
  tracked_projects {
    subscription_id
    project_id
    project_name
  }
}
    `;

/**
 * __useGetTrackedProjectsQuery__
 *
 * To run a query within a React component, call `useGetTrackedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackedProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrackedProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetTrackedProjectsQuery, GetTrackedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackedProjectsQuery, GetTrackedProjectsQueryVariables>(GetTrackedProjectsDocument, options);
      }
export function useGetTrackedProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackedProjectsQuery, GetTrackedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackedProjectsQuery, GetTrackedProjectsQueryVariables>(GetTrackedProjectsDocument, options);
        }
export type GetTrackedProjectsQueryHookResult = ReturnType<typeof useGetTrackedProjectsQuery>;
export type GetTrackedProjectsLazyQueryHookResult = ReturnType<typeof useGetTrackedProjectsLazyQuery>;
export type GetTrackedProjectsQueryResult = Apollo.QueryResult<GetTrackedProjectsQuery, GetTrackedProjectsQueryVariables>;
export const SetProjectFavoriteDocument = gql`
    mutation SetProjectFavorite($teamId: Int!, $clusterId: uuid!, $projectId: String!, $isFavorited: Boolean!) {
  insert_project_configurations_one(
    object: {team_id: $teamId, cluster_id: $clusterId, project_id: $projectId, is_favorited: $isFavorited}
    on_conflict: {constraint: project_configurations_pkey, update_columns: [is_favorited]}
  ) {
    team_id
    cluster_id
    project_id
    is_favorited
  }
}
    `;
export type SetProjectFavoriteMutationFn = Apollo.MutationFunction<SetProjectFavoriteMutation, SetProjectFavoriteMutationVariables>;

/**
 * __useSetProjectFavoriteMutation__
 *
 * To run a mutation, you first call `useSetProjectFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectFavoriteMutation, { data, loading, error }] = useSetProjectFavoriteMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      clusterId: // value for 'clusterId'
 *      projectId: // value for 'projectId'
 *      isFavorited: // value for 'isFavorited'
 *   },
 * });
 */
export function useSetProjectFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectFavoriteMutation, SetProjectFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectFavoriteMutation, SetProjectFavoriteMutationVariables>(SetProjectFavoriteDocument, options);
      }
export type SetProjectFavoriteMutationHookResult = ReturnType<typeof useSetProjectFavoriteMutation>;
export type SetProjectFavoriteMutationResult = Apollo.MutationResult<SetProjectFavoriteMutation>;
export type SetProjectFavoriteMutationOptions = Apollo.BaseMutationOptions<SetProjectFavoriteMutation, SetProjectFavoriteMutationVariables>;
export const SetTeamScenarioArchivedDocument = gql`
    mutation SetTeamScenarioArchived($scenarioId: uuid!, $teamId: Int!, $archived: Boolean!) {
  insert_scenario_configurations_one(
    object: {scenario_id: $scenarioId, team_id: $teamId, archived: $archived}
    on_conflict: {constraint: scenario_configurations_pkey, update_columns: [archived]}
  ) {
    scenario {
      ...InQueueScenarioFields
    }
  }
}
    ${InQueueScenarioFieldsFragmentDoc}`;
export type SetTeamScenarioArchivedMutationFn = Apollo.MutationFunction<SetTeamScenarioArchivedMutation, SetTeamScenarioArchivedMutationVariables>;

/**
 * __useSetTeamScenarioArchivedMutation__
 *
 * To run a mutation, you first call `useSetTeamScenarioArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeamScenarioArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeamScenarioArchivedMutation, { data, loading, error }] = useSetTeamScenarioArchivedMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      teamId: // value for 'teamId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useSetTeamScenarioArchivedMutation(baseOptions?: Apollo.MutationHookOptions<SetTeamScenarioArchivedMutation, SetTeamScenarioArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeamScenarioArchivedMutation, SetTeamScenarioArchivedMutationVariables>(SetTeamScenarioArchivedDocument, options);
      }
export type SetTeamScenarioArchivedMutationHookResult = ReturnType<typeof useSetTeamScenarioArchivedMutation>;
export type SetTeamScenarioArchivedMutationResult = Apollo.MutationResult<SetTeamScenarioArchivedMutation>;
export type SetTeamScenarioArchivedMutationOptions = Apollo.BaseMutationOptions<SetTeamScenarioArchivedMutation, SetTeamScenarioArchivedMutationVariables>;
export const SubmitScenarioDocument = gql`
    mutation SubmitScenario($scenarioId: uuid!, $authId: String!, $currentTime: timestamptz!) {
  update_scenarios(
    where: {scenario_id: {_eq: $scenarioId}}
    _set: {status: RUN_REQUESTED, updated_by: $authId, run_submitted_by: $authId, run_submitted_at: $currentTime}
  ) {
    returning {
      scenario_id
      region
      team_id
      created_by
      updated_by
      study_group
      study_cycle
      study_phase
      title
      project_size_assumptions
      custom_upgrades
      status
    }
  }
}
    `;
export type SubmitScenarioMutationFn = Apollo.MutationFunction<SubmitScenarioMutation, SubmitScenarioMutationVariables>;

/**
 * __useSubmitScenarioMutation__
 *
 * To run a mutation, you first call `useSubmitScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitScenarioMutation, { data, loading, error }] = useSubmitScenarioMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      authId: // value for 'authId'
 *      currentTime: // value for 'currentTime'
 *   },
 * });
 */
export function useSubmitScenarioMutation(baseOptions?: Apollo.MutationHookOptions<SubmitScenarioMutation, SubmitScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitScenarioMutation, SubmitScenarioMutationVariables>(SubmitScenarioDocument, options);
      }
export type SubmitScenarioMutationHookResult = ReturnType<typeof useSubmitScenarioMutation>;
export type SubmitScenarioMutationResult = Apollo.MutationResult<SubmitScenarioMutation>;
export type SubmitScenarioMutationOptions = Apollo.BaseMutationOptions<SubmitScenarioMutation, SubmitScenarioMutationVariables>;
export const SubscribeToCustomUpgradesDocument = gql`
    subscription subscribeToCustomUpgrades($clusterId: uuid!, $subscriptionId: uuid) {
  custom_upgrades(where: {cluster_id: {_eq: $clusterId}}) {
    ...CustomUpgradeWithValidationsFields
  }
}
    ${CustomUpgradeWithValidationsFieldsFragmentDoc}`;

/**
 * __useSubscribeToCustomUpgradesSubscription__
 *
 * To run a query within a React component, call `useSubscribeToCustomUpgradesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToCustomUpgradesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToCustomUpgradesSubscription({
 *   variables: {
 *      clusterId: // value for 'clusterId'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useSubscribeToCustomUpgradesSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubscribeToCustomUpgradesSubscription, SubscribeToCustomUpgradesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToCustomUpgradesSubscription, SubscribeToCustomUpgradesSubscriptionVariables>(SubscribeToCustomUpgradesDocument, options);
      }
export type SubscribeToCustomUpgradesSubscriptionHookResult = ReturnType<typeof useSubscribeToCustomUpgradesSubscription>;
export type SubscribeToCustomUpgradesSubscriptionResult = Apollo.SubscriptionResult<SubscribeToCustomUpgradesSubscription>;
export const SubscribeToInQueueScenariosDocument = gql`
    subscription subscribeToInQueueScenarios {
  scenarios {
    ...InQueueScenarioFields
  }
}
    ${InQueueScenarioFieldsFragmentDoc}`;

/**
 * __useSubscribeToInQueueScenariosSubscription__
 *
 * To run a query within a React component, call `useSubscribeToInQueueScenariosSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToInQueueScenariosSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToInQueueScenariosSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToInQueueScenariosSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToInQueueScenariosSubscription, SubscribeToInQueueScenariosSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToInQueueScenariosSubscription, SubscribeToInQueueScenariosSubscriptionVariables>(SubscribeToInQueueScenariosDocument, options);
      }
export type SubscribeToInQueueScenariosSubscriptionHookResult = ReturnType<typeof useSubscribeToInQueueScenariosSubscription>;
export type SubscribeToInQueueScenariosSubscriptionResult = Apollo.SubscriptionResult<SubscribeToInQueueScenariosSubscription>;
export const GetInQueueSubscriptionUpdatesDocument = gql`
    subscription getInQueueSubscriptionUpdates {
  in_queue_subscriptions {
    subscription_id
    region
    study_cycle
    study_group
    phase
    scenario_limit
    status_override
    project_limit
    in_queue_subscription_add_ons {
      add_on
    }
  }
}
    `;

/**
 * __useGetInQueueSubscriptionUpdatesSubscription__
 *
 * To run a query within a React component, call `useGetInQueueSubscriptionUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetInQueueSubscriptionUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInQueueSubscriptionUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetInQueueSubscriptionUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetInQueueSubscriptionUpdatesSubscription, GetInQueueSubscriptionUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetInQueueSubscriptionUpdatesSubscription, GetInQueueSubscriptionUpdatesSubscriptionVariables>(GetInQueueSubscriptionUpdatesDocument, options);
      }
export type GetInQueueSubscriptionUpdatesSubscriptionHookResult = ReturnType<typeof useGetInQueueSubscriptionUpdatesSubscription>;
export type GetInQueueSubscriptionUpdatesSubscriptionResult = Apollo.SubscriptionResult<GetInQueueSubscriptionUpdatesSubscription>;
export const UpdateScenarioDocument = gql`
    mutation UpdateScenario($scenarioId: uuid!, $authId: String!, $title: String!, $status: scenario_statuses_enum!, $projectSizeAssumptions: jsonb!, $projectAdditions: jsonb!, $customUpgrades: jsonb!, $parentProjectId: String, $costAssumptions: jsonb!, $parentSpeculativeProjectId: uuid) {
  update_scenarios(
    where: {scenario_id: {_eq: $scenarioId}}
    _set: {title: $title, status: $status, project_size_assumptions: $projectSizeAssumptions, project_additions: $projectAdditions, custom_upgrades: $customUpgrades, updated_by: $authId, parent_project_id: $parentProjectId, parent_speculative_project_id: $parentSpeculativeProjectId, cost_assumptions: $costAssumptions}
  ) {
    affected_rows
    returning {
      scenario_id
      region
      team_id
      created_by
      updated_by
      study_group
      study_cycle
      study_phase
      title
      project_size_assumptions
      project_additions
      custom_upgrades
      status
      cost_assumptions
    }
  }
}
    `;
export type UpdateScenarioMutationFn = Apollo.MutationFunction<UpdateScenarioMutation, UpdateScenarioMutationVariables>;

/**
 * __useUpdateScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScenarioMutation, { data, loading, error }] = useUpdateScenarioMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      authId: // value for 'authId'
 *      title: // value for 'title'
 *      status: // value for 'status'
 *      projectSizeAssumptions: // value for 'projectSizeAssumptions'
 *      projectAdditions: // value for 'projectAdditions'
 *      customUpgrades: // value for 'customUpgrades'
 *      parentProjectId: // value for 'parentProjectId'
 *      costAssumptions: // value for 'costAssumptions'
 *      parentSpeculativeProjectId: // value for 'parentSpeculativeProjectId'
 *   },
 * });
 */
export function useUpdateScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScenarioMutation, UpdateScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScenarioMutation, UpdateScenarioMutationVariables>(UpdateScenarioDocument, options);
      }
export type UpdateScenarioMutationHookResult = ReturnType<typeof useUpdateScenarioMutation>;
export type UpdateScenarioMutationResult = Apollo.MutationResult<UpdateScenarioMutation>;
export type UpdateScenarioMutationOptions = Apollo.BaseMutationOptions<UpdateScenarioMutation, UpdateScenarioMutationVariables>;
export const UpdateScenarioParentProjectDocument = gql`
    mutation UpdateScenarioParentProject($scenarioId: uuid!, $authId: String!, $parentProjectId: String, $parentSpeculativeProjectId: uuid) {
  update_scenarios(
    where: {scenario_id: {_eq: $scenarioId}}
    _set: {parent_project_id: $parentProjectId, parent_speculative_project_id: $parentSpeculativeProjectId, updated_by: $authId}
  ) {
    affected_rows
    returning {
      ...InQueueScenarioFields
    }
  }
}
    ${InQueueScenarioFieldsFragmentDoc}`;
export type UpdateScenarioParentProjectMutationFn = Apollo.MutationFunction<UpdateScenarioParentProjectMutation, UpdateScenarioParentProjectMutationVariables>;

/**
 * __useUpdateScenarioParentProjectMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioParentProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioParentProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScenarioParentProjectMutation, { data, loading, error }] = useUpdateScenarioParentProjectMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      authId: // value for 'authId'
 *      parentProjectId: // value for 'parentProjectId'
 *      parentSpeculativeProjectId: // value for 'parentSpeculativeProjectId'
 *   },
 * });
 */
export function useUpdateScenarioParentProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScenarioParentProjectMutation, UpdateScenarioParentProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScenarioParentProjectMutation, UpdateScenarioParentProjectMutationVariables>(UpdateScenarioParentProjectDocument, options);
      }
export type UpdateScenarioParentProjectMutationHookResult = ReturnType<typeof useUpdateScenarioParentProjectMutation>;
export type UpdateScenarioParentProjectMutationResult = Apollo.MutationResult<UpdateScenarioParentProjectMutation>;
export type UpdateScenarioParentProjectMutationOptions = Apollo.BaseMutationOptions<UpdateScenarioParentProjectMutation, UpdateScenarioParentProjectMutationVariables>;
export const UpdateScenarioStatusDocument = gql`
    mutation UpdateScenarioStatus($scenarioId: uuid!, $status: scenario_statuses_enum!, $archived: Boolean!, $lastArchivedAt: timestamptz) {
  update_scenarios(
    where: {scenario_id: {_eq: $scenarioId}}
    _set: {status: $status, archived: $archived, last_archived_at: $lastArchivedAt}
  ) {
    affected_rows
    returning {
      ...InQueueScenarioFields
    }
  }
}
    ${InQueueScenarioFieldsFragmentDoc}`;
export type UpdateScenarioStatusMutationFn = Apollo.MutationFunction<UpdateScenarioStatusMutation, UpdateScenarioStatusMutationVariables>;

/**
 * __useUpdateScenarioStatusMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScenarioStatusMutation, { data, loading, error }] = useUpdateScenarioStatusMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      status: // value for 'status'
 *      archived: // value for 'archived'
 *      lastArchivedAt: // value for 'lastArchivedAt'
 *   },
 * });
 */
export function useUpdateScenarioStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScenarioStatusMutation, UpdateScenarioStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScenarioStatusMutation, UpdateScenarioStatusMutationVariables>(UpdateScenarioStatusDocument, options);
      }
export type UpdateScenarioStatusMutationHookResult = ReturnType<typeof useUpdateScenarioStatusMutation>;
export type UpdateScenarioStatusMutationResult = Apollo.MutationResult<UpdateScenarioStatusMutation>;
export type UpdateScenarioStatusMutationOptions = Apollo.BaseMutationOptions<UpdateScenarioStatusMutation, UpdateScenarioStatusMutationVariables>;
export const UpdateScenarioTitleDocument = gql`
    mutation UpdateScenarioTitle($scenarioId: uuid!, $authId: String!, $title: String!) {
  update_scenarios(
    where: {scenario_id: {_eq: $scenarioId}}
    _set: {title: $title, updated_by: $authId}
  ) {
    affected_rows
    returning {
      ...InQueueScenarioFields
    }
  }
}
    ${InQueueScenarioFieldsFragmentDoc}`;
export type UpdateScenarioTitleMutationFn = Apollo.MutationFunction<UpdateScenarioTitleMutation, UpdateScenarioTitleMutationVariables>;

/**
 * __useUpdateScenarioTitleMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScenarioTitleMutation, { data, loading, error }] = useUpdateScenarioTitleMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      authId: // value for 'authId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateScenarioTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScenarioTitleMutation, UpdateScenarioTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScenarioTitleMutation, UpdateScenarioTitleMutationVariables>(UpdateScenarioTitleDocument, options);
      }
export type UpdateScenarioTitleMutationHookResult = ReturnType<typeof useUpdateScenarioTitleMutation>;
export type UpdateScenarioTitleMutationResult = Apollo.MutationResult<UpdateScenarioTitleMutation>;
export type UpdateScenarioTitleMutationOptions = Apollo.BaseMutationOptions<UpdateScenarioTitleMutation, UpdateScenarioTitleMutationVariables>;
export const UpdateSpeculativeProjectNameDocument = gql`
    mutation UpdateSpeculativeProjectName($updates: [in_queue_speculative_projects_updates!]!) {
  update_in_queue_speculative_projects_many(updates: $updates) {
    affected_rows
  }
}
    `;
export type UpdateSpeculativeProjectNameMutationFn = Apollo.MutationFunction<UpdateSpeculativeProjectNameMutation, UpdateSpeculativeProjectNameMutationVariables>;

/**
 * __useUpdateSpeculativeProjectNameMutation__
 *
 * To run a mutation, you first call `useUpdateSpeculativeProjectNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpeculativeProjectNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpeculativeProjectNameMutation, { data, loading, error }] = useUpdateSpeculativeProjectNameMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateSpeculativeProjectNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpeculativeProjectNameMutation, UpdateSpeculativeProjectNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpeculativeProjectNameMutation, UpdateSpeculativeProjectNameMutationVariables>(UpdateSpeculativeProjectNameDocument, options);
      }
export type UpdateSpeculativeProjectNameMutationHookResult = ReturnType<typeof useUpdateSpeculativeProjectNameMutation>;
export type UpdateSpeculativeProjectNameMutationResult = Apollo.MutationResult<UpdateSpeculativeProjectNameMutation>;
export type UpdateSpeculativeProjectNameMutationOptions = Apollo.BaseMutationOptions<UpdateSpeculativeProjectNameMutation, UpdateSpeculativeProjectNameMutationVariables>;
export const UpdateTrackedProjectNameDocument = gql`
    mutation UpdateTrackedProjectName($projectId: String!, $subscriptionId: uuid!, $teamId: Int!, $clusterId: uuid!, $projectName: String) {
  update_tracked_projects(
    where: {project_id: {_eq: $projectId}, subscription_id: {_eq: $subscriptionId}}
    _set: {project_name: $projectName}
  ) {
    affected_rows
  }
  insert_project_configurations_one(
    object: {team_id: $teamId, cluster_id: $clusterId, project_id: $projectId, project_name: $projectName}
    on_conflict: {constraint: project_configurations_pkey, update_columns: [project_name]}
  ) {
    team_id
    cluster_id
    project_id
    project_name
  }
}
    `;
export type UpdateTrackedProjectNameMutationFn = Apollo.MutationFunction<UpdateTrackedProjectNameMutation, UpdateTrackedProjectNameMutationVariables>;

/**
 * __useUpdateTrackedProjectNameMutation__
 *
 * To run a mutation, you first call `useUpdateTrackedProjectNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackedProjectNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackedProjectNameMutation, { data, loading, error }] = useUpdateTrackedProjectNameMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      subscriptionId: // value for 'subscriptionId'
 *      teamId: // value for 'teamId'
 *      clusterId: // value for 'clusterId'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useUpdateTrackedProjectNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackedProjectNameMutation, UpdateTrackedProjectNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackedProjectNameMutation, UpdateTrackedProjectNameMutationVariables>(UpdateTrackedProjectNameDocument, options);
      }
export type UpdateTrackedProjectNameMutationHookResult = ReturnType<typeof useUpdateTrackedProjectNameMutation>;
export type UpdateTrackedProjectNameMutationResult = Apollo.MutationResult<UpdateTrackedProjectNameMutation>;
export type UpdateTrackedProjectNameMutationOptions = Apollo.BaseMutationOptions<UpdateTrackedProjectNameMutation, UpdateTrackedProjectNameMutationVariables>;
export const RemoveFavoriteBusDocument = gql`
    mutation RemoveFavoriteBus($niraBusId: String!) {
  delete_favorite_buses(where: {nira_bus_id: {_eq: $niraBusId}}) {
    returning {
      nira_bus_id
    }
  }
}
    `;
export type RemoveFavoriteBusMutationFn = Apollo.MutationFunction<RemoveFavoriteBusMutation, RemoveFavoriteBusMutationVariables>;

/**
 * __useRemoveFavoriteBusMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteBusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteBusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteBusMutation, { data, loading, error }] = useRemoveFavoriteBusMutation({
 *   variables: {
 *      niraBusId: // value for 'niraBusId'
 *   },
 * });
 */
export function useRemoveFavoriteBusMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFavoriteBusMutation, RemoveFavoriteBusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFavoriteBusMutation, RemoveFavoriteBusMutationVariables>(RemoveFavoriteBusDocument, options);
      }
export type RemoveFavoriteBusMutationHookResult = ReturnType<typeof useRemoveFavoriteBusMutation>;
export type RemoveFavoriteBusMutationResult = Apollo.MutationResult<RemoveFavoriteBusMutation>;
export type RemoveFavoriteBusMutationOptions = Apollo.BaseMutationOptions<RemoveFavoriteBusMutation, RemoveFavoriteBusMutationVariables>;
export const UnlockBusDocument = gql`
    mutation unlockBus($niraBusId: String!) {
  unlock_bus(args: {bus_id: $niraBusId}) {
    nira_bus_id
  }
}
    `;
export type UnlockBusMutationFn = Apollo.MutationFunction<UnlockBusMutation, UnlockBusMutationVariables>;

/**
 * __useUnlockBusMutation__
 *
 * To run a mutation, you first call `useUnlockBusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockBusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockBusMutation, { data, loading, error }] = useUnlockBusMutation({
 *   variables: {
 *      niraBusId: // value for 'niraBusId'
 *   },
 * });
 */
export function useUnlockBusMutation(baseOptions?: Apollo.MutationHookOptions<UnlockBusMutation, UnlockBusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockBusMutation, UnlockBusMutationVariables>(UnlockBusDocument, options);
      }
export type UnlockBusMutationHookResult = ReturnType<typeof useUnlockBusMutation>;
export type UnlockBusMutationResult = Apollo.MutationResult<UnlockBusMutation>;
export type UnlockBusMutationOptions = Apollo.BaseMutationOptions<UnlockBusMutation, UnlockBusMutationVariables>;
export const UpdateUserColorblindModeDocument = gql`
    mutation UpdateUserColorblindMode($auth0Id: String!, $colorblindMode: Boolean!) {
  update_users_by_pk(
    pk_columns: {auth0_id: $auth0Id}
    _set: {colorblind_mode: $colorblindMode}
  ) {
    auth0_id
    colorblind_mode
  }
}
    `;
export type UpdateUserColorblindModeMutationFn = Apollo.MutationFunction<UpdateUserColorblindModeMutation, UpdateUserColorblindModeMutationVariables>;

/**
 * __useUpdateUserColorblindModeMutation__
 *
 * To run a mutation, you first call `useUpdateUserColorblindModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserColorblindModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserColorblindModeMutation, { data, loading, error }] = useUpdateUserColorblindModeMutation({
 *   variables: {
 *      auth0Id: // value for 'auth0Id'
 *      colorblindMode: // value for 'colorblindMode'
 *   },
 * });
 */
export function useUpdateUserColorblindModeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserColorblindModeMutation, UpdateUserColorblindModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserColorblindModeMutation, UpdateUserColorblindModeMutationVariables>(UpdateUserColorblindModeDocument, options);
      }
export type UpdateUserColorblindModeMutationHookResult = ReturnType<typeof useUpdateUserColorblindModeMutation>;
export type UpdateUserColorblindModeMutationResult = Apollo.MutationResult<UpdateUserColorblindModeMutation>;
export type UpdateUserColorblindModeMutationOptions = Apollo.BaseMutationOptions<UpdateUserColorblindModeMutation, UpdateUserColorblindModeMutationVariables>;